import De, { defineComponent as f, computed as Q, ref as N, watch as rt, nextTick as pt, provide as Kc, getCurrentInstance as Hs, onMounted as zs, toRefs as Mt, inject as Yc, unref as Nt, watchEffect as Zc, getCurrentScope as Jc, onScopeDispose as _c } from "vue";
const $c = f({
  props: {
    fieldConfig: {
      type: Object,
      required: !0
    }
  },
  created() {
    (this.environment === "development" || this.environment === "staging") && (console.log(`Loading DynamicFieldItemError in '${this.environment}'`), this.$emit("dynamic-field-mounted", this.getState()));
  },
  computed: {
    environment() {
      return process.env.NODE_ENV;
    }
  },
  methods: {
    getState() {
      return {
        ref: "error",
        value: null,
        state: {
          empty: !0
        }
      };
    }
  }
});
function E(e, t, i, r, s, n, a, o) {
  var l = typeof e == "function" ? e.options : e;
  return t && (l.render = t, l.staticRenderFns = i, l._compiled = !0), n && (l._scopeId = "data-v-" + n), {
    exports: e,
    options: l
  };
}
var eu = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "dynamic-field-item-error" }, [i("span", [t._v("Error loading dynamic field")]), i("br"), i("span", [t._v("ref:")]), t._v(" " + t._s(t.fieldConfig.ref)), i("br"), i("span", [t._v("type:")]), t._v(" " + t._s(t.fieldConfig.type)), i("br")]);
}, tu = [], iu = /* @__PURE__ */ E(
  $c,
  eu,
  tu,
  !1,
  null,
  "b4e9668f"
);
const ru = iu.exports;
var su = 5, nu = function(e, t) {
  return Promise.resolve(e.amountStarted < t.length);
}, au = { maxInProgress: su, failFast: !1, nextCheck: nu, ignoreIsFunctionCheck: !1 };
function ou(e, t) {
  return new Promise(function(i, r) {
    var s = Object.assign({}, au, t), n = { amountDone: 0, amountStarted: 0, amountResolved: 0, amountRejected: 0, amountNextCheckFalsey: 0, rejectedIndexes: [], resolvedIndexes: [], nextCheckFalseyIndexes: [], taskResults: [] };
    if (e.length === 0) return i(n);
    for (var a = !1, o = 0, l = function() {
      if (a !== !0) {
        if (n.amountDone++, typeof s.progressCallback == "function" && s.progressCallback(n), n.amountDone === e.length) return i(n);
        o < e.length && c(o++);
      }
    }, c = function(d) {
      s.nextCheck(n, e).then(function(h) {
        h === !0 ? function(p) {
          if (n.amountStarted++, typeof e[p] == "function") e[p]().then(function(m) {
            n.taskResults[p] = m, n.resolvedIndexes.push(p), n.amountResolved++, l();
          }, function(m) {
            if (n.taskResults[p] = m, n.rejectedIndexes.push(p), n.amountRejected++, s.failFast === !0) return a = !0, r(n);
            l();
          });
          else {
            if (s.ignoreIsFunctionCheck !== !0) return a = !0, r(new Error("tasks[" + p + "]: " + e[p] + ", is supposed to be of type function"));
            n.taskResults[p] = e[p], n.resolvedIndexes.push(p), n.amountResolved++, l();
          }
        }(d) : (n.amountNextCheckFalsey++, n.nextCheckFalseyIndexes.push(d), l());
      }, r);
    }, u = 0; u < Math.min(s.maxInProgress, e.length); u++) c(o++);
  });
}
function lu(e, t) {
  return new Promise(function(i, r) {
    ou(e, t).then(function(s) {
      i(s.taskResults);
    }, function(s) {
      s instanceof Error ? r(s) : r(s.taskResults[s.rejectedIndexes[0]]);
    });
  });
}
function cu(e, t) {
  return lu(e, Object.assign({}, { failFast: !0 }, t));
}
const Wr = 5 * 1024 * 1024, uu = 3;
function du(e) {
  const t = Math.ceil(e.size / Wr), i = [];
  for (let r = 0; r < t; r += 1) {
    const s = r * Wr, n = Math.min(s + Wr, e.size);
    i.push({
      file: e,
      partNumber: r + 1,
      getSlice: () => e.slice(s, n, e.type)
    });
  }
  return i;
}
function hu(e, t) {
  const i = N("IDLE"), r = N(0), s = N(0), n = N(null), a = async (c, u, d) => {
    const h = await e.getSignedUrl("ticket", {
      key: c,
      uploadId: u,
      contentType: d.file.type,
      partNumber: d.partNumber
    });
    s.value += 1;
    const p = await fetch(h, {
      method: "PUT",
      body: d.getSlice()
    });
    return s.value += 1, p.headers.get("etag") ?? "";
  }, o = async (c, u) => {
    try {
      i.value = "IN_PROGRESS";
      const d = du(c);
      r.value = 2 + d.length * 2;
      const h = await e.start("ticket", t, {
        contentType: c.type,
        contentDisposition: `attachment; filename="${c.name}"`
      });
      s.value += 1;
      const { key: p } = h, { uploadId: m } = h, g = d.map(
        (w) => () => a(p, m, w)
      ), y = await cu(g, {
        maxInProgress: uu,
        failFast: !0
      }), v = await e.stop("ticket", t, {
        key: p,
        uploadId: m,
        contentType: c.type,
        parts: y,
        category: u,
        originalFilename: c.name
      });
      s.value += 1, i.value = "SUCCESS", n.value = v.file;
    } catch (d) {
      console.error(`Could not upload file '${c.name}'`, d), i.value = "ERROR";
    }
  }, l = Q(
    () => r.value ? s.value / r.value : 0
  );
  return { upload: o, status: i, progress: l, result: n };
}
function pu() {
  const e = N("single"), t = N(""), i = N([]), r = N([]), s = (a) => {
    r.value = [a].filter(Boolean);
  }, n = (a) => {
    r.value = a;
  };
  return rt(r, (a) => {
    e.value === "single" && a.length > 1 && console.warn(
      "Dropdown configured as a single input cannot receive multiple values. Only first element will be considered"
    ), t.value = (a == null ? void 0 : a[0]) ?? "", i.value = a ?? [];
  }), {
    selectionMode: e,
    modelSingle: t,
    modelMultiple: i,
    model: r,
    updateSingle: s,
    updateMultiple: n
  };
}
function fu(e, t = ["main"]) {
  const i = e.enabledProducts.map((n) => ({
    productId: n,
    productType: "main",
    customization: e.productCustomization[n]
  })).filter(
    (n) => t.includes(n.productType)
  ), r = Q(() => i), s = Q(() => i.map((n) => n.productId));
  return { productsData: r, productIds: s, _allProductIds: () => (console.log("[DEPRECATED] _allProductIds"), [
    ...s.value,
    "task",
    "feedback",
    "service_order",
    "campaign"
  ]) };
}
function mu(e, t) {
  const i = (n) => n.roles ? n.roles.some(
    (a) => {
      var o;
      return (o = t.userRoles) == null ? void 0 : o.includes(a);
    }
  ) : !0, r = (n) => n.actions ? n.actions.every(
    (a) => {
      var o;
      return (o = t.userActions) == null ? void 0 : o.includes(a);
    }
  ) : !0, s = (n) => !!(!n.actor || n.actor.includes("creator") && t.userId === t.creatorId || n.actor.includes("assignee") && t.userId === t.assigneeId);
  return {
    accessGranted: !e.length || e.some(
      (n) => i(n) && r(n) && s(n)
    ),
    checkActionAccess: r,
    checkActorAccess: s,
    checkRoleAccess: i
  };
}
function Zo(e, t, i) {
  const r = t.settings[i];
  if (!r) {
    console.warn(`Could not find ${i} '${e}'`);
    return;
  }
  return i === "phases" ? r.find(
    (s) => e === s.name
  ) : r == null ? void 0 : r[e];
}
function Jo(e, t, i = "status") {
  const r = Zo(e, t, i);
  return r == null ? void 0 : r.resources;
}
function gu(e, t, i = "status") {
  var r;
  const s = Zo(e, t, i);
  return ((r = s == null ? void 0 : s.settings) == null ? void 0 : r.colour) || void 0;
}
function yu(e) {
  const t = () => {
    const { firstName: a, lastName: o } = e.user;
    return a && o ? `${a} ${o}`.trim() : a ?? o ?? "";
  }, i = () => {
    const a = r();
    return a ? `https://teams.microsoft.com/l/chat/0/0?users=${a}` : void 0;
  }, r = () => e.user.email ? e.user.email : void 0, s = () => {
    var a;
    return ((a = e.team) == null ? void 0 : a.name) ?? e.user.departmentName;
  }, n = (a) => {
    const o = (l) => l.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/_/g, " ").split(" ").map(
      (c) => c.charAt(0).toUpperCase() + c.slice(1).toLowerCase()
    ).join(" ");
    return Object.entries(a).map(([l, c]) => ({
      label: o(l),
      value: c
    }));
  };
  return {
    displayName: t,
    microsoftTeamsLink: i,
    userDepartment: s,
    displayEmail: r,
    getPublicSettings: () => n(e.user.public ?? {}),
    getPrivateSettings: () => n(e.user.private ?? {})
  };
}
function bu(e, t) {
  return {
    teamName: () => {
      var i, r;
      return !e.resources || !Object.keys(e.resources).length ? e.name : (i = t(e.resources)) != null && i.name ? (r = t(e.resources)) == null ? void 0 : r.name : e.name;
    },
    teamDescription: () => {
      var i, r;
      return !e.resources || !Object.keys(e.resources).length ? e.description : (i = t(e.resources)) != null && i.description ? (r = t(e.resources)) == null ? void 0 : r.description : e.description;
    }
  };
}
const fs = {
  meter: {
    dimension: "length",
    system: "si",
    unit: "meter",
    symbol: "m",
    convert: {
      fromBase: (e) => e,
      toBase: (e) => e
    }
  },
  centimeter: {
    dimension: "length",
    system: "si",
    unit: "centimeter",
    symbol: "cm",
    convert: {
      fromBase: (e) => e * 100,
      toBase: (e) => e * 0.01
    }
  },
  millimeter: {
    dimension: "length",
    system: "si",
    unit: "millimeter",
    symbol: "mm",
    convert: {
      fromBase: (e) => e * 1e3,
      toBase: (e) => e * 1e-3
    }
  },
  kilometer: {
    dimension: "length",
    system: "si",
    unit: "kilometer",
    symbol: "km",
    convert: {
      fromBase: (e) => e * 1e-3,
      toBase: (e) => e * 1e3
    }
  },
  mile: {
    dimension: "length",
    system: "imperial",
    unit: "mile",
    symbol: "mi",
    convert: {
      fromBase: (e) => e * 6213712e-10,
      toBase: (e) => e * 1609.344
    }
  },
  yard: {
    dimension: "length",
    system: "imperial",
    unit: "yard",
    symbol: "yd",
    convert: {
      fromBase: (e) => e * 1.093613,
      toBase: (e) => e * 0.9144
    }
  },
  foot: {
    dimension: "length",
    system: "imperial",
    unit: "foot",
    symbol: "ft",
    convert: {
      fromBase: (e) => e * 3.28084,
      toBase: (e) => e * 0.3048
    }
  },
  inch: {
    dimension: "length",
    system: "imperial",
    unit: "inch",
    symbol: "in",
    convert: {
      fromBase: (e) => e * 39.37008,
      toBase: (e) => e * 0.0254
    }
  }
};
function vu(e, t) {
  const i = fs[e.unit].convert.toBase(
    e.value
  );
  return fs[t].convert.fromBase(i);
}
const ms = {
  kilogram: {
    dimension: "mass",
    system: "si",
    unit: "kilogram",
    symbol: "kg",
    convert: {
      fromBase: (e) => e,
      toBase: (e) => e
    }
  },
  gram: {
    dimension: "mass",
    system: "si",
    unit: "gram",
    symbol: "g",
    convert: {
      fromBase: (e) => e * 1e3,
      toBase: (e) => e * 1e-3
    }
  },
  milligram: {
    dimension: "mass",
    system: "si",
    unit: "milligram",
    symbol: "mg",
    convert: {
      fromBase: (e) => e * 1e6,
      toBase: (e) => e * 1e-6
    }
  },
  tonne: {
    dimension: "mass",
    system: "si",
    unit: "tonne",
    symbol: "t",
    convert: {
      fromBase: (e) => e * 1e-3,
      toBase: (e) => e * 1e3
    }
  },
  ounce: {
    dimension: "mass",
    system: "imperial",
    unit: "ounce",
    symbol: "oz",
    convert: {
      fromBase: (e) => e * 35.27396,
      toBase: (e) => e * 0.02834952
    }
  },
  pound: {
    dimension: "mass",
    system: "imperial",
    unit: "pound",
    symbol: "lb",
    convert: {
      fromBase: (e) => e * 2.204623,
      toBase: (e) => e * 0.4535924
    }
  }
};
function Au(e, t) {
  const i = ms[e.unit].convert.toBase(
    e.value
  );
  return ms[t].convert.fromBase(i);
}
const gs = {
  "cubic-meter": {
    dimension: "volume",
    system: "si",
    unit: "cubic-meter",
    symbol: "m³",
    convert: {
      fromBase: (e) => e,
      toBase: (e) => e
    }
  },
  liter: {
    dimension: "volume",
    system: "si",
    unit: "liter",
    symbol: "l",
    convert: {
      fromBase: (e) => e * 1e3,
      toBase: (e) => e * 1e-3
    }
  },
  milliliter: {
    dimension: "volume",
    system: "si",
    unit: "milliliter",
    symbol: "ml",
    convert: {
      fromBase: (e) => e * 1e6,
      toBase: (e) => e * 1e-6
    }
  },
  "us-fluid-ounce": {
    dimension: "volume",
    system: "us-customary",
    unit: "us-fluid-ounce",
    symbol: "fl oz",
    convert: {
      fromBase: (e) => e * 33814.13,
      toBase: (e) => e * 2957344e-11
    }
  },
  "us-gallon": {
    dimension: "volume",
    system: "us-customary",
    unit: "us-gallon",
    symbol: "gal",
    convert: {
      fromBase: (e) => e * 264.1729,
      toBase: (e) => e * 37854e-7
    }
  },
  "us-pint": {
    dimension: "volume",
    system: "us-customary",
    unit: "us-pint",
    symbol: "pt",
    convert: {
      fromBase: (e) => e * 2113.376,
      toBase: (e) => e * 4731765e-10
    }
  }
};
function ku(e, t) {
  const i = gs[e.unit].convert.toBase(
    e.value
  );
  return gs[t].convert.fromBase(i);
}
const ys = {
  kelvin: {
    dimension: "temperature",
    system: void 0,
    unit: "kelvin",
    symbol: "K",
    convert: {
      fromBase: (e) => e,
      toBase: (e) => e
    }
  },
  celsius: {
    dimension: "temperature",
    system: "si",
    unit: "celsius",
    symbol: "°C",
    convert: {
      fromBase: (e) => e - 273.15,
      toBase: (e) => e + 273.15
    }
  },
  fahrenheit: {
    dimension: "temperature",
    system: "imperial",
    unit: "fahrenheit",
    symbol: "°F",
    convert: {
      fromBase: (e) => e * 9 / 5 - 459.67,
      toBase: (e) => 5 / 9 * (e + 459.67)
    }
  },
  rankine: {
    dimension: "temperature",
    system: void 0,
    unit: "rankine",
    symbol: "°R",
    convert: {
      fromBase: (e) => 9 / 5 * e,
      toBase: (e) => 5 / 9 * e
    }
  }
};
function wu(e, t) {
  const i = ys[e.unit].convert.toBase(
    e.value
  );
  return ys[t].convert.fromBase(i);
}
function _o(e) {
  switch (e) {
    case "length":
      return fs;
    case "mass":
      return ms;
    case "volume":
      return gs;
    case "temperature":
      return ys;
    default:
      throw new Error(`Unknown unit system '${e}'`);
  }
}
function xu(e) {
  switch (e) {
    case "length":
      return vu;
    case "mass":
      return Au;
    case "volume":
      return ku;
    case "temperature":
      return wu;
    default:
      throw new Error(`Unknown unit converter '${e}'`);
  }
}
function En(e, t, i) {
  const r = new Intl.NumberFormat(void 0, {
    style: "decimal",
    signDisplay: "auto",
    minimumFractionDigits: i || 2,
    maximumFractionDigits: i || 2
  }).format(e.value);
  if (e.dimension === "currency")
    return `${t(`measure.unit.${e.unit}.symbol`)} ${r}`;
  const s = _o(e.dimension)[e.unit];
  return `${r} ${(s == null ? void 0 : s.symbol) ?? ""}`;
}
function $o(e, t) {
  const i = Math.sign(e.value), r = {
    dimension: e.dimension,
    unit: e.unit,
    value: Math.abs(e.value)
  }, s = xu(r.dimension), n = Object.values(_o(r.dimension)).filter(
    (o) => o.system === t
  );
  let a;
  if (n.forEach((o) => {
    const l = s(r, o.unit);
    (!a || l > 1 && a.value < 1 || l > 1 && l < a.value) && (a = {
      dimension: r.dimension,
      unit: o.unit,
      value: l
    });
  }), !a && t === "us-customary")
    return $o(e, "imperial");
  if (a)
    return {
      dimension: a.dimension,
      unit: a.unit,
      value: a.value * (i || 1)
    };
}
function Cu(e) {
  return e.toLowerCase().replace(/([-_][a-z])/g, (t) => t.toUpperCase()).replace(/[^a-zA-Z]/g, "");
}
function Su(e) {
  return `${Cu(e)}Reason`;
}
function Iu(e) {
  var t;
  const i = e.settings.phases ?? [], r = Object.entries((t = e.settings) == null ? void 0 : t.status);
  function s(a) {
    return r.filter((o) => o[1].phase === a).map((o) => o[0]);
  }
  const n = [];
  return i.forEach((a) => {
    const o = s(a.name);
    o.length && n.push({
      phase: a.name,
      status: o
    });
  }), n;
}
var Du = Object.defineProperty, Pu = (e, t, i) => t in e ? Du(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, I = (e, t, i) => Pu(e, typeof t != "symbol" ? t + "" : t, i);
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function Ti(e) {
  return e + 0.5 | 0;
}
const nt = (e, t, i) => Math.max(Math.min(e, i), t);
function ui(e) {
  return nt(Ti(e * 2.55), 0, 255);
}
function ct(e) {
  return nt(Ti(e * 255), 0, 255);
}
function $e(e) {
  return nt(Ti(e / 2.55) / 100, 0, 1);
}
function Ln(e) {
  return nt(Ti(e * 100), 0, 100);
}
const Oe = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, bs = [..."0123456789ABCDEF"], Tu = (e) => bs[e & 15], Ou = (e) => bs[(e & 240) >> 4] + bs[e & 15], Hi = (e) => (e & 240) >> 4 === (e & 15), Bu = (e) => Hi(e.r) && Hi(e.g) && Hi(e.b) && Hi(e.a);
function Mu(e) {
  var t = e.length, i;
  return e[0] === "#" && (t === 4 || t === 5 ? i = {
    r: 255 & Oe[e[1]] * 17,
    g: 255 & Oe[e[2]] * 17,
    b: 255 & Oe[e[3]] * 17,
    a: t === 5 ? Oe[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (i = {
    r: Oe[e[1]] << 4 | Oe[e[2]],
    g: Oe[e[3]] << 4 | Oe[e[4]],
    b: Oe[e[5]] << 4 | Oe[e[6]],
    a: t === 9 ? Oe[e[7]] << 4 | Oe[e[8]] : 255
  })), i;
}
const Ru = (e, t) => e < 255 ? t(e) : "";
function Eu(e) {
  var t = Bu(e) ? Tu : Ou;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + Ru(e.a, t) : void 0;
}
const Lu = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function el(e, t, i) {
  const r = t * Math.min(i, 1 - i), s = (n, a = (n + e / 30) % 12) => i - r * Math.max(Math.min(a - 3, 9 - a, 1), -1);
  return [s(0), s(8), s(4)];
}
function Fu(e, t, i) {
  const r = (s, n = (s + e / 60) % 6) => i - i * t * Math.max(Math.min(n, 4 - n, 1), 0);
  return [r(5), r(3), r(1)];
}
function ju(e, t, i) {
  const r = el(e, 1, 0.5);
  let s;
  for (t + i > 1 && (s = 1 / (t + i), t *= s, i *= s), s = 0; s < 3; s++)
    r[s] *= 1 - t - i, r[s] += t;
  return r;
}
function Uu(e, t, i, r, s) {
  return e === s ? (t - i) / r + (t < i ? 6 : 0) : t === s ? (i - e) / r + 2 : (e - t) / r + 4;
}
function Ns(e) {
  const t = e.r / 255, i = e.g / 255, r = e.b / 255, s = Math.max(t, i, r), n = Math.min(t, i, r), a = (s + n) / 2;
  let o, l, c;
  return s !== n && (c = s - n, l = a > 0.5 ? c / (2 - s - n) : c / (s + n), o = Uu(t, i, r, c, s), o = o * 60 + 0.5), [o | 0, l || 0, a];
}
function Vs(e, t, i, r) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, i, r)).map(ct);
}
function Gs(e, t, i) {
  return Vs(el, e, t, i);
}
function qu(e, t, i) {
  return Vs(ju, e, t, i);
}
function Hu(e, t, i) {
  return Vs(Fu, e, t, i);
}
function tl(e) {
  return (e % 360 + 360) % 360;
}
function zu(e) {
  const t = Lu.exec(e);
  let i = 255, r;
  if (!t)
    return;
  t[5] !== r && (i = t[6] ? ui(+t[5]) : ct(+t[5]));
  const s = tl(+t[2]), n = +t[3] / 100, a = +t[4] / 100;
  return t[1] === "hwb" ? r = qu(s, n, a) : t[1] === "hsv" ? r = Hu(s, n, a) : r = Gs(s, n, a), {
    r: r[0],
    g: r[1],
    b: r[2],
    a: i
  };
}
function Nu(e, t) {
  var i = Ns(e);
  i[0] = tl(i[0] + t), i = Gs(i), e.r = i[0], e.g = i[1], e.b = i[2];
}
function Vu(e) {
  if (!e)
    return;
  const t = Ns(e), i = t[0], r = Ln(t[1]), s = Ln(t[2]);
  return e.a < 255 ? `hsla(${i}, ${r}%, ${s}%, ${$e(e.a)})` : `hsl(${i}, ${r}%, ${s}%)`;
}
const Fn = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, jn = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function Gu() {
  const e = {}, t = Object.keys(jn), i = Object.keys(Fn);
  let r, s, n, a, o;
  for (r = 0; r < t.length; r++) {
    for (a = o = t[r], s = 0; s < i.length; s++)
      n = i[s], o = o.replace(n, Fn[n]);
    n = parseInt(jn[a], 16), e[o] = [n >> 16 & 255, n >> 8 & 255, n & 255];
  }
  return e;
}
let zi;
function Wu(e) {
  zi || (zi = Gu(), zi.transparent = [0, 0, 0, 0]);
  const t = zi[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const Qu = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function Xu(e) {
  const t = Qu.exec(e);
  let i = 255, r, s, n;
  if (t) {
    if (t[7] !== r) {
      const a = +t[7];
      i = t[8] ? ui(a) : nt(a * 255, 0, 255);
    }
    return r = +t[1], s = +t[3], n = +t[5], r = 255 & (t[2] ? ui(r) : nt(r, 0, 255)), s = 255 & (t[4] ? ui(s) : nt(s, 0, 255)), n = 255 & (t[6] ? ui(n) : nt(n, 0, 255)), {
      r,
      g: s,
      b: n,
      a: i
    };
  }
}
function Ku(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${$e(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const Qr = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, Ht = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function Yu(e, t, i) {
  const r = Ht($e(e.r)), s = Ht($e(e.g)), n = Ht($e(e.b));
  return {
    r: ct(Qr(r + i * (Ht($e(t.r)) - r))),
    g: ct(Qr(s + i * (Ht($e(t.g)) - s))),
    b: ct(Qr(n + i * (Ht($e(t.b)) - n))),
    a: e.a + i * (t.a - e.a)
  };
}
function Ni(e, t, i) {
  if (e) {
    let r = Ns(e);
    r[t] = Math.max(0, Math.min(r[t] + r[t] * i, t === 0 ? 360 : 1)), r = Gs(r), e.r = r[0], e.g = r[1], e.b = r[2];
  }
}
function il(e, t) {
  return e && Object.assign(t || {}, e);
}
function Un(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = ct(e[3]))) : (t = il(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = ct(t.a)), t;
}
function Zu(e) {
  return e.charAt(0) === "r" ? Xu(e) : zu(e);
}
class ki {
  constructor(t) {
    if (t instanceof ki)
      return t;
    const i = typeof t;
    let r;
    i === "object" ? r = Un(t) : i === "string" && (r = Mu(t) || Wu(t) || Zu(t)), this._rgb = r, this._valid = !!r;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = il(this._rgb);
    return t && (t.a = $e(t.a)), t;
  }
  set rgb(t) {
    this._rgb = Un(t);
  }
  rgbString() {
    return this._valid ? Ku(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? Eu(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? Vu(this._rgb) : void 0;
  }
  mix(t, i) {
    if (t) {
      const r = this.rgb, s = t.rgb;
      let n;
      const a = i === n ? 0.5 : i, o = 2 * a - 1, l = r.a - s.a, c = ((o * l === -1 ? o : (o + l) / (1 + o * l)) + 1) / 2;
      n = 1 - c, r.r = 255 & c * r.r + n * s.r + 0.5, r.g = 255 & c * r.g + n * s.g + 0.5, r.b = 255 & c * r.b + n * s.b + 0.5, r.a = a * r.a + (1 - a) * s.a, this.rgb = r;
    }
    return this;
  }
  interpolate(t, i) {
    return t && (this._rgb = Yu(this._rgb, t._rgb, i)), this;
  }
  clone() {
    return new ki(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = ct(t), this;
  }
  clearer(t) {
    const i = this._rgb;
    return i.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, i = Ti(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = i, this;
  }
  opaquer(t) {
    const i = this._rgb;
    return i.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return Ni(this._rgb, 2, t), this;
  }
  darken(t) {
    return Ni(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return Ni(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return Ni(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return Nu(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.4.1
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
function Ze() {
}
const Ju = /* @__PURE__ */ (() => {
  let e = 0;
  return () => e++;
})();
function z(e) {
  return e === null || typeof e > "u";
}
function _(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function q(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function ie(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function Se(e, t) {
  return ie(e) ? e : t;
}
function L(e, t) {
  return typeof e > "u" ? t : e;
}
const _u = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / t, rl = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function K(e, t, i) {
  if (e && typeof e.call == "function")
    return e.apply(i, t);
}
function G(e, t, i, r) {
  let s, n, a;
  if (_(e))
    for (n = e.length, s = 0; s < n; s++)
      t.call(i, e[s], s);
  else if (q(e))
    for (a = Object.keys(e), n = a.length, s = 0; s < n; s++)
      t.call(i, e[a[s]], a[s]);
}
function pr(e, t) {
  let i, r, s, n;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (i = 0, r = e.length; i < r; ++i)
    if (s = e[i], n = t[i], s.datasetIndex !== n.datasetIndex || s.index !== n.index)
      return !1;
  return !0;
}
function fr(e) {
  if (_(e))
    return e.map(fr);
  if (q(e)) {
    const t = /* @__PURE__ */ Object.create(null), i = Object.keys(e), r = i.length;
    let s = 0;
    for (; s < r; ++s)
      t[i[s]] = fr(e[i[s]]);
    return t;
  }
  return e;
}
function sl(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function $u(e, t, i, r) {
  if (!sl(e))
    return;
  const s = t[e], n = i[e];
  q(s) && q(n) ? wi(s, n, r) : t[e] = fr(n);
}
function wi(e, t, i) {
  const r = _(t) ? t : [
    t
  ], s = r.length;
  if (!q(e))
    return e;
  i = i || {};
  const n = i.merger || $u;
  let a;
  for (let o = 0; o < s; ++o) {
    if (a = r[o], !q(a))
      continue;
    const l = Object.keys(a);
    for (let c = 0, u = l.length; c < u; ++c)
      n(l[c], e, a, i);
  }
  return e;
}
function mi(e, t) {
  return wi(e, t, {
    merger: ed
  });
}
function ed(e, t, i) {
  if (!sl(e))
    return;
  const r = t[e], s = i[e];
  q(r) && q(s) ? mi(r, s) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = fr(s));
}
const qn = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function td(e) {
  const t = e.split("."), i = [];
  let r = "";
  for (const s of t)
    r += s, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (i.push(r), r = "");
  return i;
}
function id(e) {
  const t = td(e);
  return (i) => {
    for (const r of t) {
      if (r === "")
        break;
      i = i && i[r];
    }
    return i;
  };
}
function ut(e, t) {
  return (qn[t] || (qn[t] = id(t)))(e);
}
function Ws(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const xi = (e) => typeof e < "u", dt = (e) => typeof e == "function", Hn = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const i of e)
    if (!t.has(i))
      return !1;
  return !0;
};
function rd(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const Z = Math.PI, Y = 2 * Z, sd = Y + Z, mr = Number.POSITIVE_INFINITY, nd = Z / 180, se = Z / 2, yt = Z / 4, zn = Z * 2 / 3, at = Math.log10, Ve = Math.sign;
function gi(e, t, i) {
  return Math.abs(e - t) < i;
}
function Nn(e) {
  const t = Math.round(e);
  e = gi(e, t, e / 1e3) ? t : e;
  const i = Math.pow(10, Math.floor(at(e))), r = e / i;
  return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * i;
}
function ad(e) {
  const t = [], i = Math.sqrt(e);
  let r;
  for (r = 1; r < i; r++)
    e % r === 0 && (t.push(r), t.push(e / r));
  return i === (i | 0) && t.push(i), t.sort((s, n) => s - n).pop(), t;
}
function Gt(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}
function od(e, t) {
  const i = Math.round(e);
  return i - t <= e && i + t >= e;
}
function nl(e, t, i) {
  let r, s, n;
  for (r = 0, s = e.length; r < s; r++)
    n = e[r][i], isNaN(n) || (t.min = Math.min(t.min, n), t.max = Math.max(t.max, n));
}
function Le(e) {
  return e * (Z / 180);
}
function Qs(e) {
  return e * (180 / Z);
}
function Vn(e) {
  if (!ie(e))
    return;
  let t = 1, i = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, i++;
  return i;
}
function al(e, t) {
  const i = t.x - e.x, r = t.y - e.y, s = Math.sqrt(i * i + r * r);
  let n = Math.atan2(r, i);
  return n < -0.5 * Z && (n += Y), {
    angle: n,
    distance: s
  };
}
function vs(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function ld(e, t) {
  return (e - t + sd) % Y - Z;
}
function Ie(e) {
  return (e % Y + Y) % Y;
}
function Ci(e, t, i, r) {
  const s = Ie(e), n = Ie(t), a = Ie(i), o = Ie(n - s), l = Ie(a - s), c = Ie(s - n), u = Ie(s - a);
  return s === n || s === a || r && n === a || o > l && c < u;
}
function le(e, t, i) {
  return Math.max(t, Math.min(i, e));
}
function cd(e) {
  return le(e, -32768, 32767);
}
function et(e, t, i, r = 1e-6) {
  return e >= Math.min(t, i) - r && e <= Math.max(t, i) + r;
}
function Xs(e, t, i) {
  i = i || ((a) => e[a] < t);
  let r = e.length - 1, s = 0, n;
  for (; r - s > 1; )
    n = s + r >> 1, i(n) ? s = n : r = n;
  return {
    lo: s,
    hi: r
  };
}
const tt = (e, t, i, r) => Xs(e, i, r ? (s) => {
  const n = e[s][t];
  return n < i || n === i && e[s + 1][t] === i;
} : (s) => e[s][t] < i), ud = (e, t, i) => Xs(e, i, (r) => e[r][t] >= i);
function dd(e, t, i) {
  let r = 0, s = e.length;
  for (; r < s && e[r] < t; )
    r++;
  for (; s > r && e[s - 1] > i; )
    s--;
  return r > 0 || s < e.length ? e.slice(r, s) : e;
}
const ol = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function hd(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), ol.forEach((i) => {
    const r = "_onData" + Ws(i), s = e[i];
    Object.defineProperty(e, i, {
      configurable: !0,
      enumerable: !1,
      value(...n) {
        const a = s.apply(this, n);
        return e._chartjs.listeners.forEach((o) => {
          typeof o[r] == "function" && o[r](...n);
        }), a;
      }
    });
  });
}
function Gn(e, t) {
  const i = e._chartjs;
  if (!i)
    return;
  const r = i.listeners, s = r.indexOf(t);
  s !== -1 && r.splice(s, 1), !(r.length > 0) && (ol.forEach((n) => {
    delete e[n];
  }), delete e._chartjs);
}
function ll(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const cl = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function ul(e, t) {
  let i = [], r = !1;
  return function(...s) {
    i = s, r || (r = !0, cl.call(window, () => {
      r = !1, e.apply(t, i);
    }));
  };
}
function pd(e, t) {
  let i;
  return function(...r) {
    return t ? (clearTimeout(i), i = setTimeout(e, t, r)) : e.apply(this, r), t;
  };
}
const Ks = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", pe = (e, t, i) => e === "start" ? t : e === "end" ? i : (t + i) / 2, fd = (e, t, i, r) => e === (r ? "left" : "right") ? i : e === "center" ? (t + i) / 2 : t;
function dl(e, t, i) {
  const r = t.length;
  let s = 0, n = r;
  if (e._sorted) {
    const { iScale: a, _parsed: o } = e, l = a.axis, { min: c, max: u, minDefined: d, maxDefined: h } = a.getUserBounds();
    d && (s = le(Math.min(
      // @ts-expect-error Need to type _parsed
      tt(o, l, c).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      i ? r : tt(t, l, a.getPixelForValue(c)).lo
    ), 0, r - 1)), h ? n = le(Math.max(
      // @ts-expect-error Need to type _parsed
      tt(o, a.axis, u, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      i ? 0 : tt(t, l, a.getPixelForValue(u), !0).hi + 1
    ), s, r) - s : n = r - s;
  }
  return {
    start: s,
    count: n
  };
}
function hl(e) {
  const { xScale: t, yScale: i, _scaleRanges: r } = e, s = {
    xmin: t.min,
    xmax: t.max,
    ymin: i.min,
    ymax: i.max
  };
  if (!r)
    return e._scaleRanges = s, !0;
  const n = r.xmin !== t.min || r.xmax !== t.max || r.ymin !== i.min || r.ymax !== i.max;
  return Object.assign(r, s), n;
}
const Vi = (e) => e === 0 || e === 1, Wn = (e, t, i) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * Y / i)), Qn = (e, t, i) => Math.pow(2, -10 * e) * Math.sin((e - t) * Y / i) + 1, yi = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * se) + 1,
  easeOutSine: (e) => Math.sin(e * se),
  easeInOutSine: (e) => -0.5 * (Math.cos(Z * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => Vi(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => Vi(e) ? e : Wn(e, 0.075, 0.3),
  easeOutElastic: (e) => Vi(e) ? e : Qn(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return Vi(e) ? e : e < 0.5 ? 0.5 * Wn(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * Qn(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - yi.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? yi.easeInBounce(e * 2) * 0.5 : yi.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function Ys(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function Xn(e) {
  return Ys(e) ? e : new ki(e);
}
function Xr(e) {
  return Ys(e) ? e : new ki(e).saturate(0.5).darken(0.1).hexString();
}
const md = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], gd = [
  "color",
  "borderColor",
  "backgroundColor"
];
function yd(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: gd
    },
    numbers: {
      type: "number",
      properties: md
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function bd(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Kn = /* @__PURE__ */ new Map();
function vd(e, t) {
  t = t || {};
  const i = e + JSON.stringify(t);
  let r = Kn.get(i);
  return r || (r = new Intl.NumberFormat(e, t), Kn.set(i, r)), r;
}
function Oi(e, t, i) {
  return vd(t, i).format(e);
}
const pl = {
  values(e) {
    return _(e) ? e : "" + e;
  },
  numeric(e, t, i) {
    if (e === 0)
      return "0";
    const r = this.chart.options.locale;
    let s, n = e;
    if (i.length > 1) {
      const c = Math.max(Math.abs(i[0].value), Math.abs(i[i.length - 1].value));
      (c < 1e-4 || c > 1e15) && (s = "scientific"), n = Ad(e, i);
    }
    const a = at(Math.abs(n)), o = isNaN(a) ? 1 : Math.max(Math.min(-1 * Math.floor(a), 20), 0), l = {
      notation: s,
      minimumFractionDigits: o,
      maximumFractionDigits: o
    };
    return Object.assign(l, this.options.ticks.format), Oi(e, r, l);
  },
  logarithmic(e, t, i) {
    if (e === 0)
      return "0";
    const r = i[t].significand || e / Math.pow(10, Math.floor(at(e)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(r) || t > 0.8 * i.length ? pl.numeric.call(this, e, t, i) : "";
  }
};
function Ad(e, t) {
  let i = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(i) >= 1 && e !== Math.floor(e) && (i = e - Math.floor(e)), i;
}
var Cr = {
  formatters: pl
};
function kd(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, i) => i.lineWidth,
      tickColor: (t, i) => i.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Cr.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const Ot = /* @__PURE__ */ Object.create(null), As = /* @__PURE__ */ Object.create(null);
function bi(e, t) {
  if (!t)
    return e;
  const i = t.split(".");
  for (let r = 0, s = i.length; r < s; ++r) {
    const n = i[r];
    e = e[n] || (e[n] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function Kr(e, t, i) {
  return typeof t == "string" ? wi(bi(e, t), i) : wi(bi(e, ""), t);
}
class wd {
  constructor(t, i) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (r) => r.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (r, s) => Xr(s.backgroundColor), this.hoverBorderColor = (r, s) => Xr(s.borderColor), this.hoverColor = (r, s) => Xr(s.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(i);
  }
  set(t, i) {
    return Kr(this, t, i);
  }
  get(t) {
    return bi(this, t);
  }
  describe(t, i) {
    return Kr(As, t, i);
  }
  override(t, i) {
    return Kr(Ot, t, i);
  }
  route(t, i, r, s) {
    const n = bi(this, t), a = bi(this, r), o = "_" + i;
    Object.defineProperties(n, {
      [o]: {
        value: n[i],
        writable: !0
      },
      [i]: {
        enumerable: !0,
        get() {
          const l = this[o], c = a[s];
          return q(l) ? Object.assign({}, c, l) : L(l, c);
        },
        set(l) {
          this[o] = l;
        }
      }
    });
  }
  apply(t) {
    t.forEach((i) => i(this));
  }
}
var re = /* @__PURE__ */ new wd({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  yd,
  bd,
  kd
]);
function xd(e) {
  return !e || z(e.size) || z(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function gr(e, t, i, r, s) {
  let n = t[s];
  return n || (n = t[s] = e.measureText(s).width, i.push(s)), n > r && (r = n), r;
}
function Cd(e, t, i, r) {
  r = r || {};
  let s = r.data = r.data || {}, n = r.garbageCollect = r.garbageCollect || [];
  r.font !== t && (s = r.data = {}, n = r.garbageCollect = [], r.font = t), e.save(), e.font = t;
  let a = 0;
  const o = i.length;
  let l, c, u, d, h;
  for (l = 0; l < o; l++)
    if (d = i[l], d != null && !_(d))
      a = gr(e, s, n, a, d);
    else if (_(d))
      for (c = 0, u = d.length; c < u; c++)
        h = d[c], h != null && !_(h) && (a = gr(e, s, n, a, h));
  e.restore();
  const p = n.length / 2;
  if (p > i.length) {
    for (l = 0; l < p; l++)
      delete s[n[l]];
    n.splice(0, p);
  }
  return a;
}
function bt(e, t, i) {
  const r = e.currentDevicePixelRatio, s = i !== 0 ? Math.max(i / 2, 0.5) : 0;
  return Math.round((t - s) * r) / r + s;
}
function Yn(e, t) {
  t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore();
}
function ks(e, t, i, r) {
  fl(e, t, i, r, null);
}
function fl(e, t, i, r, s) {
  let n, a, o, l, c, u, d, h;
  const p = t.pointStyle, m = t.rotation, g = t.radius;
  let y = (m || 0) * nd;
  if (p && typeof p == "object" && (n = p.toString(), n === "[object HTMLImageElement]" || n === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(i, r), e.rotate(y), e.drawImage(p, -p.width / 2, -p.height / 2, p.width, p.height), e.restore();
    return;
  }
  if (!(isNaN(g) || g <= 0)) {
    switch (e.beginPath(), p) {
      default:
        s ? e.ellipse(i, r, s / 2, g, 0, 0, Y) : e.arc(i, r, g, 0, Y), e.closePath();
        break;
      case "triangle":
        u = s ? s / 2 : g, e.moveTo(i + Math.sin(y) * u, r - Math.cos(y) * g), y += zn, e.lineTo(i + Math.sin(y) * u, r - Math.cos(y) * g), y += zn, e.lineTo(i + Math.sin(y) * u, r - Math.cos(y) * g), e.closePath();
        break;
      case "rectRounded":
        c = g * 0.516, l = g - c, a = Math.cos(y + yt) * l, d = Math.cos(y + yt) * (s ? s / 2 - c : l), o = Math.sin(y + yt) * l, h = Math.sin(y + yt) * (s ? s / 2 - c : l), e.arc(i - d, r - o, c, y - Z, y - se), e.arc(i + h, r - a, c, y - se, y), e.arc(i + d, r + o, c, y, y + se), e.arc(i - h, r + a, c, y + se, y + Z), e.closePath();
        break;
      case "rect":
        if (!m) {
          l = Math.SQRT1_2 * g, u = s ? s / 2 : l, e.rect(i - u, r - l, 2 * u, 2 * l);
          break;
        }
        y += yt;
      case "rectRot":
        d = Math.cos(y) * (s ? s / 2 : g), a = Math.cos(y) * g, o = Math.sin(y) * g, h = Math.sin(y) * (s ? s / 2 : g), e.moveTo(i - d, r - o), e.lineTo(i + h, r - a), e.lineTo(i + d, r + o), e.lineTo(i - h, r + a), e.closePath();
        break;
      case "crossRot":
        y += yt;
      case "cross":
        d = Math.cos(y) * (s ? s / 2 : g), a = Math.cos(y) * g, o = Math.sin(y) * g, h = Math.sin(y) * (s ? s / 2 : g), e.moveTo(i - d, r - o), e.lineTo(i + d, r + o), e.moveTo(i + h, r - a), e.lineTo(i - h, r + a);
        break;
      case "star":
        d = Math.cos(y) * (s ? s / 2 : g), a = Math.cos(y) * g, o = Math.sin(y) * g, h = Math.sin(y) * (s ? s / 2 : g), e.moveTo(i - d, r - o), e.lineTo(i + d, r + o), e.moveTo(i + h, r - a), e.lineTo(i - h, r + a), y += yt, d = Math.cos(y) * (s ? s / 2 : g), a = Math.cos(y) * g, o = Math.sin(y) * g, h = Math.sin(y) * (s ? s / 2 : g), e.moveTo(i - d, r - o), e.lineTo(i + d, r + o), e.moveTo(i + h, r - a), e.lineTo(i - h, r + a);
        break;
      case "line":
        a = s ? s / 2 : Math.cos(y) * g, o = Math.sin(y) * g, e.moveTo(i - a, r - o), e.lineTo(i + a, r + o);
        break;
      case "dash":
        e.moveTo(i, r), e.lineTo(i + Math.cos(y) * (s ? s / 2 : g), r + Math.sin(y) * g);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function it(e, t, i) {
  return i = i || 0.5, !t || e && e.x > t.left - i && e.x < t.right + i && e.y > t.top - i && e.y < t.bottom + i;
}
function Sr(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function Ir(e) {
  e.restore();
}
function Sd(e, t, i, r, s) {
  if (!t)
    return e.lineTo(i.x, i.y);
  if (s === "middle") {
    const n = (t.x + i.x) / 2;
    e.lineTo(n, t.y), e.lineTo(n, i.y);
  } else s === "after" != !!r ? e.lineTo(t.x, i.y) : e.lineTo(i.x, t.y);
  e.lineTo(i.x, i.y);
}
function Id(e, t, i, r) {
  if (!t)
    return e.lineTo(i.x, i.y);
  e.bezierCurveTo(r ? t.cp1x : t.cp2x, r ? t.cp1y : t.cp2y, r ? i.cp2x : i.cp1x, r ? i.cp2y : i.cp1y, i.x, i.y);
}
function Dd(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), z(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function Pd(e, t, i, r, s) {
  if (s.strikethrough || s.underline) {
    const n = e.measureText(r), a = t - n.actualBoundingBoxLeft, o = t + n.actualBoundingBoxRight, l = i - n.actualBoundingBoxAscent, c = i + n.actualBoundingBoxDescent, u = s.strikethrough ? (l + c) / 2 : c;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = s.decorationWidth || 2, e.moveTo(a, u), e.lineTo(o, u), e.stroke();
  }
}
function Td(e, t) {
  const i = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = i;
}
function Bt(e, t, i, r, s, n = {}) {
  const a = _(t) ? t : [
    t
  ], o = n.strokeWidth > 0 && n.strokeColor !== "";
  let l, c;
  for (e.save(), e.font = s.string, Dd(e, n), l = 0; l < a.length; ++l)
    c = a[l], n.backdrop && Td(e, n.backdrop), o && (n.strokeColor && (e.strokeStyle = n.strokeColor), z(n.strokeWidth) || (e.lineWidth = n.strokeWidth), e.strokeText(c, i, r, n.maxWidth)), e.fillText(c, i, r, n.maxWidth), Pd(e, i, r, c, n), r += Number(s.lineHeight);
  e.restore();
}
function Si(e, t) {
  const { x: i, y: r, w: s, h: n, radius: a } = t;
  e.arc(i + a.topLeft, r + a.topLeft, a.topLeft, 1.5 * Z, Z, !0), e.lineTo(i, r + n - a.bottomLeft), e.arc(i + a.bottomLeft, r + n - a.bottomLeft, a.bottomLeft, Z, se, !0), e.lineTo(i + s - a.bottomRight, r + n), e.arc(i + s - a.bottomRight, r + n - a.bottomRight, a.bottomRight, se, 0, !0), e.lineTo(i + s, r + a.topRight), e.arc(i + s - a.topRight, r + a.topRight, a.topRight, 0, -se, !0), e.lineTo(i + a.topLeft, r);
}
const Od = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, Bd = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function Md(e, t) {
  const i = ("" + e).match(Od);
  if (!i || i[1] === "normal")
    return t * 1.2;
  switch (e = +i[2], i[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const Rd = (e) => +e || 0;
function Zs(e, t) {
  const i = {}, r = q(t), s = r ? Object.keys(t) : t, n = q(e) ? r ? (a) => L(e[a], e[t[a]]) : (a) => e[a] : () => e;
  for (const a of s)
    i[a] = Rd(n(a));
  return i;
}
function ml(e) {
  return Zs(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Dt(e) {
  return Zs(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function me(e) {
  const t = ml(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function ae(e, t) {
  e = e || {}, t = t || re.font;
  let i = L(e.size, t.size);
  typeof i == "string" && (i = parseInt(i, 10));
  let r = L(e.style, t.style);
  r && !("" + r).match(Bd) && (console.warn('Invalid font style specified: "' + r + '"'), r = void 0);
  const s = {
    family: L(e.family, t.family),
    lineHeight: Md(L(e.lineHeight, t.lineHeight), i),
    size: i,
    style: r,
    weight: L(e.weight, t.weight),
    string: ""
  };
  return s.string = xd(s), s;
}
function di(e, t, i, r) {
  let s, n, a;
  for (s = 0, n = e.length; s < n; ++s)
    if (a = e[s], a !== void 0 && a !== void 0)
      return a;
}
function Ed(e, t, i) {
  const { min: r, max: s } = e, n = rl(t, (s - r) / 2), a = (o, l) => i && o === 0 ? 0 : o + l;
  return {
    min: a(r, -Math.abs(n)),
    max: a(s, n)
  };
}
function ft(e, t) {
  return Object.assign(Object.create(e), t);
}
function Js(e, t = [
  ""
], i, r, s = () => e[0]) {
  const n = i || e;
  typeof r > "u" && (r = vl("_fallback", e));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: n,
    _fallback: r,
    _getTarget: s,
    override: (o) => Js([
      o,
      ...e
    ], t, n, r)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(o, l) {
      return delete o[l], delete o._keys, delete e[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(o, l) {
      return yl(o, l, () => Nd(l, t, e, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(o, l) {
      return Reflect.getOwnPropertyDescriptor(o._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(o, l) {
      return Jn(o).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(o) {
      return Jn(o);
    },
    /**
    * A trap for setting property values.
    */
    set(o, l, c) {
      const u = o._storage || (o._storage = s());
      return o[l] = u[l] = c, delete o._keys, !0;
    }
  });
}
function Wt(e, t, i, r) {
  const s = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: i,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: gl(e, r),
    setContext: (n) => Wt(e, n, i, r),
    override: (n) => Wt(e.override(n), t, i, r)
  };
  return new Proxy(s, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(n, a) {
      return delete n[a], delete e[a], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(n, a, o) {
      return yl(n, a, () => Fd(n, a, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(n, a) {
      return n._descriptors.allKeys ? Reflect.has(e, a) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, a);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(n, a) {
      return Reflect.has(e, a);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(n, a, o) {
      return e[a] = o, delete n[a], !0;
    }
  });
}
function gl(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: i = t.scriptable, _indexable: r = t.indexable, _allKeys: s = t.allKeys } = e;
  return {
    allKeys: s,
    scriptable: i,
    indexable: r,
    isScriptable: dt(i) ? i : () => i,
    isIndexable: dt(r) ? r : () => r
  };
}
const Ld = (e, t) => e ? e + Ws(t) : t, _s = (e, t) => q(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function yl(e, t, i) {
  if (Object.prototype.hasOwnProperty.call(e, t))
    return e[t];
  const r = i();
  return e[t] = r, r;
}
function Fd(e, t, i) {
  const { _proxy: r, _context: s, _subProxy: n, _descriptors: a } = e;
  let o = r[t];
  return dt(o) && a.isScriptable(t) && (o = jd(t, o, e, i)), _(o) && o.length && (o = Ud(t, o, e, a.isIndexable)), _s(t, o) && (o = Wt(o, s, n && n[t], a)), o;
}
function jd(e, t, i, r) {
  const { _proxy: s, _context: n, _subProxy: a, _stack: o } = i;
  if (o.has(e))
    throw new Error("Recursion detected: " + Array.from(o).join("->") + "->" + e);
  o.add(e);
  let l = t(n, a || r);
  return o.delete(e), _s(e, l) && (l = $s(s._scopes, s, e, l)), l;
}
function Ud(e, t, i, r) {
  const { _proxy: s, _context: n, _subProxy: a, _descriptors: o } = i;
  if (typeof n.index < "u" && r(e))
    return t[n.index % t.length];
  if (q(t[0])) {
    const l = t, c = s._scopes.filter((u) => u !== l);
    t = [];
    for (const u of l) {
      const d = $s(c, s, e, u);
      t.push(Wt(d, n, a && a[e], o));
    }
  }
  return t;
}
function bl(e, t, i) {
  return dt(e) ? e(t, i) : e;
}
const qd = (e, t) => e === !0 ? t : typeof e == "string" ? ut(t, e) : void 0;
function Hd(e, t, i, r, s) {
  for (const n of t) {
    const a = qd(i, n);
    if (a) {
      e.add(a);
      const o = bl(a._fallback, i, s);
      if (typeof o < "u" && o !== i && o !== r)
        return o;
    } else if (a === !1 && typeof r < "u" && i !== r)
      return null;
  }
  return !1;
}
function $s(e, t, i, r) {
  const s = t._rootScopes, n = bl(t._fallback, i, r), a = [
    ...e,
    ...s
  ], o = /* @__PURE__ */ new Set();
  o.add(r);
  let l = Zn(o, a, i, n || i, r);
  return l === null || typeof n < "u" && n !== i && (l = Zn(o, a, n, l, r), l === null) ? !1 : Js(Array.from(o), [
    ""
  ], s, n, () => zd(t, i, r));
}
function Zn(e, t, i, r, s) {
  for (; i; )
    i = Hd(e, t, i, r, s);
  return i;
}
function zd(e, t, i) {
  const r = e._getTarget();
  t in r || (r[t] = {});
  const s = r[t];
  return _(s) && q(i) ? i : s || {};
}
function Nd(e, t, i, r) {
  let s;
  for (const n of t)
    if (s = vl(Ld(n, e), i), typeof s < "u")
      return _s(e, s) ? $s(i, r, e, s) : s;
}
function vl(e, t) {
  for (const i of t) {
    if (!i)
      continue;
    const r = i[e];
    if (typeof r < "u")
      return r;
  }
}
function Jn(e) {
  let t = e._keys;
  return t || (t = e._keys = Vd(e._scopes)), t;
}
function Vd(e) {
  const t = /* @__PURE__ */ new Set();
  for (const i of e)
    for (const r of Object.keys(i).filter((s) => !s.startsWith("_")))
      t.add(r);
  return Array.from(t);
}
function Al(e, t, i, r) {
  const { iScale: s } = e, { key: n = "r" } = this._parsing, a = new Array(r);
  let o, l, c, u;
  for (o = 0, l = r; o < l; ++o)
    c = o + i, u = t[c], a[o] = {
      r: s.parse(ut(u, n), c)
    };
  return a;
}
const Gd = Number.EPSILON || 1e-14, Qt = (e, t) => t < e.length && !e[t].skip && e[t], kl = (e) => e === "x" ? "y" : "x";
function Wd(e, t, i, r) {
  const s = e.skip ? t : e, n = t, a = i.skip ? t : i, o = vs(n, s), l = vs(a, n);
  let c = o / (o + l), u = l / (o + l);
  c = isNaN(c) ? 0 : c, u = isNaN(u) ? 0 : u;
  const d = r * c, h = r * u;
  return {
    previous: {
      x: n.x - d * (a.x - s.x),
      y: n.y - d * (a.y - s.y)
    },
    next: {
      x: n.x + h * (a.x - s.x),
      y: n.y + h * (a.y - s.y)
    }
  };
}
function Qd(e, t, i) {
  const r = e.length;
  let s, n, a, o, l, c = Qt(e, 0);
  for (let u = 0; u < r - 1; ++u)
    if (l = c, c = Qt(e, u + 1), !(!l || !c)) {
      if (gi(t[u], 0, Gd)) {
        i[u] = i[u + 1] = 0;
        continue;
      }
      s = i[u] / t[u], n = i[u + 1] / t[u], o = Math.pow(s, 2) + Math.pow(n, 2), !(o <= 9) && (a = 3 / Math.sqrt(o), i[u] = s * a * t[u], i[u + 1] = n * a * t[u]);
    }
}
function Xd(e, t, i = "x") {
  const r = kl(i), s = e.length;
  let n, a, o, l = Qt(e, 0);
  for (let c = 0; c < s; ++c) {
    if (a = o, o = l, l = Qt(e, c + 1), !o)
      continue;
    const u = o[i], d = o[r];
    a && (n = (u - a[i]) / 3, o[`cp1${i}`] = u - n, o[`cp1${r}`] = d - n * t[c]), l && (n = (l[i] - u) / 3, o[`cp2${i}`] = u + n, o[`cp2${r}`] = d + n * t[c]);
  }
}
function Kd(e, t = "x") {
  const i = kl(t), r = e.length, s = Array(r).fill(0), n = Array(r);
  let a, o, l, c = Qt(e, 0);
  for (a = 0; a < r; ++a)
    if (o = l, l = c, c = Qt(e, a + 1), !!l) {
      if (c) {
        const u = c[t] - l[t];
        s[a] = u !== 0 ? (c[i] - l[i]) / u : 0;
      }
      n[a] = o ? c ? Ve(s[a - 1]) !== Ve(s[a]) ? 0 : (s[a - 1] + s[a]) / 2 : s[a - 1] : s[a];
    }
  Qd(e, s, n), Xd(e, n, t);
}
function Gi(e, t, i) {
  return Math.max(Math.min(e, i), t);
}
function Yd(e, t) {
  let i, r, s, n, a, o = it(e[0], t);
  for (i = 0, r = e.length; i < r; ++i)
    a = n, n = o, o = i < r - 1 && it(e[i + 1], t), n && (s = e[i], a && (s.cp1x = Gi(s.cp1x, t.left, t.right), s.cp1y = Gi(s.cp1y, t.top, t.bottom)), o && (s.cp2x = Gi(s.cp2x, t.left, t.right), s.cp2y = Gi(s.cp2y, t.top, t.bottom)));
}
function Zd(e, t, i, r, s) {
  let n, a, o, l;
  if (t.spanGaps && (e = e.filter((c) => !c.skip)), t.cubicInterpolationMode === "monotone")
    Kd(e, s);
  else {
    let c = r ? e[e.length - 1] : e[0];
    for (n = 0, a = e.length; n < a; ++n)
      o = e[n], l = Wd(c, o, e[Math.min(n + 1, a - (r ? 0 : 1)) % a], t.tension), o.cp1x = l.previous.x, o.cp1y = l.previous.y, o.cp2x = l.next.x, o.cp2y = l.next.y, c = o;
  }
  t.capBezierPoints && Yd(e, i);
}
function en() {
  return typeof window < "u" && typeof document < "u";
}
function tn(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function yr(e, t, i) {
  let r;
  return typeof e == "string" ? (r = parseInt(e, 10), e.indexOf("%") !== -1 && (r = r / 100 * t.parentNode[i])) : r = e, r;
}
const Dr = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function Jd(e, t) {
  return Dr(e).getPropertyValue(t);
}
const _d = [
  "top",
  "right",
  "bottom",
  "left"
];
function Pt(e, t, i) {
  const r = {};
  i = i ? "-" + i : "";
  for (let s = 0; s < 4; s++) {
    const n = _d[s];
    r[n] = parseFloat(e[t + "-" + n + i]) || 0;
  }
  return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
const $d = (e, t, i) => (e > 0 || t > 0) && (!i || !i.shadowRoot);
function eh(e, t) {
  const i = e.touches, r = i && i.length ? i[0] : e, { offsetX: s, offsetY: n } = r;
  let a = !1, o, l;
  if ($d(s, n, e.target))
    o = s, l = n;
  else {
    const c = t.getBoundingClientRect();
    o = r.clientX - c.left, l = r.clientY - c.top, a = !0;
  }
  return {
    x: o,
    y: l,
    box: a
  };
}
function xt(e, t) {
  if ("native" in e)
    return e;
  const { canvas: i, currentDevicePixelRatio: r } = t, s = Dr(i), n = s.boxSizing === "border-box", a = Pt(s, "padding"), o = Pt(s, "border", "width"), { x: l, y: c, box: u } = eh(e, i), d = a.left + (u && o.left), h = a.top + (u && o.top);
  let { width: p, height: m } = t;
  return n && (p -= a.width + o.width, m -= a.height + o.height), {
    x: Math.round((l - d) / p * i.width / r),
    y: Math.round((c - h) / m * i.height / r)
  };
}
function th(e, t, i) {
  let r, s;
  if (t === void 0 || i === void 0) {
    const n = tn(e);
    if (!n)
      t = e.clientWidth, i = e.clientHeight;
    else {
      const a = n.getBoundingClientRect(), o = Dr(n), l = Pt(o, "border", "width"), c = Pt(o, "padding");
      t = a.width - c.width - l.width, i = a.height - c.height - l.height, r = yr(o.maxWidth, n, "clientWidth"), s = yr(o.maxHeight, n, "clientHeight");
    }
  }
  return {
    width: t,
    height: i,
    maxWidth: r || mr,
    maxHeight: s || mr
  };
}
const Wi = (e) => Math.round(e * 10) / 10;
function ih(e, t, i, r) {
  const s = Dr(e), n = Pt(s, "margin"), a = yr(s.maxWidth, e, "clientWidth") || mr, o = yr(s.maxHeight, e, "clientHeight") || mr, l = th(e, t, i);
  let { width: c, height: u } = l;
  if (s.boxSizing === "content-box") {
    const d = Pt(s, "border", "width"), h = Pt(s, "padding");
    c -= h.width + d.width, u -= h.height + d.height;
  }
  return c = Math.max(0, c - n.width), u = Math.max(0, r ? c / r : u - n.height), c = Wi(Math.min(c, a, l.maxWidth)), u = Wi(Math.min(u, o, l.maxHeight)), c && !u && (u = Wi(c / 2)), (t !== void 0 || i !== void 0) && r && l.height && u > l.height && (u = l.height, c = Wi(Math.floor(u * r))), {
    width: c,
    height: u
  };
}
function _n(e, t, i) {
  const r = t || 1, s = Math.floor(e.height * r), n = Math.floor(e.width * r);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const a = e.canvas;
  return a.style && (i || !a.style.height && !a.style.width) && (a.style.height = `${e.height}px`, a.style.width = `${e.width}px`), e.currentDevicePixelRatio !== r || a.height !== s || a.width !== n ? (e.currentDevicePixelRatio = r, a.height = s, a.width = n, e.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
const rh = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    en() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch {
  }
  return e;
}();
function $n(e, t) {
  const i = Jd(e, t), r = i && i.match(/^(\d+)(\.\d+)?px$/);
  return r ? +r[1] : void 0;
}
function Ct(e, t, i, r) {
  return {
    x: e.x + i * (t.x - e.x),
    y: e.y + i * (t.y - e.y)
  };
}
function sh(e, t, i, r) {
  return {
    x: e.x + i * (t.x - e.x),
    y: r === "middle" ? i < 0.5 ? e.y : t.y : r === "after" ? i < 1 ? e.y : t.y : i > 0 ? t.y : e.y
  };
}
function nh(e, t, i, r) {
  const s = {
    x: e.cp2x,
    y: e.cp2y
  }, n = {
    x: t.cp1x,
    y: t.cp1y
  }, a = Ct(e, s, i), o = Ct(s, n, i), l = Ct(n, t, i), c = Ct(a, o, i), u = Ct(o, l, i);
  return Ct(c, u, i);
}
const ah = function(e, t) {
  return {
    x(i) {
      return e + e + t - i;
    },
    setWidth(i) {
      t = i;
    },
    textAlign(i) {
      return i === "center" ? i : i === "right" ? "left" : "right";
    },
    xPlus(i, r) {
      return i - r;
    },
    leftForLtr(i, r) {
      return i - r;
    }
  };
}, oh = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function Vt(e, t, i) {
  return e ? ah(t, i) : oh();
}
function wl(e, t) {
  let i, r;
  (t === "ltr" || t === "rtl") && (i = e.canvas.style, r = [
    i.getPropertyValue("direction"),
    i.getPropertyPriority("direction")
  ], i.setProperty("direction", t, "important"), e.prevTextDirection = r);
}
function xl(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function Cl(e) {
  return e === "angle" ? {
    between: Ci,
    compare: ld,
    normalize: Ie
  } : {
    between: et,
    compare: (t, i) => t - i,
    normalize: (t) => t
  };
}
function ea({ start: e, end: t, count: i, loop: r, style: s }) {
  return {
    start: e % i,
    end: t % i,
    loop: r && (t - e + 1) % i === 0,
    style: s
  };
}
function lh(e, t, i) {
  const { property: r, start: s, end: n } = i, { between: a, normalize: o } = Cl(r), l = t.length;
  let { start: c, end: u, loop: d } = e, h, p;
  if (d) {
    for (c += l, u += l, h = 0, p = l; h < p && a(o(t[c % l][r]), s, n); ++h)
      c--, u--;
    c %= l, u %= l;
  }
  return u < c && (u += l), {
    start: c,
    end: u,
    loop: d,
    style: e.style
  };
}
function Sl(e, t, i) {
  if (!i)
    return [
      e
    ];
  const { property: r, start: s, end: n } = i, a = t.length, { compare: o, between: l, normalize: c } = Cl(r), { start: u, end: d, loop: h, style: p } = lh(e, t, i), m = [];
  let g = !1, y = null, v, w, C;
  const A = () => l(s, C, v) && o(s, C) !== 0, k = () => o(n, v) === 0 || l(n, C, v), S = () => g || A(), D = () => !g || k();
  for (let T = u, F = u; T <= d; ++T)
    w = t[T % a], !w.skip && (v = c(w[r]), v !== C && (g = l(v, s, n), y === null && S() && (y = o(v, s) === 0 ? T : F), y !== null && D() && (m.push(ea({
      start: y,
      end: T,
      loop: h,
      count: a,
      style: p
    })), y = null), F = T, C = v));
  return y !== null && m.push(ea({
    start: y,
    end: d,
    loop: h,
    count: a,
    style: p
  })), m;
}
function Il(e, t) {
  const i = [], r = e.segments;
  for (let s = 0; s < r.length; s++) {
    const n = Sl(r[s], e.points, t);
    n.length && i.push(...n);
  }
  return i;
}
function ch(e, t, i, r) {
  let s = 0, n = t - 1;
  if (i && !r)
    for (; s < t && !e[s].skip; )
      s++;
  for (; s < t && e[s].skip; )
    s++;
  for (s %= t, i && (n += s); n > s && e[n % t].skip; )
    n--;
  return n %= t, {
    start: s,
    end: n
  };
}
function uh(e, t, i, r) {
  const s = e.length, n = [];
  let a = t, o = e[t], l;
  for (l = t + 1; l <= i; ++l) {
    const c = e[l % s];
    c.skip || c.stop ? o.skip || (r = !1, n.push({
      start: t % s,
      end: (l - 1) % s,
      loop: r
    }), t = a = c.stop ? l : null) : (a = l, o.skip && (t = l)), o = c;
  }
  return a !== null && n.push({
    start: t % s,
    end: a % s,
    loop: r
  }), n;
}
function dh(e, t) {
  const i = e.points, r = e.options.spanGaps, s = i.length;
  if (!s)
    return [];
  const n = !!e._loop, { start: a, end: o } = ch(i, s, n, r);
  if (r === !0)
    return ta(e, [
      {
        start: a,
        end: o,
        loop: n
      }
    ], i, t);
  const l = o < a ? o + s : o, c = !!e._fullLoop && a === 0 && o === s - 1;
  return ta(e, uh(i, a, l, c), i, t);
}
function ta(e, t, i, r) {
  return !r || !r.setContext || !i ? t : hh(e, t, i, r);
}
function hh(e, t, i, r) {
  const s = e._chart.getContext(), n = ia(e.options), { _datasetIndex: a, options: { spanGaps: o } } = e, l = i.length, c = [];
  let u = n, d = t[0].start, h = d;
  function p(m, g, y, v) {
    const w = o ? -1 : 1;
    if (m !== g) {
      for (m += l; i[m % l].skip; )
        m -= w;
      for (; i[g % l].skip; )
        g += w;
      m % l !== g % l && (c.push({
        start: m % l,
        end: g % l,
        loop: y,
        style: v
      }), u = v, d = g % l);
    }
  }
  for (const m of t) {
    d = o ? d : m.start;
    let g = i[d % l], y;
    for (h = d + 1; h <= m.end; h++) {
      const v = i[h % l];
      y = ia(r.setContext(ft(s, {
        type: "segment",
        p0: g,
        p1: v,
        p0DataIndex: (h - 1) % l,
        p1DataIndex: h % l,
        datasetIndex: a
      }))), ph(y, u) && p(d, h - 1, m.loop, u), g = v, u = y;
    }
    d < h - 1 && p(d, h - 1, m.loop, u);
  }
  return c;
}
function ia(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function ph(e, t) {
  if (!t)
    return !1;
  const i = [], r = function(s, n) {
    return Ys(n) ? (i.includes(n) || i.push(n), i.indexOf(n)) : n;
  };
  return JSON.stringify(e, r) !== JSON.stringify(t, r);
}
/*!
 * Chart.js v4.4.1
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
class fh {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, i, r, s) {
    const n = i.listeners[s], a = i.duration;
    n.forEach((o) => o({
      chart: t,
      initial: i.initial,
      numSteps: a,
      currentStep: Math.min(r - i.start, a)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = cl.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let i = 0;
    this._charts.forEach((r, s) => {
      if (!r.running || !r.items.length)
        return;
      const n = r.items;
      let a = n.length - 1, o = !1, l;
      for (; a >= 0; --a)
        l = n[a], l._active ? (l._total > r.duration && (r.duration = l._total), l.tick(t), o = !0) : (n[a] = n[n.length - 1], n.pop());
      o && (s.draw(), this._notify(s, r, t, "progress")), n.length || (r.running = !1, this._notify(s, r, t, "complete"), r.initial = !1), i += n.length;
    }), this._lastDate = t, i === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const i = this._charts;
    let r = i.get(t);
    return r || (r = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, i.set(t, r)), r;
  }
  listen(t, i, r) {
    this._getAnims(t).listeners[i].push(r);
  }
  add(t, i) {
    !i || !i.length || this._getAnims(t).items.push(...i);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const i = this._charts.get(t);
    i && (i.running = !0, i.start = Date.now(), i.duration = i.items.reduce((r, s) => Math.max(r, s._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const i = this._charts.get(t);
    return !(!i || !i.running || !i.items.length);
  }
  stop(t) {
    const i = this._charts.get(t);
    if (!i || !i.items.length)
      return;
    const r = i.items;
    let s = r.length - 1;
    for (; s >= 0; --s)
      r[s].cancel();
    i.items = [], this._notify(t, i, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var Je = /* @__PURE__ */ new fh();
const ra = "transparent", mh = {
  boolean(e, t, i) {
    return i > 0.5 ? t : e;
  },
  color(e, t, i) {
    const r = Xn(e || ra), s = r.valid && Xn(t || ra);
    return s && s.valid ? s.mix(r, i).hexString() : t;
  },
  number(e, t, i) {
    return e + (t - e) * i;
  }
};
class gh {
  constructor(t, i, r, s) {
    const n = i[r];
    s = di([
      t.to,
      s,
      n,
      t.from
    ]);
    const a = di([
      t.from,
      n,
      s
    ]);
    this._active = !0, this._fn = t.fn || mh[t.type || typeof a], this._easing = yi[t.easing] || yi.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = i, this._prop = r, this._from = a, this._to = s, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, i, r) {
    if (this._active) {
      this._notify(!1);
      const s = this._target[this._prop], n = r - this._start, a = this._duration - n;
      this._start = r, this._duration = Math.floor(Math.max(a, t.duration)), this._total += n, this._loop = !!t.loop, this._to = di([
        t.to,
        i,
        s,
        t.from
      ]), this._from = di([
        t.from,
        s,
        i
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const i = t - this._start, r = this._duration, s = this._prop, n = this._from, a = this._loop, o = this._to;
    let l;
    if (this._active = n !== o && (a || i < r), !this._active) {
      this._target[s] = o, this._notify(!0);
      return;
    }
    if (i < 0) {
      this._target[s] = n;
      return;
    }
    l = i / r % 2, l = a && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[s] = this._fn(n, o, l);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((i, r) => {
      t.push({
        res: i,
        rej: r
      });
    });
  }
  _notify(t) {
    const i = t ? "res" : "rej", r = this._promises || [];
    for (let s = 0; s < r.length; s++)
      r[s][i]();
  }
}
class Dl {
  constructor(t, i) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(i);
  }
  configure(t) {
    if (!q(t))
      return;
    const i = Object.keys(re.animation), r = this._properties;
    Object.getOwnPropertyNames(t).forEach((s) => {
      const n = t[s];
      if (!q(n))
        return;
      const a = {};
      for (const o of i)
        a[o] = n[o];
      (_(n.properties) && n.properties || [
        s
      ]).forEach((o) => {
        (o === s || !r.has(o)) && r.set(o, a);
      });
    });
  }
  _animateOptions(t, i) {
    const r = i.options, s = bh(t, r);
    if (!s)
      return [];
    const n = this._createAnimations(s, r);
    return r.$shared && yh(t.options.$animations, r).then(() => {
      t.options = r;
    }, () => {
    }), n;
  }
  _createAnimations(t, i) {
    const r = this._properties, s = [], n = t.$animations || (t.$animations = {}), a = Object.keys(i), o = Date.now();
    let l;
    for (l = a.length - 1; l >= 0; --l) {
      const c = a[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        s.push(...this._animateOptions(t, i));
        continue;
      }
      const u = i[c];
      let d = n[c];
      const h = r.get(c);
      if (d)
        if (h && d.active()) {
          d.update(h, u, o);
          continue;
        } else
          d.cancel();
      if (!h || !h.duration) {
        t[c] = u;
        continue;
      }
      n[c] = d = new gh(h, t, c, u), s.push(d);
    }
    return s;
  }
  update(t, i) {
    if (this._properties.size === 0) {
      Object.assign(t, i);
      return;
    }
    const r = this._createAnimations(t, i);
    if (r.length)
      return Je.add(this._chart, r), !0;
  }
}
function yh(e, t) {
  const i = [], r = Object.keys(t);
  for (let s = 0; s < r.length; s++) {
    const n = e[r[s]];
    n && n.active() && i.push(n.wait());
  }
  return Promise.all(i);
}
function bh(e, t) {
  if (!t)
    return;
  let i = e.options;
  if (!i) {
    e.options = t;
    return;
  }
  return i.$shared && (e.options = i = Object.assign({}, i, {
    $shared: !1,
    $animations: {}
  })), i;
}
function sa(e, t) {
  const i = e && e.options || {}, r = i.reverse, s = i.min === void 0 ? t : 0, n = i.max === void 0 ? t : 0;
  return {
    start: r ? n : s,
    end: r ? s : n
  };
}
function vh(e, t, i) {
  if (i === !1)
    return !1;
  const r = sa(e, i), s = sa(t, i);
  return {
    top: s.end,
    right: r.end,
    bottom: s.start,
    left: r.start
  };
}
function Ah(e) {
  let t, i, r, s;
  return q(e) ? (t = e.top, i = e.right, r = e.bottom, s = e.left) : t = i = r = s = e, {
    top: t,
    right: i,
    bottom: r,
    left: s,
    disabled: e === !1
  };
}
function Pl(e, t) {
  const i = [], r = e._getSortedDatasetMetas(t);
  let s, n;
  for (s = 0, n = r.length; s < n; ++s)
    i.push(r[s].index);
  return i;
}
function na(e, t, i, r = {}) {
  const s = e.keys, n = r.mode === "single";
  let a, o, l, c;
  if (t !== null) {
    for (a = 0, o = s.length; a < o; ++a) {
      if (l = +s[a], l === i) {
        if (r.all)
          continue;
        break;
      }
      c = e.values[l], ie(c) && (n || t === 0 || Ve(t) === Ve(c)) && (t += c);
    }
    return t;
  }
}
function kh(e) {
  const t = Object.keys(e), i = new Array(t.length);
  let r, s, n;
  for (r = 0, s = t.length; r < s; ++r)
    n = t[r], i[r] = {
      x: n,
      y: e[n]
    };
  return i;
}
function aa(e, t) {
  const i = e && e.options.stacked;
  return i || i === void 0 && t.stack !== void 0;
}
function wh(e, t, i) {
  return `${e.id}.${t.id}.${i.stack || i.type}`;
}
function xh(e) {
  const { min: t, max: i, minDefined: r, maxDefined: s } = e.getUserBounds();
  return {
    min: r ? t : Number.NEGATIVE_INFINITY,
    max: s ? i : Number.POSITIVE_INFINITY
  };
}
function Ch(e, t, i) {
  const r = e[t] || (e[t] = {});
  return r[i] || (r[i] = {});
}
function oa(e, t, i, r) {
  for (const s of t.getMatchingVisibleMetas(r).reverse()) {
    const n = e[s.index];
    if (i && n > 0 || !i && n < 0)
      return s.index;
  }
  return null;
}
function la(e, t) {
  const { chart: i, _cachedMeta: r } = e, s = i._stacks || (i._stacks = {}), { iScale: n, vScale: a, index: o } = r, l = n.axis, c = a.axis, u = wh(n, a, r), d = t.length;
  let h;
  for (let p = 0; p < d; ++p) {
    const m = t[p], { [l]: g, [c]: y } = m, v = m._stacks || (m._stacks = {});
    h = v[c] = Ch(s, u, g), h[o] = y, h._top = oa(h, a, !0, r.type), h._bottom = oa(h, a, !1, r.type);
    const w = h._visualValues || (h._visualValues = {});
    w[o] = y;
  }
}
function Yr(e, t) {
  const i = e.scales;
  return Object.keys(i).filter((r) => i[r].axis === t).shift();
}
function Sh(e, t) {
  return ft(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function Ih(e, t, i) {
  return ft(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: i,
    index: t,
    mode: "default",
    type: "data"
  });
}
function _t(e, t) {
  const i = e.controller.index, r = e.vScale && e.vScale.axis;
  if (r) {
    t = t || e._parsed;
    for (const s of t) {
      const n = s._stacks;
      if (!n || n[r] === void 0 || n[r][i] === void 0)
        return;
      delete n[r][i], n[r]._visualValues !== void 0 && n[r]._visualValues[i] !== void 0 && delete n[r]._visualValues[i];
    }
  }
}
const Zr = (e) => e === "reset" || e === "none", ca = (e, t) => t ? e : Object.assign({}, e), Dh = (e, t, i) => e && !t.hidden && t._stacked && {
  keys: Pl(i, !0),
  values: null
};
class Fe {
  constructor(t, i) {
    this.chart = t, this._ctx = t.ctx, this.index = i, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = aa(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && _t(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, i = this._cachedMeta, r = this.getDataset(), s = (d, h, p, m) => d === "x" ? h : d === "r" ? m : p, n = i.xAxisID = L(r.xAxisID, Yr(t, "x")), a = i.yAxisID = L(r.yAxisID, Yr(t, "y")), o = i.rAxisID = L(r.rAxisID, Yr(t, "r")), l = i.indexAxis, c = i.iAxisID = s(l, n, a, o), u = i.vAxisID = s(l, a, n, o);
    i.xScale = this.getScaleForId(n), i.yScale = this.getScaleForId(a), i.rScale = this.getScaleForId(o), i.iScale = this.getScaleForId(c), i.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const i = this._cachedMeta;
    return t === i.iScale ? i.vScale : i.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && Gn(this._data, this), t._stacked && _t(t);
  }
  _dataCheck() {
    const t = this.getDataset(), i = t.data || (t.data = []), r = this._data;
    if (q(i))
      this._data = kh(i);
    else if (r !== i) {
      if (r) {
        Gn(r, this);
        const s = this._cachedMeta;
        _t(s), s._parsed = [];
      }
      i && Object.isExtensible(i) && hd(i, this), this._syncList = [], this._data = i;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const i = this._cachedMeta, r = this.getDataset();
    let s = !1;
    this._dataCheck();
    const n = i._stacked;
    i._stacked = aa(i.vScale, i), i.stack !== r.stack && (s = !0, _t(i), i.stack = r.stack), this._resyncElements(t), (s || n !== i._stacked) && la(this, i._parsed);
  }
  configure() {
    const t = this.chart.config, i = t.datasetScopeKeys(this._type), r = t.getOptionScopes(this.getDataset(), i, !0);
    this.options = t.createResolver(r, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, i) {
    const { _cachedMeta: r, _data: s } = this, { iScale: n, _stacked: a } = r, o = n.axis;
    let l = t === 0 && i === s.length ? !0 : r._sorted, c = t > 0 && r._parsed[t - 1], u, d, h;
    if (this._parsing === !1)
      r._parsed = s, r._sorted = !0, h = s;
    else {
      _(s[t]) ? h = this.parseArrayData(r, s, t, i) : q(s[t]) ? h = this.parseObjectData(r, s, t, i) : h = this.parsePrimitiveData(r, s, t, i);
      const p = () => d[o] === null || c && d[o] < c[o];
      for (u = 0; u < i; ++u)
        r._parsed[u + t] = d = h[u], l && (p() && (l = !1), c = d);
      r._sorted = l;
    }
    a && la(this, h);
  }
  parsePrimitiveData(t, i, r, s) {
    const { iScale: n, vScale: a } = t, o = n.axis, l = a.axis, c = n.getLabels(), u = n === a, d = new Array(s);
    let h, p, m;
    for (h = 0, p = s; h < p; ++h)
      m = h + r, d[h] = {
        [o]: u || n.parse(c[m], m),
        [l]: a.parse(i[m], m)
      };
    return d;
  }
  parseArrayData(t, i, r, s) {
    const { xScale: n, yScale: a } = t, o = new Array(s);
    let l, c, u, d;
    for (l = 0, c = s; l < c; ++l)
      u = l + r, d = i[u], o[l] = {
        x: n.parse(d[0], u),
        y: a.parse(d[1], u)
      };
    return o;
  }
  parseObjectData(t, i, r, s) {
    const { xScale: n, yScale: a } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(s);
    let u, d, h, p;
    for (u = 0, d = s; u < d; ++u)
      h = u + r, p = i[h], c[u] = {
        x: n.parse(ut(p, o), h),
        y: a.parse(ut(p, l), h)
      };
    return c;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, i, r) {
    const s = this.chart, n = this._cachedMeta, a = i[t.axis], o = {
      keys: Pl(s, !0),
      values: i._stacks[t.axis]._visualValues
    };
    return na(o, a, n.index, {
      mode: r
    });
  }
  updateRangeFromParsed(t, i, r, s) {
    const n = r[i.axis];
    let a = n === null ? NaN : n;
    const o = s && r._stacks[i.axis];
    s && o && (s.values = o, a = na(s, n, this._cachedMeta.index)), t.min = Math.min(t.min, a), t.max = Math.max(t.max, a);
  }
  getMinMax(t, i) {
    const r = this._cachedMeta, s = r._parsed, n = r._sorted && t === r.iScale, a = s.length, o = this._getOtherScale(t), l = Dh(i, r, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: d } = xh(o);
    let h, p;
    function m() {
      p = s[h];
      const g = p[o.axis];
      return !ie(p[t.axis]) || u > g || d < g;
    }
    for (h = 0; h < a && !(!m() && (this.updateRangeFromParsed(c, t, p, l), n)); ++h)
      ;
    if (n) {
      for (h = a - 1; h >= 0; --h)
        if (!m()) {
          this.updateRangeFromParsed(c, t, p, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(t) {
    const i = this._cachedMeta._parsed, r = [];
    let s, n, a;
    for (s = 0, n = i.length; s < n; ++s)
      a = i[s][t.axis], ie(a) && r.push(a);
    return r;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const i = this._cachedMeta, r = i.iScale, s = i.vScale, n = this.getParsed(t);
    return {
      label: r ? "" + r.getLabelForValue(n[r.axis]) : "",
      value: s ? "" + s.getLabelForValue(n[s.axis]) : ""
    };
  }
  _update(t) {
    const i = this._cachedMeta;
    this.update(t || "default"), i._clip = Ah(L(this.options.clip, vh(i.xScale, i.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, i = this.chart, r = this._cachedMeta, s = r.data || [], n = i.chartArea, a = [], o = this._drawStart || 0, l = this._drawCount || s.length - o, c = this.options.drawActiveElementsOnTop;
    let u;
    for (r.dataset && r.dataset.draw(t, n, o, l), u = o; u < o + l; ++u) {
      const d = s[u];
      d.hidden || (d.active && c ? a.push(d) : d.draw(t, n));
    }
    for (u = 0; u < a.length; ++u)
      a[u].draw(t, n);
  }
  getStyle(t, i) {
    const r = i ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(r) : this.resolveDataElementOptions(t || 0, r);
  }
  getContext(t, i, r) {
    const s = this.getDataset();
    let n;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const a = this._cachedMeta.data[t];
      n = a.$context || (a.$context = Ih(this.getContext(), t, a)), n.parsed = this.getParsed(t), n.raw = s.data[t], n.index = n.dataIndex = t;
    } else
      n = this.$context || (this.$context = Sh(this.chart.getContext(), this.index)), n.dataset = s, n.index = n.datasetIndex = this.index;
    return n.active = !!i, n.mode = r, n;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, i) {
    return this._resolveElementOptions(this.dataElementType.id, i, t);
  }
  _resolveElementOptions(t, i = "default", r) {
    const s = i === "active", n = this._cachedDataOpts, a = t + "-" + i, o = n[a], l = this.enableOptionSharing && xi(r);
    if (o)
      return ca(o, l);
    const c = this.chart.config, u = c.datasetElementScopeKeys(this._type, t), d = s ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], h = c.getOptionScopes(this.getDataset(), u), p = Object.keys(re.elements[t]), m = () => this.getContext(r, s, i), g = c.resolveNamedOptions(h, p, m, d);
    return g.$shared && (g.$shared = l, n[a] = Object.freeze(ca(g, l))), g;
  }
  _resolveAnimations(t, i, r) {
    const s = this.chart, n = this._cachedDataOpts, a = `animation-${i}`, o = n[a];
    if (o)
      return o;
    let l;
    if (s.options.animation !== !1) {
      const u = this.chart.config, d = u.datasetAnimationScopeKeys(this._type, i), h = u.getOptionScopes(this.getDataset(), d);
      l = u.createResolver(h, this.getContext(t, r, i));
    }
    const c = new Dl(s, l && l.animations);
    return l && l._cacheable && (n[a] = Object.freeze(c)), c;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, i) {
    return !i || Zr(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, i) {
    const r = this.resolveDataElementOptions(t, i), s = this._sharedOptions, n = this.getSharedOptions(r), a = this.includeOptions(i, n) || n !== s;
    return this.updateSharedOptions(n, i, r), {
      sharedOptions: n,
      includeOptions: a
    };
  }
  updateElement(t, i, r, s) {
    Zr(s) ? Object.assign(t, r) : this._resolveAnimations(i, s).update(t, r);
  }
  updateSharedOptions(t, i, r) {
    t && !Zr(i) && this._resolveAnimations(void 0, i).update(t, r);
  }
  _setStyle(t, i, r, s) {
    t.active = s;
    const n = this.getStyle(i, s);
    this._resolveAnimations(i, r, s).update(t, {
      options: !s && this.getSharedOptions(n) || n
    });
  }
  removeHoverStyle(t, i, r) {
    this._setStyle(t, r, "active", !1);
  }
  setHoverStyle(t, i, r) {
    this._setStyle(t, r, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const i = this._data, r = this._cachedMeta.data;
    for (const [o, l, c] of this._syncList)
      this[o](l, c);
    this._syncList = [];
    const s = r.length, n = i.length, a = Math.min(n, s);
    a && this.parse(0, a), n > s ? this._insertElements(s, n - s, t) : n < s && this._removeElements(n, s - n);
  }
  _insertElements(t, i, r = !0) {
    const s = this._cachedMeta, n = s.data, a = t + i;
    let o;
    const l = (c) => {
      for (c.length += i, o = c.length - 1; o >= a; o--)
        c[o] = c[o - i];
    };
    for (l(n), o = t; o < a; ++o)
      n[o] = new this.dataElementType();
    this._parsing && l(s._parsed), this.parse(t, i), r && this.updateElements(n, t, i, "reset");
  }
  updateElements(t, i, r, s) {
  }
  _removeElements(t, i) {
    const r = this._cachedMeta;
    if (this._parsing) {
      const s = r._parsed.splice(t, i);
      r._stacked && _t(r, s);
    }
    r.data.splice(t, i);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [i, r, s] = t;
      this[i](r, s);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, i) {
    i && this._sync([
      "_removeElements",
      t,
      i
    ]);
    const r = arguments.length - 2;
    r && this._sync([
      "_insertElements",
      t,
      r
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
I(Fe, "defaults", {}), I(Fe, "datasetElementType", null), I(Fe, "dataElementType", null);
function Ph(e, t) {
  if (!e._cache.$bar) {
    const i = e.getMatchingVisibleMetas(t);
    let r = [];
    for (let s = 0, n = i.length; s < n; s++)
      r = r.concat(i[s].controller.getAllParsedValues(e));
    e._cache.$bar = ll(r.sort((s, n) => s - n));
  }
  return e._cache.$bar;
}
function Th(e) {
  const t = e.iScale, i = Ph(t, e.type);
  let r = t._length, s, n, a, o;
  const l = () => {
    a === 32767 || a === -32768 || (xi(o) && (r = Math.min(r, Math.abs(a - o) || r)), o = a);
  };
  for (s = 0, n = i.length; s < n; ++s)
    a = t.getPixelForValue(i[s]), l();
  for (o = void 0, s = 0, n = t.ticks.length; s < n; ++s)
    a = t.getPixelForTick(s), l();
  return r;
}
function Oh(e, t, i, r) {
  const s = i.barThickness;
  let n, a;
  return z(s) ? (n = t.min * i.categoryPercentage, a = i.barPercentage) : (n = s * r, a = 1), {
    chunk: n / r,
    ratio: a,
    start: t.pixels[e] - n / 2
  };
}
function Bh(e, t, i, r) {
  const s = t.pixels, n = s[e];
  let a = e > 0 ? s[e - 1] : null, o = e < s.length - 1 ? s[e + 1] : null;
  const l = i.categoryPercentage;
  a === null && (a = n - (o === null ? t.end - t.start : o - n)), o === null && (o = n + n - a);
  const c = n - (n - Math.min(a, o)) / 2 * l;
  return {
    chunk: Math.abs(o - a) / 2 * l / r,
    ratio: i.barPercentage,
    start: c
  };
}
function Mh(e, t, i, r) {
  const s = i.parse(e[0], r), n = i.parse(e[1], r), a = Math.min(s, n), o = Math.max(s, n);
  let l = a, c = o;
  Math.abs(a) > Math.abs(o) && (l = o, c = a), t[i.axis] = c, t._custom = {
    barStart: l,
    barEnd: c,
    start: s,
    end: n,
    min: a,
    max: o
  };
}
function Tl(e, t, i, r) {
  return _(e) ? Mh(e, t, i, r) : t[i.axis] = i.parse(e, r), t;
}
function ua(e, t, i, r) {
  const s = e.iScale, n = e.vScale, a = s.getLabels(), o = s === n, l = [];
  let c, u, d, h;
  for (c = i, u = i + r; c < u; ++c)
    h = t[c], d = {}, d[s.axis] = o || s.parse(a[c], c), l.push(Tl(h, d, n, c));
  return l;
}
function Jr(e) {
  return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
function Rh(e, t, i) {
  return e !== 0 ? Ve(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= i ? 1 : -1);
}
function Eh(e) {
  let t, i, r, s, n;
  return e.horizontal ? (t = e.base > e.x, i = "left", r = "right") : (t = e.base < e.y, i = "bottom", r = "top"), t ? (s = "end", n = "start") : (s = "start", n = "end"), {
    start: i,
    end: r,
    reverse: t,
    top: s,
    bottom: n
  };
}
function Lh(e, t, i, r) {
  let s = t.borderSkipped;
  const n = {};
  if (!s) {
    e.borderSkipped = n;
    return;
  }
  if (s === !0) {
    e.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: a, end: o, reverse: l, top: c, bottom: u } = Eh(e);
  s === "middle" && i && (e.enableBorderRadius = !0, (i._top || 0) === r ? s = c : (i._bottom || 0) === r ? s = u : (n[da(u, a, o, l)] = !0, s = c)), n[da(s, a, o, l)] = !0, e.borderSkipped = n;
}
function da(e, t, i, r) {
  return r ? (e = Fh(e, t, i), e = ha(e, i, t)) : e = ha(e, t, i), e;
}
function Fh(e, t, i) {
  return e === t ? i : e === i ? t : e;
}
function ha(e, t, i) {
  return e === "start" ? t : e === "end" ? i : e;
}
function jh(e, { inflateAmount: t }, i) {
  e.inflateAmount = t === "auto" ? i === 1 ? 0.33 : 0 : t;
}
class rr extends Fe {
  parsePrimitiveData(t, i, r, s) {
    return ua(t, i, r, s);
  }
  parseArrayData(t, i, r, s) {
    return ua(t, i, r, s);
  }
  parseObjectData(t, i, r, s) {
    const { iScale: n, vScale: a } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = n.axis === "x" ? o : l, u = a.axis === "x" ? o : l, d = [];
    let h, p, m, g;
    for (h = r, p = r + s; h < p; ++h)
      g = i[h], m = {}, m[n.axis] = n.parse(ut(g, c), h), d.push(Tl(ut(g, u), m, a, h));
    return d;
  }
  updateRangeFromParsed(t, i, r, s) {
    super.updateRangeFromParsed(t, i, r, s);
    const n = r._custom;
    n && i === this._cachedMeta.vScale && (t.min = Math.min(t.min, n.min), t.max = Math.max(t.max, n.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const i = this._cachedMeta, { iScale: r, vScale: s } = i, n = this.getParsed(t), a = n._custom, o = Jr(a) ? "[" + a.start + ", " + a.end + "]" : "" + s.getLabelForValue(n[s.axis]);
    return {
      label: "" + r.getLabelForValue(n[r.axis]),
      value: o
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const i = this._cachedMeta;
    this.updateElements(i.data, 0, i.data.length, t);
  }
  updateElements(t, i, r, s) {
    const n = s === "reset", { index: a, _cachedMeta: { vScale: o } } = this, l = o.getBasePixel(), c = o.isHorizontal(), u = this._getRuler(), { sharedOptions: d, includeOptions: h } = this._getSharedOptions(i, s);
    for (let p = i; p < i + r; p++) {
      const m = this.getParsed(p), g = n || z(m[o.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(p), y = this._calculateBarIndexPixels(p, u), v = (m._stacks || {})[o.axis], w = {
        horizontal: c,
        base: g.base,
        enableBorderRadius: !v || Jr(m._custom) || a === v._top || a === v._bottom,
        x: c ? g.head : y.center,
        y: c ? y.center : g.head,
        height: c ? y.size : Math.abs(g.size),
        width: c ? Math.abs(g.size) : y.size
      };
      h && (w.options = d || this.resolveDataElementOptions(p, t[p].active ? "active" : s));
      const C = w.options || t[p].options;
      Lh(w, C, v, a), jh(w, C, u.ratio), this.updateElement(t[p], p, w, s);
    }
  }
  _getStacks(t, i) {
    const { iScale: r } = this._cachedMeta, s = r.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), n = r.options.stacked, a = [], o = (l) => {
      const c = l.controller.getParsed(i), u = c && c[l.vScale.axis];
      if (z(u) || isNaN(u))
        return !0;
    };
    for (const l of s)
      if (!(i !== void 0 && o(l)) && ((n === !1 || a.indexOf(l.stack) === -1 || n === void 0 && l.stack === void 0) && a.push(l.stack), l.index === t))
        break;
    return a.length || a.push(void 0), a;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, i, r) {
    const s = this._getStacks(t, r), n = i !== void 0 ? s.indexOf(i) : -1;
    return n === -1 ? s.length - 1 : n;
  }
  _getRuler() {
    const t = this.options, i = this._cachedMeta, r = i.iScale, s = [];
    let n, a;
    for (n = 0, a = i.data.length; n < a; ++n)
      s.push(r.getPixelForValue(this.getParsed(n)[r.axis], n));
    const o = t.barThickness;
    return {
      min: o || Th(i),
      pixels: s,
      start: r._startPixel,
      end: r._endPixel,
      stackCount: this._getStackCount(),
      scale: r,
      grouped: t.grouped,
      ratio: o ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: i, _stacked: r, index: s }, options: { base: n, minBarLength: a } } = this, o = n || 0, l = this.getParsed(t), c = l._custom, u = Jr(c);
    let d = l[i.axis], h = 0, p = r ? this.applyStack(i, l, r) : d, m, g;
    p !== d && (h = p - d, p = d), u && (d = c.barStart, p = c.barEnd - c.barStart, d !== 0 && Ve(d) !== Ve(c.barEnd) && (h = 0), h += d);
    const y = !z(n) && !u ? n : h;
    let v = i.getPixelForValue(y);
    if (this.chart.getDataVisibility(t) ? m = i.getPixelForValue(h + p) : m = v, g = m - v, Math.abs(g) < a) {
      g = Rh(g, i, o) * a, d === o && (v -= g / 2);
      const w = i.getPixelForDecimal(0), C = i.getPixelForDecimal(1), A = Math.min(w, C), k = Math.max(w, C);
      v = Math.max(Math.min(v, k), A), m = v + g, r && !u && (l._stacks[i.axis]._visualValues[s] = i.getValueForPixel(m) - i.getValueForPixel(v));
    }
    if (v === i.getPixelForValue(o)) {
      const w = Ve(g) * i.getLineWidthForValue(o) / 2;
      v += w, g -= w;
    }
    return {
      size: g,
      base: v,
      head: m,
      center: m + g / 2
    };
  }
  _calculateBarIndexPixels(t, i) {
    const r = i.scale, s = this.options, n = s.skipNull, a = L(s.maxBarThickness, 1 / 0);
    let o, l;
    if (i.grouped) {
      const c = n ? this._getStackCount(t) : i.stackCount, u = s.barThickness === "flex" ? Bh(t, i, s, c) : Oh(t, i, s, c), d = this._getStackIndex(this.index, this._cachedMeta.stack, n ? t : void 0);
      o = u.start + u.chunk * d + u.chunk / 2, l = Math.min(a, u.chunk * u.ratio);
    } else
      o = r.getPixelForValue(this.getParsed(t)[r.axis], t), l = Math.min(a, i.min * i.ratio);
    return {
      base: o - l / 2,
      head: o + l / 2,
      center: o,
      size: l
    };
  }
  draw() {
    const t = this._cachedMeta, i = t.vScale, r = t.data, s = r.length;
    let n = 0;
    for (; n < s; ++n)
      this.getParsed(n)[i.axis] !== null && r[n].draw(this._ctx);
  }
}
I(rr, "id", "bar"), I(rr, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), I(rr, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class sr extends Fe {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, i, r, s) {
    const n = super.parsePrimitiveData(t, i, r, s);
    for (let a = 0; a < n.length; a++)
      n[a]._custom = this.resolveDataElementOptions(a + r).radius;
    return n;
  }
  parseArrayData(t, i, r, s) {
    const n = super.parseArrayData(t, i, r, s);
    for (let a = 0; a < n.length; a++) {
      const o = i[r + a];
      n[a]._custom = L(o[2], this.resolveDataElementOptions(a + r).radius);
    }
    return n;
  }
  parseObjectData(t, i, r, s) {
    const n = super.parseObjectData(t, i, r, s);
    for (let a = 0; a < n.length; a++) {
      const o = i[r + a];
      n[a]._custom = L(o && o.r && +o.r, this.resolveDataElementOptions(a + r).radius);
    }
    return n;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let i = 0;
    for (let r = t.length - 1; r >= 0; --r)
      i = Math.max(i, t[r].size(this.resolveDataElementOptions(r)) / 2);
    return i > 0 && i;
  }
  getLabelAndValue(t) {
    const i = this._cachedMeta, r = this.chart.data.labels || [], { xScale: s, yScale: n } = i, a = this.getParsed(t), o = s.getLabelForValue(a.x), l = n.getLabelForValue(a.y), c = a._custom;
    return {
      label: r[t] || "",
      value: "(" + o + ", " + l + (c ? ", " + c : "") + ")"
    };
  }
  update(t) {
    const i = this._cachedMeta.data;
    this.updateElements(i, 0, i.length, t);
  }
  updateElements(t, i, r, s) {
    const n = s === "reset", { iScale: a, vScale: o } = this._cachedMeta, { sharedOptions: l, includeOptions: c } = this._getSharedOptions(i, s), u = a.axis, d = o.axis;
    for (let h = i; h < i + r; h++) {
      const p = t[h], m = !n && this.getParsed(h), g = {}, y = g[u] = n ? a.getPixelForDecimal(0.5) : a.getPixelForValue(m[u]), v = g[d] = n ? o.getBasePixel() : o.getPixelForValue(m[d]);
      g.skip = isNaN(y) || isNaN(v), c && (g.options = l || this.resolveDataElementOptions(h, p.active ? "active" : s), n && (g.options.radius = 0)), this.updateElement(p, h, g, s);
    }
  }
  resolveDataElementOptions(t, i) {
    const r = this.getParsed(t);
    let s = super.resolveDataElementOptions(t, i);
    s.$shared && (s = Object.assign({}, s, {
      $shared: !1
    }));
    const n = s.radius;
    return i !== "active" && (s.radius = 0), s.radius += L(r && r._custom, n), s;
  }
}
I(sr, "id", "bubble"), I(sr, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), I(sr, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function Uh(e, t, i) {
  let r = 1, s = 1, n = 0, a = 0;
  if (t < Y) {
    const o = e, l = o + t, c = Math.cos(o), u = Math.sin(o), d = Math.cos(l), h = Math.sin(l), p = (C, A, k) => Ci(C, o, l, !0) ? 1 : Math.max(A, A * i, k, k * i), m = (C, A, k) => Ci(C, o, l, !0) ? -1 : Math.min(A, A * i, k, k * i), g = p(0, c, d), y = p(se, u, h), v = m(Z, c, d), w = m(Z + se, u, h);
    r = (g - v) / 2, s = (y - w) / 2, n = -(g + v) / 2, a = -(y + w) / 2;
  }
  return {
    ratioX: r,
    ratioY: s,
    offsetX: n,
    offsetY: a
  };
}
class It extends Fe {
  constructor(t, i) {
    super(t, i), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, i) {
    const r = this.getDataset().data, s = this._cachedMeta;
    if (this._parsing === !1)
      s._parsed = r;
    else {
      let n = (l) => +r[l];
      if (q(r[t])) {
        const { key: l = "value" } = this._parsing;
        n = (c) => +ut(r[c], l);
      }
      let a, o;
      for (a = t, o = t + i; a < o; ++a)
        s._parsed[a] = n(a);
    }
  }
  _getRotation() {
    return Le(this.options.rotation - 90);
  }
  _getCircumference() {
    return Le(this.options.circumference);
  }
  _getRotationExtents() {
    let t = Y, i = -Y;
    for (let r = 0; r < this.chart.data.datasets.length; ++r)
      if (this.chart.isDatasetVisible(r) && this.chart.getDatasetMeta(r).type === this._type) {
        const s = this.chart.getDatasetMeta(r).controller, n = s._getRotation(), a = s._getCircumference();
        t = Math.min(t, n), i = Math.max(i, n + a);
      }
    return {
      rotation: t,
      circumference: i - t
    };
  }
  update(t) {
    const i = this.chart, { chartArea: r } = i, s = this._cachedMeta, n = s.data, a = this.getMaxBorderWidth() + this.getMaxOffset(n) + this.options.spacing, o = Math.max((Math.min(r.width, r.height) - a) / 2, 0), l = Math.min(_u(this.options.cutout, o), 1), c = this._getRingWeight(this.index), { circumference: u, rotation: d } = this._getRotationExtents(), { ratioX: h, ratioY: p, offsetX: m, offsetY: g } = Uh(d, u, l), y = (r.width - a) / h, v = (r.height - a) / p, w = Math.max(Math.min(y, v) / 2, 0), C = rl(this.options.radius, w), A = Math.max(C * l, 0), k = (C - A) / this._getVisibleDatasetWeightTotal();
    this.offsetX = m * C, this.offsetY = g * C, s.total = this.calculateTotal(), this.outerRadius = C - k * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - k * c, 0), this.updateElements(n, 0, n.length, t);
  }
  _circumference(t, i) {
    const r = this.options, s = this._cachedMeta, n = this._getCircumference();
    return i && r.animation.animateRotate || !this.chart.getDataVisibility(t) || s._parsed[t] === null || s.data[t].hidden ? 0 : this.calculateCircumference(s._parsed[t] * n / Y);
  }
  updateElements(t, i, r, s) {
    const n = s === "reset", a = this.chart, o = a.chartArea, l = a.options.animation, c = (o.left + o.right) / 2, u = (o.top + o.bottom) / 2, d = n && l.animateScale, h = d ? 0 : this.innerRadius, p = d ? 0 : this.outerRadius, { sharedOptions: m, includeOptions: g } = this._getSharedOptions(i, s);
    let y = this._getRotation(), v;
    for (v = 0; v < i; ++v)
      y += this._circumference(v, n);
    for (v = i; v < i + r; ++v) {
      const w = this._circumference(v, n), C = t[v], A = {
        x: c + this.offsetX,
        y: u + this.offsetY,
        startAngle: y,
        endAngle: y + w,
        circumference: w,
        outerRadius: p,
        innerRadius: h
      };
      g && (A.options = m || this.resolveDataElementOptions(v, C.active ? "active" : s)), y += w, this.updateElement(C, v, A, s);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, i = t.data;
    let r = 0, s;
    for (s = 0; s < i.length; s++) {
      const n = t._parsed[s];
      n !== null && !isNaN(n) && this.chart.getDataVisibility(s) && !i[s].hidden && (r += Math.abs(n));
    }
    return r;
  }
  calculateCircumference(t) {
    const i = this._cachedMeta.total;
    return i > 0 && !isNaN(t) ? Y * (Math.abs(t) / i) : 0;
  }
  getLabelAndValue(t) {
    const i = this._cachedMeta, r = this.chart, s = r.data.labels || [], n = Oi(i._parsed[t], r.options.locale);
    return {
      label: s[t] || "",
      value: n
    };
  }
  getMaxBorderWidth(t) {
    let i = 0;
    const r = this.chart;
    let s, n, a, o, l;
    if (!t) {
      for (s = 0, n = r.data.datasets.length; s < n; ++s)
        if (r.isDatasetVisible(s)) {
          a = r.getDatasetMeta(s), t = a.data, o = a.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (s = 0, n = t.length; s < n; ++s)
      l = o.resolveDataElementOptions(s), l.borderAlign !== "inner" && (i = Math.max(i, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return i;
  }
  getMaxOffset(t) {
    let i = 0;
    for (let r = 0, s = t.length; r < s; ++r) {
      const n = this.resolveDataElementOptions(r);
      i = Math.max(i, n.offset || 0, n.hoverOffset || 0);
    }
    return i;
  }
  _getRingWeightOffset(t) {
    let i = 0;
    for (let r = 0; r < t; ++r)
      this.chart.isDatasetVisible(r) && (i += this._getRingWeight(r));
    return i;
  }
  _getRingWeight(t) {
    return Math.max(L(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
I(It, "id", "doughnut"), I(It, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), I(It, "descriptors", {
  _scriptable: (e) => e !== "spacing",
  _indexable: (e) => e !== "spacing" && !e.startsWith("borderDash") && !e.startsWith("hoverBorderDash")
}), I(It, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const t = e.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: i, color: r } } = e.legend.options;
            return t.labels.map((s, n) => {
              const a = e.getDatasetMeta(0).controller.getStyle(n);
              return {
                text: s,
                fillStyle: a.backgroundColor,
                strokeStyle: a.borderColor,
                fontColor: r,
                lineWidth: a.borderWidth,
                pointStyle: i,
                hidden: !e.getDataVisibility(n),
                index: n
              };
            });
          }
          return [];
        }
      },
      onClick(e, t, i) {
        i.chart.toggleDataVisibility(t.index), i.chart.update();
      }
    }
  }
});
class nr extends Fe {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const i = this._cachedMeta, { dataset: r, data: s = [], _dataset: n } = i, a = this.chart._animationsDisabled;
    let { start: o, count: l } = dl(i, s, a);
    this._drawStart = o, this._drawCount = l, hl(i) && (o = 0, l = s.length), r._chart = this.chart, r._datasetIndex = this.index, r._decimated = !!n._decimated, r.points = s;
    const c = this.resolveDatasetElementOptions(t);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(r, void 0, {
      animated: !a,
      options: c
    }, t), this.updateElements(s, o, l, t);
  }
  updateElements(t, i, r, s) {
    const n = s === "reset", { iScale: a, vScale: o, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: u, includeOptions: d } = this._getSharedOptions(i, s), h = a.axis, p = o.axis, { spanGaps: m, segment: g } = this.options, y = Gt(m) ? m : Number.POSITIVE_INFINITY, v = this.chart._animationsDisabled || n || s === "none", w = i + r, C = t.length;
    let A = i > 0 && this.getParsed(i - 1);
    for (let k = 0; k < C; ++k) {
      const S = t[k], D = v ? S : {};
      if (k < i || k >= w) {
        D.skip = !0;
        continue;
      }
      const T = this.getParsed(k), F = z(T[p]), R = D[h] = a.getPixelForValue(T[h], k), M = D[p] = n || F ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, T, l) : T[p], k);
      D.skip = isNaN(R) || isNaN(M) || F, D.stop = k > 0 && Math.abs(T[h] - A[h]) > y, g && (D.parsed = T, D.raw = c.data[k]), d && (D.options = u || this.resolveDataElementOptions(k, S.active ? "active" : s)), v || this.updateElement(S, k, D, s), A = T;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, i = t.dataset, r = i.options && i.options.borderWidth || 0, s = t.data || [];
    if (!s.length)
      return r;
    const n = s[0].size(this.resolveDataElementOptions(0)), a = s[s.length - 1].size(this.resolveDataElementOptions(s.length - 1));
    return Math.max(r, n, a) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
I(nr, "id", "line"), I(nr, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), I(nr, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
class vi extends Fe {
  constructor(t, i) {
    super(t, i), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const i = this._cachedMeta, r = this.chart, s = r.data.labels || [], n = Oi(i._parsed[t].r, r.options.locale);
    return {
      label: s[t] || "",
      value: n
    };
  }
  parseObjectData(t, i, r, s) {
    return Al.bind(this)(t, i, r, s);
  }
  update(t) {
    const i = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(i, 0, i.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, i = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    return t.data.forEach((r, s) => {
      const n = this.getParsed(s).r;
      !isNaN(n) && this.chart.getDataVisibility(s) && (n < i.min && (i.min = n), n > i.max && (i.max = n));
    }), i;
  }
  _updateRadius() {
    const t = this.chart, i = t.chartArea, r = t.options, s = Math.min(i.right - i.left, i.bottom - i.top), n = Math.max(s / 2, 0), a = Math.max(r.cutoutPercentage ? n / 100 * r.cutoutPercentage : 1, 0), o = (n - a) / t.getVisibleDatasetCount();
    this.outerRadius = n - o * this.index, this.innerRadius = this.outerRadius - o;
  }
  updateElements(t, i, r, s) {
    const n = s === "reset", a = this.chart, o = a.options.animation, l = this._cachedMeta.rScale, c = l.xCenter, u = l.yCenter, d = l.getIndexAngle(0) - 0.5 * Z;
    let h = d, p;
    const m = 360 / this.countVisibleElements();
    for (p = 0; p < i; ++p)
      h += this._computeAngle(p, s, m);
    for (p = i; p < i + r; p++) {
      const g = t[p];
      let y = h, v = h + this._computeAngle(p, s, m), w = a.getDataVisibility(p) ? l.getDistanceFromCenterForValue(this.getParsed(p).r) : 0;
      h = v, n && (o.animateScale && (w = 0), o.animateRotate && (y = v = d));
      const C = {
        x: c,
        y: u,
        innerRadius: 0,
        outerRadius: w,
        startAngle: y,
        endAngle: v,
        options: this.resolveDataElementOptions(p, g.active ? "active" : s)
      };
      this.updateElement(g, p, C, s);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let i = 0;
    return t.data.forEach((r, s) => {
      !isNaN(this.getParsed(s).r) && this.chart.getDataVisibility(s) && i++;
    }), i;
  }
  _computeAngle(t, i, r) {
    return this.chart.getDataVisibility(t) ? Le(this.resolveDataElementOptions(t, i).angle || r) : 0;
  }
}
I(vi, "id", "polarArea"), I(vi, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
}), I(vi, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const t = e.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: i, color: r } } = e.legend.options;
            return t.labels.map((s, n) => {
              const a = e.getDatasetMeta(0).controller.getStyle(n);
              return {
                text: s,
                fillStyle: a.backgroundColor,
                strokeStyle: a.borderColor,
                fontColor: r,
                lineWidth: a.borderWidth,
                pointStyle: i,
                hidden: !e.getDataVisibility(n),
                index: n
              };
            });
          }
          return [];
        }
      },
      onClick(e, t, i) {
        i.chart.toggleDataVisibility(t.index), i.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
});
class ws extends It {
}
I(ws, "id", "pie"), I(ws, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
class ar extends Fe {
  getLabelAndValue(t) {
    const i = this._cachedMeta.vScale, r = this.getParsed(t);
    return {
      label: i.getLabels()[t],
      value: "" + i.getLabelForValue(r[i.axis])
    };
  }
  parseObjectData(t, i, r, s) {
    return Al.bind(this)(t, i, r, s);
  }
  update(t) {
    const i = this._cachedMeta, r = i.dataset, s = i.data || [], n = i.iScale.getLabels();
    if (r.points = s, t !== "resize") {
      const a = this.resolveDatasetElementOptions(t);
      this.options.showLine || (a.borderWidth = 0);
      const o = {
        _loop: !0,
        _fullLoop: n.length === s.length,
        options: a
      };
      this.updateElement(r, void 0, o, t);
    }
    this.updateElements(s, 0, s.length, t);
  }
  updateElements(t, i, r, s) {
    const n = this._cachedMeta.rScale, a = s === "reset";
    for (let o = i; o < i + r; o++) {
      const l = t[o], c = this.resolveDataElementOptions(o, l.active ? "active" : s), u = n.getPointPositionForValue(o, this.getParsed(o).r), d = a ? n.xCenter : u.x, h = a ? n.yCenter : u.y, p = {
        x: d,
        y: h,
        angle: u.angle,
        skip: isNaN(d) || isNaN(h),
        options: c
      };
      this.updateElement(l, o, p, s);
    }
  }
}
I(ar, "id", "radar"), I(ar, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
}), I(ar, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
class or extends Fe {
  getLabelAndValue(t) {
    const i = this._cachedMeta, r = this.chart.data.labels || [], { xScale: s, yScale: n } = i, a = this.getParsed(t), o = s.getLabelForValue(a.x), l = n.getLabelForValue(a.y);
    return {
      label: r[t] || "",
      value: "(" + o + ", " + l + ")"
    };
  }
  update(t) {
    const i = this._cachedMeta, { data: r = [] } = i, s = this.chart._animationsDisabled;
    let { start: n, count: a } = dl(i, r, s);
    if (this._drawStart = n, this._drawCount = a, hl(i) && (n = 0, a = r.length), this.options.showLine) {
      this.datasetElementType || this.addElements();
      const { dataset: o, _dataset: l } = i;
      o._chart = this.chart, o._datasetIndex = this.index, o._decimated = !!l._decimated, o.points = r;
      const c = this.resolveDatasetElementOptions(t);
      c.segment = this.options.segment, this.updateElement(o, void 0, {
        animated: !s,
        options: c
      }, t);
    } else this.datasetElementType && (delete i.dataset, this.datasetElementType = !1);
    this.updateElements(r, n, a, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(t, i, r, s) {
    const n = s === "reset", { iScale: a, vScale: o, _stacked: l, _dataset: c } = this._cachedMeta, u = this.resolveDataElementOptions(i, s), d = this.getSharedOptions(u), h = this.includeOptions(s, d), p = a.axis, m = o.axis, { spanGaps: g, segment: y } = this.options, v = Gt(g) ? g : Number.POSITIVE_INFINITY, w = this.chart._animationsDisabled || n || s === "none";
    let C = i > 0 && this.getParsed(i - 1);
    for (let A = i; A < i + r; ++A) {
      const k = t[A], S = this.getParsed(A), D = w ? k : {}, T = z(S[m]), F = D[p] = a.getPixelForValue(S[p], A), R = D[m] = n || T ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, S, l) : S[m], A);
      D.skip = isNaN(F) || isNaN(R) || T, D.stop = A > 0 && Math.abs(S[p] - C[p]) > v, y && (D.parsed = S, D.raw = c.data[A]), h && (D.options = d || this.resolveDataElementOptions(A, k.active ? "active" : s)), w || this.updateElement(k, A, D, s), C = S;
    }
    this.updateSharedOptions(d, s, u);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, i = t.data || [];
    if (!this.options.showLine) {
      let o = 0;
      for (let l = i.length - 1; l >= 0; --l)
        o = Math.max(o, i[l].size(this.resolveDataElementOptions(l)) / 2);
      return o > 0 && o;
    }
    const r = t.dataset, s = r.options && r.options.borderWidth || 0;
    if (!i.length)
      return s;
    const n = i[0].size(this.resolveDataElementOptions(0)), a = i[i.length - 1].size(this.resolveDataElementOptions(i.length - 1));
    return Math.max(s, n, a) / 2;
  }
}
I(or, "id", "scatter"), I(or, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), I(or, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var qh = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: rr,
  BubbleController: sr,
  DoughnutController: It,
  LineController: nr,
  PieController: ws,
  PolarAreaController: vi,
  RadarController: ar,
  ScatterController: or
});
function vt() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class rn {
  constructor(t) {
    I(this, "options"), this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(rn.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return vt();
  }
  parse() {
    return vt();
  }
  format() {
    return vt();
  }
  add() {
    return vt();
  }
  diff() {
    return vt();
  }
  startOf() {
    return vt();
  }
  endOf() {
    return vt();
  }
}
var Hh = {
  _date: rn
};
function zh(e, t, i, r) {
  const { controller: s, data: n, _sorted: a } = e, o = s._cachedMeta.iScale;
  if (o && t === o.axis && t !== "r" && a && n.length) {
    const l = o._reversePixels ? ud : tt;
    if (r) {
      if (s._sharedOptions) {
        const c = n[0], u = typeof c.getRange == "function" && c.getRange(t);
        if (u) {
          const d = l(n, t, i - u), h = l(n, t, i + u);
          return {
            lo: d.lo,
            hi: h.hi
          };
        }
      }
    } else return l(n, t, i);
  }
  return {
    lo: 0,
    hi: n.length - 1
  };
}
function Pr(e, t, i, r, s) {
  const n = e.getSortedVisibleDatasetMetas(), a = i[t];
  for (let o = 0, l = n.length; o < l; ++o) {
    const { index: c, data: u } = n[o], { lo: d, hi: h } = zh(n[o], t, a, s);
    for (let p = d; p <= h; ++p) {
      const m = u[p];
      m.skip || r(m, c, p);
    }
  }
}
function Nh(e) {
  const t = e.indexOf("x") !== -1, i = e.indexOf("y") !== -1;
  return function(r, s) {
    const n = t ? Math.abs(r.x - s.x) : 0, a = i ? Math.abs(r.y - s.y) : 0;
    return Math.sqrt(Math.pow(n, 2) + Math.pow(a, 2));
  };
}
function _r(e, t, i, r, s) {
  const n = [];
  return !s && !e.isPointInArea(t) || Pr(e, i, t, function(a, o, l) {
    !s && !it(a, e.chartArea, 0) || a.inRange(t.x, t.y, r) && n.push({
      element: a,
      datasetIndex: o,
      index: l
    });
  }, !0), n;
}
function Vh(e, t, i, r) {
  let s = [];
  function n(a, o, l) {
    const { startAngle: c, endAngle: u } = a.getProps([
      "startAngle",
      "endAngle"
    ], r), { angle: d } = al(a, {
      x: t.x,
      y: t.y
    });
    Ci(d, c, u) && s.push({
      element: a,
      datasetIndex: o,
      index: l
    });
  }
  return Pr(e, i, t, n), s;
}
function Gh(e, t, i, r, s, n) {
  let a = [];
  const o = Nh(i);
  let l = Number.POSITIVE_INFINITY;
  function c(u, d, h) {
    const p = u.inRange(t.x, t.y, s);
    if (r && !p)
      return;
    const m = u.getCenterPoint(s);
    if (!(n || e.isPointInArea(m)) && !p)
      return;
    const g = o(t, m);
    g < l ? (a = [
      {
        element: u,
        datasetIndex: d,
        index: h
      }
    ], l = g) : g === l && a.push({
      element: u,
      datasetIndex: d,
      index: h
    });
  }
  return Pr(e, i, t, c), a;
}
function $r(e, t, i, r, s, n) {
  return !n && !e.isPointInArea(t) ? [] : i === "r" && !r ? Vh(e, t, i, s) : Gh(e, t, i, r, s, n);
}
function pa(e, t, i, r, s) {
  const n = [], a = i === "x" ? "inXRange" : "inYRange";
  let o = !1;
  return Pr(e, i, t, (l, c, u) => {
    l[a](t[i], s) && (n.push({
      element: l,
      datasetIndex: c,
      index: u
    }), o = o || l.inRange(t.x, t.y, s));
  }), r && !o ? [] : n;
}
var Wh = {
  modes: {
    index(e, t, i, r) {
      const s = xt(t, e), n = i.axis || "x", a = i.includeInvisible || !1, o = i.intersect ? _r(e, s, n, r, a) : $r(e, s, n, !1, r, a), l = [];
      return o.length ? (e.getSortedVisibleDatasetMetas().forEach((c) => {
        const u = o[0].index, d = c.data[u];
        d && !d.skip && l.push({
          element: d,
          datasetIndex: c.index,
          index: u
        });
      }), l) : [];
    },
    dataset(e, t, i, r) {
      const s = xt(t, e), n = i.axis || "xy", a = i.includeInvisible || !1;
      let o = i.intersect ? _r(e, s, n, r, a) : $r(e, s, n, !1, r, a);
      if (o.length > 0) {
        const l = o[0].datasetIndex, c = e.getDatasetMeta(l).data;
        o = [];
        for (let u = 0; u < c.length; ++u)
          o.push({
            element: c[u],
            datasetIndex: l,
            index: u
          });
      }
      return o;
    },
    point(e, t, i, r) {
      const s = xt(t, e), n = i.axis || "xy", a = i.includeInvisible || !1;
      return _r(e, s, n, r, a);
    },
    nearest(e, t, i, r) {
      const s = xt(t, e), n = i.axis || "xy", a = i.includeInvisible || !1;
      return $r(e, s, n, i.intersect, r, a);
    },
    x(e, t, i, r) {
      const s = xt(t, e);
      return pa(e, s, "x", i.intersect, r);
    },
    y(e, t, i, r) {
      const s = xt(t, e);
      return pa(e, s, "y", i.intersect, r);
    }
  }
};
const Ol = [
  "left",
  "top",
  "right",
  "bottom"
];
function $t(e, t) {
  return e.filter((i) => i.pos === t);
}
function fa(e, t) {
  return e.filter((i) => Ol.indexOf(i.pos) === -1 && i.box.axis === t);
}
function ei(e, t) {
  return e.sort((i, r) => {
    const s = t ? r : i, n = t ? i : r;
    return s.weight === n.weight ? s.index - n.index : s.weight - n.weight;
  });
}
function Qh(e) {
  const t = [];
  let i, r, s, n, a, o;
  for (i = 0, r = (e || []).length; i < r; ++i)
    s = e[i], { position: n, options: { stack: a, stackWeight: o = 1 } } = s, t.push({
      index: i,
      box: s,
      pos: n,
      horizontal: s.isHorizontal(),
      weight: s.weight,
      stack: a && n + a,
      stackWeight: o
    });
  return t;
}
function Xh(e) {
  const t = {};
  for (const i of e) {
    const { stack: r, pos: s, stackWeight: n } = i;
    if (!r || !Ol.includes(s))
      continue;
    const a = t[r] || (t[r] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    a.count++, a.weight += n;
  }
  return t;
}
function Kh(e, t) {
  const i = Xh(e), { vBoxMaxWidth: r, hBoxMaxHeight: s } = t;
  let n, a, o;
  for (n = 0, a = e.length; n < a; ++n) {
    o = e[n];
    const { fullSize: l } = o.box, c = i[o.stack], u = c && o.stackWeight / c.weight;
    o.horizontal ? (o.width = u ? u * r : l && t.availableWidth, o.height = s) : (o.width = r, o.height = u ? u * s : l && t.availableHeight);
  }
  return i;
}
function Yh(e) {
  const t = Qh(e), i = ei(t.filter((c) => c.box.fullSize), !0), r = ei($t(t, "left"), !0), s = ei($t(t, "right")), n = ei($t(t, "top"), !0), a = ei($t(t, "bottom")), o = fa(t, "x"), l = fa(t, "y");
  return {
    fullSize: i,
    leftAndTop: r.concat(n),
    rightAndBottom: s.concat(l).concat(a).concat(o),
    chartArea: $t(t, "chartArea"),
    vertical: r.concat(s).concat(l),
    horizontal: n.concat(a).concat(o)
  };
}
function ma(e, t, i, r) {
  return Math.max(e[i], t[i]) + Math.max(e[r], t[r]);
}
function Bl(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function Zh(e, t, i, r) {
  const { pos: s, box: n } = i, a = e.maxPadding;
  if (!q(s)) {
    i.size && (e[s] -= i.size);
    const d = r[i.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, i.horizontal ? n.height : n.width), i.size = d.size / d.count, e[s] += i.size;
  }
  n.getPadding && Bl(a, n.getPadding());
  const o = Math.max(0, t.outerWidth - ma(a, e, "left", "right")), l = Math.max(0, t.outerHeight - ma(a, e, "top", "bottom")), c = o !== e.w, u = l !== e.h;
  return e.w = o, e.h = l, i.horizontal ? {
    same: c,
    other: u
  } : {
    same: u,
    other: c
  };
}
function Jh(e) {
  const t = e.maxPadding;
  function i(r) {
    const s = Math.max(t[r] - e[r], 0);
    return e[r] += s, s;
  }
  e.y += i("top"), e.x += i("left"), i("right"), i("bottom");
}
function _h(e, t) {
  const i = t.maxPadding;
  function r(s) {
    const n = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return s.forEach((a) => {
      n[a] = Math.max(t[a], i[a]);
    }), n;
  }
  return r(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function hi(e, t, i, r) {
  const s = [];
  let n, a, o, l, c, u;
  for (n = 0, a = e.length, c = 0; n < a; ++n) {
    o = e[n], l = o.box, l.update(o.width || t.w, o.height || t.h, _h(o.horizontal, t));
    const { same: d, other: h } = Zh(t, i, o, r);
    c |= d && s.length, u = u || h, l.fullSize || s.push(o);
  }
  return c && hi(s, t, i, r) || u;
}
function Qi(e, t, i, r, s) {
  e.top = i, e.left = t, e.right = t + r, e.bottom = i + s, e.width = r, e.height = s;
}
function ga(e, t, i, r) {
  const s = i.padding;
  let { x: n, y: a } = t;
  for (const o of e) {
    const l = o.box, c = r[o.stack] || {
      placed: 0,
      weight: 1
    }, u = o.stackWeight / c.weight || 1;
    if (o.horizontal) {
      const d = t.w * u, h = c.size || l.height;
      xi(c.start) && (a = c.start), l.fullSize ? Qi(l, s.left, a, i.outerWidth - s.right - s.left, h) : Qi(l, t.left + c.placed, a, d, h), c.start = a, c.placed += d, a = l.bottom;
    } else {
      const d = t.h * u, h = c.size || l.width;
      xi(c.start) && (n = c.start), l.fullSize ? Qi(l, n, s.top, h, i.outerHeight - s.bottom - s.top) : Qi(l, n, t.top + c.placed, h, d), c.start = n, c.placed += d, n = l.right;
    }
  }
  t.x = n, t.y = a;
}
var fe = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(i) {
            t.draw(i);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const i = e.boxes ? e.boxes.indexOf(t) : -1;
    i !== -1 && e.boxes.splice(i, 1);
  },
  configure(e, t, i) {
    t.fullSize = i.fullSize, t.position = i.position, t.weight = i.weight;
  },
  update(e, t, i, r) {
    if (!e)
      return;
    const s = me(e.options.layout.padding), n = Math.max(t - s.width, 0), a = Math.max(i - s.height, 0), o = Yh(e.boxes), l = o.vertical, c = o.horizontal;
    G(e.boxes, (g) => {
      typeof g.beforeLayout == "function" && g.beforeLayout();
    });
    const u = l.reduce((g, y) => y.box.options && y.box.options.display === !1 ? g : g + 1, 0) || 1, d = Object.freeze({
      outerWidth: t,
      outerHeight: i,
      padding: s,
      availableWidth: n,
      availableHeight: a,
      vBoxMaxWidth: n / 2 / u,
      hBoxMaxHeight: a / 2
    }), h = Object.assign({}, s);
    Bl(h, me(r));
    const p = Object.assign({
      maxPadding: h,
      w: n,
      h: a,
      x: s.left,
      y: s.top
    }, s), m = Kh(l.concat(c), d);
    hi(o.fullSize, p, d, m), hi(l, p, d, m), hi(c, p, d, m) && hi(l, p, d, m), Jh(p), ga(o.leftAndTop, p, d, m), p.x += p.w, p.y += p.h, ga(o.rightAndBottom, p, d, m), e.chartArea = {
      left: p.left,
      top: p.top,
      right: p.left + p.w,
      bottom: p.top + p.h,
      height: p.h,
      width: p.w
    }, G(o.chartArea, (g) => {
      const y = g.box;
      Object.assign(y, e.chartArea), y.update(p.w, p.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class Ml {
  acquireContext(t, i) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, i, r) {
  }
  removeEventListener(t, i, r) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, i, r, s) {
    return i = Math.max(0, i || t.width), r = r || t.height, {
      width: i,
      height: Math.max(0, s ? Math.floor(i / s) : r)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class $h extends Ml {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const lr = "$chartjs", ep = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, ya = (e) => e === null || e === "";
function tp(e, t) {
  const i = e.style, r = e.getAttribute("height"), s = e.getAttribute("width");
  if (e[lr] = {
    initial: {
      height: r,
      width: s,
      style: {
        display: i.display,
        height: i.height,
        width: i.width
      }
    }
  }, i.display = i.display || "block", i.boxSizing = i.boxSizing || "border-box", ya(s)) {
    const n = $n(e, "width");
    n !== void 0 && (e.width = n);
  }
  if (ya(r))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const n = $n(e, "height");
      n !== void 0 && (e.height = n);
    }
  return e;
}
const Rl = rh ? {
  passive: !0
} : !1;
function ip(e, t, i) {
  e.addEventListener(t, i, Rl);
}
function rp(e, t, i) {
  e.canvas.removeEventListener(t, i, Rl);
}
function sp(e, t) {
  const i = ep[e.type] || e.type, { x: r, y: s } = xt(e, t);
  return {
    type: i,
    chart: t,
    native: e,
    x: r !== void 0 ? r : null,
    y: s !== void 0 ? s : null
  };
}
function br(e, t) {
  for (const i of e)
    if (i === t || i.contains(t))
      return !0;
}
function np(e, t, i) {
  const r = e.canvas, s = new MutationObserver((n) => {
    let a = !1;
    for (const o of n)
      a = a || br(o.addedNodes, r), a = a && !br(o.removedNodes, r);
    a && i();
  });
  return s.observe(document, {
    childList: !0,
    subtree: !0
  }), s;
}
function ap(e, t, i) {
  const r = e.canvas, s = new MutationObserver((n) => {
    let a = !1;
    for (const o of n)
      a = a || br(o.removedNodes, r), a = a && !br(o.addedNodes, r);
    a && i();
  });
  return s.observe(document, {
    childList: !0,
    subtree: !0
  }), s;
}
const Ii = /* @__PURE__ */ new Map();
let ba = 0;
function El() {
  const e = window.devicePixelRatio;
  e !== ba && (ba = e, Ii.forEach((t, i) => {
    i.currentDevicePixelRatio !== e && t();
  }));
}
function op(e, t) {
  Ii.size || window.addEventListener("resize", El), Ii.set(e, t);
}
function lp(e) {
  Ii.delete(e), Ii.size || window.removeEventListener("resize", El);
}
function cp(e, t, i) {
  const r = e.canvas, s = r && tn(r);
  if (!s)
    return;
  const n = ul((o, l) => {
    const c = s.clientWidth;
    i(o, l), c < s.clientWidth && i();
  }, window), a = new ResizeObserver((o) => {
    const l = o[0], c = l.contentRect.width, u = l.contentRect.height;
    c === 0 && u === 0 || n(c, u);
  });
  return a.observe(s), op(e, n), a;
}
function es(e, t, i) {
  i && i.disconnect(), t === "resize" && lp(e);
}
function up(e, t, i) {
  const r = e.canvas, s = ul((n) => {
    e.ctx !== null && i(sp(n, e));
  }, e);
  return ip(r, t, s), s;
}
class dp extends Ml {
  acquireContext(t, i) {
    const r = t && t.getContext && t.getContext("2d");
    return r && r.canvas === t ? (tp(t, i), r) : null;
  }
  releaseContext(t) {
    const i = t.canvas;
    if (!i[lr])
      return !1;
    const r = i[lr].initial;
    [
      "height",
      "width"
    ].forEach((n) => {
      const a = r[n];
      z(a) ? i.removeAttribute(n) : i.setAttribute(n, a);
    });
    const s = r.style || {};
    return Object.keys(s).forEach((n) => {
      i.style[n] = s[n];
    }), i.width = i.width, delete i[lr], !0;
  }
  addEventListener(t, i, r) {
    this.removeEventListener(t, i);
    const s = t.$proxies || (t.$proxies = {}), n = {
      attach: np,
      detach: ap,
      resize: cp
    }[i] || up;
    s[i] = n(t, i, r);
  }
  removeEventListener(t, i) {
    const r = t.$proxies || (t.$proxies = {}), s = r[i];
    s && (({
      attach: es,
      detach: es,
      resize: es
    }[i] || rp)(t, i, s), r[i] = void 0);
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, i, r, s) {
    return ih(t, i, r, s);
  }
  isAttached(t) {
    const i = tn(t);
    return !!(i && i.isConnected);
  }
}
function hp(e) {
  return !en() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? $h : dp;
}
var Xi;
let st = (Xi = class {
  constructor() {
    I(this, "x"), I(this, "y"), I(this, "active", !1), I(this, "options"), I(this, "$animations");
  }
  tooltipPosition(e) {
    const { x: t, y: i } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: t,
      y: i
    };
  }
  hasValue() {
    return Gt(this.x) && Gt(this.y);
  }
  getProps(e, t) {
    const i = this.$animations;
    if (!t || !i)
      return this;
    const r = {};
    return e.forEach((s) => {
      r[s] = i[s] && i[s].active() ? i[s]._to : this[s];
    }), r;
  }
}, I(Xi, "defaults", {}), I(Xi, "defaultRoutes"), Xi);
function pp(e, t) {
  const i = e.options.ticks, r = fp(e), s = Math.min(i.maxTicksLimit || r, r), n = i.major.enabled ? gp(t) : [], a = n.length, o = n[0], l = n[a - 1], c = [];
  if (a > s)
    return yp(t, c, n, a / s), c;
  const u = mp(n, t, s);
  if (a > 0) {
    let d, h;
    const p = a > 1 ? Math.round((l - o) / (a - 1)) : null;
    for (Ki(t, c, u, z(p) ? 0 : o - p, o), d = 0, h = a - 1; d < h; d++)
      Ki(t, c, u, n[d], n[d + 1]);
    return Ki(t, c, u, l, z(p) ? t.length : l + p), c;
  }
  return Ki(t, c, u), c;
}
function fp(e) {
  const t = e.options.offset, i = e._tickSize(), r = e._length / i + (t ? 0 : 1), s = e._maxLength / i;
  return Math.floor(Math.min(r, s));
}
function mp(e, t, i) {
  const r = bp(e), s = t.length / i;
  if (!r)
    return Math.max(s, 1);
  const n = ad(r);
  for (let a = 0, o = n.length - 1; a < o; a++) {
    const l = n[a];
    if (l > s)
      return l;
  }
  return Math.max(s, 1);
}
function gp(e) {
  const t = [];
  let i, r;
  for (i = 0, r = e.length; i < r; i++)
    e[i].major && t.push(i);
  return t;
}
function yp(e, t, i, r) {
  let s = 0, n = i[0], a;
  for (r = Math.ceil(r), a = 0; a < e.length; a++)
    a === n && (t.push(e[a]), s++, n = i[s * r]);
}
function Ki(e, t, i, r, s) {
  const n = L(r, 0), a = Math.min(L(s, e.length), e.length);
  let o = 0, l, c, u;
  for (i = Math.ceil(i), s && (l = s - r, i = l / Math.floor(l / i)), u = n; u < 0; )
    o++, u = Math.round(n + o * i);
  for (c = Math.max(n, 0); c < a; c++)
    c === u && (t.push(e[c]), o++, u = Math.round(n + o * i));
}
function bp(e) {
  const t = e.length;
  let i, r;
  if (t < 2)
    return !1;
  for (r = e[0], i = 1; i < t; ++i)
    if (e[i] - e[i - 1] !== r)
      return !1;
  return r;
}
const vp = (e) => e === "left" ? "right" : e === "right" ? "left" : e, va = (e, t, i) => t === "top" || t === "left" ? e[t] + i : e[t] - i, Aa = (e, t) => Math.min(t || e, e);
function ka(e, t) {
  const i = [], r = e.length / t, s = e.length;
  let n = 0;
  for (; n < s; n += r)
    i.push(e[Math.floor(n)]);
  return i;
}
function Ap(e, t, i) {
  const r = e.ticks.length, s = Math.min(t, r - 1), n = e._startPixel, a = e._endPixel, o = 1e-6;
  let l = e.getPixelForTick(s), c;
  if (!(i && (r === 1 ? c = Math.max(l - n, a - l) : t === 0 ? c = (e.getPixelForTick(1) - l) / 2 : c = (l - e.getPixelForTick(s - 1)) / 2, l += s < t ? c : -c, l < n - o || l > a + o)))
    return l;
}
function kp(e, t) {
  G(e, (i) => {
    const r = i.gc, s = r.length / 2;
    let n;
    if (s > t) {
      for (n = 0; n < s; ++n)
        delete i.data[r[n]];
      r.splice(0, s);
    }
  });
}
function ti(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function wa(e, t) {
  if (!e.display)
    return 0;
  const i = ae(e.font, t), r = me(e.padding);
  return (_(e.text) ? e.text.length : 1) * i.lineHeight + r.height;
}
function wp(e, t) {
  return ft(e, {
    scale: t,
    type: "scale"
  });
}
function xp(e, t, i) {
  return ft(e, {
    tick: i,
    index: t,
    type: "tick"
  });
}
function Cp(e, t, i) {
  let r = Ks(e);
  return (i && t !== "right" || !i && t === "right") && (r = vp(r)), r;
}
function Sp(e, t, i, r) {
  const { top: s, left: n, bottom: a, right: o, chart: l } = e, { chartArea: c, scales: u } = l;
  let d = 0, h, p, m;
  const g = a - s, y = o - n;
  if (e.isHorizontal()) {
    if (p = pe(r, n, o), q(i)) {
      const v = Object.keys(i)[0], w = i[v];
      m = u[v].getPixelForValue(w) + g - t;
    } else i === "center" ? m = (c.bottom + c.top) / 2 + g - t : m = va(e, i, t);
    h = o - n;
  } else {
    if (q(i)) {
      const v = Object.keys(i)[0], w = i[v];
      p = u[v].getPixelForValue(w) - y + t;
    } else i === "center" ? p = (c.left + c.right) / 2 - y + t : p = va(e, i, t);
    m = pe(r, a, s), d = i === "left" ? -se : se;
  }
  return {
    titleX: p,
    titleY: m,
    maxWidth: h,
    rotation: d
  };
}
class Rt extends st {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, i) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: i, _suggestedMin: r, _suggestedMax: s } = this;
    return t = Se(t, Number.POSITIVE_INFINITY), i = Se(i, Number.NEGATIVE_INFINITY), r = Se(r, Number.POSITIVE_INFINITY), s = Se(s, Number.NEGATIVE_INFINITY), {
      min: Se(t, r),
      max: Se(i, s),
      minDefined: ie(t),
      maxDefined: ie(i)
    };
  }
  getMinMax(t) {
    let { min: i, max: r, minDefined: s, maxDefined: n } = this.getUserBounds(), a;
    if (s && n)
      return {
        min: i,
        max: r
      };
    const o = this.getMatchingVisibleMetas();
    for (let l = 0, c = o.length; l < c; ++l)
      a = o[l].controller.getMinMax(this, t), s || (i = Math.min(i, a.min)), n || (r = Math.max(r, a.max));
    return i = n && i > r ? r : i, r = s && i > r ? i : r, {
      min: Se(i, Se(r, i)),
      max: Se(r, Se(i, r))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    K(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, i, r) {
    const { beginAtZero: s, grace: n, ticks: a } = this.options, o = a.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = i, this._margins = r = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, r), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + r.left + r.right : this.height + r.top + r.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = Ed(this, n, s), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = o < this.ticks.length;
    this._convertTicksToLabels(l ? ka(this.ticks, o) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), a.display && (a.autoSkip || a.source === "auto") && (this.ticks = pp(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, i, r;
    this.isHorizontal() ? (i = this.left, r = this.right) : (i = this.top, r = this.bottom, t = !t), this._startPixel = i, this._endPixel = r, this._reversePixels = t, this._length = r - i, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    K(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    K(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    K(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), K(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    K(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const i = this.options.ticks;
    let r, s, n;
    for (r = 0, s = t.length; r < s; r++)
      n = t[r], n.label = K(i.callback, [
        n.value,
        r,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    K(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    K(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, i = t.ticks, r = Aa(this.ticks.length, t.ticks.maxTicksLimit), s = i.minRotation || 0, n = i.maxRotation;
    let a = s, o, l, c;
    if (!this._isVisible() || !i.display || s >= n || r <= 1 || !this.isHorizontal()) {
      this.labelRotation = s;
      return;
    }
    const u = this._getLabelSizes(), d = u.widest.width, h = u.highest.height, p = le(this.chart.width - d, 0, this.maxWidth);
    o = t.offset ? this.maxWidth / r : p / (r - 1), d + 6 > o && (o = p / (r - (t.offset ? 0.5 : 1)), l = this.maxHeight - ti(t.grid) - i.padding - wa(t.title, this.chart.options.font), c = Math.sqrt(d * d + h * h), a = Qs(Math.min(Math.asin(le((u.highest.height + 6) / o, -1, 1)), Math.asin(le(l / c, -1, 1)) - Math.asin(le(h / c, -1, 1)))), a = Math.max(s, Math.min(n, a))), this.labelRotation = a;
  }
  afterCalculateLabelRotation() {
    K(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    K(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: i, options: { ticks: r, title: s, grid: n } } = this, a = this._isVisible(), o = this.isHorizontal();
    if (a) {
      const l = wa(s, i.options.font);
      if (o ? (t.width = this.maxWidth, t.height = ti(n) + l) : (t.height = this.maxHeight, t.width = ti(n) + l), r.display && this.ticks.length) {
        const { first: c, last: u, widest: d, highest: h } = this._getLabelSizes(), p = r.padding * 2, m = Le(this.labelRotation), g = Math.cos(m), y = Math.sin(m);
        if (o) {
          const v = r.mirror ? 0 : y * d.width + g * h.height;
          t.height = Math.min(this.maxHeight, t.height + v + p);
        } else {
          const v = r.mirror ? 0 : g * d.width + y * h.height;
          t.width = Math.min(this.maxWidth, t.width + v + p);
        }
        this._calculatePadding(c, u, y, g);
      }
    }
    this._handleMargins(), o ? (this.width = this._length = i.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = i.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, i, r, s) {
    const { ticks: { align: n, padding: a }, position: o } = this.options, l = this.labelRotation !== 0, c = o !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let h = 0, p = 0;
      l ? c ? (h = s * t.width, p = r * i.height) : (h = r * t.height, p = s * i.width) : n === "start" ? p = i.width : n === "end" ? h = t.width : n !== "inner" && (h = t.width / 2, p = i.width / 2), this.paddingLeft = Math.max((h - u + a) * this.width / (this.width - u), 0), this.paddingRight = Math.max((p - d + a) * this.width / (this.width - d), 0);
    } else {
      let u = i.height / 2, d = t.height / 2;
      n === "start" ? (u = 0, d = t.height) : n === "end" && (u = i.height, d = 0), this.paddingTop = u + a, this.paddingBottom = d + a;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    K(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: i } = this.options;
    return i === "top" || i === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let i, r;
    for (i = 0, r = t.length; i < r; i++)
      z(t[i].label) && (t.splice(i, 1), r--, i--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const i = this.options.ticks.sampleSize;
      let r = this.ticks;
      i < r.length && (r = ka(r, i)), this._labelSizes = t = this._computeLabelSizes(r, r.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, i, r) {
    const { ctx: s, _longestTextCache: n } = this, a = [], o = [], l = Math.floor(i / Aa(i, r));
    let c = 0, u = 0, d, h, p, m, g, y, v, w, C, A, k;
    for (d = 0; d < i; d += l) {
      if (m = t[d].label, g = this._resolveTickFontOptions(d), s.font = y = g.string, v = n[y] = n[y] || {
        data: {},
        gc: []
      }, w = g.lineHeight, C = A = 0, !z(m) && !_(m))
        C = gr(s, v.data, v.gc, C, m), A = w;
      else if (_(m))
        for (h = 0, p = m.length; h < p; ++h)
          k = m[h], !z(k) && !_(k) && (C = gr(s, v.data, v.gc, C, k), A += w);
      a.push(C), o.push(A), c = Math.max(C, c), u = Math.max(A, u);
    }
    kp(n, i);
    const S = a.indexOf(c), D = o.indexOf(u), T = (F) => ({
      width: a[F] || 0,
      height: o[F] || 0
    });
    return {
      first: T(0),
      last: T(i - 1),
      widest: T(S),
      highest: T(D),
      widths: a,
      heights: o
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, i) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const i = this.ticks;
    return t < 0 || t > i.length - 1 ? null : this.getPixelForValue(i[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const i = this._startPixel + t * this._length;
    return cd(this._alignToPixels ? bt(this.chart, i, 0) : i);
  }
  getDecimalForPixel(t) {
    const i = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - i : i;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: i } = this;
    return t < 0 && i < 0 ? i : t > 0 && i > 0 ? t : 0;
  }
  getContext(t) {
    const i = this.ticks || [];
    if (t >= 0 && t < i.length) {
      const r = i[t];
      return r.$context || (r.$context = xp(this.getContext(), t, r));
    }
    return this.$context || (this.$context = wp(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, i = Le(this.labelRotation), r = Math.abs(Math.cos(i)), s = Math.abs(Math.sin(i)), n = this._getLabelSizes(), a = t.autoSkipPadding || 0, o = n ? n.widest.width + a : 0, l = n ? n.highest.height + a : 0;
    return this.isHorizontal() ? l * r > o * s ? o / r : l / s : l * s < o * r ? l / r : o / s;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const i = this.axis, r = this.chart, s = this.options, { grid: n, position: a, border: o } = s, l = n.offset, c = this.isHorizontal(), u = this.ticks.length + (l ? 1 : 0), d = ti(n), h = [], p = o.setContext(this.getContext()), m = p.display ? p.width : 0, g = m / 2, y = function(j) {
      return bt(r, j, m);
    };
    let v, w, C, A, k, S, D, T, F, R, M, H;
    if (a === "top")
      v = y(this.bottom), S = this.bottom - d, T = v - g, R = y(t.top) + g, H = t.bottom;
    else if (a === "bottom")
      v = y(this.top), R = t.top, H = y(t.bottom) - g, S = v + g, T = this.top + d;
    else if (a === "left")
      v = y(this.right), k = this.right - d, D = v - g, F = y(t.left) + g, M = t.right;
    else if (a === "right")
      v = y(this.left), F = t.left, M = y(t.right) - g, k = v + g, D = this.left + d;
    else if (i === "x") {
      if (a === "center")
        v = y((t.top + t.bottom) / 2 + 0.5);
      else if (q(a)) {
        const j = Object.keys(a)[0], X = a[j];
        v = y(this.chart.scales[j].getPixelForValue(X));
      }
      R = t.top, H = t.bottom, S = v + g, T = S + d;
    } else if (i === "y") {
      if (a === "center")
        v = y((t.left + t.right) / 2);
      else if (q(a)) {
        const j = Object.keys(a)[0], X = a[j];
        v = y(this.chart.scales[j].getPixelForValue(X));
      }
      k = v - g, D = k - d, F = t.left, M = t.right;
    }
    const ce = L(s.ticks.maxTicksLimit, u), ue = Math.max(1, Math.ceil(u / ce));
    for (w = 0; w < u; w += ue) {
      const j = this.getContext(w), X = n.setContext(j), ge = o.setContext(j), we = X.lineWidth, de = X.color, We = ge.dash || [], ee = ge.dashOffset, Qe = X.tickWidth, te = X.tickColor, Ue = X.tickBorderDash || [], W = X.tickBorderDashOffset;
      C = Ap(this, w, l), C !== void 0 && (A = bt(r, C, we), c ? k = D = F = M = A : S = T = R = H = A, h.push({
        tx1: k,
        ty1: S,
        tx2: D,
        ty2: T,
        x1: F,
        y1: R,
        x2: M,
        y2: H,
        width: we,
        color: de,
        borderDash: We,
        borderDashOffset: ee,
        tickWidth: Qe,
        tickColor: te,
        tickBorderDash: Ue,
        tickBorderDashOffset: W
      }));
    }
    return this._ticksLength = u, this._borderValue = v, h;
  }
  _computeLabelItems(t) {
    const i = this.axis, r = this.options, { position: s, ticks: n } = r, a = this.isHorizontal(), o = this.ticks, { align: l, crossAlign: c, padding: u, mirror: d } = n, h = ti(r.grid), p = h + u, m = d ? -u : p, g = -Le(this.labelRotation), y = [];
    let v, w, C, A, k, S, D, T, F, R, M, H, ce = "middle";
    if (s === "top")
      S = this.bottom - m, D = this._getXAxisLabelAlignment();
    else if (s === "bottom")
      S = this.top + m, D = this._getXAxisLabelAlignment();
    else if (s === "left") {
      const j = this._getYAxisLabelAlignment(h);
      D = j.textAlign, k = j.x;
    } else if (s === "right") {
      const j = this._getYAxisLabelAlignment(h);
      D = j.textAlign, k = j.x;
    } else if (i === "x") {
      if (s === "center")
        S = (t.top + t.bottom) / 2 + p;
      else if (q(s)) {
        const j = Object.keys(s)[0], X = s[j];
        S = this.chart.scales[j].getPixelForValue(X) + p;
      }
      D = this._getXAxisLabelAlignment();
    } else if (i === "y") {
      if (s === "center")
        k = (t.left + t.right) / 2 - p;
      else if (q(s)) {
        const j = Object.keys(s)[0], X = s[j];
        k = this.chart.scales[j].getPixelForValue(X);
      }
      D = this._getYAxisLabelAlignment(h).textAlign;
    }
    i === "y" && (l === "start" ? ce = "top" : l === "end" && (ce = "bottom"));
    const ue = this._getLabelSizes();
    for (v = 0, w = o.length; v < w; ++v) {
      C = o[v], A = C.label;
      const j = n.setContext(this.getContext(v));
      T = this.getPixelForTick(v) + n.labelOffset, F = this._resolveTickFontOptions(v), R = F.lineHeight, M = _(A) ? A.length : 1;
      const X = M / 2, ge = j.color, we = j.textStrokeColor, de = j.textStrokeWidth;
      let We = D;
      a ? (k = T, D === "inner" && (v === w - 1 ? We = this.options.reverse ? "left" : "right" : v === 0 ? We = this.options.reverse ? "right" : "left" : We = "center"), s === "top" ? c === "near" || g !== 0 ? H = -M * R + R / 2 : c === "center" ? H = -ue.highest.height / 2 - X * R + R : H = -ue.highest.height + R / 2 : c === "near" || g !== 0 ? H = R / 2 : c === "center" ? H = ue.highest.height / 2 - X * R : H = ue.highest.height - M * R, d && (H *= -1), g !== 0 && !j.showLabelBackdrop && (k += R / 2 * Math.sin(g))) : (S = T, H = (1 - M) * R / 2);
      let ee;
      if (j.showLabelBackdrop) {
        const Qe = me(j.backdropPadding), te = ue.heights[v], Ue = ue.widths[v];
        let W = H - Qe.top, Re = 0 - Qe.left;
        switch (ce) {
          case "middle":
            W -= te / 2;
            break;
          case "bottom":
            W -= te;
            break;
        }
        switch (D) {
          case "center":
            Re -= Ue / 2;
            break;
          case "right":
            Re -= Ue;
            break;
          case "inner":
            v === w - 1 ? Re -= Ue : v > 0 && (Re -= Ue / 2);
            break;
        }
        ee = {
          left: Re,
          top: W,
          width: Ue + Qe.width,
          height: te + Qe.height,
          color: j.backdropColor
        };
      }
      y.push({
        label: A,
        font: F,
        textOffset: H,
        options: {
          rotation: g,
          color: ge,
          strokeColor: we,
          strokeWidth: de,
          textAlign: We,
          textBaseline: ce,
          translation: [
            k,
            S
          ],
          backdrop: ee
        }
      });
    }
    return y;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: i } = this.options;
    if (-Le(this.labelRotation))
      return t === "top" ? "left" : "right";
    let r = "center";
    return i.align === "start" ? r = "left" : i.align === "end" ? r = "right" : i.align === "inner" && (r = "inner"), r;
  }
  _getYAxisLabelAlignment(t) {
    const { position: i, ticks: { crossAlign: r, mirror: s, padding: n } } = this.options, a = this._getLabelSizes(), o = t + n, l = a.widest.width;
    let c, u;
    return i === "left" ? s ? (u = this.right + n, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u += l)) : (u = this.right - o, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u = this.left)) : i === "right" ? s ? (u = this.left + n, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u -= l)) : (u = this.left + o, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u = this.right)) : c = "right", {
      textAlign: c,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, i = this.options.position;
    if (i === "left" || i === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (i === "top" || i === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: i }, left: r, top: s, width: n, height: a } = this;
    i && (t.save(), t.fillStyle = i, t.fillRect(r, s, n, a), t.restore());
  }
  getLineWidthForValue(t) {
    const i = this.options.grid;
    if (!this._isVisible() || !i.display)
      return 0;
    const r = this.ticks.findIndex((s) => s.value === t);
    return r >= 0 ? i.setContext(this.getContext(r)).lineWidth : 0;
  }
  drawGrid(t) {
    const i = this.options.grid, r = this.ctx, s = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let n, a;
    const o = (l, c, u) => {
      !u.width || !u.color || (r.save(), r.lineWidth = u.width, r.strokeStyle = u.color, r.setLineDash(u.borderDash || []), r.lineDashOffset = u.borderDashOffset, r.beginPath(), r.moveTo(l.x, l.y), r.lineTo(c.x, c.y), r.stroke(), r.restore());
    };
    if (i.display)
      for (n = 0, a = s.length; n < a; ++n) {
        const l = s[n];
        i.drawOnChartArea && o({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), i.drawTicks && o({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: i, options: { border: r, grid: s } } = this, n = r.setContext(this.getContext()), a = r.display ? n.width : 0;
    if (!a)
      return;
    const o = s.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, u, d, h;
    this.isHorizontal() ? (c = bt(t, this.left, a) - a / 2, u = bt(t, this.right, o) + o / 2, d = h = l) : (d = bt(t, this.top, a) - a / 2, h = bt(t, this.bottom, o) + o / 2, c = u = l), i.save(), i.lineWidth = n.width, i.strokeStyle = n.color, i.beginPath(), i.moveTo(c, d), i.lineTo(u, h), i.stroke(), i.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const i = this.ctx, r = this._computeLabelArea();
    r && Sr(i, r);
    const s = this.getLabelItems(t);
    for (const n of s) {
      const a = n.options, o = n.font, l = n.label, c = n.textOffset;
      Bt(i, l, 0, c, o, a);
    }
    r && Ir(i);
  }
  drawTitle() {
    const { ctx: t, options: { position: i, title: r, reverse: s } } = this;
    if (!r.display)
      return;
    const n = ae(r.font), a = me(r.padding), o = r.align;
    let l = n.lineHeight / 2;
    i === "bottom" || i === "center" || q(i) ? (l += a.bottom, _(r.text) && (l += n.lineHeight * (r.text.length - 1))) : l += a.top;
    const { titleX: c, titleY: u, maxWidth: d, rotation: h } = Sp(this, l, i, o);
    Bt(t, r.text, 0, 0, n, {
      color: r.color,
      maxWidth: d,
      rotation: h,
      textAlign: Cp(o, i, s),
      textBaseline: "middle",
      translation: [
        c,
        u
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, i = t.ticks && t.ticks.z || 0, r = L(t.grid && t.grid.z, -1), s = L(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Rt.prototype.draw ? [
      {
        z: i,
        draw: (n) => {
          this.draw(n);
        }
      }
    ] : [
      {
        z: r,
        draw: (n) => {
          this.drawBackground(), this.drawGrid(n), this.drawTitle();
        }
      },
      {
        z: s,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: i,
        draw: (n) => {
          this.drawLabels(n);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const i = this.chart.getSortedVisibleDatasetMetas(), r = this.axis + "AxisID", s = [];
    let n, a;
    for (n = 0, a = i.length; n < a; ++n) {
      const o = i[n];
      o[r] === this.id && (!t || o.type === t) && s.push(o);
    }
    return s;
  }
  _resolveTickFontOptions(t) {
    const i = this.options.ticks.setContext(this.getContext(t));
    return ae(i.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class Yi {
  constructor(t, i, r) {
    this.type = t, this.scope = i, this.override = r, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const i = Object.getPrototypeOf(t);
    let r;
    Pp(i) && (r = this.register(i));
    const s = this.items, n = t.id, a = this.scope + "." + n;
    if (!n)
      throw new Error("class does not have id: " + t);
    return n in s || (s[n] = t, Ip(t, a, r), this.override && re.override(t.id, t.overrides)), a;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const i = this.items, r = t.id, s = this.scope;
    r in i && delete i[r], s && r in re[s] && (delete re[s][r], this.override && delete Ot[r]);
  }
}
function Ip(e, t, i) {
  const r = wi(/* @__PURE__ */ Object.create(null), [
    i ? re.get(i) : {},
    re.get(t),
    e.defaults
  ]);
  re.set(t, r), e.defaultRoutes && Dp(t, e.defaultRoutes), e.descriptors && re.describe(t, e.descriptors);
}
function Dp(e, t) {
  Object.keys(t).forEach((i) => {
    const r = i.split("."), s = r.pop(), n = [
      e
    ].concat(r).join("."), a = t[i].split("."), o = a.pop(), l = a.join(".");
    re.route(n, s, l, o);
  });
}
function Pp(e) {
  return "id" in e && "defaults" in e;
}
class Tp {
  constructor() {
    this.controllers = new Yi(Fe, "datasets", !0), this.elements = new Yi(st, "elements"), this.plugins = new Yi(Object, "plugins"), this.scales = new Yi(Rt, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, i, r) {
    [
      ...i
    ].forEach((s) => {
      const n = r || this._getRegistryForType(s);
      r || n.isForType(s) || n === this.plugins && s.id ? this._exec(t, n, s) : G(s, (a) => {
        const o = r || this._getRegistryForType(a);
        this._exec(t, o, a);
      });
    });
  }
  _exec(t, i, r) {
    const s = Ws(t);
    K(r["before" + s], [], r), i[t](r), K(r["after" + s], [], r);
  }
  _getRegistryForType(t) {
    for (let i = 0; i < this._typedRegistries.length; i++) {
      const r = this._typedRegistries[i];
      if (r.isForType(t))
        return r;
    }
    return this.plugins;
  }
  _get(t, i, r) {
    const s = i.get(t);
    if (s === void 0)
      throw new Error('"' + t + '" is not a registered ' + r + ".");
    return s;
  }
}
var ze = /* @__PURE__ */ new Tp();
class Op {
  constructor() {
    this._init = [];
  }
  notify(t, i, r, s) {
    i === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const n = s ? this._descriptors(t).filter(s) : this._descriptors(t), a = this._notify(n, t, i, r);
    return i === "afterDestroy" && (this._notify(n, t, "stop"), this._notify(this._init, t, "uninstall")), a;
  }
  _notify(t, i, r, s) {
    s = s || {};
    for (const n of t) {
      const a = n.plugin, o = a[r], l = [
        i,
        s,
        n.options
      ];
      if (K(o, l, a) === !1 && s.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    z(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const i = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), i;
  }
  _createDescriptors(t, i) {
    const r = t && t.config, s = L(r.options && r.options.plugins, {}), n = Bp(r);
    return s === !1 && !i ? [] : Rp(t, n, s, i);
  }
  _notifyStateChanges(t) {
    const i = this._oldCache || [], r = this._cache, s = (n, a) => n.filter((o) => !a.some((l) => o.plugin.id === l.plugin.id));
    this._notify(s(i, r), t, "stop"), this._notify(s(r, i), t, "start");
  }
}
function Bp(e) {
  const t = {}, i = [], r = Object.keys(ze.plugins.items);
  for (let n = 0; n < r.length; n++)
    i.push(ze.getPlugin(r[n]));
  const s = e.plugins || [];
  for (let n = 0; n < s.length; n++) {
    const a = s[n];
    i.indexOf(a) === -1 && (i.push(a), t[a.id] = !0);
  }
  return {
    plugins: i,
    localIds: t
  };
}
function Mp(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function Rp(e, { plugins: t, localIds: i }, r, s) {
  const n = [], a = e.getContext();
  for (const o of t) {
    const l = o.id, c = Mp(r[l], s);
    c !== null && n.push({
      plugin: o,
      options: Ep(e.config, {
        plugin: o,
        local: i[l]
      }, c, a)
    });
  }
  return n;
}
function Ep(e, { plugin: t, local: i }, r, s) {
  const n = e.pluginScopeKeys(t), a = e.getOptionScopes(r, n);
  return i && t.defaults && a.push(t.defaults), e.createResolver(a, s, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function xs(e, t) {
  const i = re.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || i.indexAxis || "x";
}
function Lp(e, t) {
  let i = e;
  return e === "_index_" ? i = t : e === "_value_" && (i = t === "x" ? "y" : "x"), i;
}
function Fp(e, t) {
  return e === t ? "_index_" : "_value_";
}
function xa(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
function jp(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function Cs(e, ...t) {
  if (xa(e))
    return e;
  for (const i of t) {
    const r = i.axis || jp(i.position) || e.length > 1 && xa(e[0].toLowerCase());
    if (r)
      return r;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function Ca(e, t, i) {
  if (i[t + "AxisID"] === e)
    return {
      axis: t
    };
}
function Up(e, t) {
  if (t.data && t.data.datasets) {
    const i = t.data.datasets.filter((r) => r.xAxisID === e || r.yAxisID === e);
    if (i.length)
      return Ca(e, "x", i[0]) || Ca(e, "y", i[0]);
  }
  return {};
}
function qp(e, t) {
  const i = Ot[e.type] || {
    scales: {}
  }, r = t.scales || {}, s = xs(e.type, t), n = /* @__PURE__ */ Object.create(null);
  return Object.keys(r).forEach((a) => {
    const o = r[a];
    if (!q(o))
      return console.error(`Invalid scale configuration for scale: ${a}`);
    if (o._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${a}`);
    const l = Cs(a, o, Up(a, e), re.scales[o.type]), c = Fp(l, s), u = i.scales || {};
    n[a] = mi(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      o,
      u[l],
      u[c]
    ]);
  }), e.data.datasets.forEach((a) => {
    const o = a.type || e.type, l = a.indexAxis || xs(o, t), c = (Ot[o] || {}).scales || {};
    Object.keys(c).forEach((u) => {
      const d = Lp(u, l), h = a[d + "AxisID"] || d;
      n[h] = n[h] || /* @__PURE__ */ Object.create(null), mi(n[h], [
        {
          axis: d
        },
        r[h],
        c[u]
      ]);
    });
  }), Object.keys(n).forEach((a) => {
    const o = n[a];
    mi(o, [
      re.scales[o.type],
      re.scale
    ]);
  }), n;
}
function Ll(e) {
  const t = e.options || (e.options = {});
  t.plugins = L(t.plugins, {}), t.scales = qp(e, t);
}
function Fl(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function Hp(e) {
  return e = e || {}, e.data = Fl(e.data), Ll(e), e;
}
const Sa = /* @__PURE__ */ new Map(), jl = /* @__PURE__ */ new Set();
function Zi(e, t) {
  let i = Sa.get(e);
  return i || (i = t(), Sa.set(e, i), jl.add(i)), i;
}
const ii = (e, t, i) => {
  const r = ut(t, i);
  r !== void 0 && e.add(r);
};
class zp {
  constructor(t) {
    this._config = Hp(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = Fl(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), Ll(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return Zi(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, i) {
    return Zi(`${t}.transition.${i}`, () => [
      [
        `datasets.${t}.transitions.${i}`,
        `transitions.${i}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, i) {
    return Zi(`${t}-${i}`, () => [
      [
        `datasets.${t}.elements.${i}`,
        `datasets.${t}`,
        `elements.${i}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const i = t.id, r = this.type;
    return Zi(`${r}-plugin-${i}`, () => [
      [
        `plugins.${i}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, i) {
    const r = this._scopeCache;
    let s = r.get(t);
    return (!s || i) && (s = /* @__PURE__ */ new Map(), r.set(t, s)), s;
  }
  getOptionScopes(t, i, r) {
    const { options: s, type: n } = this, a = this._cachedScopes(t, r), o = a.get(i);
    if (o)
      return o;
    const l = /* @__PURE__ */ new Set();
    i.forEach((u) => {
      t && (l.add(t), u.forEach((d) => ii(l, t, d))), u.forEach((d) => ii(l, s, d)), u.forEach((d) => ii(l, Ot[n] || {}, d)), u.forEach((d) => ii(l, re, d)), u.forEach((d) => ii(l, As, d));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), jl.has(i) && a.set(i, c), c;
  }
  chartOptionScopes() {
    const { options: t, type: i } = this;
    return [
      t,
      Ot[i] || {},
      re.datasets[i] || {},
      {
        type: i
      },
      re,
      As
    ];
  }
  resolveNamedOptions(t, i, r, s = [
    ""
  ]) {
    const n = {
      $shared: !0
    }, { resolver: a, subPrefixes: o } = Ia(this._resolverCache, t, s);
    let l = a;
    if (Vp(a, i)) {
      n.$shared = !1, r = dt(r) ? r() : r;
      const c = this.createResolver(t, r, o);
      l = Wt(a, r, c);
    }
    for (const c of i)
      n[c] = l[c];
    return n;
  }
  createResolver(t, i, r = [
    ""
  ], s) {
    const { resolver: n } = Ia(this._resolverCache, t, r);
    return q(i) ? Wt(n, i, void 0, s) : n;
  }
}
function Ia(e, t, i) {
  let r = e.get(t);
  r || (r = /* @__PURE__ */ new Map(), e.set(t, r));
  const s = i.join();
  let n = r.get(s);
  return n || (n = {
    resolver: Js(t, i),
    subPrefixes: i.filter((a) => !a.toLowerCase().includes("hover"))
  }, r.set(s, n)), n;
}
const Np = (e) => q(e) && Object.getOwnPropertyNames(e).some((t) => dt(e[t]));
function Vp(e, t) {
  const { isScriptable: i, isIndexable: r } = gl(e);
  for (const s of t) {
    const n = i(s), a = r(s), o = (a || n) && e[s];
    if (n && (dt(o) || Np(o)) || a && _(o))
      return !0;
  }
  return !1;
}
var Gp = "4.4.1";
const Wp = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function Da(e, t) {
  return e === "top" || e === "bottom" || Wp.indexOf(e) === -1 && t === "x";
}
function Pa(e, t) {
  return function(i, r) {
    return i[e] === r[e] ? i[t] - r[t] : i[e] - r[e];
  };
}
function Ta(e) {
  const t = e.chart, i = t.options.animation;
  t.notifyPlugins("afterRender"), K(i && i.onComplete, [
    e
  ], t);
}
function Qp(e) {
  const t = e.chart, i = t.options.animation;
  K(i && i.onProgress, [
    e
  ], t);
}
function Ul(e) {
  return en() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const vr = {}, ql = (e) => {
  const t = Ul(e);
  return Object.values(vr).filter((i) => i.canvas === t).pop();
};
function Xp(e, t, i) {
  const r = Object.keys(e);
  for (const s of r) {
    const n = +s;
    if (n >= t) {
      const a = e[s];
      delete e[s], (i > 0 || n > t) && (e[n + i] = a);
    }
  }
}
function Kp(e, t, i, r) {
  return !i || e.type === "mouseout" ? null : r ? t : e;
}
function Ji(e, t, i) {
  return e.options.clip ? e[i] : t[i];
}
function Yp(e, t) {
  const { xScale: i, yScale: r } = e;
  return i && r ? {
    left: Ji(i, t, "left"),
    right: Ji(i, t, "right"),
    top: Ji(r, t, "top"),
    bottom: Ji(r, t, "bottom")
  } : t;
}
class Ne {
  static register(...t) {
    ze.add(...t), Oa();
  }
  static unregister(...t) {
    ze.remove(...t), Oa();
  }
  constructor(t, i) {
    const r = this.config = new zp(i), s = Ul(t), n = ql(s);
    if (n)
      throw new Error("Canvas is already in use. Chart with ID '" + n.id + "' must be destroyed before the canvas with ID '" + n.canvas.id + "' can be reused.");
    const a = r.createResolver(r.chartOptionScopes(), this.getContext());
    this.platform = new (r.platform || hp(s))(), this.platform.updateConfig(r);
    const o = this.platform.acquireContext(s, a.aspectRatio), l = o && o.canvas, c = l && l.height, u = l && l.width;
    if (this.id = Ju(), this.ctx = o, this.canvas = l, this.width = u, this.height = c, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new Op(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = pd((d) => this.update(d), a.resizeDelay || 0), this._dataChanges = [], vr[this.id] = this, !o || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    Je.listen(this, "complete", Ta), Je.listen(this, "progress", Qp), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: i }, width: r, height: s, _aspectRatio: n } = this;
    return z(t) ? i && n ? n : s ? r / s : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return ze;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : _n(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Yn(this.canvas, this.ctx), this;
  }
  stop() {
    return Je.stop(this), this;
  }
  resize(t, i) {
    Je.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: i
    } : this._resize(t, i);
  }
  _resize(t, i) {
    const r = this.options, s = this.canvas, n = r.maintainAspectRatio && this.aspectRatio, a = this.platform.getMaximumSize(s, t, i, n), o = r.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = a.width, this.height = a.height, this._aspectRatio = this.aspectRatio, _n(this, o, !0) && (this.notifyPlugins("resize", {
      size: a
    }), K(r.onResize, [
      this,
      a
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const t = this.options.scales || {};
    G(t, (i, r) => {
      i.id = r;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, i = t.scales, r = this.scales, s = Object.keys(r).reduce((a, o) => (a[o] = !1, a), {});
    let n = [];
    i && (n = n.concat(Object.keys(i).map((a) => {
      const o = i[a], l = Cs(a, o), c = l === "r", u = l === "x";
      return {
        options: o,
        dposition: c ? "chartArea" : u ? "bottom" : "left",
        dtype: c ? "radialLinear" : u ? "category" : "linear"
      };
    }))), G(n, (a) => {
      const o = a.options, l = o.id, c = Cs(l, o), u = L(o.type, a.dtype);
      (o.position === void 0 || Da(o.position, c) !== Da(a.dposition)) && (o.position = a.dposition), s[l] = !0;
      let d = null;
      if (l in r && r[l].type === u)
        d = r[l];
      else {
        const h = ze.getScale(u);
        d = new h({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), r[d.id] = d;
      }
      d.init(o, t);
    }), G(s, (a, o) => {
      a || delete r[o];
    }), G(r, (a) => {
      fe.configure(this, a, a.options), fe.addBox(this, a);
    });
  }
  _updateMetasets() {
    const t = this._metasets, i = this.data.datasets.length, r = t.length;
    if (t.sort((s, n) => s.index - n.index), r > i) {
      for (let s = i; s < r; ++s)
        this._destroyDatasetMeta(s);
      t.splice(i, r - i);
    }
    this._sortedMetasets = t.slice(0).sort(Pa("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: i } } = this;
    t.length > i.length && delete this._stacks, t.forEach((r, s) => {
      i.filter((n) => n === r._dataset).length === 0 && this._destroyDatasetMeta(s);
    });
  }
  buildOrUpdateControllers() {
    const t = [], i = this.data.datasets;
    let r, s;
    for (this._removeUnreferencedMetasets(), r = 0, s = i.length; r < s; r++) {
      const n = i[r];
      let a = this.getDatasetMeta(r);
      const o = n.type || this.config.type;
      if (a.type && a.type !== o && (this._destroyDatasetMeta(r), a = this.getDatasetMeta(r)), a.type = o, a.indexAxis = n.indexAxis || xs(o, this.options), a.order = n.order || 0, a.index = r, a.label = "" + n.label, a.visible = this.isDatasetVisible(r), a.controller)
        a.controller.updateIndex(r), a.controller.linkScales();
      else {
        const l = ze.getController(o), { datasetElementType: c, dataElementType: u } = re.datasets[o];
        Object.assign(l, {
          dataElementType: ze.getElement(u),
          datasetElementType: c && ze.getElement(c)
        }), a.controller = new l(this, r), t.push(a.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    G(this.data.datasets, (t, i) => {
      this.getDatasetMeta(i).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const i = this.config;
    i.update();
    const r = this._options = i.createResolver(i.chartOptionScopes(), this.getContext()), s = this._animationsDisabled = !r.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const n = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let a = 0;
    for (let c = 0, u = this.data.datasets.length; c < u; c++) {
      const { controller: d } = this.getDatasetMeta(c), h = !s && n.indexOf(d) === -1;
      d.buildOrUpdateElements(h), a = Math.max(+d.getMaxOverflow(), a);
    }
    a = this._minPadding = r.layout.autoPadding ? a : 0, this._updateLayout(a), s || G(n, (c) => {
      c.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(Pa("z", "_idx"));
    const { _active: o, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : o.length && this._updateHoverStyles(o, o, !0), this.render();
  }
  _updateScales() {
    G(this.scales, (t) => {
      fe.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, i = new Set(Object.keys(this._listeners)), r = new Set(t.events);
    (!Hn(i, r) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, i = this._getUniformDataChanges() || [];
    for (const { method: r, start: s, count: n } of i) {
      const a = r === "_removeElements" ? -n : n;
      Xp(t, s, a);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const i = this.data.datasets.length, r = (n) => new Set(t.filter((a) => a[0] === n).map((a, o) => o + "," + a.splice(1).join(","))), s = r(0);
    for (let n = 1; n < i; n++)
      if (!Hn(s, r(n)))
        return;
    return Array.from(s).map((n) => n.split(",")).map((n) => ({
      method: n[1],
      start: +n[2],
      count: +n[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    fe.update(this, this.width, this.height, t);
    const i = this.chartArea, r = i.width <= 0 || i.height <= 0;
    this._layers = [], G(this.boxes, (s) => {
      r && s.position === "chartArea" || (s.configure && s.configure(), this._layers.push(...s._layers()));
    }, this), this._layers.forEach((s, n) => {
      s._idx = n;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let i = 0, r = this.data.datasets.length; i < r; ++i)
        this.getDatasetMeta(i).controller.configure();
      for (let i = 0, r = this.data.datasets.length; i < r; ++i)
        this._updateDataset(i, dt(t) ? t({
          datasetIndex: i
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, i) {
    const r = this.getDatasetMeta(t), s = {
      meta: r,
      index: t,
      mode: i,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", s) !== !1 && (r.controller._update(i), s.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", s));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (Je.has(this) ? this.attached && !Je.running(this) && Je.start(this) : (this.draw(), Ta({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: r, height: s } = this._resizeBeforeDraw;
      this._resize(r, s), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const i = this._layers;
    for (t = 0; t < i.length && i[t].z <= 0; ++t)
      i[t].draw(this.chartArea);
    for (this._drawDatasets(); t < i.length; ++t)
      i[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const i = this._sortedMetasets, r = [];
    let s, n;
    for (s = 0, n = i.length; s < n; ++s) {
      const a = i[s];
      (!t || a.visible) && r.push(a);
    }
    return r;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let i = t.length - 1; i >= 0; --i)
      this._drawDataset(t[i]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const i = this.ctx, r = t._clip, s = !r.disabled, n = Yp(t, this.chartArea), a = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", a) !== !1 && (s && Sr(i, {
      left: r.left === !1 ? 0 : n.left - r.left,
      right: r.right === !1 ? this.width : n.right + r.right,
      top: r.top === !1 ? 0 : n.top - r.top,
      bottom: r.bottom === !1 ? this.height : n.bottom + r.bottom
    }), t.controller.draw(), s && Ir(i), a.cancelable = !1, this.notifyPlugins("afterDatasetDraw", a));
  }
  isPointInArea(t) {
    return it(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, i, r, s) {
    const n = Wh.modes[i];
    return typeof n == "function" ? n(this, t, r, s) : [];
  }
  getDatasetMeta(t) {
    const i = this.data.datasets[t], r = this._metasets;
    let s = r.filter((n) => n && n._dataset === i).pop();
    return s || (s = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: i && i.order || 0,
      index: t,
      _dataset: i,
      _parsed: [],
      _sorted: !1
    }, r.push(s)), s;
  }
  getContext() {
    return this.$context || (this.$context = ft(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const i = this.data.datasets[t];
    if (!i)
      return !1;
    const r = this.getDatasetMeta(t);
    return typeof r.hidden == "boolean" ? !r.hidden : !i.hidden;
  }
  setDatasetVisibility(t, i) {
    const r = this.getDatasetMeta(t);
    r.hidden = !i;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, i, r) {
    const s = r ? "show" : "hide", n = this.getDatasetMeta(t), a = n.controller._resolveAnimations(void 0, s);
    xi(i) ? (n.data[i].hidden = !r, this.update()) : (this.setDatasetVisibility(t, r), a.update(n, {
      visible: r
    }), this.update((o) => o.datasetIndex === t ? s : void 0));
  }
  hide(t, i) {
    this._updateVisibility(t, i, !1);
  }
  show(t, i) {
    this._updateVisibility(t, i, !0);
  }
  _destroyDatasetMeta(t) {
    const i = this._metasets[t];
    i && i.controller && i.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, i;
    for (this.stop(), Je.remove(this), t = 0, i = this.data.datasets.length; t < i; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: i } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), Yn(t, i), this.platform.releaseContext(i), this.canvas = null, this.ctx = null), delete vr[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, i = this.platform, r = (n, a) => {
      i.addEventListener(this, n, a), t[n] = a;
    }, s = (n, a, o) => {
      n.offsetX = a, n.offsetY = o, this._eventHandler(n);
    };
    G(this.options.events, (n) => r(n, s));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, i = this.platform, r = (l, c) => {
      i.addEventListener(this, l, c), t[l] = c;
    }, s = (l, c) => {
      t[l] && (i.removeEventListener(this, l, c), delete t[l]);
    }, n = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let a;
    const o = () => {
      s("attach", o), this.attached = !0, this.resize(), r("resize", n), r("detach", a);
    };
    a = () => {
      this.attached = !1, s("resize", n), this._stop(), this._resize(0, 0), r("attach", o);
    }, i.isAttached(this.canvas) ? o() : a();
  }
  unbindEvents() {
    G(this._listeners, (t, i) => {
      this.platform.removeEventListener(this, i, t);
    }), this._listeners = {}, G(this._responsiveListeners, (t, i) => {
      this.platform.removeEventListener(this, i, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, i, r) {
    const s = r ? "set" : "remove";
    let n, a, o, l;
    for (i === "dataset" && (n = this.getDatasetMeta(t[0].datasetIndex), n.controller["_" + s + "DatasetHoverStyle"]()), o = 0, l = t.length; o < l; ++o) {
      a = t[o];
      const c = a && this.getDatasetMeta(a.datasetIndex).controller;
      c && c[s + "HoverStyle"](a.element, a.datasetIndex, a.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const i = this._active || [], r = t.map(({ datasetIndex: s, index: n }) => {
      const a = this.getDatasetMeta(s);
      if (!a)
        throw new Error("No dataset found at index " + s);
      return {
        datasetIndex: s,
        element: a.data[n],
        index: n
      };
    });
    !pr(r, i) && (this._active = r, this._lastEvent = null, this._updateHoverStyles(r, i));
  }
  notifyPlugins(t, i, r) {
    return this._plugins.notify(this, t, i, r);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((i) => i.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, i, r) {
    const s = this.options.hover, n = (l, c) => l.filter((u) => !c.some((d) => u.datasetIndex === d.datasetIndex && u.index === d.index)), a = n(i, t), o = r ? t : n(t, i);
    a.length && this.updateHoverStyle(a, s.mode, !1), o.length && s.mode && this.updateHoverStyle(o, s.mode, !0);
  }
  _eventHandler(t, i) {
    const r = {
      event: t,
      replay: i,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, s = (a) => (a.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", r, s) === !1)
      return;
    const n = this._handleEvent(t, i, r.inChartArea);
    return r.cancelable = !1, this.notifyPlugins("afterEvent", r, s), (n || r.changed) && this.render(), this;
  }
  _handleEvent(t, i, r) {
    const { _active: s = [], options: n } = this, a = i, o = this._getActiveElements(t, s, r, a), l = rd(t), c = Kp(t, this._lastEvent, r, l);
    r && (this._lastEvent = null, K(n.onHover, [
      t,
      o,
      this
    ], this), l && K(n.onClick, [
      t,
      o,
      this
    ], this));
    const u = !pr(o, s);
    return (u || i) && (this._active = o, this._updateHoverStyles(o, s, i)), this._lastEvent = c, u;
  }
  _getActiveElements(t, i, r, s) {
    if (t.type === "mouseout")
      return [];
    if (!r)
      return i;
    const n = this.options.hover;
    return this.getElementsAtEventForMode(t, n.mode, n, s);
  }
}
I(Ne, "defaults", re), I(Ne, "instances", vr), I(Ne, "overrides", Ot), I(Ne, "registry", ze), I(Ne, "version", Gp), I(Ne, "getChart", ql);
function Oa() {
  return G(Ne.instances, (e) => e._plugins.invalidate());
}
function Zp(e, t, i) {
  const { startAngle: r, pixelMargin: s, x: n, y: a, outerRadius: o, innerRadius: l } = t;
  let c = s / o;
  e.beginPath(), e.arc(n, a, o, r - c, i + c), l > s ? (c = s / l, e.arc(n, a, l, i + c, r - c, !0)) : e.arc(n, a, s, i + se, r - se), e.closePath(), e.clip();
}
function Jp(e) {
  return Zs(e, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function _p(e, t, i, r) {
  const s = Jp(e.options.borderRadius), n = (i - t) / 2, a = Math.min(n, r * t / 2), o = (l) => {
    const c = (i - Math.min(n, l)) * r / 2;
    return le(l, 0, Math.min(n, c));
  };
  return {
    outerStart: o(s.outerStart),
    outerEnd: o(s.outerEnd),
    innerStart: le(s.innerStart, 0, a),
    innerEnd: le(s.innerEnd, 0, a)
  };
}
function zt(e, t, i, r) {
  return {
    x: i + e * Math.cos(t),
    y: r + e * Math.sin(t)
  };
}
function Ar(e, t, i, r, s, n) {
  const { x: a, y: o, startAngle: l, pixelMargin: c, innerRadius: u } = t, d = Math.max(t.outerRadius + r + i - c, 0), h = u > 0 ? u + r + i + c : 0;
  let p = 0;
  const m = s - l;
  if (r) {
    const j = u > 0 ? u - r : 0, X = d > 0 ? d - r : 0, ge = (j + X) / 2, we = ge !== 0 ? m * ge / (ge + r) : m;
    p = (m - we) / 2;
  }
  const g = Math.max(1e-3, m * d - i / Z) / d, y = (m - g) / 2, v = l + y + p, w = s - y - p, { outerStart: C, outerEnd: A, innerStart: k, innerEnd: S } = _p(t, h, d, w - v), D = d - C, T = d - A, F = v + C / D, R = w - A / T, M = h + k, H = h + S, ce = v + k / M, ue = w - S / H;
  if (e.beginPath(), n) {
    const j = (F + R) / 2;
    if (e.arc(a, o, d, F, j), e.arc(a, o, d, j, R), A > 0) {
      const de = zt(T, R, a, o);
      e.arc(de.x, de.y, A, R, w + se);
    }
    const X = zt(H, w, a, o);
    if (e.lineTo(X.x, X.y), S > 0) {
      const de = zt(H, ue, a, o);
      e.arc(de.x, de.y, S, w + se, ue + Math.PI);
    }
    const ge = (w - S / h + (v + k / h)) / 2;
    if (e.arc(a, o, h, w - S / h, ge, !0), e.arc(a, o, h, ge, v + k / h, !0), k > 0) {
      const de = zt(M, ce, a, o);
      e.arc(de.x, de.y, k, ce + Math.PI, v - se);
    }
    const we = zt(D, v, a, o);
    if (e.lineTo(we.x, we.y), C > 0) {
      const de = zt(D, F, a, o);
      e.arc(de.x, de.y, C, v - se, F);
    }
  } else {
    e.moveTo(a, o);
    const j = Math.cos(F) * d + a, X = Math.sin(F) * d + o;
    e.lineTo(j, X);
    const ge = Math.cos(R) * d + a, we = Math.sin(R) * d + o;
    e.lineTo(ge, we);
  }
  e.closePath();
}
function $p(e, t, i, r, s) {
  const { fullCircles: n, startAngle: a, circumference: o } = t;
  let l = t.endAngle;
  if (n) {
    Ar(e, t, i, r, l, s);
    for (let c = 0; c < n; ++c)
      e.fill();
    isNaN(o) || (l = a + (o % Y || Y));
  }
  return Ar(e, t, i, r, l, s), e.fill(), l;
}
function ef(e, t, i, r, s) {
  const { fullCircles: n, startAngle: a, circumference: o, options: l } = t, { borderWidth: c, borderJoinStyle: u, borderDash: d, borderDashOffset: h } = l, p = l.borderAlign === "inner";
  if (!c)
    return;
  e.setLineDash(d || []), e.lineDashOffset = h, p ? (e.lineWidth = c * 2, e.lineJoin = u || "round") : (e.lineWidth = c, e.lineJoin = u || "bevel");
  let m = t.endAngle;
  if (n) {
    Ar(e, t, i, r, m, s);
    for (let g = 0; g < n; ++g)
      e.stroke();
    isNaN(o) || (m = a + (o % Y || Y));
  }
  p && Zp(e, t, m), n || (Ar(e, t, i, r, m, s), e.stroke());
}
class pi extends st {
  constructor(t) {
    super(), I(this, "circumference"), I(this, "endAngle"), I(this, "fullCircles"), I(this, "innerRadius"), I(this, "outerRadius"), I(this, "pixelMargin"), I(this, "startAngle"), this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, t && Object.assign(this, t);
  }
  inRange(t, i, r) {
    const s = this.getProps([
      "x",
      "y"
    ], r), { angle: n, distance: a } = al(s, {
      x: t,
      y: i
    }), { startAngle: o, endAngle: l, innerRadius: c, outerRadius: u, circumference: d } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], r), h = (this.options.spacing + this.options.borderWidth) / 2, p = L(d, l - o) >= Y || Ci(n, o, l), m = et(a, c + h, u + h);
    return p && m;
  }
  getCenterPoint(t) {
    const { x: i, y: r, startAngle: s, endAngle: n, innerRadius: a, outerRadius: o } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], t), { offset: l, spacing: c } = this.options, u = (s + n) / 2, d = (a + o + c + l) / 2;
    return {
      x: i + Math.cos(u) * d,
      y: r + Math.sin(u) * d
    };
  }
  tooltipPosition(t) {
    return this.getCenterPoint(t);
  }
  draw(t) {
    const { options: i, circumference: r } = this, s = (i.offset || 0) / 4, n = (i.spacing || 0) / 2, a = i.circular;
    if (this.pixelMargin = i.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = r > Y ? Math.floor(r / Y) : 0, r === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    t.save();
    const o = (this.startAngle + this.endAngle) / 2;
    t.translate(Math.cos(o) * s, Math.sin(o) * s);
    const l = 1 - Math.sin(Math.min(Z, r || 0)), c = s * l;
    t.fillStyle = i.backgroundColor, t.strokeStyle = i.borderColor, $p(t, this, c, n, a), ef(t, this, c, n, a), t.restore();
  }
}
I(pi, "id", "arc"), I(pi, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), I(pi, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), I(pi, "descriptors", {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash"
});
function Hl(e, t, i = t) {
  e.lineCap = L(i.borderCapStyle, t.borderCapStyle), e.setLineDash(L(i.borderDash, t.borderDash)), e.lineDashOffset = L(i.borderDashOffset, t.borderDashOffset), e.lineJoin = L(i.borderJoinStyle, t.borderJoinStyle), e.lineWidth = L(i.borderWidth, t.borderWidth), e.strokeStyle = L(i.borderColor, t.borderColor);
}
function tf(e, t, i) {
  e.lineTo(i.x, i.y);
}
function rf(e) {
  return e.stepped ? Sd : e.tension || e.cubicInterpolationMode === "monotone" ? Id : tf;
}
function zl(e, t, i = {}) {
  const r = e.length, { start: s = 0, end: n = r - 1 } = i, { start: a, end: o } = t, l = Math.max(s, a), c = Math.min(n, o), u = s < a && n < a || s > o && n > o;
  return {
    count: r,
    start: l,
    loop: t.loop,
    ilen: c < l && !u ? r + c - l : c - l
  };
}
function sf(e, t, i, r) {
  const { points: s, options: n } = t, { count: a, start: o, loop: l, ilen: c } = zl(s, i, r), u = rf(n);
  let { move: d = !0, reverse: h } = r || {}, p, m, g;
  for (p = 0; p <= c; ++p)
    m = s[(o + (h ? c - p : p)) % a], !m.skip && (d ? (e.moveTo(m.x, m.y), d = !1) : u(e, g, m, h, n.stepped), g = m);
  return l && (m = s[(o + (h ? c : 0)) % a], u(e, g, m, h, n.stepped)), !!l;
}
function nf(e, t, i, r) {
  const s = t.points, { count: n, start: a, ilen: o } = zl(s, i, r), { move: l = !0, reverse: c } = r || {};
  let u = 0, d = 0, h, p, m, g, y, v;
  const w = (A) => (a + (c ? o - A : A)) % n, C = () => {
    g !== y && (e.lineTo(u, y), e.lineTo(u, g), e.lineTo(u, v));
  };
  for (l && (p = s[w(0)], e.moveTo(p.x, p.y)), h = 0; h <= o; ++h) {
    if (p = s[w(h)], p.skip)
      continue;
    const A = p.x, k = p.y, S = A | 0;
    S === m ? (k < g ? g = k : k > y && (y = k), u = (d * u + A) / ++d) : (C(), e.lineTo(A, k), m = S, d = 0, g = y = k), v = k;
  }
  C();
}
function Ss(e) {
  const t = e.options, i = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !i ? nf : sf;
}
function af(e) {
  return e.stepped ? sh : e.tension || e.cubicInterpolationMode === "monotone" ? nh : Ct;
}
function of(e, t, i, r) {
  let s = t._path;
  s || (s = t._path = new Path2D(), t.path(s, i, r) && s.closePath()), Hl(e, t.options), e.stroke(s);
}
function lf(e, t, i, r) {
  const { segments: s, options: n } = t, a = Ss(t);
  for (const o of s)
    Hl(e, n, o.style), e.beginPath(), a(e, t, o, {
      start: i,
      end: i + r - 1
    }) && e.closePath(), e.stroke();
}
const cf = typeof Path2D == "function";
function uf(e, t, i, r) {
  cf && !t.options.segment ? of(e, t, i, r) : lf(e, t, i, r);
}
class ot extends st {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, i) {
    const r = this.options;
    if ((r.tension || r.cubicInterpolationMode === "monotone") && !r.stepped && !this._pointsUpdated) {
      const s = r.spanGaps ? this._loop : this._fullLoop;
      Zd(this._points, r, t, s, i), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = dh(this, this.options.segment));
  }
  first() {
    const t = this.segments, i = this.points;
    return t.length && i[t[0].start];
  }
  last() {
    const t = this.segments, i = this.points, r = t.length;
    return r && i[t[r - 1].end];
  }
  interpolate(t, i) {
    const r = this.options, s = t[i], n = this.points, a = Il(this, {
      property: i,
      start: s,
      end: s
    });
    if (!a.length)
      return;
    const o = [], l = af(r);
    let c, u;
    for (c = 0, u = a.length; c < u; ++c) {
      const { start: d, end: h } = a[c], p = n[d], m = n[h];
      if (p === m) {
        o.push(p);
        continue;
      }
      const g = Math.abs((s - p[i]) / (m[i] - p[i])), y = l(p, m, g, r.stepped);
      y[i] = t[i], o.push(y);
    }
    return o.length === 1 ? o[0] : o;
  }
  pathSegment(t, i, r) {
    return Ss(this)(t, this, i, r);
  }
  path(t, i, r) {
    const s = this.segments, n = Ss(this);
    let a = this._loop;
    i = i || 0, r = r || this.points.length - i;
    for (const o of s)
      a &= n(t, this, o, {
        start: i,
        end: i + r - 1
      });
    return !!a;
  }
  draw(t, i, r, s) {
    const n = this.options || {};
    (this.points || []).length && n.borderWidth && (t.save(), uf(t, this, r, s), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
I(ot, "id", "line"), I(ot, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), I(ot, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), I(ot, "descriptors", {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash" && e !== "fill"
});
function Ba(e, t, i, r) {
  const s = e.options, { [i]: n } = e.getProps([
    i
  ], r);
  return Math.abs(t - n) < s.radius + s.hitRadius;
}
class cr extends st {
  constructor(t) {
    super(), I(this, "parsed"), I(this, "skip"), I(this, "stop"), this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, t && Object.assign(this, t);
  }
  inRange(t, i, r) {
    const s = this.options, { x: n, y: a } = this.getProps([
      "x",
      "y"
    ], r);
    return Math.pow(t - n, 2) + Math.pow(i - a, 2) < Math.pow(s.hitRadius + s.radius, 2);
  }
  inXRange(t, i) {
    return Ba(this, t, "x", i);
  }
  inYRange(t, i) {
    return Ba(this, t, "y", i);
  }
  getCenterPoint(t) {
    const { x: i, y: r } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: i,
      y: r
    };
  }
  size(t) {
    t = t || this.options || {};
    let i = t.radius || 0;
    i = Math.max(i, i && t.hoverRadius || 0);
    const r = i && t.borderWidth || 0;
    return (i + r) * 2;
  }
  draw(t, i) {
    const r = this.options;
    this.skip || r.radius < 0.1 || !it(this, i, this.size(r) / 2) || (t.strokeStyle = r.borderColor, t.lineWidth = r.borderWidth, t.fillStyle = r.backgroundColor, ks(t, r, this.x, this.y));
  }
  getRange() {
    const t = this.options || {};
    return t.radius + t.hitRadius;
  }
}
I(cr, "id", "point"), /**
* @type {any}
*/
I(cr, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
I(cr, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function Nl(e, t) {
  const { x: i, y: r, base: s, width: n, height: a } = e.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let o, l, c, u, d;
  return e.horizontal ? (d = a / 2, o = Math.min(i, s), l = Math.max(i, s), c = r - d, u = r + d) : (d = n / 2, o = i - d, l = i + d, c = Math.min(r, s), u = Math.max(r, s)), {
    left: o,
    top: c,
    right: l,
    bottom: u
  };
}
function lt(e, t, i, r) {
  return e ? 0 : le(t, i, r);
}
function df(e, t, i) {
  const r = e.options.borderWidth, s = e.borderSkipped, n = ml(r);
  return {
    t: lt(s.top, n.top, 0, i),
    r: lt(s.right, n.right, 0, t),
    b: lt(s.bottom, n.bottom, 0, i),
    l: lt(s.left, n.left, 0, t)
  };
}
function hf(e, t, i) {
  const { enableBorderRadius: r } = e.getProps([
    "enableBorderRadius"
  ]), s = e.options.borderRadius, n = Dt(s), a = Math.min(t, i), o = e.borderSkipped, l = r || q(s);
  return {
    topLeft: lt(!l || o.top || o.left, n.topLeft, 0, a),
    topRight: lt(!l || o.top || o.right, n.topRight, 0, a),
    bottomLeft: lt(!l || o.bottom || o.left, n.bottomLeft, 0, a),
    bottomRight: lt(!l || o.bottom || o.right, n.bottomRight, 0, a)
  };
}
function pf(e) {
  const t = Nl(e), i = t.right - t.left, r = t.bottom - t.top, s = df(e, i / 2, r / 2), n = hf(e, i / 2, r / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: i,
      h: r,
      radius: n
    },
    inner: {
      x: t.left + s.l,
      y: t.top + s.t,
      w: i - s.l - s.r,
      h: r - s.t - s.b,
      radius: {
        topLeft: Math.max(0, n.topLeft - Math.max(s.t, s.l)),
        topRight: Math.max(0, n.topRight - Math.max(s.t, s.r)),
        bottomLeft: Math.max(0, n.bottomLeft - Math.max(s.b, s.l)),
        bottomRight: Math.max(0, n.bottomRight - Math.max(s.b, s.r))
      }
    }
  };
}
function ts(e, t, i, r) {
  const s = t === null, n = i === null, a = e && !(s && n) && Nl(e, r);
  return a && (s || et(t, a.left, a.right)) && (n || et(i, a.top, a.bottom));
}
function ff(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function mf(e, t) {
  e.rect(t.x, t.y, t.w, t.h);
}
function is(e, t, i = {}) {
  const r = e.x !== i.x ? -t : 0, s = e.y !== i.y ? -t : 0, n = (e.x + e.w !== i.x + i.w ? t : 0) - r, a = (e.y + e.h !== i.y + i.h ? t : 0) - s;
  return {
    x: e.x + r,
    y: e.y + s,
    w: e.w + n,
    h: e.h + a,
    radius: e.radius
  };
}
class ur extends st {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: i, options: { borderColor: r, backgroundColor: s } } = this, { inner: n, outer: a } = pf(this), o = ff(a.radius) ? Si : mf;
    t.save(), (a.w !== n.w || a.h !== n.h) && (t.beginPath(), o(t, is(a, i, n)), t.clip(), o(t, is(n, -i, a)), t.fillStyle = r, t.fill("evenodd")), t.beginPath(), o(t, is(n, i)), t.fillStyle = s, t.fill(), t.restore();
  }
  inRange(t, i, r) {
    return ts(this, t, i, r);
  }
  inXRange(t, i) {
    return ts(this, t, null, i);
  }
  inYRange(t, i) {
    return ts(this, null, t, i);
  }
  getCenterPoint(t) {
    const { x: i, y: r, base: s, horizontal: n } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: n ? (i + s) / 2 : i,
      y: n ? r : (r + s) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
I(ur, "id", "bar"), I(ur, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), I(ur, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var gf = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: pi,
  BarElement: ur,
  LineElement: ot,
  PointElement: cr
});
const Is = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
], Ma = /* @__PURE__ */ Is.map((e) => e.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function Vl(e) {
  return Is[e % Is.length];
}
function Gl(e) {
  return Ma[e % Ma.length];
}
function yf(e, t) {
  return e.borderColor = Vl(t), e.backgroundColor = Gl(t), ++t;
}
function bf(e, t) {
  return e.backgroundColor = e.data.map(() => Vl(t++)), t;
}
function vf(e, t) {
  return e.backgroundColor = e.data.map(() => Gl(t++)), t;
}
function Af(e) {
  let t = 0;
  return (i, r) => {
    const s = e.getDatasetMeta(r).controller;
    s instanceof It ? t = bf(i, t) : s instanceof vi ? t = vf(i, t) : s && (t = yf(i, t));
  };
}
function Ra(e) {
  let t;
  for (t in e)
    if (e[t].borderColor || e[t].backgroundColor)
      return !0;
  return !1;
}
function kf(e) {
  return e && (e.borderColor || e.backgroundColor);
}
var wf = {
  id: "colors",
  defaults: {
    enabled: !0,
    forceOverride: !1
  },
  beforeLayout(e, t, i) {
    if (!i.enabled)
      return;
    const { data: { datasets: r }, options: s } = e.config, { elements: n } = s;
    if (!i.forceOverride && (Ra(r) || kf(s) || n && Ra(n)))
      return;
    const a = Af(e);
    r.forEach(a);
  }
};
function xf(e, t, i, r, s) {
  const n = s.samples || r;
  if (n >= i)
    return e.slice(t, t + i);
  const a = [], o = (i - 2) / (n - 2);
  let l = 0;
  const c = t + i - 1;
  let u = t, d, h, p, m, g;
  for (a[l++] = e[u], d = 0; d < n - 2; d++) {
    let y = 0, v = 0, w;
    const C = Math.floor((d + 1) * o) + 1 + t, A = Math.min(Math.floor((d + 2) * o) + 1, i) + t, k = A - C;
    for (w = C; w < A; w++)
      y += e[w].x, v += e[w].y;
    y /= k, v /= k;
    const S = Math.floor(d * o) + 1 + t, D = Math.min(Math.floor((d + 1) * o) + 1, i) + t, { x: T, y: F } = e[u];
    for (p = m = -1, w = S; w < D; w++)
      m = 0.5 * Math.abs((T - y) * (e[w].y - F) - (T - e[w].x) * (v - F)), m > p && (p = m, h = e[w], g = w);
    a[l++] = h, u = g;
  }
  return a[l++] = e[c], a;
}
function Cf(e, t, i, r) {
  let s = 0, n = 0, a, o, l, c, u, d, h, p, m, g;
  const y = [], v = t + i - 1, w = e[t].x, C = e[v].x - w;
  for (a = t; a < t + i; ++a) {
    o = e[a], l = (o.x - w) / C * r, c = o.y;
    const A = l | 0;
    if (A === u)
      c < m ? (m = c, d = a) : c > g && (g = c, h = a), s = (n * s + o.x) / ++n;
    else {
      const k = a - 1;
      if (!z(d) && !z(h)) {
        const S = Math.min(d, h), D = Math.max(d, h);
        S !== p && S !== k && y.push({
          ...e[S],
          x: s
        }), D !== p && D !== k && y.push({
          ...e[D],
          x: s
        });
      }
      a > 0 && k !== p && y.push(e[k]), y.push(o), u = A, n = 0, m = g = c, d = h = p = a;
    }
  }
  return y;
}
function Wl(e) {
  if (e._decimated) {
    const t = e._data;
    delete e._decimated, delete e._data, Object.defineProperty(e, "data", {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: t
    });
  }
}
function Ea(e) {
  e.data.datasets.forEach((t) => {
    Wl(t);
  });
}
function Sf(e, t) {
  const i = t.length;
  let r = 0, s;
  const { iScale: n } = e, { min: a, max: o, minDefined: l, maxDefined: c } = n.getUserBounds();
  return l && (r = le(tt(t, n.axis, a).lo, 0, i - 1)), c ? s = le(tt(t, n.axis, o).hi + 1, r, i) - r : s = i - r, {
    start: r,
    count: s
  };
}
var If = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (e, t, i) => {
    if (!i.enabled) {
      Ea(e);
      return;
    }
    const r = e.width;
    e.data.datasets.forEach((s, n) => {
      const { _data: a, indexAxis: o } = s, l = e.getDatasetMeta(n), c = a || s.data;
      if (di([
        o,
        e.options.indexAxis
      ]) === "y" || !l.controller.supportsDecimation)
        return;
      const u = e.scales[l.xAxisID];
      if (u.type !== "linear" && u.type !== "time" || e.options.parsing)
        return;
      let { start: d, count: h } = Sf(l, c);
      const p = i.threshold || 4 * r;
      if (h <= p) {
        Wl(s);
        return;
      }
      z(a) && (s._data = c, delete s.data, Object.defineProperty(s, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(g) {
          this._data = g;
        }
      }));
      let m;
      switch (i.algorithm) {
        case "lttb":
          m = xf(c, d, h, r, i);
          break;
        case "min-max":
          m = Cf(c, d, h, r);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${i.algorithm}'`);
      }
      s._decimated = m;
    });
  },
  destroy(e) {
    Ea(e);
  }
};
function Df(e, t, i) {
  const r = e.segments, s = e.points, n = t.points, a = [];
  for (const o of r) {
    let { start: l, end: c } = o;
    c = sn(l, c, s);
    const u = Ds(i, s[l], s[c], o.loop);
    if (!t.segments) {
      a.push({
        source: o,
        target: u,
        start: s[l],
        end: s[c]
      });
      continue;
    }
    const d = Il(t, u);
    for (const h of d) {
      const p = Ds(i, n[h.start], n[h.end], h.loop), m = Sl(o, s, p);
      for (const g of m)
        a.push({
          source: g,
          target: h,
          start: {
            [i]: La(u, p, "start", Math.max)
          },
          end: {
            [i]: La(u, p, "end", Math.min)
          }
        });
    }
  }
  return a;
}
function Ds(e, t, i, r) {
  if (r)
    return;
  let s = t[e], n = i[e];
  return e === "angle" && (s = Ie(s), n = Ie(n)), {
    property: e,
    start: s,
    end: n
  };
}
function Pf(e, t) {
  const { x: i = null, y: r = null } = e || {}, s = t.points, n = [];
  return t.segments.forEach(({ start: a, end: o }) => {
    o = sn(a, o, s);
    const l = s[a], c = s[o];
    r !== null ? (n.push({
      x: l.x,
      y: r
    }), n.push({
      x: c.x,
      y: r
    })) : i !== null && (n.push({
      x: i,
      y: l.y
    }), n.push({
      x: i,
      y: c.y
    }));
  }), n;
}
function sn(e, t, i) {
  for (; t > e; t--) {
    const r = i[t];
    if (!isNaN(r.x) && !isNaN(r.y))
      break;
  }
  return t;
}
function La(e, t, i, r) {
  return e && t ? r(e[i], t[i]) : e ? e[i] : t ? t[i] : 0;
}
function Ql(e, t) {
  let i = [], r = !1;
  return _(e) ? (r = !0, i = e) : i = Pf(e, t), i.length ? new ot({
    points: i,
    options: {
      tension: 0
    },
    _loop: r,
    _fullLoop: r
  }) : null;
}
function Fa(e) {
  return e && e.fill !== !1;
}
function Tf(e, t, i) {
  let r = e[t].fill;
  const s = [
    t
  ];
  let n;
  if (!i)
    return r;
  for (; r !== !1 && s.indexOf(r) === -1; ) {
    if (!ie(r))
      return r;
    if (n = e[r], !n)
      return !1;
    if (n.visible)
      return r;
    s.push(r), r = n.fill;
  }
  return !1;
}
function Of(e, t, i) {
  const r = Ef(e);
  if (q(r))
    return isNaN(r.value) ? !1 : r;
  let s = parseFloat(r);
  return ie(s) && Math.floor(s) === s ? Bf(r[0], t, s, i) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(r) >= 0 && r;
}
function Bf(e, t, i, r) {
  return (e === "-" || e === "+") && (i = t + i), i === t || i < 0 || i >= r ? !1 : i;
}
function Mf(e, t) {
  let i = null;
  return e === "start" ? i = t.bottom : e === "end" ? i = t.top : q(e) ? i = t.getPixelForValue(e.value) : t.getBasePixel && (i = t.getBasePixel()), i;
}
function Rf(e, t, i) {
  let r;
  return e === "start" ? r = i : e === "end" ? r = t.options.reverse ? t.min : t.max : q(e) ? r = e.value : r = t.getBaseValue(), r;
}
function Ef(e) {
  const t = e.options, i = t.fill;
  let r = L(i && i.target, i);
  return r === void 0 && (r = !!t.backgroundColor), r === !1 || r === null ? !1 : r === !0 ? "origin" : r;
}
function Lf(e) {
  const { scale: t, index: i, line: r } = e, s = [], n = r.segments, a = r.points, o = Ff(t, i);
  o.push(Ql({
    x: null,
    y: t.bottom
  }, r));
  for (let l = 0; l < n.length; l++) {
    const c = n[l];
    for (let u = c.start; u <= c.end; u++)
      jf(s, a[u], o);
  }
  return new ot({
    points: s,
    options: {}
  });
}
function Ff(e, t) {
  const i = [], r = e.getMatchingVisibleMetas("line");
  for (let s = 0; s < r.length; s++) {
    const n = r[s];
    if (n.index === t)
      break;
    n.hidden || i.unshift(n.dataset);
  }
  return i;
}
function jf(e, t, i) {
  const r = [];
  for (let s = 0; s < i.length; s++) {
    const n = i[s], { first: a, last: o, point: l } = Uf(n, t, "x");
    if (!(!l || a && o)) {
      if (a)
        r.unshift(l);
      else if (e.push(l), !o)
        break;
    }
  }
  e.push(...r);
}
function Uf(e, t, i) {
  const r = e.interpolate(t, i);
  if (!r)
    return {};
  const s = r[i], n = e.segments, a = e.points;
  let o = !1, l = !1;
  for (let c = 0; c < n.length; c++) {
    const u = n[c], d = a[u.start][i], h = a[u.end][i];
    if (et(s, d, h)) {
      o = s === d, l = s === h;
      break;
    }
  }
  return {
    first: o,
    last: l,
    point: r
  };
}
class Xl {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, i, r) {
    const { x: s, y: n, radius: a } = this;
    return i = i || {
      start: 0,
      end: Y
    }, t.arc(s, n, a, i.end, i.start, !0), !r.bounds;
  }
  interpolate(t) {
    const { x: i, y: r, radius: s } = this, n = t.angle;
    return {
      x: i + Math.cos(n) * s,
      y: r + Math.sin(n) * s,
      angle: n
    };
  }
}
function qf(e) {
  const { chart: t, fill: i, line: r } = e;
  if (ie(i))
    return Hf(t, i);
  if (i === "stack")
    return Lf(e);
  if (i === "shape")
    return !0;
  const s = zf(e);
  return s instanceof Xl ? s : Ql(s, r);
}
function Hf(e, t) {
  const i = e.getDatasetMeta(t);
  return i && e.isDatasetVisible(t) ? i.dataset : null;
}
function zf(e) {
  return (e.scale || {}).getPointPositionForValue ? Vf(e) : Nf(e);
}
function Nf(e) {
  const { scale: t = {}, fill: i } = e, r = Mf(i, t);
  if (ie(r)) {
    const s = t.isHorizontal();
    return {
      x: s ? r : null,
      y: s ? null : r
    };
  }
  return null;
}
function Vf(e) {
  const { scale: t, fill: i } = e, r = t.options, s = t.getLabels().length, n = r.reverse ? t.max : t.min, a = Rf(i, t, n), o = [];
  if (r.grid.circular) {
    const l = t.getPointPositionForValue(0, n);
    return new Xl({
      x: l.x,
      y: l.y,
      radius: t.getDistanceFromCenterForValue(a)
    });
  }
  for (let l = 0; l < s; ++l)
    o.push(t.getPointPositionForValue(l, a));
  return o;
}
function rs(e, t, i) {
  const r = qf(t), { line: s, scale: n, axis: a } = t, o = s.options, l = o.fill, c = o.backgroundColor, { above: u = c, below: d = c } = l || {};
  r && s.points.length && (Sr(e, i), Gf(e, {
    line: s,
    target: r,
    above: u,
    below: d,
    area: i,
    scale: n,
    axis: a
  }), Ir(e));
}
function Gf(e, t) {
  const { line: i, target: r, above: s, below: n, area: a, scale: o } = t, l = i._loop ? "angle" : t.axis;
  e.save(), l === "x" && n !== s && (ja(e, r, a.top), Ua(e, {
    line: i,
    target: r,
    color: s,
    scale: o,
    property: l
  }), e.restore(), e.save(), ja(e, r, a.bottom)), Ua(e, {
    line: i,
    target: r,
    color: n,
    scale: o,
    property: l
  }), e.restore();
}
function ja(e, t, i) {
  const { segments: r, points: s } = t;
  let n = !0, a = !1;
  e.beginPath();
  for (const o of r) {
    const { start: l, end: c } = o, u = s[l], d = s[sn(l, c, s)];
    n ? (e.moveTo(u.x, u.y), n = !1) : (e.lineTo(u.x, i), e.lineTo(u.x, u.y)), a = !!t.pathSegment(e, o, {
      move: a
    }), a ? e.closePath() : e.lineTo(d.x, i);
  }
  e.lineTo(t.first().x, i), e.closePath(), e.clip();
}
function Ua(e, t) {
  const { line: i, target: r, property: s, color: n, scale: a } = t, o = Df(i, r, s);
  for (const { source: l, target: c, start: u, end: d } of o) {
    const { style: { backgroundColor: h = n } = {} } = l, p = r !== !0;
    e.save(), e.fillStyle = h, Wf(e, a, p && Ds(s, u, d)), e.beginPath();
    const m = !!i.pathSegment(e, l);
    let g;
    if (p) {
      m ? e.closePath() : qa(e, r, d, s);
      const y = !!r.pathSegment(e, c, {
        move: m,
        reverse: !0
      });
      g = m && y, g || qa(e, r, u, s);
    }
    e.closePath(), e.fill(g ? "evenodd" : "nonzero"), e.restore();
  }
}
function Wf(e, t, i) {
  const { top: r, bottom: s } = t.chart.chartArea, { property: n, start: a, end: o } = i || {};
  n === "x" && (e.beginPath(), e.rect(a, r, o - a, s - r), e.clip());
}
function qa(e, t, i, r) {
  const s = t.interpolate(i, r);
  s && e.lineTo(s.x, s.y);
}
var Qf = {
  id: "filler",
  afterDatasetsUpdate(e, t, i) {
    const r = (e.data.datasets || []).length, s = [];
    let n, a, o, l;
    for (a = 0; a < r; ++a)
      n = e.getDatasetMeta(a), o = n.dataset, l = null, o && o.options && o instanceof ot && (l = {
        visible: e.isDatasetVisible(a),
        index: a,
        fill: Of(o, a, r),
        chart: e,
        axis: n.controller.options.indexAxis,
        scale: n.vScale,
        line: o
      }), n.$filler = l, s.push(l);
    for (a = 0; a < r; ++a)
      l = s[a], !(!l || l.fill === !1) && (l.fill = Tf(s, a, i.propagate));
  },
  beforeDraw(e, t, i) {
    const r = i.drawTime === "beforeDraw", s = e.getSortedVisibleDatasetMetas(), n = e.chartArea;
    for (let a = s.length - 1; a >= 0; --a) {
      const o = s[a].$filler;
      o && (o.line.updateControlPoints(n, o.axis), r && o.fill && rs(e.ctx, o, n));
    }
  },
  beforeDatasetsDraw(e, t, i) {
    if (i.drawTime !== "beforeDatasetsDraw")
      return;
    const r = e.getSortedVisibleDatasetMetas();
    for (let s = r.length - 1; s >= 0; --s) {
      const n = r[s].$filler;
      Fa(n) && rs(e.ctx, n, e.chartArea);
    }
  },
  beforeDatasetDraw(e, t, i) {
    const r = t.meta.$filler;
    !Fa(r) || i.drawTime !== "beforeDatasetDraw" || rs(e.ctx, r, e.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const Ha = (e, t) => {
  let { boxHeight: i = t, boxWidth: r = t } = e;
  return e.usePointStyle && (i = Math.min(i, t), r = e.pointStyleWidth || Math.min(r, t)), {
    boxWidth: r,
    boxHeight: i,
    itemHeight: Math.max(t, i)
  };
}, Xf = (e, t) => e !== null && t !== null && e.datasetIndex === t.datasetIndex && e.index === t.index;
class za extends st {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, i, r) {
    this.maxWidth = t, this.maxHeight = i, this._margins = r, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let i = K(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (i = i.filter((r) => t.filter(r, this.chart.data))), t.sort && (i = i.sort((r, s) => t.sort(r, s, this.chart.data))), this.options.reverse && i.reverse(), this.legendItems = i;
  }
  fit() {
    const { options: t, ctx: i } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const r = t.labels, s = ae(r.font), n = s.size, a = this._computeTitleHeight(), { boxWidth: o, itemHeight: l } = Ha(r, n);
    let c, u;
    i.font = s.string, this.isHorizontal() ? (c = this.maxWidth, u = this._fitRows(a, n, o, l) + 10) : (u = this.maxHeight, c = this._fitCols(a, s, o, l) + 10), this.width = Math.min(c, t.maxWidth || this.maxWidth), this.height = Math.min(u, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, i, r, s) {
    const { ctx: n, maxWidth: a, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], u = s + o;
    let d = t;
    n.textAlign = "left", n.textBaseline = "middle";
    let h = -1, p = -u;
    return this.legendItems.forEach((m, g) => {
      const y = r + i / 2 + n.measureText(m.text).width;
      (g === 0 || c[c.length - 1] + y + 2 * o > a) && (d += u, c[c.length - (g > 0 ? 0 : 1)] = 0, p += u, h++), l[g] = {
        left: 0,
        top: p,
        row: h,
        width: y,
        height: s
      }, c[c.length - 1] += y + o;
    }), d;
  }
  _fitCols(t, i, r, s) {
    const { ctx: n, maxHeight: a, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], u = a - t;
    let d = o, h = 0, p = 0, m = 0, g = 0;
    return this.legendItems.forEach((y, v) => {
      const { itemWidth: w, itemHeight: C } = Kf(r, i, n, y, s);
      v > 0 && p + C + 2 * o > u && (d += h + o, c.push({
        width: h,
        height: p
      }), m += h + o, g++, h = p = 0), l[v] = {
        left: m,
        top: p,
        col: g,
        width: w,
        height: C
      }, h = Math.max(h, w), p += C + o;
    }), d += h, c.push({
      width: h,
      height: p
    }), d;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: i, options: { align: r, labels: { padding: s }, rtl: n } } = this, a = Vt(n, this.left, this.width);
    if (this.isHorizontal()) {
      let o = 0, l = pe(r, this.left + s, this.right - this.lineWidths[o]);
      for (const c of i)
        o !== c.row && (o = c.row, l = pe(r, this.left + s, this.right - this.lineWidths[o])), c.top += this.top + t + s, c.left = a.leftForLtr(a.x(l), c.width), l += c.width + s;
    } else {
      let o = 0, l = pe(r, this.top + t + s, this.bottom - this.columnSizes[o].height);
      for (const c of i)
        c.col !== o && (o = c.col, l = pe(r, this.top + t + s, this.bottom - this.columnSizes[o].height)), c.top = l, c.left += this.left + s, c.left = a.leftForLtr(a.x(c.left), c.width), l += c.height + s;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      Sr(t, this), this._draw(), Ir(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: i, lineWidths: r, ctx: s } = this, { align: n, labels: a } = t, o = re.color, l = Vt(t.rtl, this.left, this.width), c = ae(a.font), { padding: u } = a, d = c.size, h = d / 2;
    let p;
    this.drawTitle(), s.textAlign = l.textAlign("left"), s.textBaseline = "middle", s.lineWidth = 0.5, s.font = c.string;
    const { boxWidth: m, boxHeight: g, itemHeight: y } = Ha(a, d), v = function(S, D, T) {
      if (isNaN(m) || m <= 0 || isNaN(g) || g < 0)
        return;
      s.save();
      const F = L(T.lineWidth, 1);
      if (s.fillStyle = L(T.fillStyle, o), s.lineCap = L(T.lineCap, "butt"), s.lineDashOffset = L(T.lineDashOffset, 0), s.lineJoin = L(T.lineJoin, "miter"), s.lineWidth = F, s.strokeStyle = L(T.strokeStyle, o), s.setLineDash(L(T.lineDash, [])), a.usePointStyle) {
        const R = {
          radius: g * Math.SQRT2 / 2,
          pointStyle: T.pointStyle,
          rotation: T.rotation,
          borderWidth: F
        }, M = l.xPlus(S, m / 2), H = D + h;
        fl(s, R, M, H, a.pointStyleWidth && m);
      } else {
        const R = D + Math.max((d - g) / 2, 0), M = l.leftForLtr(S, m), H = Dt(T.borderRadius);
        s.beginPath(), Object.values(H).some((ce) => ce !== 0) ? Si(s, {
          x: M,
          y: R,
          w: m,
          h: g,
          radius: H
        }) : s.rect(M, R, m, g), s.fill(), F !== 0 && s.stroke();
      }
      s.restore();
    }, w = function(S, D, T) {
      Bt(s, T.text, S, D + y / 2, c, {
        strikethrough: T.hidden,
        textAlign: l.textAlign(T.textAlign)
      });
    }, C = this.isHorizontal(), A = this._computeTitleHeight();
    C ? p = {
      x: pe(n, this.left + u, this.right - r[0]),
      y: this.top + u + A,
      line: 0
    } : p = {
      x: this.left + u,
      y: pe(n, this.top + A + u, this.bottom - i[0].height),
      line: 0
    }, wl(this.ctx, t.textDirection);
    const k = y + u;
    this.legendItems.forEach((S, D) => {
      s.strokeStyle = S.fontColor, s.fillStyle = S.fontColor;
      const T = s.measureText(S.text).width, F = l.textAlign(S.textAlign || (S.textAlign = a.textAlign)), R = m + h + T;
      let M = p.x, H = p.y;
      l.setWidth(this.width), C ? D > 0 && M + R + u > this.right && (H = p.y += k, p.line++, M = p.x = pe(n, this.left + u, this.right - r[p.line])) : D > 0 && H + k > this.bottom && (M = p.x = M + i[p.line].width + u, p.line++, H = p.y = pe(n, this.top + A + u, this.bottom - i[p.line].height));
      const ce = l.x(M);
      if (v(ce, H, S), M = fd(F, M + m + h, C ? M + R : this.right, t.rtl), w(l.x(M), H, S), C)
        p.x += R + u;
      else if (typeof S.text != "string") {
        const ue = c.lineHeight;
        p.y += Kl(S, ue) + u;
      } else
        p.y += k;
    }), xl(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, i = t.title, r = ae(i.font), s = me(i.padding);
    if (!i.display)
      return;
    const n = Vt(t.rtl, this.left, this.width), a = this.ctx, o = i.position, l = r.size / 2, c = s.top + l;
    let u, d = this.left, h = this.width;
    if (this.isHorizontal())
      h = Math.max(...this.lineWidths), u = this.top + c, d = pe(t.align, d, this.right - h);
    else {
      const m = this.columnSizes.reduce((g, y) => Math.max(g, y.height), 0);
      u = c + pe(t.align, this.top, this.bottom - m - t.labels.padding - this._computeTitleHeight());
    }
    const p = pe(o, d, d + h);
    a.textAlign = n.textAlign(Ks(o)), a.textBaseline = "middle", a.strokeStyle = i.color, a.fillStyle = i.color, a.font = r.string, Bt(a, i.text, p, u, r);
  }
  _computeTitleHeight() {
    const t = this.options.title, i = ae(t.font), r = me(t.padding);
    return t.display ? i.lineHeight + r.height : 0;
  }
  _getLegendItemAt(t, i) {
    let r, s, n;
    if (et(t, this.left, this.right) && et(i, this.top, this.bottom)) {
      for (n = this.legendHitBoxes, r = 0; r < n.length; ++r)
        if (s = n[r], et(t, s.left, s.left + s.width) && et(i, s.top, s.top + s.height))
          return this.legendItems[r];
    }
    return null;
  }
  handleEvent(t) {
    const i = this.options;
    if (!Jf(t.type, i))
      return;
    const r = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const s = this._hoveredItem, n = Xf(s, r);
      s && !n && K(i.onLeave, [
        t,
        s,
        this
      ], this), this._hoveredItem = r, r && !n && K(i.onHover, [
        t,
        r,
        this
      ], this);
    } else r && K(i.onClick, [
      t,
      r,
      this
    ], this);
  }
}
function Kf(e, t, i, r, s) {
  const n = Yf(r, e, t, i), a = Zf(s, r, t.lineHeight);
  return {
    itemWidth: n,
    itemHeight: a
  };
}
function Yf(e, t, i, r) {
  let s = e.text;
  return s && typeof s != "string" && (s = s.reduce((n, a) => n.length > a.length ? n : a)), t + i.size / 2 + r.measureText(s).width;
}
function Zf(e, t, i) {
  let r = e;
  return typeof t.text != "string" && (r = Kl(t, i)), r;
}
function Kl(e, t) {
  const i = e.text ? e.text.length : 0;
  return t * i;
}
function Jf(e, t) {
  return !!((e === "mousemove" || e === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (e === "click" || e === "mouseup"));
}
var _f = {
  id: "legend",
  _element: za,
  start(e, t, i) {
    const r = e.legend = new za({
      ctx: e.ctx,
      options: i,
      chart: e
    });
    fe.configure(e, r, i), fe.addBox(e, r);
  },
  stop(e) {
    fe.removeBox(e, e.legend), delete e.legend;
  },
  beforeUpdate(e, t, i) {
    const r = e.legend;
    fe.configure(e, r, i), r.options = i;
  },
  afterUpdate(e) {
    const t = e.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(e, t) {
    t.replay || e.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(e, t, i) {
      const r = t.datasetIndex, s = i.chart;
      s.isDatasetVisible(r) ? (s.hide(r), t.hidden = !0) : (s.show(r), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (e) => e.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(e) {
        const t = e.data.datasets, { labels: { usePointStyle: i, pointStyle: r, textAlign: s, color: n, useBorderRadius: a, borderRadius: o } } = e.legend.options;
        return e._getSortedDatasetMetas().map((l) => {
          const c = l.controller.getStyle(i ? 0 : void 0), u = me(c.borderWidth);
          return {
            text: t[l.index].label,
            fillStyle: c.backgroundColor,
            fontColor: n,
            hidden: !l.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (u.width + u.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: r || c.pointStyle,
            rotation: c.rotation,
            textAlign: s || c.textAlign,
            borderRadius: a && (o || c.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (e) => e.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (e) => !e.startsWith("on"),
    labels: {
      _scriptable: (e) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(e)
    }
  }
};
class nn extends st {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, i) {
    const r = this.options;
    if (this.left = 0, this.top = 0, !r.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = i;
    const s = _(r.text) ? r.text.length : 1;
    this._padding = me(r.padding);
    const n = s * ae(r.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = n : this.width = n;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: i, left: r, bottom: s, right: n, options: a } = this, o = a.align;
    let l = 0, c, u, d;
    return this.isHorizontal() ? (u = pe(o, r, n), d = i + t, c = n - r) : (a.position === "left" ? (u = r + t, d = pe(o, s, i), l = Z * -0.5) : (u = n - t, d = pe(o, i, s), l = Z * 0.5), c = s - i), {
      titleX: u,
      titleY: d,
      maxWidth: c,
      rotation: l
    };
  }
  draw() {
    const t = this.ctx, i = this.options;
    if (!i.display)
      return;
    const r = ae(i.font), s = r.lineHeight / 2 + this._padding.top, { titleX: n, titleY: a, maxWidth: o, rotation: l } = this._drawArgs(s);
    Bt(t, i.text, 0, 0, r, {
      color: i.color,
      maxWidth: o,
      rotation: l,
      textAlign: Ks(i.align),
      textBaseline: "middle",
      translation: [
        n,
        a
      ]
    });
  }
}
function $f(e, t) {
  const i = new nn({
    ctx: e.ctx,
    options: t,
    chart: e
  });
  fe.configure(e, i, t), fe.addBox(e, i), e.titleBlock = i;
}
var em = {
  id: "title",
  _element: nn,
  start(e, t, i) {
    $f(e, i);
  },
  stop(e) {
    const t = e.titleBlock;
    fe.removeBox(e, t), delete e.titleBlock;
  },
  beforeUpdate(e, t, i) {
    const r = e.titleBlock;
    fe.configure(e, r, i), r.options = i;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const _i = /* @__PURE__ */ new WeakMap();
var tm = {
  id: "subtitle",
  start(e, t, i) {
    const r = new nn({
      ctx: e.ctx,
      options: i,
      chart: e
    });
    fe.configure(e, r, i), fe.addBox(e, r), _i.set(e, r);
  },
  stop(e) {
    fe.removeBox(e, _i.get(e)), _i.delete(e);
  },
  beforeUpdate(e, t, i) {
    const r = _i.get(e);
    fe.configure(e, r, i), r.options = i;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Ai = {
  average(e) {
    if (!e.length)
      return !1;
    let t, i, r = 0, s = 0, n = 0;
    for (t = 0, i = e.length; t < i; ++t) {
      const a = e[t].element;
      if (a && a.hasValue()) {
        const o = a.tooltipPosition();
        r += o.x, s += o.y, ++n;
      }
    }
    return {
      x: r / n,
      y: s / n
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let i = t.x, r = t.y, s = Number.POSITIVE_INFINITY, n, a, o;
    for (n = 0, a = e.length; n < a; ++n) {
      const l = e[n].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), u = vs(t, c);
        u < s && (s = u, o = l);
      }
    }
    if (o) {
      const l = o.tooltipPosition();
      i = l.x, r = l.y;
    }
    return {
      x: i,
      y: r
    };
  }
};
function He(e, t) {
  return t && (_(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function _e(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function im(e, t) {
  const { element: i, datasetIndex: r, index: s } = t, n = e.getDatasetMeta(r).controller, { label: a, value: o } = n.getLabelAndValue(s);
  return {
    chart: e,
    label: a,
    parsed: n.getParsed(s),
    raw: e.data.datasets[r].data[s],
    formattedValue: o,
    dataset: n.getDataset(),
    dataIndex: s,
    datasetIndex: r,
    element: i
  };
}
function Na(e, t) {
  const i = e.chart.ctx, { body: r, footer: s, title: n } = e, { boxWidth: a, boxHeight: o } = t, l = ae(t.bodyFont), c = ae(t.titleFont), u = ae(t.footerFont), d = n.length, h = s.length, p = r.length, m = me(t.padding);
  let g = m.height, y = 0, v = r.reduce((A, k) => A + k.before.length + k.lines.length + k.after.length, 0);
  if (v += e.beforeBody.length + e.afterBody.length, d && (g += d * c.lineHeight + (d - 1) * t.titleSpacing + t.titleMarginBottom), v) {
    const A = t.displayColors ? Math.max(o, l.lineHeight) : l.lineHeight;
    g += p * A + (v - p) * l.lineHeight + (v - 1) * t.bodySpacing;
  }
  h && (g += t.footerMarginTop + h * u.lineHeight + (h - 1) * t.footerSpacing);
  let w = 0;
  const C = function(A) {
    y = Math.max(y, i.measureText(A).width + w);
  };
  return i.save(), i.font = c.string, G(e.title, C), i.font = l.string, G(e.beforeBody.concat(e.afterBody), C), w = t.displayColors ? a + 2 + t.boxPadding : 0, G(r, (A) => {
    G(A.before, C), G(A.lines, C), G(A.after, C);
  }), w = 0, i.font = u.string, G(e.footer, C), i.restore(), y += m.width, {
    width: y,
    height: g
  };
}
function rm(e, t) {
  const { y: i, height: r } = t;
  return i < r / 2 ? "top" : i > e.height - r / 2 ? "bottom" : "center";
}
function sm(e, t, i, r) {
  const { x: s, width: n } = r, a = i.caretSize + i.caretPadding;
  if (e === "left" && s + n + a > t.width || e === "right" && s - n - a < 0)
    return !0;
}
function nm(e, t, i, r) {
  const { x: s, width: n } = i, { width: a, chartArea: { left: o, right: l } } = e;
  let c = "center";
  return r === "center" ? c = s <= (o + l) / 2 ? "left" : "right" : s <= n / 2 ? c = "left" : s >= a - n / 2 && (c = "right"), sm(c, e, t, i) && (c = "center"), c;
}
function Va(e, t, i) {
  const r = i.yAlign || t.yAlign || rm(e, i);
  return {
    xAlign: i.xAlign || t.xAlign || nm(e, t, i, r),
    yAlign: r
  };
}
function am(e, t) {
  let { x: i, width: r } = e;
  return t === "right" ? i -= r : t === "center" && (i -= r / 2), i;
}
function om(e, t, i) {
  let { y: r, height: s } = e;
  return t === "top" ? r += i : t === "bottom" ? r -= s + i : r -= s / 2, r;
}
function Ga(e, t, i, r) {
  const { caretSize: s, caretPadding: n, cornerRadius: a } = e, { xAlign: o, yAlign: l } = i, c = s + n, { topLeft: u, topRight: d, bottomLeft: h, bottomRight: p } = Dt(a);
  let m = am(t, o);
  const g = om(t, l, c);
  return l === "center" ? o === "left" ? m += c : o === "right" && (m -= c) : o === "left" ? m -= Math.max(u, h) + s : o === "right" && (m += Math.max(d, p) + s), {
    x: le(m, 0, r.width - t.width),
    y: le(g, 0, r.height - t.height)
  };
}
function $i(e, t, i) {
  const r = me(i.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - r.right : e.x + r.left;
}
function Wa(e) {
  return He([], _e(e));
}
function lm(e, t, i) {
  return ft(e, {
    tooltip: t,
    tooltipItems: i,
    type: "tooltip"
  });
}
function Qa(e, t) {
  const i = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return i ? e.override(i) : e;
}
const Yl = {
  beforeTitle: Ze,
  title(e) {
    if (e.length > 0) {
      const t = e[0], i = t.chart.data.labels, r = i ? i.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (r > 0 && t.dataIndex < r)
        return i[t.dataIndex];
    }
    return "";
  },
  afterTitle: Ze,
  beforeBody: Ze,
  beforeLabel: Ze,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const i = e.formattedValue;
    return z(i) || (t += i), t;
  },
  labelColor(e) {
    const t = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: t.borderColor,
      backgroundColor: t.backgroundColor,
      borderWidth: t.borderWidth,
      borderDash: t.borderDash,
      borderDashOffset: t.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const t = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: t.pointStyle,
      rotation: t.rotation
    };
  },
  afterLabel: Ze,
  afterBody: Ze,
  beforeFooter: Ze,
  footer: Ze,
  afterFooter: Ze
};
function xe(e, t, i, r) {
  const s = e[t].call(i, r);
  return typeof s > "u" ? Yl[t].call(i, r) : s;
}
class Ps extends st {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const i = this.chart, r = this.options.setContext(this.getContext()), s = r.enabled && i.options.animation && r.animations, n = new Dl(this.chart, s);
    return s._cacheable && (this._cachedAnimations = Object.freeze(n)), n;
  }
  getContext() {
    return this.$context || (this.$context = lm(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, i) {
    const { callbacks: r } = i, s = xe(r, "beforeTitle", this, t), n = xe(r, "title", this, t), a = xe(r, "afterTitle", this, t);
    let o = [];
    return o = He(o, _e(s)), o = He(o, _e(n)), o = He(o, _e(a)), o;
  }
  getBeforeBody(t, i) {
    return Wa(xe(i.callbacks, "beforeBody", this, t));
  }
  getBody(t, i) {
    const { callbacks: r } = i, s = [];
    return G(t, (n) => {
      const a = {
        before: [],
        lines: [],
        after: []
      }, o = Qa(r, n);
      He(a.before, _e(xe(o, "beforeLabel", this, n))), He(a.lines, xe(o, "label", this, n)), He(a.after, _e(xe(o, "afterLabel", this, n))), s.push(a);
    }), s;
  }
  getAfterBody(t, i) {
    return Wa(xe(i.callbacks, "afterBody", this, t));
  }
  getFooter(t, i) {
    const { callbacks: r } = i, s = xe(r, "beforeFooter", this, t), n = xe(r, "footer", this, t), a = xe(r, "afterFooter", this, t);
    let o = [];
    return o = He(o, _e(s)), o = He(o, _e(n)), o = He(o, _e(a)), o;
  }
  _createItems(t) {
    const i = this._active, r = this.chart.data, s = [], n = [], a = [];
    let o = [], l, c;
    for (l = 0, c = i.length; l < c; ++l)
      o.push(im(this.chart, i[l]));
    return t.filter && (o = o.filter((u, d, h) => t.filter(u, d, h, r))), t.itemSort && (o = o.sort((u, d) => t.itemSort(u, d, r))), G(o, (u) => {
      const d = Qa(t.callbacks, u);
      s.push(xe(d, "labelColor", this, u)), n.push(xe(d, "labelPointStyle", this, u)), a.push(xe(d, "labelTextColor", this, u));
    }), this.labelColors = s, this.labelPointStyles = n, this.labelTextColors = a, this.dataPoints = o, o;
  }
  update(t, i) {
    const r = this.options.setContext(this.getContext()), s = this._active;
    let n, a = [];
    if (!s.length)
      this.opacity !== 0 && (n = {
        opacity: 0
      });
    else {
      const o = Ai[r.position].call(this, s, this._eventPosition);
      a = this._createItems(r), this.title = this.getTitle(a, r), this.beforeBody = this.getBeforeBody(a, r), this.body = this.getBody(a, r), this.afterBody = this.getAfterBody(a, r), this.footer = this.getFooter(a, r);
      const l = this._size = Na(this, r), c = Object.assign({}, o, l), u = Va(this.chart, r, c), d = Ga(r, c, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, n = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: l.width,
        height: l.height,
        caretX: o.x,
        caretY: o.y
      };
    }
    this._tooltipItems = a, this.$context = void 0, n && this._resolveAnimations().update(this, n), t && r.external && r.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: i
    });
  }
  drawCaret(t, i, r, s) {
    const n = this.getCaretPosition(t, r, s);
    i.lineTo(n.x1, n.y1), i.lineTo(n.x2, n.y2), i.lineTo(n.x3, n.y3);
  }
  getCaretPosition(t, i, r) {
    const { xAlign: s, yAlign: n } = this, { caretSize: a, cornerRadius: o } = r, { topLeft: l, topRight: c, bottomLeft: u, bottomRight: d } = Dt(o), { x: h, y: p } = t, { width: m, height: g } = i;
    let y, v, w, C, A, k;
    return n === "center" ? (A = p + g / 2, s === "left" ? (y = h, v = y - a, C = A + a, k = A - a) : (y = h + m, v = y + a, C = A - a, k = A + a), w = y) : (s === "left" ? v = h + Math.max(l, u) + a : s === "right" ? v = h + m - Math.max(c, d) - a : v = this.caretX, n === "top" ? (C = p, A = C - a, y = v - a, w = v + a) : (C = p + g, A = C + a, y = v + a, w = v - a), k = C), {
      x1: y,
      x2: v,
      x3: w,
      y1: C,
      y2: A,
      y3: k
    };
  }
  drawTitle(t, i, r) {
    const s = this.title, n = s.length;
    let a, o, l;
    if (n) {
      const c = Vt(r.rtl, this.x, this.width);
      for (t.x = $i(this, r.titleAlign, r), i.textAlign = c.textAlign(r.titleAlign), i.textBaseline = "middle", a = ae(r.titleFont), o = r.titleSpacing, i.fillStyle = r.titleColor, i.font = a.string, l = 0; l < n; ++l)
        i.fillText(s[l], c.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + o, l + 1 === n && (t.y += r.titleMarginBottom - o);
    }
  }
  _drawColorBox(t, i, r, s, n) {
    const a = this.labelColors[r], o = this.labelPointStyles[r], { boxHeight: l, boxWidth: c } = n, u = ae(n.bodyFont), d = $i(this, "left", n), h = s.x(d), p = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, m = i.y + p;
    if (n.usePointStyle) {
      const g = {
        radius: Math.min(c, l) / 2,
        pointStyle: o.pointStyle,
        rotation: o.rotation,
        borderWidth: 1
      }, y = s.leftForLtr(h, c) + c / 2, v = m + l / 2;
      t.strokeStyle = n.multiKeyBackground, t.fillStyle = n.multiKeyBackground, ks(t, g, y, v), t.strokeStyle = a.borderColor, t.fillStyle = a.backgroundColor, ks(t, g, y, v);
    } else {
      t.lineWidth = q(a.borderWidth) ? Math.max(...Object.values(a.borderWidth)) : a.borderWidth || 1, t.strokeStyle = a.borderColor, t.setLineDash(a.borderDash || []), t.lineDashOffset = a.borderDashOffset || 0;
      const g = s.leftForLtr(h, c), y = s.leftForLtr(s.xPlus(h, 1), c - 2), v = Dt(a.borderRadius);
      Object.values(v).some((w) => w !== 0) ? (t.beginPath(), t.fillStyle = n.multiKeyBackground, Si(t, {
        x: g,
        y: m,
        w: c,
        h: l,
        radius: v
      }), t.fill(), t.stroke(), t.fillStyle = a.backgroundColor, t.beginPath(), Si(t, {
        x: y,
        y: m + 1,
        w: c - 2,
        h: l - 2,
        radius: v
      }), t.fill()) : (t.fillStyle = n.multiKeyBackground, t.fillRect(g, m, c, l), t.strokeRect(g, m, c, l), t.fillStyle = a.backgroundColor, t.fillRect(y, m + 1, c - 2, l - 2));
    }
    t.fillStyle = this.labelTextColors[r];
  }
  drawBody(t, i, r) {
    const { body: s } = this, { bodySpacing: n, bodyAlign: a, displayColors: o, boxHeight: l, boxWidth: c, boxPadding: u } = r, d = ae(r.bodyFont);
    let h = d.lineHeight, p = 0;
    const m = Vt(r.rtl, this.x, this.width), g = function(T) {
      i.fillText(T, m.x(t.x + p), t.y + h / 2), t.y += h + n;
    }, y = m.textAlign(a);
    let v, w, C, A, k, S, D;
    for (i.textAlign = a, i.textBaseline = "middle", i.font = d.string, t.x = $i(this, y, r), i.fillStyle = r.bodyColor, G(this.beforeBody, g), p = o && y !== "right" ? a === "center" ? c / 2 + u : c + 2 + u : 0, A = 0, S = s.length; A < S; ++A) {
      for (v = s[A], w = this.labelTextColors[A], i.fillStyle = w, G(v.before, g), C = v.lines, o && C.length && (this._drawColorBox(i, t, A, m, r), h = Math.max(d.lineHeight, l)), k = 0, D = C.length; k < D; ++k)
        g(C[k]), h = d.lineHeight;
      G(v.after, g);
    }
    p = 0, h = d.lineHeight, G(this.afterBody, g), t.y -= n;
  }
  drawFooter(t, i, r) {
    const s = this.footer, n = s.length;
    let a, o;
    if (n) {
      const l = Vt(r.rtl, this.x, this.width);
      for (t.x = $i(this, r.footerAlign, r), t.y += r.footerMarginTop, i.textAlign = l.textAlign(r.footerAlign), i.textBaseline = "middle", a = ae(r.footerFont), i.fillStyle = r.footerColor, i.font = a.string, o = 0; o < n; ++o)
        i.fillText(s[o], l.x(t.x), t.y + a.lineHeight / 2), t.y += a.lineHeight + r.footerSpacing;
    }
  }
  drawBackground(t, i, r, s) {
    const { xAlign: n, yAlign: a } = this, { x: o, y: l } = t, { width: c, height: u } = r, { topLeft: d, topRight: h, bottomLeft: p, bottomRight: m } = Dt(s.cornerRadius);
    i.fillStyle = s.backgroundColor, i.strokeStyle = s.borderColor, i.lineWidth = s.borderWidth, i.beginPath(), i.moveTo(o + d, l), a === "top" && this.drawCaret(t, i, r, s), i.lineTo(o + c - h, l), i.quadraticCurveTo(o + c, l, o + c, l + h), a === "center" && n === "right" && this.drawCaret(t, i, r, s), i.lineTo(o + c, l + u - m), i.quadraticCurveTo(o + c, l + u, o + c - m, l + u), a === "bottom" && this.drawCaret(t, i, r, s), i.lineTo(o + p, l + u), i.quadraticCurveTo(o, l + u, o, l + u - p), a === "center" && n === "left" && this.drawCaret(t, i, r, s), i.lineTo(o, l + d), i.quadraticCurveTo(o, l, o + d, l), i.closePath(), i.fill(), s.borderWidth > 0 && i.stroke();
  }
  _updateAnimationTarget(t) {
    const i = this.chart, r = this.$animations, s = r && r.x, n = r && r.y;
    if (s || n) {
      const a = Ai[t.position].call(this, this._active, this._eventPosition);
      if (!a)
        return;
      const o = this._size = Na(this, t), l = Object.assign({}, a, this._size), c = Va(i, t, l), u = Ga(t, l, c, i);
      (s._to !== u.x || n._to !== u.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = o.width, this.height = o.height, this.caretX = a.x, this.caretY = a.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const i = this.options.setContext(this.getContext());
    let r = this.opacity;
    if (!r)
      return;
    this._updateAnimationTarget(i);
    const s = {
      width: this.width,
      height: this.height
    }, n = {
      x: this.x,
      y: this.y
    };
    r = Math.abs(r) < 1e-3 ? 0 : r;
    const a = me(i.padding), o = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    i.enabled && o && (t.save(), t.globalAlpha = r, this.drawBackground(n, t, s, i), wl(t, i.textDirection), n.y += a.top, this.drawTitle(n, t, i), this.drawBody(n, t, i), this.drawFooter(n, t, i), xl(t, i.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, i) {
    const r = this._active, s = t.map(({ datasetIndex: o, index: l }) => {
      const c = this.chart.getDatasetMeta(o);
      if (!c)
        throw new Error("Cannot find a dataset at index " + o);
      return {
        datasetIndex: o,
        element: c.data[l],
        index: l
      };
    }), n = !pr(r, s), a = this._positionChanged(s, i);
    (n || a) && (this._active = s, this._eventPosition = i, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, i, r = !0) {
    if (i && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const s = this.options, n = this._active || [], a = this._getActiveElements(t, n, i, r), o = this._positionChanged(a, t), l = i || !pr(a, n) || o;
    return l && (this._active = a, (s.enabled || s.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, i))), l;
  }
  _getActiveElements(t, i, r, s) {
    const n = this.options;
    if (t.type === "mouseout")
      return [];
    if (!s)
      return i.filter((o) => this.chart.data.datasets[o.datasetIndex] && this.chart.getDatasetMeta(o.datasetIndex).controller.getParsed(o.index) !== void 0);
    const a = this.chart.getElementsAtEventForMode(t, n.mode, n, r);
    return n.reverse && a.reverse(), a;
  }
  _positionChanged(t, i) {
    const { caretX: r, caretY: s, options: n } = this, a = Ai[n.position].call(this, t, i);
    return a !== !1 && (r !== a.x || s !== a.y);
  }
}
I(Ps, "positioners", Ai);
var cm = {
  id: "tooltip",
  _element: Ps,
  positioners: Ai,
  afterInit(e, t, i) {
    i && (e.tooltip = new Ps({
      chart: e,
      options: i
    }));
  },
  beforeUpdate(e, t, i) {
    e.tooltip && e.tooltip.initialize(i);
  },
  reset(e, t, i) {
    e.tooltip && e.tooltip.initialize(i);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const i = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...i,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", i);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const i = t.replay;
      e.tooltip.handleEvent(t.event, i, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Yl
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
}, um = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: wf,
  Decimation: If,
  Filler: Qf,
  Legend: _f,
  SubTitle: tm,
  Title: em,
  Tooltip: cm
});
const dm = (e, t, i, r) => (typeof t == "string" ? (i = e.push(t) - 1, r.unshift({
  index: i,
  label: t
})) : isNaN(t) && (i = null), i);
function hm(e, t, i, r) {
  const s = e.indexOf(t);
  if (s === -1)
    return dm(e, t, i, r);
  const n = e.lastIndexOf(t);
  return s !== n ? i : s;
}
const pm = (e, t) => e === null ? null : le(Math.round(e), 0, t);
function Zl(e) {
  const t = this.getLabels();
  return e >= 0 && e < t.length ? t[e] : e;
}
class Ts extends Rt {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const i = this._addedLabels;
    if (i.length) {
      const r = this.getLabels();
      for (const { index: s, label: n } of i)
        r[s] === n && r.splice(s, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, i) {
    if (z(t))
      return null;
    const r = this.getLabels();
    return i = isFinite(i) && r[i] === t ? i : hm(r, t, L(i, t), this._addedLabels), pm(i, r.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: i } = this.getUserBounds();
    let { min: r, max: s } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (r = 0), i || (s = this.getLabels().length - 1)), this.min = r, this.max = s;
  }
  buildTicks() {
    const t = this.min, i = this.max, r = this.options.offset, s = [];
    let n = this.getLabels();
    n = t === 0 && i === n.length - 1 ? n : n.slice(t, i + 1), this._valueRange = Math.max(n.length - (r ? 0 : 1), 1), this._startValue = this.min - (r ? 0.5 : 0);
    for (let a = t; a <= i; a++)
      s.push({
        value: a
      });
    return s;
  }
  getLabelForValue(t) {
    return Zl.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const i = this.ticks;
    return t < 0 || t > i.length - 1 ? null : this.getPixelForValue(i[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
I(Ts, "id", "category"), I(Ts, "defaults", {
  ticks: {
    callback: Zl
  }
});
function fm(e, t) {
  const i = [], { bounds: r, step: s, min: n, max: a, precision: o, count: l, maxTicks: c, maxDigits: u, includeBounds: d } = e, h = s || 1, p = c - 1, { min: m, max: g } = t, y = !z(n), v = !z(a), w = !z(l), C = (g - m) / (u + 1);
  let A = Nn((g - m) / p / h) * h, k, S, D, T;
  if (A < 1e-14 && !y && !v)
    return [
      {
        value: m
      },
      {
        value: g
      }
    ];
  T = Math.ceil(g / A) - Math.floor(m / A), T > p && (A = Nn(T * A / p / h) * h), z(o) || (k = Math.pow(10, o), A = Math.ceil(A * k) / k), r === "ticks" ? (S = Math.floor(m / A) * A, D = Math.ceil(g / A) * A) : (S = m, D = g), y && v && s && od((a - n) / s, A / 1e3) ? (T = Math.round(Math.min((a - n) / A, c)), A = (a - n) / T, S = n, D = a) : w ? (S = y ? n : S, D = v ? a : D, T = l - 1, A = (D - S) / T) : (T = (D - S) / A, gi(T, Math.round(T), A / 1e3) ? T = Math.round(T) : T = Math.ceil(T));
  const F = Math.max(Vn(A), Vn(S));
  k = Math.pow(10, z(o) ? F : o), S = Math.round(S * k) / k, D = Math.round(D * k) / k;
  let R = 0;
  for (y && (d && S !== n ? (i.push({
    value: n
  }), S < n && R++, gi(Math.round((S + R * A) * k) / k, n, Xa(n, C, e)) && R++) : S < n && R++); R < T; ++R) {
    const M = Math.round((S + R * A) * k) / k;
    if (v && M > a)
      break;
    i.push({
      value: M
    });
  }
  return v && d && D !== a ? i.length && gi(i[i.length - 1].value, a, Xa(a, C, e)) ? i[i.length - 1].value = a : i.push({
    value: a
  }) : (!v || D === a) && i.push({
    value: D
  }), i;
}
function Xa(e, t, { horizontal: i, minRotation: r }) {
  const s = Le(r), n = (i ? Math.sin(s) : Math.cos(s)) || 1e-3, a = 0.75 * t * ("" + e).length;
  return Math.min(t / n, a);
}
class kr extends Rt {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, i) {
    return z(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: i, maxDefined: r } = this.getUserBounds();
    let { min: s, max: n } = this;
    const a = (l) => s = i ? s : l, o = (l) => n = r ? n : l;
    if (t) {
      const l = Ve(s), c = Ve(n);
      l < 0 && c < 0 ? o(0) : l > 0 && c > 0 && a(0);
    }
    if (s === n) {
      let l = n === 0 ? 1 : Math.abs(n * 0.05);
      o(n + l), t || a(s - l);
    }
    this.min = s, this.max = n;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: i, stepSize: r } = t, s;
    return r ? (s = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1, s > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${s} ticks. Limiting to 1000.`), s = 1e3)) : (s = this.computeTickLimit(), i = i || 11), i && (s = Math.min(i, s)), s;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, i = t.ticks;
    let r = this.getTickLimit();
    r = Math.max(2, r);
    const s = {
      maxTicks: r,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: i.precision,
      step: i.stepSize,
      count: i.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: i.minRotation || 0,
      includeBounds: i.includeBounds !== !1
    }, n = this._range || this, a = fm(s, n);
    return t.bounds === "ticks" && nl(a, this, "value"), t.reverse ? (a.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), a;
  }
  configure() {
    const t = this.ticks;
    let i = this.min, r = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const s = (r - i) / Math.max(t.length - 1, 1) / 2;
      i -= s, r += s;
    }
    this._startValue = i, this._endValue = r, this._valueRange = r - i;
  }
  getLabelForValue(t) {
    return Oi(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class Os extends kr {
  determineDataLimits() {
    const { min: t, max: i } = this.getMinMax(!0);
    this.min = ie(t) ? t : 0, this.max = ie(i) ? i : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), i = t ? this.width : this.height, r = Le(this.options.ticks.minRotation), s = (t ? Math.sin(r) : Math.cos(r)) || 1e-3, n = this._resolveTickFontOptions(0);
    return Math.ceil(i / Math.min(40, n.lineHeight / s));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
I(Os, "id", "linear"), I(Os, "defaults", {
  ticks: {
    callback: Cr.formatters.numeric
  }
});
const Di = (e) => Math.floor(at(e)), At = (e, t) => Math.pow(10, Di(e) + t);
function Ka(e) {
  return e / Math.pow(10, Di(e)) === 1;
}
function Ya(e, t, i) {
  const r = Math.pow(10, i), s = Math.floor(e / r);
  return Math.ceil(t / r) - s;
}
function mm(e, t) {
  const i = t - e;
  let r = Di(i);
  for (; Ya(e, t, r) > 10; )
    r++;
  for (; Ya(e, t, r) < 10; )
    r--;
  return Math.min(r, Di(e));
}
function gm(e, { min: t, max: i }) {
  t = Se(e.min, t);
  const r = [], s = Di(t);
  let n = mm(t, i), a = n < 0 ? Math.pow(10, Math.abs(n)) : 1;
  const o = Math.pow(10, n), l = s > n ? Math.pow(10, s) : 0, c = Math.round((t - l) * a) / a, u = Math.floor((t - l) / o / 10) * o * 10;
  let d = Math.floor((c - u) / Math.pow(10, n)), h = Se(e.min, Math.round((l + u + d * Math.pow(10, n)) * a) / a);
  for (; h < i; )
    r.push({
      value: h,
      major: Ka(h),
      significand: d
    }), d >= 10 ? d = d < 15 ? 15 : 20 : d++, d >= 20 && (n++, d = 2, a = n >= 0 ? 1 : a), h = Math.round((l + u + d * Math.pow(10, n)) * a) / a;
  const p = Se(e.max, h);
  return r.push({
    value: p,
    major: Ka(p),
    significand: d
  }), r;
}
class Bs extends Rt {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, i) {
    const r = kr.prototype.parse.apply(this, [
      t,
      i
    ]);
    if (r === 0) {
      this._zero = !0;
      return;
    }
    return ie(r) && r > 0 ? r : null;
  }
  determineDataLimits() {
    const { min: t, max: i } = this.getMinMax(!0);
    this.min = ie(t) ? Math.max(0, t) : null, this.max = ie(i) ? Math.max(0, i) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !ie(this._userMin) && (this.min = t === At(this.min, 0) ? At(this.min, -1) : At(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: i } = this.getUserBounds();
    let r = this.min, s = this.max;
    const n = (o) => r = t ? r : o, a = (o) => s = i ? s : o;
    r === s && (r <= 0 ? (n(1), a(10)) : (n(At(r, -1)), a(At(s, 1)))), r <= 0 && n(At(s, -1)), s <= 0 && a(At(r, 1)), this.min = r, this.max = s;
  }
  buildTicks() {
    const t = this.options, i = {
      min: this._userMin,
      max: this._userMax
    }, r = gm(i, this);
    return t.bounds === "ticks" && nl(r, this, "value"), t.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : Oi(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = at(t), this._valueRange = at(this.max) - at(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (at(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const i = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + i * this._valueRange);
  }
}
I(Bs, "id", "logarithmic"), I(Bs, "defaults", {
  ticks: {
    callback: Cr.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function Ms(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const i = me(t.backdropPadding);
    return L(t.font && t.font.size, re.font.size) + i.height;
  }
  return 0;
}
function ym(e, t, i) {
  return i = _(i) ? i : [
    i
  ], {
    w: Cd(e, t.string, i),
    h: i.length * t.lineHeight
  };
}
function Za(e, t, i, r, s) {
  return e === r || e === s ? {
    start: t - i / 2,
    end: t + i / 2
  } : e < r || e > s ? {
    start: t - i,
    end: t
  } : {
    start: t,
    end: t + i
  };
}
function bm(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, i = Object.assign({}, t), r = [], s = [], n = e._pointLabels.length, a = e.options.pointLabels, o = a.centerPointLabels ? Z / n : 0;
  for (let l = 0; l < n; l++) {
    const c = a.setContext(e.getPointLabelContext(l));
    s[l] = c.padding;
    const u = e.getPointPosition(l, e.drawingArea + s[l], o), d = ae(c.font), h = ym(e.ctx, d, e._pointLabels[l]);
    r[l] = h;
    const p = Ie(e.getIndexAngle(l) + o), m = Math.round(Qs(p)), g = Za(m, u.x, h.w, 0, 180), y = Za(m, u.y, h.h, 90, 270);
    vm(i, t, p, g, y);
  }
  e.setCenterPoint(t.l - i.l, i.r - t.r, t.t - i.t, i.b - t.b), e._pointLabelItems = wm(e, r, s);
}
function vm(e, t, i, r, s) {
  const n = Math.abs(Math.sin(i)), a = Math.abs(Math.cos(i));
  let o = 0, l = 0;
  r.start < t.l ? (o = (t.l - r.start) / n, e.l = Math.min(e.l, t.l - o)) : r.end > t.r && (o = (r.end - t.r) / n, e.r = Math.max(e.r, t.r + o)), s.start < t.t ? (l = (t.t - s.start) / a, e.t = Math.min(e.t, t.t - l)) : s.end > t.b && (l = (s.end - t.b) / a, e.b = Math.max(e.b, t.b + l));
}
function Am(e, t, i) {
  const r = e.drawingArea, { extra: s, additionalAngle: n, padding: a, size: o } = i, l = e.getPointPosition(t, r + s + a, n), c = Math.round(Qs(Ie(l.angle + se))), u = Sm(l.y, o.h, c), d = xm(c), h = Cm(l.x, o.w, d);
  return {
    visible: !0,
    x: l.x,
    y: u,
    textAlign: d,
    left: h,
    top: u,
    right: h + o.w,
    bottom: u + o.h
  };
}
function km(e, t) {
  if (!t)
    return !0;
  const { left: i, top: r, right: s, bottom: n } = e;
  return !(it({
    x: i,
    y: r
  }, t) || it({
    x: i,
    y: n
  }, t) || it({
    x: s,
    y: r
  }, t) || it({
    x: s,
    y: n
  }, t));
}
function wm(e, t, i) {
  const r = [], s = e._pointLabels.length, n = e.options, { centerPointLabels: a, display: o } = n.pointLabels, l = {
    extra: Ms(n) / 2,
    additionalAngle: a ? Z / s : 0
  };
  let c;
  for (let u = 0; u < s; u++) {
    l.padding = i[u], l.size = t[u];
    const d = Am(e, u, l);
    r.push(d), o === "auto" && (d.visible = km(d, c), d.visible && (c = d));
  }
  return r;
}
function xm(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function Cm(e, t, i) {
  return i === "right" ? e -= t : i === "center" && (e -= t / 2), e;
}
function Sm(e, t, i) {
  return i === 90 || i === 270 ? e -= t / 2 : (i > 270 || i < 90) && (e -= t), e;
}
function Im(e, t, i) {
  const { left: r, top: s, right: n, bottom: a } = i, { backdropColor: o } = t;
  if (!z(o)) {
    const l = Dt(t.borderRadius), c = me(t.backdropPadding);
    e.fillStyle = o;
    const u = r - c.left, d = s - c.top, h = n - r + c.width, p = a - s + c.height;
    Object.values(l).some((m) => m !== 0) ? (e.beginPath(), Si(e, {
      x: u,
      y: d,
      w: h,
      h: p,
      radius: l
    }), e.fill()) : e.fillRect(u, d, h, p);
  }
}
function Dm(e, t) {
  const { ctx: i, options: { pointLabels: r } } = e;
  for (let s = t - 1; s >= 0; s--) {
    const n = e._pointLabelItems[s];
    if (!n.visible)
      continue;
    const a = r.setContext(e.getPointLabelContext(s));
    Im(i, a, n);
    const o = ae(a.font), { x: l, y: c, textAlign: u } = n;
    Bt(i, e._pointLabels[s], l, c + o.lineHeight / 2, o, {
      color: a.color,
      textAlign: u,
      textBaseline: "middle"
    });
  }
}
function Jl(e, t, i, r) {
  const { ctx: s } = e;
  if (i)
    s.arc(e.xCenter, e.yCenter, t, 0, Y);
  else {
    let n = e.getPointPosition(0, t);
    s.moveTo(n.x, n.y);
    for (let a = 1; a < r; a++)
      n = e.getPointPosition(a, t), s.lineTo(n.x, n.y);
  }
}
function Pm(e, t, i, r, s) {
  const n = e.ctx, a = t.circular, { color: o, lineWidth: l } = t;
  !a && !r || !o || !l || i < 0 || (n.save(), n.strokeStyle = o, n.lineWidth = l, n.setLineDash(s.dash), n.lineDashOffset = s.dashOffset, n.beginPath(), Jl(e, i, a, r), n.closePath(), n.stroke(), n.restore());
}
function Tm(e, t, i) {
  return ft(e, {
    label: i,
    index: t,
    type: "pointLabel"
  });
}
class fi extends kr {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = me(Ms(this.options) / 2), i = this.width = this.maxWidth - t.width, r = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + i / 2 + t.left), this.yCenter = Math.floor(this.top + r / 2 + t.top), this.drawingArea = Math.floor(Math.min(i, r) / 2);
  }
  determineDataLimits() {
    const { min: t, max: i } = this.getMinMax(!1);
    this.min = ie(t) && !isNaN(t) ? t : 0, this.max = ie(i) && !isNaN(i) ? i : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / Ms(this.options));
  }
  generateTickLabels(t) {
    kr.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((i, r) => {
      const s = K(this.options.pointLabels.callback, [
        i,
        r
      ], this);
      return s || s === 0 ? s : "";
    }).filter((i, r) => this.chart.getDataVisibility(r));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? bm(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, i, r, s) {
    this.xCenter += Math.floor((t - i) / 2), this.yCenter += Math.floor((r - s) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, i, r, s));
  }
  getIndexAngle(t) {
    const i = Y / (this._pointLabels.length || 1), r = this.options.startAngle || 0;
    return Ie(t * i + Le(r));
  }
  getDistanceFromCenterForValue(t) {
    if (z(t))
      return NaN;
    const i = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * i : (t - this.min) * i;
  }
  getValueForDistanceFromCenter(t) {
    if (z(t))
      return NaN;
    const i = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - i : this.min + i;
  }
  getPointLabelContext(t) {
    const i = this._pointLabels || [];
    if (t >= 0 && t < i.length) {
      const r = i[t];
      return Tm(this.getContext(), t, r);
    }
  }
  getPointPosition(t, i, r = 0) {
    const s = this.getIndexAngle(t) - se + r;
    return {
      x: Math.cos(s) * i + this.xCenter,
      y: Math.sin(s) * i + this.yCenter,
      angle: s
    };
  }
  getPointPositionForValue(t, i) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(i));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: i, top: r, right: s, bottom: n } = this._pointLabelItems[t];
    return {
      left: i,
      top: r,
      right: s,
      bottom: n
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: i } } = this.options;
    if (t) {
      const r = this.ctx;
      r.save(), r.beginPath(), Jl(this, this.getDistanceFromCenterForValue(this._endValue), i, this._pointLabels.length), r.closePath(), r.fillStyle = t, r.fill(), r.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, i = this.options, { angleLines: r, grid: s, border: n } = i, a = this._pointLabels.length;
    let o, l, c;
    if (i.pointLabels.display && Dm(this, a), s.display && this.ticks.forEach((u, d) => {
      if (d !== 0) {
        l = this.getDistanceFromCenterForValue(u.value);
        const h = this.getContext(d), p = s.setContext(h), m = n.setContext(h);
        Pm(this, p, l, a, m);
      }
    }), r.display) {
      for (t.save(), o = a - 1; o >= 0; o--) {
        const u = r.setContext(this.getPointLabelContext(o)), { color: d, lineWidth: h } = u;
        !h || !d || (t.lineWidth = h, t.strokeStyle = d, t.setLineDash(u.borderDash), t.lineDashOffset = u.borderDashOffset, l = this.getDistanceFromCenterForValue(i.ticks.reverse ? this.min : this.max), c = this.getPointPosition(o, l), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(c.x, c.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, i = this.options, r = i.ticks;
    if (!r.display)
      return;
    const s = this.getIndexAngle(0);
    let n, a;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(s), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((o, l) => {
      if (l === 0 && !i.reverse)
        return;
      const c = r.setContext(this.getContext(l)), u = ae(c.font);
      if (n = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        t.font = u.string, a = t.measureText(o.label).width, t.fillStyle = c.backdropColor;
        const d = me(c.backdropPadding);
        t.fillRect(-a / 2 - d.left, -n - u.size / 2 - d.top, a + d.width, u.size + d.height);
      }
      Bt(t, o.label, 0, -n, u, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
I(fi, "id", "radialLinear"), I(fi, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Cr.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(e) {
      return e;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), I(fi, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), I(fi, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const Tr = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, Ce = /* @__PURE__ */ Object.keys(Tr);
function Ja(e, t) {
  return e - t;
}
function _a(e, t) {
  if (z(t))
    return null;
  const i = e._adapter, { parser: r, round: s, isoWeekday: n } = e._parseOpts;
  let a = t;
  return typeof r == "function" && (a = r(a)), ie(a) || (a = typeof r == "string" ? i.parse(a, r) : i.parse(a)), a === null ? null : (s && (a = s === "week" && (Gt(n) || n === !0) ? i.startOf(a, "isoWeek", n) : i.startOf(a, s)), +a);
}
function $a(e, t, i, r) {
  const s = Ce.length;
  for (let n = Ce.indexOf(e); n < s - 1; ++n) {
    const a = Tr[Ce[n]], o = a.steps ? a.steps : Number.MAX_SAFE_INTEGER;
    if (a.common && Math.ceil((i - t) / (o * a.size)) <= r)
      return Ce[n];
  }
  return Ce[s - 1];
}
function Om(e, t, i, r, s) {
  for (let n = Ce.length - 1; n >= Ce.indexOf(i); n--) {
    const a = Ce[n];
    if (Tr[a].common && e._adapter.diff(s, r, a) >= t - 1)
      return a;
  }
  return Ce[i ? Ce.indexOf(i) : 0];
}
function Bm(e) {
  for (let t = Ce.indexOf(e) + 1, i = Ce.length; t < i; ++t)
    if (Tr[Ce[t]].common)
      return Ce[t];
}
function eo(e, t, i) {
  if (!i)
    e[t] = !0;
  else if (i.length) {
    const { lo: r, hi: s } = Xs(i, t), n = i[r] >= t ? i[r] : i[s];
    e[n] = !0;
  }
}
function Mm(e, t, i, r) {
  const s = e._adapter, n = +s.startOf(t[0].value, r), a = t[t.length - 1].value;
  let o, l;
  for (o = n; o <= a; o = +s.add(o, 1, r))
    l = i[o], l >= 0 && (t[l].major = !0);
  return t;
}
function to(e, t, i) {
  const r = [], s = {}, n = t.length;
  let a, o;
  for (a = 0; a < n; ++a)
    o = t[a], s[o] = a, r.push({
      value: o,
      major: !1
    });
  return n === 0 || !i ? r : Mm(e, r, s, i);
}
class Pi extends Rt {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, i = {}) {
    const r = t.time || (t.time = {}), s = this._adapter = new Hh._date(t.adapters.date);
    s.init(i), mi(r.displayFormats, s.formats()), this._parseOpts = {
      parser: r.parser,
      round: r.round,
      isoWeekday: r.isoWeekday
    }, super.init(t), this._normalized = i.normalized;
  }
  parse(t, i) {
    return t === void 0 ? null : _a(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, i = this._adapter, r = t.time.unit || "day";
    let { min: s, max: n, minDefined: a, maxDefined: o } = this.getUserBounds();
    function l(c) {
      !a && !isNaN(c.min) && (s = Math.min(s, c.min)), !o && !isNaN(c.max) && (n = Math.max(n, c.max));
    }
    (!a || !o) && (l(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && l(this.getMinMax(!1))), s = ie(s) && !isNaN(s) ? s : +i.startOf(Date.now(), r), n = ie(n) && !isNaN(n) ? n : +i.endOf(Date.now(), r) + 1, this.min = Math.min(s, n - 1), this.max = Math.max(s + 1, n);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let i = Number.POSITIVE_INFINITY, r = Number.NEGATIVE_INFINITY;
    return t.length && (i = t[0], r = t[t.length - 1]), {
      min: i,
      max: r
    };
  }
  buildTicks() {
    const t = this.options, i = t.time, r = t.ticks, s = r.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && s.length && (this.min = this._userMin || s[0], this.max = this._userMax || s[s.length - 1]);
    const n = this.min, a = this.max, o = dd(s, n, a);
    return this._unit = i.unit || (r.autoSkip ? $a(i.minUnit, this.min, this.max, this._getLabelCapacity(n)) : Om(this, o.length, i.minUnit, this.min, this.max)), this._majorUnit = !r.major.enabled || this._unit === "year" ? void 0 : Bm(this._unit), this.initOffsets(s), t.reverse && o.reverse(), to(this, o, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let i = 0, r = 0, s, n;
    this.options.offset && t.length && (s = this.getDecimalForValue(t[0]), t.length === 1 ? i = 1 - s : i = (this.getDecimalForValue(t[1]) - s) / 2, n = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? r = n : r = (n - this.getDecimalForValue(t[t.length - 2])) / 2);
    const a = t.length < 3 ? 0.5 : 0.25;
    i = le(i, 0, a), r = le(r, 0, a), this._offsets = {
      start: i,
      end: r,
      factor: 1 / (i + 1 + r)
    };
  }
  _generate() {
    const t = this._adapter, i = this.min, r = this.max, s = this.options, n = s.time, a = n.unit || $a(n.minUnit, i, r, this._getLabelCapacity(i)), o = L(s.ticks.stepSize, 1), l = a === "week" ? n.isoWeekday : !1, c = Gt(l) || l === !0, u = {};
    let d = i, h, p;
    if (c && (d = +t.startOf(d, "isoWeek", l)), d = +t.startOf(d, c ? "day" : a), t.diff(r, i, a) > 1e5 * o)
      throw new Error(i + " and " + r + " are too far apart with stepSize of " + o + " " + a);
    const m = s.ticks.source === "data" && this.getDataTimestamps();
    for (h = d, p = 0; h < r; h = +t.add(h, o, a), p++)
      eo(u, h, m);
    return (h === r || s.bounds === "ticks" || p === 1) && eo(u, h, m), Object.keys(u).sort(Ja).map((g) => +g);
  }
  getLabelForValue(t) {
    const i = this._adapter, r = this.options.time;
    return r.tooltipFormat ? i.format(t, r.tooltipFormat) : i.format(t, r.displayFormats.datetime);
  }
  format(t, i) {
    const r = this.options.time.displayFormats, s = this._unit, n = i || r[s];
    return this._adapter.format(t, n);
  }
  _tickFormatFunction(t, i, r, s) {
    const n = this.options, a = n.ticks.callback;
    if (a)
      return K(a, [
        t,
        i,
        r
      ], this);
    const o = n.time.displayFormats, l = this._unit, c = this._majorUnit, u = l && o[l], d = c && o[c], h = r[i], p = c && d && h && h.major;
    return this._adapter.format(t, s || (p ? d : u));
  }
  generateTickLabels(t) {
    let i, r, s;
    for (i = 0, r = t.length; i < r; ++i)
      s = t[i], s.label = this._tickFormatFunction(s.value, i, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const i = this._offsets, r = this.getDecimalForValue(t);
    return this.getPixelForDecimal((i.start + r) * i.factor);
  }
  getValueForPixel(t) {
    const i = this._offsets, r = this.getDecimalForPixel(t) / i.factor - i.end;
    return this.min + r * (this.max - this.min);
  }
  _getLabelSize(t) {
    const i = this.options.ticks, r = this.ctx.measureText(t).width, s = Le(this.isHorizontal() ? i.maxRotation : i.minRotation), n = Math.cos(s), a = Math.sin(s), o = this._resolveTickFontOptions(0).size;
    return {
      w: r * n + o * a,
      h: r * a + o * n
    };
  }
  _getLabelCapacity(t) {
    const i = this.options.time, r = i.displayFormats, s = r[i.unit] || r.millisecond, n = this._tickFormatFunction(t, 0, to(this, [
      t
    ], this._majorUnit), s), a = this._getLabelSize(n), o = Math.floor(this.isHorizontal() ? this.width / a.w : this.height / a.h) - 1;
    return o > 0 ? o : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], i, r;
    if (t.length)
      return t;
    const s = this.getMatchingVisibleMetas();
    if (this._normalized && s.length)
      return this._cache.data = s[0].controller.getAllParsedValues(this);
    for (i = 0, r = s.length; i < r; ++i)
      t = t.concat(s[i].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let i, r;
    if (t.length)
      return t;
    const s = this.getLabels();
    for (i = 0, r = s.length; i < r; ++i)
      t.push(_a(this, s[i]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return ll(t.sort(Ja));
  }
}
I(Pi, "id", "time"), I(Pi, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function er(e, t, i) {
  let r = 0, s = e.length - 1, n, a, o, l;
  i ? (t >= e[r].pos && t <= e[s].pos && ({ lo: r, hi: s } = tt(e, "pos", t)), { pos: n, time: o } = e[r], { pos: a, time: l } = e[s]) : (t >= e[r].time && t <= e[s].time && ({ lo: r, hi: s } = tt(e, "time", t)), { time: n, pos: o } = e[r], { time: a, pos: l } = e[s]);
  const c = a - n;
  return c ? o + (l - o) * (t - n) / c : o;
}
class Rs extends Pi {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), i = this._table = this.buildLookupTable(t);
    this._minPos = er(i, this.min), this._tableRange = er(i, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: i, max: r } = this, s = [], n = [];
    let a, o, l, c, u;
    for (a = 0, o = t.length; a < o; ++a)
      c = t[a], c >= i && c <= r && s.push(c);
    if (s.length < 2)
      return [
        {
          time: i,
          pos: 0
        },
        {
          time: r,
          pos: 1
        }
      ];
    for (a = 0, o = s.length; a < o; ++a)
      u = s[a + 1], l = s[a - 1], c = s[a], Math.round((u + l) / 2) !== c && n.push({
        time: c,
        pos: a / (o - 1)
      });
    return n;
  }
  _generate() {
    const t = this.min, i = this.max;
    let r = super.getDataTimestamps();
    return (!r.includes(t) || !r.length) && r.splice(0, 0, t), (!r.includes(i) || r.length === 1) && r.push(i), r.sort((s, n) => s - n);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const i = this.getDataTimestamps(), r = this.getLabelTimestamps();
    return i.length && r.length ? t = this.normalize(i.concat(r)) : t = i.length ? i : r, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (er(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const i = this._offsets, r = this.getDecimalForPixel(t) / i.factor - i.end;
    return er(this._table, r * this._tableRange + this._minPos, !0);
  }
}
I(Rs, "id", "timeseries"), I(Rs, "defaults", Pi.defaults);
var Rm = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: Ts,
  LinearScale: Os,
  LogarithmicScale: Bs,
  RadialLinearScale: fi,
  TimeScale: Pi,
  TimeSeriesScale: Rs
});
const Em = [
  qh,
  gf,
  um,
  Rm
];
Ne.register(...Em);
f({
  name: "BarChart",
  props: {
    data: {
      type: Object,
      required: !0
    },
    legendPosition: {
      type: String
    }
  },
  mounted() {
    const e = this.$refs["bar-chart"];
    new Ne(e, {
      type: "bar",
      data: this.data,
      options: this.chartOptions
    });
  },
  computed: {
    showLegend() {
      return !!this.legendPosition;
    },
    chartOptions() {
      return {
        indexAxis: "y",
        // Elements options apply to all the options unless overridden in a dataset
        // In this case, we are setting the border of each horizontal bar to be 2px wide
        elements: {
          bar: {
            borderWidth: 2
          }
        },
        responsive: !0,
        plugins: {
          legend: {
            display: this.showLegend,
            position: this.legendPosition
          },
          title: {
            display: !1
          }
        }
      };
    }
  }
});
function x(e, t, i, r, s, n, a, o) {
  var l = typeof e == "function" ? e.options : e;
  return t && (l.render = t, l.staticRenderFns = i, l._compiled = !0), n && (l._scopeId = "data-v-" + n), {
    exports: e,
    options: l
  };
}
f({
  name: "LineChart",
  props: {
    data: {
      type: Object,
      required: !0
    },
    fillLine: {
      type: Boolean,
      required: !1
    },
    legendPosition: {
      type: String,
      required: !1
    }
  },
  mounted() {
    const e = this.$refs["line-chart"];
    new Ne(e, {
      type: "line",
      data: this.data,
      options: this.chartOptions
    });
  },
  computed: {
    showLegend() {
      return !!this.legendPosition;
    },
    chartOptions() {
      return {
        // Elements options apply to all the options unless overridden in a dataset
        // In this case, we are setting the border of each horizontal bar to be 2px wide
        elements: {
          bar: {
            borderWidth: 2
          },
          point: {
            pointStyle: this.fillLine ? !1 : "circle"
          },
          line: {
            fill: this.fillLine
          }
        },
        responsive: !0,
        plugins: {
          legend: {
            display: this.showLegend,
            position: this.legendPosition
          },
          filler: {
            propagate: !0
          },
          title: {
            display: !1
          }
        }
      };
    }
  }
});
const Lm = f({
  props: {
    value: {
      type: Boolean,
      required: !0
    }
  },
  computed: {
    faIcon() {
      return this.value ? "fa-regular fa-window-restore" : "fa-regular fa-arrow-up-right-from-square";
    }
  },
  methods: {
    onClickExpand() {
      this.$emit("input", !this.value);
    },
    onClickClose() {
      this.$emit("chat-close");
    }
  }
});
var Fm = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-chat-header" }, [t("img", { staticClass: "rready-ai-logo", attrs: { src: "/img/rready-ai-logo.svg", alt: "rreadyAI" } }), t("div", { staticClass: "spacer" }), t("app-icon-button", { attrs: { size: 26, padding: 2 }, on: { click: e.onClickExpand } }, [t("fa-icon-compat", { staticClass: "icon", attrs: { icon: e.faIcon } })], 1), t("app-icon-button", { staticClass: "icon", attrs: { size: 26, padding: 2 }, on: { click: e.onClickClose } }, [t("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1)], 1);
}, jm = [], Um = /* @__PURE__ */ x(
  Lm,
  Fm,
  jm,
  !1,
  null,
  "909cb2f9"
);
const qm = Um.exports, Hm = f({
  data() {
    return {
      input: ""
    };
  },
  computed: {
    sendEnabled() {
      return !!this.input.trim();
    }
  },
  methods: {
    onSendMessage() {
      const e = this.input.trim();
      e && (this.$emit("send-message", e), this.input = "");
    }
  }
});
var zm = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("base-input-text", { staticClass: "app-chat-input", on: { keydown: function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "enter", 13, i.key, "Enter") ? null : e.onSendMessage.apply(null, arguments);
  } }, scopedSlots: e._u([{ key: "end", fn: function() {
    return [t("app-icon-button", { attrs: { size: 26, padding: 0, enabled: e.sendEnabled }, on: { click: e.onSendMessage } }, [t("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-solid fa-circle-arrow-up" } })], 1)];
  }, proxy: !0 }]), model: { value: e.input, callback: function(i) {
    e.input = i;
  }, expression: "input" } });
}, Nm = [], Vm = /* @__PURE__ */ x(
  Hm,
  zm,
  Nm,
  !1,
  null,
  "6c556f78"
);
const Gm = Vm.exports, Wm = "/img/profile-placeholder.svg", Qm = f({
  props: {
    chatUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {};
  },
  computed: {
    avatarDecorator() {
      if (this.chatUser.ai)
        return "/img/rready-ai-icon-mini.png";
    },
    avatarImage() {
      return this.chatUser.avatar || Wm;
    },
    cssClass() {
      return {
        self: this.chatUser.self,
        other: !this.chatUser.self
      };
    }
  }
});
var Xm = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-chat-message-avatar", class: e.cssClass }, [e.avatarDecorator ? t("img", { staticClass: "ai-icon", attrs: { src: e.avatarDecorator } }) : e._e(), t("img", { staticClass: "avatar-image", attrs: { src: e.avatarImage } })]);
}, Km = [], Ym = /* @__PURE__ */ x(
  Qm,
  Xm,
  Km,
  !1,
  null,
  "657d920b"
);
const Zm = Ym.exports, Jm = f({
  props: {
    message: {
      type: Object,
      required: !0
    }
  }
});
var _m = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "chat-message-content" }, [t("span", [e._v(e._s(e.$t("aiChat.errorResponse")))])]);
}, $m = [], eg = /* @__PURE__ */ x(
  Jm,
  _m,
  $m,
  !1,
  null,
  "8485ce9a"
);
const tg = eg.exports, ig = f({
  props: {
    message: {
      type: Object,
      required: !0
    }
  }
});
var rg = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "chat-message-content" }, [t("span", [e._v(e._s(e.$t("aiChat.processingResponse")))]), t("app-bounce-loading", { staticClass: "app-bounce-loading" })], 1);
}, sg = [], ng = /* @__PURE__ */ x(
  ig,
  rg,
  sg,
  !1,
  null,
  "a0b2b61e"
);
const ag = ng.exports, og = f({
  props: {
    message: {
      type: Object,
      required: !0
    },
    actionType: {
      type: String,
      required: !0
    }
  },
  computed: {
    buttonText() {
      return this.actionType === "copy" ? this.$t("aiChat.buttonCopy").toString() : this.$t("aiChat.buttonApply").toString();
    }
  },
  methods: {
    onAcceptAction() {
      this.$emit("accept-action", { message: this.message });
    }
  }
});
var lg = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "chat-message-content" }, [t("div", { staticClass: "suggestions-label" }, [e._v(e._s(e.$t("aiChat.labelActions")))]), t("app-markdown-text", { attrs: { text: e.message.text } }), t("div", { staticClass: "chat-message-suggestion" }, [t("button", { staticClass: "apply-button", on: { click: e.onAcceptAction } }, [t("img", { attrs: { src: "/img/rready-ai-icon-mini.png" } }), e._v(" " + e._s(e.buttonText) + " ")])])], 1);
}, cg = [], ug = /* @__PURE__ */ x(
  og,
  lg,
  cg,
  !1,
  null,
  "9e89fefe"
);
const dg = ug.exports, hg = f({
  props: {
    message: {
      type: Object,
      required: !0
    }
  },
  computed: {
    suggestions() {
      var e;
      return ((e = this.message.suggestions) == null ? void 0 : e.filter(({ text: t }) => !!t)) || [];
    }
  },
  methods: {
    onSelectSuggestion(e) {
      this.$emit("select-suggestion", { message: this.message, index: e });
    }
  }
});
var pg = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "chat-message-content" }, [t("app-markdown-text", { attrs: { text: e.message.text } }), e.suggestions.length ? t("div", { staticClass: "chat-message-suggestion" }, [t("div", { staticClass: "suggestions-label" }, [e._v(e._s(e.$t("aiChat.labelSuggestions")))]), e._l(e.suggestions, function(i, r) {
    return t("div", { key: r }, [t("button", { staticClass: "suggestion-button", on: { click: function(s) {
      return e.onSelectSuggestion(r);
    } } }, [e._v(" " + e._s(i.text) + " ")])]);
  })], 2) : e._e()], 1);
}, fg = [], mg = /* @__PURE__ */ x(
  hg,
  pg,
  fg,
  !1,
  null,
  "d00c8ff7"
);
const gg = mg.exports, yg = f({
  components: {
    ChatMessageAvatar: Zm,
    ChatMessageContentError: tg,
    ChatMessageContentLoading: ag,
    ChatMessageContentText: gg,
    ChatMessageContentAction: dg
  },
  props: {
    message: {
      type: Object,
      required: !0
    }
  },
  computed: {
    cssClass() {
      return {
        self: this.message.owner.self,
        other: !this.message.owner.self
      };
    }
  }
});
var bg = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-chat-message", class: e.cssClass }, [e.message.status === "loading" ? t("chat-message-content-loading", { staticClass: "message-content", attrs: { message: e.message } }) : e.message.status === "error" ? t("chat-message-content-error", { staticClass: "message-content", attrs: { message: e.message } }) : ["action", "copy"].includes(e.message.template) ? t("chat-message-content-action", e._g({ staticClass: "message-content", attrs: { message: e.message, "action-type": e.message.template } }, e.$listeners)) : e.message.template === "text" ? t("chat-message-content-text", e._g({ staticClass: "message-content", attrs: { message: e.message } }, e.$listeners)) : e._e(), t("chat-message-avatar", { attrs: { "chat-user": e.message.owner } })], 1);
}, vg = [], Ag = /* @__PURE__ */ x(
  yg,
  bg,
  vg,
  !1,
  null,
  "302403d2"
);
const kg = Ag.exports, wg = f({
  components: {
    ChatMessage: kg
  },
  mounted() {
    this.$el.scrollTo(0, this.$el.scrollHeight);
  },
  props: {
    messages: {
      type: Array,
      required: !0
    }
  },
  watch: {
    messages: {
      handler() {
        pt(() => {
          this.$el.scrollTo({ top: this.$el.scrollHeight, behavior: "smooth" });
        });
      },
      deep: !0
    }
  }
});
var xg = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "chat-tab" }, [t("div", { staticClass: "flex-trick" }), e._l(e.messages, function(i, r) {
    return t("chat-message", e._g({ key: r, attrs: { message: i } }, e.$listeners));
  })], 2);
}, Cg = [], Sg = /* @__PURE__ */ x(
  wg,
  xg,
  Cg,
  !1,
  null,
  "bd924d5b"
);
const Ig = Sg.exports;
f({
  components: {
    ChatHeader: qm,
    ChatInput: Gm,
    ChatTab: Ig
  },
  props: {
    sessions: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      expanded: !1,
      currentTab: ""
    };
  },
  created() {
    var e;
    this.currentTab = ((e = this.sessions) == null ? void 0 : e[0].key) ?? "";
  },
  watch: {
    expanded(e) {
      this.$emit("chat-expand-toggle", e);
    }
  },
  computed: {
    tabOptions() {
      return this.sessions.map((e) => ({
        tabKey: e.key,
        label: e.title
      }));
    },
    currentSession() {
      return this.sessions.find((e) => e.key === this.currentTab);
    },
    messages() {
      var e;
      return ((e = this.currentSession) == null ? void 0 : e.messages) ?? [];
    }
  },
  methods: {
    onSendMessage(e) {
      this.$emit("send-message", {
        sessionKey: this.currentTab,
        text: e
      });
    },
    onSelectSuggestion(e) {
      this.$emit("select-suggestion", {
        sessionKey: this.currentTab,
        message: e.message,
        suggestionIndex: e.index
      });
    },
    onAcceptAction(e) {
      this.$emit("accept-action", {
        sessionKey: this.currentTab,
        message: e.message
      });
    },
    onClickClose() {
      this.$emit("chat-close");
    }
  }
});
var Dg = 5, Pg = function(e, t) {
  return Promise.resolve(e.amountStarted < t.length);
}, Tg = { maxInProgress: Dg, failFast: !1, nextCheck: Pg, ignoreIsFunctionCheck: !1 };
function Og(e, t) {
  return new Promise(function(i, r) {
    var s = Object.assign({}, Tg, t), n = { amountDone: 0, amountStarted: 0, amountResolved: 0, amountRejected: 0, amountNextCheckFalsey: 0, rejectedIndexes: [], resolvedIndexes: [], nextCheckFalseyIndexes: [], taskResults: [] };
    if (e.length === 0) return i(n);
    for (var a = !1, o = 0, l = function() {
      if (a !== !0) {
        if (n.amountDone++, typeof s.progressCallback == "function" && s.progressCallback(n), n.amountDone === e.length) return i(n);
        o < e.length && c(o++);
      }
    }, c = function(d) {
      s.nextCheck(n, e).then(function(h) {
        h === !0 ? function(p) {
          if (n.amountStarted++, typeof e[p] == "function") e[p]().then(function(m) {
            n.taskResults[p] = m, n.resolvedIndexes.push(p), n.amountResolved++, l();
          }, function(m) {
            if (n.taskResults[p] = m, n.rejectedIndexes.push(p), n.amountRejected++, s.failFast === !0) return a = !0, r(n);
            l();
          });
          else {
            if (s.ignoreIsFunctionCheck !== !0) return a = !0, r(new Error("tasks[" + p + "]: " + e[p] + ", is supposed to be of type function"));
            n.taskResults[p] = e[p], n.resolvedIndexes.push(p), n.amountResolved++, l();
          }
        }(d) : (n.amountNextCheckFalsey++, n.nextCheckFalseyIndexes.push(d), l());
      }, r);
    }, u = 0; u < Math.min(s.maxInProgress, e.length); u++) c(o++);
  });
}
function Bg(e, t) {
  return new Promise(function(i, r) {
    Og(e, t).then(function(s) {
      i(s.taskResults);
    }, function(s) {
      s instanceof Error ? r(s) : r(s.taskResults[s.rejectedIndexes[0]]);
    });
  });
}
function Mg(e, t) {
  return Bg(e, Object.assign({}, { failFast: !0 }, t));
}
const ss = 5 * 1024 * 1024, Rg = 3;
function Eg(e) {
  const t = Math.ceil(e.size / ss), i = [];
  for (let r = 0; r < t; r += 1) {
    const s = r * ss, n = Math.min(s + ss, e.size);
    i.push({
      file: e,
      partNumber: r + 1,
      getSlice: () => e.slice(s, n, e.type)
    });
  }
  return i;
}
function Lg(e, t) {
  const i = N("IDLE"), r = N(0), s = N(0), n = N(null), a = async (c, u, d) => {
    const h = await e.getSignedUrl("ticket", {
      key: c,
      uploadId: u,
      contentType: d.file.type,
      partNumber: d.partNumber
    });
    s.value += 1;
    const p = await fetch(h, {
      method: "PUT",
      body: d.getSlice()
    });
    return s.value += 1, p.headers.get("etag") ?? "";
  }, o = async (c, u) => {
    try {
      i.value = "IN_PROGRESS";
      const d = Eg(c);
      r.value = 2 + d.length * 2;
      const h = await e.start("ticket", t, {
        contentType: c.type,
        contentDisposition: `attachment; filename="${c.name}"`
      });
      s.value += 1;
      const { key: p } = h, { uploadId: m } = h, g = d.map(
        (w) => () => a(p, m, w)
      ), y = await Mg(g, {
        maxInProgress: Rg,
        failFast: !0
      }), v = await e.stop("ticket", t, {
        key: p,
        uploadId: m,
        contentType: c.type,
        parts: y,
        category: u,
        originalFilename: c.name
      });
      s.value += 1, i.value = "SUCCESS", n.value = v.file;
    } catch (d) {
      console.error(`Could not upload file '${c.name}'`, d), i.value = "ERROR";
    }
  }, l = Q(
    () => r.value ? s.value / r.value : 0
  );
  return { upload: o, status: i, progress: l, result: n };
}
function Fg() {
  return { getUserReference: (e) => {
    const t = e.split(":");
    if (t.length !== 4) {
      console.warn(
        "Malformed canonical string. Expected format: context:entity:key:value"
      );
      return;
    }
    const [i, r, s, n] = t;
    if (r !== "user") {
      console.warn(`Unsupported entity: ${r}. Only 'user' is supported.`);
      return;
    }
    if (!i || !s || !n) {
      console.warn("Missing context, key, or value in the canonical string.");
      return;
    }
    return {
      context: i,
      entity: r,
      key: s,
      value: n
    };
  }, referenceToCanonical: (e) => {
    const { context: t, entity: i, key: r, value: s } = e;
    if (!t || !i || !r || !s) {
      console.warn(
        "Incomplete reference. Expected all fields to be non-empty."
      );
      return;
    }
    return `${t}:${i}:${r}:${s}`;
  } };
}
function jg(e, t) {
  return t.reduce((i, r) => (i == null ? void 0 : i[r]) ?? null, e);
}
function Ug(e, t) {
  const i = /* @__PURE__ */ new Map();
  for (const r of e) {
    const s = jg(r, t);
    typeof s != "string" ? console.warn("Data grouping must use 'string' values", { groupKey: s }) : i.has(s) ? i.get(s).push(r) : i.set(s, [r]);
  }
  return i;
}
function _l(e, t, i) {
  const r = Nt(i), s = Q(() => {
    const o = Ug(Nt(e), Nt(t));
    return r.reduce((l, c) => (l[c] = o.get(c) ?? [], l), {});
  }), n = Q(() => r), a = Q(
    () => r.filter((o) => {
      var l;
      return ((l = s.value[o]) == null ? void 0 : l.length) > 0;
    })
  );
  return { groupedData: s, groups: n, nonEmptyGroups: a };
}
function qg(e) {
  const t = N(""), i = N(""), r = Q(() => {
    if (!(!t.value || !i.value))
      return {
        field: t.value,
        direction: i.value
      };
  }), s = () => {
    i.value === "ASC" ? i.value = "DESC" : i.value === "DESC" ? i.value = "" : i.value = "ASC";
  };
  return { sortStatus: r, toggleSort: (n) => {
    t.value === n ? s() : (t.value = n, i.value = "ASC");
  } };
}
function Or(e, t) {
  const i = N(e), r = N(t), s = Q(() => i.value.length), n = Q(
    () => r.value.reduce((o, l) => {
      const c = i.value.some((u) => u.id === l) ? 1 : 0;
      return o + c;
    }, 0)
  ), a = Q(() => n.value === 0 ? "no" : i.value.some((o) => !r.value.includes(o.id)) ? "partial" : "yes");
  return {
    countFound: s,
    countSelected: n,
    selection: r,
    selectionStatus: a,
    itemStatus: (o) => r.value.includes(o) ? "yes" : "no",
    toggleAll: () => {
      a.value === "yes" ? r.value = [] : r.value = i.value.map((o) => o.id);
    },
    toggleItem: (o) => {
      if (r.value === void 0) {
        console.warn("Error selecting item, no selection array provided");
        return;
      }
      const l = r.value.indexOf(o);
      if (l === -1)
        r.value = [o, ...r.value];
      else {
        const c = [...r.value];
        c.splice(l, 1), r.value = c;
      }
    }
  };
}
function $l() {
  const e = Yc("maxFileUploadSize", 52428800), t = Q(
    () => (
      // Default 50MB
      e ?? 52428800
    )
  ), i = (s) => {
    const n = ["Bytes", "KB", "MB", "GB", "TB"];
    if (s === 0) return "0 Byte";
    const a = Math.floor(Math.log(s) / Math.log(1024));
    return `${parseFloat((s / 1024 ** a).toFixed(2))} ${n[a]}`;
  }, r = Q(
    () => i(t.value)
  );
  return {
    allowFileSize: (s) => !t.value || s.size <= t.value,
    bytesToReadableValue: i,
    maxFileUploadSize: t,
    readableMaxFileUploadSize: r
  };
}
function ec(e, t, i) {
  const r = Q(
    () => i.includes("ADMIN_TICKET_USER_FIELD_LIST")
  ), s = Q(
    () => t.value && r.value ? Nt(t) : Nt(e)
  ), n = (l, c) => {
    var u;
    return s.value ? (u = s.value) != null && u.audience ? i.includes(c) : i.includes(l) : !1;
  }, a = Q(
    () => n("USER_TICKET_USER_FIELD_LIST", "ADMIN_TICKET_USER_FIELD_LIST")
  ), o = Q(
    () => n(
      "USER_TICKET_USER_FIELD_WRITE_OWN",
      "ADMIN_TICKET_USER_FIELD_WRITE_OWN"
    )
  );
  return {
    firstCitizen: s,
    hasFirstCitizenReadPermission: a,
    hasFirstCitizenWritePermission: o
  };
}
const Hg = /{\s*[\w.]+\s*}/g, zg = /{{\s*[\w.]+\s*}}/g, io = /[\w.]+/;
function Ng(e, t) {
  const i = e.split(".");
  let r = t;
  for (const s of i)
    if (r = r[s], !r)
      return;
  return r;
}
function Vg(e, t) {
  const i = { mustache: "double", ...t }.mustache === "single" ? Hg : zg, r = e.match(i) ?? [];
  return { replace: (s) => {
    let n = e;
    return r.forEach((a) => {
      var o;
      const l = (o = a == null ? void 0 : a.match(io)) == null ? void 0 : o[0], c = l ? s[l] : void 0;
      c !== void 0 && (n = n.replace(a, c));
    }), n;
  }, replaceNested: (s) => {
    let n = e;
    return r.forEach((a) => {
      var o;
      const l = (o = a == null ? void 0 : a.match(io)) == null ? void 0 : o[0], c = l ? Ng(l, s) : void 0;
      c !== void 0 && typeof c == "string" && (n = n.replace(a, c));
    }), n;
  } };
}
function Gg(e, t) {
  const i = Q(() => e.value.filter((n) => !n.groupKey)), r = Q(
    () => t.value.filter((n) => e.value.find((a) => a.groupKey === n.key))
  ), s = Q(() => r.value.length > 0);
  return { ungrouped: i, nonEmptyGroups: r, hasGroups: s, groupedItems: (n) => e.value.filter((a) => a.groupKey === n.key) };
}
function Ge(e, t = ["main"]) {
  const i = e.enabledProducts.map((n) => ({
    productId: n,
    productType: "main",
    customization: e.productCustomization[n]
  })).filter(
    (n) => t.includes(n.productType)
  ), r = Q(() => i), s = Q(() => i.map((n) => n.productId));
  return { productsData: r, productIds: s, _allProductIds: () => (console.log("[DEPRECATED] _allProductIds"), [
    ...s.value,
    "task",
    "feedback",
    "service_order",
    "campaign"
  ]) };
}
function Kt(e) {
  var t, i, r;
  const s = (t = e.product) == null ? void 0 : t.icons, n = (i = e.product) == null ? void 0 : i.resources, a = (r = e.product) == null ? void 0 : r.ticketCard;
  return s || console.error("workflow.product?.icons cannot be empty"), n || console.error("workflow.product?.resources cannot be empty"), a || console.error("workflow.product?.ticketCard cannot be empty"), { resources: n, icons: s, ticketCard: a };
}
function an(e, t) {
  var i, r;
  const s = (r = (i = e == null ? void 0 : e.site) == null ? void 0 : i[t]) == null ? void 0 : r.views;
  function n(a) {
    return s == null ? void 0 : s[a];
  }
  return { page: n };
}
function Br(e, t) {
  const i = (n) => n.roles ? n.roles.some(
    (a) => {
      var o;
      return (o = t.userRoles) == null ? void 0 : o.includes(a);
    }
  ) : !0, r = (n) => n.actions ? n.actions.every(
    (a) => {
      var o;
      return (o = t.userActions) == null ? void 0 : o.includes(a);
    }
  ) : !0, s = (n) => !!(!n.actor || n.actor.includes("creator") && t.userId === t.creatorId || n.actor.includes("assignee") && t.userId === t.assigneeId);
  return {
    accessGranted: !e.length || e.some(
      (n) => i(n) && r(n) && s(n)
    ),
    checkActionAccess: r,
    checkActorAccess: s,
    checkRoleAccess: i
  };
}
function tc(e, t, i) {
  const r = t.settings[i];
  if (!r) {
    console.warn(`Could not find ${i} '${e}'`);
    return;
  }
  return i === "phases" ? r.find(
    (s) => e === s.name
  ) : r == null ? void 0 : r[e];
}
function J(e, t, i = "status") {
  const r = tc(e, t, i);
  return r == null ? void 0 : r.resources;
}
function Bi(e, t, i = "status") {
  var r;
  const s = tc(e, t, i);
  return ((r = s == null ? void 0 : s.settings) == null ? void 0 : r.colour) || void 0;
}
function B(e) {
  const t = () => {
    const { firstName: a, lastName: o } = e.user;
    return a && o ? `${a} ${o}`.trim() : a ?? o ?? "";
  }, i = () => {
    const a = r();
    return a ? `https://teams.microsoft.com/l/chat/0/0?users=${a}` : void 0;
  }, r = () => e.user.email ? e.user.email : void 0, s = () => {
    var a;
    return ((a = e.team) == null ? void 0 : a.name) ?? e.user.departmentName;
  }, n = (a) => {
    const o = (l) => l.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/_/g, " ").split(" ").map(
      (c) => c.charAt(0).toUpperCase() + c.slice(1).toLowerCase()
    ).join(" ");
    return Object.entries(a).map(([l, c]) => ({
      label: o(l),
      value: c
    }));
  };
  return {
    displayName: t,
    microsoftTeamsLink: i,
    userDepartment: s,
    displayEmail: r,
    getPublicSettings: () => n(e.user.public ?? {}),
    getPrivateSettings: () => n(e.user.private ?? {})
  };
}
function Be(e, t) {
  return {
    teamName: () => {
      var i, r;
      return !e.resources || !Object.keys(e.resources).length ? e.name : (i = t(e.resources)) != null && i.name ? (r = t(e.resources)) == null ? void 0 : r.name : e.name;
    },
    teamDescription: () => {
      var i, r;
      return !e.resources || !Object.keys(e.resources).length ? e.description : (i = t(e.resources)) != null && i.description ? (r = t(e.resources)) == null ? void 0 : r.description : e.description;
    }
  };
}
function Wg(e) {
  const t = e.settings.mailCoachingPhase ?? [], i = e.settings.disableTimeline ?? [], r = e.settings.creationStatus, s = e.settings.deleteStatus ?? [], n = Object.keys(e.settings.status).filter((a) => a !== r).filter((a) => !s.includes(a));
  return { mailCoachingPhase: t, disableTimeline: i, activeStatus: n };
}
function Qg(e) {
  const t = N(""), i = Q(
    () => {
      var n, a;
      return (a = (n = e.settings) == null ? void 0 : n.status) == null ? void 0 : a[t.value];
    }
  ), r = Q(
    () => {
      var n;
      return ((n = e.transitions) == null ? void 0 : n.filter(
        (a) => a.transitionFrom === t.value
      )) ?? [];
    }
  ), s = Q(() => {
    var n, a;
    const o = (a = (n = i.value) == null ? void 0 : n.settings) == null ? void 0 : a.preferredNext;
    return r.value.find((l) => l.transitionTo === o);
  });
  return { fromStatus: t, available: r, preferred: s };
}
const Xg = [
  "length",
  "mass",
  "volume",
  "temperature",
  "currency"
], Kg = [
  "meter",
  "centimeter",
  "millimeter",
  "kilometer",
  "mile",
  "yard",
  "foot",
  "inch"
], Yg = [
  "kilogram",
  "gram",
  "milligram",
  "tonne",
  "ounce",
  "pound"
], Zg = [
  "cubic-meter",
  "liter",
  "milliliter",
  "us-fluid-ounce",
  "us-gallon",
  "us-pint"
], Jg = [
  "kelvin",
  "celsius",
  "fahrenheit",
  "rankine"
], _g = [
  "us-dollar",
  "euro",
  "japanese-yen",
  "british-pound-sterling",
  "australian-dollar",
  "canadian-dollar",
  "swiss-franc",
  "chinese-yuan-renminbi",
  "hong-kong-dollar",
  "new-zealand-dollar",
  "swedish-krona",
  "south-korean-won",
  "singapore-dollar",
  "norwegian-krone",
  "mexican-peso",
  "indian-rupee",
  "russian-ruble",
  "south-african-rand",
  "brazilian-real",
  "turkish-lira"
], $g = {
  length: Kg,
  mass: Yg,
  volume: Zg,
  temperature: Jg,
  currency: _g
}, ey = {
  meter: {
    dimension: "length",
    system: "si",
    unit: "meter",
    symbol: "m",
    convert: {
      fromBase: (e) => e,
      toBase: (e) => e
    }
  },
  centimeter: {
    dimension: "length",
    system: "si",
    unit: "centimeter",
    symbol: "cm",
    convert: {
      fromBase: (e) => e * 100,
      toBase: (e) => e * 0.01
    }
  },
  millimeter: {
    dimension: "length",
    system: "si",
    unit: "millimeter",
    symbol: "mm",
    convert: {
      fromBase: (e) => e * 1e3,
      toBase: (e) => e * 1e-3
    }
  },
  kilometer: {
    dimension: "length",
    system: "si",
    unit: "kilometer",
    symbol: "km",
    convert: {
      fromBase: (e) => e * 1e-3,
      toBase: (e) => e * 1e3
    }
  },
  mile: {
    dimension: "length",
    system: "imperial",
    unit: "mile",
    symbol: "mi",
    convert: {
      fromBase: (e) => e * 6213712e-10,
      toBase: (e) => e * 1609.344
    }
  },
  yard: {
    dimension: "length",
    system: "imperial",
    unit: "yard",
    symbol: "yd",
    convert: {
      fromBase: (e) => e * 1.093613,
      toBase: (e) => e * 0.9144
    }
  },
  foot: {
    dimension: "length",
    system: "imperial",
    unit: "foot",
    symbol: "ft",
    convert: {
      fromBase: (e) => e * 3.28084,
      toBase: (e) => e * 0.3048
    }
  },
  inch: {
    dimension: "length",
    system: "imperial",
    unit: "inch",
    symbol: "in",
    convert: {
      fromBase: (e) => e * 39.37008,
      toBase: (e) => e * 0.0254
    }
  }
}, ty = {
  kilogram: {
    dimension: "mass",
    system: "si",
    unit: "kilogram",
    symbol: "kg",
    convert: {
      fromBase: (e) => e,
      toBase: (e) => e
    }
  },
  gram: {
    dimension: "mass",
    system: "si",
    unit: "gram",
    symbol: "g",
    convert: {
      fromBase: (e) => e * 1e3,
      toBase: (e) => e * 1e-3
    }
  },
  milligram: {
    dimension: "mass",
    system: "si",
    unit: "milligram",
    symbol: "mg",
    convert: {
      fromBase: (e) => e * 1e6,
      toBase: (e) => e * 1e-6
    }
  },
  tonne: {
    dimension: "mass",
    system: "si",
    unit: "tonne",
    symbol: "t",
    convert: {
      fromBase: (e) => e * 1e-3,
      toBase: (e) => e * 1e3
    }
  },
  ounce: {
    dimension: "mass",
    system: "imperial",
    unit: "ounce",
    symbol: "oz",
    convert: {
      fromBase: (e) => e * 35.27396,
      toBase: (e) => e * 0.02834952
    }
  },
  pound: {
    dimension: "mass",
    system: "imperial",
    unit: "pound",
    symbol: "lb",
    convert: {
      fromBase: (e) => e * 2.204623,
      toBase: (e) => e * 0.4535924
    }
  }
}, iy = {
  "cubic-meter": {
    dimension: "volume",
    system: "si",
    unit: "cubic-meter",
    symbol: "m³",
    convert: {
      fromBase: (e) => e,
      toBase: (e) => e
    }
  },
  liter: {
    dimension: "volume",
    system: "si",
    unit: "liter",
    symbol: "l",
    convert: {
      fromBase: (e) => e * 1e3,
      toBase: (e) => e * 1e-3
    }
  },
  milliliter: {
    dimension: "volume",
    system: "si",
    unit: "milliliter",
    symbol: "ml",
    convert: {
      fromBase: (e) => e * 1e6,
      toBase: (e) => e * 1e-6
    }
  },
  "us-fluid-ounce": {
    dimension: "volume",
    system: "us-customary",
    unit: "us-fluid-ounce",
    symbol: "fl oz",
    convert: {
      fromBase: (e) => e * 33814.13,
      toBase: (e) => e * 2957344e-11
    }
  },
  "us-gallon": {
    dimension: "volume",
    system: "us-customary",
    unit: "us-gallon",
    symbol: "gal",
    convert: {
      fromBase: (e) => e * 264.1729,
      toBase: (e) => e * 37854e-7
    }
  },
  "us-pint": {
    dimension: "volume",
    system: "us-customary",
    unit: "us-pint",
    symbol: "pt",
    convert: {
      fromBase: (e) => e * 2113.376,
      toBase: (e) => e * 4731765e-10
    }
  }
}, ry = {
  kelvin: {
    dimension: "temperature",
    system: void 0,
    unit: "kelvin",
    symbol: "K",
    convert: {
      fromBase: (e) => e,
      toBase: (e) => e
    }
  },
  celsius: {
    dimension: "temperature",
    system: "si",
    unit: "celsius",
    symbol: "°C",
    convert: {
      fromBase: (e) => e - 273.15,
      toBase: (e) => e + 273.15
    }
  },
  fahrenheit: {
    dimension: "temperature",
    system: "imperial",
    unit: "fahrenheit",
    symbol: "°F",
    convert: {
      fromBase: (e) => e * 9 / 5 - 459.67,
      toBase: (e) => 5 / 9 * (e + 459.67)
    }
  },
  rankine: {
    dimension: "temperature",
    system: void 0,
    unit: "rankine",
    symbol: "°R",
    convert: {
      fromBase: (e) => 9 / 5 * e,
      toBase: (e) => 5 / 9 * e
    }
  }
};
function sy(e) {
  switch (e) {
    case "length":
      return ey;
    case "mass":
      return ty;
    case "volume":
      return iy;
    case "temperature":
      return ry;
    default:
      throw new Error(`Unknown unit system '${e}'`);
  }
}
function ny(e, t, i) {
  const r = new Intl.NumberFormat(void 0, {
    style: "decimal",
    signDisplay: "auto",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(e.value);
  if (e.dimension === "currency")
    return `${t(`measure.unit.${e.unit}.symbol`)} ${r}`;
  const s = sy(e.dimension)[e.unit];
  return `${r} ${(s == null ? void 0 : s.symbol) ?? ""}`;
}
function ic(e) {
  var t;
  const i = e.settings.phases ?? [], r = Object.entries((t = e.settings) == null ? void 0 : t.status);
  function s(a) {
    return r.filter((o) => o[1].phase === a).map((o) => o[0]);
  }
  const n = [];
  return i.forEach((a) => {
    const o = s(a.name);
    o.length && n.push({
      phase: a.name,
      status: o
    });
  }), n;
}
function ay() {
  function e(s, n, a) {
    return s === n ? !0 : Math.abs(s - n) < a;
  }
  function t(s) {
    return Math.floor(s * 1e4) / 1e4;
  }
  function i(s, n = 100) {
    let a = s.reduce(
      (u, d) => u + d.share,
      0
    ), o = n - a, l = s.filter((u) => u.share === 0);
    if (o < 0 || e(o, 0, 0.01) && l.length > 0)
      return s.forEach((u) => {
        u.share = 0;
      }), i(s, n);
    l.length === 0 && o > 0 && (l = s);
    const c = o / l.length;
    if (l.forEach((u) => {
      u.share += t(c);
    }), !r(s, n)) {
      const u = s.reduce((h, p) => h + p.share, 0), d = (n - u) / s.length;
      s.forEach((h) => {
        h.share = t(h.share - d);
      });
    }
    return s;
  }
  function r(s, n) {
    const a = s.reduce((l, c) => l + c.share, 0), o = s.every((l) => l.share > 0);
    return a <= n && e(a, n, 0.01) && o;
  }
  return {
    distributeShares: i,
    checkShareDivide: r
  };
}
const oy = {
  type: "function",
  function: {
    name: "updateTicketField",
    description: "Updates one field of the current idea, returning which field key to update, which value and the reason why to update this field with this value",
    parameters: {
      type: "object",
      properties: {
        fieldKey: {
          type: "string",
          description: 'Json key to update, used in the full key format like "a.b.c"'
        },
        fieldValue: {
          type: "string",
          description: "Value to update the key with"
        },
        reason: {
          type: "string",
          description: 'Human readable explanation of this tool calling in the format: "Update {field} with {very short description of the value chosen and why}"'
        }
      },
      additionalProperties: !1,
      required: ["fieldKey", "fieldValue", "reason"]
    }
  },
  strict: !0
};
function ly(e, t, i) {
  if (!e || !t)
    return;
  const r = e.split(".");
  let s = t;
  for (let n = 0; n < r.length; n += 1) {
    const a = r[n];
    Object.hasOwn(s, a) || (s[a] = {}), n === r.length - 1 ? s[a] = i : s = s[a];
  }
}
const cy = (e, t) => {
  ly(e.fieldKey, t, e.fieldValue);
}, uy = {
  type: "function",
  function: {
    name: "suggestTicketImprovement",
    description: "Given a ticket and a set of similar or duplicate idea in the system, suggest a way to improve the idea to make it more likely to be accepted.",
    parameters: {
      type: "object",
      properties: {
        reason: {
          type: "string",
          description: "The text of the improvements to be made to my ticket. This should be a human readable text that explains what to change and why."
        }
      },
      additionalProperties: !1,
      required: ["improvementText"]
    }
  },
  strict: !0
}, dy = (e) => {
  navigator.clipboard.writeText(e.reason);
};
function hy(e) {
  const t = { ...e.meta, title: e.title };
  return t.title = t.title ?? "", t;
}
function py(e, t) {
  var i;
  return {
    key: e.ref,
    type: e.type,
    label: t(((i = e.options) == null ? void 0 : i.resources) ?? {}).label
  };
}
const fy = {
  updateTicketFieldDefinition: oy,
  suggestTicketImprovementDefinition: uy
}, my = {
  type: "object",
  properties: {
    answer: {
      type: "string"
    }
  },
  required: ["answer"],
  additionalProperties: !1
};
function gy(e) {
  return {
    id: e.id,
    name: B({ user: e }).displayName(),
    avatar: e.avatar,
    self: !0,
    ai: !1
  };
}
function rc(e, t) {
  const i = e(t.resources);
  return {
    id: t.id,
    name: i.label,
    avatar: t.avatarUrl,
    self: !1,
    ai: !0
  };
}
function yy(e, t) {
  const i = e(t.messages);
  return {
    owner: rc(e, t),
    text: i.message,
    suggestions: i.suggestedPrompts.map((r) => ({
      text: r.label
    })),
    template: "text",
    status: "ok",
    dateCreated: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function by(e, t) {
  var i, r, s, n;
  let a = ((i = t.message) == null ? void 0 : i.answer) ?? "";
  a = a && `${a}
`, (r = t.tools) == null || r.forEach((o) => {
    a += `- ${o.arguments.reason}
`;
  }), e.text = a, e.meta = { tools: t.tools }, (s = t.tools) != null && s.some(({ name: o }) => o === "updateTicketField") ? e.template = "action" : (n = t.tools) != null && n.some(({ name: o }) => o === "suggestTicketImprovement") ? e.template = "copy" : e.template = "text";
}
function ns(e, t, i, r, s, n) {
  const a = (c) => {
    const u = s.getContext(c), d = t(i.messages).prePrompt, { replaceNested: h } = Vg(d);
    return h(u);
  }, o = (c) => {
    const u = {
      role: "system",
      content: a(c.key)
    }, d = c.messages.map(
      (h) => ({
        role: h.owner.ai ? "assistant" : "user",
        content: h.text
      })
    );
    return [u, ...d];
  }, l = (c) => {
    const u = c.users.find((h) => h.self), d = c.users.find((h) => h.ai);
    return { sendMessage: async (h) => {
      const { pushMessage: p } = n;
      p(c.key, {
        owner: u,
        text: h,
        status: "ok",
        template: "text",
        dateCreated: (/* @__PURE__ */ new Date()).toISOString()
      });
      const m = o(c), g = i.functions.map((C) => C.type), y = Object.entries(fy).filter((C) => g.includes(C[0])).map((C) => C[1]), v = e.completePrompt(
        my,
        m,
        y
      ), w = {
        owner: d,
        text: "",
        status: "loading",
        template: "text",
        dateCreated: (/* @__PURE__ */ new Date()).toISOString()
      };
      setTimeout(async () => {
        p(c.key, w);
        try {
          const C = await v;
          by(w, C), w.status = "ok";
        } catch {
          w.status = "error";
        }
      }, 700);
    }, acceptAction: async (h, p) => {
      var m;
      const g = ((m = h.meta) == null ? void 0 : m.tools) ?? [], y = s.getContext(p);
      g.forEach((v) => {
        v.name === "updateTicketField" ? cy(
          v.arguments,
          y.ticketSource
        ) : v.name === "suggestTicketImprovement" && dy(
          v.arguments
        );
      }), s.contextUpdated();
    } };
  };
  return { createSession: (c) => {
    const u = gy(r), d = rc(t, i), h = {
      key: c,
      title: t(i.resources).label,
      users: [u, d],
      messages: [yy(t, i)]
    }, p = n.createSession(h);
    return l(p);
  }, openSession: (c) => {
    const u = n.loadSession(c);
    return l(u);
  }, hasSession: (c) => n.hasSession(c) };
}
const vy = f({
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    user: {
      type: Object,
      required: !0
    }
  },
  computed: {
    icon() {
      var e;
      return ((e = this.ticket.meta) == null ? void 0 : e.feedbackIcon) ?? "/img/review-icon.svg";
    },
    title() {
      return this.ticket.title;
    },
    subtitle() {
      return this.$t("common.byName", {
        name: B({ user: this.user }).displayName()
      }).toString();
    }
  }
});
var Ay = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "feedback-activity-card" }, [t("app-icon", { staticClass: "feedback-icon", attrs: { size: 33, src: e.icon, frame: "square" } }), t("div", { staticClass: "content" }, [t("div", { staticClass: "feedback-title" }, [e._v(e._s(e.title))]), t("div", { staticClass: "feedback-creator" }, [e._v(e._s(e.subtitle))])])], 1);
}, ky = [], wy = /* @__PURE__ */ x(
  vy,
  Ay,
  ky,
  !1,
  null,
  "7ae78c79"
);
const xy = wy.exports;
f({
  props: {
    tickets: {
      type: Array,
      required: !0
    },
    editMode: {
      type: Boolean,
      default: !1
    },
    productId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      showFeedbackResultModal: !1,
      feedbackTickets: [],
      selectedTicketId: ""
    };
  },
  watch: {
    tickets: {
      async handler() {
        this.getFeedbackTickets();
      },
      immediate: !0
    }
  },
  methods: {
    allowEdit(e) {
      return this.editMode && e.group !== "first_citizen";
    },
    async onButtonClick(e) {
      const t = this.tickets.find((s) => s.canonicalId === e);
      if (!t)
        return;
      if (!await this.$gateway.feedback.isFeedbackAllowed(
        t,
        this.currentUser.id
      )) {
        this.onViewResult({ ticketId: e });
        return;
      }
      const i = t.meta.feedbackDialogue, r = this.$res(i);
      this.$modal(t.meta["feedback-type"], r), this.$route.query.reload !== "false" && this.$router.replace({ query: { reload: "false" } });
    },
    onEditTicket({ ticketId: e }) {
      this.$emit("edit:feedback", e);
    },
    onDeleteTicket({ ticketId: e }) {
      this.$emit("delete:feedback", e);
    },
    onViewResult({ ticketId: e }) {
      this.showFeedbackResultModal = !0, this.selectedTicketId = e;
    },
    async getFeedbackTickets() {
      this.feedbackTickets = await Promise.all(
        this.tickets.map(async (e) => (e.allowFeedback = await this.$gateway.feedback.isFeedbackAllowed(
          e,
          this.currentUser.id
        ), e))
      );
    }
  }
});
f({
  props: {
    parentTicketId: {
      type: String,
      required: !0
    },
    tickets: {
      type: Array,
      required: !0
    },
    defaultTickets: {
      type: Array,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    allowCreation: {
      type: Boolean,
      default: !0
    },
    label: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      ticketList: this.tickets,
      showChoiceFeedbackModal: !1,
      showFeedbackFormModal: !1,
      selectedTicketId: "",
      selectedTicketType: "",
      showDeleteFeedbackModal: !1,
      deleteInProgress: !1
    };
  },
  methods: {
    choiceFeedbackType() {
      this.showChoiceFeedbackModal = !0;
    },
    editFeedbackTicket(e) {
      this.selectedTicketId = e, this.showFeedbackFormModal = !0;
    },
    newFeedbackTicket(e) {
      this.showChoiceFeedbackModal = !1, this.selectedTicketId = "", this.selectedTicketType = e, this.showFeedbackFormModal = !0;
    },
    markForDeletion(e) {
      this.selectedTicketId = e, this.showDeleteFeedbackModal = !0;
    },
    saveFeedbackTicket(e) {
      this.selectedTicketId ? this.ticketList = this.ticketList.map(
        (t) => t.canonicalId === this.selectedTicketId ? e : t
      ) : this.ticketList = [...this.ticketList, e], this.$emit("refresh"), this.closeFeedbackFormModal();
    },
    closeChoiceFeedbackModal() {
      this.selectedTicketId = "", this.selectedTicketType = "", this.showChoiceFeedbackModal = !1;
    },
    closeFeedbackFormModal() {
      this.selectedTicketId = "", this.selectedTicketType = "", this.showFeedbackFormModal = !1;
    },
    removeFeedbackTicket() {
      try {
        this.deleteInProgress = !0, this.$datasource.ticket.updateStatus(
          this.productId,
          this.selectedTicketId,
          "ARCHIVED"
        ), this.ticketList = this.ticketList.filter(
          (e) => e.canonicalId !== this.selectedTicketId
        );
      } catch (e) {
        e.message ? this.$toast(e.message) : this.$toast(this.$t("error.general").toString());
      } finally {
        this.deleteInProgress = !1, this.showDeleteFeedbackModal = !1, this.selectedTicketId = "";
      }
      this.$emit("refresh");
    }
  }
});
f({
  name: "FeedbackSelectionModal",
  props: {
    parentTicketId: {
      type: String,
      required: !0
    },
    ticketId: {
      type: String,
      required: !1
    },
    ticketType: {
      type: String,
      required: !1
    },
    organization: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      ticket: {},
      type: "",
      form: {
        title: "",
        text: "",
        delegate: []
      },
      error: {
        title: !1,
        text: !1,
        delegate: !1
      },
      teamConfiguration: {
        class: "team",
        types: ["VIRTUAL_TEAM"],
        operations: ["create", "select"]
      }
    };
  },
  async created() {
    var e, t;
    this.loading = !0, this.ticketId && (this.ticket = await this.loadTicket(this.ticketId), this.prefillForm()), this.type = ((t = (e = this.ticket) == null ? void 0 : e.meta) == null ? void 0 : t["feedback-type"]) || this.ticketType, this.loading = !1;
  },
  computed: {
    formTitle() {
      const e = this.$t(`form.feedback.${this.type}.title`);
      return this.$t("form.feedback.formFields.title", { type: e }).toString();
    },
    teamIds() {
      return this.form.delegate.map((e) => e.id);
    }
  },
  methods: {
    async loadTicket(e) {
      return this.$gateway.feedback.loadFeedbackTicketById(
        this.productId,
        e
      );
    },
    prefillForm() {
      this.form = {
        title: this.ticket.title,
        text: this.ticket.meta.text,
        delegate: this.ticket.delegate
      };
    },
    validateForm() {
      return this.error = {
        title: !this.form.title.length,
        text: !this.form.text.length,
        delegate: !this.form.delegate.length
      }, !Object.values(this.error).some((e) => e);
    },
    setDelegate(e) {
      this.form.delegate = e.map((t) => ({
        context: "",
        domain: "team",
        id: t
      }));
    },
    async saveFeedbackTicket() {
      if (!this.validateForm())
        return;
      this.loading = !0;
      const e = {
        ...this.form,
        type: this.type,
        product: this.productId,
        parentTicketId: this.parentTicketId,
        // TODO: Remove this and find a better way to work with multiple languages
        languages: this.organization.language.available
      }, t = await this.$gateway.feedback.saveFeedbackTicket(
        e,
        this.ticketId
      );
      this.$emit("saveFeedback", t);
    },
    onClose() {
      this.$emit("close");
    }
  }
});
/*! @license DOMPurify 3.2.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.4/LICENSE */
const {
  entries: sc,
  setPrototypeOf: ro,
  isFrozen: Cy,
  getPrototypeOf: Sy,
  getOwnPropertyDescriptor: Iy
} = Object;
let {
  freeze: ve,
  seal: Me,
  create: nc
} = Object, {
  apply: Es,
  construct: Ls
} = typeof Reflect < "u" && Reflect;
ve || (ve = function(e) {
  return e;
});
Me || (Me = function(e) {
  return e;
});
Es || (Es = function(e, t, i) {
  return e.apply(t, i);
});
Ls || (Ls = function(e, t) {
  return new e(...t);
});
const tr = Ae(Array.prototype.forEach), Dy = Ae(Array.prototype.lastIndexOf), so = Ae(Array.prototype.pop), ri = Ae(Array.prototype.push), Py = Ae(Array.prototype.splice), dr = Ae(String.prototype.toLowerCase), as = Ae(String.prototype.toString), no = Ae(String.prototype.match), si = Ae(String.prototype.replace), Ty = Ae(String.prototype.indexOf), Oy = Ae(String.prototype.trim), Ee = Ae(Object.prototype.hasOwnProperty), be = Ae(RegExp.prototype.test), ni = By(TypeError);
function Ae(e) {
  return function(t) {
    for (var i = arguments.length, r = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
      r[s - 1] = arguments[s];
    return Es(e, t, r);
  };
}
function By(e) {
  return function() {
    for (var t = arguments.length, i = new Array(t), r = 0; r < t; r++)
      i[r] = arguments[r];
    return Ls(e, i);
  };
}
function U(e, t) {
  let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : dr;
  ro && ro(e, null);
  let r = t.length;
  for (; r--; ) {
    let s = t[r];
    if (typeof s == "string") {
      const n = i(s);
      n !== s && (Cy(t) || (t[r] = n), s = n);
    }
    e[s] = !0;
  }
  return e;
}
function My(e) {
  for (let t = 0; t < e.length; t++)
    Ee(e, t) || (e[t] = null);
  return e;
}
function St(e) {
  const t = nc(null);
  for (const [i, r] of sc(e))
    Ee(e, i) && (Array.isArray(r) ? t[i] = My(r) : r && typeof r == "object" && r.constructor === Object ? t[i] = St(r) : t[i] = r);
  return t;
}
function ai(e, t) {
  for (; e !== null; ) {
    const r = Iy(e, t);
    if (r) {
      if (r.get)
        return Ae(r.get);
      if (typeof r.value == "function")
        return Ae(r.value);
    }
    e = Sy(e);
  }
  function i() {
    return null;
  }
  return i;
}
const ao = ve(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), os = ve(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), ls = ve(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Ry = ve(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), cs = ve(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Ey = ve(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), oo = ve(["#text"]), lo = ve(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), us = ve(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), co = ve(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), ir = ve(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Ly = Me(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Fy = Me(/<%[\w\W]*|[\w\W]*%>/gm), jy = Me(/\$\{[\w\W]*/gm), Uy = Me(/^data-[\-\w.\u00B7-\uFFFF]+$/), qy = Me(/^aria-[\-\w]+$/), ac = Me(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Hy = Me(/^(?:\w+script|data):/i), zy = Me(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), oc = Me(/^html$/i), Ny = Me(/^[a-z][.\w]*(-[.\w]+)+$/i);
var uo = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: qy,
  ATTR_WHITESPACE: zy,
  CUSTOM_ELEMENT: Ny,
  DATA_ATTR: Uy,
  DOCTYPE_NAME: oc,
  ERB_EXPR: Fy,
  IS_ALLOWED_URI: ac,
  IS_SCRIPT_OR_DATA: Hy,
  MUSTACHE_EXPR: Ly,
  TMPLIT_EXPR: jy
});
const oi = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, Vy = function() {
  return typeof window > "u" ? null : window;
}, Gy = function(e, t) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let i = null;
  const r = "data-tt-policy-suffix";
  t && t.hasAttribute(r) && (i = t.getAttribute(r));
  const s = "dompurify" + (i ? "#" + i : "");
  try {
    return e.createPolicy(s, {
      createHTML(n) {
        return n;
      },
      createScriptURL(n) {
        return n;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + s + " could not be created."), null;
  }
}, ho = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function lc() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Vy();
  const t = (b) => lc(b);
  if (t.version = "3.2.4", t.removed = [], !e || !e.document || e.document.nodeType !== oi.document || !e.Element)
    return t.isSupported = !1, t;
  let {
    document: i
  } = e;
  const r = i, s = r.currentScript, {
    DocumentFragment: n,
    HTMLTemplateElement: a,
    Node: o,
    Element: l,
    NodeFilter: c,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: d,
    DOMParser: h,
    trustedTypes: p
  } = e, m = l.prototype, g = ai(m, "cloneNode"), y = ai(m, "remove"), v = ai(m, "nextSibling"), w = ai(m, "childNodes"), C = ai(m, "parentNode");
  if (typeof a == "function") {
    const b = i.createElement("template");
    b.content && b.content.ownerDocument && (i = b.content.ownerDocument);
  }
  let A, k = "";
  const {
    implementation: S,
    createNodeIterator: D,
    createDocumentFragment: T,
    getElementsByTagName: F
  } = i, {
    importNode: R
  } = r;
  let M = ho();
  t.isSupported = typeof sc == "function" && typeof C == "function" && S && S.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: H,
    ERB_EXPR: ce,
    TMPLIT_EXPR: ue,
    DATA_ATTR: j,
    ARIA_ATTR: X,
    IS_SCRIPT_OR_DATA: ge,
    ATTR_WHITESPACE: we,
    CUSTOM_ELEMENT: de
  } = uo;
  let {
    IS_ALLOWED_URI: We
  } = uo, ee = null;
  const Qe = U({}, [...ao, ...os, ...ls, ...cs, ...oo]);
  let te = null;
  const Ue = U({}, [...lo, ...us, ...co, ...ir]);
  let W = Object.seal(nc(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Re = null, Er = null, fn = !0, Lr = !0, mn = !1, gn = !0, Et = !1, Fr = !0, mt = !1, jr = !1, Ur = !1, Lt = !1, Ri = !1, Ei = !1, yn = !0, bn = !1;
  const qc = "user-content-";
  let qr = !0, Zt = !1, Ft = {}, jt = null;
  const vn = U({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let An = null;
  const kn = U({}, ["audio", "video", "img", "source", "image", "track"]);
  let Hr = null;
  const wn = U({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Li = "http://www.w3.org/1998/Math/MathML", Fi = "http://www.w3.org/2000/svg", Xe = "http://www.w3.org/1999/xhtml";
  let Ut = Xe, zr = !1, Nr = null;
  const Hc = U({}, [Li, Fi, Xe], as);
  let ji = U({}, ["mi", "mo", "mn", "ms", "mtext"]), Ui = U({}, ["annotation-xml"]);
  const zc = U({}, ["title", "style", "font", "a", "script"]);
  let Jt = null;
  const Nc = ["application/xhtml+xml", "text/html"], Vc = "text/html";
  let oe = null, qt = null;
  const Gc = i.createElement("form"), xn = function(b) {
    return b instanceof RegExp || b instanceof Function;
  }, Vr = function() {
    let b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(qt && qt === b)) {
      if ((!b || typeof b != "object") && (b = {}), b = St(b), Jt = // eslint-disable-next-line unicorn/prefer-includes
      Nc.indexOf(b.PARSER_MEDIA_TYPE) === -1 ? Vc : b.PARSER_MEDIA_TYPE, oe = Jt === "application/xhtml+xml" ? as : dr, ee = Ee(b, "ALLOWED_TAGS") ? U({}, b.ALLOWED_TAGS, oe) : Qe, te = Ee(b, "ALLOWED_ATTR") ? U({}, b.ALLOWED_ATTR, oe) : Ue, Nr = Ee(b, "ALLOWED_NAMESPACES") ? U({}, b.ALLOWED_NAMESPACES, as) : Hc, Hr = Ee(b, "ADD_URI_SAFE_ATTR") ? U(St(wn), b.ADD_URI_SAFE_ATTR, oe) : wn, An = Ee(b, "ADD_DATA_URI_TAGS") ? U(St(kn), b.ADD_DATA_URI_TAGS, oe) : kn, jt = Ee(b, "FORBID_CONTENTS") ? U({}, b.FORBID_CONTENTS, oe) : vn, Re = Ee(b, "FORBID_TAGS") ? U({}, b.FORBID_TAGS, oe) : {}, Er = Ee(b, "FORBID_ATTR") ? U({}, b.FORBID_ATTR, oe) : {}, Ft = Ee(b, "USE_PROFILES") ? b.USE_PROFILES : !1, fn = b.ALLOW_ARIA_ATTR !== !1, Lr = b.ALLOW_DATA_ATTR !== !1, mn = b.ALLOW_UNKNOWN_PROTOCOLS || !1, gn = b.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Et = b.SAFE_FOR_TEMPLATES || !1, Fr = b.SAFE_FOR_XML !== !1, mt = b.WHOLE_DOCUMENT || !1, Lt = b.RETURN_DOM || !1, Ri = b.RETURN_DOM_FRAGMENT || !1, Ei = b.RETURN_TRUSTED_TYPE || !1, Ur = b.FORCE_BODY || !1, yn = b.SANITIZE_DOM !== !1, bn = b.SANITIZE_NAMED_PROPS || !1, qr = b.KEEP_CONTENT !== !1, Zt = b.IN_PLACE || !1, We = b.ALLOWED_URI_REGEXP || ac, Ut = b.NAMESPACE || Xe, ji = b.MATHML_TEXT_INTEGRATION_POINTS || ji, Ui = b.HTML_INTEGRATION_POINTS || Ui, W = b.CUSTOM_ELEMENT_HANDLING || {}, b.CUSTOM_ELEMENT_HANDLING && xn(b.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (W.tagNameCheck = b.CUSTOM_ELEMENT_HANDLING.tagNameCheck), b.CUSTOM_ELEMENT_HANDLING && xn(b.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (W.attributeNameCheck = b.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), b.CUSTOM_ELEMENT_HANDLING && typeof b.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (W.allowCustomizedBuiltInElements = b.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Et && (Lr = !1), Ri && (Lt = !0), Ft && (ee = U({}, oo), te = [], Ft.html === !0 && (U(ee, ao), U(te, lo)), Ft.svg === !0 && (U(ee, os), U(te, us), U(te, ir)), Ft.svgFilters === !0 && (U(ee, ls), U(te, us), U(te, ir)), Ft.mathMl === !0 && (U(ee, cs), U(te, co), U(te, ir))), b.ADD_TAGS && (ee === Qe && (ee = St(ee)), U(ee, b.ADD_TAGS, oe)), b.ADD_ATTR && (te === Ue && (te = St(te)), U(te, b.ADD_ATTR, oe)), b.ADD_URI_SAFE_ATTR && U(Hr, b.ADD_URI_SAFE_ATTR, oe), b.FORBID_CONTENTS && (jt === vn && (jt = St(jt)), U(jt, b.FORBID_CONTENTS, oe)), qr && (ee["#text"] = !0), mt && U(ee, ["html", "head", "body"]), ee.table && (U(ee, ["tbody"]), delete Re.tbody), b.TRUSTED_TYPES_POLICY) {
        if (typeof b.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw ni('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof b.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw ni('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        A = b.TRUSTED_TYPES_POLICY, k = A.createHTML("");
      } else
        A === void 0 && (A = Gy(p, s)), A !== null && typeof k == "string" && (k = A.createHTML(""));
      ve && ve(b), qt = b;
    }
  }, Cn = U({}, [...os, ...ls, ...Ry]), Sn = U({}, [...cs, ...Ey]), Wc = function(b) {
    let O = C(b);
    (!O || !O.tagName) && (O = {
      namespaceURI: Ut,
      tagName: "template"
    });
    const P = dr(b.tagName), V = dr(O.tagName);
    return Nr[b.namespaceURI] ? b.namespaceURI === Fi ? O.namespaceURI === Xe ? P === "svg" : O.namespaceURI === Li ? P === "svg" && (V === "annotation-xml" || ji[V]) : !!Cn[P] : b.namespaceURI === Li ? O.namespaceURI === Xe ? P === "math" : O.namespaceURI === Fi ? P === "math" && Ui[V] : !!Sn[P] : b.namespaceURI === Xe ? O.namespaceURI === Fi && !Ui[V] || O.namespaceURI === Li && !ji[V] ? !1 : !Sn[P] && (zc[P] || !Cn[P]) : !!(Jt === "application/xhtml+xml" && Nr[b.namespaceURI]) : !1;
  }, gt = function(b) {
    ri(t.removed, {
      element: b
    });
    try {
      C(b).removeChild(b);
    } catch {
      y(b);
    }
  }, qi = function(b, O) {
    try {
      ri(t.removed, {
        attribute: O.getAttributeNode(b),
        from: O
      });
    } catch {
      ri(t.removed, {
        attribute: null,
        from: O
      });
    }
    if (O.removeAttribute(b), b === "is")
      if (Lt || Ri)
        try {
          gt(O);
        } catch {
        }
      else
        try {
          O.setAttribute(b, "");
        } catch {
        }
  }, In = function(b) {
    let O = null, P = null;
    if (Ur)
      b = "<remove></remove>" + b;
    else {
      const ne = no(b, /^[\r\n\t ]+/);
      P = ne && ne[0];
    }
    Jt === "application/xhtml+xml" && Ut === Xe && (b = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + b + "</body></html>");
    const V = A ? A.createHTML(b) : b;
    if (Ut === Xe)
      try {
        O = new h().parseFromString(V, Jt);
      } catch {
      }
    if (!O || !O.documentElement) {
      O = S.createDocument(Ut, "template", null);
      try {
        O.documentElement.innerHTML = zr ? k : V;
      } catch {
      }
    }
    const he = O.body || O.documentElement;
    return b && P && he.insertBefore(i.createTextNode(P), he.childNodes[0] || null), Ut === Xe ? F.call(O, mt ? "html" : "body")[0] : mt ? O.documentElement : he;
  }, Dn = function(b) {
    return D.call(
      b.ownerDocument || b,
      b,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, Gr = function(b) {
    return b instanceof d && (typeof b.nodeName != "string" || typeof b.textContent != "string" || typeof b.removeChild != "function" || !(b.attributes instanceof u) || typeof b.removeAttribute != "function" || typeof b.setAttribute != "function" || typeof b.namespaceURI != "string" || typeof b.insertBefore != "function" || typeof b.hasChildNodes != "function");
  }, Pn = function(b) {
    return typeof o == "function" && b instanceof o;
  };
  function Ke(b, O, P) {
    tr(b, (V) => {
      V.call(t, O, P, qt);
    });
  }
  const Tn = function(b) {
    let O = null;
    if (Ke(M.beforeSanitizeElements, b, null), Gr(b))
      return gt(b), !0;
    const P = oe(b.nodeName);
    if (Ke(M.uponSanitizeElement, b, {
      tagName: P,
      allowedTags: ee
    }), b.hasChildNodes() && !Pn(b.firstElementChild) && be(/<[/\w]/g, b.innerHTML) && be(/<[/\w]/g, b.textContent) || b.nodeType === oi.progressingInstruction || Fr && b.nodeType === oi.comment && be(/<[/\w]/g, b.data))
      return gt(b), !0;
    if (!ee[P] || Re[P]) {
      if (!Re[P] && Bn(P) && (W.tagNameCheck instanceof RegExp && be(W.tagNameCheck, P) || W.tagNameCheck instanceof Function && W.tagNameCheck(P)))
        return !1;
      if (qr && !jt[P]) {
        const V = C(b) || b.parentNode, he = w(b) || b.childNodes;
        if (he && V) {
          const ne = he.length;
          for (let Ye = ne - 1; Ye >= 0; --Ye) {
            const Te = g(he[Ye], !0);
            Te.__removalCount = (b.__removalCount || 0) + 1, V.insertBefore(Te, v(b));
          }
        }
      }
      return gt(b), !0;
    }
    return b instanceof l && !Wc(b) || (P === "noscript" || P === "noembed" || P === "noframes") && be(/<\/no(script|embed|frames)/i, b.innerHTML) ? (gt(b), !0) : (Et && b.nodeType === oi.text && (O = b.textContent, tr([H, ce, ue], (V) => {
      O = si(O, V, " ");
    }), b.textContent !== O && (ri(t.removed, {
      element: b.cloneNode()
    }), b.textContent = O)), Ke(M.afterSanitizeElements, b, null), !1);
  }, On = function(b, O, P) {
    if (yn && (O === "id" || O === "name") && (P in i || P in Gc))
      return !1;
    if (!(Lr && !Er[O] && be(j, O)) && !(fn && be(X, O))) {
      if (!te[O] || Er[O]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(Bn(b) && (W.tagNameCheck instanceof RegExp && be(W.tagNameCheck, b) || W.tagNameCheck instanceof Function && W.tagNameCheck(b)) && (W.attributeNameCheck instanceof RegExp && be(W.attributeNameCheck, O) || W.attributeNameCheck instanceof Function && W.attributeNameCheck(O)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          O === "is" && W.allowCustomizedBuiltInElements && (W.tagNameCheck instanceof RegExp && be(W.tagNameCheck, P) || W.tagNameCheck instanceof Function && W.tagNameCheck(P)))
        ) return !1;
      } else if (!Hr[O] && !be(We, si(P, we, "")) && !((O === "src" || O === "xlink:href" || O === "href") && b !== "script" && Ty(P, "data:") === 0 && An[b]) && !(mn && !be(ge, si(P, we, ""))) && P)
        return !1;
    }
    return !0;
  }, Bn = function(b) {
    return b !== "annotation-xml" && no(b, de);
  }, Mn = function(b) {
    Ke(M.beforeSanitizeAttributes, b, null);
    const {
      attributes: O
    } = b;
    if (!O || Gr(b))
      return;
    const P = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: te,
      forceKeepAttr: void 0
    };
    let V = O.length;
    for (; V--; ) {
      const he = O[V], {
        name: ne,
        namespaceURI: Ye,
        value: Te
      } = he, qe = oe(ne);
      let ye = ne === "value" ? Te : Oy(Te);
      if (P.attrName = qe, P.attrValue = ye, P.keepAttr = !0, P.forceKeepAttr = void 0, Ke(M.uponSanitizeAttribute, b, P), ye = P.attrValue, bn && (qe === "id" || qe === "name") && (qi(ne, b), ye = qc + ye), Fr && be(/((--!?|])>)|<\/(style|title)/i, ye)) {
        qi(ne, b);
        continue;
      }
      if (P.forceKeepAttr || (qi(ne, b), !P.keepAttr))
        continue;
      if (!gn && be(/\/>/i, ye)) {
        qi(ne, b);
        continue;
      }
      Et && tr([H, ce, ue], (Xc) => {
        ye = si(ye, Xc, " ");
      });
      const Rn = oe(b.nodeName);
      if (On(Rn, qe, ye)) {
        if (A && typeof p == "object" && typeof p.getAttributeType == "function" && !Ye)
          switch (p.getAttributeType(Rn, qe)) {
            case "TrustedHTML": {
              ye = A.createHTML(ye);
              break;
            }
            case "TrustedScriptURL": {
              ye = A.createScriptURL(ye);
              break;
            }
          }
        try {
          Ye ? b.setAttributeNS(Ye, ne, ye) : b.setAttribute(ne, ye), Gr(b) ? gt(b) : so(t.removed);
        } catch {
        }
      }
    }
    Ke(M.afterSanitizeAttributes, b, null);
  }, Qc = function b(O) {
    let P = null;
    const V = Dn(O);
    for (Ke(M.beforeSanitizeShadowDOM, O, null); P = V.nextNode(); )
      Ke(M.uponSanitizeShadowNode, P, null), Tn(P), Mn(P), P.content instanceof n && b(P.content);
    Ke(M.afterSanitizeShadowDOM, O, null);
  };
  return t.sanitize = function(b) {
    let O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, P = null, V = null, he = null, ne = null;
    if (zr = !b, zr && (b = "<!-->"), typeof b != "string" && !Pn(b))
      if (typeof b.toString == "function") {
        if (b = b.toString(), typeof b != "string")
          throw ni("dirty is not a string, aborting");
      } else
        throw ni("toString is not a function");
    if (!t.isSupported)
      return b;
    if (jr || Vr(O), t.removed = [], typeof b == "string" && (Zt = !1), Zt) {
      if (b.nodeName) {
        const qe = oe(b.nodeName);
        if (!ee[qe] || Re[qe])
          throw ni("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (b instanceof o)
      P = In("<!---->"), V = P.ownerDocument.importNode(b, !0), V.nodeType === oi.element && V.nodeName === "BODY" || V.nodeName === "HTML" ? P = V : P.appendChild(V);
    else {
      if (!Lt && !Et && !mt && // eslint-disable-next-line unicorn/prefer-includes
      b.indexOf("<") === -1)
        return A && Ei ? A.createHTML(b) : b;
      if (P = In(b), !P)
        return Lt ? null : Ei ? k : "";
    }
    P && Ur && gt(P.firstChild);
    const Ye = Dn(Zt ? b : P);
    for (; he = Ye.nextNode(); )
      Tn(he), Mn(he), he.content instanceof n && Qc(he.content);
    if (Zt)
      return b;
    if (Lt) {
      if (Ri)
        for (ne = T.call(P.ownerDocument); P.firstChild; )
          ne.appendChild(P.firstChild);
      else
        ne = P;
      return (te.shadowroot || te.shadowrootmode) && (ne = R.call(r, ne, !0)), ne;
    }
    let Te = mt ? P.outerHTML : P.innerHTML;
    return mt && ee["!doctype"] && P.ownerDocument && P.ownerDocument.doctype && P.ownerDocument.doctype.name && be(oc, P.ownerDocument.doctype.name) && (Te = "<!DOCTYPE " + P.ownerDocument.doctype.name + `>
` + Te), Et && tr([H, ce, ue], (qe) => {
      Te = si(Te, qe, " ");
    }), A && Ei ? A.createHTML(Te) : Te;
  }, t.setConfig = function() {
    let b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vr(b), jr = !0;
  }, t.clearConfig = function() {
    qt = null, jr = !1;
  }, t.isValidAttribute = function(b, O, P) {
    qt || Vr({});
    const V = oe(b), he = oe(O);
    return On(V, he, P);
  }, t.addHook = function(b, O) {
    typeof O == "function" && ri(M[b], O);
  }, t.removeHook = function(b, O) {
    if (O !== void 0) {
      const P = Dy(M[b], O);
      return P === -1 ? void 0 : Py(M[b], P, 1)[0];
    }
    return so(M[b]);
  }, t.removeHooks = function(b) {
    M[b] = [];
  }, t.removeAllHooks = function() {
    M = ho();
  }, t;
}
var Wy = lc(), Qy = { "": ["<em>", "</em>"], _: ["<strong>", "</strong>"], "*": ["<strong>", "</strong>"], "~": ["<s>", "</s>"], "\n": ["<br />"], " ": ["<br />"], "-": ["<hr />"] };
function po(e) {
  return e.replace(RegExp("^" + (e.match(/^(\t| )+/) || "")[0], "gm"), "");
}
function li(e) {
  return (e + "").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Fs(e, t) {
  var i, r, s, n, a, o = /((?:^|\n+)(?:\n---+|\* \*(?: \*)+)\n)|(?:^``` *(\w*)\n([\s\S]*?)\n```$)|((?:(?:^|\n+)(?:\t|  {2,}).+)+\n*)|((?:(?:^|\n)([>*+-]|\d+\.)\s+.*)+)|(?:!\[([^\]]*?)\]\(([^)]+?)\))|(\[)|(\](?:\(([^)]+?)\))?)|(?:(?:^|\n+)([^\s].*)\n(-{3,}|={3,})(?:\n+|$))|(?:(?:^|\n+)(#{1,6})\s*(.+)(?:\n+|$))|(?:`([^`].*?)`)|(  \n\n*|\n{2,}|__|\*\*|[_*]|~~)/gm, l = [], c = "", u = t || {}, d = 0;
  function h(m) {
    var g = Qy[m[1] || ""], y = l[l.length - 1] == m;
    return g ? g[1] ? (y ? l.pop() : l.push(m), g[0 | y]) : g[0] : m;
  }
  function p() {
    for (var m = ""; l.length; ) m += h(l[l.length - 1]);
    return m;
  }
  for (e = e.replace(/^\[(.+?)\]:\s*(.+)$/gm, function(m, g, y) {
    return u[g.toLowerCase()] = y, "";
  }).replace(/^\n+|\n+$/g, ""); s = o.exec(e); ) r = e.substring(d, s.index), d = o.lastIndex, i = s[0], r.match(/[^\\](\\\\)*\\$/) || ((a = s[3] || s[4]) ? i = '<pre class="code ' + (s[4] ? "poetry" : s[2].toLowerCase()) + '"><code' + (s[2] ? ' class="language-' + s[2].toLowerCase() + '"' : "") + ">" + po(li(a).replace(/^\n+|\n+$/g, "")) + "</code></pre>" : (a = s[6]) ? (a.match(/\./) && (s[5] = s[5].replace(/^\d+/gm, "")), n = Fs(po(s[5].replace(/^\s*[>*+.-]/gm, ""))), a == ">" ? a = "blockquote" : (a = a.match(/\./) ? "ol" : "ul", n = n.replace(/^(.*)(\n|$)/gm, "<li>$1</li>")), i = "<" + a + ">" + n + "</" + a + ">") : s[8] ? i = '<img src="' + li(s[8]) + '" alt="' + li(s[7]) + '">' : s[10] ? (c = c.replace("<a>", '<a href="' + li(s[11] || u[r.toLowerCase()]) + '">'), i = p() + "</a>") : s[9] ? i = "<a>" : s[12] || s[14] ? i = "<" + (a = "h" + (s[14] ? s[14].length : s[13] > "=" ? 1 : 2)) + ">" + Fs(s[12] || s[15], u) + "</" + a + ">" : s[16] ? i = "<code>" + li(s[16]) + "</code>" : (s[17] || s[1]) && (i = h(s[17] || "--"))), c += r, c += i;
  return (c + e.substring(d) + p()).replace(/^\n+|\n+$/g, "");
}
const Xy = f({
  props: {
    text: {
      type: String,
      default: ""
    },
    sanitizeOptions: {
      type: Object,
      default: () => ({
        USE_PROFILES: { html: !0 },
        ADD_ATTR: ["target"]
      })
    }
  },
  computed: {
    htmlText() {
      const e = Fs(this.text).replaceAll("><", "> <");
      return this.processText(Wy.sanitize(e, this.sanitizeOptions));
    }
  },
  methods: {
    processText(e) {
      return /^\s*#\s+/.test(e) ? e : e.replaceAll(new RegExp("\\n(?!\\n)|(?<!\\\\)\\\\n", "g"), `
<br>`);
    }
  }
});
var Ky = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "markdown-container" }, [t("div", { domProps: { innerHTML: e._s(e.htmlText) } })]);
}, Yy = [], Zy = /* @__PURE__ */ x(
  Xy,
  Ky,
  Yy,
  !1,
  null,
  "7ad989f1"
);
const je = Zy.exports;
f({
  name: "FeedbackSelectionModal",
  components: { AppMarkdownText: je },
  props: {
    defaultTickets: {
      type: Array,
      required: !0
    }
  },
  methods: {
    async addFeedbackTicket(e) {
      this.$emit("addFeedback", e);
    },
    onClose() {
      this.$emit("close");
    }
  }
});
f({
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    editMode: {
      type: Boolean,
      default: !1
    },
    userId: {
      type: String,
      required: !0
    }
  },
  computed: {
    menuOptions() {
      const e = [
        {
          label: this.$t("form.feedback.viewResults").toString(),
          tabKey: "view-result"
        }
      ];
      return this.ticket.meta.allowEdit !== !1 && e.push({
        label: this.$t("menu.edit").toString(),
        tabKey: "edit-ticket",
        visible: this.editMode
      }), this.ticket.meta.allowDelete !== !1 && e.push({
        label: this.$t("menu.delete").toString(),
        tabKey: "delete-ticket",
        visible: !this.ticket.group && this.editMode
      }), e;
    }
  },
  methods: {
    feedbackComponentType(e) {
      return (e.meta["feedback-type"] ?? "unknown") === "rating" ? "feedback-rating-ticket" : "feedback-multi-question-ticket";
    }
  }
});
f({
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    iconText: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    buttonEnabled: {
      type: Boolean,
      default: !1
    },
    menuOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    icon() {
      return this.ticket.meta.feedbackIcon ?? "/img/transparent-pixel.png";
    },
    title() {
      return this.ticket.title;
    },
    teamCount() {
      return this.ticket.delegate.filter((e) => e.domain === "team").length;
    }
  },
  methods: {
    clickButton() {
      this.$emit("click:button", this.ticket.canonicalId);
    }
  }
});
f({
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    menuOptions: {
      type: Array,
      default: () => []
    },
    userId: {
      type: String,
      required: !0
    }
  },
  computed: {
    buttonText() {
      return this.$t(`form.feedback.${this.buttonKey}`).toString();
    },
    buttonKey() {
      return this.ticket.allowFeedback ? this.hasCurrentUserFeedback ? this.ticket.meta.allowResubmission ? "resubmitFeedback" : "feedbackAdded" : "addFeedback" : "feedbackClosed";
    },
    isButtonEnabled() {
      return (!this.hasCurrentUserFeedback || this.ticket.meta.allowResubmission) && this.ticket.allowFeedback;
    },
    hasCurrentUserFeedback() {
      return Object.keys(this.feedbackEntries).some(
        (e) => e === this.userId
      );
    },
    feedbackFieldName() {
      return this.ticket.meta.feedbackFieldName ?? "";
    },
    feedbackVoteFieldName() {
      return this.ticket.meta.feedbackFieldContent[0] ?? "";
    },
    feedbackEntries() {
      var e;
      return ((e = this.ticket.userFields) == null ? void 0 : e[this.feedbackFieldName]) ?? {};
    },
    feedbackCount() {
      return Object.keys(this.feedbackEntries).length;
    },
    averageVote() {
      if (!this.feedbackFieldName || !this.feedbackVoteFieldName || !this.feedbackCount)
        return;
      const e = Object.entries(this.feedbackEntries).reduce(
        (t, [, i]) => {
          const r = i.content ?? {};
          return t + Number.parseInt(r[this.feedbackVoteFieldName], 10);
        },
        0
      );
      return this.formatNumber(e / this.feedbackCount);
    },
    responseCount() {
      return this.$tc("form.feedback.responseAverageText", this.feedbackCount, {
        count: this.feedbackCount,
        averageVote: this.averageVote
      }).toString();
    }
  },
  methods: {
    formatNumber(e) {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      }).format(e);
    }
  }
});
f({
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    menuOptions: {
      type: Array,
      default: () => []
    },
    userId: {
      type: String,
      required: !0
    }
  },
  computed: {
    buttonText() {
      return this.$t(`form.feedback.${this.buttonKey}`).toString();
    },
    buttonKey() {
      return this.ticket.allowFeedback ? this.hasCurrentUserFeedback ? this.ticket.meta.allowResubmission ? "resubmitFeedback" : "feedbackAdded" : "addFeedback" : "feedbackClosed";
    },
    isButtonEnabled() {
      return (!this.hasCurrentUserFeedback || this.ticket.meta.allowResubmission) && this.ticket.allowFeedback;
    },
    hasCurrentUserFeedback() {
      var e;
      return !!((e = Object.values(this.feedbackEntries)[0]) != null && e[this.userId]);
    },
    feedbackEntries() {
      return this.ticket.userFields ?? {};
    },
    feedbackCount() {
      return new Set(
        Object.values(this.feedbackEntries).map(Object.keys).flat()
      ).size;
    },
    subtitle() {
      return this.$tc("form.feedback.responseCountText", this.feedbackCount, {
        count: this.feedbackCount
      }).toString();
    }
  }
});
f({
  components: { AppMarkdownText: je },
  props: {
    ticket: {
      type: Object,
      required: !0
    }
  },
  computed: {
    icon() {
      return this.ticket.meta.feedbackIcon ?? "";
    },
    title() {
      return this.$t(`form.feedback.${this.type}.title`).toString();
    },
    description() {
      return this.$t(`form.feedback.${this.type}.description`).toString();
    },
    type() {
      return this.ticket.meta["feedback-type"];
    }
  }
});
function cc(e, t) {
  return [...new Set(e.map(t))].filter((i) => !!i);
}
function Jy(e, t) {
  const i = /* @__PURE__ */ new Map();
  for (const r of e) {
    const s = t(r);
    i.has(s) || i.set(s, []), i.get(s).push(r);
  }
  return i;
}
function on(e, t) {
  const i = /* @__PURE__ */ new Map();
  for (const r of e) {
    const s = t(r);
    if (!i.has(s))
      i.set(s, r);
    else
      throw new Error("Could not mapBy: Multiple values with the same key");
  }
  return i;
}
const _y = "/img/profile-placeholder.svg", $y = f({
  name: "MultipleChoiceResultList",
  props: {
    question: {
      type: Object,
      required: !0
    },
    userMap: {
      type: Map,
      default: () => ({})
    },
    answers: {
      type: Object,
      default: () => ({})
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  computed: {
    isMultipleChoice() {
      return this.question.type === "multiple-choice";
    },
    questionWithIndexes() {
      var e;
      const t = (e = this.question.options) == null ? void 0 : e.map(
        (i, r) => ({
          ...i,
          value: r,
          actualValue: i.value
        })
      );
      return {
        ...this.question,
        options: t
      };
    },
    allAnswers() {
      const e = Object.entries(this.answers).reduce(
        (i, [r, s]) => ((s.contentIndexes ?? s.content).forEach(
          (n) => {
            i[n] = i[n] || { userIds: [], answerCount: 0 }, i[n].userIds.push(r), i[n].answerCount++;
          }
        ), i),
        {}
      ), t = Object.keys(this.answers).length;
      return Object.entries(e).map(([i, { userIds: r, answerCount: s }]) => {
        const n = this.formatNumber(
          s / t * 100
        );
        return {
          answer: `${this.getAnswerText(i)}: ${n}%`,
          userIds: r,
          percentage: n
        };
      }).sort((i, r) => r.percentage - i.percentage);
    }
  },
  methods: {
    formatNumber(e) {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      }).format(e);
    },
    getAnswerText(e) {
      var t;
      return ((t = this.questionWithIndexes.options.find(
        (i) => i.value == e
      )) == null ? void 0 : t.text) ?? e;
    },
    getUserName(e) {
      return e === this.currentUser.id ? this.$t("form.feedback.results.yourFeedback").toString() : B({
        user: this.userMap.get(e) ?? {}
      }).displayName();
    },
    userAvatar(e) {
      var t;
      return ((t = this.userMap.get(e)) == null ? void 0 : t.avatar) || _y;
    }
  }
});
var eb = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "multiple-choice-list" }, e._l(e.allAnswers, function({ userIds: i, answer: r }, s) {
    return t("div", { key: s, staticClass: "answer-container" }, [t("div", { staticClass: "answer" }, [e._v(" " + e._s(r) + " ")]), e._l(i, function(n) {
      return t("div", { key: n, staticClass: "user", class: { highlighted: n === e.currentUser.id } }, [t("app-image", { staticClass: "user-image", attrs: { src: e.userAvatar(n), height: "25px", type: "circle", width: "25px" } }), t("span", [e._v(e._s(e.getUserName(n)))])], 1);
    })], 2);
  }), 0);
}, tb = [], ib = /* @__PURE__ */ x(
  $y,
  eb,
  tb,
  !1,
  null,
  "5e2deacc"
);
const rb = ib.exports, sb = "/img/profile-placeholder.svg", nb = f({
  name: "RatingResult",
  props: {
    rating: {
      type: Number,
      required: !0
    },
    highlighted: {
      type: Boolean,
      required: !1
    },
    maxRating: {
      type: Number,
      required: !0
    },
    img: {
      type: String,
      required: !0
    },
    userName: {
      type: String,
      required: !0
    },
    userAvatar: {
      type: String,
      default: sb
    }
  }
});
var ab = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "rating-container" }, [t("div", { staticClass: "rating-result" }, e._l(e.maxRating, function(i) {
    return t("img", { key: i, staticClass: "rating-img", class: { selected: i <= e.rating }, attrs: { src: e.img } });
  }), 0), t("app-image", { staticClass: "user-image", attrs: { src: e.userAvatar, height: "25px", type: "circle", width: "25px" } }), t("div", { staticClass: "user-name", class: { highlighted: e.highlighted } }, [e._v(e._s(e.userName))])], 1);
}, ob = [], lb = /* @__PURE__ */ x(
  nb,
  ab,
  ob,
  !1,
  null,
  "b3f31183"
);
const uc = lb.exports, cb = "/img/profile-placeholder.svg", ub = f({
  name: "RatingResultList",
  components: { RatingResult: uc },
  props: {
    question: {
      type: Object,
      required: !0
    },
    userMap: {
      type: Map,
      default: () => ({})
    },
    answers: {
      type: Object,
      default: () => ({})
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  computed: {
    totalRatings() {
      return Object.entries(this.answers).map(
        ([e, { content: t }]) => ({
          user: this.userMap.get(e),
          rating: Number.parseInt(t, 10)
        })
      );
    },
    ratingImg() {
      return this.question.valueImageUrl;
    },
    maxRating() {
      return this.question.values.length;
    }
  },
  methods: {
    getUserName(e) {
      return e.id === this.currentUser.id ? this.$t("form.feedback.results.yourFeedback").toString() : B({ user: e }).displayName();
    },
    userAvatar(e) {
      return e.avatar || cb;
    }
  }
});
var db = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "rating-list" }, e._l(e.totalRatings, function({ user: i, rating: r }) {
    return t("rating-result", { key: i.id, attrs: { highlighted: i.id === e.currentUser.id, img: e.ratingImg, "max-rating": e.maxRating, rating: r, "user-avatar": e.userAvatar(i), "user-name": e.getUserName(i) } });
  }), 1);
}, hb = [], pb = /* @__PURE__ */ x(
  ub,
  db,
  hb,
  !1,
  null,
  "10ff9508"
);
const fb = pb.exports, mb = "/img/profile-placeholder.svg", gb = f({
  name: "TextResultList",
  props: {
    question: {
      type: Object,
      required: !0
    },
    userMap: {
      type: Map,
      default: () => ({})
    },
    answers: {
      type: Object,
      default: () => ({})
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  computed: {
    allAnswers() {
      return Object.entries(this.answers).map(
        ([e, { content: t }]) => ({
          user: this.userMap.get(e),
          answer: t ?? "-"
        })
      );
    }
  },
  methods: {
    getUserName(e) {
      return e.id === this.currentUser.id ? this.$t("form.feedback.results.yourFeedback").toString() : B({ user: e }).displayName();
    },
    userAvatar(e) {
      return e.avatar || mb;
    }
  }
});
var yb = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "text-list" }, e._l(e.allAnswers, function({ user: i, answer: r }) {
    return t("div", { key: i.id, staticClass: "answer-container" }, [t("div", { staticClass: "user", class: { highlighted: i.id === e.currentUser.id } }, [t("app-image", { staticClass: "user-image", attrs: { src: e.userAvatar(i), height: "25px", type: "circle", width: "25px" } }), t("span", [e._v(e._s(e.getUserName(i)))])], 1), t("div", { staticClass: "answer" }, [e._v(" " + e._s(r) + " ")])]);
  }), 0);
}, bb = [], vb = /* @__PURE__ */ x(
  gb,
  yb,
  bb,
  !1,
  null,
  "8bbe7a76"
);
const Ab = vb.exports, kb = f({
  name: "MultiQuestionResultModalContent",
  components: {
    MultipleChoiceResultList: rb,
    RatingResultList: fb,
    TextResultList: Ab
  },
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !0,
      userMap: /* @__PURE__ */ new Map()
    };
  },
  async created() {
    await this.loadUserMap(), this.loading = !1;
  },
  computed: {
    questions() {
      return this.totalNumberOfResponses ? this.resource.questions : [];
    },
    feedbackEntries() {
      return this.ticket.userFields ?? {};
    },
    totalNumberOfResponses() {
      return new Set(
        Object.values(this.feedbackEntries).map(Object.keys).flat()
      ).size;
    },
    resource() {
      const e = this.ticket.meta.feedbackDialogue;
      return this.$res(e);
    }
  },
  methods: {
    getAnswerText(e, t) {
      return e.map(
        (i) => {
          var r;
          return ((r = t.find((s) => s.value === i)) == null ? void 0 : r.text) ?? i;
        }
      );
    },
    async loadUserMap() {
      var e;
      const t = Object.keys(
        ((e = Object.values(this.feedbackEntries)) == null ? void 0 : e[0]) ?? {}
      ), i = await this.$datasource.user.listBatch(t);
      this.userMap = on(i, (r) => r.id);
    },
    resultListType(e) {
      switch (e) {
        case "rating":
          return "RatingResultList";
        case "multiple-choice":
          return "MultipleChoiceResultList";
        case "text":
        default:
          return "TextResultList";
      }
    },
    formatNumber(e) {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      }).format(e);
    },
    questionImage(e) {
      switch (e) {
        case "rating":
          return "/img/feedback_star_rating.svg";
        case "multiple-choice":
          return "/img/feedback_abtest.svg";
        case "text":
        default:
          return "/img/feedback_text.svg";
      }
    },
    questionResultSummary(e, t) {
      const i = this.feedbackEntries[e] ?? {}, r = Object.keys(i).length;
      if (t === "rating") {
        const s = Object.values(i), n = this.formatNumber(
          s.reduce(
            (a, o) => a + Number.parseInt(o.content, 10),
            0
          ) / r
        );
        return this.$tc("form.feedback.responseAverageText", r, {
          count: r,
          averageVote: n
        });
      }
      return this.$tc(
        "form.feedback.responseCountText",
        r
      ).toString();
    }
  }
});
var wb = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, e.loading ? e._e() : t("div", { staticClass: "rating-container" }, [t("div", { staticClass: "rating-text" }, [e._v(" " + e._s(e.$t("form.feedback.results.amountOfResponses")) + " " + e._s(e.totalNumberOfResponses) + " ")]), e._l(e.questions, function(i) {
    return t("app-accordion", { key: i.id, staticClass: "response-container", attrs: { name: "results" }, scopedSlots: e._u([{ key: "summary", fn: function() {
      return [t("div", { staticClass: "question-container" }, [t("img", { staticClass: "question-image", attrs: { src: e.questionImage(i.type) } }), t("div", { staticClass: "question-text-container" }, [t("div", { staticClass: "question-title" }, [e._v(" " + e._s(i.title ?? i.description) + " ")]), t("div", { staticClass: "question-result-summary" }, [t("user-avatar-list", { attrs: { users: Array.from(e.userMap.values()), "max-display": 4 } }), e._v(" " + e._s(e.questionResultSummary(i.id, i.type)) + " ")], 1)])])];
    }, proxy: !0 }, { key: "content", fn: function() {
      return [t(e.resultListType(i.type), { tag: "component", attrs: { answers: e.feedbackEntries[i.id], "current-user": e.currentUser, question: i, userMap: e.userMap } })];
    }, proxy: !0 }], null, !0) });
  })], 2);
}, xb = [], Cb = /* @__PURE__ */ x(
  kb,
  wb,
  xb,
  !1,
  null,
  "cb535b80"
);
const Sb = Cb.exports, Ib = f({
  name: "RatingResultModalContent",
  components: { RatingResult: uc },
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      userMap: /* @__PURE__ */ new Map()
    };
  },
  async created() {
    this.loading = !0, await this.loadUserMap(), this.loading = !1;
  },
  computed: {
    resource() {
      const e = this.ticket.meta.feedbackDialogue;
      return this.$res(e);
    },
    allRatings() {
      return this.resource.options.map((e) => e.values).flat();
    },
    maxRating() {
      return this.allRatings.length;
    },
    ratingImg() {
      return this.resource.options[0].valueImageUrl;
    },
    totalRatings() {
      return Object.entries(this.feedbackEntries).filter(([e]) => e !== this.currentUser.id).map(([e, t]) => {
        var i;
        return {
          user: this.userMap.get(e),
          rating: Number.parseInt(
            ((i = t == null ? void 0 : t.content) == null ? void 0 : i[this.feedbackVoteFieldName]) ?? "0",
            10
          )
        };
      });
    },
    currentUserRating() {
      var e;
      const t = this.feedbackEntries[this.currentUser.id];
      return Number.parseInt(
        ((e = t == null ? void 0 : t.content) == null ? void 0 : e[this.feedbackVoteFieldName]) ?? "0",
        10
      );
    },
    feedbackFieldName() {
      return this.ticket.meta.feedbackFieldName ?? "";
    },
    feedbackVoteFieldName() {
      return this.ticket.meta.feedbackFieldContent[0] ?? "";
    },
    feedbackEntries() {
      var e;
      return ((e = this.ticket.userFields) == null ? void 0 : e[this.feedbackFieldName]) ?? {};
    },
    numberOfVotes() {
      return Object.keys(this.feedbackEntries).length;
    },
    averageRating() {
      if (!this.feedbackVoteFieldName || !this.numberOfVotes)
        return;
      const e = Object.entries(this.feedbackEntries).reduce(
        (t, [, i]) => {
          const r = i.content ?? {};
          return t + Number.parseInt(r[this.feedbackVoteFieldName], 10);
        },
        0
      );
      return this.formatNumber(e / this.numberOfVotes);
    }
  },
  methods: {
    getUserName(e) {
      return e ? B({ user: e }).displayName() : "";
    },
    async loadUserMap() {
      var e;
      const t = Object.keys(
        ((e = this.ticket.userFields) == null ? void 0 : e[this.ticket.meta.feedbackFieldName]) ?? {}
      ), i = await this.$datasource.user.listBatch(t);
      this.userMap = on(i, (r) => r.id);
    },
    formatNumber(e) {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        minimumFractionDigits: 0,
        maximumFractionDigits: 1
      }).format(e);
    }
  }
});
var Db = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, e.loading ? e._e() : t("div", { staticClass: "rating-container" }, [t("div", { staticClass: "rating-text" }, [e._v(" " + e._s(e.$t("form.feedback.results.amountOfVotes")) + " " + e._s(e.numberOfVotes) + " "), e.averageRating ? [t("span", { staticClass: "rating-separator" }, [e._v(" | ")]), e._v(" " + e._s(e.$t("form.feedback.results.averageRating")) + " " + e._s(e.averageRating) + " ")] : e._e()], 2), t("div", { staticClass: "review-rating" }, [e.currentUserRating ? t("rating-result", { attrs: { highlighted: !0, img: e.ratingImg, "max-rating": e.maxRating, rating: e.currentUserRating, "user-avatar": e.currentUser.avatar, "user-name": e.$t("form.feedback.results.yourFeedback") } }) : e._e(), e._l(e.totalRatings, function({ user: i, rating: r }) {
    return t("rating-result", { key: i == null ? void 0 : i.id, attrs: { img: e.ratingImg, "max-rating": e.maxRating, rating: r, "user-avatar": i == null ? void 0 : i.avatar, "user-name": e.getUserName(i) } });
  })], 2)]);
}, Pb = [], Tb = /* @__PURE__ */ x(
  Ib,
  Db,
  Pb,
  !1,
  null,
  "da864909"
);
const Ob = Tb.exports;
f({
  name: "FeedbackResultModal",
  components: {
    MultiQuestionResultModalContent: Sb,
    RatingResultModalContent: Ob
  },
  props: {
    ticketId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      ticket: {},
      loading: !1
    };
  },
  async created() {
    this.loading = !0, await this.loadResultDate(), this.loading = !1;
  },
  computed: {
    resource() {
      const e = this.ticket.meta.feedbackDialogue;
      return this.$res(e, {});
    },
    componentType() {
      switch (this.ticket.meta["feedback-type"]) {
        case "multi-question":
          return "MultiQuestionResultModalContent";
        case "rating":
        default:
          return "RatingResultModalContent";
      }
    }
  },
  methods: {
    async loadResultDate() {
      this.ticket = await this.$gateway.feedback.loadFeedbackTicketById(
        this.productId,
        this.ticketId
      );
    },
    onClose() {
      this.$emit("close");
    }
  }
});
const Bb = f({
  props: {
    scanResult: {
      type: String,
      default: ""
    }
  },
  computed: {
    icon() {
      switch (this.scanResult) {
        case "NO_THREATS_FOUND":
          return {
            icon: "fa-regular fa-shield-check",
            color: "#00987E"
          };
        case "THREATS_FOUND":
          return {
            icon: "fa-regular fa-shield-xmark",
            color: "#FF4A4A"
          };
        default:
          return {
            icon: "",
            color: ""
          };
      }
    }
  }
});
var Mb = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "icon-container" }, [t("fa-icon-compat", { staticClass: "icon", style: { color: e.icon.color }, attrs: { icon: e.icon.icon } })], 1);
}, Rb = [], Eb = /* @__PURE__ */ x(
  Bb,
  Mb,
  Rb,
  !1,
  null,
  "b811aa8e"
);
const dc = Eb.exports, Lb = f({
  components: { AppFileScanIcon: dc },
  props: {
    file: {
      type: Object,
      required: !0
    }
  },
  computed: {
    galleryStyle() {
      return {
        border: "1px solid var(--color-grey)",
        backgroundColor: "var(--color-grey-light)",
        backgroundImage: this.coverSrc ? `url(${this.coverSrc})` : "none"
      };
    },
    coverSrc() {
      var e;
      return (e = this.file.contentType) != null && e.startsWith("image") ? this.file.src : void 0;
    },
    fileIconSrc() {
      var e;
      if ((e = this.file.contentType) != null && e.startsWith("video"))
        return "/img/video.svg";
    },
    fileLabel() {
      var e;
      if (!((e = this.file.contentType) != null && e.startsWith("image")))
        return this.file.label || this.file.filename;
    },
    hint() {
      const e = this.file.createdDate ? `| ${this.file.createdDate}` : "";
      return `${this.file.filename} ${e}`.trim();
    }
  }
});
var Fb = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-file-gallery-preview", style: e.galleryStyle, attrs: { title: e.hint } }, [e.fileIconSrc ? t("img", { staticClass: "icon", attrs: { src: e.fileIconSrc } }) : e._e(), e.fileLabel ? t("div", { staticClass: "label" }, [e._v(e._s(e.fileLabel))]) : e._e(), e.file.scanResult ? t("app-file-scan-icon", { staticClass: "scan-icon", attrs: { "scan-result": e.file.scanResult } }) : e._e()], 1);
}, jb = [], Ub = /* @__PURE__ */ x(
  Lb,
  Fb,
  jb,
  !1,
  null,
  "0af5fc3d"
);
const qb = Ub.exports;
function Hb(e) {
  const { createdDate: t } = e;
  if (!t)
    return "";
  const i = new Date(t), r = {
    year: "numeric",
    month: "short",
    day: "2-digit"
  };
  return i.toLocaleDateString(void 0, r);
}
function Xt(e) {
  if (!e)
    throw new Error("Could not buildUserFile, legacy file is undefined");
  return {
    id: e.id,
    contentType: e.contentType,
    src: e.url,
    filename: e.filename,
    label: e.name,
    roles: e.roles,
    createdDate: Hb(e),
    scanResult: e.scanResult
  };
}
const zb = f({
  props: {
    file: {
      type: Object,
      required: !1
    }
  },
  computed: {
    extension() {
      var e;
      return (/(?:\.([^.]+))?$/.exec(((e = this.file) == null ? void 0 : e.filename) ?? "")[1] ?? "???").substring(0, 3).toUpperCase();
    }
  }
});
var Nb = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("svg", { staticStyle: { zoom: "1" }, attrs: { xmlns: "http://www.w3.org/2000/svg", width: "42", height: "46", viewBox: "0 0 42 46", fill: "none" } }, [t("path", { attrs: { d: `M4.39185 20.3065C4.39185 20.6802 4.69417 20.9796 5.06495
              20.9796C5.43858 20.9796 5.73806 20.6773 5.73806 20.3065V1.34833H29.3393L35.5027
              7.51177V20.309C35.5027 20.6826 35.805 20.9821 36.1758 20.9821C36.5494 20.9821
              36.8489 20.6798 36.8489 20.309V7.23212C36.8489 7.06099 36.7833 6.88701 36.6521
              6.75582L30.0979 0.201603C29.9753 0.078961 29.807 0.00195312 29.6187
              0.00195312H5.06471C4.69108 0.00195312 4.3916 0.304277
              4.3916 0.675059V20.3094L4.39185 20.3065ZM36.8519 38.2038C36.8519 37.8302
              36.5496 37.5307 36.1788 37.5307C35.8052 37.5307 35.5057 37.8331 35.5057
              38.2038V43.8083H5.74061V38.2038C5.74061 37.8302 5.43828 37.5307
              5.0675 37.5307C4.69387 37.5307 4.3944 37.8331 4.3944
              38.2038V44.4814C4.3944 44.855 4.69673 45.1545 5.0675 45.1545H36.1812C36.5548
              45.1545 36.8543 44.8522 36.8543 44.4814V38.2038H36.8519Z`, fill: "#B3B3B3" } }), t("path", { attrs: { d: `M30.2949 0.673106C30.2949 0.299477 29.9926 0 29.6218 0C29.2482 0 28.9487
              0.302324 28.9487 0.673106V3.95306C28.9487 5.03974 29.3937 6.02945
              30.1095 6.74528C30.8254 7.46117 31.8151 7.90606 32.9017 7.90606H36.1817C36.5553
              7.90606 36.8548 7.60374 36.8548 7.23296C36.8548 6.85933 36.5525 6.55985 36.1817
              6.55985H32.9017C32.1858 6.55985 31.5356 6.26609 31.0621 5.79546C30.5887 5.32201
              30.2977 4.6717 30.2977 3.95587V0.67591L30.2949 0.673106Z`, fill: "#B3B3B3" } }), t("path", { attrs: { d: `M1.34557 37.5292H39.9009V20.9812H1.34557V37.5292ZM40.5741
              38.8783H0.673106C0.299477 38.8783 0 38.576 0 38.2052V20.3079C0 19.9342
              0.302324 19.6348 0.673106 19.6348H40.5741C40.9477 19.6348 41.2472 19.9371
              41.2472 20.3079V38.2052C41.2472 38.5788 40.9448
              38.8783 40.5741 38.8783Z`, fill: "#B3B3B3" } }), t("path", { attrs: { d: `M10.4006 7.72266C10.027 7.72266 9.72754 8.02498 9.72754 8.39576C9.72754
              8.76939 10.0299 9.06887 10.4006 9.06887H24.921C25.2947 9.06887 25.5941 8.76654
              25.5941 8.39576C25.5941 8.02213 25.2918
              7.72266 24.921 7.72266H10.4006Z`, fill: "#B3B3B3" } }), t("path", { attrs: { d: `M10.4006 11.4434C10.027 11.4434 9.72754 11.7457 9.72754 12.1165C9.72754
              12.4901 10.0299 12.7896 10.4006 12.7896H30.8476C31.2212 12.7896 31.5207 12.4872
              31.5207 12.1165C31.5207 11.7428 31.2184 11.4434
              30.8476 11.4434H10.4006Z`, fill: "#B3B3B3" } }), t("path", { attrs: { d: `M10.4006 15.1602C10.027 15.1602 9.72754 15.4625 9.72754 15.8333C9.72754
              16.2069 10.0299 16.5064 10.4006 16.5064H30.8476C31.2212 16.5064 31.5207 16.204
              31.5207 15.8333C31.5207 15.4596 31.2184 15.1602
              30.8476 15.1602H10.4006Z`, fill: "#B3B3B3" } }), t("g", [t("text", { staticClass: "file-extension", attrs: { x: "50%", y: "33" } }, [e._v(e._s(e.extension))])])]);
}, Vb = [], Gb = /* @__PURE__ */ x(
  zb,
  Nb,
  Vb,
  !1,
  null,
  "096313ea"
);
const hc = Gb.exports, Wb = f({
  components: {
    AppFileUploadPreviewIcon: hc
  },
  props: {
    file: {
      type: Object,
      required: !1
    }
  },
  computed: {
    previewVisible() {
      var e;
      return ((e = this.file) == null ? void 0 : e.contentType.startsWith("image")) ?? !1;
    },
    previewSrc() {
      var e;
      return (e = this.file) == null ? void 0 : e.src;
    }
  }
});
var Qb = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-file-upload-preview" }, [e.previewVisible ? t("img", { staticClass: "image-preview", attrs: { src: e.previewSrc } }) : t("app-file-upload-preview-icon", { staticClass: "image-preview", attrs: { file: e.file } })], 1);
}, Xb = [], Kb = /* @__PURE__ */ x(
  Wb,
  Qb,
  Xb,
  !1,
  null,
  "131724f0"
);
const Yb = Kb.exports, Zb = f({
  components: {
    AppFileUploadPreview: Yb
  },
  props: {
    file: {
      type: Object,
      required: !0
    }
  },
  computed: {
    hasSlotControls() {
      return !!this.$slots.controls;
    }
  }
});
var Jb = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-file-upload-item" }, [t("app-file-upload-preview", { staticClass: "file-preview", attrs: { file: e.file } }), t("div", { staticClass: "file-name" }, [e._v(e._s(e.file.filename))]), e.hasSlotControls ? t("div", { staticClass: "controls" }, [e._t("controls")], 2) : e._e()], 1);
}, _b = [], $b = /* @__PURE__ */ x(
  Zb,
  Jb,
  _b,
  !1,
  null,
  "b23505b7"
);
const Mr = $b.exports, ev = f({
  props: {
    dynamicGroup: {
      type: Object,
      required: !0
    },
    label: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      expanded: !0
    };
  },
  created() {
    this.expanded = this.displayConfig.collapse !== "collapsed";
  },
  computed: {
    displayConfig() {
      const { display: e } = this.dynamicGroup.options ?? {};
      return { ...e == null ? void 0 : e.all, ...e == null ? void 0 : e.view };
    },
    toggleEnabled() {
      const { collapse: e } = this.displayConfig;
      return e === "expanded" || e === "collapsed";
    },
    headerIcon() {
      return this.expanded ? "fa-regular fa-chevron-up" : "fa-regular fa-chevron-down";
    }
  },
  methods: {
    onToggleGroup() {
      this.expanded = !this.expanded;
    }
  }
});
var tv = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "legacy-field-view" }, [e.label ? t("div", { staticClass: "legacy-field-label" }, [e.toggleEnabled ? t("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: e.onToggleGroup } }, [t("fa-icon-compat", { staticClass: "icon", attrs: { icon: e.headerIcon } })], 1) : e._e(), t("div", { staticClass: "legacy-field-label-title" }, [e._v(e._s(e.label) + " ")])], 1) : e._e(), t("div", { directives: [{ name: "show", rawName: "v-show", value: e.expanded, expression: "expanded" }], staticClass: "legacy-field-content" }, [e._t("default")], 2)]);
}, iv = [], rv = /* @__PURE__ */ x(
  ev,
  tv,
  iv,
  !1,
  null,
  "a56f4603"
);
const sv = rv.exports, nv = f({
  components: { AppFileScanIcon: dc, AppFileUploadPreviewIcon: hc },
  props: {
    item: {
      type: Object,
      required: !0
    }
  }
});
var av = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [t("div", { staticClass: "separator" }), t("div", { staticClass: "gallery-item-container" }, [t("app-file-upload-preview-icon", { staticClass: "icon", attrs: { file: e.item } }), t("div", { staticClass: "filename" }, [e._v(e._s(e.item.filename))]), e.item.createdDate ? t("div", { staticClass: "date" }, [e._v(e._s(e.item.createdDate))]) : e._e(), e.item.scanResult ? t("app-file-scan-icon", { attrs: { "scan-result": e.item.scanResult } }) : e._e()], 1)]);
}, ov = [], lv = /* @__PURE__ */ x(
  nv,
  av,
  ov,
  !1,
  null,
  "98cce130"
);
const cv = lv.exports;
f({
  components: {
    AppFileGalleryItem: cv,
    LegacyFieldLabel: sv,
    AppFileUploadItem: Mr,
    AppFileGalleryPreview: qb
  },
  props: {
    files: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentFiles: [],
      view: "grid"
    };
  },
  created() {
    this.currentFiles = this.files.map(Xt);
  },
  computed: {
    gridConfig() {
      return {
        summary: "disabled",
        item: {
          minWidth: 150,
          maxWidth: 200
        }
      };
    },
    listConfig() {
      return {
        summary: "disabled",
        display: {
          separators: "disabled"
        }
      };
    }
  },
  methods: {
    hrefFile(e) {
      return e || void 0;
    }
  }
});
const uv = f({
  props: {
    label: {
      type: String,
      required: !0
    },
    acceptFilter: {
      type: String,
      required: !1
    }
  },
  setup() {
    return $l();
  },
  methods: {
    onClickInput() {
      this.$refs.fileInput.click();
    },
    checkFileSize(e) {
      return this.allowFileSize(e) ? !0 : (console.error(`File size is too big, ${e.size}`), this.$toast(
        this.$t("error.maxFileSize", {
          size: this.readableMaxFileUploadSize
        }).toString()
      ), !1);
    },
    onFileChange(e) {
      const t = e == null ? void 0 : e.target, i = t == null ? void 0 : t.files;
      (i == null ? void 0 : i.length) === 1 && this.checkFileSize(i[0]) ? this.$emit("pick-file", i[0]) : console.error("Error picking file to upload");
    }
  }
});
var dv = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-file-upload-picker" }, [t("add-button", { attrs: { text: e.label }, on: { click: e.onClickInput, keydown: function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "enter", 13, i.key, "Enter") ? null : (i.stopPropagation(), e.onClickInput.apply(null, arguments));
  } } }), t("input", { ref: "fileInput", staticClass: "hidden-file-input", attrs: { type: "file", accept: e.acceptFilter }, on: { change: e.onFileChange } })], 1);
}, hv = [], pv = /* @__PURE__ */ x(
  uv,
  dv,
  hv,
  !1,
  null,
  "8736ecc3"
);
const pc = pv.exports, fv = f({
  name: "SelectTeamMembers",
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      search: "",
      loading: !1,
      users: [],
      selection: [],
      selectedUsers: [],
      reloadKey: 0
    };
  },
  created() {
    this.selection = [...this.value];
  },
  watch: {
    async selection(e) {
      await this.updateModel(e), await this.onUpdateSelection(e);
    }
  },
  computed: {
    isEmpty() {
      return this.users.length === 0;
    },
    emptyViewMessage() {
      return this.search.length && !this.users.length && !this.loading ? this.$t("common.no-result-found").toString() : this.$t("page.userSearchModal.searchByName").toString();
    },
    gridConfig() {
      return {
        selection: {
          mode: "multiple",
          selectAllButton: !1
        },
        item: { minWidth: 200 }
      };
    },
    mappedUsers() {
      return this.users.map((e) => ({ ...e, id: e.user.id }));
    }
  },
  methods: {
    async onDebounced(e) {
      this.search = e, await this.onSearch();
    },
    async onSearch() {
      try {
        this.loading = !0;
        const e = await this.$gateway.search.searchUserIds({
          query: this.search,
          filter: {
            active: !0
          },
          limit: 100
        });
        this.users = await this.$gateway.portal.findUsersById(e);
      } catch (e) {
        console.error("Error loading users", e);
      } finally {
        this.loading = !1;
      }
    },
    removeSelection(e) {
      this.selection = this.selection.filter((t) => t !== e), this.reloadKey += 1;
    },
    async onUpdateSelection(e) {
      try {
        this.selectedUsers = await this.$gateway.portal.findUsersById(
          e
        );
      } catch (t) {
        console.error("Error loading selected users", t);
      }
    },
    updateModel(e) {
      this.$emit("input", e);
    }
  }
});
var mv = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "select-team-members" }, [e.selectedUsers.length ? t("base-input-item", { attrs: { label: e.$t("page.userSearchModal.selected") } }, [t("app-data-grid", { attrs: { data: e.selectedUsers, config: { summary: "disabled", item: { minWidth: 200 } } }, scopedSlots: e._u([{ key: "default", fn: function({ item: i }) {
    return [t("team-member-card", { staticClass: "clickable-card", attrs: { "user-data": i }, nativeOn: { click: function(r) {
      return e.removeSelection(i.id);
    } } })];
  } }], null, !1, 111531775) })], 1) : e._e(), t("app-search-input", { staticClass: "app-search-input", attrs: { "debounce-timeout": 500, label: e.$t("modal.createTeam.searchLabel"), placeholder: e.$t("common.searchUserByNameEmail") }, on: { debounced: e.onDebounced } }), e.loading ? t("app-overlay", { attrs: { "full-page": !1, "center-content": !0, theme: "light" } }, [t("app-loading")], 1) : e._e(), e.isEmpty ? t("app-empty-view", { attrs: { theme: "white", title: e.emptyViewMessage, "fa-icon": "fa-regular fa-magnifying-glass" } }) : t("app-data-grid", { key: e.reloadKey, staticClass: "search-results-grid", attrs: { data: e.mappedUsers, config: e.gridConfig }, scopedSlots: e._u([{ key: "default", fn: function({ item: i }) {
    return [t("team-member-card", { attrs: { "user-data": i } })];
  } }]), model: { value: e.selection, callback: function(i) {
    e.selection = i;
  }, expression: "selection" } })], 1);
}, gv = [], yv = /* @__PURE__ */ x(
  fv,
  mv,
  gv,
  !1,
  null,
  "40bdb1c0"
);
const fc = yv.exports, bv = f({
  props: {
    value: {
      type: Array,
      required: !0
    },
    catalog: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      query: "",
      selection: []
    };
  },
  watch: {
    value(e) {
      this.selection = e;
    }
  },
  computed: {
    optionsAll() {
      return [...this.catalog].sort().map((e) => ({
        text: e,
        value: e
      }));
    },
    optionsFiltered() {
      const e = this.query.toUpperCase();
      return this.optionsAll.filter(
        (t) => t.text.toUpperCase().includes(e)
      );
    },
    permissionGlobalOption() {
      return {
        text: this.$t("modal.uploadPermissions.allRoles"),
        value: "*"
      };
    }
  },
  methods: {
    onToggleOpen(e) {
      e || (this.query = "");
    },
    onUpdate(e) {
      this.$emit("input", e);
    }
  }
});
var vv = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-multiselect", { staticClass: "selector", attrs: { placeholder: e.placeholder, options: e.optionsFiltered, "options-pool": e.optionsAll, "global-selection": e.permissionGlobalOption, "search-enabled": !0 }, on: { "toggle-open": e.onToggleOpen, "update-multiple": e.onUpdate }, scopedSlots: e._u([{ key: "search", fn: function() {
    return [t("app-search-input", { staticClass: "inner-search", attrs: { placeholder: e.searchPlaceholder }, model: { value: e.query, callback: function(i) {
      e.query = i;
    }, expression: "query" } })];
  }, proxy: !0 }]), model: { value: e.selection, callback: function(i) {
    e.selection = i;
  }, expression: "selection" } });
}, Av = [], kv = /* @__PURE__ */ x(
  bv,
  vv,
  Av,
  !1,
  null,
  "0e13a8e7"
);
const wv = kv.exports, xv = f({
  components: {
    PermissionsMultiselect: wv,
    SelectTeamMembers: fc
  },
  props: {
    productId: {
      type: String,
      required: !0
    },
    ticketId: {
      type: String,
      required: !0
    },
    file: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      selectedPermissions: [],
      allPermissions: []
    };
  },
  async created() {
    var e;
    await this.loadPermissions(), this.selectedPermissions = (e = this.file.roles) != null && e.length ? this.file.roles : ["*"];
  },
  methods: {
    async loadPermissions() {
      const e = await this.$api.role.fetchAllRoles();
      this.allPermissions = e.map((t) => t.name);
    },
    async onUploadPermissions() {
      const e = this.selectedPermissions[0] === "*" ? [] : this.selectedPermissions;
      await this.$api.ticketFileUpload.updateTicketFilePermissions(
        this.productId,
        this.ticketId,
        this.file.id,
        e
      ), this.$emit("permissions-updated");
    }
  }
});
var Cv = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { staticClass: "modal", on: { "click-outside": function(i) {
    return e.$emit("close");
  } } }, [t("div", { staticClass: "modal-container" }, [t("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: function(i) {
    return e.$emit("close");
  } } }, [t("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1), t("h3", { staticClass: "modal-title" }, [e._v(" " + e._s(e.$t("modal.uploadPermissions.title")) + " ")]), t("div", { staticClass: "modal-description" }, [e._v(e._s(e.$t("modal.uploadPermissions.description")))]), t("permissions-multiselect", { attrs: { "search-placeholder": e.$t("modal.uploadPermissions.searchPlaceholder"), placeholder: e.$t("modal.uploadPermissions.placeholder"), catalog: e.allPermissions }, model: { value: e.selectedPermissions, callback: function(i) {
    e.selectedPermissions = i;
  }, expression: "selectedPermissions" } }), t("div", { staticClass: "modal-footer" }, [t("app-button", { staticClass: "button", attrs: { label: e.$t("common.form.apply") }, on: { click: e.onUploadPermissions } })], 1)], 1)]);
}, Sv = [], Iv = /* @__PURE__ */ x(
  xv,
  Cv,
  Sv,
  !1,
  null,
  "086bea78"
);
const Dv = Iv.exports;
f({
  name: "Countdown",
  props: {
    endDate: {
      type: Date,
      required: !0
    }
  },
  data() {
    return {
      intervalId: 0,
      timeRemaining: 0
    };
  },
  mounted() {
    this.timeRemaining = this.endDate.getTime() - Date.now(), this.intervalId = window.setInterval(() => {
      this.timeRemaining = this.endDate.getTime() - Date.now();
    }, 1e3);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  computed: {
    totalSeconds() {
      return Math.floor(this.timeRemaining / 1e3);
    },
    days() {
      return Math.floor(this.totalSeconds / 3600 / 24).toString().padStart(2, "0");
    },
    hours() {
      return (Math.floor(this.totalSeconds / 3600) % 24).toString().padStart(2, "0");
    },
    minutes() {
      return (Math.floor(this.totalSeconds / 60) % 60).toString().padStart(2, "0");
    },
    seconds() {
      return (this.totalSeconds % 60).toString().padStart(2, "0");
    }
  }
});
const Pv = f({
  props: {
    image: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    date: {
      type: Date,
      required: !0
    }
  },
  computed: {
    displayDate() {
      return Intl.DateTimeFormat(void 0, {
        dateStyle: "medium"
      }).format(new Date(this.date));
    },
    //Testing relative formatting on dev
    displayRelativeDate() {
      const e = Math.round(
        (this.date.getTime() - Date.now()) / 1e3
      ), t = [60, 3600, 86400, 86400 * 30, 86400 * 365, 1 / 0], i = [
        "second",
        "minute",
        "hour",
        "day",
        "month",
        "year"
      ], r = t.findIndex(
        (n) => n > Math.abs(e)
      ), s = r ? t[r - 1] : 1;
      return new Intl.RelativeTimeFormat(void 0, {
        numeric: "auto"
      }).format(
        Math.round(e / s),
        i[r]
      );
    }
  }
});
var Tv = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "activity-feed-item" }, [t("div", { staticClass: "feed-item-header" }, [t("img", { staticClass: "item-header-image", attrs: { src: e.image } }), t("div", { staticClass: "item-header-content" }, [t("div", { staticClass: "item-header-title" }, [e._v(e._s(e.title))]), t("div", { staticClass: "item-header-date" }, [e._v(e._s(e.displayRelativeDate))])])]), t("div", { staticClass: "feed-item-content" }, [e._t("content")], 2)]);
}, Ov = [], Bv = /* @__PURE__ */ x(
  Pv,
  Tv,
  Ov,
  !1,
  null,
  "921924d9"
);
const Rr = Bv.exports, Mv = "/img/profile-placeholder.svg";
f({
  components: {
    ActivityItem: Rr
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    data: {
      type: [],
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    }
  },
  computed: {
    eventType() {
      return this.data[0];
    },
    entry() {
      return this.data[1];
    },
    ticketResponse() {
      return this.data[2];
    },
    user() {
      return this.data[3];
    },
    userName() {
      return B({ user: this.user }).displayName();
    },
    activityTitle() {
      const e = this.$t("activityFeed.commentAddTitle", {
        userName: this.userName
      }).toString();
      return e.charAt(0).toUpperCase() + e.slice(1);
    },
    activityImage() {
      return this.user.avatar || Mv;
    },
    activityDate() {
      return new Date(this.entry["@timestamp"]);
    },
    routeToTicket() {
      return {
        name: "TicketDetails",
        params: { id: this.ticketResponse.ticket.canonicalId }
      };
    }
  }
});
const Rv = "/img/profile-placeholder.svg";
f({
  components: {
    ActivityItem: Rr,
    FeedbackActivityCard: xy
  },
  props: {
    data: {
      type: [],
      required: !0
    }
  },
  computed: {
    eventType() {
      return this.data[0];
    },
    entry() {
      return this.data[1];
    },
    parentTicket() {
      return this.data[2];
    },
    feedbackTicket() {
      return this.data[3];
    },
    user() {
      return this.data[4];
    },
    userName() {
      return B({ user: this.user }).displayName();
    },
    activityTitle() {
      const e = this.$t("activityFeed.feedbackCreatedTitle", {
        userName: this.userName,
        ticketTitle: this.parentTicket.title
      }).toString();
      return e.charAt(0).toUpperCase() + e.slice(1);
    },
    activityImage() {
      return this.user.avatar || Rv;
    },
    activityDate() {
      return new Date(this.entry["@timestamp"]);
    },
    routeToTicket() {
      return {
        name: "TicketDetails",
        params: { id: this.parentTicket.canonicalId }
      };
    }
  },
  methods: {
    getTicketImage(e) {
      const t = e.meta.cover;
      if (t)
        return t;
      const i = e.files.find((r) => r.category === "ticket-cover");
      return (i == null ? void 0 : i.url) || "";
    }
  }
});
const Ev = "/img/profile-placeholder.svg";
f({
  components: {
    ActivityItem: Rr
  },
  props: {
    data: {
      type: [],
      required: !0
    }
  },
  computed: {
    eventType() {
      return this.data[0];
    },
    entry() {
      return this.data[1];
    },
    offer() {
      return this.data[2];
    },
    workgroup() {
      return this.data[3];
    },
    ticket() {
      return this.data[4];
    },
    user() {
      return this.data[5];
    },
    userName() {
      return B({ user: this.user }).displayName();
    },
    activityTitle() {
      const e = this.$t("activityFeed.offerPurchasedTitle", {
        userName: this.userName,
        ticketTitle: this.ticket.title
      }).toString();
      return e.charAt(0).toUpperCase() + e.slice(1);
    },
    activityImage() {
      return this.user.avatar || Ev;
    },
    activityDate() {
      return new Date(this.entry["@timestamp"]);
    },
    routeToTicket() {
      return {
        name: "TicketDetails",
        params: { id: this.ticket.canonicalId }
      };
    }
  }
});
const Lv = "/img/profile-placeholder.svg";
f({
  components: {
    ActivityItem: Rr
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    data: {
      type: [],
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    eventType() {
      return this.data[0];
    },
    entry() {
      return this.data[1];
    },
    ticketResponse() {
      return this.data[2];
    },
    user() {
      return this.data[3];
    },
    userName() {
      return B({ user: this.user }).displayName();
    },
    activityTitle() {
      const e = this.$t("activityFeed.statusChangeTitle", {
        userName: this.userName,
        ticketTitle: this.ticketResponse.ticket.title,
        statusFrom: this.previousStatus,
        statusTo: this.nextStatus
      }).toString();
      return e.charAt(0).toUpperCase() + e.slice(1);
    },
    activityImage() {
      return this.user.avatar || Lv;
    },
    activityDate() {
      return new Date(this.entry["@timestamp"]);
    },
    previousStatus() {
      var e;
      const t = J(
        this.entry.meta.oldStatus,
        this.ticketResponse.workflow
      );
      return ((e = this.$res(t)) == null ? void 0 : e.label) ?? this.entry.meta.status;
    },
    nextStatus() {
      var e;
      const t = J(
        this.entry.meta.status,
        this.ticketResponse.workflow
      );
      return ((e = this.$res(t)) == null ? void 0 : e.label) ?? this.entry.meta.status;
    },
    routeToTicket() {
      return {
        name: "TicketDetails",
        params: { id: this.ticketResponse.ticket.canonicalId }
      };
    }
  }
});
f({
  props: {
    feed: {
      type: Array,
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    },
    organization: {
      type: Object,
      required: !0
    }
  },
  computed: {
    empty() {
      return this.feed.length === 0;
    }
  },
  methods: {
    activityItemComponent(e) {
      switch (e[0]) {
        case "status-updated":
          return "activity-item-status-updated";
        case "comment-added":
          return "activity-item-comment-added";
        case "offer-purchased":
          return "activity-item-offer-purchased";
        case "feedback-created":
          return "activity-item-feedback-created";
        default:
          throw new Error(`Unknown activity item type: '${e[0]}'`);
      }
    }
  }
});
const Fv = "/img/profile-placeholder.svg";
f({
  props: {
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      data: []
    };
  },
  async created() {
    try {
      this.loading = !0, this.data = await this.$gateway.activity.loadTopCommenters(
        this.productId,
        5
      );
    } catch (e) {
      console.error("Could not load top commenters", e), this.$toast(this.$t("error.general").toString());
    } finally {
      this.loading = !1;
    }
  },
  computed: {
    viewState() {
      return this.loading ? "loading" : this.data.length === 0 ? "empty" : "ready";
    }
  },
  methods: {
    getUserAvatar(e) {
      return e.avatar || Fv;
    },
    getUserName(e) {
      return B({ user: e }).displayName();
    },
    getActivityDescription(e) {
      return this.$tc(
        "activityFeed.topCommenters.itemDescription",
        e.activityCount
      ).toString();
    },
    routeToUser(e) {
      return {
        name: "UserProfile",
        params: { userId: e.id }
      };
    }
  }
});
const jv = "/img/profile-placeholder.svg";
f({
  props: {
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      data: []
    };
  },
  async created() {
    try {
      this.loading = !0, this.data = await this.$gateway.activity.loadTopReactors(
        this.productId,
        5
      );
    } catch (e) {
      console.error("Could not load top reactors", e), this.$toast(this.$t("error.general").toString());
    } finally {
      this.loading = !1;
    }
  },
  computed: {
    viewState() {
      return this.loading ? "loading" : this.data.length === 0 ? "empty" : "ready";
    }
  },
  methods: {
    getUserAvatar(e) {
      return e.avatar || jv;
    },
    getUserName(e) {
      return B({ user: e }).displayName();
    },
    getActivityDescription(e) {
      return this.$tc(
        "activityFeed.topReactors.itemDescription",
        e.activityCount
      ).toString();
    },
    routeToUser(e) {
      return {
        name: "UserProfile",
        params: { userId: e.id }
      };
    }
  }
});
const Uv = "/img/profile-placeholder.svg";
f({
  props: {
    contextId: {
      type: String,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: !0,
      data: []
    };
  },
  async mounted() {
    try {
      this.loading = !0, this.data = await this.$gateway.portal.loadActivityTickets(
        this.contextId,
        this.productId,
        10
      );
    } catch (e) {
      console.error("Could not load latest ideas", e), this.$toast(this.$t("error.general").toString());
    } finally {
      this.loading = !1;
    }
  },
  computed: {
    viewState() {
      return this.loading ? "loading" : this.data.length === 0 ? "empty" : "ready";
    }
  },
  methods: {
    userName(e) {
      return e ? B({ user: e }).displayName() : "";
    },
    activityTitle(e) {
      const t = this.$t("activityFeed.ticketCreatedTitle", {
        userName: this.userName(e)
      }).toString();
      return t.charAt(0).toUpperCase() + t.slice(1);
    },
    activityImage(e) {
      return (e == null ? void 0 : e.avatar) || Uv;
    },
    activityDate(e) {
      return new Date(e.createdDate);
    },
    routeToTicket(e) {
      return {
        name: "TicketDetails",
        params: { id: e.canonicalId }
      };
    }
  }
});
f({
  props: {
    contextId: {
      type: String,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: !0,
      data: []
    };
  },
  async created() {
    try {
      this.loading = !0, this.data = await this.$gateway.activity.loadPopularTickets(
        this.productId,
        this.contextId,
        3
      );
    } catch (e) {
      console.error("Could not load popular tickets", e), this.$toast(this.$t("error.general").toString());
    } finally {
      this.loading = !1;
    }
  },
  computed: {
    visible() {
      return this.viewState === "ready";
    },
    viewState() {
      return this.loading ? "loading" : this.data.length === 0 ? "empty" : "ready";
    }
  },
  methods: {
    routeToTicket(e) {
      return {
        name: "TicketDetails",
        params: { id: e.ticket.canonicalId }
      };
    }
  }
});
f({
  props: {
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !0,
      data: [],
      allStats: {}
    };
  },
  async mounted() {
    try {
      this.loading = !0;
      const e = await this.$datasource.topic.listPopular(
        this.productId,
        6
      ), t = cc(e, (i) => i.id);
      this.allStats = await this.$api.stats.fetchTopicStatsByBatch(
        t,
        this.productId
      ), this.data = e;
    } catch (e) {
      console.error("Could not load popular topics", e), this.$toast(this.$t("error.general").toString());
    } finally {
      this.loading = !1;
    }
  },
  computed: {
    visible() {
      return this.viewState === "ready";
    },
    viewState() {
      return this.loading ? "loading" : this.data.length === 0 ? "empty" : "ready";
    }
  },
  methods: {
    getTopicStats(e) {
      return this.allStats[e.id];
    },
    routeToTopic(e) {
      return {
        name: "TopicDetails",
        params: { id: e.id }
      };
    },
    goToTopicsPage() {
      this.$router.push({ name: "TopicOverview" });
    }
  }
});
const qv = De.extend({
  name: "AddButton",
  props: {
    text: {
      type: String,
      default: "Add"
    },
    icon: {
      type: String,
      default: "fa-solid fa-plus"
    },
    enabled: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    onClick() {
      this.enabled && this.$emit("click");
    }
  }
});
var Hv = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "add-button-container", class: { disabled: !e.enabled }, on: { click: e.onClick } }, [t("div", { staticClass: "button-text" }, [t("fa-icon-compat", { attrs: { icon: e.icon } }), e._v(" " + e._s(e.text) + " ")], 1)]);
}, zv = [], Nv = /* @__PURE__ */ x(
  qv,
  Hv,
  zv,
  !1,
  null,
  "9690e33e"
);
const Vv = Nv.exports;
var fo = function(e, t, i, r) {
  if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return i === "m" ? r : i === "a" ? r.call(e) : r ? r.value : t.get(e);
}, hr, js;
const Gv = [
  "[data-md-button]",
  "md-header",
  "md-bold",
  "md-italic",
  "md-quote",
  "md-code",
  "md-link",
  "md-image",
  "md-unordered-list",
  "md-ordered-list",
  "md-task-list",
  "md-mention",
  "md-ref",
  "md-strikethrough"
];
function mc(e) {
  const t = [];
  for (const i of e.querySelectorAll(Gv.join(", ")))
    i.hidden || i.offsetWidth <= 0 && i.offsetHeight <= 0 || i.closest("markdown-toolbar") === e && t.push(i);
  return t;
}
function gc(e) {
  return function(t) {
    (t.key === " " || t.key === "Enter") && e(t);
  };
}
const ke = /* @__PURE__ */ new WeakMap(), Wv = {
  "header-1": { prefix: "# " },
  "header-2": { prefix: "## " },
  "header-3": { prefix: "### " },
  "header-4": { prefix: "#### " },
  "header-5": { prefix: "##### " },
  "header-6": { prefix: "###### " },
  bold: { prefix: "**", suffix: "**", trimFirst: !0 },
  italic: { prefix: "_", suffix: "_", trimFirst: !0 },
  quote: { prefix: "> ", multiline: !0, surroundWithNewlines: !0 },
  code: {
    prefix: "`",
    suffix: "`",
    blockPrefix: "```",
    blockSuffix: "```"
  },
  link: { prefix: "[", suffix: "](url)", replaceNext: "url", scanFor: "https?://" },
  image: { prefix: "![", suffix: "](url)", replaceNext: "url", scanFor: "https?://" },
  "unordered-list": {
    prefix: "- ",
    multiline: !0,
    unorderedList: !0
  },
  "ordered-list": {
    prefix: "1. ",
    multiline: !0,
    orderedList: !0
  },
  "task-list": { prefix: "- [ ] ", multiline: !0, surroundWithNewlines: !0 },
  mention: { prefix: "@", prefixSpace: !0 },
  ref: { prefix: "#", prefixSpace: !0 },
  strikethrough: { prefix: "~~", suffix: "~~", trimFirst: !0 }
};
class Pe extends HTMLElement {
  constructor() {
    super();
    const t = (i) => {
      const r = ke.get(this);
      r && (i.preventDefault(), qs(this, r));
    };
    this.addEventListener("keydown", gc(t)), this.addEventListener("click", t);
  }
  connectedCallback() {
    this.hasAttribute("role") || this.setAttribute("role", "button");
  }
  click() {
    const t = ke.get(this);
    t && qs(this, t);
  }
}
class mo extends Pe {
  constructor() {
    super(...arguments), hr.add(this);
  }
  connectedCallback() {
    const t = parseInt(this.getAttribute("level") || "3", 10);
    fo(this, hr, "m", js).call(this, t);
  }
  static get observedAttributes() {
    return ["level"];
  }
  attributeChangedCallback(t, i, r) {
    if (t !== "level")
      return;
    const s = parseInt(r || "3", 10);
    fo(this, hr, "m", js).call(this, s);
  }
}
hr = /* @__PURE__ */ new WeakSet(), js = function(e) {
  if (e < 1 || e > 6)
    return;
  const t = `${"#".repeat(e)} `;
  ke.set(this, {
    prefix: t
  });
};
window.customElements.get("md-header") || (window.MarkdownHeaderButtonElement = mo, window.customElements.define("md-header", mo));
class go extends Pe {
  connectedCallback() {
    ke.set(this, { prefix: "**", suffix: "**", trimFirst: !0 });
  }
}
window.customElements.get("md-bold") || (window.MarkdownBoldButtonElement = go, window.customElements.define("md-bold", go));
class yo extends Pe {
  connectedCallback() {
    ke.set(this, { prefix: "_", suffix: "_", trimFirst: !0 });
  }
}
window.customElements.get("md-italic") || (window.MarkdownItalicButtonElement = yo, window.customElements.define("md-italic", yo));
class bo extends Pe {
  connectedCallback() {
    ke.set(this, { prefix: "> ", multiline: !0, surroundWithNewlines: !0 });
  }
}
window.customElements.get("md-quote") || (window.MarkdownQuoteButtonElement = bo, window.customElements.define("md-quote", bo));
class vo extends Pe {
  connectedCallback() {
    ke.set(this, { prefix: "`", suffix: "`", blockPrefix: "```", blockSuffix: "```" });
  }
}
window.customElements.get("md-code") || (window.MarkdownCodeButtonElement = vo, window.customElements.define("md-code", vo));
class Ao extends Pe {
  connectedCallback() {
    ke.set(this, { prefix: "[", suffix: "](url)", replaceNext: "url", scanFor: "https?://" });
  }
}
window.customElements.get("md-link") || (window.MarkdownLinkButtonElement = Ao, window.customElements.define("md-link", Ao));
class ko extends Pe {
  connectedCallback() {
    ke.set(this, { prefix: "![", suffix: "](url)", replaceNext: "url", scanFor: "https?://" });
  }
}
window.customElements.get("md-image") || (window.MarkdownImageButtonElement = ko, window.customElements.define("md-image", ko));
class wo extends Pe {
  connectedCallback() {
    ke.set(this, { prefix: "- ", multiline: !0, unorderedList: !0 });
  }
}
window.customElements.get("md-unordered-list") || (window.MarkdownUnorderedListButtonElement = wo, window.customElements.define("md-unordered-list", wo));
class xo extends Pe {
  connectedCallback() {
    ke.set(this, { prefix: "1. ", multiline: !0, orderedList: !0 });
  }
}
window.customElements.get("md-ordered-list") || (window.MarkdownOrderedListButtonElement = xo, window.customElements.define("md-ordered-list", xo));
class Co extends Pe {
  connectedCallback() {
    ke.set(this, { prefix: "- [ ] ", multiline: !0, surroundWithNewlines: !0 });
  }
}
window.customElements.get("md-task-list") || (window.MarkdownTaskListButtonElement = Co, window.customElements.define("md-task-list", Co));
class So extends Pe {
  connectedCallback() {
    ke.set(this, { prefix: "@", prefixSpace: !0 });
  }
}
window.customElements.get("md-mention") || (window.MarkdownMentionButtonElement = So, window.customElements.define("md-mention", So));
class Io extends Pe {
  connectedCallback() {
    ke.set(this, { prefix: "#", prefixSpace: !0 });
  }
}
window.customElements.get("md-ref") || (window.MarkdownRefButtonElement = Io, window.customElements.define("md-ref", Io));
class Do extends Pe {
  connectedCallback() {
    ke.set(this, { prefix: "~~", suffix: "~~", trimFirst: !0 });
  }
}
window.customElements.get("md-strikethrough") || (window.MarkdownStrikethroughButtonElement = Do, window.customElements.define("md-strikethrough", Do));
function Po(e) {
  const { target: t, currentTarget: i } = e;
  if (!(t instanceof Element))
    return;
  const r = t.closest("[data-md-button]");
  if (!r || r.closest("markdown-toolbar") !== i)
    return;
  const s = r.getAttribute("data-md-button"), n = Wv[s];
  n && (e.preventDefault(), qs(t, n));
}
function To(e) {
  e.addEventListener("keydown", bc), e.setAttribute("tabindex", "0"), e.addEventListener("focus", yc, { once: !0 });
}
function Oo(e) {
  e.removeEventListener("keydown", bc), e.removeAttribute("tabindex"), e.removeEventListener("focus", yc);
}
class wr extends HTMLElement {
  connectedCallback() {
    this.hasAttribute("role") || this.setAttribute("role", "toolbar"), this.hasAttribute("data-no-focus") || To(this), this.addEventListener("keydown", gc(Po)), this.addEventListener("click", Po);
  }
  attributeChangedCallback(t, i, r) {
    t === "data-no-focus" && (r === null ? To(this) : Oo(this));
  }
  disconnectedCallback() {
    Oo(this);
  }
  get field() {
    const t = this.getAttribute("for");
    if (!t)
      return null;
    const i = "getRootNode" in this ? this.getRootNode() : document;
    let r;
    return (i instanceof Document || i instanceof ShadowRoot) && (r = i.getElementById(t)), r instanceof HTMLTextAreaElement ? r : null;
  }
}
wr.observedAttributes = ["data-no-focus"];
function yc({ target: e }) {
  if (!(e instanceof Element))
    return;
  e.removeAttribute("tabindex");
  let t = "0";
  for (const i of mc(e))
    i.setAttribute("tabindex", t), t === "0" && (i.focus(), t = "-1");
}
function bc(e) {
  const t = e.key;
  if (t !== "ArrowRight" && t !== "ArrowLeft" && t !== "Home" && t !== "End")
    return;
  const i = e.currentTarget;
  if (!(i instanceof HTMLElement))
    return;
  const r = mc(i), s = r.indexOf(e.target), n = r.length;
  if (s === -1)
    return;
  let a = 0;
  t === "ArrowLeft" && (a = s - 1), t === "ArrowRight" && (a = s + 1), t === "End" && (a = n - 1), a < 0 && (a = n - 1), a > n - 1 && (a = 0);
  for (let o = 0; o < n; o += 1)
    r[o].setAttribute("tabindex", o === a ? "0" : "-1");
  e.preventDefault(), r[a].focus();
}
window.customElements.get("markdown-toolbar") || (window.MarkdownToolbarElement = wr, window.customElements.define("markdown-toolbar", wr));
function Us(e) {
  return e.trim().split(`
`).length > 1;
}
function Bo(e, t) {
  return Array(t + 1).join(e);
}
function Qv(e, t) {
  let i = t;
  for (; e[i] && e[i - 1] != null && !e[i - 1].match(/\s/); )
    i--;
  return i;
}
function Xv(e, t, i) {
  let r = t;
  const s = i ? /\n/ : /\s/;
  for (; e[r] && !e[r].match(s); )
    r++;
  return r;
}
let kt = null;
function Kv(e, { text: t, selectionStart: i, selectionEnd: r }) {
  const s = e.selectionStart, n = e.value.slice(0, s), a = e.value.slice(e.selectionEnd);
  if (kt === null || kt === !0) {
    e.contentEditable = "true";
    try {
      kt = document.execCommand("insertText", !1, t);
    } catch {
      kt = !1;
    }
    e.contentEditable = "false";
  }
  if (kt && !e.value.slice(0, e.selectionStart).endsWith(t) && (kt = !1), !kt) {
    try {
      document.execCommand("ms-beginUndoUnit");
    } catch {
    }
    e.value = n + t + a;
    try {
      document.execCommand("ms-endUndoUnit");
    } catch {
    }
    e.dispatchEvent(new CustomEvent("input", { bubbles: !0, cancelable: !0 }));
  }
  i != null && r != null ? e.setSelectionRange(i, r) : e.setSelectionRange(s, e.selectionEnd);
}
function Yv(e, t) {
  const i = e.value.slice(e.selectionStart, e.selectionEnd);
  let r;
  t.orderedList || t.unorderedList ? r = tA(e, t) : t.multiline && Us(i) ? r = $v(e, t) : r = _v(e, t), Kv(e, r);
}
function Zv(e) {
  const t = e.value.split(`
`);
  let i = 0;
  for (let r = 0; r < t.length; r++) {
    const s = t[r].length + 1;
    e.selectionStart >= i && e.selectionStart < i + s && (e.selectionStart = i), e.selectionEnd >= i && e.selectionEnd < i + s && (e.selectionEnd = i + s - 1), i += s;
  }
}
function Jv(e, t, i, r = !1) {
  if (e.selectionStart === e.selectionEnd)
    e.selectionStart = Qv(e.value, e.selectionStart), e.selectionEnd = Xv(e.value, e.selectionEnd, r);
  else {
    const s = e.selectionStart - t.length, n = e.selectionEnd + i.length, a = e.value.slice(s, e.selectionStart) === t, o = e.value.slice(e.selectionEnd, n) === i;
    a && o && (e.selectionStart = s, e.selectionEnd = n);
  }
  return e.value.slice(e.selectionStart, e.selectionEnd);
}
function ln(e) {
  const t = e.value.slice(0, e.selectionStart), i = e.value.slice(e.selectionEnd), r = t.match(/\n*$/), s = i.match(/^\n*/), n = r ? r[0].length : 0, a = s ? s[0].length : 0;
  let o, l;
  return t.match(/\S/) && n < 2 && (o = Bo(`
`, 2 - n)), i.match(/\S/) && a < 2 && (l = Bo(`
`, 2 - a)), o == null && (o = ""), l == null && (l = ""), { newlinesToAppend: o, newlinesToPrepend: l };
}
function _v(e, t) {
  let i, r;
  const { prefix: s, suffix: n, blockPrefix: a, blockSuffix: o, replaceNext: l, prefixSpace: c, scanFor: u, surroundWithNewlines: d } = t, h = e.selectionStart, p = e.selectionEnd;
  let m = e.value.slice(e.selectionStart, e.selectionEnd), g = Us(m) && a.length > 0 ? `${a}
` : s, y = Us(m) && o.length > 0 ? `
${o}` : n;
  if (c) {
    const A = e.value[e.selectionStart - 1];
    e.selectionStart !== 0 && A != null && !A.match(/\s/) && (g = ` ${g}`);
  }
  m = Jv(e, g, y, t.multiline);
  let v = e.selectionStart, w = e.selectionEnd;
  const C = l.length > 0 && y.indexOf(l) > -1 && m.length > 0;
  if (d) {
    const A = ln(e);
    i = A.newlinesToAppend, r = A.newlinesToPrepend, g = i + s, y += r;
  }
  if (m.startsWith(g) && m.endsWith(y)) {
    const A = m.slice(g.length, m.length - y.length);
    if (h === p) {
      let k = h - g.length;
      k = Math.max(k, v), k = Math.min(k, v + A.length), v = w = k;
    } else
      w = v + A.length;
    return { text: A, selectionStart: v, selectionEnd: w };
  } else if (C)
    if (u.length > 0 && m.match(u)) {
      y = y.replace(l, m);
      const A = g + y;
      return v = w = v + g.length, { text: A, selectionStart: v, selectionEnd: w };
    } else {
      const A = g + m + y;
      return v = v + g.length + m.length + y.indexOf(l), w = v + l.length, { text: A, selectionStart: v, selectionEnd: w };
    }
  else {
    let A = g + m + y;
    v = h + g.length, w = p + g.length;
    const k = m.match(/^\s*|\s*$/g);
    if (t.trimFirst && k) {
      const S = k[0] || "", D = k[1] || "";
      A = S + g + m.trim() + y + D, v += S.length, w -= D.length;
    }
    return { text: A, selectionStart: v, selectionEnd: w };
  }
}
function $v(e, t) {
  const { prefix: i, suffix: r, surroundWithNewlines: s } = t;
  let n = e.value.slice(e.selectionStart, e.selectionEnd), a = e.selectionStart, o = e.selectionEnd;
  const l = n.split(`
`);
  if (l.every((c) => c.startsWith(i) && c.endsWith(r)))
    n = l.map((c) => c.slice(i.length, c.length - r.length)).join(`
`), o = a + n.length;
  else if (n = l.map((c) => i + c + r).join(`
`), s) {
    const { newlinesToAppend: c, newlinesToPrepend: u } = ln(e);
    a += c.length, o = a + n.length, n = c + n + u;
  }
  return { text: n, selectionStart: a, selectionEnd: o };
}
function Mo(e) {
  const t = e.split(`
`), i = /^\d+\.\s+/, r = t.every((n) => i.test(n));
  let s = t;
  return r && (s = t.map((n) => n.replace(i, ""))), {
    text: s.join(`
`),
    processed: r
  };
}
function Ro(e) {
  const t = e.split(`
`), i = "- ", r = t.every((n) => n.startsWith(i));
  let s = t;
  return r && (s = t.map((n) => n.slice(i.length, n.length))), {
    text: s.join(`
`),
    processed: r
  };
}
function ci(e, t) {
  return t ? "- " : `${e + 1}. `;
}
function eA(e, t) {
  let i, r, s;
  return e.orderedList ? (r = Mo(t), i = Ro(r.text), s = i.text) : (r = Ro(t), i = Mo(r.text), s = i.text), [r, i, s];
}
function tA(e, t) {
  const i = e.selectionStart === e.selectionEnd;
  let r = e.selectionStart, s = e.selectionEnd;
  Zv(e);
  const n = e.value.slice(e.selectionStart, e.selectionEnd), [a, o, l] = eA(t, n), c = l.split(`
`).map((g, y) => `${ci(y, t.unorderedList)}${g}`), u = c.reduce((g, y, v) => g + ci(v, t.unorderedList).length, 0), d = c.reduce((g, y, v) => g + ci(v, !t.unorderedList).length, 0);
  if (a.processed)
    return i ? (r = Math.max(r - ci(0, t.unorderedList).length, 0), s = r) : (r = e.selectionStart, s = e.selectionEnd - u), { text: l, selectionStart: r, selectionEnd: s };
  const { newlinesToAppend: h, newlinesToPrepend: p } = ln(e), m = h + c.join(`
`) + p;
  return i ? (r = Math.max(r + ci(0, t.unorderedList).length + h.length, 0), s = r) : o.processed ? (r = Math.max(e.selectionStart + h.length, 0), s = e.selectionEnd + h.length + u - d) : (r = Math.max(e.selectionStart + h.length, 0), s = e.selectionEnd + h.length + u), { text: m, selectionStart: r, selectionEnd: s };
}
function qs(e, t) {
  const i = e.closest("markdown-toolbar");
  if (!(i instanceof wr))
    return;
  const r = Object.assign(Object.assign({}, {
    prefix: "",
    suffix: "",
    blockPrefix: "",
    blockSuffix: "",
    multiline: !1,
    replaceNext: "",
    prefixSpace: !1,
    scanFor: "",
    surroundWithNewlines: !1,
    orderedList: !1,
    unorderedList: !1,
    trimFirst: !1
  }), t), s = i.field;
  s && (s.focus(), Yv(s, r));
}
const iA = f({
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  components: {
    AppMarkdownText: je
  },
  methods: {
    closeModal() {
      this.$emit("close");
    }
  }
});
var rA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { on: { "click-outside": e.closeModal } }, [t("div", { staticClass: "modal-content" }, [t("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: e.closeModal } }, [t("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1), t("app-markdown-text", { attrs: { text: e.text } })], 1)]);
}, sA = [], nA = /* @__PURE__ */ x(
  iA,
  rA,
  sA,
  !1,
  null,
  "a6e954d9"
);
const aA = nA.exports, oA = f({
  components: { AppMarkdownPreviewModal: aA },
  props: {
    showHint: {
      type: Boolean,
      default: !1
    },
    options: {
      type: Array,
      default: () => []
    },
    textAreaId: {
      type: String,
      required: !0
    },
    text: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showPreview: !1
    };
  },
  methods: {
    getIcon(e) {
      switch (e) {
        case "unordered-list":
          return "fa-solid fa-list-ul";
        case "ordered-list":
          return "fa-solid fa-list-ol";
        default:
          return `fa-solid fa-${e}`;
      }
    },
    getTooltip(e) {
      return this.$t(`common.markdown.tooltip.${e}`).toString();
    },
    closeModal() {
      this.showPreview = !1;
    }
  }
});
var lA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [e.showHint ? t("div", { staticClass: "markdown-hint" }, [t("span", [e._v(e._s(e.$t("common.markdown.supported")))]), t("a", { attrs: { href: "https://www.markdownguide.org/basic-syntax/", target: "_blank" } }, [e._v(" " + e._s(e.$t("common.markdown.here")) + " ")])]) : e._e(), t("div", { staticClass: "markdown-toolbar-container" }, [t("markdown-toolbar", { staticClass: "markdown-toolbar", attrs: { for: e.textAreaId } }, e._l(e.options, function(i) {
    return t(`md-${i}`, { key: i, tag: "component", attrs: { title: i } }, [t("app-tooltip", { attrs: { tooltip: e.getTooltip(i), placement: "top" } }, [t("app-icon-button", { attrs: { padding: 6 } }, [t("fa-icon-compat", { attrs: { icon: e.getIcon(i) } })], 1)], 1)], 1);
  }), 1), t("app-icon-button", { staticClass: "icon-preview", attrs: { enabled: !!e.text }, on: { click: function(i) {
    e.showPreview = !0;
  } } }, [e._v(" " + e._s(e.$t("common.markdown.preview")) + " ")]), e.showPreview ? t("app-markdown-preview-modal", { attrs: { text: e.text }, on: { close: function(i) {
    e.showPreview = !1;
  } } }) : e._e()], 1)]);
}, cA = [], uA = /* @__PURE__ */ x(
  oA,
  lA,
  cA,
  !1,
  null,
  "d26b1388"
);
const dA = uA.exports;
f({
  components: {
    AppMarkdownToolbar: dA
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      required: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    rows: {
      type: Number,
      default: 4
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      text: "",
      options: [
        "header",
        "bold",
        "italic",
        "link",
        "image",
        "code",
        "unordered-list",
        "ordered-list"
      ],
      textAreaId: self.crypto.randomUUID()
    };
  },
  watch: {
    value(e) {
      this.text = e;
    }
  },
  created() {
    this.text = this.value;
  },
  methods: {
    onKeydown(e) {
      this.$emit("keydown", e);
      const t = this.$el.querySelector(".app-text-area .text-area");
      t && this.$emit("selection", { selectionStart: t.selectionStart + 1 });
    }
  }
});
f({
  components: { AppMarkdownText: je },
  props: {
    title: {
      type: String,
      required: !1
    },
    description: {
      type: String,
      required: !0
    },
    bannerStyle: {
      type: String,
      default: "warning"
    }
  },
  computed: {
    bannerIcon() {
      switch (this.bannerStyle) {
        case "error":
          return "fa-light fa-ban";
        case "warning":
          return "fa-light fa-triangle-exclamation";
        case "notice":
          return "fa-light fa-circle-info";
        default:
          return "";
      }
    }
  }
});
f({});
f({
  name: "AppDeleteButton",
  props: {
    label: {
      type: String,
      required: !0
    },
    enabled: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    onClick(e) {
      this.$emit("click", e);
    }
  }
});
f({
  props: {
    value: String,
    enabled: {
      type: Boolean,
      default: !0
    },
    debounceTimeout: {
      type: Number,
      required: !1
    }
  },
  data() {
    return {
      iconSize: 20
    };
  },
  methods: {
    copyInput() {
      navigator.clipboard.writeText(this.value ?? ""), this.$toast(this.$t("common.copiedToClipboard"));
    }
  }
});
f({
  name: "AppImageUpload",
  props: {
    value: {
      type: String,
      required: !1
    },
    filePrefix: {
      type: String,
      default: "other/"
    },
    maxImageHeight: {
      type: Number,
      required: !0
    },
    maxImageWidth: {
      type: Number,
      required: !0
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    returnBlob: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      reloadKey: 0,
      imageCropInput: {}
    };
  },
  computed: {
    ratio() {
      return this.maxImageWidth / this.maxImageHeight;
    }
  },
  methods: {
    setImageUrl(e) {
      this.$emit("input", e ?? ""), this.resetInput();
    },
    onImageInput(e) {
      this.imageCropInput = e;
    },
    async onAcceptImageCrop(e) {
      if (this.returnBlob) {
        this.$emit("crop-accept", e), this.setImageUrl();
        return;
      }
      const t = await this.$api.fileUpload.uploadFile(
        e,
        this.filePrefix
      );
      this.setImageUrl(t.payload.location);
    },
    onRejectImageCrop() {
      this.resetInput();
    },
    onChangeImage() {
      var e, t;
      const i = (t = (e = this.$refs.imageInput) == null ? void 0 : e.$refs) == null ? void 0 : t.file;
      i ? i.click() : console.error("Could trigger inner file input to replace user image");
    },
    onRemoveImage() {
      this.setImageUrl();
    },
    resetInput() {
      this.imageCropInput = {}, this.reloadKey += 1;
    }
  }
});
const hA = De.extend({
  name: "AppItemCard",
  props: {
    image: {
      type: String,
      required: !1
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      required: !1
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    shadow: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasSlotControls() {
      return !!this.$slots.control;
    }
  }
});
var pA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", e._g({ staticClass: "app-item-card", class: { clickable: e.clickable, shadow: e.shadow } }, e.$listeners), [e._t("image", function() {
    return [t("img", { staticClass: "card-image", attrs: { src: e.image } })];
  }), t("div", { staticClass: "card-content" }, [e.title ? t("div", { staticClass: "card-title" }, [e._v(" " + e._s(e.title) + " ")]) : e._e(), e.description ? t("div", { staticClass: "card-description" }, [e._t("description", function() {
    return [e._v(" " + e._s(e.description) + " ")];
  })], 2) : e._e()]), e.hasSlotControls ? t("div", { staticClass: "card-control" }, [e._t("control")], 2) : e._e()], 2);
}, fA = [], mA = /* @__PURE__ */ x(
  hA,
  pA,
  fA,
  !1,
  null,
  "f1fb7692"
);
const vc = mA.exports;
f({
  props: {
    icon: {
      type: String,
      required: !1
    },
    image: {
      type: String,
      required: !1
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      required: !1
    }
  },
  computed: {
    hasSlotControls() {
      return !!this.$slots.controls;
    }
  }
});
f({
  props: {
    value: {
      type: Object,
      required: !1
    },
    fixedDimension: {
      type: String,
      required: !1
    },
    fractionDigits: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      innerValue: 0,
      dimension: "",
      unit: ""
    };
  },
  created() {
    this.dimension = this.fixedDimension ?? "", this.validateMeasurement(this.value) && this.applyMeasurement(this.value);
  },
  watch: {
    dimension() {
      this.unit = "";
    }
  },
  computed: {
    dimensionSelectorEnabled() {
      return !this.fixedDimension;
    },
    dimensionOptions() {
      return Xg.map((e) => ({
        text: this.$t(`measure.dimension.${e}`).toString(),
        value: e
      }));
    },
    unitOptions() {
      return this.dimension ? $g[this.dimension].map((e) => ({
        text: this.$t(`measure.unit.${e}.name`).toString(),
        value: e
      })) : [];
    },
    measure() {
      return {
        dimension: this.dimension,
        unit: this.unit,
        value: this.innerValue
      };
    }
  },
  methods: {
    validateMeasurement(e) {
      return this.fixedDimension && (e == null ? void 0 : e.dimension) !== this.fixedDimension ? (console.error(
        `MeasurementInput is configured to allow only '${this.fixedDimension}'`
      ), !1) : !0;
    },
    applyMeasurement(e) {
      this.innerValue = (e == null ? void 0 : e.value) ?? 0, this.dimension = (e == null ? void 0 : e.dimension) ?? "", pt(() => {
        this.unit = (e == null ? void 0 : e.unit) ?? "";
      });
    },
    onUpdateValues() {
      const { dimension: e, unit: t } = this.measure;
      e && t ? this.$emit("input", this.measure) : this.$emit("input", void 0);
    }
  }
});
const gA = De.extend({
  name: "grid-layout",
  props: {
    columnsLg: {
      type: Number
    },
    columnsMd: {
      type: Number
    },
    columnsSm: {
      type: Number
    },
    columnsXs: {
      type: Number,
      default: 1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    columnCount() {
      switch (this.$breakpoint.name()) {
        case "xs":
          return this._columnsXs;
        case "sm":
          return this._columnsSm;
        case "md":
          return this._columnsMd;
        case "lg":
          return this._columnsLg;
        default:
          return this._columnsLg;
      }
    },
    _columnsXs() {
      return this.columnsXs;
    },
    _columnsSm() {
      return this.columnsSm || this._columnsXs;
    },
    _columnsMd() {
      return this.columnsMd || this._columnsSm;
    },
    _columnsLg() {
      return this.columnsLg || this._columnsMd;
    },
    hasPrependSlot() {
      return !!this.$slots.prepend;
    },
    style() {
      return {
        gridTemplateColumns: `repeat(${this.columnCount}, minmax(0, 1fr))`
      };
    }
  }
});
var yA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, e.loading ? t("app-overlay", { attrs: { "full-page": !1, "center-content": !0, theme: "light" } }, [t("app-loading")], 1) : t("div", { staticClass: "grid-layout", style: e.style }, [e.hasPrependSlot ? t("div", { staticClass: "grid-layout-item" }, [e._t("prepend")], 2) : e._e(), e._l(e.data, function(i) {
    return t("div", { key: i.id, staticClass: "grid-layout-item" }, [e._t("default", null, { item: i })], 2);
  })], 2);
}, bA = [], vA = /* @__PURE__ */ x(
  gA,
  yA,
  bA,
  !1,
  null,
  null
);
const AA = vA.exports;
f({
  props: {
    title: {
      type: String,
      required: !1
    },
    data: {
      type: Array,
      default: () => []
    },
    displayCount: {
      type: Number,
      default: 3
    },
    level: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      displayAll: !1
    };
  },
  computed: {
    detail() {
      return this.showDisplayAllButton ? this.data.length.toString() : "";
    },
    displayData() {
      return this.displayAll ? this.data : this.data.slice(0, this.displayCount);
    },
    showDisplayAllButton() {
      return this.data.length > this.displayCount;
    },
    viewAllText() {
      const e = this.displayAll ? "common.viewLess" : "common.viewAll";
      return this.$t(e).toString();
    }
  },
  methods: {
    toggleDisplayAllItems() {
      this.displayAll = !this.displayAll;
    }
  }
});
const Eo = 2, kA = 40;
f({
  props: {
    value: {
      type: Array,
      required: !0
    },
    skillCatalog: {
      type: Array,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      required: !0
    },
    createItemLabel: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      reloadKey: 0,
      loading: !1,
      query: "",
      selection: []
    };
  },
  watch: {
    value(e) {
      this.selection = e;
    }
  },
  computed: {
    optionsAll() {
      return [...this.skillCatalog].sort().map((e) => ({
        text: e,
        value: e
      }));
    },
    optionsFiltered() {
      if (this.query.length < Eo)
        return [];
      const e = this.query.toUpperCase();
      return this.optionsAll.filter(
        (t) => t.text.toUpperCase().includes(e)
      );
    },
    candidate() {
      const e = this.query.trim();
      if (!(e.length < Eo || e.length > kA || this.skillCatalog.some(
        (t) => t.toUpperCase() === e.toUpperCase()
      )))
        return e;
    }
  },
  methods: {
    onToggleOpen(e) {
      e || (this.query = "");
    },
    onClickCreate() {
      this.$emit("create-skill", this.candidate);
    },
    onAddItem(e) {
      this.$emit("add-skill", e);
    },
    onRemoveItem(e) {
      this.$emit("remove-skill", e);
    }
  }
});
De.extend({
  name: "ViewAllButton",
  props: {
    level: {
      type: Number,
      default: 2
    },
    text: {
      type: String,
      required: !1
    }
  },
  computed: {
    levelClass() {
      return `level-${this.level}`;
    },
    buttonText() {
      return this.text ?? this.$t("common.viewAll").toString();
    }
  }
});
De.extend({
  props: {
    value: {
      type: Array,
      default: () => []
    },
    item: null
  }
});
f({
  name: "TableIcon",
  props: {
    header: Object,
    value: null,
    item: null
  }
});
const wA = f({
  name: "ProductDropdown",
  props: {
    value: {
      type: String
    },
    context: {
      type: String,
      required: !0
    },
    products: {
      type: Array,
      required: !0
    },
    additionalSelectors: {
      type: Array,
      default: () => [],
      validator(e) {
        return e.every(
          (t) => ["all-products", "no-products"].includes(t)
        );
      }
    },
    workflows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filterSelection: this.value
    };
  },
  computed: {
    filterOptions() {
      const e = this.products.map((t) => ({
        text: t.toUpperCase(),
        value: t,
        image: this.getIcon(t)
      }));
      return this.additionalSelectors.includes("no-products") && e.unshift({
        text: this.$t("common.noProducts").toString(),
        value: "no-products",
        image: "/img/filter-none.svg"
      }), this.additionalSelectors.includes("all-products") && e.unshift({
        text: this.$t("common.allProducts").toString(),
        value: "all-products",
        image: "/img/filter-all.svg"
      }), e;
    }
  },
  methods: {
    getIcon(e) {
      const t = this.workflows.find(
        (r) => {
          var s;
          return ((s = r.product) == null ? void 0 : s.ticketType) === e;
        }
      );
      if (!t)
        return;
      const { icons: i } = Kt(t);
      return i.solid;
    },
    updatedSelections(e) {
      this.$emit("input", e);
    }
  }
});
var xA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-singleselect", e._b({ staticClass: "filter-dropdown", attrs: { options: e.filterOptions }, on: { input: e.updatedSelections }, model: { value: e.filterSelection, callback: function(i) {
    e.filterSelection = i;
  }, expression: "filterSelection" } }, "app-singleselect", e.$attrs, !1));
}, CA = [], SA = /* @__PURE__ */ x(
  wA,
  xA,
  CA,
  !1,
  null,
  "abe4381e"
);
const Ac = SA.exports;
f({});
const IA = f({
  props: {
    value: {
      type: String,
      required: !0
    },
    rows: {
      type: Number,
      default: 2
    },
    mode: {
      type: String,
      default: "view"
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      text: ""
    };
  },
  watch: {
    value(e) {
      this.text !== e && (this.text = e, this.updateSize());
    }
  },
  created() {
    this.text = this.value;
  },
  mounted() {
    this.updateSize(), setTimeout(() => {
      this.updateSize();
    }, 500), setTimeout(() => {
      this.updateSize();
    }, 1e3);
  },
  computed: {
    disabled() {
      return !this.enabled || this.mode === "view";
    }
  },
  methods: {
    onUpdateModel(e) {
      var t;
      this.$emit("input", (t = e == null ? void 0 : e.target) == null ? void 0 : t.value), this.updateSize();
    },
    updateSize() {
      const e = this.$el, { clientHeight: t, scrollHeight: i } = e;
      i > t && (e.style.height = `${e.scrollHeight + 2}px`);
    },
    onBlur(e) {
      this.$emit("blur", e);
    },
    onKeydown(e) {
      this.$emit("keydown", e);
    }
  }
});
var DA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("textarea", { directives: [{ name: "model", rawName: "v-model", value: e.text, expression: "text" }], staticClass: "editable-text-area", class: [e.mode], attrs: { disabled: e.disabled, placeholder: e.placeholder, rows: e.rows }, domProps: { value: e.text }, on: { input: [function(i) {
    i.target.composing || (e.text = i.target.value);
  }, e.onUpdateModel], blur: e.onBlur, keydown: e.onKeydown } });
}, PA = [], TA = /* @__PURE__ */ x(
  IA,
  DA,
  PA,
  !1,
  null,
  "651f8024"
);
const kc = TA.exports;
f({
  props: {
    label: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      required: !1
    },
    backgroundColor: {
      type: String,
      required: !1
    }
  },
  computed: {
    pillColour() {
      return {
        color: this.color,
        borderColor: this.color,
        backgroundColor: this.backgroundColor
      };
    }
  }
});
f({
  name: "TranslationBanner",
  props: {
    language: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      closed: !1
    };
  },
  computed: {
    text() {
      const e = this.$t(
        `translated-language.${this.language.original}`
      );
      return this.$t("common.translation.pageTranslated", {
        translatedLanguage: e
      }).toString();
    },
    show() {
      var e, t;
      return !!((e = this.language) != null && e.translatedTo) && ((t = this.language) == null ? void 0 : t.translatedTo) !== "none" && !this.closed;
    }
  },
  methods: {
    close() {
      this.closed = !0;
    }
  }
});
const OA = f({
  props: {
    value: {
      type: String,
      default: ""
    },
    languages: {
      type: Array,
      default: () => []
    },
    defaultLanguage: {
      type: String,
      default: "EN"
    },
    error: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      required: !1
    },
    singleLanguageMode: {
      type: Boolean,
      default: !1
    }
  },
  watch: {
    currentTabKey() {
      this.$emit("input", this.currentTabKey);
    },
    value() {
      this.currentTabKey = this.value;
    }
  },
  data() {
    return {
      currentTabKey: this.defaultLanguage
    };
  },
  computed: {
    tabs() {
      let { languages: e } = this;
      e = this.languages.filter((i) => i !== this.defaultLanguage);
      const t = e.sort().map((i) => ({
        label: i.toUpperCase(),
        tabKey: i
      }));
      return t.unshift({
        label: `${this.defaultLanguage.toUpperCase()}*`,
        tabKey: this.defaultLanguage,
        error: this.error
      }), t;
    }
  }
});
var BA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-language-container", class: { singleLanguageMode: e.singleLanguageMode } }, [t("div", { staticClass: "wrapper" }, [e.title ? t("div", { staticClass: "title" }, [e._v(" " + e._s(e.title) + " ")]) : e._e(), t("app-tabs", { staticClass: "tabs", attrs: { tabs: e.tabs }, model: { value: e.currentTabKey, callback: function(i) {
    e.currentTabKey = i;
  }, expression: "currentTabKey" } })], 1), e._t("default")], 2);
}, MA = [], RA = /* @__PURE__ */ x(
  OA,
  BA,
  MA,
  !1,
  null,
  "4ed958cf"
);
const EA = RA.exports;
f({
  props: {
    methods: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      required: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    imageSelectorItems: {
      type: Array,
      default: () => []
    },
    itemsPerPage: {
      type: Number,
      default: 3
    },
    value: {
      type: String,
      default: ""
    },
    uploadMaxHeight: {
      type: Number,
      default: 350
    },
    uploadMaxWidth: {
      type: Number,
      default: 350
    },
    filePrefix: {
      type: String,
      default: ""
    },
    rounded: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      inputOptions: [
        {
          label: `${this.$t("form.imageInputContainer.upload")}`,
          value: "upload"
        },
        {
          label: `${this.$t("form.imageInputContainer.selectFromGallery")}`,
          value: "select"
        }
      ],
      radioInput: "upload",
      selectedInput: this.value,
      uploadInput: this.value
    };
  },
  computed: {
    hasUploadInputPermission() {
      return this.hasPermission("UPLOAD");
    },
    hasSelectInputPermission() {
      return this.hasPermission("GALLERY");
    },
    showUploadInput() {
      return this.showInputOptions && this.radioInput === "upload" || !this.showInputOptions && this.hasUploadInputPermission;
    },
    showSelectInput() {
      return this.showInputOptions && this.radioInput === "select" || !this.showInputOptions && this.hasSelectInputPermission;
    },
    showInputOptions() {
      return this.hasSelectInputPermission && this.hasUploadInputPermission;
    }
  },
  methods: {
    hasPermission(e) {
      return this.methods.includes(e);
    },
    radioChanged() {
      this.radioInput === "upload" && this.$emit("input", this.uploadInput), this.radioInput === "select" && this.$emit("input", this.selectedInput);
    }
  }
});
f({
  props: {
    methods: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      required: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    imageSelectorItems: {
      type: Array,
      default: () => []
    },
    imageTicketItems: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ""
    },
    uploadMaxHeight: {
      type: Number,
      default: 350
    },
    uploadMaxWidth: {
      type: Number,
      default: 350
    },
    filePrefix: {
      type: String,
      default: ""
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    ticket: {
      type: Object,
      required: !0
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      selectedInput: this.value,
      imageCropInput: {},
      showAiModal: !1,
      itemsPerPage: 3
    };
  },
  mounted() {
    window.addEventListener("resize", this.setItemsPerPage), setTimeout(this.setItemsPerPage, 400);
  },
  destroyed() {
    window.removeEventListener("resize", this.setItemsPerPage);
  },
  computed: {
    showAddImageCard() {
      return this.hasPermission("UPLOAD") || this.hasPermission("AI");
    },
    imageItems() {
      return this.hasPermission("GALLERY") ? this.imageTicketItems.concat(this.imageSelectorItems) : this.imageTicketItems;
    }
  },
  methods: {
    hasPermission(e) {
      return this.methods.includes(e);
    },
    onClickInput() {
      this.$refs.file.click();
    },
    onClickAi() {
      this.showAiModal = !0;
    },
    loadImage(e) {
      const t = this, { files: i } = e.target;
      i && i[0] && (t.src && URL.revokeObjectURL(t.src), t.src = URL.createObjectURL(i[0]), t.type = i[0].type, this.imageCropInput = { src: t.src, type: t.type }, t.$refs.file.value = "");
    },
    async onAcceptImageCrop(e) {
      const t = new File([e], "image.jpeg", {
        type: e.type
      });
      this.$emit("crop-accept", t), this.resetInput();
    },
    onRejectImageCrop() {
      this.resetInput();
    },
    resetInput() {
      this.imageCropInput = {};
    },
    setItemsPerPage() {
      const e = this.$el.querySelector(".carousel"), t = (e == null ? void 0 : e.offsetWidth) || 650, i = 215;
      this.itemsPerPage = Math.floor(t / i);
    }
  }
});
f({
  props: {
    faIcon: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    theme: {
      type: String,
      default: "grey",
      validator(e) {
        return ["white", "grey"].includes(e);
      }
    }
  }
});
f({
  name: "EmptyCard",
  props: {
    resource: {
      type: Object,
      required: !0
    }
  },
  computed: {
    title() {
      return this.resource.title;
    },
    description() {
      return this.resource.text;
    },
    imageSrc() {
      return this.resource.image;
    },
    hasSlotActions() {
      return !!this.$slots.actions;
    }
  }
});
f({
  props: {
    title: {
      type: String,
      required: !0
    },
    level: {
      type: Number,
      default: 2
    },
    viewState: {
      type: String,
      required: !0,
      validator(e) {
        return ["loading", "empty", "ready"].includes(e);
      }
    },
    overflow: {
      type: Boolean,
      default: !0
    }
  }
});
f({
  props: {
    methods: {
      type: Array,
      default: () => []
    },
    width: {
      type: String,
      required: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      smallSlide: !1
    };
  },
  mounted() {
    window.addEventListener("resize", this.checkSlideWidth), setTimeout(this.checkSlideWidth, 400);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkSlideWidth);
  },
  computed: {
    slideWidth() {
      return {
        width: this.width
      };
    },
    showUpload() {
      return this.methods.includes("UPLOAD");
    },
    showAI() {
      return this.methods.includes("AI");
    },
    showOr() {
      return this.showUpload && this.showAI;
    }
  },
  methods: {
    checkSlideWidth() {
      const e = document.getElementById("text-container");
      this.smallSlide = (e == null ? void 0 : e.offsetWidth) < 185;
    }
  }
});
f({
  props: {
    ticket: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      prompt: "",
      step: 1,
      imageUrl: [],
      selectedStyle: ""
    };
  },
  computed: {
    title() {
      switch (this.step) {
        case 1:
          return this.$t("modal.imageAiModal.titles.step1");
        case 2:
          return this.$t("modal.imageAiModal.titles.step2");
        case 3:
          return this.$t("modal.imageAiModal.titles.step3");
        default:
          return "";
      }
    },
    styleOptions() {
      const e = this.$t(
        "modal.imageAiModal.styles.options"
      ), t = [];
      for (const [i, r] of Object.entries(e))
        t.push({
          text: r,
          value: this.$t(
            `modal.imageAiModal.styles.options.${i}`,
            "en"
          ).toString()
        });
      return t;
    }
  },
  methods: {
    async generateImage() {
      const e = {
        prompt: `${this.prompt} in Style ${this.selectedStyle} `,
        n: 1,
        aspectRation: 1.537037037,
        category: "cover/ai"
      };
      try {
        this.step = 2, this.imageUrl = await this.$api.ticket.generateTicketAi(
          this.ticket.type,
          this.ticket.canonicalId,
          e
        ), this.step = 3, this.$toast(this.$t("common.toast.imageToGallery").toString());
      } catch (t) {
        t.status === 400 ? this.$toast(
          this.$t("modal.imageAiModal.toastErrorMessage").toString()
        ) : this.$toast(this.$t("error.general").toString()), this.onClose();
      }
    },
    onClose() {
      this.$emit("close");
    },
    done() {
      this.$emit("generated");
    }
  }
});
f({
  props: {},
  data() {
    return {
      sidePanelVisible: !0
    };
  },
  computed: {
    toggleIcon() {
      return this.sidePanelVisible ? "fa-solid fa-chevron-left" : "fa-solid fa-chevron-right";
    },
    panelToggleCssClass() {
      return this.sidePanelVisible ? ["side-panel-visible"] : ["side-panel-hidden"];
    }
  },
  methods: {
    toggleSidePanel() {
      this.sidePanelVisible = !this.sidePanelVisible;
    }
  }
});
const LA = De.extend({
  props: {
    label: null
  }
});
var FA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "label-value-container" }, [t("div", { staticClass: "label" }, [e._v(e._s(e.label))]), t("div", { staticClass: "value" }, [e._t("default")], 2)]);
}, jA = [], UA = /* @__PURE__ */ x(
  LA,
  FA,
  jA,
  !1,
  null,
  "587b135d"
);
const wc = UA.exports;
De.extend({
  name: "AppAccordion",
  props: {
    // Only one element with the same name can be opened at the same time
    name: {
      type: String,
      default: ""
    },
    open: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      mounted: !1
    };
  },
  mounted() {
    this.mounted = !0;
  }
});
f({
  props: {
    label: {
      type: String,
      required: !1
    },
    searchLabel: {
      type: String,
      required: !1
    },
    searchEnabled: {
      type: Boolean,
      required: !1,
      default: !0
    },
    value: {
      type: Array,
      required: !0
    },
    availableOptions: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      searchText: ""
    };
  },
  computed: {
    labelCounter() {
      return `${this.label} (${this.value.length})`;
    },
    filteredOptions() {
      const e = this.searchText.toLowerCase();
      return this.availableOptions.forEach((t) => {
        t.selected = this.value.includes(t.value);
      }), this.availableOptions.filter((t) => {
        var i;
        return t.value.toLowerCase().includes(e.replaceAll(" ", "_")) || ((i = t.description) == null ? void 0 : i.toLowerCase().includes(e));
      }).sort((t, i) => t.selected && !i.selected ? -1 : !t.selected && i.selected ? 1 : 0);
    }
  },
  methods: {
    toggleOption(e) {
      e.selected ? this.removeOption(e) : this.addOption(e), this.$emit("input", this.value);
    },
    removeOption(e) {
      const t = this.value.indexOf(e.value);
      t !== -1 && this.value.splice(t, 1);
    },
    addOption(e) {
      this.availableOptions.indexOf(e) !== -1 && this.value.push(e.value);
    }
  }
});
const Lo = 2, qA = 40;
f({
  props: {
    value: {
      type: Array,
      required: !0
    },
    catalog: {
      type: Array,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      required: !0
    },
    createItemLabel: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      reloadKey: 0,
      loading: !1,
      query: "",
      selection: []
    };
  },
  watch: {
    value(e) {
      this.selection = e;
    }
  },
  computed: {
    optionsAll() {
      return [...this.catalog].sort().map((e) => ({
        text: e,
        value: e
      }));
    },
    optionsFiltered() {
      if (this.query.length < Lo)
        return [];
      const e = this.query.toUpperCase();
      return this.optionsAll.filter(
        (t) => t.text.toUpperCase().includes(e)
      );
    },
    candidate() {
      const e = this.query.trim();
      if (!(e.length < Lo || e.length > qA || this.catalog.some(
        (t) => t.toUpperCase() === e.toUpperCase()
      )))
        return e;
    }
  },
  methods: {
    onToggleOpen(e) {
      e || (this.query = "");
    },
    onClickCreate() {
      this.$emit("create-tag", this.candidate);
    },
    onAddItem(e) {
      this.$emit("add-tag", e);
    },
    onRemoveItem(e) {
      this.$emit("remove-tag", e);
    }
  }
});
f({
  props: {
    title: {
      type: String,
      default: ""
    },
    path: {
      type: String,
      required: !0
    },
    provider: {
      type: Function,
      required: !0
    }
  },
  computed: {
    content() {
      return this.provider(this.path);
    }
  }
});
const HA = De.extend({
  name: "TeamMemberCard",
  components: { AppItemCard: vc },
  props: {
    userData: {
      type: Object,
      required: !0
    },
    menuOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    id() {
      return this.userData.user.id;
    },
    image() {
      return this.userData.user.avatar;
    },
    displayName() {
      return B(this.userData).displayName();
    },
    userDepartment() {
      return B(this.userData).userDepartment();
    }
  }
});
var zA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-item-card", { staticClass: "team-member-card", attrs: { description: e.userDepartment, image: e.image, shadow: !0, title: e.displayName }, scopedSlots: e._u([e.image ? null : { key: "image", fn: function() {
    return [t("div", { staticClass: "avatar" }, [t("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-solid fa-user" } })], 1)];
  }, proxy: !0 }, { key: "control", fn: function() {
    return [e.menuOptions.filter((i) => i.visible || i.visible === void 0).length ? t("app-ellipsis-menu", e._g({ attrs: { "menu-options": e.menuOptions, reference: { id: e.id } } }, e.$listeners)) : e._e()];
  }, proxy: !0 }], null, !0) });
}, NA = [], VA = /* @__PURE__ */ x(
  HA,
  zA,
  NA,
  !1,
  null,
  "f7b0e3d2"
);
const GA = VA.exports, WA = "/img/profile-placeholder.svg", QA = 180, XA = f({
  props: {
    value: {
      type: Array,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    userCountLabel: {
      type: String,
      default: ""
    },
    additionalHeaders: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      form: {
        query: "",
        filters: {
          teams: [],
          languages: [],
          active: !1
        }
      },
      loading: !1,
      loadingUserBatch: !1,
      users: [],
      userIds: [],
      selection: [],
      isFiltersSlotVisible: !0,
      currentPage: 0,
      pageSize: 100,
      scrollElement: null
    };
  },
  created() {
    this.selection = [...this.value];
  },
  mounted() {
    var e;
    this.scrollElement = this.$refs["user-table-container"], (e = this.scrollElement) == null || e.addEventListener("scroll", this.scrollListener, {
      passive: !0
    });
  },
  destroyed() {
    var e;
    (e = this.scrollElement) == null || e.removeEventListener("scroll", this.scrollListener);
  },
  watch: {
    value(e) {
      this.selection = [...e];
    }
  },
  computed: {
    tableData() {
      return this.users.map((e) => ({
        ...e.user,
        id: e.user.id,
        avatar: e.user.avatar || WA,
        name: this.displayName(e),
        unitName: this.userDepartment(e)
      }));
    },
    tableHeaders() {
      return [
        {
          key: "avatar",
          label: "",
          width: "50px",
          component: "table-image-avatar"
        },
        {
          key: "name",
          label: this.$t("common.name"),
          width: "100%"
        },
        ...this.additionalHeaders
      ];
    },
    tableConfig() {
      return {
        selection: {
          mode: "multiple",
          selectAllButton: !0
        }
      };
    },
    hasSlotFilters() {
      return !!this.$scopedSlots.filters;
    },
    isEmpty() {
      return !this.loading && this.users.length === 0;
    },
    showUserCount() {
      return !!this.userCountLabel;
    },
    lastPage() {
      const e = Math.ceil(this.userIds.length / this.pageSize);
      return this.currentPage >= e;
    },
    loadingMore() {
      return !this.lastPage && this.userIds.length > 0 && this.currentPage > 0;
    }
  },
  methods: {
    onToggleFiltersSlot() {
      this.isFiltersSlotVisible = !this.isFiltersSlotVisible;
    },
    onDirty() {
      this.loading = !0;
    },
    async onSubmit() {
      const e = this.form.query, t = this.form.filters;
      try {
        if (this.filterIsEmpty(e, t)) {
          this.users = [];
          return;
        }
        this.loading = !0, this.users = [], this.userIds = await this.$gateway.search.searchUserIds({
          query: e,
          filter: {
            unit: t.teams,
            skills: [],
            language: t.languages,
            active: t.active
          },
          limit: 1e4
          // It's over 9000!!!
        }), this.currentPage = 0, this.loadUsers();
      } catch {
        console.error("Error searching for users"), this.$toast(this.$t("error.general").toString());
      } finally {
        this.loading = !1;
      }
    },
    filterIsEmpty(e, t) {
      return e.length > 2 ? !1 : !Object.values(t).some((i) => typeof i == "string" && i.length > 2 ? !0 : Array.isArray(i) && i.length > 0);
    },
    displayName(e) {
      return B(e).displayName();
    },
    userDepartment(e) {
      return B(e).userDepartment();
    },
    onConfirm() {
      this.$emit("input", [...this.selection]), this.$emit("save");
    },
    onCancel() {
      this.$emit("close");
    },
    async loadUsers() {
      try {
        this.loadingUserBatch = !0;
        const e = this.currentPage * this.pageSize, t = e + this.pageSize, i = await this.$gateway.portal.findUsersById(
          this.userIds.slice(e, t)
        );
        this.users = [...this.users, ...i];
      } catch {
        console.error("Error loading users"), this.$toast(this.$t("error.general").toString());
      } finally {
        this.loadingUserBatch = !1;
      }
    },
    scrollListener() {
      if (this.lastPage || this.loading || this.loadingUserBatch)
        return;
      const { scrollTop: e, scrollHeight: t, clientHeight: i } = this.scrollElement;
      t - (e + i) < QA && this.loadMore();
    },
    loadMore() {
      this.lastPage || this.loading || this.loadingUserBatch || (this.currentPage += 1, this.loadUsers());
    }
  }
});
var KA = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { staticClass: "user-list-modal", on: { "click-outside": e.onCancel } }, [t("app-form", { staticClass: "search-form", attrs: { form: e.form, "auto-submit": !0 }, on: { dirty: e.onDirty, submit: e.onSubmit } }, [t("div", { staticClass: "search-filters-container" }, [t("app-search-input", { staticClass: "app-search-input", attrs: { placeholder: e.searchPlaceholder }, model: { value: e.form.query, callback: function(i) {
    e.$set(e.form, "query", i);
  }, expression: "form.query" } }), e.hasSlotFilters ? t("app-icon-button", { staticClass: "toggle-filters-button", attrs: { size: 32 }, on: { click: e.onToggleFiltersSlot } }, [t("fa-icon-compat", { attrs: { icon: "fa-solid fa-sliders" } })], 1) : e._e()], 1), e.isFiltersSlotVisible ? t("div", [e._t("filters", null, { filters: e.form.filters })], 2) : e._e(), e.showUserCount ? t("div", { staticClass: "user-selection-label" }, [e._v(" " + e._s(e.userCountLabel) + ": "), t("span", { staticClass: "user-selection-count" }, [e._v(e._s(e.selected.size))])]) : e._e()]), t("div", { ref: "user-table-container", staticClass: "user-table-container" }, [e.loading ? t("app-overlay", { attrs: { theme: "light", "center-content": !0, "full-page": !1 } }, [t("app-loading")], 1) : e.isEmpty ? t("app-empty-view", { staticClass: "widget-empty", attrs: { title: e.$t("error.nothingFound"), "fa-icon": "fa-regular fa-user-check" } }) : t("app-data-table", { attrs: { data: e.tableData, headers: e.tableHeaders, config: e.tableConfig }, model: { value: e.selection, callback: function(i) {
    e.selection = i;
  }, expression: "selection" } }), e.loadingMore ? t("div", { staticClass: "load-more" }, [e._v(" " + e._s(e.$t("search.label-loading-more")) + " ")]) : e._e()], 1), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center", theme: "gray" } }, [t("app-button", { attrs: { label: e.$t("common.form.confirm") }, on: { click: e.onConfirm } }), t("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } })], 1)], 1);
}, YA = [], ZA = /* @__PURE__ */ x(
  XA,
  KA,
  YA,
  !1,
  null,
  "7150c23a"
);
const xc = ZA.exports, JA = f({
  components: {
    GridLayout: AA,
    AddButton: Vv,
    UserSelectionModal: xc,
    TeamMemberCard: GA
  },
  props: {
    labelAddButton: {
      type: String,
      required: !1
    },
    users: {
      type: Array,
      required: !0
    },
    minimumUserCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    menuOptions() {
      return [
        {
          label: this.$t("common.form.delete").toString(),
          tabKey: "delete",
          visible: this.users.length > this.minimumUserCount
        }
      ];
    },
    gridConfig() {
      return { summary: "disabled", item: { minWidth: 270, maxWidth: 339 } };
    }
  },
  methods: {
    onDelete({ id: e }) {
      this.$emit("remove-member", e);
    },
    onClickAdd() {
      this.$emit("select-members");
    }
  }
});
var _A = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-data-grid", { attrs: { data: e.users, config: e.gridConfig }, scopedSlots: e._u([{ key: "prepend", fn: function() {
    return [t("add-button", { staticClass: "add-button", attrs: { text: e.labelAddButton }, on: { click: e.onClickAdd } })];
  }, proxy: !0 }, { key: "default", fn: function({ item: i }) {
    return [t("team-member-card", { staticClass: "team-member-card", attrs: { "user-data": i, "menu-options": e.menuOptions }, on: { "click:delete": e.onDelete } })];
  } }]) });
}, $A = [], ek = /* @__PURE__ */ x(
  JA,
  _A,
  $A,
  !1,
  null,
  "64641936"
);
const tk = ek.exports, ik = f({
  components: {
    TeamMemberList: tk,
    UserSelectionModal: xc
  },
  props: {
    teamId: {
      type: String,
      required: !0
    },
    teamType: {
      type: String,
      required: !0
    },
    labelOwners: {
      type: String,
      required: !0
    },
    labelMembers: {
      type: String,
      required: !0
    },
    buttonAddOwner: {
      type: String,
      required: !0
    },
    buttonAddMember: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      teamMembers: [],
      users: [],
      selection: null
    };
  },
  async created() {
    await this.reload();
  },
  computed: {
    additionalHeaders() {
      return [
        {
          key: "unitName",
          label: this.$t("common.unit"),
          align: "end",
          width: "200px"
        }
      ];
    }
  },
  methods: {
    async reload() {
      const e = await this.$api.team.fetchTeamMembers(
        this.teamId
      ), t = e.map(({ userId: r }) => r), i = await this.$gateway.portal.findUsersById(t);
      this.teamMembers = e, this.users = i.sort(
        (r, s) => r.user.firstName.localeCompare(s.user.firstName)
      );
    },
    getUserIds(e) {
      return this.teamMembers.filter((t) => t.roles.includes(e)).map((t) => t.userId);
    },
    getUserList(e) {
      const t = this.getUserIds(e);
      return this.users.filter((i) => t.includes(i.user.id));
    },
    onMemberSelection(e) {
      this.selection = {
        role: e,
        ids: this.getUserIds(e)
      };
    },
    async onRemoveMember(e, t) {
      try {
        await this.$gateway.team.removeTeamMembers({
          teamId: this.teamId,
          role: e,
          userIds: [t]
        });
      } catch {
        console.error("Could not remove team member"), this.$toast(this.$t("error.general").toString());
      } finally {
        await this.reload();
      }
    },
    async onSaveSelection() {
      var e, t;
      if (this.selection) {
        try {
          await this.$gateway.team.updateTeamMembers({
            teamId: this.teamId,
            role: (e = this.selection) == null ? void 0 : e.role,
            userIds: (t = this.selection) == null ? void 0 : t.ids,
            teamType: this.teamType
          });
        } catch (i) {
          console.error("Could not update team members", i), this.$toast(this.$t("error.general").toString());
        } finally {
          await this.reload();
        }
        this.selection = null;
      }
    },
    onCancelSelection() {
      this.selection = null;
    }
  }
});
var rk = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "team-container" }, [t("base-input-item", { attrs: { label: e.labelOwners } }, [t("team-member-list", { attrs: { "label-add-button": e.buttonAddOwner, users: e.getUserList("owner"), "minimum-user-count": 1 }, on: { "select-members": function(i) {
    return e.onMemberSelection("owner");
  }, "remove-member": function(i) {
    return e.onRemoveMember("owner", i);
  } } })], 1), t("base-input-item", { attrs: { label: e.labelMembers } }, [t("team-member-list", { attrs: { "label-add-button": e.buttonAddMember, users: e.getUserList("member") }, on: { "select-members": function(i) {
    return e.onMemberSelection("member");
  }, "remove-member": function(i) {
    return e.onRemoveMember("member", i);
  } } })], 1), e.selection ? t("user-selection-modal", { attrs: { "additional-headers": e.additionalHeaders }, on: { save: e.onSaveSelection, close: e.onCancelSelection }, model: { value: e.selection.ids, callback: function(i) {
    e.$set(e.selection, "ids", i);
  }, expression: "selection.ids" } }) : e._e()], 1);
}, sk = [], nk = /* @__PURE__ */ x(
  ik,
  rk,
  sk,
  !1,
  null,
  "cf5820df"
);
const ak = nk.exports;
f({
  name: "TeamForm",
  components: {
    AppLanguageSection: EA,
    TeamMemberManagement: ak
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    team: {
      type: Object,
      default: () => ({})
    },
    teamType: {
      type: String,
      required: !1
    },
    tagsVisible: {
      type: Boolean,
      default: !0
    },
    validationKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: !1,
      form: {
        resources: {}
      },
      error: {
        resources: {
          name: !1,
          description: !1,
          publicDescription: !1
        }
      },
      selectedGenericTags: [],
      allGenericTags: [],
      selectedLanguage: ""
    };
  },
  watch: {
    validationKey(e) {
      e > 0 && this.onUpdate();
    }
  },
  async created() {
    this.loading = !0, this.tagsVisible && ([this.allGenericTags, this.selectedGenericTags] = await Promise.all([
      this.$api.genericTags.fetchGenericTagsCatalog("team"),
      this.$api.genericTags.fetchGenericTags("team", this.team.id)
    ])), this.selectedLanguage = this.defaultLanguage, this.form.resources = this.languages.reduce(
      (e, t) => (e[t] = {}, e),
      {}
    ), this.form.resources = Object.assign(
      this.form.resources,
      this.team.resources
    ), this.migrateFieldsCompat(), this.loading = !1;
  },
  computed: {
    teamData() {
      const e = {
        ...this.team,
        resources: this.form.resources
      };
      return e.name = this.form.resources[this.defaultLanguage].name, e.description = this.form.resources[this.defaultLanguage].description ?? "", {
        team: e,
        actions: [],
        tags: this.tagsVisible ? this.selectedGenericTags : void 0
      };
    },
    requiresCurrentLanguage() {
      return this.selectedLanguage === this.defaultLanguage;
    },
    languages() {
      return this.organization.language.available;
    },
    defaultLanguage() {
      return this.organization.language.default;
    }
  },
  methods: {
    validate() {
      var e, t, i;
      return this.error.resources.name = !this.validateNotEmpty(
        (e = this.form.resources[this.defaultLanguage]) == null ? void 0 : e.name
      ), this.error.resources.description = !this.validateNotEmpty(
        (t = this.form.resources[this.defaultLanguage]) == null ? void 0 : t.description
      ), this.error.resources.publicDescription = this.teamType === "WORKGROUP" && !this.validateNotEmpty(
        (i = this.form.resources[this.defaultLanguage]) == null ? void 0 : i.publicDescription
      ), !this.error.resources.name && !this.error.resources.description && !this.error.resources.publicDescription;
    },
    validateNotEmpty(e) {
      return !!(e ?? "").trim();
    },
    migrateFieldsCompat() {
      const e = this.form.resources[this.selectedLanguage];
      e.name || (e.name = this.team.name || ""), e.description || (e.description = this.team.description || "");
    },
    onUpdate() {
      this.validate() ? this.$emit("input", this.teamData) : this.$emit("input", null);
    },
    addGenericTag(e) {
      this.selectedGenericTags.push(e), this.allGenericTags.push(e), this.allGenericTags = [...new Set(this.allGenericTags)], this.onUpdate();
    },
    removeGenericTag(e) {
      this.selectedGenericTags = this.selectedGenericTags.filter(
        (t) => t !== e
      ), this.onUpdate();
    }
  }
});
f({
  name: "TeamItem",
  props: {
    team: {
      type: Object,
      required: !0
    }
  },
  computed: {
    title() {
      return Be(this.team, this.$res).teamName();
    },
    description() {
      return this.$t("common.team").toString();
    },
    isVirtualTeam() {
      return this.team.type === "VIRTUAL_TEAM";
    }
  }
});
f({
  name: "WorkgroupItem",
  props: {
    team: {
      type: Object,
      required: !0
    }
  },
  computed: {
    title() {
      return Be(this.team, this.$res).teamName();
    },
    description() {
      return this.$t("form.teamManagement.WORKGROUP").toString().toUpperCase();
    }
  }
});
f({
  name: "TeamItemCard",
  props: {
    team: {
      type: Object,
      required: !0
    }
  }
});
f({
  name: "TeamMembersWidget",
  props: {
    currentUserId: {
      type: String,
      required: !0
    },
    teamId: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    allowJoining: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      PROFILE_PLACEHOLDER_IMAGE: "/img/add-user-placeholder.svg",
      memberIds: [],
      users: []
    };
  },
  computed: {
    showJoinAction() {
      return this.allowJoining && !this.memberIds.includes(this.currentUserId);
    }
  },
  async created() {
    await this.setMembers();
  },
  methods: {
    routeToUser(e) {
      return {
        name: "UserProfile",
        params: { userId: e.user.id }
      };
    },
    async setMembers() {
      const e = await this.$api.team.fetchTeamMembers(this.teamId) ?? [];
      this.memberIds = cc(
        e,
        (t) => t.userId
      ), this.users = await this.$gateway.portal.findUsersById(this.memberIds);
    },
    async joinTeam() {
      await this.$api.team.addTeamMember({
        type: "member",
        teamId: this.teamId,
        userId: this.currentUserId
      }), await this.setMembers();
    },
    goToUserProfile(e) {
      this.$router.push({
        name: "UserProfile",
        params: { userId: e }
      });
    }
  }
});
const Fo = "/img/team-placeholder.svg";
f({
  props: {
    value: {
      type: Array,
      required: !0
    },
    multiselect: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    tooltip: {
      type: String,
      required: !1
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    previewOptions: {
      type: Array,
      default: () => []
    },
    previewGroups: {
      type: Array,
      default: () => []
    },
    teamTypes: {
      type: Array,
      required: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    required: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    tags: {
      type: Array,
      required: !1
    }
  },
  data() {
    return {
      loading: !1,
      optionsPool: [],
      selection: [],
      query: "",
      searchOptions: []
    };
  },
  async created() {
    if (this.value) {
      this.loading = !0;
      const e = await this.$datasource.team.listBatch(this.value);
      this.optionsPool = e.map((t) => ({
        text: Be(t, this.$res).teamName(),
        value: t.id,
        image: Fo
      })), this.selection = this.value, this.loading = !1;
    }
  },
  computed: {
    selectionMode() {
      return this.multiselect ? "multiple" : "single";
    },
    options() {
      return this.query ? this.searchOptions : this.previewOptions;
    },
    groups() {
      return this.query ? void 0 : this.previewGroups;
    }
  },
  methods: {
    onUpdate(e) {
      this.$emit("input", e);
    },
    onDirty() {
      this.loading = !!this.query;
    },
    onToggleOpen(e) {
      e || (this.query = "", this.$emit("blur"));
    },
    async onSearchDebounced(e) {
      if (!e.length) {
        this.searchOptions = [];
        return;
      }
      this.loading = !0;
      const t = await this.$gateway.search.searchTeamIds(
        {
          query: e,
          filter: {
            type: this.teamTypes,
            tags: this.tags
          }
        },
        this.$res
      ), i = await this.$datasource.team.listBatch(t);
      this.searchOptions = i.map((r) => ({
        text: Be(r, this.$res).teamName(),
        value: r.id,
        image: Fo
      })), this.loading = !1;
    }
  }
});
De.extend({
  props: {
    header: Object,
    value: null,
    item: null
  }
});
f({
  props: {
    value: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      form: {
        query: ""
      },
      loading: !1,
      allTeams: [],
      teams: [],
      selection: []
    };
  },
  async created() {
    this.loading = !0, this.selection = [...this.value], await this.loadTeams(), this.loading = !1;
  },
  computed: {
    tableData() {
      return this.teams.map((e) => ({
        id: e.id,
        name: Be(e, this.$res).teamName()
      }));
    },
    tableHeaders() {
      return [
        {
          key: "name",
          label: this.$t("common.name"),
          width: "100%"
        }
      ];
    },
    tableConfig() {
      return {
        summary: "simple",
        selection: {
          mode: "multiple",
          selectAllButton: !0
        }
      };
    },
    isEmpty() {
      return !this.loading && this.teams.length === 0;
    }
  },
  methods: {
    async loadTeams() {
      const e = await this.$gateway.search.searchTeamIds(
        {
          filter: {
            type: ["ORGANIZATIONAL_TEAM", "VIRTUAL_TEAM"]
          }
        },
        this.$res
      );
      this.allTeams = await this.$datasource.team.listBatch(e), this.teams = this.allTeams;
    },
    async onSubmit() {
      const e = this.form.query.toLocaleLowerCase();
      this.teams = this.allTeams.filter(
        ({ name: t }) => t == null ? void 0 : t.toLowerCase().includes(e)
      );
    },
    onConfirm() {
      this.$emit("input", this.selection), this.$emit("save");
    },
    onCancel() {
      this.$emit("close");
    }
  }
});
f({
  name: "BaseCreateTeamModal",
  components: {
    SelectTeamMembers: fc
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    userId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      teamName: "",
      selectedUsers: []
    };
  },
  computed: {
    isFormValid() {
      return !!(this.teamName && this.selectedUsers.length);
    }
  },
  methods: {
    async createTeam() {
      const e = this.organization.language.default, t = {
        team: {
          name: this.teamName,
          context: "",
          description: "",
          resources: {
            [e]: {
              name: this.teamName,
              description: ""
            }
          },
          type: "VIRTUAL_TEAM"
        },
        actions: this.selectedUsers.map(
          (i) => ({
            action: "add",
            role: "member",
            userId: i
          })
        )
      };
      try {
        const i = await this.$gateway.team.createTeam(t);
        this.$emit("teamCreated", i);
      } catch (i) {
        console.error(i), this.$toast(this.$t("error.general").toString());
      }
    }
  }
});
f({
  props: {
    user: {
      type: Object
    },
    title: {
      type: String,
      required: !0
    },
    icon: {
      type: String,
      required: !0
    },
    date: {
      type: Number,
      required: !0
    }
  },
  computed: {
    historicalDate() {
      return Intl.DateTimeFormat(void 0, {
        dateStyle: "medium",
        timeStyle: "short"
      }).format(new Date(this.date));
    },
    username() {
      return this.user ? B({ user: this.user }).displayName() : this.$t("common.deletedUser").toString();
    }
  }
});
f({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      previousAssignee: "",
      nextAssignee: ""
    };
  },
  async created() {
    this.previousAssignee = await this.setPreviousAssignee(), this.nextAssignee = await this.setNextAssignee();
  },
  methods: {
    async setPreviousAssignee() {
      return this.history.previousValue && this.history.previousValue !== "null" ? await this.getUserName(this.history.previousValue) : this.$t("page.ticketHistory.none").toString();
    },
    async setNextAssignee() {
      return this.history.newValue && this.history.newValue !== "null" ? await this.getUserName(this.history.newValue) : this.$t("page.ticketHistory.none").toString();
    },
    async getUserName(e) {
      const t = await this.$datasource.user.findById(e);
      return t ? B({ user: t }).displayName() ?? t.email ?? this.$t("common.deletedUser").toString() : this.$t("page.ticketHistory.none").toString();
    }
  }
});
f({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    }
  }
});
f({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    },
    userRoles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: !1,
      externalFields: [],
      previousValue: "",
      nextValue: ""
    };
  },
  async created() {
    this.loading = !0, [
      { externalFields: this.externalFields },
      this.previousValue,
      this.nextValue
    ] = await Promise.all([
      this.$datasource.dynamicField.find(
        this.ticket.type,
        this.ticket.context
      ),
      this.setPreviousValue(),
      this.setNextValue()
    ]), this.loading = !1;
  },
  computed: {
    accessProvider() {
      return {
        userId: this.currentUser.id,
        userRoles: this.userRoles,
        userActions: this.userActions,
        creatorId: this.ticket.creator,
        assigneeId: this.ticket.assignee
      };
    },
    title() {
      return `${this.$t("page.ticketHistory.changed")} ${this.label} ${this.$t(
        "page.ticketHistory.field"
      )}`;
    },
    dynamicField() {
      return this.externalFields.flatMap((e) => e.fields).find(({ ref: e }) => e === this.history.field);
    },
    visibilityAllowed() {
      var e, t;
      const i = ((t = (e = this.dynamicField) == null ? void 0 : e.accessPolicy) == null ? void 0 : t.view) ?? [], { accessGranted: r } = Br(i, this.accessProvider);
      return r;
    },
    label() {
      var e;
      const t = this.findResourceByRef(this.history.field), i = (e = this.$res(t)) == null ? void 0 : e.label;
      if (i)
        return i;
      const r = this.history.field.replace("meta.", ""), s = `page.ticketHistory.${r}`;
      return this.$te(s) ? this.$t(s).toString() : r;
    }
  },
  methods: {
    async setPreviousValue() {
      const e = await this.getStringValue("previousValue");
      return this.convertToDate(e);
    },
    async setNextValue() {
      const e = await this.getStringValue("newValue");
      return this.convertToDate(e);
    },
    convertToDate(e) {
      const t = e.replaceAll('"', ""), i = new Date(t);
      return i instanceof Date && !isNaN(i.getTime()) && isNaN(Number(t)) ? Intl.DateTimeFormat(void 0, {
        dateStyle: "medium"
      }).format(i) : e;
    },
    async getStringValue(e) {
      return !this.history[e] || this.history[e] === "null" ? this.$t("page.ticketHistory.none").toString() : this.history.field === "delegate" && this.history[e] ? await this.getDelegateName(this.history[e]) : ["creator", "creatorTeam"].includes(this.history.field) ? await this.getUserName(this.history[e]) : this.maybeJsonValueParse(this.history[e] ?? "");
    },
    maybeJsonValueParse(e) {
      try {
        const t = JSON.parse(e);
        return (t == null ? void 0 : t._dfType) === "measurement" ? ny(
          t.value,
          (i) => this.$t(i).toString()
        ) : e;
      } catch {
        return e;
      }
    },
    convertDelegateData(e) {
      try {
        return JSON.parse(e);
      } catch (t) {
        return console.error(`Error parsing delegate data: ${t}`), [];
      }
    },
    async getDelegateName(e) {
      const t = this.convertDelegateData(e), i = t.length > 0 ? t[0] : void 0;
      if (!i)
        return this.$t("page.ticketHistory.none").toString();
      if (i.domain === "team") {
        const r = await this.$datasource.team.find(i.id);
        return (r == null ? void 0 : r.name) ?? "--";
      }
      if (i.domain === "topic") {
        const r = await this.$datasource.topic.find(i.id);
        return this.$res(r == null ? void 0 : r.resources).title ?? "--";
      }
      return console.warn(`Unknown Delegate domain [domain=${i.domain}]`), "--";
    },
    async getUserName(e) {
      const t = await this.$datasource.user.findById(e);
      return t ? B({ user: t }).displayName() ?? t.email ?? this.$t("common.deletedUser").toString() : this.$t("page.ticketHistory.none").toString();
    },
    findResourceByRef(e) {
      var t;
      for (let i of this.externalFields)
        for (let r of i.fields)
          if (r.ref === e)
            return ((t = r.options) == null ? void 0 : t.resources) ?? {};
      return {};
    }
  }
});
f({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      imgError: !1,
      currentTime: -1
    };
  },
  computed: {
    icon() {
      var e;
      switch ((e = this.history) == null ? void 0 : e.eventType) {
        case "FILE_REMOVED":
          return "fal fa-trash";
        case "FILE_UPDATED":
          return "fal fa-pen-alt";
        case "FILE_ADDED":
        default:
          return "fal fa-arrow-to-top";
      }
    },
    fileUrl() {
      return !this.history.newValue || this.history.newValue === "null" ? "" : this.history.newValue.split(",")[1].split("=")[1];
    },
    title() {
      var e;
      switch ((e = this.history) == null ? void 0 : e.eventType) {
        case "FILE_REMOVED":
          return this.$t("page.ticketHistory.removedFile").toString();
        case "FILE_UPDATED":
          return this.$t("page.ticketHistory.updatedFile").toString();
        case "FILE_ADDED":
        default:
          return this.$t("page.ticketHistory.uploadedNewFile").toString();
      }
    }
  },
  methods: {
    onImgError() {
      this.imgError = !0;
    },
    isVideoByURL(e) {
      var t, i;
      const r = ((i = (t = e.split(/[#?]/)[0]) == null ? void 0 : t.split(".").pop()) == null ? void 0 : i.trim()) || "";
      return r ? r.includes("video") : !1;
    },
    resume() {
      if (this.currentTime !== -1) {
        const e = this.$refs.video;
        e.currentTime = this.currentTime, e.play(), this.currentTime = -1;
      }
    }
  }
});
f({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    }
  },
  computed: {
    previousStatus() {
      var e;
      if (!this.history.previousValue)
        return "";
      const t = J(this.history.previousValue, this.workflow);
      return ((e = this.$res(t)) == null ? void 0 : e.label) ?? this.history.previousValue;
    },
    nextStatus() {
      var e;
      if (!this.history.newValue)
        return "";
      const t = J(this.history.newValue, this.workflow);
      return ((e = this.$res(t)) == null ? void 0 : e.label) ?? this.history.newValue;
    }
  }
});
f({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    }
  },
  computed: {
    icon() {
      var e;
      switch ((e = this.history) == null ? void 0 : e.eventType) {
        case "TASK_DELETED":
          return "fal fa-trash";
        default:
          return "fal fa-pen-alt";
      }
    },
    title() {
      const e = this.history.eventType === "TASK_DELETED" ? "deletedTask" : "updatedTask";
      return this.$t(`page.ticketHistory.${e}`).toString();
    }
  }
});
f({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      relationType: "",
      linkedTicketId: "",
      linkedTicket: void 0
    };
  },
  async created() {
    this.loading = !0, [, this.relationType, this.linkedTicketId] = this.history.newValue.split(" "), this.linkedTicket = await this.$datasource.ticket.find(
      this.ticket.type,
      this.linkedTicketId
    ), this.loading = !1;
  },
  computed: {
    title() {
      return this.$t("page.ticketHistory.linkCreated").toString();
    },
    relation() {
      return this.$t(`linking.${this.relationType}`).toString();
    },
    description() {
      return this.$t("page.ticketHistory.linkAsDescription", {
        relation: this.relation
      }).toString();
    }
  }
});
f({
  props: {
    user: {
      type: Object
    },
    history: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      relationType: "",
      linkedTicketId: "",
      linkedTicket: void 0
    };
  },
  async created() {
    this.loading = !0, [, this.relationType, this.linkedTicketId] = this.history.previousValue.split(" "), this.linkedTicket = await this.$datasource.ticket.find(
      this.ticket.type,
      this.linkedTicketId
    ), this.loading = !1;
  },
  computed: {
    title() {
      return this.$t("page.ticketHistory.linkRemoved").toString();
    },
    relation() {
      return this.$t(`linking.${this.relationType}`).toString();
    },
    description() {
      return this.$t("page.ticketHistory.removedLinkAsDescription", {
        relation: this.relation
      }).toString();
    }
  }
});
const ok = f({
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    ticketId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    },
    userRoles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ticketHistory: [],
      ticket: {},
      loading: !1
    };
  },
  async created() {
    this.loading = !0, this.ticketHistory = await this.$gateway.portal.loadTicketHistory(
      this.contextId,
      this.productId,
      this.ticketId
    ), this.ticket = this.ticketHistory[0].ticket, this.ticketHistory = this.ticketHistory.map(
      (e) => ({
        ...e,
        user: this.filterCreatorName(e.user, e.history.creatorUser)
      })
    ), this.loading = !1;
  },
  computed: {
    componentLookup() {
      return {
        ASSIGNEE_CHANGED: "HistoryItemAssigneeChanged",
        DETAILS_UPDATED: "HistoryItemDetailsUpdated",
        FILE_ADDED: "HistoryItemFile",
        FILE_REMOVED: "HistoryItemFile",
        FILE_UPDATED: "HistoryItemFile",
        TASK_UPDATED: "HistoryItemTaskChanged",
        LINK_CREATED: "HistoryItemLinkCreated",
        LINK_REMOVED: "HistoryItemLinkRemoved",
        TASK_DELETED: "HistoryItemTaskChanged",
        TICKET_CREATED: "HistoryItemCreated",
        STATUS_UPDATED: "HistoryItemStatusUpdated"
      };
    },
    productCustomization() {
      var e, t;
      const { productsData: i } = Ge(this.organization, [
        "main",
        "subproduct"
      ]);
      return (t = (e = i.value) == null ? void 0 : e.find(
        ({ productId: r }) => r === this.ticket.type
      )) == null ? void 0 : t.customization;
    },
    accessProvider() {
      return {
        userId: this.currentUser.id,
        userActions: this.userActions,
        userRoles: this.userRoles,
        creatorId: this.ticket.creator,
        assigneeId: this.ticket.assignee
      };
    },
    showCreator() {
      var e, t, i;
      const r = ((i = (t = (e = this.productCustomization) == null ? void 0 : e.accessPolicy) == null ? void 0 : t.creator) == null ? void 0 : i.view) ?? [], { accessGranted: s } = Br(r, this.accessProvider);
      return s;
    },
    creatorTitle() {
      const e = an(
        this.ticketHistory[0].workflow,
        "app"
      ).page("TicketDetails"), t = this.$res(e == null ? void 0 : e.resources) ?? {};
      return t == null ? void 0 : t.creator;
    }
  },
  methods: {
    filterCreatorName(e = {}, t) {
      return t === "webhook" ? {
        firstName: this.$t("common.automation").toString(),
        lastName: ""
      } : this.showCreator || e.id !== this.ticket.creator ? e : {
        ...e,
        firstName: this.creatorTitle || this.$t("page.ticketHistory.creator").toString(),
        lastName: ""
      };
    },
    historyTypeComponent(e) {
      return this.componentLookup[e];
    }
  }
});
var lk = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, e.loading ? t("app-loading", { staticClass: "app-loading" }) : t("div", { staticClass: "ticket-history" }, e._l(e.ticketHistory, function(i, r) {
    return t(e.historyTypeComponent(i.history.eventType), { key: r, tag: "component", attrs: { "current-user": e.currentUser, history: i.history, ticket: i.ticket, user: i.user, "user-actions": e.userActions, "user-roles": e.userRoles, workflow: i.workflow } });
  }), 1);
}, ck = [], uk = /* @__PURE__ */ x(
  ok,
  lk,
  ck,
  !1,
  null,
  "ab429265"
);
const dk = uk.exports;
f({
  props: {
    value: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      required: !1
    },
    workflow: {
      type: Object,
      required: !0
    },
    statusList: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      selection: ""
    };
  },
  async mounted() {
    this.selection = this.value;
  },
  watch: {
    value(e) {
      this.selection = e;
    },
    selection(e) {
      this.$emit("input", e);
    }
  },
  computed: {
    options() {
      return this.statusList.map((e) => {
        var t;
        const i = J(e, this.workflow);
        return {
          text: ((t = this.$res(i)) == null ? void 0 : t.label) ?? e,
          value: e
        };
      });
    }
  }
});
const hk = "/img/profile-placeholder.svg", pk = f({
  props: {
    // pass just the user that now use the new IUserResponse
    userData: {
      type: Object,
      required: !0
    }
  },
  computed: {
    userAvatar() {
      return this.userData.user.avatar || hk;
    },
    displayName() {
      return B(this.userData).displayName();
    },
    userDepartment() {
      return B(this.userData).userDepartment();
    }
  }
});
var fk = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-list-item", { attrs: { image: e.userAvatar, title: e.displayName, description: e.userDepartment }, scopedSlots: e._u([{ key: "controls", fn: function() {
    return [e._t("controls")];
  }, proxy: !0 }], null, !0) });
}, mk = [], gk = /* @__PURE__ */ x(
  pk,
  fk,
  mk,
  !1,
  null,
  "e2a9c97f"
);
const cn = gk.exports, yk = f({
  components: {
    UserItem: cn
  },
  props: {
    options: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      open: !1,
      dirty: !1,
      loading: !1,
      searchQuery: "",
      reloadKey: 0
    };
  },
  watch: {
    options() {
      this.reloadKey += 1;
    },
    open(e) {
      e || this.$nextTick(() => {
        this.onHideFloating();
      });
    }
  },
  computed: {
    hasSlotPrepend() {
      return !!this.$slots.prepend;
    }
  },
  methods: {
    onDirty() {
      this.dirty = !0, this.loading = !0;
    },
    async onDebouncedSearch(e) {
      this.loading = !0, this.$emit("update-search", e), this.loading = !1;
    },
    onHideFloating() {
      this.$emit("hide-floating");
    },
    onSelectItem(e) {
      this.$emit("select-item", e.user.id), this.open = !1;
    }
  }
});
var bk = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-floating", { scopedSlots: e._u([{ key: "content", fn: function() {
    return [t("app-search-input", { attrs: { placeholder: e.$t("common.search"), "debounce-timeout": 300 }, on: { dirty: e.onDirty, debounced: e.onDebouncedSearch }, model: { value: e.searchQuery, callback: function(i) {
      e.searchQuery = i;
    }, expression: "searchQuery" } })];
  }, proxy: !0 }, { key: "options", fn: function() {
    return [e.options.length || e.hasSlotPrepend ? t("div", { key: e.reloadKey, staticClass: "user-selection-results" }, [e.hasSlotPrepend ? t("div", { staticClass: "item" }, [e._t("prepend")], 2) : e._e(), e._l(e.options, function(i) {
      return t("user-item", { key: i.user.id, staticClass: "item", attrs: { "user-data": i }, nativeOn: { click: function(r) {
        return e.onSelectItem(i);
      } } });
    })], 2) : e._e()];
  }, proxy: !0 }], null, !0), model: { value: e.open, callback: function(i) {
    e.open = i;
  }, expression: "open" } });
}, vk = [], Ak = /* @__PURE__ */ x(
  yk,
  bk,
  vk,
  !1,
  null,
  "1765ebf1"
);
const un = Ak.exports;
f({
  components: {
    UserItem: cn,
    UserSelectionInput: un
  },
  props: {
    currentUser: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    routeToUser: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      ready: !1,
      searchOpen: !1,
      currentSelection: void 0,
      searchOptions: []
    };
  },
  watch: {
    ticket() {
      this.load();
    }
  },
  async created() {
    await this.load(), this.ready = !0;
  },
  computed: {
    canUpdate() {
      var e;
      const t = ((e = this.ticket.type) == null ? void 0 : e.toUpperCase()) ?? "";
      return this.userActions.includes(
        `${t}_ADMIN_TICKET_CREATOR_WRITE`
      );
    },
    ticketIdOrType() {
      return this.ticket.canonicalId ?? this.ticket.type;
    },
    currentSelectionId() {
      return this.ticket.creator;
    },
    display() {
      return this.searchOpen ? "search" : this.currentSelection ? "selected" : "empty";
    },
    menuOptions() {
      return [
        {
          label: this.$t("menu.changeToMe").toString(),
          tabKey: "assign-to-self",
          visible: this.currentSelectionId !== this.currentUser.id
        },
        {
          label: this.$t("menu.changeToSomeone").toString(),
          tabKey: "assign-to-other"
        }
      ];
    }
  },
  methods: {
    async load() {
      try {
        if (!this.currentSelectionId) {
          this.currentSelection = void 0;
          return;
        }
        const e = await this.$gateway.portal.findUserById(
          this.currentSelectionId
        );
        this.currentSelection = e ?? void 0, this.currentSelection || console.error(
          `Error loading ticket assignee [userId=${this.currentSelectionId}]`
        );
      } finally {
        this.onCloseSearch();
      }
    },
    onSelectUser(e) {
      this.$emit("update-assignee", e);
    },
    async onUpdateSearch(e) {
      const t = await this.$gateway.search.searchUserIds({ query: e }), i = await this.$gateway.portal.findUsersById(t);
      this.searchOptions = i.filter((r) => r.user.enabled && !r.user.deleted).filter((r) => !!r.user.firstName || r.user.lastName);
    },
    onRemoveAssignee() {
      this.$emit("update-assignee", void 0);
    },
    onSelectSelf() {
      this.onSelectUser(this.currentUser.id);
    },
    onOpenSearch() {
      this.searchOptions = [], this.searchOpen = !0;
    },
    onCloseSearch() {
      this.searchOpen = !1;
    }
  }
});
const kk = f({
  name: "TicketBreadcrumb",
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      parent: {},
      workflows: []
    };
  },
  computed: {
    product() {
      var e;
      return ((e = this.parent) == null ? void 0 : e.type) ?? this.ticket.type;
    },
    productText() {
      return this.product.replaceAll(/_/g, " ");
    },
    productRoute() {
      switch (this.product) {
        case "campaign":
          return { name: "CampaignOverview" };
        case "service_order":
          return { name: "ServiceOverview" };
        default:
          return {
            name: "TicketOverview",
            params: { product: this.product }
          };
      }
    }
  },
  async created() {
    await this.load();
  },
  methods: {
    getCanonicalNumber(e) {
      return e.split("-")[2];
    },
    async load() {
      var e;
      try {
        this.loading = !0;
        const { parent: t } = this.ticket;
        t && (this.parent = await this.$datasource.ticket.find(
          this.productId,
          t
        ));
        const i = [this.ticket.type, (e = this.parent) == null ? void 0 : e.type].filter(
          Boolean
        );
        this.workflows = await this.$gateway.portal.fetchWorkflowsByBatch(
          i,
          this.contextId
        );
      } catch (t) {
        console.error(t), this.$toast(this.$t("error.general").toString());
      } finally {
        this.loading = !1;
      }
    },
    getIcon(e) {
      const t = this.workflows.find(
        (r) => {
          var s;
          return ((s = r.product) == null ? void 0 : s.ticketType) === e;
        }
      );
      if (!t)
        return "";
      const { icons: i } = Kt(t);
      return i.solid ?? "/img/transparent-pixel.png";
    },
    getTicketRoute(e) {
      return {
        name: "TicketDetails",
        params: {
          product: this.productId,
          id: e
        }
      };
    }
  }
});
var wk = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "container" }, [e.ticket.canonicalId ? [t("router-link", { staticClass: "product-link", attrs: { to: e.productRoute } }, [e._v(" " + e._s(e.productText) + " ")]), e.parent.canonicalId ? [t("span", { staticClass: "slash" }, [e._v("/")]), t("router-link", { staticClass: "ticket-link", attrs: { to: e.getTicketRoute(e.parent.canonicalId) } }, [t("img", { staticClass: "item-icon", class: [e.parent.type], attrs: { src: e.getIcon(e.parent.type) } }), e._v(" " + e._s(e.parent.title) + " ")])] : e._e(), t("span", { staticClass: "slash" }, [e._v("/")]), e.ticket.status === "SCRATCH" ? [t("img", { staticClass: "item-icon", class: [e.ticket.type], attrs: { src: e.getIcon(e.ticket.type) } }), t("div", { staticClass: "ticket-link" }, [e._v(" " + e._s(e.$t("ticket.yourTicket")) + " ")])] : [t(e.ticket.type === "feedback" ? "span" : "router-link", { tag: "component", staticClass: "ticket-link", attrs: { to: e.getTicketRoute(e.ticket.canonicalId) } }, [t("img", { staticClass: "item-icon", class: [e.ticket.type], attrs: { src: e.getIcon(e.ticket.type) } }), e._v(" #" + e._s(e.getCanonicalNumber(e.ticket.canonicalId)) + " ")])]] : e._e()], 2);
}, xk = [], Ck = /* @__PURE__ */ x(
  kk,
  wk,
  xk,
  !1,
  null,
  "acec3b1e"
);
const Sk = Ck.exports;
f({
  name: "TicketBalance",
  props: {
    balance: {
      type: Number,
      default: 0
    },
    compact: {
      type: Boolean,
      default: !1
    },
    menuOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    displayBalance() {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        signDisplay: "auto",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.balance);
    }
  },
  methods: {
    openTransactions() {
      this.$emit("openTransactions");
    }
  }
});
const Ik = f({
  name: "TicketTransactions",
  props: {
    ticketId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !0,
      walletTransactions: [],
      walletOwners: {}
    };
  },
  async created() {
    const e = await this.$gateway.portal.loadTicketWalletTransactions(this.ticketId);
    e && ([, this.walletTransactions, this.walletOwners] = e), this.loading = !1, this.scrollToTransactions();
  },
  methods: {
    scrollToTransactions() {
      setTimeout(() => {
        var e;
        const { hash: t } = window.location;
        t === "#transactions" && ((e = document.getElementById(t.slice(1))) == null || e.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start"
        }));
      }, 50);
    }
  }
});
var Dk = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, e.loading ? t("app-loading", { staticClass: "app-loading" }) : t("wallet-transactions", { attrs: { id: "transactions", owners: e.walletOwners, transactions: e.walletTransactions } });
}, Pk = [], Tk = /* @__PURE__ */ x(
  Ik,
  Dk,
  Pk,
  !1,
  null,
  "5d3d5bd8"
);
const Ok = Tk.exports, Bk = f({
  props: {
    workflow: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    },
    transition: {
      type: Object,
      required: !0
    }
  },
  computed: {
    faIcon() {
      return `fal fa-${this.transition.icon}`;
    },
    label() {
      const e = this.transition.transitionTo, t = this.$res(this.transition.resources, {});
      if (t.transitionLabel)
        return t.transitionLabel;
      const i = J(e, this.workflow), { label: r } = this.$res(i);
      return this.$t("common.moveTo", { label: r }).toString();
    },
    hasPermission() {
      return this.checkPermission(this.transition.requiredActions ?? []);
    }
  },
  methods: {
    checkPermission(e) {
      return e.length === 0 ? !0 : e.some((t) => this.userActions.includes(t));
    },
    onTransition(e) {
      e.stopPropagation(), this.$emit("execute-transition", this.transition);
    }
  }
});
var Mk = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-action-button", { staticClass: "action-button", attrs: { enabled: e.hasPermission, "fa-icon": e.faIcon, label: e.label }, on: { click: e.onTransition } });
}, Rk = [], Ek = /* @__PURE__ */ x(
  Bk,
  Mk,
  Rk,
  !1,
  null,
  "8dc20a37"
);
const Cc = Ek.exports, Lk = f({
  components: { TicketQuickTransition: Cc },
  props: {
    workflow: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    },
    transitions: {
      type: Array,
      required: !0
    }
  },
  methods: {
    onTransition(e) {
      this.$emit("execute-transition", e);
    }
  }
});
var Fk = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-section", { attrs: { level: 2, title: e.$t("page.editTicket.sideOptions") } }, e._l(e.transitions, function(i, r) {
    return t("ticket-quick-transition", { key: r, attrs: { transition: i, "user-actions": e.userActions, workflow: e.workflow }, on: { "execute-transition": e.onTransition } });
  }), 1);
}, jk = [], Uk = /* @__PURE__ */ x(
  Lk,
  Fk,
  jk,
  !1,
  null,
  "dcc07ef7"
);
const Sc = Uk.exports, qk = f({
  props: {
    autocomplete: {
      type: String,
      required: !1
    }
  }
});
var Hk = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("base-input-item", e._b({ staticClass: "app-text-input" }, "base-input-item", e.$attrs, !1), [t("base-input-text", e._g(e._b({ attrs: { autocomplete: e.autocomplete } }, "base-input-text", e.$attrs, !1), e.$listeners))], 1);
}, zk = [], Nk = /* @__PURE__ */ x(
  qk,
  Hk,
  zk,
  !1,
  null,
  "490ccb70"
);
const Vk = Nk.exports, Gk = f({
  props: {
    align: {
      type: String,
      default: "start",
      validator(e) {
        return ["start", "center", "end"].includes(e);
      }
    },
    theme: {
      type: String,
      default: "white",
      validator(e) {
        return ["white", "gray"].includes(e);
      }
    }
  }
});
var Wk = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-button-sheet", class: [e.theme, e.align] }, [e._t("default")], 2);
}, Qk = [], Xk = /* @__PURE__ */ x(
  Gk,
  Wk,
  Qk,
  !1,
  null,
  "b25a6a7e"
);
const Kk = Xk.exports, Yk = f({
  components: {
    AppButtonSheet: Kk,
    TicketAvailableTransitions: Sc,
    TicketQuickTransition: Cc
  },
  props: {
    workflow: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    },
    availableTransitions: {
      type: Array,
      required: !0
    },
    preferredTransition: {
      type: Object,
      required: !1
    },
    theme: {
      type: String,
      default: "primary"
    },
    showDescription: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      visible: !1
    };
  },
  computed: {
    currentStatus() {
      var e;
      return ((e = this.preferredTransition) == null ? void 0 : e.transitionFrom) ?? this.availableTransitions[0].transitionFrom;
    },
    buttonLabel() {
      if (this.currentStatus) {
        const i = J(this.currentStatus, this.workflow), { buttonLabel: r } = this.$res(i);
        if (r)
          return r;
      }
      if (!this.preferredTransition)
        return this.$t("page.editTicket.sideOptions").toString();
      const e = J(
        this.preferredTransition.transitionTo,
        this.workflow
      ), { label: t } = this.$res(e);
      return this.$t("common.goTo", { label: t }).toString();
    },
    transitionTipTitle() {
      return this.showDescription ? this.resources.transitionTipTitle : "";
    },
    resources() {
      var e;
      const t = {
        transitionTipTitle: this.$t("page.editTicket.moveToNextPhase.title"),
        transitionTipMessage: this.$t("page.editTicket.moveToNextPhase.text")
      };
      if (!this.preferredTransition)
        return t;
      const i = J(
        this.preferredTransition.transitionTo,
        this.workflow
      ), r = this.$res(i);
      return (r != null && r.transitionTipTitle || r != null && r.transitionTipMessage) && console.warn("[DEPRECATED] Using deprecated status translation"), this.$res(
        ((e = this.preferredTransition) == null ? void 0 : e.resources) ?? i,
        t
      );
    },
    hasPermission() {
      var e;
      return this.checkPermission(
        ((e = this.preferredTransition) == null ? void 0 : e.requiredActions) ?? []
      );
    }
  },
  methods: {
    pressMainButton() {
      this.preferredTransition ? this.onTransition(this.preferredTransition) : this.visible = !this.visible;
    },
    checkPermission(e) {
      return e.length === 0 ? !0 : e.some((t) => this.userActions.includes(t));
    },
    onTransition(e) {
      this.$emit("execute-transition", e);
    }
  }
});
var Zk = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-section", { attrs: { level: 2, title: e.transitionTipTitle } }, [e.showDescription ? t("span", { staticClass: "transition-description" }, [e._v(" " + e._s(e.resources.transitionTipMessage) + " ")]) : e._e(), e.availableTransitions.length || e.preferredTransition ? t("div", { staticClass: "button-container", class: {
    [`${e.theme}-theme`]: !0,
    "hide-trigger": !e.preferredTransition
  } }, [t("app-button", { staticClass: "app-button", attrs: { disabled: !e.hasPermission, label: e.buttonLabel }, on: { click: e.pressMainButton } }), e.availableTransitions.length ? t("app-floating", { style: { position: "static" }, attrs: { "floating-style": { width: "unset", zIndex: "50" }, placement: "bottom-start" }, scopedSlots: e._u([{ key: "content", fn: function() {
    return [e.preferredTransition ? t("app-icon-button", { staticClass: "app-icon-button", attrs: { size: 48, frame: "square" }, on: { "!click": function(i) {
      i.stopPropagation(), i.preventDefault();
    } } }, [t("fa-icon-compat", { staticClass: "open-icon", attrs: { icon: "fa-solid fa-ellipsis-vertical" } })], 1) : e._e()];
  }, proxy: !0 }, { key: "options", fn: function() {
    return [t("ticket-available-transitions", { staticClass: "side-options", attrs: { transitions: e.availableTransitions, "user-actions": e.userActions, workflow: e.workflow }, on: { "execute-transition": e.onTransition } })];
  }, proxy: !0 }], null, !1, 4065610175), model: { value: e.visible, callback: function(i) {
    e.visible = i;
  }, expression: "visible" } }) : e._e()], 1) : e._e()]);
}, Jk = [], _k = /* @__PURE__ */ x(
  Yk,
  Zk,
  Jk,
  !1,
  null,
  "ebc24cea"
);
const Ic = _k.exports;
f({
  components: { TicketPreferredTransition: Ic },
  props: {
    statusHistory: {
      type: Array,
      required: !0
    },
    status: {
      type: String,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    },
    availableTransitions: {
      type: Array,
      required: !0
    },
    preferredTransition: {
      type: Object,
      required: !1
    }
  },
  computed: {
    config() {
      return this.phaseConfig.map(({ phase: e }) => e);
    },
    phaseConfig() {
      return ic(this.workflow);
    },
    currentProgress() {
      return this.isFinalStatus ? this.phaseConfig[this.currentPhaseIndex].status.length : this.currentStatusIndex;
    },
    currentStatusIndex() {
      const e = this.phaseConfig[this.currentPhaseIndex].status.findIndex(
        (t) => t === this.status
      );
      return e === -1 ? 0 : e;
    },
    currentPhaseIndex() {
      for (let e = this.phaseConfig.length - 1; e >= 0; e--)
        if (this.phaseConfig[e].status.includes(this.status))
          return e;
      return 0;
    },
    phase() {
      const e = J(
        this.phaseConfig[this.currentPhaseIndex].phase,
        this.workflow,
        "phases"
      );
      return this.$res(e, {});
    },
    phaseCompleteTitle() {
      return this.phase.completeTitle ?? this.$t("ticket.completePhase", { phase: this.phase.label }).toString();
    },
    progressStyle() {
      return `--color-custom: ${Bi(
        this.phaseConfig[this.currentPhaseIndex].phase,
        this.workflow,
        "phases"
      )}`;
    },
    buttonTheme() {
      return this.currentStatusIndex === this.phaseConfig[this.currentPhaseIndex].status.length - 1 ? "primary" : "secondary";
    },
    finalStatus() {
      var e, t, i;
      return ((i = (t = (e = this.workflow) == null ? void 0 : e.settings) == null ? void 0 : t.finalStatus) == null ? void 0 : i[0]) ?? "";
    },
    isFinalStatus() {
      return this.status === this.finalStatus;
    }
  },
  methods: {
    statusRes(e) {
      return this.$res(J(e, this.workflow, "status"), {});
    },
    iconClass(e, t) {
      return this.currentStatusIndex > e && this.statusHistory.includes(t) || this.currentStatusIndex === e && t === this.finalStatus ? "fa-regular fa-check" : this.currentStatusIndex === e ? "fa-regular fa-dash" : "fa-regular fa-question";
    },
    onExecuteTransition(e) {
      this.$emit("execute-transition", e);
    }
  }
});
f({
  props: {
    value: {
      type: String,
      required: !1
    },
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    productId: {
      type: String,
      required: !0
    },
    products: {
      type: Array,
      required: !0
    },
    context: {
      type: String,
      required: !0
    },
    excludeTicketId: {
      type: String,
      required: !1
    }
  },
  async created() {
    if (this.value) {
      const e = await this.fetchTicketsByIds([this.value]);
      this.options = this.mapDataToDropdown(e), this.ticketSelected = this.value;
    }
  },
  data() {
    return {
      loading: !1,
      options: [],
      ticketSelected: ""
    };
  },
  methods: {
    onUpdate(e) {
      this.$emit("input", e);
    },
    onToggleOpen(e) {
      e || (this.options = [], this.$emit("blur"));
    },
    async fetchTicketsByIds(e) {
      return this.$gateway.ticket.loadTicketsByBatch(
        this.context,
        this.productId,
        e
      );
    },
    mapDataToDropdown(e) {
      return e.map((t) => {
        const i = J(t.ticket.status, t.workflow), r = this.$res(i).label;
        return {
          text: t.ticket.title,
          value: t.ticket.canonicalId,
          description: `${t.ticket.canonicalId} (${r})`,
          image: Kt(t.workflow).icons.solid
        };
      });
    },
    async onSearchDebounced(e) {
      if (e.length < 3) {
        this.options = [];
        return;
      }
      this.loading = !0;
      const t = 30, i = (await this.$gateway.search.searchTicketIds({
        query: e,
        filter: {
          type: this.products
        },
        limit: t
      })).filter((s) => s !== this.excludeTicketId).slice(0, t), r = await this.fetchTicketsByIds(i);
      this.options = this.mapDataToDropdown(r), this.loading = !1;
    }
  }
});
class Tt {
  constructor(t, i) {
    I(this, "class"), I(this, "tag"), this.class = t, this.tag = i;
  }
  static build(t) {
    if (typeof t == "string") {
      const [i, r] = t.split(":");
      return (!i || !r) && console.error(`Could not parse malformed tag '${t}'`), new Tt(i, r);
    } else
      return new Tt(t.class, t.tag);
  }
  toString() {
    return `${this.class}:${this.tag}`;
  }
}
class xr {
  constructor(t) {
    I(this, "tagList"), I(this, "classList");
    const i = new Set(t);
    this.tagList = [...i].map(Tt.build), this.classList = new Set(this.tagList.map((r) => r.tag));
  }
  get classes() {
    return [...this.classList];
  }
  get tagsAsString() {
    return this.tagList.map((t) => t.toString());
  }
  get tags() {
    return this.tagList;
  }
  static build(t) {
    return new xr(t);
  }
  addTag(t) {
    const i = Tt.build(t);
    this.tagList.push(i), this.classList.add(i.class);
  }
  removeTag(t) {
    const i = Tt.build(t);
    this.tagList = this.tagList.filter((r) => r.toString() !== t), this.filterClass(i.class) && this.classList.delete(i.class);
  }
  filterClass(t) {
    return this.tagList.filter((i) => i.class === t);
  }
  includesSomeTag(t) {
    return t.some((i) => this.tags.some((r) => r.toString() === i));
  }
  includesEveryTag(t) {
    return t.every((i) => this.tags.some((r) => r.toString() === i));
  }
  includesSomeClass(t) {
    return t.some((i) => this.classes.includes(i));
  }
  includesEveryClass(t) {
    return t.every((i) => this.classes.includes(i));
  }
}
f({
  props: {
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    productId: {
      type: String,
      required: !0
    },
    offerGroup: {
      type: String,
      required: !1
    },
    context: {
      type: String,
      required: !0
    }
  },
  async created() {
    try {
      this.loading = !0;
      const e = await this.$gateway.offer.loadAvailableOffers(this.offerGroup);
      this.data = e.filter(
        ([t]) => !xr.build(t.tags).includesSomeClass(["product"]) || xr.build(t.tags).includesSomeTag([this.productId])
      ), this.options = this.mapDataToDropdown(this.data);
    } catch (e) {
      this.$toast(this.$t("error.general").toString()), console.error("Error loading Service Overview", e);
    } finally {
      this.loading = !1;
    }
  },
  data() {
    return {
      loading: !1,
      options: [],
      data: [],
      selectedOffer: ""
    };
  },
  methods: {
    onUpdate(e) {
      const t = this.data.find(([i]) => i.id === e);
      this.$emit("input", t == null ? void 0 : t[0]);
    },
    mapDataToDropdown(e) {
      return e.map(([t, i]) => {
        const r = this.$res(t.resources, {});
        return {
          text: r.title,
          value: t.id,
          description: `${this.$t(
            "bulkActions.purchaseOfferModal.offerPriceLabel"
          )}: ${t.price} ${i ? ` - ${i.name}` : ""}`,
          image: r.image
        };
      });
    }
  }
});
const $k = f({
  props: {
    status: {
      type: String,
      default: ""
    },
    workflow: {
      type: Object
    }
  },
  computed: {
    statusLabel() {
      var e;
      const t = J(this.status, this.workflow);
      return ((e = this.$res(t)) == null ? void 0 : e.label) ?? this.status;
    }
  }
});
var e0 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "status" }, [e._v(" " + e._s(e.statusLabel) + " ")]);
}, t0 = [], i0 = /* @__PURE__ */ x(
  $k,
  e0,
  t0,
  !1,
  null,
  "d48bc6dc"
);
const r0 = i0.exports, s0 = "/img/profile-placeholder.svg", n0 = f({
  props: {
    comment: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !1
    },
    threadOwnerId: {
      type: String,
      required: !1
    },
    threadOwnerLabel: {
      type: String,
      required: !1
    },
    allowEdit: {
      type: Boolean,
      default: !1
    },
    allowDelete: {
      type: Boolean,
      default: !1
    },
    contextId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      text: "",
      showText: !1,
      showEdit: !1
    };
  },
  created() {
    this.text = this.comment.content ?? "", this.parsingMentionsOnComment();
  },
  computed: {
    commentIdHtml() {
      return `comment_${this.comment.commentId}`;
    },
    authorAvatar() {
      var e, t;
      return ((t = (e = this.comment.author) == null ? void 0 : e.user) == null ? void 0 : t.avatar) || s0;
    },
    displayName() {
      const e = this.comment.author;
      if (e)
        return B(e).displayName();
    },
    userDepartment() {
      const e = this.comment.author;
      if (e)
        return B(e).userDepartment();
    },
    commentTitle() {
      return [this.displayName, this.userDepartment].filter((e) => !!e).join(", ");
    },
    displayThreadOwnerLabel() {
      var e, t;
      if (this.threadOwnerId && this.threadOwnerId === ((t = (e = this.comment.author) == null ? void 0 : e.user) == null ? void 0 : t.id))
        return this.threadOwnerLabel;
    },
    commentDate() {
      var e;
      const t = (e = this.comment) == null ? void 0 : e.createdAt;
      if (!t)
        return "";
      const i = new Date(t), r = {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
      };
      return i.toLocaleDateString(void 0, r);
    },
    routeToUser() {
      var e, t;
      return {
        name: "UserProfile",
        params: { userId: ((t = (e = this.comment.author) == null ? void 0 : e.user) == null ? void 0 : t.id) ?? "" }
      };
    },
    useRouterLink() {
      var e, t;
      const i = (e = this.$router.options.routes) == null ? void 0 : e.find(
        (r) => r.path.includes("product")
      );
      return !!((t = i == null ? void 0 : i.children) != null && t.find((r) => r.name === "UserProfile"));
    }
  },
  methods: {
    onDeleteComment() {
      var e;
      this.$emit("delete-comment", (e = this.comment) == null ? void 0 : e.commentId);
    },
    onEditComment() {
      this.showEdit = !0;
    },
    onCancelEditComment() {
      this.showEdit = !1;
    },
    onUpdateComment(e) {
      this.showEdit = !1, this.$emit("update-comment", {
        comment: this.comment,
        text: e
      });
    },
    async parsingMentionsOnComment() {
      const e = /@{(.*?)}/g, t = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g, i = this.text.match(e), r = this.text.match(t), s = i == null ? void 0 : i.map((n) => n.slice(2, -1)).map((n) => `mail:${n}`);
      if (s != null && s.length) {
        const n = await this.$api.users.fetchUriByBatch(s), a = await this.$datasource.user.listBatch(r), o = on(a, (l) => l.id);
        i == null || i.forEach((l) => {
          const c = l.slice(2, -1), u = Fg().getUserReference(c), d = n[`mail:${c}`] ?? o.get((u == null ? void 0 : u.value) ?? "");
          if (d) {
            const h = `${d.firstName} ${d.lastName}`;
            this.productId ? this.text = this.text.replace(
              l,
              `[@${h}](/${this.productId}/profile/${d.id}/tickets)`
            ) : this.text = this.text.replace(l, `*@${h}*`);
          } else
            this.text = this.text.replace(l, `**@${c}**`);
        });
      }
      this.showText = !0;
    }
  }
});
var a0 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "classic-comment-item", attrs: { id: e.commentIdHtml } }, [t(e.useRouterLink ? "router-link" : "div", { tag: "component", staticClass: "comment-header", attrs: { to: e.routeToUser } }, [t("img", { staticClass: "author-avatar", attrs: { src: e.authorAvatar } }), t("div", { staticClass: "content" }, [t("div", { staticClass: "comment-title" }, [t("span", [e._v(e._s(e.commentTitle))]), e.displayThreadOwnerLabel ? t("span", { staticClass: "thread-owner" }, [e._v(" " + e._s(e.displayThreadOwnerLabel) + " ")]) : e._e()]), t("div", { staticClass: "comment-date" }, [e._v(" " + e._s(e.commentDate) + " ")])]), t("div", { staticClass: "controls" }, [e.allowEdit ? t("app-icon-button", { staticClass: "edit-comment-button", attrs: { size: 26 }, on: { click: function(i) {
    return i.preventDefault(), e.onEditComment.apply(null, arguments);
  } } }, [t("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-pencil" } })], 1) : e._e(), e.allowDelete ? t("app-icon-button", { staticClass: "delete-comment-button", attrs: { size: 26 }, on: { click: function(i) {
    return i.preventDefault(), e.onDeleteComment.apply(null, arguments);
  } } }, [t("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1) : e._e()], 1)]), e.showEdit ? t("div", { staticClass: "text-area-wrapper" }, [t("classic-comment-area", { attrs: { "original-text": e.comment.content, "context-id": e.contextId }, on: { "cancel-comment": e.onCancelEditComment, "save-comment": e.onUpdateComment } })], 1) : e.showText ? t("app-markdown-text", { staticClass: "comment-text", attrs: { text: e.text } }) : e._e()], 1);
}, o0 = [], l0 = /* @__PURE__ */ x(
  n0,
  a0,
  o0,
  !1,
  null,
  "f35d9ed1"
);
const c0 = l0.exports, u0 = f({
  components: { ClassicCommentItem: c0 },
  props: {
    commentIdPrefix: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !1
    },
    comments: {
      type: Array,
      default: () => []
    },
    threadOwnerId: {
      type: String,
      default: ""
    },
    threadOwnerLabel: {
      type: String,
      default: ""
    },
    permissions: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      newCommentText: "",
      showDeleteCommentModal: !1,
      currentComment: {}
    };
  },
  mounted() {
    this.scrollToComment();
  },
  computed: {
    newestComments() {
      return [...this.comments].sort(
        (e, t) => t.createdAt - e.createdAt
      );
    }
  },
  methods: {
    scrollToComment() {
      setTimeout(() => {
        const e = this.$route.hash.split("_");
        if (e.length === 2 && e[0] === `#${this.commentIdPrefix}`) {
          const t = document.getElementById(`comment_${e[1]}`);
          t == null || t.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "start"
          });
        }
      }, 1e3);
    },
    allowAction(e, t) {
      var i, r;
      if (!this.permissions)
        return !1;
      const { admin: s, user: n } = this.permissions;
      return s[t] || n[t] && this.currentUser.id === ((r = (i = e.author) == null ? void 0 : i.user) == null ? void 0 : r.id);
    },
    onCreateComment(e) {
      this.$emit("post-comment", e);
    },
    onUpdateComment(e) {
      this.$emit("update-comment", e);
    },
    onDeleteComment(e) {
      const t = this.comments.find((i) => i.commentId === e);
      t && this.openDeleteCommentModal(t);
    },
    openDeleteCommentModal(e) {
      this.currentComment = e, this.showDeleteCommentModal = !0;
    },
    closeDeleteCommentModal() {
      this.showDeleteCommentModal = !1;
    },
    deleteComment() {
      this.closeDeleteCommentModal(), this.$emit("delete-comment", this.currentComment);
    }
  }
});
var d0 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-form", { staticClass: "base-comment-container" }, [t("classic-comment-area", { attrs: { "context-id": e.contextId }, on: { "save-comment": e.onCreateComment } }), e._l(e.newestComments, function(i) {
    return t("div", { key: i.id }, [t("classic-comment-item", { attrs: { "allow-delete": e.allowAction(i, "delete"), "allow-edit": e.allowAction(i, "edit"), comment: i, "product-id": e.productId, "thread-owner-id": e.threadOwnerId, "thread-owner-label": e.threadOwnerLabel, "context-id": e.contextId }, on: { "delete-comment": e.onDeleteComment, "update-comment": e.onUpdateComment } })], 1);
  }), e.showDeleteCommentModal ? t("app-modal-confirmation", { attrs: { title: e.$t("modal.deleteComment.title"), description: e.$t("modal.deleteComment.description"), "primary-label": e.$t("form.button.confirm"), "secondary-label": e.$t("form.button.cancel") }, on: { "click-primary": e.deleteComment, "click-secondary": e.closeDeleteCommentModal } }) : e._e()], 2);
}, h0 = [], p0 = /* @__PURE__ */ x(
  u0,
  d0,
  h0,
  !1,
  null,
  "df27714b"
);
const Dc = p0.exports, f0 = f({
  props: {
    targetId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !1
    },
    threadOwnerId: {
      type: String,
      required: !0
    },
    threadOwnerLabel: {
      type: String,
      default: ""
    },
    userActions: {
      type: Array,
      default: () => []
    },
    contextId: {
      type: String,
      required: !0
    }
  },
  components: {
    BaseComments: Dc
  },
  data() {
    return {
      reloadKey: 0,
      comments: [],
      commentPermissions: {
        admin: {
          delete: !1,
          edit: !1
        },
        user: {
          delete: !1,
          edit: !1
        }
      }
    };
  },
  async created() {
    this.commentPermissions = {
      admin: {
        delete: this.userActions.includes("ADMIN_COMMENT_DELETE"),
        edit: this.userActions.includes("ADMIN_COMMENT_UPDATE")
      },
      user: {
        delete: this.userActions.includes("USER_COMMENT_DELETE"),
        edit: this.userActions.includes("USER_COMMENT_WRITE")
      }
    }, await this.loadComments();
  },
  methods: {
    async loadComments() {
      this.comments = await this.$gateway.portal.getPublicComments(
        this.targetId
      );
    },
    updateComment(e) {
      var t, i, r, s;
      const { comment: n, text: a } = e, o = this.currentUser.id === ((i = (t = n.author) == null ? void 0 : t.user) == null ? void 0 : i.id), l = { author: (s = (r = n.author) == null ? void 0 : r.user) == null ? void 0 : s.id, content: a };
      o ? this.$api.comment.updateOwnComment(
        this.targetId,
        n.commentId,
        l
      ) : this.$api.comment.adminUpdateComment(
        this.targetId,
        n.commentId,
        l
      ), this.comments = this.comments.map(
        (c) => c.commentId === n.commentId ? { ...c, content: a } : c
      ), this.reloadKey += 1, this.refreshReactionBoard();
    },
    async deleteComment(e) {
      var t, i;
      const r = this.currentUser.id === ((i = (t = e.author) == null ? void 0 : t.user) == null ? void 0 : i.id);
      let s;
      r ? s = this.$api.comment.deleteOwnComment(
        this.targetId,
        e.commentId
      ) : s = this.$api.comment.adminDeleteComment(
        this.targetId,
        e.commentId
      ), this.comments = this.comments.filter(
        (n) => n.commentId !== e.commentId
      ), await s, this.reloadKey += 1, this.refreshReactionBoard();
    },
    async postNewComment(e) {
      await this.$gateway.portal.createPublicComment(this.targetId, {
        author: this.currentUser.id,
        content: e
      }), await this.loadComments(), this.reloadKey += 1, this.refreshReactionBoard();
    },
    refreshReactionBoard() {
      this.$datasource.reaction.refreshReactionBoard(this.targetId);
    }
  }
});
var m0 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("base-comments", { key: e.reloadKey, attrs: { "comment-id-prefix": "comment", "current-user": e.currentUser, "product-id": e.productId, comments: e.comments, "thread-owner-id": e.threadOwnerId, "thread-owner-label": e.threadOwnerLabel, permissions: e.commentPermissions, "context-id": e.contextId }, on: { "delete-comment": e.deleteComment, "post-comment": e.postNewComment, "update-comment": e.updateComment } });
}, g0 = [], y0 = /* @__PURE__ */ x(
  f0,
  m0,
  g0,
  !1,
  null,
  null
);
const b0 = y0.exports, v0 = f({
  props: {
    targetId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !1
    },
    threadOwnerId: {
      type: String,
      required: !1
    },
    threadOwnerLabel: {
      type: String,
      required: !1
    },
    userActions: {
      type: Array,
      default: () => []
    },
    targetType: {
      type: String,
      default: "TICKET"
    },
    contextId: {
      type: String,
      required: !0
    }
  },
  components: {
    BaseComments: Dc
  },
  data() {
    return {
      reloadKey: 0,
      commentPermissions: {
        admin: {
          delete: !1,
          edit: !1
        },
        user: {
          delete: !1,
          edit: !1
        }
      },
      comments: []
    };
  },
  async created() {
    this.commentPermissions = {
      admin: {
        delete: this.userActions.includes("ADMIN_PRIVATE_COMMENT_DELETE"),
        edit: this.userActions.includes("ADMIN_PRIVATE_COMMENT_WRITE")
      },
      user: {
        delete: this.userActions.includes("ADMIN_PRIVATE_COMMENT_DELETE_OWN"),
        edit: this.userActions.includes("ADMIN_PRIVATE_COMMENT_WRITE")
      }
    }, await this.loadComments();
  },
  methods: {
    async loadComments() {
      this.comments = await this.$gateway.portal.getPrivateComments(
        this.targetId,
        this.targetType
      );
    },
    updateComment(e) {
      var t, i, r, s;
      const { comment: n, text: a } = e, o = this.currentUser.id === ((i = (t = n.author) == null ? void 0 : t.user) == null ? void 0 : i.id), l = { author: (s = (r = n.author) == null ? void 0 : r.user) == null ? void 0 : s.id, content: a };
      o ? this.$api.privateComment.adminUpdateOwnComment(
        this.targetId,
        n.commentId,
        l,
        this.targetType
      ) : this.$api.privateComment.adminUpdateComment(
        this.targetId,
        n.commentId,
        l,
        this.targetType
      ), this.comments = this.comments.map(
        (c) => c.commentId === n.commentId ? { ...c, content: a } : c
      ), this.reloadKey += 1;
    },
    deleteComment(e) {
      var t, i;
      this.currentUser.id === ((i = (t = e.author) == null ? void 0 : t.user) == null ? void 0 : i.id) ? this.$api.privateComment.deleteOwnComment(
        this.targetId,
        e.commentId,
        this.targetType
      ) : this.$api.privateComment.deleteComment(
        this.targetId,
        e.commentId,
        this.targetType
      ), this.comments = this.comments.filter(
        (r) => r.commentId !== e.commentId
      ), this.reloadKey += 1, this.$emit("delete-comment");
    },
    async postNewComment(e) {
      await this.$api.privateComment.createComment(
        this.targetId,
        this.targetType,
        {
          author: this.currentUser.id,
          content: e
        }
      ), await this.loadComments(), this.reloadKey += 1, this.$emit("post-comment");
    }
  }
});
var A0 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("base-comments", { key: e.reloadKey, attrs: { "comment-id-prefix": "privatecomment", "product-id": e.productId, "current-user": e.currentUser, comments: e.comments, "thread-owner-id": e.threadOwnerId, "thread-owner-label": e.threadOwnerLabel, permissions: e.commentPermissions, "context-id": e.contextId }, on: { "delete-comment": e.deleteComment, "post-comment": e.postNewComment, "update-comment": e.updateComment } });
}, k0 = [], w0 = /* @__PURE__ */ x(
  v0,
  A0,
  k0,
  !1,
  null,
  null
);
const x0 = w0.exports;
f({
  components: {
    PublicCommentsWidget: b0,
    PrivateCommentsWidget: x0,
    TicketHistoryWidget: dk,
    TicketTransactionsWidget: Ok
  },
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    value: {
      type: String,
      required: !1
    },
    currentUser: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    },
    userRoles: {
      type: Array,
      required: !0
    },
    showTransactions: {
      type: Boolean,
      default: !1
    },
    contextId: {
      type: String,
      required: !0
    },
    appId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      tabs: {
        comments: !0,
        privateComments: !1,
        history: !1,
        transactions: !1
      },
      currentTab: "comments",
      publicCreatorTitle: ""
    };
  },
  async created() {
    this.publicCreatorTitle = await this.getPublicCreatorTitle(this.ticket);
  },
  watch: {
    value(e) {
      this.currentTab !== e && this.goToTab(e);
    }
  },
  async mounted() {
    this.$route.hash.startsWith("#privatecomment") && this.goToTab("privateComments"), this.$route.hash === "#transactions" && this.goToTab("transactions");
  },
  computed: {
    showPrivateNotes() {
      return this.userActions.some(
        (e) => e === "ADMIN_PRIVATE_COMMENT_READ"
      );
    },
    tabOptions() {
      return [
        {
          label: this.$t("common.comments").toString(),
          tabKey: "comments"
        },
        {
          label: this.$t("common.history").toString(),
          tabKey: "history"
        },
        {
          label: this.$t("common.privateNotes").toString(),
          tabKey: "privateComments",
          visible: this.showPrivateNotes
        },
        {
          label: this.$t("common.transactions").toString(),
          tabKey: "transactions",
          visible: this.showTransactions
        }
      ];
    }
  },
  methods: {
    goToTab(e) {
      this.hideTabs(), this.tabs[e] = !0, this.currentTab = e, this.$emit("input", e);
    },
    hideTabs() {
      Object.keys(this.tabs).forEach((e) => {
        this.tabs[e] = !1;
      });
    },
    async getPublicCreatorTitle(e) {
      var t;
      const i = await this.$datasource.workflow.find(
        e.type,
        e.context
      ), r = an(i, this.appId).page(
        this.$router.currentRoute.name
      );
      return ((t = this.$res(r == null ? void 0 : r.resources)) == null ? void 0 : t.creator) ?? "";
    }
  }
});
const C0 = f({
  components: {
    ProductDropdown: Ac
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    ticketId: {
      type: String,
      required: !0
    },
    action: {
      type: String,
      default: "copy"
    }
  },
  data() {
    return {
      loading: !1,
      targetProduct: "",
      workflows: []
    };
  },
  async created() {
    this.workflows = await this.$gateway.admin.fetchWorkflowsByBatch(
      this.productIds,
      this.organization.name
    ), this.targetProduct = this.productIds[0];
  },
  computed: {
    productIds() {
      const { productsData: e } = Ge(this.organization);
      return e.value.filter(
        ({ customization: t }) => {
          var i;
          return !!((i = t.ticketCopyMapping) != null && i[this.productId]);
        }
      ).filter(
        ({ productId: t }) => !(this.action === "move" && t === this.productId)
      ).map(({ productId: t }) => t).flat();
    }
  },
  methods: {
    async executeAction() {
      try {
        this.loading = !0;
        let e;
        return this.action === "copy" ? e = await this.$api.ticket.copyTicket(
          this.productId,
          this.targetProduct,
          this.ticketId
        ) : e = await this.$api.ticket.moveTicket(
          this.productId,
          this.targetProduct,
          this.ticketId
        ), e == null ? void 0 : e.canonicalId;
      } catch (e) {
        console.error(`Could not execute ${this.action} action`, e);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const e = await this.executeAction();
      if (e) {
        this.$emit("confirm", e);
        return;
      }
      this.onCancel();
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var S0 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { attrs: { loading: e.loading } }, [t("div", { staticClass: "modal-content" }, [t("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.$t(`ticket.${e.action}.title`)) + " ")]), t("div", { staticClass: "modal-description" }, [e._v(" " + e._s(e.$t(`ticket.${e.action}.description`)) + " ")]), t("product-dropdown", { staticClass: "product-dropdown", attrs: { context: e.organization.name, placeholder: e.$t("form.placeholder.productSelect"), products: e.productIds, workflows: e.workflows }, model: { value: e.targetProduct, callback: function(i) {
    e.targetProduct = i;
  }, expression: "targetProduct" } }), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [t("app-button", { attrs: { enabled: !!e.targetProduct, label: e.$t("common.form.confirm") }, on: { click: e.onConfirm } }), t("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } })], 1)], 1)]);
}, I0 = [], D0 = /* @__PURE__ */ x(
  C0,
  S0,
  I0,
  !1,
  null,
  "c0cef0bd"
);
const P0 = D0.exports;
f({
  components: {
    TicketCopyMoveModal: P0
  },
  props: {
    userActions: {
      type: Array,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    ticketId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      showResult: !1,
      showActionModal: !1,
      action: void 0,
      targetProduct: "",
      newTicketId: ""
    };
  },
  computed: {
    menuItems() {
      return [
        {
          label: this.$t("common.copy").toString(),
          tabKey: "copy",
          visible: this.showCopyOption
        },
        {
          label: this.$t("common.move").toString(),
          tabKey: "move",
          visible: this.showMoveOption
        }
      ].filter(({ visible: e }) => e);
    },
    showCopyOption() {
      return this.checkPermission("USER_TICKET_COPY") && this.hasDuplicationSettings;
    },
    showMoveOption() {
      return this.checkPermission("USER_TICKET_MOVE") && this.hasDuplicationSettings;
    },
    hasDuplicationSettings() {
      const { productsData: e } = Ge(this.organization);
      return e.value.some(
        ({ customization: t }) => {
          var i;
          return !!((i = t.ticketCopyMapping) != null && i[this.productId]);
        }
      );
    }
  },
  methods: {
    checkPermission(e) {
      const t = `${this.productId.toUpperCase()}_${e}`;
      return this.userActions.includes(e) || this.userActions.includes(t);
    },
    onMove() {
      this.action = "move", this.showActionModal = !0;
    },
    onCopy() {
      this.action = "copy", this.showActionModal = !0;
    },
    onCancel() {
      this.reset();
    },
    onConfirm(e) {
      this.showActionModal = !1, this.showResult = !0, this.newTicketId = e;
    },
    reset() {
      this.showResult = !1, this.showActionModal = !1, this.action = void 0, this.newTicketId = "", this.targetProduct = "";
    },
    onGoToTicket() {
      this.$router.push({
        name: "TicketDetails",
        params: { id: this.newTicketId }
      });
    }
  }
});
f({
  props: {
    assignee: {
      type: Object,
      required: !0
    }
  },
  computed: {
    assigneeAvatar() {
      return this.assignee.user.avatar ?? "";
    },
    displayName() {
      return B(this.assignee).displayName();
    }
  }
});
const jo = "/img/profile-placeholder.svg";
f({
  props: {
    value: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    excludeUserIds: {
      type: Array,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      loading: !1,
      options: [],
      optionsPool: [],
      enabled: !1,
      selection: ""
    };
  },
  async created() {
    const e = await this.$gateway.portal.fetchTicketAssigneePermissions(
      this.ticketIdOrType,
      this.productId
    );
    if (this.enabled = e.update, this.value) {
      const t = await this.$gateway.portal.findUsersById([this.value]);
      this.optionsPool = t.map((i) => ({
        text: B(i).displayName(),
        value: i.user.id,
        image: i.user.avatar || jo,
        description: B(i).userDepartment()
      })), this.selection = this.value;
    }
  },
  computed: {
    ticketIdOrType() {
      return this.ticket.canonicalId ?? this.ticket.type;
    }
  },
  methods: {
    onUpdate(e) {
      this.$emit("input", e), this.$emit("update-assignee", e);
    },
    onToggleOpen(e) {
      e || (this.options = [], this.$emit("blur"));
    },
    async onSearchDebounced(e) {
      if (e.length < 3) {
        this.options = [];
        return;
      }
      this.loading = !0;
      const t = await this.$gateway.portal.fetchTicketAssigneeAudience(
        e,
        this.ticketIdOrType,
        this.productId
      );
      this.options = t.filter(({ user: i }) => i.firstName || i.lastName).filter(
        ({ user: i }) => {
          var r;
          return !((r = this.excludeUserIds) != null && r.includes(i.id));
        }
      ).map((i) => ({
        text: B(i).displayName(),
        value: i.user.id,
        image: i.user.avatar || jo,
        description: B(i).userDepartment()
      })), this.loading = !1;
    }
  }
});
f({
  components: {
    UserItem: cn,
    UserSelectionInput: un
  },
  props: {
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    routeToUser: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      ready: !1,
      canUpdate: !1,
      searchOpen: !1,
      currentSelection: void 0,
      searchOptions: []
    };
  },
  watch: {
    ticket() {
      this.load();
    }
  },
  async created() {
    await this.loadPermission(), await this.load(), this.ready = !0;
  },
  computed: {
    ticketIdOrType() {
      return this.ticket.canonicalId ?? this.ticket.type;
    },
    currentSelectionId() {
      return this.ticket.assignee;
    },
    display() {
      return this.searchOpen ? "search" : this.currentSelection ? "selected" : "empty";
    },
    menuOptions() {
      return [
        {
          label: this.$t("menu.changeToMe").toString(),
          tabKey: "assign-to-self",
          visible: this.ticket.assignee !== this.currentUser.id
        },
        {
          label: this.$t("menu.changeToSomeone").toString(),
          tabKey: "assign-to-other"
        },
        {
          label: this.$t("menu.unassign").toString(),
          tabKey: "remove-assignee"
        }
      ];
    }
  },
  methods: {
    async loadPermission() {
      try {
        const e = await this.$gateway.portal.fetchTicketAssigneePermissions(
          this.ticketIdOrType,
          this.productId
        );
        this.canUpdate = (e == null ? void 0 : e.update) ?? !1;
      } catch (e) {
        console.error("Error loading assignement permissions", e);
      }
    },
    async load() {
      try {
        if (!this.currentSelectionId) {
          this.currentSelection = void 0;
          return;
        }
        const e = await this.$gateway.portal.findUserById(
          this.currentSelectionId
        );
        this.currentSelection = e ?? void 0, this.currentSelection || console.error(
          `Error loading ticket assignee [userId=${this.currentSelectionId}]`
        );
      } finally {
        this.onCloseSearch();
      }
    },
    async onUpdateSearch(e) {
      this.searchOptions = await this.$gateway.portal.fetchTicketAssigneeAudience(
        e,
        this.ticketIdOrType,
        this.productId
      );
    },
    onRemoveAssignee() {
      this.$emit("update-assignee");
    },
    onSelectUser(e) {
      this.$emit("update-assignee", e);
    },
    onSelectSelf() {
      this.onSelectUser(this.currentUser.id);
    },
    onOpenSearch() {
      this.searchOptions = [], this.searchOpen = !0;
    },
    onCloseSearch() {
      this.searchOpen = !1;
    }
  }
});
f({
  name: "CampaignGalleryCard",
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    creator: {
      type: Object,
      required: !0
    }
  },
  computed: {
    statusLabel() {
      var e;
      const t = J(this.ticket.status, this.workflow);
      return ((e = this.$res(t)) == null ? void 0 : e.label) ?? this.ticket.status;
    },
    statusColour() {
      return Bi(this.ticket.status, this.workflow) ?? "";
    },
    coverImage() {
      return this.ticket.meta.cover || this.fileImage;
    },
    fileImage() {
      const e = this.ticket.files.find(
        (t) => t.category === "ticket-cover"
      );
      return (e == null ? void 0 : e.url) || "";
    },
    creatorUserNameAndUnit() {
      if (!this.creator)
        return "";
      const { displayName: e, userDepartment: t } = B(this.creator);
      return t() ? `${this.$t("common.by")} ${e()}, ${t()}` : `${this.$t("common.by")} ${e()}`;
    }
  }
});
f({
  name: "TicketCardCampaign",
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    creator: {
      type: Object,
      required: !1
    },
    reactionBoard: {
      type: Object,
      required: !1
    },
    showEmojiViewer: {
      type: Boolean,
      default: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    creatorVisibility: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    statusLabel() {
      var e;
      const t = J(this.ticket.status, this.workflow);
      return ((e = this.$res(t)) == null ? void 0 : e.label) ?? this.ticket.status;
    },
    statusColour() {
      return Bi(this.ticket.status, this.workflow) ?? "";
    },
    coverImage() {
      return this.ticket.meta.cover || this.fileImage;
    },
    fileImage() {
      const e = this.ticket.files.find(
        (t) => t.category === "ticket-cover"
      );
      return (e == null ? void 0 : e.url) || "";
    },
    creatorUserNameAndUnit() {
      if (!this.creator || !this.creatorVisibility)
        return "";
      const { displayName: e, userDepartment: t } = B(this.creator);
      return t() ? `${this.$t("common.by")} ${e()}, ${t()}` : `${this.$t("common.by")} ${e()}`;
    }
  }
});
const T0 = f({
  props: {
    resources: {
      type: Object,
      required: !0
    },
    firstCitizenAggregation: {
      type: Object,
      required: !1
    },
    imagePath: {
      type: String,
      required: !0
    }
  },
  computed: {
    amount() {
      return this.average && !isNaN(this.average) ? this.average.toFixed(1) : "-";
    },
    average() {
      var e;
      return (e = this.firstCitizenAggregation) == null ? void 0 : e.average;
    },
    userReviewsAmount() {
      var e;
      return ((e = this.firstCitizenAggregation) == null ? void 0 : e.userFieldsUserCount) ?? 0;
    },
    questions() {
      const { questions: e } = this.resources;
      return e.filter((t) => t.type === "rating").map((t) => {
        var i;
        const r = ((i = this.firstCitizenAggregation) == null ? void 0 : i.averagePerQuestion[t.id]) ?? 0;
        return {
          title: t.title,
          id: t.id,
          valueImageUrl: t.valueImageUrl,
          value: r.toFixed(1)
        };
      });
    },
    firstCitizenLabel() {
      var e;
      return (e = this.firstCitizenAggregation) != null && e.audience ? this.$t("firstCitizen.adminReviews").toString() : this.$t("firstCitizen.userReviews").toString();
    }
  }
});
var O0 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "floating-container", class: { "no-responses": !e.average } }, [e.average ? t("div", [t("div", { staticClass: "content header" }, [t("span", [e._v(" " + e._s(e.firstCitizenLabel) + " (" + e._s(e.userReviewsAmount) + ") ")]), t("span", { staticClass: "rating" }, [t("img", { attrs: { height: 16, src: e.imagePath, alt: "rating" } }), t("span", { staticClass: "amount" }, [e._v(" " + e._s(e.amount))])])]), t("hr", { staticClass: "line-break" }), e._l(e.questions, function(i) {
    return t("div", { key: i.id, staticClass: "content" }, [t("div", { staticClass: "content-label" }, [e._v(e._s(i.title))]), t("div", { staticClass: "rating" }, [t("img", { attrs: { height: 14, src: i.valueImageUrl, alt: "rating" } }), t("span", { staticClass: "amount" }, [e._v(e._s(i.value))])])]);
  })], 2) : t("div", [e._v(" " + e._s(e.$t("firstCitizen.noResponses")) + " ")])]);
}, B0 = [], M0 = /* @__PURE__ */ x(
  T0,
  O0,
  B0,
  !1,
  null,
  "423b33ee"
);
const R0 = M0.exports, E0 = f({
  props: {
    firstCitizenAggregation: {
      type: Object,
      required: !0
    },
    floatingPlacement: {
      type: String,
      default: "left"
    },
    ticket: {
      type: Object,
      required: !1
    },
    productId: {
      type: String,
      required: !1
    },
    currentUser: {
      type: Object,
      required: !1
    },
    enableClick: {
      type: Boolean,
      default: !1
    },
    hasWriteAction: {
      type: Boolean,
      default: !1
    }
  },
  components: {
    FirstCitizenHover: R0
  },
  data() {
    return {
      openFeedbackResultModal: !1
    };
  },
  computed: {
    hasCurrentUserFeedback() {
      var e;
      return this.currentUser ? !!((e = Object.values(this.feedbackEntries)[0]) != null && e[this.currentUser.id]) : !1;
    },
    feedbackEntries() {
      return this.firstCitizenAggregation.userFields ?? {};
    },
    amount() {
      const { average: e = void 0 } = this.firstCitizenAggregation || {};
      return e && !isNaN(e) ? e.toFixed(1) : "-";
    },
    resources() {
      const e = this.$gateway.feedback.parseFeedbackDialogue(
        this.firstCitizenAggregation.meta.feedback,
        this.firstCitizenAggregation.resources,
        this.firstCitizenAggregation.canonicalId,
        this.firstCitizenAggregation.group
      );
      return this.$res(e);
    },
    imagePath() {
      return "/img/star.svg";
    }
  },
  methods: {
    async manageRatingPopup() {
      var e;
      this.enableClick && (!this.hasCurrentUserFeedback && this.hasWriteAction ? (this.$modal(
        (e = this.firstCitizenAggregation.meta) == null ? void 0 : e["feedback-type"],
        this.resources
      ), this.$router.replace({ query: { reload: "false" } })) : this.openFeedbackResultModal = !0);
    }
  }
});
var L0 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [t("app-floating-hover", { class: { pointer: e.enableClick }, style: { position: "static" }, attrs: { enabled: !!e.firstCitizenAggregation, placement: e.floatingPlacement }, nativeOn: { click: function(i) {
    return e.manageRatingPopup.apply(null, arguments);
  } }, scopedSlots: e._u([{ key: "content", fn: function() {
    return [t("social-rating-button", { attrs: { amount: e.amount, "image-path": e.imagePath } })];
  }, proxy: !0 }, { key: "floating", fn: function() {
    return [e.resources ? t("first-citizen-hover", { attrs: { resources: e.resources, "first-citizen-aggregation": e.firstCitizenAggregation, "image-path": e.imagePath } }) : e._e()];
  }, proxy: !0 }]) }), e.openFeedbackResultModal && e.productId && e.currentUser ? t("feedback-result-modal", { attrs: { "product-id": e.productId, "ticket-id": e.firstCitizenAggregation.canonicalId, "current-user": e.currentUser }, on: { close: function(i) {
    e.openFeedbackResultModal = !1;
  } } }) : e._e()], 1);
}, F0 = [], j0 = /* @__PURE__ */ x(
  E0,
  L0,
  F0,
  !1,
  null,
  "a028fad4"
);
const Pc = j0.exports;
f({
  name: "TicketCardVerticalDefault",
  components: {
    FirstCitizenPill: Pc
  },
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    creator: {
      type: Object,
      required: !0
    },
    reactionBoard: {
      type: Object,
      required: !1
    },
    showEmojiViewer: {
      type: Boolean,
      default: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    publicFirstCitizen: {
      type: Object,
      required: !1
    },
    adminFirstCitizen: {
      type: Object,
      required: !1
    },
    userActions: {
      type: Array,
      default: () => []
    },
    creatorVisibility: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const { firstCitizen: t, hasFirstCitizenReadPermission: i } = ec(
      N(e.publicFirstCitizen),
      N(e.adminFirstCitizen),
      e.userActions
    );
    return { firstCitizen: t, hasFirstCitizenReadPermission: i };
  },
  computed: {
    statusLabel() {
      const e = J(this.ticket.status, this.workflow);
      return this.$res(e ?? {}).label;
    },
    statusColour() {
      return Bi(this.ticket.status, this.workflow) ?? "";
    },
    coverImage() {
      return this.ticket.meta.cover || this.fileImage;
    },
    fileImage() {
      const e = this.ticket.files.find(
        (t) => t.category === "ticket-cover"
      );
      return (e == null ? void 0 : e.url) || "";
    },
    creatorUserNameAndUnit() {
      if (!this.creator || !this.creatorVisibility)
        return "";
      const { displayName: e, userDepartment: t } = B(this.creator);
      return t() ? `${this.$t("common.by")} ${e()}, ${t()}` : `${this.$t("common.by")} ${e()}`;
    }
  }
});
const U0 = f({
  props: {
    delegates: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    delegatesDisplay() {
      return this.delegates.map(({ type: e, data: t }) => {
        if (["workgroup"].includes(e))
          return this.getTeamDelegate(t);
        if (e === "topic")
          return this.getTopicDelegate(t);
      }).filter((e) => !!e);
    }
  },
  methods: {
    getTopicDelegate(e) {
      return {
        name: this.$res(e.resources).title,
        color: e.meta.color,
        type: "topic-type"
      };
    },
    getTeamDelegate(e) {
      return {
        name: Be(e, this.$res).teamName(),
        color: "",
        type: "team-type"
      };
    }
  }
});
var q0 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "delegate-list" }, e._l(e.delegatesDisplay, function(i) {
    return t("div", { key: i.id, class: `card-delegate ${i.type}`, style: { "background-color": i.color } }, [e._v(" " + e._s(i.name) + " ")]);
  }), 0);
}, H0 = [], z0 = /* @__PURE__ */ x(
  U0,
  q0,
  H0,
  !1,
  null,
  "281b1133"
);
const Tc = z0.exports;
f({
  components: {
    DelegateTagList: Tc
  },
  name: "TicketCardHorizontalDefault",
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    creator: {
      type: Object,
      required: !0
    },
    assignee: {
      type: Object,
      required: !1
    },
    delegates: {
      type: Array,
      default: () => []
    },
    reactionBoard: {
      type: Object,
      required: !1
    },
    showEmojiViewer: {
      type: Boolean,
      default: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    creatorVisibility: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    creatorUserNameAndUnit() {
      if (!this.creator || !this.creatorVisibility)
        return "";
      const { displayName: e, userDepartment: t } = B(this.creator);
      return t() ? `${this.$t("common.by")} ${e()}, ${t()}` : `${this.$t("common.by")} ${e()}`;
    }
  }
});
f({
  name: "AppTicketCard",
  props: {
    ticketResponse: {
      type: Object,
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    cardStyle() {
      const { ticketCard: e } = Kt(
        this.ticketResponse.workflow
      );
      return e.style ?? "HorizontalDefault";
    },
    componentType() {
      switch (this.cardStyle) {
        case "HorizontalDefault":
          return "TicketCardHorizontalDefault";
        case "VerticalDefault":
          return "TicketCardVerticalDefault";
        case "Campaign":
          return "TicketCardCampaign";
        default:
          throw new Error(`Unknown ticket card style: '${this.cardStyle}'`);
      }
    },
    publicFirstCitizen() {
      var e;
      return (e = this.ticketResponse.firstCitizen) == null ? void 0 : e.children[0];
    },
    adminFirstCitizen() {
      var e;
      return (e = this.ticketResponse.adminFirstCitizen) == null ? void 0 : e.children[0];
    },
    productCustomization() {
      var e, t;
      const { productsData: i } = Ge(this.organization, [
        "main",
        "subproduct"
      ]);
      return (t = (e = i.value) == null ? void 0 : e.find(
        ({ productId: r }) => r === this.ticketResponse.ticket.type
      )) == null ? void 0 : t.customization;
    },
    accessProvider() {
      return {
        userId: this.currentUserId,
        // userRoles: this.userRoles,
        userActions: this.userActions,
        creatorId: this.ticketResponse.ticket.creator,
        assigneeId: this.ticketResponse.ticket.assignee
      };
    },
    creatorPolicyVisibility() {
      var e, t, i;
      const r = ((i = (t = (e = this.productCustomization) == null ? void 0 : e.accessPolicy) == null ? void 0 : t.creator) == null ? void 0 : i.view) ?? [], { accessGranted: s } = Br(r, this.accessProvider);
      return s;
    }
  }
});
f({
  props: {
    text: {
      type: String,
      required: !0
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
});
f({
  components: {
    FirstCitizenPill: Pc,
    DelegateTagList: Tc,
    TicketStatusPill: r0
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    ticketResponse: {
      type: Object,
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    }
  },
  setup(e) {
    var t, i;
    const r = (t = e.ticketResponse.firstCitizen) == null ? void 0 : t.children[0], s = (i = e.ticketResponse.adminFirstCitizen) == null ? void 0 : i.children[0], { firstCitizen: n, hasFirstCitizenReadPermission: a } = ec(
      N(r),
      N(s),
      e.userActions
    );
    return { firstCitizen: n, hasFirstCitizenReadPermission: a };
  },
  computed: {
    ticket() {
      return this.ticketResponse.ticket;
    },
    workflow() {
      return this.ticketResponse.workflow;
    },
    creator() {
      return this.ticketResponse.creator;
    },
    imageUrl() {
      const e = this.ticket.meta.cover;
      if (e)
        return e;
      const t = this.ticket.files.find((i) => i.category === "ticket-cover");
      return t == null ? void 0 : t.url;
    },
    creatorUserNameAndUnit() {
      if (!this.creator || !this.creatorPolicyVisibility)
        return "";
      const { displayName: e, userDepartment: t } = B(this.creator);
      return t() ? `${this.$t("common.by")} ${e()}, ${t()}` : `${this.$t("common.by")} ${e()}`;
    },
    productCustomization() {
      var e, t;
      const { productsData: i } = Ge(this.organization, [
        "main",
        "subproduct"
      ]);
      return (t = (e = i.value) == null ? void 0 : e.find(
        ({ productId: r }) => r === this.ticketResponse.ticket.type
      )) == null ? void 0 : t.customization;
    },
    accessProvider() {
      return {
        userId: this.currentUserId,
        // userRoles: this.userRoles,
        userActions: this.userActions,
        creatorId: this.ticketResponse.ticket.creator,
        assigneeId: this.ticketResponse.ticket.assignee
      };
    },
    creatorPolicyVisibility() {
      var e, t, i;
      const r = ((i = (t = (e = this.productCustomization) == null ? void 0 : e.accessPolicy) == null ? void 0 : t.creator) == null ? void 0 : i.view) ?? [], { accessGranted: s } = Br(r, this.accessProvider);
      return s;
    }
  }
});
const N0 = f({
  props: {
    ticketId: {
      type: String,
      required: !0
    },
    category: {
      type: String,
      default: ""
    },
    file: {
      type: File,
      required: !0
    },
    randomFileId: {
      type: String,
      required: !0
    }
  },
  async mounted() {
    await this.uploadFile();
  },
  data() {
    return {
      status: "IDLE",
      progress: 0
    };
  },
  methods: {
    async uploadFile() {
      if (!this.file)
        return;
      const { upload: e, status: t, progress: i, result: r } = Lg(
        this.$api.fileAttachment,
        this.ticketId
      );
      rt(t, (s) => {
        s === "SUCCESS" ? this.$emit("upload-success", {
          randomFileId: this.randomFileId,
          userFile: Xt(r.value)
        }) : s === "ERROR" && this.$toast(this.$t("error.general").toString());
      }), rt(i, (s) => {
        this.progress = s;
      }), e(this.file, this.category);
    }
  }
});
var V0 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-file-upload-item-progress" }, [t("fa-icon-compat", { staticClass: "file-preview-icon", attrs: { icon: "fa-light fa-file-arrow-up" } }), t("div", { staticClass: "file-details" }, [t("span", [e._v(e._s(e.file.name))]), t("progress", { attrs: { min: "0", max: "1" }, domProps: { value: e.progress } })])], 1);
}, G0 = [], W0 = /* @__PURE__ */ x(
  N0,
  V0,
  G0,
  !1,
  null,
  "c10fd75e"
);
const Oc = W0.exports;
f({
  components: {
    AppFileUploadPermissionsModal: Dv,
    AppFileUploadItem: Mr,
    AppFileUploadItemProgress: Oc,
    AppFileUploadPicker: pc
  },
  props: {
    ticketId: {
      type: String,
      required: !0
    },
    files: {
      type: Array,
      default: () => []
    },
    acceptedExtensions: {
      type: Array,
      default: () => []
    },
    maxFileCount: {
      type: Number,
      required: !1
    },
    maxFileSize: {
      type: Number,
      required: !1
    },
    category: {
      type: String,
      default: ""
    },
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      currentFiles: [],
      uploading: [],
      uploadPermissionVisible: !1,
      currentFile: void 0
    };
  },
  watch: {
    files() {
      this.currentFiles = this.files.map(Xt);
    }
  },
  created() {
    this.currentFiles = this.files.map(Xt), this.maxFileSize && Kc("maxFileUploadSize", this.maxFileSize);
  },
  computed: {
    allowMoreFiles() {
      return !this.maxFileCount || this.currentFiles.length + this.uploading.length < this.maxFileCount;
    },
    menuOptions() {
      return [
        {
          label: this.$t("common.roles").toString(),
          tabKey: "roles"
        },
        {
          label: this.$t("menu.remove").toString(),
          tabKey: "remove"
        }
      ];
    },
    acceptFilter() {
      return this.acceptedExtensions.length === 0 ? void 0 : this.acceptedExtensions.join(",");
    }
  },
  methods: {
    onFilePicked(e) {
      this.uploading.push([self.crypto.randomUUID(), e]);
    },
    onUploadSuccess(e) {
      this.uploading = this.uploading.filter(
        (t) => t[0] !== e.randomFileId
      ), this.currentFiles.push(e.userFile), this.onAttachmentChange();
    },
    async onRemoveFile(e) {
      await this.$api.fileAttachment.remove("ticket", this.ticketId, e.id), this.currentFiles = this.currentFiles.filter((t) => t.id !== e.id), this.onAttachmentChange();
    },
    onAttachmentChange() {
      this.$emit("attachment-updated");
    },
    onUpdatePermissions(e) {
      this.currentFile = e, this.uploadPermissionVisible = !0;
    },
    onClosePermissions() {
      this.uploadPermissionVisible = !1;
    },
    onPermissionsUpdated() {
      this.onClosePermissions(), this.$emit("permissions-updated");
    }
  }
});
const Q0 = f({
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    appId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      selectedStatus: "",
      optionsStatus: []
    };
  },
  async created() {
    await this.loadStatus();
  },
  methods: {
    async loadStatus() {
      const e = await this.$gateway.search.status(
        this.contextId,
        this.productId,
        this.appId
      );
      this.optionsStatus = e[0].map((t) => ({
        text: this.$res(J(t, e[1]), { label: t }).label,
        value: t
      }));
    },
    async executeBulkAction() {
      try {
        this.loading = !0;
        const e = await this.$api.ticket.bulkUpdateStatus(this.productId, {
          canonicalIds: this.selection,
          ticketRequest: { status: this.selectedStatus }
        });
        return this.$datasource.ticket.dirtyBatch(this.selection), e.id;
      } catch (e) {
        console.error("Could not execute bulk action", e);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const e = await this.executeBulkAction();
      this.$emit("confirm", e);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var X0 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { attrs: { loading: e.loading } }, [t("div", { staticClass: "modal-content" }, [t("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.$t("bulkActions.actions.setStatus")) + " ")]), t("app-singleselect", { attrs: { options: e.optionsStatus, placeholder: e.$t("search.filter.status.placeholder") }, model: { value: e.selectedStatus, callback: function(i) {
    e.selectedStatus = i;
  }, expression: "selectedStatus" } }), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [t("app-button", { attrs: { label: e.$t("common.form.confirm"), enabled: !!e.selectedStatus }, on: { click: e.onConfirm } }), t("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } })], 1)], 1)]);
}, K0 = [], Y0 = /* @__PURE__ */ x(
  Q0,
  X0,
  K0,
  !1,
  null,
  "34bda6a3"
);
const Z0 = Y0.exports, J0 = f({
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    appId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      selectedStatus: "",
      optionsStatus: []
    };
  },
  methods: {
    async executeBulkAction() {
      try {
        this.loading = !0;
        const e = await this.$api.ticket.bulkDeleteTickets(
          this.productId,
          this.selection
        );
        return this.$datasource.ticket.dirtyBatch(this.selection), e.id;
      } catch (e) {
        console.error("Could not execute bulk action", e);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const e = await this.executeBulkAction();
      this.$emit("confirm", e);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var _0 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal-confirmation", { attrs: { "confirmation-label": e.$t("bulkActions.deleteTickets.conformationLabel"), description: e.$t("bulkActions.deleteTickets.description"), "extra-confirmation": !0, "primary-label": e.$t("common.form.confirm"), "secondary-label": e.$t("common.form.cancel"), title: e.$t("bulkActions.actions.deleteTickets") }, on: { "click-outside": e.onCancel, "click-primary": e.onConfirm, "click-secondary": e.onCancel } });
}, $0 = [], ew = /* @__PURE__ */ x(
  J0,
  _0,
  $0,
  !1,
  null,
  "dfe00d82"
);
const tw = ew.exports, iw = f({
  components: {
    ProductDropdown: Ac
  },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    },
    action: {
      type: String,
      default: "copy"
    }
  },
  data() {
    return {
      loading: !1,
      targetProduct: "",
      triggerWebhooks: !1,
      useAuthorAsCreator: !1,
      workflows: []
    };
  },
  async created() {
    this.workflows = await this.$gateway.admin.fetchWorkflowsByBatch(
      this.productIds,
      this.contextId
    ), this.targetProduct = this.productIds[0];
  },
  computed: {
    productIds() {
      const { productsData: e } = Ge(this.organization);
      return e.value.filter(
        ({ customization: t }) => {
          var i;
          return !!((i = t.ticketCopyMapping) != null && i[this.productId]);
        }
      ).map(({ productId: t }) => t).flat();
    },
    copyMoveRequest() {
      return {
        canonicalIds: this.selection,
        sourceProduct: this.productId,
        triggerWebhooks: this.triggerWebhooks,
        useAuthorAsCreator: this.useAuthorAsCreator
      };
    }
  },
  methods: {
    async executeBulkAction() {
      try {
        return this.loading = !0, this.action === "copy" ? this.copyTickets() : this.moveTickets();
      } catch (e) {
        console.error("Could not execute bulk action", e);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async copyTickets() {
      return (await this.$api.ticket.bulkCopyTicket(
        this.copyMoveRequest,
        this.targetProduct
      )).id;
    },
    async moveTickets() {
      return (await this.$api.ticket.bulkMoveTicket(
        this.copyMoveRequest,
        this.targetProduct
      )).id;
    },
    async onConfirm() {
      const e = await this.executeBulkAction();
      this.$emit("confirm", e);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var rw = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { attrs: { loading: e.loading } }, [t("div", { staticClass: "modal-content" }, [t("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.$t(`bulkActions.${e.action}Tickets.title`)) + " ")]), t("product-dropdown", { staticClass: "product-dropdown", attrs: { context: e.contextId, label: e.$t(`bulkActions.${e.action}Tickets.productSelector`), placeholder: e.$t("form.placeholder.productSelect"), products: e.productIds, workflows: e.workflows }, model: { value: e.targetProduct, callback: function(i) {
    e.targetProduct = i;
  }, expression: "targetProduct" } }), t("app-checkbox", { attrs: { label: e.$t("bulkActions.actions.triggerWebhooks") }, model: { value: e.triggerWebhooks, callback: function(i) {
    e.triggerWebhooks = i;
  }, expression: "triggerWebhooks" } }), t("app-checkbox", { attrs: { label: e.$t("bulkActions.actions.useAuthorAsCreator") }, model: { value: e.useAuthorAsCreator, callback: function(i) {
    e.useAuthorAsCreator = i;
  }, expression: "useAuthorAsCreator" } }), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [t("app-button", { attrs: { enabled: !!e.targetProduct, label: e.$t(`bulkActions.${e.action}Tickets.title`) }, on: { click: e.onConfirm } }), t("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } })], 1)], 1)]);
}, sw = [], nw = /* @__PURE__ */ x(
  iw,
  rw,
  sw,
  !1,
  null,
  "855a3964"
);
const aw = nw.exports, ow = f({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      selectedTicket: ""
    };
  },
  methods: {
    async executeBulkAction() {
      try {
        return this.loading = !0, (await this.$api.ticket.bulkUpdateTicket(this.productId, {
          canonicalIds: this.selection,
          ticketRequest: {
            parent: this.selectedTicket
          }
        })).id;
      } catch (e) {
        console.error("Could not execute bulk action", e);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const e = await this.executeBulkAction();
      this.$emit("confirm", e);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var lw = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { attrs: { loading: e.loading } }, [t("div", { staticClass: "modal-content" }, [t("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.$t("bulkActions.actions.setParent")) + " ")]), t("ticket-dropdown", { attrs: { context: e.contextId, "product-id": e.productId, products: [e.productId], placeholder: e.$t("bulkActions.setParentModal.placeholder") }, model: { value: e.selectedTicket, callback: function(i) {
    e.selectedTicket = i;
  }, expression: "selectedTicket" } }), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [t("app-button", { attrs: { label: e.$t("common.form.confirm"), enabled: !!e.selectedTicket }, on: { click: e.onConfirm } }), t("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } })], 1)], 1)]);
}, cw = [], uw = /* @__PURE__ */ x(
  ow,
  lw,
  cw,
  !1,
  null,
  "41ba2772"
);
const dw = uw.exports, hw = f({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      selectedUser: ""
    };
  },
  methods: {
    async executeBulkAction() {
      try {
        this.loading = !0;
        const e = await this.$api.ticket.bulkUpdateTicket(this.productId, {
          canonicalIds: this.selection,
          ticketRequest: {
            assignee: this.selectedUser
          }
        });
        return this.$datasource.ticket.dirtyBatch(this.selection), e.id;
      } catch (e) {
        console.error("Could not execute bulk action", e);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const e = await this.executeBulkAction();
      this.$emit("confirm", e);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var pw = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { attrs: { loading: e.loading } }, [t("div", { staticClass: "modal-content" }, [t("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.$t("bulkActions.actions.setAssignee")) + " ")]), t("user-dropdown", { attrs: { context: e.contextId, "product-id": e.productId, products: [e.productId], placeholder: e.$t("bulkActions.setAssigneeModal.placeholder") }, model: { value: e.selectedUser, callback: function(i) {
    e.selectedUser = i;
  }, expression: "selectedUser" } }), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [t("app-button", { attrs: { label: e.$t("common.form.confirm"), enabled: !!e.selectedUser }, on: { click: e.onConfirm } }), t("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } })], 1)], 1)]);
}, fw = [], mw = /* @__PURE__ */ x(
  hw,
  pw,
  fw,
  !1,
  null,
  "92cf5383"
);
const gw = mw.exports, yw = f({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      selectedTicket: ""
    };
  },
  methods: {
    async executeBulkAction() {
      try {
        return this.loading = !0, (await this.$api.ticket.bulkUpdateTicket(this.productId, {
          canonicalIds: this.selection,
          ticketRequest: {
            parent: this.selectedTicket
          }
        })).id;
      } catch (e) {
        console.error("Could not execute bulk action", e);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const e = await this.executeBulkAction();
      this.$emit("confirm", e);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var bw = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { attrs: { loading: e.loading } }, [t("div", { staticClass: "modal-content" }, [t("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.$t("bulkActions.actions.setCampaign")) + " ")]), t("ticket-dropdown", { attrs: { context: e.contextId, "product-id": e.productId, products: ["campaign"], placeholder: e.$t("bulkActions.setCampaignModal.placeholder") }, model: { value: e.selectedTicket, callback: function(i) {
    e.selectedTicket = i;
  }, expression: "selectedTicket" } }), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [t("app-button", { attrs: { label: e.$t("common.form.confirm"), enabled: !!e.selectedTicket }, on: { click: e.onConfirm } }), t("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } })], 1)], 1)]);
}, vw = [], Aw = /* @__PURE__ */ x(
  yw,
  bw,
  vw,
  !1,
  null,
  "f22e038d"
);
const kw = Aw.exports, ww = f({
  components: { AppLabelValue: wc },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      contextFunding: !1,
      companyWallet: null,
      selectedOffer: null
    };
  },
  async created() {
    [this.companyWallet] = await this.$api.juoco.fetchCompanyWallet(
      this.contextId
    );
  },
  computed: {
    showCalculation() {
      return this.contextFunding && !!this.selectedOffer;
    },
    totalPrice() {
      return this.selectedOffer ? this.selectedOffer.price * this.selection.length : 0;
    },
    companyWalletBalanceAfter() {
      var e;
      return (((e = this.companyWallet) == null ? void 0 : e.balance) ?? 0) - this.totalPrice;
    },
    companyWalletBalance() {
      var e;
      return ((e = this.companyWallet) == null ? void 0 : e.balance) ?? 0;
    },
    selectedOfferPrice() {
      var e;
      return ((e = this.selectedOffer) == null ? void 0 : e.price) ?? 0;
    }
  },
  methods: {
    async executeBulkAction() {
      try {
        return this.loading = !0, (await this.$api.juoco.bulkPurchaseOffer({
          offerId: this.selectedOffer.id,
          contextFunding: this.contextFunding,
          batchRequest: {
            targets: this.selection,
            context: this.contextId
          }
        })).id;
      } catch (e) {
        console.error("Could not execute bulk action", e);
        return;
      } finally {
        this.loading = !1;
      }
    },
    priceDisplay(e = 0) {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        signDisplay: "auto",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(e);
    },
    async onConfirm() {
      const e = await this.executeBulkAction();
      this.$emit("confirm", e);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var xw = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { attrs: { loading: e.loading } }, [t("div", { staticClass: "modal-content" }, [t("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.$t("bulkActions.purchaseOfferModal.title")) + " ")]), t("div", { staticClass: "modal-description" }, [e._v(" " + e._s(e.$t("bulkActions.purchaseOfferModal.description")) + " ")]), t("offer-dropdown", { attrs: { context: e.contextId, group: "TICKET", label: e.$t("bulkActions.purchaseOfferModal.offerLabel"), placeholder: e.$t("bulkActions.purchaseOfferModal.offerPlaceholder"), "product-id": e.productId }, model: { value: e.selectedOffer, callback: function(i) {
    e.selectedOffer = i;
  }, expression: "selectedOffer" } }), t("app-checkbox", { attrs: { label: e.$t("bulkActions.purchaseOfferModal.contextFunding") }, model: { value: e.contextFunding, callback: function(i) {
    e.contextFunding = i;
  }, expression: "contextFunding" } }), e.totalPrice ? t("div", { staticClass: "price-container" }, [t("div", { staticClass: "price-group" }, [t("span", { staticClass: "label" }, [e._v(" " + e._s(e.$t("bulkActions.purchaseOfferModal.offerPrice")) + " ")]), t("span", { staticClass: "price" }, [e._v(e._s(e.priceDisplay(e.selectedOfferPrice)))])]), t("div", { staticClass: "price-group" }, [t("span", { staticClass: "label" }, [e._v(" " + e._s(e.$t("bulkActions.purchaseOfferModal.totalPrice")) + " ")]), t("span", { staticClass: "price" }, [e._v(e._s(e.priceDisplay(e.totalPrice)))])]), e.showCalculation ? [t("div", { staticClass: "price-group" }, [t("span", { staticClass: "label" }, [e._v(" " + e._s(e.$t("bulkActions.purchaseOfferModal.companyBalance")) + " ")]), t("span", { staticClass: "price" }, [e._v(e._s(e.priceDisplay(e.companyWalletBalance)))])]), t("div", { staticClass: "price-group" }, [t("span", { staticClass: "label" }, [e._v(" " + e._s(e.$t("bulkActions.purchaseOfferModal.companyBalanceAfter")) + " ")]), t("span", { staticClass: "price" }, [e._v(e._s(e.priceDisplay(e.companyWalletBalanceAfter)))])])] : e._e()], 2) : e._e(), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [t("app-button", { attrs: { enabled: !!e.selectedOffer, label: e.$t("bulkActions.purchaseOfferModal.purchaseButton") }, on: { click: e.onConfirm } }), t("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } })], 1)], 1)]);
}, Cw = [], Sw = /* @__PURE__ */ x(
  ww,
  xw,
  Cw,
  !1,
  null,
  "cf023000"
);
const Iw = Sw.exports, Dw = f({
  props: {
    contextId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      fileName: `export-${this.contextId}`,
      appendDate: !0
    };
  },
  computed: {
    fileNamePreview() {
      return this.$gateway.search.createExportFilename({
        file: {
          name: this.fileName,
          appendDate: this.appendDate
        }
      });
    }
  },
  methods: {
    executeBulkAction() {
      const e = {
        file: {
          name: this.fileName,
          appendDate: this.appendDate
        }
      };
      this.$emit("export-selected", e);
    },
    onConfirm() {
      this.executeBulkAction(), this.onCancel();
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var Pw = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", [t("div", { staticClass: "modal-content" }, [t("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.$t("bulkActions.actions.exportData")) + " ")]), t("app-text-input", { attrs: { label: e.$t("bulkActions.exportDataModal.fileNameLabel"), required: !0 }, model: { value: e.fileName, callback: function(i) {
    e.fileName = i;
  }, expression: "fileName" } }), t("app-checkbox", { attrs: { label: e.$t("bulkActions.exportDataModal.appendDateLabel") }, model: { value: e.appendDate, callback: function(i) {
    e.appendDate = i;
  }, expression: "appendDate" } }), t("app-text-input", { attrs: { value: e.fileNamePreview, label: e.$t("bulkActions.exportDataModal.previewLabel"), enabled: !1 } }), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [t("app-button", { attrs: { label: e.$t("common.form.confirm"), enabled: !!e.fileName }, on: { click: e.onConfirm } }), t("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } })], 1)], 1)]);
}, Tw = [], Ow = /* @__PURE__ */ x(
  Dw,
  Pw,
  Tw,
  !1,
  null,
  "7974a35e"
);
const Bc = Ow.exports, Bw = f({
  props: {
    bulkId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      bulkResponse: void 0
    };
  },
  async created() {
    await this.reload();
  },
  computed: {
    refreshVisible() {
      var e;
      return ((e = this.bulkResponse) == null ? void 0 : e.status) !== "FINISHED";
    },
    failedListVisible() {
      var e, t;
      return (((t = (e = this.bulkResponse) == null ? void 0 : e.report.failedActions) == null ? void 0 : t.length) ?? 0) > 0;
    },
    totalActions() {
      var e;
      return ((e = this.bulkResponse) == null ? void 0 : e.report.totalJobs) ?? 0;
    },
    completedActions() {
      var e, t;
      const i = ((e = this.bulkResponse) == null ? void 0 : e.report.failedActions.length) ?? 0, r = ((t = this.bulkResponse) == null ? void 0 : t.report.completedIds.length) ?? 0;
      return i + r;
    },
    failedIds() {
      var e;
      return (((e = this.bulkResponse) == null ? void 0 : e.report.failedActions) ?? []).map(
        (t) => t.canonicalId
      );
    }
  },
  methods: {
    async reload() {
      try {
        this.loading = !0, this.bulkResponse = await this.$api.ticket.fetchBulkAction(this.bulkId);
      } catch (e) {
        console.error("Could not check bulk action status", e);
      } finally {
        this.loading = !1;
      }
    },
    async onRefresh() {
      await this.reload();
    },
    onClose() {
      this.$emit("close");
    }
  }
});
var Mw = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { attrs: { loading: e.loading } }, [t("div", { staticClass: "modal-content" }, [t("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.$t("bulkActions.resultsModal.title")) + " ")]), e.bulkResponse ? t("div", [t("div", [e._v(" " + e._s(e.$t("bulkActions.resultsModal.processId")) + ": " + e._s(e.bulkResponse.id) + " ")]), t("div", [e._v(" " + e._s(e.$t("bulkActions.resultsModal.completion", { completed: e.completedActions, total: e.totalActions })) + " ")]), e.failedListVisible ? [e._v(" " + e._s(e.$t("bulkActions.resultsModal.failed")) + ": "), t("ul", { staticClass: "failed-list" }, e._l(e.failedIds, function(i) {
    return t("li", { key: i }, [e._v(" " + e._s(i) + " ")]);
  }), 0)] : e._e()], 2) : e._e()]), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [e.refreshVisible ? t("app-button", { attrs: { label: e.$t("common.form.refresh") }, on: { click: e.onRefresh } }) : e._e(), t("app-secondary-button", { attrs: { label: e.$t("common.form.close") }, on: { click: e.onClose } })], 1)], 1);
}, Rw = [], Ew = /* @__PURE__ */ x(
  Bw,
  Mw,
  Rw,
  !1,
  null,
  "bd0f2712"
);
const Mc = Ew.exports;
f({
  components: {
    BulkModalSetStatus: Z0,
    BulkModalDeleteTickets: tw,
    BulkModalCopyMoveTickets: aw,
    BulkModalSetParent: dw,
    BulkModalSetAssignee: gw,
    BulkModalSetCampaign: kw,
    BulkModalPurchaseOffer: Iw,
    BulkModalExportData: Bc,
    BulkModalResults: Mc
  },
  props: {
    value: {
      type: String,
      required: !1
    },
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    appId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  watch: {
    value(e) {
      this.bulkAction = e;
    }
  },
  data() {
    return {
      bulkAction: void 0,
      bulkId: void 0
    };
  },
  created() {
    this.bulkAction = this.value;
  },
  methods: {
    onConfirm(e) {
      this.bulkId = e, this.bulkAction = void 0;
    },
    onCloseResults() {
      this.onCancel(), this.$emit("reload");
    },
    onCancel() {
      this.bulkId = void 0, this.bulkAction = void 0, this.$emit("input", void 0);
    },
    componentType(e) {
      switch (e) {
        case "deleteTickets":
          return "bulk-modal-delete-tickets";
        case "setParent":
          return "bulk-modal-set-parent";
        case "copyTickets":
        case "moveTickets":
          return "bulk-modal-copy-move-tickets";
        case "setAssignee":
          return "bulk-modal-set-assignee";
        case "setCampaign":
          return "bulk-modal-set-campaign";
        case "purchaseOffer":
          return "bulk-modal-purchase-offer";
        case "exportData":
          return "bulk-modal-export-data";
        case "setStatus":
          return "bulk-modal-set-status";
        default:
          return "";
      }
    },
    getActionType(e) {
      switch (e) {
        case "copyTickets":
          return "copy";
        case "moveTickets":
          return "move";
        default:
          return;
      }
    }
  }
});
f({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      selected: ""
    };
  },
  computed: {
    filteredOptions() {
      return this.options.filter(({ availabilityCheck: e }) => e !== !1).filter(
        ({ requiredAction: e }) => !e || this.checkPermission(e)
      ).map(({ option: e }) => e);
    },
    options() {
      return [
        {
          requiredAction: "ADMIN_BULK_TICKET_UPDATE",
          option: {
            value: "setStatus",
            text: this.$t("bulkActions.actions.setStatus").toString()
          }
        },
        {
          requiredAction: "ADMIN_BULK_TICKET_UPDATE",
          option: {
            value: "setAssignee",
            text: this.$t("bulkActions.actions.setAssignee").toString()
          }
        },
        {
          requiredAction: "Hidden for IP-6902 - ADMIN_BULK_TICKET_UPDATE",
          option: {
            value: "setParent",
            text: this.$t("bulkActions.actions.setParent").toString()
          }
        },
        {
          requiredAction: "ADMIN_BULK_TICKET_UPDATE",
          option: {
            value: "setCampaign",
            text: this.$t("bulkActions.actions.setCampaign").toString()
          }
        },
        {
          requiredAction: "ADMIN_TICKET_COPY",
          availabilityCheck: this.hasDuplicationSettings(),
          option: {
            value: "copyTickets",
            text: this.$t("bulkActions.actions.copyTickets").toString()
          }
        },
        {
          requiredAction: "ADMIN_TICKET_MOVE",
          availabilityCheck: this.hasDuplicationSettings(),
          option: {
            value: "moveTickets",
            text: this.$t("bulkActions.actions.moveTickets").toString()
          }
        },
        {
          requiredAction: "ADMIN_BULK_TICKET_DELETE",
          option: {
            value: "deleteTickets",
            text: this.$t("bulkActions.actions.deleteTickets").toString()
          }
        },
        {
          requiredAction: "ADMIN_OFFER_WRITE",
          option: {
            value: "purchaseOffer",
            text: this.$t("bulkActions.actions.purchaseOffer").toString()
          }
        },
        {
          requiredAction: "USER_TICKET_LIST",
          option: {
            value: "exportData",
            text: this.$t("bulkActions.actions.exportData").toString()
          }
        }
      ];
    }
  },
  methods: {
    checkPermission(e) {
      const t = `${this.productId.toUpperCase()}_${e}`;
      return this.userActions.checkPermission([t, e]);
    },
    hasDuplicationSettings() {
      const { productsData: e } = Ge(this.organization);
      return e.value.some(
        ({ customization: t }) => {
          var i;
          return !!((i = t.ticketCopyMapping) != null && i[this.productId]);
        }
      );
    },
    onUpdateSingle(e) {
      e && this.$emit("select-action", e), pt(() => {
        this.selected = "";
      });
    }
  }
});
f({
  name: "TicketDelegationWidget",
  props: {
    delegate: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      empty: !1,
      loading: !0,
      team: void 0,
      topic: void 0
    };
  },
  async created() {
    try {
      ["workgroup", "team"].includes(this.delegate.type) ? this.team = this.delegate.data : this.delegate.type === "topic" && (this.topic = this.delegate.data), !this.team && !this.topic && (this.empty = !0, console.warn(
        "Could not find Delegation item:",
        this.delegate.type,
        this.delegate.data
      ));
    } catch (e) {
      this.empty = !0, console.error(e);
    }
    this.loading = !1;
  }
});
const Lw = "/img/team-placeholder.svg";
f({
  props: {
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      required: !1
    },
    favoritesLabel: {
      type: String,
      required: !1
    },
    configuration: {
      type: Object,
      required: !0
    },
    error: {
      type: Boolean,
      default: !1
    },
    userId: {
      type: String,
      required: !1
    },
    tags: {
      type: Array,
      required: !1
    },
    multiselect: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    initialTeamIds: {
      type: Array,
      default: () => []
    },
    organization: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      reloadKey: 0,
      loading: !1,
      userTeams: [],
      selected: [],
      errorState: !1,
      createTeamModalVisible: !1
    };
  },
  async created() {
    this.tags || await this.loadUserTeams(), this.selected = this.initialTeamIds, this.selected.length || this.$emit("input", []), this.reloadKey += 1;
  },
  computed: {
    teamTypes() {
      return this.configuration.types ?? ["VIRTUAL_TEAM"];
    },
    previewOptions() {
      return this.userTeams.map((e) => ({
        text: Be(e, this.$res).teamName(),
        value: e.id,
        image: Lw,
        groupKey: "favorites"
      }));
    },
    previewGroups() {
      return this.userTeams.length ? [
        {
          key: "favorites",
          label: this.favoritesLabel ?? this.$t("page.teams.myTeams").toString()
        }
      ] : [];
    },
    createTeamEnabled() {
      var e, t;
      return !!((t = (e = this.configuration) == null ? void 0 : e.operations) != null && t.includes("create") && this.userId);
    }
  },
  watch: {
    selected(e) {
      this.$emit("input", e);
    }
  },
  methods: {
    async loadUserTeams() {
      try {
        this.loading = !0;
        const e = this.userId ? await this.$datasource.team.fetchSubscribedTeams(this.userId) : [];
        this.userTeams = e.filter(
          ({ type: t }) => this.teamTypes.includes(t)
        );
      } catch {
        console.error("Error loading subscribed teams"), this.userTeams = [];
      } finally {
        this.loading = !1;
      }
    },
    onBlur() {
      this.validate();
    },
    validate() {
      this.required ? this.errorState = this.multiselect ? !this.selected.length : !this.selected : this.errorState = !1;
    },
    onCloseTeamModal() {
      this.createTeamModalVisible = !1;
    },
    onOpenTeamModal() {
      this.createTeamModalVisible = !0;
    },
    onTeamCreated(e) {
      this.selected = this.multiselect ? [e.id, ...this.selected] : [e.id], this.errorState = !1, this.userTeams = [e, ...this.userTeams], this.reloadKey += 1, this.onCloseTeamModal();
    }
  }
});
const Uo = "#6B778C";
f({
  props: {
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      required: !1
    },
    user: {
      type: Object,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    initialTopicId: {
      type: String,
      required: !1
    },
    product: {
      type: String,
      required: !0
    },
    tags: {
      type: Array,
      required: !1
    }
  },
  data() {
    return {
      loading: !1,
      allTopics: [],
      relatedTopics: [],
      reloadKey: 0,
      selected: "",
      error: !1,
      customTopicIcons: /* @__PURE__ */ new Map()
    };
  },
  async created() {
    await this.loadTopics(), this.selected = this.initialTopicId ?? "", this.selected === "" && this.$emit("input", ""), this.reloadKey += 1;
  },
  destroyed() {
    Object.values(this.customTopicIcons).forEach((e) => {
      URL.revokeObjectURL(e);
    });
  },
  computed: {
    previewOptions() {
      return this.allTopics.map((e) => ({
        text: this.$res(e == null ? void 0 : e.resources).title,
        value: e.id,
        image: this.getTopicIcon(e),
        groupKey: this.getTopicGroup(e)
      }));
    },
    previewGroups() {
      const e = [
        {
          key: "all",
          label: this.$t("page.topicOverview.relationTypes.other").toString()
        }
      ];
      return this.relatedTopics.length > 0 && e.unshift({
        key: "favorites",
        label: this.$t("page.topicOverview.relationTypes.relates").toString()
      }), e;
    },
    topicFilter() {
      var e;
      const t = ((e = this.tags) == null ? void 0 : e.map((i) => ({ tag: i, class: "tag" }))) ?? [];
      return {
        tags: [{ tag: this.product, class: "product" }, ...t]
      };
    }
  },
  watch: {
    selected(e) {
      this.$emit("input", e);
    }
  },
  methods: {
    async loadTopics() {
      var e;
      try {
        this.loading = !0, this.allTopics = await this.$gateway.topic.filterByTags(
          this.topicFilter
        ), this.allTopics.forEach((i) => this.createTopicIcon(i));
        const t = (e = this.user) == null ? void 0 : e.unit;
        if (t) {
          const i = await this.$api.topic.getTopicByTeam(t, "relates");
          this.relatedTopics = i.topicIds.filter(
            (r) => this.allTopics.some((s) => s.id === r)
          );
        }
      } catch {
        console.error("Error loading subscribed teams");
      } finally {
        this.loading = !1;
      }
    },
    createTopicIcon(e) {
      const t = (e == null ? void 0 : e.meta.color) ?? Uo;
      if (this.customTopicIcons.has(t))
        return;
      const i = `
        <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="3.5" fill="${t}" />
        </svg>
      `, r = new Blob([i], { type: "image/svg+xml" }), s = URL.createObjectURL(r);
      this.customTopicIcons.set(t, s);
    },
    getTopicIcon(e) {
      var t;
      const i = ((t = e == null ? void 0 : e.meta) == null ? void 0 : t.color) ?? Uo;
      return this.customTopicIcons.get(i);
    },
    getTopicGroup(e) {
      return this.relatedTopics.includes(e.id) ? "favorites" : "all";
    },
    onBlur() {
      this.validate();
    },
    validate() {
      this.required ? this.error = !this.selected : this.error = !1;
    }
  }
});
const Fw = f({
  props: {
    ownerIds: {
      type: Array,
      required: !0
    },
    initialCoCreatorIds: {
      type: Array,
      required: !0
    },
    team: {
      type: Object,
      required: !0
    },
    allowTeamEdit: {
      type: Boolean,
      default: !0
    }
  },
  setup(e, { emit: t }) {
    const { distributeShares: i, checkShareDivide: r } = ay(), s = N(!1), n = N(0), a = N({}), o = N(e.initialCoCreatorIds), l = N(!1), c = N([]), u = Hs(), { $gateway: d } = u.proxy, h = Q(() => (n.value, c.value.map((A) => ({
      id: A.userInfo.user.id,
      share: a.value[A.userInfo.user.id]
    })))), p = () => {
      a.value = [...e.ownerIds, ...o.value].reduce(
        (A, k) => {
          var S, D;
          const T = ((D = (S = e.team) == null ? void 0 : S.meta) == null ? void 0 : D[`shares_${k}`]) ?? 0;
          return A[k] = a.value[k] || parseFloat(T), A;
        },
        a.value
      );
    }, m = () => {
      n.value++, l.value = r(h.value, 100);
    }, g = async () => {
      const A = c.value.map((k) => ({
        ...k,
        share: a.value[k.userInfo.user.id]
      }));
      t("confirm", A);
    }, y = () => {
      t("cancel");
    }, v = async () => {
      await w(), p(), m();
    }, w = async () => {
      const A = await d.portal.findUsersById([
        ...e.ownerIds,
        ...o.value
      ]);
      c.value = A.reduce(
        (k, S) => {
          const D = S.user.id;
          return k.push({
            userInfo: S,
            share: a.value[D] ?? 0
          }), k;
        },
        []
      );
    }, C = () => {
      const A = i(h.value, 100);
      a.value = A.reduce(
        (k, S) => (k[S.id] = S.share, k),
        {}
      ), m();
    };
    return zs(async () => {
      p(), await w();
    }), {
      loading: s,
      reloadKey: n,
      enableSaveButton: l,
      shares: a,
      coCreatorIds: o,
      userList: c,
      shareItems: h,
      validateForm: m,
      onDistributeShares: C,
      checkShareDivide: r,
      onConfirm: g,
      onCancel: y,
      onInput: v
    };
  }
});
var jw = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { attrs: { loading: e.loading } }, [t("div", { staticClass: "modal-content" }, [t("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.$t("modal.coCreatorShares.title")) + " ")]), t("div", { staticClass: "modal-description" }, [e._v(" " + e._s(e.$t("modal.coCreatorShares.description")) + " ")]), t("user-dropdown", { attrs: { enabled: e.allowTeamEdit, label: e.$t("form.coCreator.label"), placeholder: e.$t("form.coCreator.placeholder"), "selection-mode": "multiple" }, on: { blur: e.onInput, input: e.onInput }, model: { value: e.coCreatorIds, callback: function(i) {
    e.coCreatorIds = i;
  }, expression: "coCreatorIds" } }), t("div", { staticClass: "co-creator-list" }, e._l(e.userList, function({ userInfo: i }) {
    return t("user-item", { key: i.user.id, staticClass: "co-creator-item", attrs: { "user-data": i }, scopedSlots: e._u([{ key: "controls", fn: function() {
      return [t("app-number-input", { staticClass: "share-input", attrs: { "fraction-digits": 4 }, on: { blur: e.validateForm }, model: { value: e.shares[i.user.id], callback: function(r) {
        e.$set(e.shares, i.user.id, r);
      }, expression: "shares[userInfo.user.id]" } })];
    }, proxy: !0 }], null, !0) });
  }), 1), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "end" } }, [t("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } }), t("app-secondary-button", { attrs: { label: e.$t("modal.coCreatorShares.distributeButton") }, on: { click: e.onDistributeShares } }), t("app-button", { attrs: { enabled: e.enableSaveButton, label: e.$t("common.form.save") }, on: { click: e.onConfirm } })], 1)], 1)]);
}, Uw = [], qw = /* @__PURE__ */ x(
  Fw,
  jw,
  Uw,
  !1,
  null,
  "acf95b3f"
);
const Hw = qw.exports;
f({
  components: {
    CoCreatorModal: Hw
  },
  props: {
    userId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    },
    teamId: {
      type: String,
      required: !0
    },
    enabled: {
      type: Boolean,
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      team: {},
      teamMembers: [],
      coCreators: [],
      showModal: !1,
      error: !1,
      loading: !0
    };
  },
  async created() {
    this.loading = !0, this.teamId && ([this.team, this.teamMembers] = await Promise.all([
      this.$api.team.fetchCoCreatorTeamById(this.teamId),
      this.$api.team.fetchTeamMembers(this.teamId)
    ]), await this.fetchCoCreators()), this.loading = !1;
  },
  computed: {
    coCreatorIds() {
      return this.teamMembers.filter(({ roles: e }) => e.includes("member")).map(({ userId: e }) => e);
    },
    allowTeamEdit() {
      return this.userActions.includes("USER_COCREATOR_TEAM_WRITE") && this.coCreators.some(({ userInfo: e }) => e.user.id === this.userId);
    },
    ownerIds() {
      return this.teamMembers.filter(({ roles: e }) => e.includes("owner")).map(({ userId: e }) => e);
    }
  },
  methods: {
    async fetchCoCreators() {
      const e = await this.$gateway.portal.findUsersById(
        this.teamMembers.map(({ userId: t }) => t)
      );
      this.coCreators = e.reduce((t, i) => {
        var r, s;
        return t.push({
          userInfo: i,
          share: ((s = (r = this.team) == null ? void 0 : r.meta) == null ? void 0 : s[`shares_${i.user.id}`]) ?? 0
        }), t;
      }, []).sort(
        (t) => this.ownerIds.includes(t.userInfo.user.id) ? -1 : 1
      );
    },
    async updateTeamMembers(e) {
      const t = e.map((i) => i.userInfo.user.id);
      await this.$gateway.team.updateTeamMembers({
        teamId: this.teamId,
        role: "member",
        userIds: t,
        teamType: this.team.type
      }), this.teamMembers = await this.$api.team.fetchTeamMembers(this.teamId);
    },
    async saveShares(e) {
      const t = Object.entries(this.team.meta ?? {}).filter(
        ([i]) => !i.startsWith("shares_")
      );
      this.team = await this.$datasource.team.updateCoCreator({
        ...this.team,
        meta: {
          ...t,
          ...e.reduce(
            (i, r) => (i[`shares_${r.userInfo.user.id}`] = r.share, i),
            {}
          )
        }
      });
    },
    async saveCoCreators(e) {
      this.toggleModal(), this.coCreators = e, await Promise.all([
        this.saveShares(e),
        this.updateTeamMembers(e)
      ]);
    },
    toggleModal() {
      this.showModal = !this.showModal;
    }
  }
});
const zw = f({
  props: {
    statusName: {
      type: String,
      required: !0
    },
    statusType: {
      type: String,
      required: !0
    },
    state: {
      type: String,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    }
  },
  computed: {
    cssClass() {
      return `style-${this.state}`;
    },
    cssStyle() {
      if (this.state === "completed")
        return {
          color: this.color,
          borderColor: this.color
        };
    },
    label() {
      var e;
      const t = J(this.statusName, this.workflow, this.statusType);
      return ((e = this.$res(t)) == null ? void 0 : e.label) ?? this.statusName;
    },
    color() {
      const e = Bi(
        this.statusName,
        this.workflow,
        this.statusType
      );
      return e != null && e.endsWith(";") ? e.substring(0, e.length - 1) : e;
    }
  }
});
var Nw = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "timeline-item", class: e.cssClass, style: e.cssStyle }, [e._v(" " + e._s(e.label) + " ")]);
}, Vw = [], Gw = /* @__PURE__ */ x(
  zw,
  Nw,
  Vw,
  !1,
  null,
  "e2f35e5e"
);
const Ww = Gw.exports;
f({
  components: {
    TicketTimelineItem: Ww
  },
  props: {
    statusHistory: {
      type: Array,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    showStatus: {
      type: Boolean,
      default: !0
    },
    showCurrent: {
      type: Boolean,
      default: !1
    },
    showPhase: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    status() {
      return this.ticket.status;
    },
    displayStatusType() {
      return this.showStatus || this.showCurrentPhaseStatuses ? "status" : "phases";
    },
    statusType() {
      return this.showStatus ? "status" : "phases";
    },
    config() {
      return this.showCurrentPhaseStatuses ? this.phaseConfig[this.currentIndex].status : this.statusType === "phases" ? this.phaseConfig.map(({ phase: e }) => e) : this.statusConfig;
    },
    showCurrentPhaseStatuses() {
      return this.showCurrent && this.currentIndex !== void 0;
    },
    phaseConfig() {
      return ic(this.workflow);
    },
    statusConfig() {
      var e;
      return ((e = this.workflow.settings) == null ? void 0 : e.timelineStatuses) ?? [];
    },
    currentIndex() {
      if (this.statusType === "phases") {
        for (let e = this.phaseConfig.length - 1; e >= 0; e--)
          if (this.phaseConfig[e].status.includes(this.status))
            return e;
        return;
      }
      return this.statusConfig.findIndex((e) => e === this.status);
    },
    disableTimeline() {
      const { disableTimeline: e } = Wg(this.workflow);
      return e.includes(this.status);
    }
  },
  methods: {
    itemState(e) {
      return this.showCurrentPhaseStatuses ? this.config.findIndex((t) => t === this.status) >= e ? "completed" : "waiting" : this.currentIndex === void 0 ? "disabled" : this.statusType === "phases" && e <= this.currentIndex && this.phaseConfig[e].status.some(
        (t) => this.statusHistory.includes(t)
      ) || e <= this.currentIndex && this.statusHistory.includes(this.statusConfig[e]) ? "completed" : "waiting";
    }
  }
});
const Qw = f({
  components: {
    AppFileUploadItem: Mr,
    AppFileUploadItemProgress: Oc,
    AppFileUploadPicker: pc
  },
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    config: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      currentFiles: [],
      uploading: []
    };
  },
  created() {
    var e;
    this.currentFiles = ((e = this.ticket.files) == null ? void 0 : e.filter((t) => t.category === this.config.uploadCategory).map(Xt)) ?? [];
  },
  computed: {
    contextId() {
      return this.ticket.context;
    },
    productId() {
      return this.ticket.type;
    },
    ticketId() {
      return this.ticket.canonicalId;
    },
    fileFilter() {
      return ".mp4,.avi,.m4v,.mpg,.mpeg,.mov";
    },
    menuOptions() {
      return [
        {
          label: this.$t("menu.remove").toString(),
          tabKey: "remove"
        }
      ];
    },
    uploadAllowed() {
      const e = this.config.upload === "never", t = this.config.upload === "always", i = this.currentFiles.length + this.uploading.length;
      return e ? !1 : t ? !0 : this.config.upload === "single" ? i === 0 : !1;
    }
  },
  methods: {
    onFilePicked(e) {
      this.uploading.push([self.crypto.randomUUID(), e]);
    },
    onUploadSuccess(e) {
      this.uploading = this.uploading.filter(
        (t) => t[0] !== e.randomFileId
      ), this.currentFiles.push(e.userFile), this.onAttachmentChange();
    },
    async onRemoveFile(e) {
      await this.$api.fileAttachment.remove("ticket", this.ticketId, e.id), this.currentFiles = this.currentFiles.filter((t) => t.id !== e.id), this.onAttachmentChange();
    },
    onAttachmentChange() {
      this.$emit("attachment-updated");
    }
  }
});
var Xw = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "ticket-pitch-upload-group" }, [e._l(e.currentFiles, function(i, r) {
    return t("app-file-upload-item", { key: r, attrs: { file: i }, scopedSlots: e._u([{ key: "controls", fn: function() {
      return [t("app-ellipsis-menu", { attrs: { reference: i, "menu-options": e.menuOptions }, on: { "click:remove": e.onRemoveFile } })];
    }, proxy: !0 }], null, !0) });
  }), e._l(e.uploading, function([i, r]) {
    return t("app-file-upload-item-progress", { key: i, attrs: { "random-file-id": i, file: r, category: e.config.uploadCategory, "ticket-id": e.ticketId }, on: { "upload-success": e.onUploadSuccess } });
  }), e.uploadAllowed ? t("app-file-upload-picker", { attrs: { label: e.$t("common.upload"), "accept-filter": e.fileFilter }, on: { "pick-file": e.onFilePicked } }) : e._e()], 2);
}, Kw = [], Yw = /* @__PURE__ */ x(
  Qw,
  Xw,
  Kw,
  !1,
  null,
  "0299db4b"
);
const Zw = Yw.exports;
f({
  components: {
    AppFileItem: Mr,
    TicketPitchUploadGroup: Zw
  },
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    pitchConfig: {
      type: Array,
      required: !0
    }
  },
  computed: {
    contextId() {
      return this.ticket.context;
    },
    productId() {
      return this.ticket.type;
    },
    menuOptions() {
      return [[this.$t("menu.remove").toString(), "remove-file"]];
    },
    filteredPitches() {
      return this.pitchConfig.filter((e) => {
        const t = e.visibility === "never", i = e.visibility === "always", r = this.pitchFiles(e).length > 0, s = e.associatedStatus.includes(this.ticket.status);
        return t ? !1 : i || r || s;
      });
    }
  },
  methods: {
    groupLabelStyle(e) {
      return { color: e.color };
    },
    pitchFiles(e) {
      var t;
      return ((t = this.ticket.files) == null ? void 0 : t.filter((i) => i.category === e.uploadCategory).map(Xt)) ?? [];
    }
  }
});
f({
  props: {
    ticket: {
      type: Object,
      required: !0
    },
    pitchConfig: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      currentTab: "",
      tabList: []
    };
  },
  async created() {
    await this.loadTabs();
  },
  watch: {
    async pitchConfig() {
      await this.loadTabs();
    }
  },
  computed: {
    videoSrc() {
      var e;
      const t = (e = this.ticket.files) == null ? void 0 : e.find(
        (i) => i.category === this.currentTab
      );
      return t ? t.url : void 0;
    }
  },
  methods: {
    loadTabs() {
      var e;
      this.tabList = this.pitchConfig.filter((i) => {
        var r;
        return (r = this.ticket.files) == null ? void 0 : r.some(
          (s) => s.category === i.uploadCategory
        );
      }).map((i) => ({
        key: i.uploadCategory,
        label: this.$res(i.resources).label,
        color: i.color
      }));
      const t = this.tabList.length - 1;
      t > -1 && (this.currentTab = (e = this.tabList[t]) == null ? void 0 : e.key);
    },
    tabStyle(e) {
      return e.key === this.currentTab ? { borderColor: e.color } : { borderColor: "transparent" };
    },
    onSelectTab(e) {
      this.currentTab = e.key;
    }
  }
});
const Jw = f({
  props: {
    label: {
      type: String,
      required: !0
    },
    count: {
      type: Number,
      default: 0
    }
  }
});
var _w = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "ticket-stats-pill" }, [t("div", { staticClass: "stats-count" }, [e._v(e._s(e.count))]), t("div", { staticClass: "stats-title" }, [e._v(e._s(e.label))])]);
}, $w = [], ex = /* @__PURE__ */ x(
  Jw,
  _w,
  $w,
  !1,
  null,
  "4eb38814"
);
const tx = ex.exports;
f({
  components: {
    TicketStatsPill: tx
  },
  props: {
    ticketStats: {
      type: Object,
      default: () => ({})
    },
    workflow: {
      type: Object,
      required: !0
    },
    activeStatuses: {
      type: Array,
      default: null
    }
  },
  computed: {
    totalAmount() {
      return this.activeStatuses.reduce(
        (e, t) => {
          var i, r;
          return e + (((r = (i = this.ticketStats) == null ? void 0 : i.byStatus) == null ? void 0 : r[t]) ?? 0);
        },
        0
      );
    }
  },
  methods: {
    statusLabel(e) {
      var t;
      const i = J(e, this.workflow);
      return ((t = this.$res(i)) == null ? void 0 : t.label) ?? "";
    },
    ticketCountPerStatus(e) {
      var t, i;
      return ((i = (t = this.ticketStats) == null ? void 0 : t.byStatus) == null ? void 0 : i[e]) ?? 0;
    }
  }
});
f({
  components: {
    TicketPreferredTransition: Ic,
    TicketAvailableTransitions: Sc
  },
  props: {
    statusHistory: {
      type: Array,
      required: !0
    },
    status: {
      type: String,
      required: !0
    },
    workflow: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      preferredTransition: void 0,
      availableTransitions: []
    };
  },
  created() {
    const { fromStatus: e, available: t, preferred: i } = Qg(this.workflow);
    rt(i, (r) => {
      this.preferredTransition = r;
    }), rt(t, (r) => {
      this.availableTransitions = r ?? [];
    }), e.value = this.status;
  },
  computed: {
    hasPhase() {
      var e, t, i;
      return !!((i = (t = (e = this.workflow) == null ? void 0 : e.settings) == null ? void 0 : t.status[this.status]) != null && i.phase);
    }
  },
  methods: {
    onExecuteTransition(e) {
      this.$emit("execute-transition", e);
    }
  }
});
f({
  props: {
    transitionDialogSettings: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      reasonText: ""
    };
  },
  computed: {
    replacements() {
      return [
        ["@:common.ticket", this.$t("common.ticket").toString()],
        ["@common.ticket", this.$t("common.ticket").toString()]
      ];
    },
    showStatusMessage() {
      return this.transitionDialogSettings.statusMessage && this.transitionDialogSettings.statusMessage !== "DISABLED";
    },
    statusMessageLabel() {
      return this.resources.statusMessageLabel;
    },
    isConfirmEnabled() {
      return this.transitionDialogSettings.statusMessage !== "REQUIRED" || !!this.reasonText;
    },
    resources() {
      const e = this.transitionDialogSettings.resources;
      return this.$res(e);
    },
    title() {
      return this.replaceTranslations(this.resources.title ?? "");
    },
    description() {
      return this.replaceTranslations(this.resources.description ?? "");
    }
  },
  methods: {
    replaceTranslations(e) {
      return this.replacements.reduce((t, i) => t.replaceAll(i[0], i[1]), e);
    },
    onConfirm() {
      this.$emit("click-primary", this.reasonText);
    },
    onCancel() {
      this.$emit("click-secondary");
    }
  }
});
const ix = "/img/profile-placeholder.svg", rx = f({
  components: {
    EditableTextArea: kc,
    UserSelectionInput: un
  },
  props: {
    productId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    task: {
      type: Object,
      required: !0
    },
    comments: {
      type: Array,
      required: !0
    },
    mode: {
      type: String,
      default: "view"
    }
  },
  data() {
    return {
      checked: !1,
      title: "",
      deadline: void 0,
      assignee: null,
      userSelectionOpen: !1,
      searchOptions: []
    };
  },
  async created() {
    this.checked = this.task.ticket.status === "COMPLETED", this.title = this.task.ticket.title;
    const e = this.task.ticket.deadLine;
    this.deadline = e ? new Date(e) : void 0, this.task.assignee && (this.assignee = this.task.assignee.user ?? null);
  },
  computed: {
    ticketIdOrType() {
      return this.task.ticket.canonicalId ?? this.task.ticket.type;
    },
    deadlineText() {
      var e;
      const t = {
        year: void 0,
        month: "short",
        day: "numeric"
      };
      return ((e = this.deadline) == null ? void 0 : e.toLocaleDateString(void 0, t)) ?? "";
    },
    expired() {
      return this.deadline ? this.deadline < /* @__PURE__ */ new Date() : !1;
    },
    commentsCount() {
      return this.comments.length ? `${this.comments.length}` : "";
    },
    commentsIcon() {
      return this.commentsCount ? "fa-light fa-comment" : "fa-light fa-comment-plus";
    },
    assigneeAvatar() {
      var e;
      return ((e = this.assignee) == null ? void 0 : e.avatar) || ix;
    },
    menuOptions() {
      return [
        {
          label: this.$t("menu.removeTask").toString(),
          tabKey: "remove-task"
        }
      ];
    }
  },
  methods: {
    onToggleUserSelection() {
      this.userSelectionOpen = !this.userSelectionOpen;
    },
    async onUpdateSearch(e) {
      this.searchOptions = await this.$gateway.portal.fetchTicketAssigneeAudience(
        e,
        this.ticketIdOrType,
        this.productId
      );
    },
    removeTask() {
      this.$emit("remove-task");
    },
    onUpdateStatus(e) {
      this.$emit("update-status", e);
    },
    onUpdateTitle(e) {
      e.code === "Escape" && (e.preventDefault(), this.title = this.task.ticket.title), e.code === "Enter" && !e.shiftKey && (e.preventDefault(), this.$emit("update-title", this.title.trim()));
    },
    onBlurTitle(e) {
      this.$emit("update-title", this.title.trim());
    },
    onChangeDeadline(e) {
      if (e) {
        this.$emit("update-deadline", e.toISOString());
        const t = new Date(e.getTime());
        t.setHours(23), t.setMinutes(59), this.deadline = t;
      } else
        this.deadline = void 0;
    },
    async onChangeAssignee(e) {
      this.$emit("update-assignee", e);
      try {
        const t = await this.$datasource.user.findById(e);
        this.assignee = t ?? null;
      } catch (t) {
        console.error("Could not load assignee", t);
      }
    },
    onChangeAssigneeSelf() {
      this.onChangeAssignee(this.currentUser.id);
    },
    onToggleComments() {
      this.$emit("toggle-comments");
    }
  }
});
var sx = function() {
  var e, t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "task-item-content" }, [i("div", { staticClass: "inner-container" }, [i("app-checkbox", { staticClass: "completed-checkbox", on: { input: t.onUpdateStatus }, model: { value: t.checked, callback: function(r) {
    t.checked = r;
  }, expression: "checked" } })], 1), i("editable-text-area", { staticClass: "task-title", attrs: { rows: 1, mode: t.mode }, on: { keydown: t.onUpdateTitle, blur: t.onBlurTitle }, model: { value: t.title, callback: function(r) {
    t.title = r;
  }, expression: "title" } }), i("div", { staticClass: "inner-container deadline-container" }, [i("app-datepicker-button", { on: { input: t.onChangeDeadline }, scopedSlots: t._u([{ key: "default", fn: function({ toggle: r }) {
    return [t.deadline ? i("div", { staticClass: "deadline-date", class: { expired: t.expired }, on: { click: r } }, [t._v(" " + t._s(t.deadlineText) + " ")]) : i("app-icon-button", { attrs: { size: 30 }, on: { click: r } }, [i("fa-icon-compat", { staticClass: "inner-icon", attrs: { icon: "fa-light fa-calendar" } })], 1)];
  } }]) })], 1), i("div", { staticClass: "inner-container assignee-container" }, [t.assignee ? i("img", { staticClass: "assignee-image", attrs: { src: t.assigneeAvatar }, on: { click: t.onToggleUserSelection } }) : i("app-icon-button", { attrs: { size: 30 }, on: { click: t.onToggleUserSelection } }, [i("fa-icon-compat", { staticClass: "inner-icon", attrs: { icon: "fa-light fa-user-plus" } })], 1), t.userSelectionOpen ? i("div", { staticClass: "assignee-selection" }, [i("user-selection-input", { attrs: { options: t.searchOptions }, on: { "hide-floating": t.onToggleUserSelection, "update-search": t.onUpdateSearch, "select-item": t.onChangeAssignee }, scopedSlots: t._u([t.currentUser.id !== ((e = t.assignee) == null ? void 0 : e.id) ? { key: "prepend", fn: function() {
    return [i("app-list-item", { attrs: { image: t.currentUser.avatar, title: t.$t("menu.assignToMe") }, nativeOn: { click: function(r) {
      return t.onChangeAssigneeSelf.apply(null, arguments);
    } } })];
  }, proxy: !0 } : null], null, !0) })], 1) : t._e()], 1), i("div", { staticClass: "inner-container" }, [i("app-icon-button", { attrs: { size: 30 }, on: { click: t.onToggleComments } }, [i("fa-icon-compat", { staticClass: "inner-icon comments-icon", attrs: { icon: t.commentsIcon } })], 1), i("span", { staticClass: "comments-count" }, [t._v(" " + t._s(t.commentsCount) + " ")])], 1), i("div", { staticClass: "inner-container" }, [i("app-ellipsis-menu", { staticClass: "task-menu", attrs: { "menu-options": t.menuOptions }, on: { "click:remove-task": t.removeTask } })], 1)], 1);
}, nx = [], ax = /* @__PURE__ */ x(
  rx,
  sx,
  nx,
  !1,
  null,
  "00591a4c"
);
const ox = ax.exports, qo = "/img/profile-placeholder.svg", lx = f({
  props: {
    mode: {
      type: String,
      default: "view"
    },
    comment: {
      type: Object,
      required: !1
    },
    placeholder: {
      type: String,
      required: !1
    },
    currentUser: {
      type: Object,
      required: !1
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      text: ""
    };
  },
  created() {
    var e;
    this.text = ((e = this.comment) == null ? void 0 : e.content) ?? "";
  },
  computed: {
    authorAvatar() {
      var e, t, i;
      return this.comment ? ((t = (e = this.comment.author) == null ? void 0 : e.user) == null ? void 0 : t.avatar) || qo : ((i = this.currentUser) == null ? void 0 : i.avatar) || qo;
    },
    routeToUser() {
      var e, t, i;
      return {
        name: "UserProfile",
        params: {
          userId: ((i = (t = (e = this.comment) == null ? void 0 : e.author) == null ? void 0 : t.user) == null ? void 0 : i.id) ?? this.currentUser.id
        }
      };
    }
  },
  methods: {
    onKeydown(e) {
      e.code === "Enter" && !e.shiftKey && (this.$emit("confirmComment", this.text.trim()), e.preventDefault());
    }
  }
});
var cx = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "compact-comment-item" }, [t("router-link", { attrs: { to: e.routeToUser } }, [t("img", { staticClass: "author-avatar", attrs: { src: e.authorAvatar } })]), t("editable-text-area", { staticClass: "comment-text", attrs: { placeholder: e.placeholder, rows: e.rows, mode: e.mode }, on: { keydown: e.onKeydown }, model: { value: e.text, callback: function(i) {
    e.text = i;
  }, expression: "text" } })], 1);
}, ux = [], dx = /* @__PURE__ */ x(
  lx,
  cx,
  ux,
  !1,
  null,
  "c9bb1e6e"
);
const hx = dx.exports, px = f({
  components: {
    CompactCommentItem: hx
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    currentUser: {
      type: Object,
      required: !0
    },
    comments: {
      type: Array,
      required: !0
    },
    threadOwnerId: {
      type: Object,
      required: !1
    }
  },
  methods: {
    getCommentMode(e) {
      var t, i;
      return (i = (t = e.author) == null ? void 0 : t.user) == null || i.id, this.currentUser.id, "view";
    },
    onCreateComment(e) {
      this.$emit("commentCreate", e);
    },
    onUpdateComment(e, t) {
      this.$emit("commentUpdate", { id: e, text: t });
    }
  }
});
var fx = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "compact-comment-area" }, [t("compact-comment-item", { attrs: { "current-user": e.currentUser, placeholder: e.$t("page.ticketDetails.leaveComment"), rows: 2, mode: "edit" }, on: { confirmComment: e.onCreateComment } }), e._l(e.comments, function(i) {
    return t("div", { key: i.id }, [t("compact-comment-item", { attrs: { comment: i, mode: e.getCommentMode(i) }, on: { confirmComment: function(r) {
      return e.onUpdateComment(i.id, r);
    } } })], 1);
  })], 2);
}, mx = [], gx = /* @__PURE__ */ x(
  px,
  fx,
  mx,
  !1,
  null,
  "dbf1d93f"
);
const yx = gx.exports, bx = f({
  components: {
    TaskItemContent: ox,
    CompactCommentArea: yx
  },
  props: {
    productId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    taskResponse: {
      type: Object,
      required: !0
    },
    comments: {
      type: Array,
      required: !0
    },
    mode: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      reloadKey: 0,
      commentsVisible: !1,
      currentComments: []
    };
  },
  created() {
    this.currentComments = this.comments;
  },
  computed: {
    task() {
      return this.taskResponse.ticket;
    }
  },
  methods: {
    onToggleComments() {
      this.commentsVisible = !this.commentsVisible;
    },
    async onUpdateStatus(e) {
      const t = e ? "COMPLETED" : "DRAFT";
      try {
        await this.$datasource.ticket.updateStatus(
          this.productId,
          this.task.canonicalId,
          t
        ), this.task.status = t, this.onTaskUpdated(), t === "COMPLETED" ? this.$toast(this.$t("page.tasks.completed").toString()) : this.$toast(this.$t("common.saved").toString());
      } catch (i) {
        console.error(`Could not update status [${this.task.canonicalId}]`, i), this.$toast(this.$t("error.general").toString());
      }
    },
    async onUpdateTitle(e) {
      if (e.length && this.task.title !== e)
        try {
          await this.$datasource.ticket.update(
            this.productId,
            this.task.canonicalId,
            {
              title: e
            }
          ), this.task.title = e, this.onTaskUpdated(), this.$toast(this.$t("common.saved").toString());
        } catch (t) {
          console.error(`Could not update title [${this.task.canonicalId}]`, t), this.$toast(this.$t("error.general").toString());
        }
    },
    async onUpdateDeadline(e) {
      const t = new Date(Date.parse(e));
      t.setHours(23), t.setMinutes(59);
      try {
        const i = t.getTime();
        await this.$datasource.ticket.update(
          this.productId,
          this.task.canonicalId,
          {
            deadLine: i
          }
        ), this.task.deadLine = i, this.onTaskUpdated(), this.$toast(this.$t("common.saved").toString());
      } catch (i) {
        console.error(
          `Could not update deadline [${this.task.canonicalId}]`,
          i
        ), this.$toast(this.$t("error.general").toString());
      }
    },
    async onUpdateAssignee(e) {
      try {
        await this.$datasource.ticket.update(
          this.productId,
          this.task.canonicalId,
          {
            assignee: e
          }
        ), this.task.assignee = e, this.$toast(this.$t("common.saved").toString()), this.onTaskUpdated();
      } catch (t) {
        console.error(
          `Could not update assignee [${this.task.canonicalId}]`,
          t
        ), this.$toast(this.$t("error.general").toString());
      }
    },
    async onRemoveTask() {
      try {
        await this.$gateway.portal.removeTask(
          this.productId,
          this.task.canonicalId
        ), this.onTaskRemoved();
      } catch (e) {
        console.error(`Could not remove task [${this.task.canonicalId}]`, e), this.$toast(this.$t("error.general").toString());
      }
    },
    async onCreateComment(e) {
      if (e.length)
        try {
          const t = this.task.canonicalId, i = await this.$gateway.portal.createPublicComment(
            t,
            {
              author: this.currentUser.id,
              content: e
            }
          );
          this.currentComments = [i, ...this.currentComments], this.reloadKey += 1;
        } catch (t) {
          console.error("Could not create comment", t), this.$toast(this.$t("error.general").toString());
        }
    },
    async onUpdateComment(e) {
      console.warn("Update comment not implemented", e);
    },
    onTaskUpdated() {
      this.$emit("task-updated", this.task.canonicalId);
    },
    onTaskRemoved() {
      this.$emit("task-removed", this.task.canonicalId);
    }
  }
});
var vx = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "task-item" }, [t("task-item-content", { attrs: { "product-id": e.productId, "current-user": e.currentUser, task: e.taskResponse, comments: e.currentComments, mode: e.mode }, on: { "update-status": e.onUpdateStatus, "update-title": e.onUpdateTitle, "update-deadline": e.onUpdateDeadline, "update-assignee": e.onUpdateAssignee, "toggle-comments": e.onToggleComments, "remove-task": e.onRemoveTask } }), t("transition", { attrs: { mode: "out-in", name: "slide-fade-vertical" } }, [e.commentsVisible ? t("compact-comment-area", { key: e.reloadKey, staticClass: "compact-comment-area", attrs: { mode: e.mode, "current-user": e.currentUser, comments: e.currentComments, "thread-owner-id": void 0 }, on: { commentCreate: e.onCreateComment, commentUpdate: e.onUpdateComment } }) : e._e()], 1)], 1);
}, Ax = [], kx = /* @__PURE__ */ x(
  bx,
  vx,
  Ax,
  !1,
  null,
  "d994ea5e"
);
const wx = kx.exports, xx = f({
  components: {
    EditableTextArea: kc
  },
  props: {
    productId: {
      type: String,
      required: !0
    },
    parentCanonicalId: {
      type: String,
      required: !0
    },
    taskGroup: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      title: "",
      loading: !1
    };
  },
  computed: {
    enabled() {
      return !this.loading;
    }
  },
  methods: {
    async onUpdateTitle(e) {
      e.code === "Enter" && !e.shiftKey && (e.preventDefault(), await this.createTask(this.title.trim()));
    },
    async createTask(e) {
      if (e.length)
        try {
          this.loading = !0;
          const t = await this.$gateway.portal.createTask(
            this.productId,
            this.parentCanonicalId,
            this.taskGroup,
            e
          );
          this.$emit("task-created", t), this.title = "";
        } catch (t) {
          console.error("Could not create task", t), this.$toast(this.$t("error.general").toString());
        } finally {
          this.loading = !1;
        }
    }
  }
});
var Cx = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("editable-text-area", { staticClass: "task-item-create", attrs: { rows: 1, mode: "edit", enabled: e.enabled, placeholder: e.$t("page.tasks.add-placeholder") }, on: { keydown: e.onUpdateTitle }, model: { value: e.title, callback: function(i) {
    e.title = i;
  }, expression: "title" } });
}, Sx = [], Ix = /* @__PURE__ */ x(
  xx,
  Cx,
  Sx,
  !1,
  null,
  "eae998e0"
);
const Dx = Ix.exports;
f({
  components: {
    TaskItem: wx,
    TaskItemCreate: Dx
  },
  props: {
    currentUser: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    parentCanonicalId: {
      type: String,
      required: !0
    },
    mode: {
      type: String,
      required: !0
    },
    taskGroup: {
      type: String,
      required: !1
    },
    actionsCreateTask: {
      type: Boolean,
      default: !0
    },
    tasks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentTasks: []
    };
  },
  created() {
    this.currentTasks = [...this.tasks];
  },
  computed: {
    createTaskVisible() {
      return this.actionsCreateTask && this.mode === "edit";
    }
  },
  methods: {
    onTaskUpdated() {
      this.$datasource.ticket.dirty(this.parentCanonicalId);
    },
    onTaskRemoved(e) {
      this.$datasource.ticket.dirty(this.parentCanonicalId), this.currentTasks = this.currentTasks.filter(
        ([{ ticket: t }]) => t.canonicalId !== e
      ), this.$toast(this.$t("common.removed").toString()), this.$emit("update-task-list");
    },
    onTaskCreated(e) {
      this.$datasource.ticket.dirty(this.parentCanonicalId), this.currentTasks = [...this.currentTasks, [e, []]], this.$toast(this.$t("common.created").toString()), this.$emit("update-task-list");
    }
  }
});
const Px = f({
  props: {
    currentImage: {
      type: String,
      required: !1
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      src: "",
      type: ""
    };
  },
  setup() {
    return $l();
  },
  computed: {
    disabled() {
      return !this.enabled;
    }
  },
  methods: {
    onClickInput() {
      const e = this;
      e.enabled && e.$refs.file.click();
    },
    loadImage(e) {
      const t = this, { files: i } = e.target;
      if (i != null && i[0] && !this.allowFileSize(i[0])) {
        console.error(`File size is too big, ${i[0].size}`), this.$toast(
          this.$t("error.maxFileSize", {
            size: this.readableMaxFileUploadSize
          }).toString()
        );
        return;
      } else if (i != null && i[0]) {
        t.src && URL.revokeObjectURL(t.src);
        const r = URL.createObjectURL(i[0]);
        this.$emit("blob-loaded", i[0]), t.src = r, t.type = i[0].type, this.$emit("image-loaded", { src: t.src, type: t.type });
      }
    }
  }
});
var Tx = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "input-content", attrs: { role: "input" }, on: { click: e.onClickInput, keypress: function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "enter", 13, i.key, "Enter") ? null : (i.stopPropagation(), e.onClickInput.apply(null, arguments));
  } } }, [t("app-icon-button", { attrs: { size: 48, frame: "square" } }, [t("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-paperclip" } })], 1), t("input", { ref: "file", staticClass: "hidden-file-input", attrs: { type: "file" }, on: { change: function(i) {
    return e.loadImage(i);
  } } })], 1);
}, Ox = [], Bx = /* @__PURE__ */ x(
  Px,
  Tx,
  Ox,
  !1,
  null,
  "56ac7775"
);
const Mx = Bx.exports;
f({
  components: {
    CommentFileInput: Mx
  },
  props: {
    originalText: {
      type: String,
      required: !1
    },
    contextId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      text: this.originalText ?? "",
      open: !1,
      lastCaretPosition: 0,
      dirty: !1,
      loading: !1,
      reloadKey: 0,
      options: [],
      search: "",
      commentImage: ""
    };
  },
  mounted() {
    document.addEventListener("keyup", this.listenerKeyup);
  },
  unmounted() {
    document.removeEventListener("keyup", this.listenerKeyup);
  },
  computed: {
    postButtonEnabled() {
      return this.text.trim().length > 0;
    }
  },
  methods: {
    onCancelComment() {
      this.text = "", this.$emit("cancel-comment");
    },
    insertText(e) {
      const t = this.lastCaretPosition;
      this.text = `${this.text.substring(
        0,
        t
      )}{${e}} ${this.text.substring(t)}`;
    },
    async onImageInput(e) {
      const t = await this.$api.fileUpload.uploadFile(
        e,
        "comment-file",
        e.name
      );
      this.text = `${this.text} [${e.name}](${t.payload.location}) `;
    },
    onCommentSelection(e) {
      this.lastCaretPosition = e.selectionStart;
    },
    onCommentKeydown(e) {
      e.key === "@" && (this.open = !0, setTimeout(() => {
        const t = this.$el.querySelector(".user-list-search input");
        t == null || t.focus();
      }, 100));
    },
    onDirty() {
      this.dirty = !0, this.loading = !0;
    },
    onSelectItem(e) {
      const t = B({ user: e.user }).displayEmail(), i = t || `${this.contextId}:user:id:${e.user.id}`;
      this.insertText(i), this.open = !1, setTimeout(() => {
        const r = this.$el.querySelector(".app-text-area textarea");
        r == null || r.focus();
      }, 100), this.search = "", this.options = [];
    },
    async onDebouncedSearch(e) {
      this.loading = !0;
      const t = await this.$gateway.search.searchUserIds({ query: e }), i = await this.$gateway.portal.findUsersById(
        t
      );
      this.options = i.filter(
        (r) => !!r.user.firstName || r.user.lastName
      ), this.loading = !1;
    },
    onCancelMention() {
      this.open = !1, this.search = "", this.options = [], setTimeout(() => {
        const e = this.$el.querySelector(".app-text-area textarea");
        e == null || e.focus();
      }, 500);
    },
    listenerKeyup(e) {
      var t;
      ((t = e.key) == null ? void 0 : t.toUpperCase()) === "ESCAPE" && this.onCancelMention();
    },
    saveComment() {
      this.$emit("save-comment", this.text.trim()), this.text = "";
    }
  }
});
const Rx = f({
  name: "LinkItemTicket",
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    link: {
      type: Object,
      required: !0
    },
    deleteEnabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      loading: !1,
      ticket: null,
      workflow: null
    };
  },
  async mounted() {
    this.loading = !0;
    try {
      const e = await this.$gateway.ticket.loadTicket(
        this.contextId,
        this.productId,
        this.link.destination.id
      );
      this.ticket = e.ticket, this.workflow = e.workflow;
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = !1;
    }
  },
  computed: {
    title() {
      var e;
      return ((e = this.ticket) == null ? void 0 : e.title) ?? "";
    },
    status() {
      var e;
      return ((e = this.ticket) == null ? void 0 : e.status) ?? "";
    },
    createdDate() {
      const e = new Date(this.ticket.createdDate);
      return (e == null ? void 0 : e.toLocaleDateString(void 0, {
        day: "2-digit",
        month: "short",
        year: "numeric"
      })) || "";
    },
    statusLabel() {
      var e;
      const t = J(this.ticket.status, this.workflow);
      return ((e = this.$res(t)) == null ? void 0 : e.label) ?? "";
    },
    targetRoute() {
      var e;
      return {
        name: "TicketDetails",
        params: { id: (e = this.ticket) == null ? void 0 : e.canonicalId }
      };
    },
    menuOptions() {
      return [
        {
          label: this.$t("common.form.delete").toString(),
          tabKey: "delete"
        }
      ];
    },
    image() {
      if (!this.workflow)
        return "";
      const { icons: e } = Kt(this.workflow);
      return e.solid ?? "";
    }
  },
  methods: {
    onDelete() {
      this.$emit("delete", this.link);
    }
  }
});
var Ex = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, e.ticket ? t("router-link", { attrs: { to: e.targetRoute } }, [t("app-list-item", { attrs: { description: e.createdDate, image: e.image, title: e.title }, scopedSlots: e._u([{ key: "description", fn: function() {
    return [t("div", { staticClass: "description-container" }, [t("div", { staticClass: "item-description" }, [e._v(e._s(e.createdDate))]), t("div", { staticClass: "item-status" }, [e._v(e._s(e.statusLabel))])])];
  }, proxy: !0 }, { key: "controls", fn: function() {
    return [e.deleteEnabled ? t("app-ellipsis-menu", { attrs: { "menu-options": e.menuOptions }, on: { "click:delete": e.onDelete } }) : e._e()];
  }, proxy: !0 }], null, !1, 2079526083) })], 1) : e._e();
}, Lx = [], Fx = /* @__PURE__ */ x(
  Rx,
  Ex,
  Lx,
  !1,
  null,
  "76751eee"
);
const jx = Fx.exports, Ux = f({
  name: "LinkItem",
  components: {
    LinkItemTicket: jx
  },
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    link: {
      type: Object,
      required: !0
    },
    deleteEnabled: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    target() {
      return this.link.destination;
    },
    linkItemComponent() {
      var e, t;
      switch ((e = this.target) == null ? void 0 : e.class) {
        case "SERVICE_ORDER":
          return "LinkItemTicket";
        case "TICKET":
          return "LinkItemTicket";
        default:
          return console.error(`Unknown link target class: '${(t = this.target) == null ? void 0 : t.class}'`), "";
      }
    }
  }
});
var qx = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t(e.linkItemComponent, e._g({ tag: "component", attrs: { "context-id": e.contextId, "product-id": e.productId, link: e.link, "delete-enabled": e.deleteEnabled } }, e.$listeners));
}, Hx = [], zx = /* @__PURE__ */ x(
  Ux,
  qx,
  Hx,
  !1,
  null,
  null
);
const Nx = zx.exports, Vx = De.extend({
  props: {
    link: {
      type: Object,
      required: !0
    },
    relation: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !1
    };
  },
  methods: {
    async onConfirmDelete() {
      try {
        this.loading = !0, await this.$api.link.deleteLink({
          sourceId: this.link.source.id,
          destinationId: this.link.destination.id,
          class: this.link.destination.class,
          relation: this.relation
        }), this.$toast(
          this.$t("modal.linkItemDelete.toast-delete-success").toString()
        ), this.$emit("updated");
      } catch (e) {
        e.message ? this.$toast(e.message) : this.$toast(this.$t("error.general").toString());
      } finally {
        this.loading = !1, this.onClose();
      }
    },
    onClose() {
      this.$emit("close");
    }
  }
});
var Gx = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal-confirmation", { attrs: { title: e.$t("modal.linkItemDelete.title"), description: e.$t("modal.linkItemDelete.message"), "primary-label": e.$t("form.button.confirm"), "secondary-label": e.$t("form.button.cancel"), loading: e.loading }, on: { "click-primary": e.onConfirmDelete, "click-secondary": e.onClose } });
}, Wx = [], Qx = /* @__PURE__ */ x(
  Vx,
  Gx,
  Wx,
  !1,
  null,
  null
);
const Xx = Qx.exports, Kx = f({
  name: "LinkGroup",
  components: {
    LinkItem: Nx,
    LinkItemDelete: Xx
  },
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    relation: {
      type: String,
      required: !0
    },
    links: {
      type: Array,
      required: !0
    },
    deleteEnabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      link: {},
      openLinkDeleteModal: !1
    };
  },
  computed: {
    relationTitle() {
      return this.$t(`linking.${this.relation}`).toString();
    }
  },
  methods: {
    manageDeleteModal(e) {
      this.link = e, this.openLinkDeleteModal = !0;
    }
  }
});
var Yx = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [t("app-section-list", { staticClass: "link-group", attrs: { data: e.links, level: 3, title: e.relationTitle }, scopedSlots: e._u([{ key: "default", fn: function({ item: i }) {
    return [t("link-item", { staticClass: "link-item", attrs: { "context-id": e.contextId, "product-id": e.productId, link: i, "delete-enabled": e.deleteEnabled }, on: { delete: e.manageDeleteModal } })];
  } }]) }), e.openLinkDeleteModal ? t("link-item-delete", { attrs: { relation: e.relation, link: e.link }, on: { close: function(i) {
    e.openLinkDeleteModal = !1;
  }, updated: function(i) {
    return e.$emit("updated");
  } } }) : e._e()], 1);
}, Zx = [], Jx = /* @__PURE__ */ x(
  Kx,
  Yx,
  Zx,
  !1,
  null,
  "bb7ff8a3"
);
const _x = Jx.exports;
f({
  name: "TicketLinkWidget",
  components: {
    LinkGroup: _x
  },
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    links: {
      type: Array,
      required: !0
    }
  },
  computed: {
    availableTargets() {
      return ["TICKET", "SERVICE_ORDER"];
    },
    availableRelations() {
      return [
        { name: "COPY_TO", deleteEnabled: !1 },
        { name: "COPIED_FROM", deleteEnabled: !1 },
        { name: "MOVED", deleteEnabled: !1 },
        { name: "MOVED_FROM", deleteEnabled: !1 },
        { name: "PURCHASED", deleteEnabled: !1 },
        { name: "IS_PURCHASED_BY", deleteEnabled: !1 },
        { name: "CONTINUED_FROM", deleteEnabled: !0 },
        { name: "CONTINUED_AS", deleteEnabled: !0 },
        { name: "RELATED_TO", deleteEnabled: !0 },
        { name: "RELATED_FROM", deleteEnabled: !0 }
      ];
    },
    validLinks() {
      return this.links.filter((e) => this.availableTargets.includes(e.destination.class)).filter(
        (e) => this.availableRelations.some((t) => t.name === e.relation)
      );
    },
    linkByRelation() {
      return Jy(this.validLinks, (e) => e.relation);
    },
    relationList() {
      return [...this.linkByRelation.keys()];
    }
  },
  methods: {
    linkRelationObjects(e) {
      return this.linkByRelation.get(e);
    },
    isDeleteEnabled(e) {
      return this.availableRelations.find((t) => t.name === e).deleteEnabled;
    }
  }
});
f({
  props: {
    ticketId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      ticketSelected: "",
      relationSelected: "",
      relationOptions: [
        {
          text: this.$t("linking.CONTINUED_FROM").toString().toUpperCase(),
          value: "CONTINUED_FROM"
        },
        {
          text: this.$t("linking.CONTINUED_AS").toString().toUpperCase(),
          value: "CONTINUED_AS"
        },
        {
          text: this.$t("linking.RELATED_TO").toString().toUpperCase(),
          value: "RELATED_TO"
        }
      ]
    };
  },
  computed: {
    submitButtonEnabled() {
      return !!this.ticketSelected && !!this.relationSelected;
    },
    productIds() {
      const { productIds: e } = Ge(this.organization);
      return e.value;
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    updatedLink() {
      this.$emit("updated"), this.closeModal();
    },
    async addLinkButton() {
      const e = {
        source: {
          id: this.ticketId,
          class: "TICKET"
        },
        destination: {
          id: this.ticketSelected,
          class: "TICKET"
        },
        relation: this.relationSelected
      };
      await this.$api.link.addLink(e), this.$toast(
        this.$t("modal.ticketLinkingModal.toast-add-success").toString()
      ), this.updatedLink();
    }
  }
});
f({
  name: "AvatarList",
  props: {
    users: {
      type: Array,
      required: !0
    },
    maxDisplay: {
      type: Number,
      default: 4
    }
  },
  computed: {
    displayUsers() {
      return this.users.slice(0, this.maxDisplay);
    },
    otherUserCount() {
      return `+${this.users.length - this.maxDisplay}`;
    }
  },
  methods: {
    getAvatar(e) {
      return e.avatar || "/img/profile-placeholder.svg";
    },
    displayName(e) {
      return B({ user: e }).displayName();
    }
  }
});
f({
  name: "UserItemCard",
  props: {
    userData: {
      type: Object,
      required: !0
    }
  }
});
f({
  props: {
    userData: {
      type: Object,
      required: !0
    }
  },
  computed: {
    avatar() {
      var e;
      return (e = this.userData.user) == null ? void 0 : e.avatar;
    },
    displayName() {
      return B(this.userData).displayName();
    },
    userDepartment() {
      return B(this.userData).userDepartment();
    }
  }
});
const Ho = "/img/profile-placeholder.svg";
f({
  props: {
    value: {
      type: [String, Array],
      required: !0
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    selectionMode: {
      type: String,
      default: "single"
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    filter: {
      type: Object,
      required: !1
    },
    excludeUserIds: {
      type: Array,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      loading: !1,
      options: [],
      optionsPool: [],
      selection: []
    };
  },
  async created() {
    if (this.value) {
      const e = Array.isArray(this.value) ? this.value : [this.value];
      this.loading = !0;
      const t = await this.$gateway.portal.findUsersById(e);
      this.optionsPool = t.map((i) => ({
        text: B(i).displayName(),
        value: i.user.id,
        image: i.user.avatar || Ho,
        description: B(i).userDepartment()
      })), this.selection = e, this.loading = !1;
    }
  },
  computed: {
    isSingleSelectionMode() {
      return this.selectionMode === "single";
    }
  },
  methods: {
    onUpdate(e) {
      let t = e;
      this.isSingleSelectionMode && (t = Array.isArray(e) ? e[0] : e), this.$emit("input", t);
    },
    onToggleOpen(e) {
      e || (this.options = [], this.$emit("blur"));
    },
    async onSearchDebounced(e) {
      var t, i, r;
      if (e.length < 3) {
        this.options = [];
        return;
      }
      this.loading = !0;
      const s = (await this.$gateway.search.searchUserIds({
        query: e,
        context: (t = this.filter) == null ? void 0 : t.context,
        filter: {
          teams: (i = this.filter) == null ? void 0 : i.teamIds,
          topics: (r = this.filter) == null ? void 0 : r.topicIds
        }
      })).filter(
        (a) => {
          var o;
          return !((o = this.excludeUserIds) != null && o.includes(a));
        }
      ), n = await this.$gateway.portal.findUsersById(s);
      this.options = n.filter(({ user: a }) => a.firstName || a.lastName).map((a) => ({
        text: B(a).displayName(),
        value: a.user.id,
        image: a.user.avatar || Ho,
        description: B(a).userDepartment()
      })), this.loading = !1;
    }
  }
});
const zo = "/img/profile-placeholder.svg";
f({
  props: {
    value: {
      type: Array,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    filter: {
      type: Object,
      required: !1
    },
    excludeUserIds: {
      type: Array,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      required: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      loading: !1,
      options: [],
      optionsPool: [],
      selection: []
    };
  },
  async created() {
    if (this.value.length > 0) {
      this.loading = !0;
      const e = await this.$gateway.portal.findUsersById(this.value);
      this.optionsPool = e.map((t) => ({
        text: B(t).displayName(),
        value: t.user.id,
        image: t.user.avatar || zo,
        description: B(t).userDepartment()
      })), this.selection = [...this.value], this.loading = !1;
    }
  },
  methods: {
    onUpdate(e) {
      this.$emit("input", e);
    },
    onToggleOpen(e) {
      e || (this.options = [], this.$emit("blur"));
    },
    async onSearchDebounced(e) {
      var t, i, r;
      if (e.length < 3) {
        this.options = [];
        return;
      }
      this.loading = !0;
      const s = (await this.$gateway.search.searchUserIds({
        query: e,
        context: (t = this.filter) == null ? void 0 : t.context,
        filter: {
          teams: (i = this.filter) == null ? void 0 : i.teamIds,
          topics: (r = this.filter) == null ? void 0 : r.topicIds
        }
      })).filter(
        (a) => {
          var o;
          return !((o = this.excludeUserIds) != null && o.includes(a));
        }
      ), n = await this.$gateway.portal.findUsersById(s);
      this.options = n.filter(({ user: a }) => a.firstName || a.lastName).map((a) => ({
        text: B(a).displayName(),
        value: a.user.id,
        image: a.user.avatar || zo,
        description: B(a).userDepartment()
      })), this.loading = !1;
    }
  }
});
const $x = f({
  components: { AppTextInput: Vk },
  props: {
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      selectedTicket: "",
      title: "",
      description: ""
    };
  },
  methods: {
    async executeBulkAction() {
      try {
        return this.loading = !0, (await this.$api.ticket.bulkInspirePeople(
          this.productId,
          {
            campaignCanonicalId: this.selectedTicket,
            ticketSuggestion: {
              title: this.title,
              description: this.description
            },
            audience: this.selection
          }
        )).id;
      } catch (e) {
        console.error("Could not execute bulk action", e);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const e = await this.executeBulkAction();
      this.$emit("confirm", e);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var eC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { attrs: { loading: e.loading } }, [t("div", { staticClass: "modal-content" }, [t("div", { staticClass: "modal-title" }, [t("fa-icon-compat", { staticClass: "ai-icon", attrs: { icon: "fa-solid fa-sparkles" } }), e._v(" " + e._s(e.$t("bulkActions.actions.inspireUsers")) + " ")], 1), t("app-text-input", { attrs: { label: e.$t("bulkActions.inspireUsersModal.title"), placeholder: e.$t("bulkActions.inspireUsersModal.titlePlaceholder") }, model: { value: e.title, callback: function(i) {
    e.title = i;
  }, expression: "title" } }), t("app-text-area", { attrs: { label: e.$t("bulkActions.inspireUsersModal.description"), placeholder: e.$t("bulkActions.inspireUsersModal.descriptionPlaceholder") }, model: { value: e.description, callback: function(i) {
    e.description = i;
  }, expression: "description" } }), t("ticket-dropdown", { attrs: { context: e.contextId, label: e.$t("bulkActions.inspireUsersModal.campaign"), "product-id": e.productId, products: ["campaign"], placeholder: e.$t("bulkActions.setCampaignModal.placeholder"), required: !0 }, model: { value: e.selectedTicket, callback: function(i) {
    e.selectedTicket = i;
  }, expression: "selectedTicket" } }), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [t("app-button", { attrs: { label: e.$t("common.form.confirm"), enabled: !!e.selectedTicket }, on: { click: e.onConfirm } }), t("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } })], 1)], 1)]);
}, tC = [], iC = /* @__PURE__ */ x(
  $x,
  eC,
  tC,
  !1,
  null,
  "33e5f1aa"
);
const rC = iC.exports, sC = f({
  props: {
    selection: {
      type: Array,
      required: !0
    },
    action: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      allRoles: [],
      selectedRoles: []
    };
  },
  async created() {
    await this.fetchAvailableRoles();
  },
  computed: {
    title() {
      const e = this.action === "ADD" ? "addUserRoles" : "removeUserRoles";
      return this.$t(`bulkActions.actions.${e}`).toString();
    },
    roleOptions() {
      return this.allRoles.map((e) => {
        var t;
        return {
          description: `${((t = e == null ? void 0 : e.roleActions) == null ? void 0 : t.length) || 0} actions`,
          text: e.name,
          value: e.name
        };
      });
    }
  },
  methods: {
    async fetchAvailableRoles() {
      this.loading = !0;
      try {
        this.allRoles = await this.$api.role.adminFetchAllRoles();
      } catch (e) {
        console.warn(e), this.$toast(this.$t("error.general").toString());
      } finally {
        this.loading = !1;
      }
    },
    async executeBulkAction() {
      try {
        return this.loading = !0, (await this.$api.users.bulkUpdateUserRoles(
          this.selectedRoles,
          this.selection,
          this.action
        )).id;
      } catch (e) {
        console.error("Could not execute bulk action", e);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const e = await this.executeBulkAction();
      this.$emit("confirm", e);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var nC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { attrs: { loading: e.loading } }, [t("div", { staticClass: "modal-content" }, [t("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.title) + " ")]), t("app-multiselect", { attrs: { label: e.$t("form.roles.label"), options: e.roleOptions, placeholder: e.$t("form.roles.placeholder"), "search-enabled": !0, "search-label": e.$t("common.form.search") }, model: { value: e.selectedRoles, callback: function(i) {
    e.selectedRoles = i;
  }, expression: "selectedRoles" } }), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [t("app-button", { attrs: { label: e.$t("common.form.confirm"), enabled: !!e.selectedRoles.length }, on: { click: e.onConfirm } }), t("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } })], 1)], 1)]);
}, aC = [], oC = /* @__PURE__ */ x(
  sC,
  nC,
  aC,
  !1,
  null,
  "03b3c219"
);
const lC = oC.exports, cC = f({
  props: {
    selection: {
      type: Array,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      teamConfiguration: {
        class: "team",
        types: ["ORGANIZATIONAL_TEAM", "VIRTUAL_TEAM", "WORKGROUP"],
        operations: ["select"]
      },
      teamIds: []
    };
  },
  methods: {
    async executeBulkAction() {
      try {
        return this.loading = !0, (await this.$api.team.bulkAddUserToTeam(
          this.teamIds[0],
          this.selection
        )).id;
      } catch (e) {
        console.error("Could not execute bulk action", e);
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onConfirm() {
      const e = await this.executeBulkAction();
      this.$emit("confirm", e);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
});
var uC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-modal", { attrs: { loading: e.loading } }, [t("div", { staticClass: "modal-content" }, [t("div", { staticClass: "modal-title" }, [e._v(" " + e._s(e.$t("bulkActions.actions.addUserToTeam")) + " ")]), t("team-selector", { attrs: { configuration: e.teamConfiguration, organization: e.organization, label: e.$t("form.selectTeam.label"), placeholder: e.$t("form.selectTeam.placeholder"), required: !0 }, model: { value: e.teamIds, callback: function(i) {
    e.teamIds = i;
  }, expression: "teamIds" } }), t("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "center" } }, [t("app-button", { attrs: { label: e.$t("common.form.confirm"), enabled: !!e.teamIds.length }, on: { click: e.onConfirm } }), t("app-secondary-button", { attrs: { label: e.$t("common.form.cancel") }, on: { click: e.onCancel } })], 1)], 1)]);
}, dC = [], hC = /* @__PURE__ */ x(
  cC,
  uC,
  dC,
  !1,
  null,
  "74edfb72"
);
const pC = hC.exports;
f({
  components: {
    BulkModalManageUserRoles: lC,
    BulkModalAddUserToTeam: pC,
    BulkModalInspireUsers: rC,
    BulkModalExportData: Bc,
    BulkModalResults: Mc
  },
  props: {
    value: {
      type: String,
      required: !1
    },
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    selection: {
      type: Array,
      required: !0
    }
  },
  watch: {
    value(e) {
      this.bulkAction = e;
    }
  },
  data() {
    return {
      bulkAction: void 0,
      bulkId: void 0
    };
  },
  created() {
    this.bulkAction = this.value;
  },
  methods: {
    componentType(e) {
      switch (e) {
        case "exportData":
          return "bulk-modal-export-data";
        case "inspireUsers":
          return "bulk-modal-inspire-users";
        case "addUserRoles":
        case "removeUserRoles":
          return "bulk-modal-manage-user-roles";
        case "addUserToTeam":
          return "bulk-modal-add-user-to-team";
        default:
          return "";
      }
    },
    getActionType(e) {
      switch (e) {
        case "addUserRoles":
          return "ADD";
        case "removeUserRoles":
          return "REMOVE";
        default:
          return;
      }
    },
    onConfirm(e) {
      this.bulkId = e, this.bulkAction = void 0;
    },
    onCancel() {
      this.bulkId = void 0, this.bulkAction = void 0, this.$emit("input", void 0);
    }
  }
});
f({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      selected: ""
    };
  },
  computed: {
    filteredOptions() {
      return this.options.filter(({ availabilityCheck: e }) => e !== !1).filter(
        ({ requiredAction: e }) => !e || this.checkPermission(e)
      ).map(({ option: e }) => e);
    },
    options() {
      return [
        {
          requiredAction: "ADMIN_EXPORT_USERS",
          option: {
            value: "exportData",
            text: this.$t("bulkActions.actions.exportData").toString()
          }
        },
        {
          requiredAction: "ADMIN_BULK_USER_ROLES_UPDATE",
          option: {
            value: "addUserRoles",
            text: this.$t("bulkActions.actions.addUserRoles").toString()
          }
        },
        {
          requiredAction: "ADMIN_BULK_USER_ROLES_UPDATE",
          option: {
            value: "removeUserRoles",
            text: this.$t("bulkActions.actions.removeUserRoles").toString()
          }
        },
        {
          requiredAction: "ADMIN_BULK_USER_TEAM_UPDATE",
          option: {
            value: "addUserToTeam",
            text: this.$t("bulkActions.actions.addUserToTeam").toString()
          }
        },
        {
          requiredAction: "USER_AI_GENERATION",
          availabilityCheck: this.enableInspirePeople,
          option: {
            value: "inspireUsers",
            text: this.$t("bulkActions.actions.inspireUsers").toString()
          }
        }
      ];
    },
    enableInspirePeople() {
      var e;
      return !!(this.organization.productCustomization[this.productId].enableAiContentGeneration && (e = this.organization.settings) != null && e.inspirePeople);
    }
  },
  methods: {
    checkPermission(e) {
      const t = `${this.productId.toUpperCase()}_${e}`;
      return this.userActions.checkPermission([t, e]);
    },
    onUpdateSingle(e) {
      e && this.$emit("select-action", e), pt(() => {
        this.selected = "";
      });
    }
  }
});
f({
  name: "ModalLauncher",
  props: {
    type: {
      type: String,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    userId: {
      type: String,
      required: !0
    }
  },
  computed: {
    modalType() {
      switch (this.type) {
        case "multi-question":
          return "MultiQuestionModal";
        case "rating":
        case "review":
          return "ReviewModal";
      }
      return "BasicModal";
    }
  },
  methods: {
    closeModal() {
      this.$modalClose();
    }
  }
});
f({
  components: { AppMarkdownText: je },
  props: {
    notification: {
      type: Object,
      required: !0
    }
  },
  computed: {
    notificationResource() {
      const e = JSON.parse(this.notification.body);
      return this.$res(e);
    },
    isUnread() {
      return !this.notification.readAt;
    },
    image() {
      return this.notificationResource.imageUrl ?? "/img/comment-notification-icon.svg";
    },
    type() {
      return this.notification.contentType ?? "";
    },
    title() {
      return this.notificationResource.title ?? "";
    },
    description() {
      return this.notificationResource.text ?? "";
    },
    date() {
      return new Date(this.notification.createdAt).toLocaleDateString();
    }
  },
  methods: {
    onDelete() {
      this.$emit("delete", this.notification);
    }
  }
});
const fC = f({
  name: "MultipleChoiceInput",
  components: { AppMarkdownText: je },
  props: {
    value: {
      type: [Array, String, Number],
      default: () => []
    },
    selectionType: {
      type: String,
      default: "single"
    },
    layout: {
      type: String,
      default: "vertical"
    },
    columns: {
      type: Number,
      default: 2
    },
    options: {
      type: Array,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  watch: {
    value: {
      handler() {
        this.selectionType === "single" ? this.singleAnswer = this.value[0] : this.answer = this.value;
      },
      immediate: !0
    }
  },
  data() {
    return {
      answer: [],
      singleAnswer: ""
    };
  },
  computed: {
    alignment() {
      return this.layout === "horizontal" ? "row" : "column";
    }
  },
  methods: {
    updateValue(e) {
      this.answer = Array.isArray(e) ? e : [e], this.$emit("input", this.answer);
    }
  }
});
var mC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "multiple-choice-input" }, [t("div", { staticClass: "title" }, [e._v(" " + e._s(e.label) + " ")]), e.description ? t("app-markdown-text", { staticClass: "description", attrs: { text: e.description } }) : e._e(), t("div", { staticClass: "multiple-choice", class: e.alignment }, [e.selectionType === "multiple" ? t("app-checkbox-group", { attrs: { alignment: e.alignment, error: e.error, options: e.options }, on: { input: e.updateValue }, model: { value: e.answer, callback: function(i) {
    e.answer = i;
  }, expression: "answer" } }) : t("app-radio-buttons", { attrs: { alignment: e.alignment, error: e.error, options: e.options }, on: { input: e.updateValue }, model: { value: e.singleAnswer, callback: function(i) {
    e.singleAnswer = i;
  }, expression: "singleAnswer" } })], 1)], 1);
}, gC = [], yC = /* @__PURE__ */ x(
  fC,
  mC,
  gC,
  !1,
  null,
  "b81d8c53"
);
const bC = yC.exports, vC = f({
  components: {
    AppMarkdownText: je,
    AppLabelValue: wc
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    values: {
      type: Array,
      default: () => []
    },
    valueImageUrl: {
      type: String,
      default: "/img/star.svg"
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  watch: {
    value: {
      handler() {
        this.hoverRating = this.value, this.rating = this.value;
      },
      immediate: !0
    }
  },
  data() {
    return {
      rating: 0,
      hoverRating: 0
    };
  },
  computed: {
    totalRatings() {
      return this.values.length;
    }
  },
  methods: {
    setRating(e) {
      this.rating = e, this.$emit("input", this.rating);
    }
  }
});
var AC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [t("base-input-label", { staticClass: "label", attrs: { error: e.error, label: e.label } }), e.description ? t("app-markdown-text", { staticClass: "description", attrs: { text: e.description } }) : e._e(), e.error ? t("div", { staticClass: "rating-error" }, [e._v(" " + e._s(e.$t("error.voteIsRequired")) + " ")]) : e._e(), t("div", { staticClass: "review-rating" }, e._l(e.totalRatings, function(i) {
    return t("img", { key: i, staticClass: "rating-img", class: { selected: i <= e.hoverRating }, attrs: { src: e.valueImageUrl }, on: { click: function(r) {
      return e.setRating(i);
    }, mouseenter: function(r) {
      e.hoverRating = i;
    }, mouseleave: function(r) {
      e.hoverRating = e.rating;
    } } });
  }), 0)], 1);
}, kC = [], wC = /* @__PURE__ */ x(
  vC,
  AC,
  kC,
  !1,
  null,
  "2ced4e4e"
);
const Rc = wC.exports, xC = f({
  components: { AppMarkdownText: je },
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  watch: {
    value: {
      handler() {
        this.answer = this.value;
      },
      immediate: !0
    }
  },
  data() {
    return {
      answer: ""
    };
  }
});
var CC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "text-input" }, [t("div", { staticClass: "title" }, [e._v(" " + e._s(e.label) + " ")]), e.description ? t("app-markdown-text", { staticClass: "description", attrs: { text: e.description } }) : e._e(), t("app-text-area", { attrs: { error: e.error, placeholder: e.$t("common.enterYourReply"), required: !0, rows: 6 }, on: { input: () => e.$emit("input", e.answer) }, model: { value: e.answer, callback: function(i) {
    e.answer = i;
  }, expression: "answer" } })], 1);
}, SC = [], IC = /* @__PURE__ */ x(
  xC,
  CC,
  SC,
  !1,
  null,
  "85da021c"
);
const DC = IC.exports, PC = f({
  name: "QuestionWizard",
  props: {
    steps: {
      type: Array,
      required: !0
    },
    validation: {
      type: Function,
      default: () => (console.warn("No validation function provided"), !0)
    }
  },
  data() {
    return {
      currentStep: 0
    };
  },
  computed: {
    item() {
      return this.steps[this.currentStep];
    },
    isLastStep() {
      return this.currentStep === this.steps.length - 1;
    },
    isFirstStep() {
      return this.currentStep === 0;
    },
    nextButtonLabel() {
      const e = this.isLastStep ? "finish" : "continue";
      return this.$t(`common.${e}`).toString();
    }
  },
  methods: {
    nextStep() {
      this.validation(this.currentStep + 1) && !this.isLastStep ? this.currentStep++ : this.validation(this.currentStep + 1) && this.$emit("finish");
    },
    previousStep() {
      this.currentStep > 0 && this.currentStep--;
    }
  }
});
var TC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "question-wizard" }, [t("div", { staticClass: "steps" }, e._l(e.steps, function(i, r) {
    return t("div", { key: r, staticClass: "step", class: {
      active: r === e.currentStep,
      done: r <= e.currentStep
    } }, [t("span", { staticClass: "current-step" }, [e._v(e._s(r + 1))])]);
  }), 0), t("div", { staticClass: "content" }, [e._t("default", null, { item: e.item })], 2), t("div", { staticClass: "button-container", class: { "justify-end": e.isFirstStep } }, [e.isFirstStep ? e._e() : t("app-icon-button", { staticClass: "back-button", attrs: { size: 48, frame: "square" }, on: { click: e.previousStep } }, [t("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-chevron-left" } })], 1), t("app-button", { class: { "justify-end": e.isFirstStep }, attrs: { label: e.nextButtonLabel }, on: { click: e.nextStep } })], 1)]);
}, OC = [], BC = /* @__PURE__ */ x(
  PC,
  TC,
  OC,
  !1,
  null,
  "f0605691"
);
const MC = BC.exports, RC = f({
  components: { AppMarkdownText: je },
  props: {
    resource: {
      type: Object,
      required: !0
    },
    buttonAction: {
      type: Function,
      required: !1
    },
    centerContent: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    buttonComponent() {
      var e;
      return ((e = this.resource.button) == null ? void 0 : e.style) === "secondary" ? "app-secondary-button" : "app-button";
    },
    buttonLabel() {
      var e;
      return ((e = this.resource.button) == null ? void 0 : e.label) ?? "";
    },
    imageSrc() {
      return this.resource.modalImageUrl ?? "";
    },
    title() {
      return this.resource.modalTitle ?? this.resource.title;
    },
    tagline() {
      return this.resource.tagline ?? "";
    },
    description() {
      return this.resource.description ?? this.resource.text ?? "";
    }
  },
  methods: {
    buttonPressed() {
      var e, t, i;
      this.buttonAction ? this.buttonAction() : ((t = (e = this.resource.button) == null ? void 0 : e.action) != null && t.fetch && this.apiCall(this.resource.button.action.fetch), (i = this.resource.button) != null && i.url && window.open(this.resource.button.url, "_blank"), this.$emit("close"));
    },
    apiCall({ url: e, method: t, body: i }) {
      fetch(e, {
        method: t,
        body: i
      });
    }
  }
});
var EC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "basic-content", class: { centerContent: e.centerContent } }, [e.resource.modalType ? t("app-markdown-text", { staticClass: "basic-type", attrs: { text: e.resource.modalType } }) : e._e(), e.imageSrc ? t("img", { staticClass: "basic-image", attrs: { src: e.imageSrc } }) : e._e(), t("div", [t("div", { staticClass: "basic-title", attrs: { title: e.title } }, [e._v(" " + e._s(e.title) + " ")]), e.tagline ? t("div", { staticClass: "basic-subtitle", attrs: { title: e.tagline } }, [e._v(" " + e._s(e.tagline) + " ")]) : e._e()]), t("app-markdown-text", { staticClass: "basic-description", attrs: { text: e.description } }), e._t("default"), e.buttonLabel ? t("div", { staticClass: "button-container", class: { centerContent: e.centerContent } }, [t(e.buttonComponent, { tag: "component", staticClass: "basic-button", attrs: { label: e.buttonLabel }, on: { click: e.buttonPressed } })], 1) : e._e(), e.resource.link ? t("app-link", { staticClass: "link", attrs: { "external-path": e.resource.link.url, label: e.resource.link.label, target: "_blank" } }) : e._e()], 2);
}, LC = [], FC = /* @__PURE__ */ x(
  RC,
  EC,
  LC,
  !1,
  null,
  "585e63f3"
);
const Ec = FC.exports;
f({
  components: {
    TextInput: DC,
    RatingInput: Rc,
    MultipleChoiceInput: bC,
    TicketBreadcrumb: Sk,
    QuestionWizard: MC,
    BasicContent: Ec
  },
  props: {
    resource: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    userId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      answers: {},
      errors: {},
      loading: !1,
      showQuestions: !1,
      showIntro: !0,
      ticket: null
    };
  },
  async created() {
    this.resource.ticketId && (this.ticket = await this.$datasource.ticket.find(
      this.productId,
      this.resource.ticketId
    ), this.setInitialAnswers());
  },
  computed: {
    questionsWithIndexes() {
      var e;
      return (e = this.resource.questions) == null ? void 0 : e.map((t) => {
        var i;
        const r = (i = t.options) == null ? void 0 : i.map(
          (s, n) => ({
            ...s,
            value: n,
            actualValue: s.value
          })
        );
        return {
          ...t,
          options: r
        };
      });
    },
    modalResource() {
      return {
        ...this.resource,
        button: { label: this.$t("common.start").toString() }
      };
    }
  },
  methods: {
    setInitialAnswers() {
      var e;
      this.answers = (e = this.resource.questions) == null ? void 0 : e.reduce(
        (t, { id: i, options: r, type: s }) => {
          var n, a, o;
          const l = (o = (a = (n = this.ticket) == null ? void 0 : n.userFields) == null ? void 0 : a[i]) == null ? void 0 : o[this.userId], c = (l == null ? void 0 : l.contentIndexes) ?? (r == null ? void 0 : r.findIndex(
            ({ value: u }) => u == (l == null ? void 0 : l.content)
          )) ?? -1;
          return c === -1 ? t[i] = l == null ? void 0 : l.content : t[i] = Array.isArray(c) ? c : [c], t;
        },
        this.answers
      );
    },
    prepareAnswerPayload(e) {
      var t;
      return (t = this.resource.questions) == null ? void 0 : t.reduce(
        (i, { id: r, options: s, type: n }) => {
          if (n === "multiple-choice") {
            if (e[r] !== void 0) {
              const a = e[r].map(
                (l) => Number(l)
              );
              i.contentIndexes[r] = a;
              const o = Object.values(s);
              i.content[r] = a.map(
                (l) => o[l].value
              );
            }
          } else
            i.content[r] = e[r];
          return i;
        },
        { content: {}, contentIndexes: {} }
      );
    },
    startQuestions() {
      this.showIntro = !1, this.showQuestions = !0;
    },
    questionComponent(e) {
      switch (e) {
        case "rating":
          return "rating-input";
        case "multiple-choice":
          return "multiple-choice-input";
        case "text":
          return "text-input";
        default:
          return "text-input";
      }
    },
    isValid(e) {
      let t = !1;
      const i = {};
      return this.resource.questions.slice(0, e ?? this.resource.questions.length).forEach(({ id: r, required: s }) => {
        i[r] = !this.answers[r] && // Required is true by default
        s !== !1, t = t || i[r];
      }), this.$set(this, "errors", i), !t;
    },
    async saveAnswers() {
      var e, t;
      if (!this.isValid(2))
        return;
      this.showQuestions = !1, (t = (e = this.resource.button) == null ? void 0 : e.action) != null && t.fetch && await this.apiCall(this.resource.button.action.fetch);
      const i = this.resource.response;
      i ? this.$modal("basic", i) : this.onClose();
    },
    async apiCall({ url: e, method: t }) {
      var i, r, s, n, a, o;
      try {
        this.loading = !0;
        const l = this.prepareAnswerPayload(this.answers), c = {
          group: (i = this.resource) == null ? void 0 : i.group,
          audience: (r = this.resource) == null ? void 0 : r.audience
        };
        await this.$api.dynamicFields.callCustomUrl(
          e,
          t,
          l,
          c
        ), this.$datasource.ticket.clearCache([
          (s = this.ticket) == null ? void 0 : s.canonicalId,
          (n = this.ticket) == null ? void 0 : n.parent
        ]), this.$datasource.firstCitizen.clearCache([(a = this.ticket) == null ? void 0 : a.parent]), this.$datasource.adminFirstCitizen.clearCache([(o = this.ticket) == null ? void 0 : o.parent]);
      } catch (l) {
        this.$sentry.captureException(l), l.message ? this.$toast(l.message) : this.$toast(this.$t("error.general").toString());
      } finally {
        this.loading = !1;
      }
    },
    onClose() {
      this.$emit("close");
    }
  }
});
f({
  components: { RatingInput: Rc },
  props: {
    resource: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      rating: 0,
      loading: !1,
      showRatingError: !1
    };
  },
  computed: {
    allRatings() {
      return this.resource.options.map((e) => e.values).flat();
    },
    ratingImg() {
      return this.resource.options[0].valueImageUrl;
    }
  },
  methods: {
    async saveRating() {
      var e, t;
      if (this.rating === 0) {
        this.showRatingError = !0;
        return;
      }
      this.showRatingError = !1, (t = (e = this.resource.button) == null ? void 0 : e.action) != null && t.fetch && await this.apiCall(this.resource.button.action.fetch);
      const i = this.findRatingModal(this.resource);
      i ? this.$modal("basic", i) : this.onClose();
    },
    findRatingModal(e) {
      const t = this.rating - 1, i = e.options.find(({ values: r }) => r.includes(this.allRatings[t]));
      return i == null ? void 0 : i.response;
    },
    async apiCall({ url: e, method: t, body: i }) {
      var r;
      try {
        this.loading = !0;
        const s = (i == null ? void 0 : i.replace(/{{VALUE}}/g, this.rating.toString())) ?? "", n = JSON.parse(s), a = (r = this.resource) != null && r.group ? { group: this.resource.group } : {};
        await this.$api.dynamicFields.callCustomUrl(
          e,
          t,
          n,
          a
        ), this.loading = !1;
      } catch (s) {
        this.$sentry.captureException(s), s.message ? this.$toast(s.message) : this.$toast(this.$t("error.general").toString());
      } finally {
        this.loading = !1;
      }
    },
    onClose() {
      this.$emit("close");
    }
  }
});
f({
  components: {
    AppMarkdownText: je,
    BasicContent: Ec
  },
  props: {
    resource: {
      type: Object,
      required: !0
    },
    buttonAction: {
      type: Function,
      required: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    centerContent: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    onClose() {
      this.$router.replace({ query: { reload: "true" } }), this.$emit("close");
    }
  }
});
f({
  props: {
    offer: {
      type: Object,
      required: !0
    },
    workgroup: {
      type: Object,
      required: !0
    },
    showProvider: {
      type: Boolean,
      default: !0
    },
    showPrice: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    image() {
      return this.$res(this.offer.resources).image;
    },
    title() {
      return this.$res(this.offer.resources).title;
    },
    label() {
    },
    subtitle() {
      const e = Be(this.workgroup, this.$res).teamName();
      return this.$t("common.byName", { name: e }).toString();
    },
    price() {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        signDisplay: "auto",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.offer.price ?? 0);
    }
  }
});
f({
  props: {
    offer: {
      type: Object,
      required: !0
    },
    workgroup: {
      type: Object,
      required: !0
    },
    showProvider: {
      type: Boolean,
      default: !0
    },
    showPrice: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    image() {
      return this.$res(this.offer.resources).image;
    },
    title() {
      return this.$res(this.offer.resources).title;
    },
    label() {
      return this.$t("page.admin.services.highlightedOffer").toString();
    },
    subtitle() {
      const e = Be(this.workgroup, this.$res).teamName();
      return this.$t("common.byName", { name: e }).toString();
    },
    price() {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        signDisplay: "auto",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.offer.price ?? 0);
    }
  }
});
f({
  props: {
    offer: {
      type: Object,
      required: !0
    },
    workgroup: {
      type: Object,
      required: !0
    },
    buttonLabel: {
      type: String,
      required: !0
    }
  },
  computed: {
    offerResources() {
      return this.$res(this.offer.resources);
    },
    priceDisplay() {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        signDisplay: "auto",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.offer.price);
    },
    workgroupName() {
      return Be(this.workgroup, this.$res).teamName();
    }
  },
  methods: {
    onClickPurchase() {
      this.$emit("click:purchase", this.offer.id);
    }
  }
});
const jC = f({
  props: {
    enabled: {
      type: Boolean,
      default: !0
    },
    selectionStatus: {
      type: String,
      default: "no"
    }
  },
  computed: {
    disabled() {
      return !this.enabled;
    },
    checked() {
      return this.selectionStatus !== "no";
    },
    mark() {
      return this.selectionStatus === "partial" ? "partial" : "full";
    }
  },
  methods: {
    onClick(e) {
      this.$emit("click", e);
    }
  }
});
var UC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("button", { staticClass: "data-control-checkbox", attrs: { disabled: e.disabled }, on: { click: e.onClick } }, [t("base-checkmark", { attrs: { enabled: e.enabled, checked: e.checked, mark: e.mark } })], 1);
}, qC = [], HC = /* @__PURE__ */ x(
  jC,
  UC,
  qC,
  !1,
  null,
  "77e5b11d"
);
const Mi = HC.exports, zC = f({
  components: {
    DataControlCheckbox: Mi
  },
  props: {
    selection: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { data: t, selection: i } = Mt(e), { selectionStatus: r, countFound: s, countSelected: n } = Or(
      t,
      i
    );
    return { selectionStatus: r, countFound: s, countSelected: n };
  },
  computed: {
    buttonSelectAll() {
      return this.config.mode === "multiple" && this.config.selectAllButton;
    },
    foundLabel() {
      return this.$tc("common.resultsFound", this.countFound, {
        countFound: this.countFound
      }).toString();
    },
    selectionLabel() {
      return this.$t("common.resultsSelected", {
        countSelected: this.countSelected,
        countFound: this.countFound
      }).toString();
    }
  },
  methods: {
    onToggleSelectAll() {
      this.$emit("select-all");
    }
  }
});
var NC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "data-control-summary" }, [e.buttonSelectAll ? t("data-control-checkbox", { attrs: { "selection-status": e.selectionStatus }, on: { click: e.onToggleSelectAll } }) : e._e(), e.selectionStatus === "no" ? t("div", [e._v(e._s(e.foundLabel))]) : t("div", [e._v(e._s(e.selectionLabel))])], 1);
}, VC = [], GC = /* @__PURE__ */ x(
  zC,
  NC,
  VC,
  !1,
  null,
  "54a8b129"
);
const dn = GC.exports, WC = f({
  components: {
    DataControlCheckbox: Mi
  },
  props: {
    selectionEnabled: {
      type: Boolean,
      required: !0
    },
    selectionStatus: {
      type: String,
      default: "no"
    },
    overflow: {
      type: String,
      default: "visible"
    }
  },
  computed: {
    cssStyle() {
      return {
        overflowX: this.overflow
      };
    }
  },
  methods: {
    onToggleCheckbox() {
      this.$emit("click:select");
    }
  }
});
var QC = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "data-item-container" }, [e.selectionEnabled ? t("data-control-checkbox", { staticClass: "data-control-checkbox", attrs: { "selection-status": e.selectionStatus }, on: { click: function(i) {
    return i.stopPropagation(), e.onToggleCheckbox.apply(null, arguments);
  } } }) : e._e(), t("div", { staticClass: "item-slot", style: e.cssStyle }, [e._t("default")], 2)], 1);
}, XC = [], KC = /* @__PURE__ */ x(
  WC,
  QC,
  XC,
  !1,
  null,
  "d3c3552c"
);
const YC = KC.exports, ZC = {
  summary: "simple",
  selection: {
    mode: "disabled",
    selectAllButton: !1
  },
  item: {
    minWidth: 300,
    maxWidth: void 0
  },
  display: {
    itemOverflow: "visible",
    itemDecoration: "disabled"
  }
}, JC = f({
  components: {
    DataControlSummary: dn,
    AppDataGridItem: YC
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      required: !1
    }
  },
  setup(e) {
    const { data: t, value: i } = Mt(e), { selection: r, selectionStatus: s, itemStatus: n, toggleAll: a, toggleItem: o } = Or(t.value, i.value);
    return { selection: r, selectionStatus: s, itemStatus: n, toggleAll: a, toggleItem: o };
  },
  computed: {
    innerConfig() {
      return { ...ZC, ...this.config };
    },
    summaryEnabled() {
      return this.innerConfig.summary === "simple";
    },
    appDataGridItemWastedSpace() {
      const e = this.selectionEnabled ? 22 : 0, t = this.selectionEnabled ? 12 : 0;
      return e + t;
    },
    gridStyle() {
      const e = this.innerConfig.item.minWidth, t = this.appDataGridItemWastedSpace;
      return {
        gridTemplateColumns: `repeat(auto-fill, minmax(${e + t}px, 1fr))`
      };
    },
    itemContainerStyle() {
      const e = this.innerConfig.item.maxWidth;
      return {
        maxWidth: e ? `${e}px` : void 0
      };
    },
    itemContainerCssClass() {
      return {
        panel: this.innerConfig.display.itemDecoration === "shadow"
      };
    },
    hasPrependSlot() {
      return !!this.$slots.prepend;
    },
    selectionEnabled() {
      return this.innerConfig.selection.mode === "multiple";
    }
  },
  methods: {
    onToggleSelectAll() {
      this.toggleAll(), this.updateModel(), this.$emit("click:all");
    },
    onToggleCheckbox(e) {
      this.toggleItem(e), this.updateModel(), this.$emit("click:select", e);
    },
    updateModel() {
      this.$emit("input", [...this.selection]);
    }
  }
});
var _C = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-data-grid-container" }, [e.summaryEnabled ? t("data-control-summary", { staticClass: "data-control-summary", attrs: { selection: e.selection, data: e.data, config: e.innerConfig.selection }, on: { "select-all": e.onToggleSelectAll } }) : e._e(), t("div", { staticClass: "app-data-grid", style: e.gridStyle }, [e.hasPrependSlot ? t("div", { staticClass: "item-container slot-prepend" }, [t("app-data-grid-item", { style: e.itemContainerStyle, attrs: { "selection-enabled": !1 } }, [e._t("prepend")], 2)], 1) : e._e(), e._l(e.data, function(i) {
    return t("div", { key: i.id, staticClass: "item-container" }, [t("app-data-grid-item", { class: e.itemContainerCssClass, style: e.itemContainerStyle, attrs: { "selection-enabled": e.selectionEnabled, "selection-status": e.itemStatus(i.id), overflow: e.innerConfig.display.itemOverflow }, on: { "click:select": function(r) {
      return e.onToggleCheckbox(i.id);
    } } }, [e._t("default", null, { item: i })], 2)], 1);
  })], 2)], 1);
}, $C = [], eS = /* @__PURE__ */ x(
  JC,
  _C,
  $C,
  !1,
  null,
  "a8476b03"
);
const Lc = eS.exports;
f({
  components: {
    AppDataGrid: Lc
  },
  props: {
    offers: {
      type: Array,
      default: () => []
    },
    label: {
      type: String
    },
    showProvider: {
      type: Boolean,
      default: !0
    }
  },
  methods: {
    routeToOffer(e) {
      return {
        name: "ServiceDetails",
        params: {
          id: e.id
        }
      };
    }
  },
  computed: {
    gridConfig() {
      return { summary: "disabled", item: { minWidth: 231 } };
    }
  }
});
f({
  props: {
    workgroup: {
      type: Object,
      required: !1
    }
  },
  computed: {
    /**
     * @todo Use `useTeam`
     */
    workgroupResource() {
      var e;
      return this.$res(((e = this.workgroup) == null ? void 0 : e.resources) ?? {}) ?? {};
    }
  }
});
f({
  props: {
    value: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1
    },
    placeholder: {
      type: String,
      required: !0
    },
    tooltip: {
      type: String,
      required: !1
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    previewOptions: {
      type: Array,
      default: () => []
    },
    previewGroups: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    topicFilter: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      optionsPool: [],
      selection: "",
      query: "",
      searchOptions: []
    };
  },
  async created() {
    if (this.value)
      try {
        this.loading = !0;
        const e = await this.$datasource.topic.find(this.value);
        this.optionsPool = [
          {
            text: this.$res(e == null ? void 0 : e.resources).title,
            value: e.id
          }
        ], this.selection = this.value;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = !1;
      }
  },
  computed: {
    options() {
      return this.query ? this.searchOptions : this.previewOptions;
    },
    groups() {
      return this.query ? void 0 : this.previewGroups;
    }
  },
  methods: {
    onUpdate(e) {
      this.$emit("input", e);
    },
    onDirty() {
      this.loading = !!this.query;
    },
    onToggleOpen(e) {
      e || (this.query = "", this.$emit("blur"));
    },
    async onSearchDebounced(e) {
      if (!e.length) {
        this.searchOptions = [];
        return;
      }
      this.loading = !0;
      const t = await this.searchTopics(e);
      this.searchOptions = t.map((i) => ({
        text: this.$res(i == null ? void 0 : i.resources).title,
        value: i.id
      })), this.loading = !1;
    },
    async searchTopics(e) {
      const t = await this.$datasource.topic.filterByTags(
        this.topicFilter
      );
      if (e) {
        const i = e.toUpperCase();
        return t.filter((r) => {
          var s;
          return (s = this.$res(r == null ? void 0 : r.resources).title) == null ? void 0 : s.toUpperCase().includes(i);
        });
      } else
        return t;
    }
  }
});
f({
  name: "TopicMultiselect",
  props: {
    value: {
      type: Array,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    enabled: {
      type: Boolean,
      default: !0
    },
    required: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      loading: !1,
      optionsPool: [],
      options: [],
      selection: [],
      query: "",
      searchOptions: []
    };
  },
  async created() {
    if (this.value)
      try {
        this.loading = !0;
        const e = await this.$datasource.topic.list();
        this.optionsPool = e.map((t) => ({
          text: this.$res(t == null ? void 0 : t.resources).title,
          value: t.id
        })), this.options = this.optionsPool, this.selection = this.value;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = !1;
      }
  },
  methods: {
    onUpdate(e) {
      this.$emit("input", e);
    },
    onToggleOpen(e) {
      e || (this.query = "", this.$emit("blur"));
    },
    onSearchDebounced(e) {
      if (!e)
        this.options = this.optionsPool;
      else {
        const t = e.toUpperCase();
        this.options = this.optionsPool.filter(
          ({ text: i }) => i == null ? void 0 : i.toUpperCase().includes(t)
        );
      }
    }
  }
});
f({
  name: "TopicItem",
  props: {
    topic: {
      type: Object,
      required: !1
    }
  },
  computed: {
    color() {
      var e;
      return ((e = this.topic) == null ? void 0 : e.meta.color) ?? "";
    },
    title() {
      var e;
      return this.$res((e = this.topic) == null ? void 0 : e.resources).title;
    },
    description() {
      return this.$t("common.topic").toString();
    },
    initial() {
      return this.title ? this.title[0].toUpperCase() : "";
    }
  }
});
f({
  name: "TopicCard",
  props: {
    topic: {
      type: Object,
      required: !0
    },
    stats: {
      type: Object,
      required: !1
    }
  },
  computed: {
    resources() {
      return this.$res(this.topic.resources);
    },
    image() {
      var e;
      return ((e = this.resources) == null ? void 0 : e.imageUrl) ?? "";
    },
    appPillStyle() {
      return {
        backgroundColor: this.topic.meta.color ?? "#2b94fc",
        color: "#ffffff",
        border: "0"
      };
    },
    numberOfExperts() {
      var e;
      return ((e = this.stats) == null ? void 0 : e.numberOfExperts) ?? 0;
    },
    numberOfTickets() {
      var e, t;
      const i = (e = this.stats) == null ? void 0 : e.ticketStats;
      return this.stats && i ? i.total - (((t = i.byStatus) == null ? void 0 : t.ARCHIVED) || 0) : 0;
    }
  }
});
f({
  props: {
    stats: {
      type: Object,
      required: !0
    },
    activeStatuses: {
      type: Array,
      required: !0
    },
    ticketFaIcon: {
      type: String,
      required: !0
    }
  },
  computed: {
    faIcon() {
      return `fa-light ${this.ticketFaIcon}`;
    },
    memberCount() {
      return this.stats.numberOfExperts ?? 0;
    },
    ticketCount() {
      return this.activeStatuses.reduce(
        (e, t) => {
          var i;
          return e + (((i = this.stats.ticketStats) == null ? void 0 : i.byStatus[t]) ?? 0);
        },
        0
      );
    }
  }
});
f({
  name: "BadgeListItem",
  components: {
    AppItemCard: vc
  },
  props: {
    resources: {
      type: Object,
      required: !0
    }
  },
  computed: {
    resource() {
      return this.$res(this.resources);
    }
  }
});
f({
  name: "Badge",
  components: {
    AppMarkdownText: je
  },
  props: {
    resources: {
      type: Object,
      required: !0
    }
  },
  computed: {
    resource() {
      return this.$res(this.resources);
    },
    showButton() {
      var e;
      return !!((e = this.resource.button) != null && e.href);
    },
    showLink() {
      var e;
      return !!((e = this.resource.link) != null && e.href);
    }
  },
  methods: {
    doButtonAction() {
      const e = this.resource.button.href;
      window.open(e, "_blank");
    }
  }
});
De.util.warn;
function Fc(e) {
  return Jc() ? (_c(e), !0) : !1;
}
function hn(e) {
  return typeof e == "function" ? e() : Nt(e);
}
const tS = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const iS = Object.prototype.toString, rS = (e) => iS.call(e) === "[object Object]", sS = () => {
};
function nS(e) {
  return Hs();
}
function aS(e, t = !0, i) {
  nS() ? zs(e, i) : t ? e() : pt(e);
}
const pn = tS ? window : void 0;
function oS(e) {
  var t;
  const i = hn(e);
  return (t = i == null ? void 0 : i.$el) != null ? t : i;
}
function lS(...e) {
  let t, i, r, s;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([i, r, s] = e, t = pn) : [t, i, r, s] = e, !t)
    return sS;
  Array.isArray(i) || (i = [i]), Array.isArray(r) || (r = [r]);
  const n = [], a = () => {
    n.forEach((u) => u()), n.length = 0;
  }, o = (u, d, h, p) => (u.addEventListener(d, h, p), () => u.removeEventListener(d, h, p)), l = rt(
    () => [oS(t), hn(s)],
    ([u, d]) => {
      if (a(), !u)
        return;
      const h = rS(d) ? { ...d } : d;
      n.push(
        ...i.flatMap((p) => r.map((m) => o(u, p, m, h)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), a();
  };
  return Fc(c), c;
}
function cS() {
  const e = N(!1);
  return Hs() && zs(() => {
    e.value = !0;
  }, void 0), e;
}
function uS(e) {
  const t = cS();
  return Q(() => (t.value, !!e()));
}
function dS(e, t = {}) {
  const { window: i = pn } = t, r = uS(() => i && "matchMedia" in i && typeof i.matchMedia == "function");
  let s;
  const n = N(!1), a = (c) => {
    n.value = c.matches;
  }, o = () => {
    s && ("removeEventListener" in s ? s.removeEventListener("change", a) : s.removeListener(a));
  }, l = Zc(() => {
    r.value && (o(), s = i.matchMedia(hn(e)), "addEventListener" in s ? s.addEventListener("change", a) : s.addListener(a), n.value = s.matches);
  });
  return Fc(() => {
    l(), o(), s = void 0;
  }), n;
}
function hS(e = {}) {
  const {
    window: t = pn,
    initialWidth: i = Number.POSITIVE_INFINITY,
    initialHeight: r = Number.POSITIVE_INFINITY,
    listenOrientation: s = !0,
    includeScrollbar: n = !0,
    type: a = "inner"
  } = e, o = N(i), l = N(r), c = () => {
    t && (a === "outer" ? (o.value = t.outerWidth, l.value = t.outerHeight) : n ? (o.value = t.innerWidth, l.value = t.innerHeight) : (o.value = t.document.documentElement.clientWidth, l.value = t.document.documentElement.clientHeight));
  };
  if (c(), aS(c), lS("resize", c, { passive: !0 }), s) {
    const u = dS("(orientation: portrait)");
    rt(u, () => c());
  }
  return { width: o, height: l };
}
f({
  props: {
    maxWidth: {
      type: Number,
      required: !1
    },
    collapseWidth: {
      type: Number,
      default: 920
    }
  },
  data() {
    return {
      windowWidth: 0
    };
  },
  created() {
    pt(() => {
      const { width: e } = hS();
      this.windowWidth = e.value, rt(e, (t) => {
        this.windowWidth = t;
      });
    });
  },
  computed: {
    headerContentStyle() {
      return {
        width: this.maxWidth ? `${this.maxWidth}px` : "100%"
      };
    },
    collapsed() {
      return this.windowWidth <= this.collapseWidth;
    },
    hasSlotStart() {
      return !!this.$slots["header-start"] || !!this.$scopedSlots["header-start"];
    },
    hasSlotMain() {
      return !!this.$slots["header-main"] || !!this.$scopedSlots["header-main"];
    },
    hasSlotEnd() {
      return !!this.$slots["header-end"] || !!this.$scopedSlots["header-end"];
    }
  },
  methods: {}
});
const pS = f({
  props: {
    label: {
      type: String,
      required: !0
    },
    routeName: {
      type: String,
      required: !0
    }
  },
  computed: {
    location() {
      return {
        name: this.routeName
      };
    }
  }
});
var fS = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("router-link", { staticClass: "header-navigation-link", attrs: { to: e.location } }, [e._v(" " + e._s(e.label) + " ")]);
}, mS = [], gS = /* @__PURE__ */ x(
  pS,
  fS,
  mS,
  !1,
  null,
  "e8b40ce5"
);
const yS = gS.exports;
f({
  components: {
    HeaderNavigationLink: yS
  },
  props: {
    options: {
      type: Array,
      required: !0
    }
  }
});
const bS = f({
  props: {
    productLogo: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    productTitle: {
      type: String,
      required: !0
    },
    productTagline: {
      type: String,
      required: !1
    },
    selected: {
      type: Boolean,
      required: !0
    }
  },
  data() {
    return {
      optionsVisible: !1
    };
  }
});
var vS = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "header-product-link" }, [t("div", { staticClass: "product-link-content" }, [t("img", { staticClass: "product-image", attrs: { src: e.productLogo } }), e.productTagline ? t("div", { staticClass: "product-tagline" }, [e._v(" " + e._s(e.productTagline) + " ")]) : e._e()]), e.selected ? t("fa-icon-compat", { staticClass: "selection-indicator", attrs: { icon: "fa-solid fa-check" } }) : e._e()], 1);
}, AS = [], kS = /* @__PURE__ */ x(
  bS,
  vS,
  AS,
  !1,
  null,
  "2933c44b"
);
const wS = kS.exports, xS = f({
  components: {
    HeaderProductLink: wS
  },
  props: {
    productId: {
      type: String,
      required: !1
    },
    productList: {
      type: Array,
      required: !0
    },
    portalSwitchLabel: {
      type: String,
      required: !1
    },
    portalSwitchUrl: {
      type: String,
      required: !1
    },
    companySwitchLabel: {
      type: String,
      required: !1
    },
    companySwitchUrl: {
      type: String,
      required: !1
    },
    homeRouteName: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      optionsVisible: !1
    };
  },
  computed: {
    portalSwitcherVisible() {
      return !!this.portalSwitchLabel && !!this.portalSwitchUrl;
    },
    companySwitcherVisible() {
      return !!this.companySwitchLabel && !!this.companySwitchUrl;
    }
  },
  methods: {
    routeTo(e) {
      return {
        name: this.homeRouteName,
        params: {
          product: e.productId
        }
      };
    }
  }
});
var CS = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "header-selector-floating" }, [e.portalSwitcherVisible ? t("div", { staticClass: "portal-switch" }, [t("span", { staticClass: "portal-switch-label" }, [e._v(" " + e._s(e.$t("structure.header.labelSwitchTo")) + " ")]), t("a", { staticClass: "portal-switch-link", attrs: { href: e.portalSwitchUrl } }, [t("span", [e._v(e._s(e.portalSwitchLabel))]), t("fa-icon-compat", { attrs: { icon: "fa-regular fa-arrow-up-right-from-square" } })], 1)]) : e._e(), e._l(e.productList, function(i, r) {
    return t("router-link", { key: r, attrs: { to: e.routeTo(i) } }, [t("header-product-link", { attrs: { "product-id": i.productId, "product-logo": i.customization.logo, "product-title": i.customization.name, "product-tagline": i.customization.tagline, selected: e.productId === i.productId } })], 1);
  }), e.companySwitcherVisible ? t("div", { staticClass: "company-switch-separator" }) : e._e(), e.companySwitcherVisible ? t("div", { staticClass: "portal-switch" }, [t("a", { staticClass: "portal-switch-link", attrs: { href: e.companySwitchUrl } }, [t("fa-icon-compat", { attrs: { icon: "fa-solid fa-arrows-repeat" } }), t("span", [e._v(e._s(e.companySwitchLabel))])], 1)]) : e._e()], 2);
}, SS = [], IS = /* @__PURE__ */ x(
  xS,
  CS,
  SS,
  !1,
  null,
  "7ce0d6b6"
);
const DS = IS.exports;
f({
  components: {
    HeaderSelectorFloating: DS
  },
  props: {
    portalSwitchLabel: {
      type: String,
      required: !1
    },
    portalSwitchUrl: {
      type: String,
      required: !1
    },
    companySwitchLabel: {
      type: String,
      required: !1
    },
    companySwitchUrl: {
      type: String,
      required: !1
    },
    productId: {
      type: String,
      required: !1
    },
    productList: {
      type: Array,
      required: !0
    },
    homeRouteName: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      optionsVisible: !1
    };
  },
  methods: {
    onToggleFloating() {
      this.optionsVisible = !this.optionsVisible;
    },
    onHideFloating() {
      this.optionsVisible = !1;
    }
  }
});
f({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !1
    },
    homeRouteName: {
      type: String,
      required: !0
    }
  },
  computed: {
    contextId() {
      return this.organization.context;
    },
    contextLogo() {
      return this.organization.logo;
    },
    productLogo() {
      return this.organization.productCustomization[this.productId].logo;
    },
    separatorVisible() {
      return !!this.contextId && !!this.productId;
    },
    contextVisible() {
      return !!this.contextId && !!this.contextLogo;
    },
    reverse() {
      var e;
      return !!((e = this.organization.productCustomization[this.productId]) != null && e.contextLogoFirst);
    }
  }
});
f({
  props: {
    user: {
      type: Object,
      required: !1
    },
    navigation: {
      type: Array,
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    collapsed: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      optionsVisible: !1
    };
  },
  watch: {
    $route() {
      this.onHideFloating();
    }
  },
  computed: {
    userAvatar() {
      var e;
      return (e = this.user) == null ? void 0 : e.avatar;
    },
    allOptions() {
      return [...this.collapsed ? this.navigation : [], ...this.options];
    }
  },
  methods: {
    onToggleFloating() {
      this.optionsVisible = !this.optionsVisible;
    },
    onHideFloating() {
      this.optionsVisible = !1;
    }
  }
});
const PS = f({
  props: {
    ticketResponse: {
      type: Object,
      required: !0
    }
  },
  computed: {
    ticket() {
      return this.ticketResponse.ticket;
    },
    ticketIcon() {
      const { icons: e } = Kt(this.ticketResponse.workflow);
      return e.solid;
    },
    statusLabel() {
      var e;
      const t = J(
        this.ticket.status,
        this.ticketResponse.workflow
      );
      return ((e = this.$res(t)) == null ? void 0 : e.label) ?? this.ticket.status;
    },
    statusVisible() {
      return this.ticketResponse.ticket.type !== "task";
    }
  }
});
var TS = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "quick-search-ticket-item" }, [t("img", { staticClass: "item-icon", class: [e.ticket.type], attrs: { src: e.ticketIcon } }), t("div", { staticClass: "item-title" }, [e._v(" " + e._s(e.ticket.title) + " ")]), e.statusVisible ? t("div", { staticClass: "tag status" }, [e._v(" " + e._s(e.statusLabel) + " ")]) : t("div", { staticClass: "canonical-id" }, [e._v(" " + e._s(e.ticket.parent) + " ")])]);
}, OS = [], BS = /* @__PURE__ */ x(
  PS,
  TS,
  OS,
  !1,
  null,
  "885fd733"
);
const MS = BS.exports, RS = f({
  props: {
    userData: {
      type: Object,
      required: !0
    }
  },
  computed: {
    displayName() {
      return B(this.userData).displayName();
    },
    userDepartment() {
      return B(this.userData).userDepartment();
    },
    avatar() {
      return this.userData.user.avatar;
    }
  }
});
var ES = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "quick-search-user-item" }, [t("div", { staticClass: "item-avatar" }, [e.avatar ? t("app-image", { attrs: { src: e.avatar, height: "18px", width: "18px", type: "circle" } }) : t("div", { staticClass: "avatar-fallback" }, [t("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-light fa-user" } })], 1)], 1), t("div", { staticClass: "item-title" }, [e._v(" " + e._s(e.displayName) + " ")]), t("div", { staticClass: "item-subtitle" }, [e._v(" " + e._s(e.userDepartment) + " ")])]);
}, LS = [], FS = /* @__PURE__ */ x(
  RS,
  ES,
  LS,
  !1,
  null,
  "ff86ff81"
);
const jS = FS.exports, US = f({
  components: {
    QuickSearchTicketItem: MS,
    QuickSearchUserItem: jS
  },
  inject: ["quickSearchConfig"],
  props: {
    productId: {
      type: String,
      required: !0
    },
    query: {
      type: String,
      required: !0
    },
    emptyInput: {
      type: Boolean,
      required: !0
    },
    dirty: {
      type: Boolean,
      required: !0
    },
    ticketCount: {
      type: Number,
      required: !0
    },
    tickets: {
      type: Array,
      required: !0
    },
    userCount: {
      type: Number,
      required: !0
    },
    users: {
      type: Array,
      required: !0
    }
  },
  computed: {
    quickSearchConfig() {
      return this.quickSearchConfig ?? {};
    },
    loading() {
      return this.dirty && !this.emptyInput;
    },
    emptyResult() {
      return !this.ticketCount && !this.userCount;
    },
    searchTicketLink() {
      return {
        name: this.quickSearchConfig.tickets,
        query: { query: this.query }
      };
    },
    searchUserLink() {
      return {
        name: this.quickSearchConfig.users,
        query: { query: this.query }
      };
    },
    ticketCountText() {
      return this.ticketCount >= 1e3 ? "1000+" : this.ticketCount.toString();
    },
    userCountText() {
      return this.userCount >= 1e3 ? "1000+" : this.userCount.toString();
    }
  },
  methods: {
    ticketRouterLink(e) {
      const t = e.parent && e.type === "task" ? e.parent : e.canonicalId;
      return this.generatePortalUrl(`/${this.productId}/ticket/${t}`);
    },
    userRouterLink(e) {
      return this.generatePortalUrl(
        `/${this.productId}/profile/${e.user.id}`
      );
    },
    generatePortalUrl(e) {
      return new URL(e, this.quickSearchConfig.portalUrl).href;
    }
  }
});
var qS = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "quick-search-results" }, [e.emptyInput ? t("div", { staticClass: "no-results" }, [e._v(" " + e._s(e.$t("search.quick.label-instructions")) + " ")]) : e.emptyResult && !e.loading ? t("div", { staticClass: "no-results" }, [e._v(" " + e._s(e.$t("search.quick.label-empty")) + " ")]) : e._e(), (e.emptyInput || e.emptyResult) && !e.loading ? t("div", { staticClass: "search-links" }, [t("router-link", { attrs: { to: { name: e.quickSearchConfig.users } } }, [e._v(" " + e._s(e.$t("menu.users")) + " ")]), t("router-link", { attrs: { to: { name: e.quickSearchConfig.tickets } } }, [e._v(" " + e._s(e.$t("common.ideas")) + " ")])], 1) : [e.ticketCount ? [t("div", { staticClass: "result-group" }, [t("div", { staticClass: "group-header" }, [t("span", { staticClass: "group-title" }, [e._v(e._s(e.$t("common.ideas")))]), t("span", { staticClass: "group-count" }, [e._v(e._s(e.ticketCountText))])]), e._l(e.tickets, function(i) {
    return t("a", { key: i.ticket.id, staticClass: "result-link", attrs: { target: e.quickSearchConfig.target, href: e.ticketRouterLink(i.ticket) } }, [t("quick-search-ticket-item", { attrs: { "ticket-response": i } })], 1);
  }), t("router-link", { staticClass: "view-all", attrs: { to: e.searchTicketLink } }, [e._v(" " + e._s(e.$t("common.viewAll")) + " ")])], 2)] : e._e(), e.userCount ? [t("div", { staticClass: "result-group" }, [t("div", { staticClass: "group-header" }, [t("span", { staticClass: "group-title" }, [e._v(e._s(e.$t("menu.people")))]), t("span", { staticClass: "group-count" }, [e._v(e._s(e.userCountText))])]), e._l(e.users, function(i) {
    return t("a", { key: i.user.id, staticClass: "result-link", attrs: { href: e.userRouterLink(i) } }, [t("quick-search-user-item", { attrs: { "user-data": i } })], 1);
  }), t("router-link", { staticClass: "view-all", attrs: { to: e.searchUserLink } }, [e._v(" " + e._s(e.$t("common.viewAll")) + " ")])], 2)] : e._e()], t("transition", { attrs: { mode: "out-in", name: "modal-fade" } }, [e.loading ? t("app-overlay", { attrs: { "full-page": !1, "center-content": !0, theme: "light" } }, [t("app-loading")], 1) : e._e()], 1)], 2);
}, HS = [], zS = /* @__PURE__ */ x(
  US,
  qS,
  HS,
  !1,
  null,
  "969e9061"
);
const NS = zS.exports, VS = f({
  components: {
    QuickSearchResults: NS
  },
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      open: !1,
      dirty: !1,
      loading: !1,
      query: "",
      ticketCount: 0,
      tickets: [],
      userCount: 0,
      users: []
    };
  },
  watch: {
    $route() {
      this.open = !1, this.query = "";
    }
  },
  computed: {
    emptyInput() {
      return this.query.length < 3;
    }
  },
  methods: {
    onDirty() {
      this.dirty = !0, this.loading = !0;
    },
    async onDebouncedSearch(e) {
      if (this.emptyInput) {
        this.dirty = !1, this.loading = !1, this.clearResults();
        return;
      }
      const t = 5, i = await this.$gateway.search.quickSearch({
        query: e,
        filter: { excludeTicketTypes: ["feedback"] }
      }), r = i.ticketIds.slice(0, t), s = i.userIds.slice(0, t);
      this.ticketCount = i.ticketIds.length, this.userCount = i.userIds.length, [this.tickets, this.users] = await Promise.all([
        this.$gateway.ticket.loadTicketsByBatch(
          this.contextId,
          this.productId,
          r
        ),
        this.$gateway.portal.findUsersById(s)
      ]), this.dirty = !1, this.loading = !1;
    },
    clearResults() {
      this.ticketCount = 0, this.tickets = [], this.userCount = 0, this.users = [];
    }
  }
});
var GS = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-floating", { scopedSlots: e._u([{ key: "content", fn: function() {
    return [t("app-search-input", { attrs: { "debounce-timeout": 300, placeholder: e.$t("common.search") }, on: { debounced: e.onDebouncedSearch, dirty: e.onDirty }, model: { value: e.query, callback: function(i) {
      e.query = i;
    }, expression: "query" } })];
  }, proxy: !0 }, { key: "options", fn: function() {
    return [t("quick-search-results", { attrs: { "product-id": e.productId, dirty: e.dirty, "empty-input": e.emptyInput, loading: e.loading, query: e.query, tickets: e.tickets, "ticket-count": e.ticketCount, users: e.users, "user-count": e.userCount } })];
  }, proxy: !0 }]), model: { value: e.open, callback: function(i) {
    e.open = i;
  }, expression: "open" } });
}, WS = [], QS = /* @__PURE__ */ x(
  VS,
  GS,
  WS,
  !1,
  null,
  "b89bc0e2"
);
const XS = QS.exports;
f({
  components: {
    QuickSearchInput: XS
  },
  props: {
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    expanded: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    focusSearchInput() {
      const e = this.$el.querySelector(
        ".quick-search-input .text-input"
      );
      e == null || e.focus();
    }
  }
});
f({
  props: {
    options: {
      type: Array,
      required: !0
    }
  }
});
f({
  props: {
    version: {
      type: String,
      required: !1
    }
  }
});
const KS = f({
  props: {
    title: {
      type: String,
      required: !0
    },
    faIcon: {
      type: String,
      required: !0
    },
    routeName: {
      type: String,
      required: !0
    },
    routeParams: {
      type: Object,
      required: !1
    }
  }
});
var YS = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-menu-item", { staticClass: "menu-bar-item", attrs: { title: e.title, "fa-icon": e.faIcon, "route-name": e.routeName, "route-params": e.routeParams } });
}, ZS = [], JS = /* @__PURE__ */ x(
  KS,
  YS,
  ZS,
  !1,
  null,
  "6381f596"
);
const jc = JS.exports, _S = f({
  props: {
    label: {
      type: String,
      required: !0
    }
  }
});
var $S = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "menu-group-header" }, [t("div", { staticClass: "menu-group-title" }, [e._v(e._s(e.label))])]);
}, e1 = [], t1 = /* @__PURE__ */ x(
  _S,
  $S,
  e1,
  !1,
  null,
  "c94a5d19"
);
const i1 = t1.exports, r1 = f({
  components: {
    MenuBarGroupHeader: i1,
    MenuBarItem: jc
  },
  props: {
    menuGroup: {
      type: Object,
      required: !1
    },
    menuItems: {
      type: Array,
      default: () => []
    }
  }
});
var s1 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "menu-bar-group" }, [e.menuGroup ? t("menu-bar-group-header", { attrs: { label: e.menuGroup.label } }) : e._e(), e._l(e.menuItems, function(i, r) {
    return t("menu-bar-item", { key: r, attrs: { title: i.label, "fa-icon": i.faIcon, "route-name": i.routeName, "route-params": i.routeParams } });
  })], 2);
}, n1 = [], a1 = /* @__PURE__ */ x(
  r1,
  s1,
  n1,
  !1,
  null,
  "82eeefb7"
);
const o1 = a1.exports;
f({
  components: {
    MenuBarGroup: o1,
    MenuBarItem: jc
  },
  props: {
    menuItems: {
      type: Array,
      default: () => []
    },
    menuGroups: {
      type: Array,
      default: () => []
    }
  },
  setup(e) {
    const { menuItems: t, menuGroups: i } = Mt(e), { ungrouped: r, nonEmptyGroups: s, groupedItems: n } = Gg(
      t,
      i
    );
    return { ungrouped: r, nonEmptyGroups: s, groupedItems: n };
  }
});
De.extend({
  props: {
    tag: {
      type: Object,
      required: !0
    },
    tagsSelected: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    searchEnabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      selected: []
    };
  },
  created() {
    this.selected = this.tagsSelected;
  },
  computed: {
    options() {
      return this.tag.tags.map((e) => ({
        text: e.tag,
        value: Tt.build(e).toString()
      }));
    }
  },
  methods: {
    onUpdateMultiple(e) {
      this.$emit("update-tags", e);
    },
    onAddTag(e) {
      this.$emit("addTag", e);
    },
    onRemoveTag(e) {
      this.$emit("removeTag", e);
    }
  }
});
f({
  name: "AppTagCloud",
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  }
});
const l1 = f({
  props: {
    highlight: {
      type: Boolean,
      default: !1
    },
    emojiPath: {
      type: String
    },
    amount: {
      type: Number,
      default: 0
    },
    emojiHeight: {
      type: Number,
      default: 18
    }
  },
  methods: {
    onClick(e) {
      this.$emit("click", e);
    }
  }
});
var c1 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("button", { class: { highlight: e.highlight }, attrs: { type: "button" }, on: { click: e.onClick } }, [e._t("default", function() {
    return [t("div", { staticClass: "social-emoji-button-container" }, [t("img", { staticClass: "emoji", attrs: { src: e.emojiPath, height: e.emojiHeight } }), t("span", { staticClass: "amount" }, [e._v(e._s(e.amount))])])];
  })], 2);
}, u1 = [], d1 = /* @__PURE__ */ x(
  l1,
  c1,
  u1,
  !1,
  null,
  "394f7191"
);
const Yt = d1.exports, h1 = f({
  props: {
    emoji: {
      type: Object
    }
  }
});
var p1 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", [t("button", { staticClass: "emojis-list-item", attrs: { type: "button" }, on: { click: function(i) {
    return i.preventDefault(), e.$emit("click", e.emoji);
  } } }, [t("img", { staticClass: "emoji", attrs: { src: e.emoji.path, alt: "emoji" } })])]);
}, f1 = [], m1 = /* @__PURE__ */ x(
  h1,
  p1,
  f1,
  !1,
  null,
  "abbbc1aa"
);
const g1 = m1.exports, y1 = f({
  components: {
    SocialButton: Yt,
    EmojiButton: g1
  },
  props: {
    shortListEmojis: {
      type: Array,
      default: () => []
    },
    otherEmojis: {
      type: Array,
      default: () => []
    },
    columnCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: !1,
      menuExpanded: !1
    };
  },
  computed: {
    gridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.otherEmojis.length ? this.columnCount : this.columnCount - 1}, minmax(0, 1fr))`
      };
    }
  },
  methods: {
    onEmojiSelect(e) {
      this.$emit("input", e), this.visible = !1;
    }
  }
});
var b1 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-floating", { style: { position: "static" }, attrs: { "floating-style": { width: "320px", zIndex: "50" }, placement: "bottom-end" }, scopedSlots: e._u([{ key: "content", fn: function() {
    return [t("social-button", { staticClass: "add-reactions-button", on: { click: function(i) {
      i.preventDefault();
    } } }, [t("fa-icon-compat", { staticClass: "smile-icon", attrs: { icon: "fa-regular fa-smile" } }), t("img", { staticClass: "emoji", attrs: { height: 12, src: "/img/plus-solid.svg" } })], 1)];
  }, proxy: !0 }, { key: "options", fn: function() {
    return [t("div", { staticClass: "base-emoji-picker-container" }, [t("div", { staticClass: "emoji-list-grid emojis-list", style: e.gridStyle }, [e._l(e.shortListEmojis, function(i) {
      return t("emoji-button", { key: i.key, attrs: { "data-ruid": i.key, emoji: i }, on: { click: e.onEmojiSelect } });
    }), e.otherEmojis.length ? t("emoji-button", { attrs: { emoji: { key: "", path: "/img/emojis/emoji_dots.svg" } }, on: { click: function(i) {
      e.menuExpanded = !e.menuExpanded;
    } } }) : e._e()], 2), e.menuExpanded ? t("div", { staticClass: "emoji-list-grid emojis-list other-emojis", style: e.gridStyle }, e._l(e.otherEmojis, function(i) {
      return t("emoji-button", { key: i.key, attrs: { emoji: i }, on: { click: e.onEmojiSelect } });
    }), 1) : e._e()])];
  }, proxy: !0 }]), model: { value: e.visible, callback: function(i) {
    e.visible = i;
  }, expression: "visible" } });
}, v1 = [], A1 = /* @__PURE__ */ x(
  y1,
  b1,
  v1,
  !1,
  null,
  "04383953"
);
const k1 = A1.exports, w1 = [
  {
    // 👍
    path: "/img/emojis/emoji_thumb_up.svg",
    key: "thumbUp"
  },
  {
    // 🙂
    path: "/img/emojis/emoji_smiling.svg",
    key: "smiling"
  },
  {
    // 😎
    path: "/img/emojis/emoji_sunglasses.svg",
    key: "sunglasses"
  },
  {
    // 😮
    path: "/img/emojis/emoji_wow.svg",
    key: "wow"
  },
  {
    // 💪
    path: "/img/emojis/emoji_strong.svg",
    key: "strong"
  },
  {
    // ❤️
    path: "/img/emojis/emoji_heart.svg",
    key: "heart"
  },
  {
    // 🔥
    path: "/img/emojis/emoji_fire.svg",
    key: "fire"
  }
], x1 = [
  {
    // 😉
    path: "/img/emojis/emoji_wink.svg",
    key: "wink"
  },
  {
    // 😜
    path: "/img/emojis/emoji_tongue.svg",
    key: "tongue"
  },
  {
    // 😍
    path: "/img/emojis/emoji_heart_eyes.svg",
    key: "heartEyes"
  },
  {
    // 😂
    path: "/img/emojis/smile_joy_tears.svg",
    key: "joyTears"
  },
  {
    // 🥰
    path: "/img/emojis/emoji_loved.svg",
    key: "loved"
  },
  {
    // 😣
    path: "/img/emojis/emoji_dead_eyes.svg",
    key: "deadEyes"
  },
  {
    // 😬
    path: "/img/emojis/emoji_grymacing.svg",
    key: "grymacing"
  },
  {
    // 😘
    path: "/img/emojis/emoji_send_heart_kiss.svg",
    key: "kisses"
  },
  {
    // 😋
    path: "/img/emojis/emoji_tongue_smile.svg",
    key: "tongueSmile"
  },
  {
    // 🤗
    path: "/img/emojis/emoji_hugging_face.svg",
    key: "huggingFace"
  },
  {
    // 😭
    path: "/img/emojis/emoji_crying.svg",
    key: "crying"
  },
  {
    // ☺️
    path: "/img/emojis/emoji_smiley.svg",
    key: "smiley"
  },
  {
    // 🙏
    path: "/img/emojis/emoji_folded_hands.svg",
    key: "foldedHands"
  },
  {
    // ✌️
    path: "/img/emojis/emoji_vctory_hand.svg",
    key: "victoryHand"
  },
  {
    // 🙌
    path: "/img/emojis/emoji_rasing_hands.svg",
    key: "raisngHands"
  },
  {
    // 👀
    path: "/img/emojis/emoji_eyes.svg",
    key: "eyes"
  },
  {
    // 💯
    path: "/img/emojis/emoji_100.svg",
    key: "hundred"
  },
  {
    // 🎉
    path: "/img/emojis/emoji_party.svg",
    key: "party"
  },
  {
    // 🏆
    path: "/img/emojis/emoji_trophy.svg",
    key: "trophy"
  },
  {
    // 🦄
    path: "/img/emojis/emoji_unicorn.svg",
    key: "unicorn"
  },
  {
    // ✅
    path: "/img/emojis/emoji_checked.svg",
    key: "checked"
  },
  {
    // 👑
    path: "/img/emojis/emoji_crown.svg",
    key: "crown"
  },
  {
    // 🍒
    path: "/img/emojis/emoji_cherries.svg",
    key: "cherries"
  },
  {
    // 💩
    path: "/img/emojis/emoji_poop.svg",
    key: "poop"
  }
], C1 = f({
  components: {
    EmojiSelection: k1,
    SocialButton: Yt
  },
  props: {
    reactions: {
      type: Array,
      default: () => []
    },
    visibleReactions: {
      type: Number
    },
    userId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      shortListEmojis: w1,
      otherEmojis: x1,
      allEmojis: [],
      emojis: {}
    };
  },
  computed: {
    hiddenReactionsCount() {
      return this.reactions.length - this.partialReactions.length;
    },
    partialReactions() {
      return this.visibleReactions === void 0 ? this.reactions : this.reactions.slice(0, this.visibleReactions);
    }
  },
  created() {
    this.allEmojis = this.shortListEmojis.concat(this.otherEmojis), this.allEmojis.forEach((e) => {
      this.emojis[e.key] = e.path;
    });
  },
  methods: {
    hasUserIdReacted(e) {
      return e.events.filter((t) => t.author === this.userId).length > 0;
    },
    clickEmoji(e) {
      this.$emit("updateReaction", e.key);
    },
    updateReaction(e) {
      this.$emit("updateReaction", e.reactionKey);
    }
  }
});
var S1 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "emoji-list-container" }, [e._l(e.partialReactions, function(i) {
    return t("social-button", { key: i.reactionKey, attrs: { "emoji-path": e.emojis[i.reactionKey], amount: i.events.length, highlight: e.hasUserIdReacted(i) }, on: { click: function(r) {
      return r.preventDefault(), e.updateReaction(i);
    } } });
  }), e.hiddenReactionsCount > 0 ? t("social-button", { attrs: { amount: e.hiddenReactionsCount, "emoji-height": 12, "emoji-path": "/img/plus-solid.svg" } }) : e._e(), t("emoji-selection", { attrs: { shortListEmojis: e.shortListEmojis, otherEmojis: e.otherEmojis, columnCount: 8 }, on: { input: e.clickEmoji } })], 2);
}, I1 = [], D1 = /* @__PURE__ */ x(
  C1,
  S1,
  I1,
  !1,
  null,
  "4ed7a8a0"
);
const P1 = D1.exports;
f({
  components: {
    EmojiViewer: P1,
    SocialButton: Yt
  },
  props: {
    ticketId: {
      type: String,
      required: !0
    },
    showEmojiViewer: {
      type: Boolean,
      default: !0
    },
    visibleReactions: {
      type: Number
    },
    board: {
      type: Object,
      required: !0
    },
    currentUserId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      reactionBoard: void 0
    };
  },
  created() {
    this.reactionBoard = this.board;
  },
  computed: {
    reactions() {
      var e;
      return (((e = this.reactionBoard) == null ? void 0 : e.reactions) ?? []).filter((t) => t.events.length);
    },
    numberOfComments() {
      var e;
      return ((e = this.reactionBoard) == null ? void 0 : e.comments.length) ?? 0;
    }
  },
  methods: {
    async onUpdateReaction(e) {
      if (e)
        try {
          const t = await this.$gateway.admin.updateReaction(
            this.reactionBoard,
            e,
            this.ticketId,
            this.currentUserId
          );
          this.reactionBoard = t;
        } catch (t) {
          console.error("Could not update reaction board", t);
        }
    }
  }
});
f({
  components: {
    SocialButton: Yt
  },
  props: {
    type: {
      type: String,
      required: !0
    },
    typeId: {
      type: String,
      default: ""
    },
    currentUserId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      watchers: []
    };
  },
  async mounted() {
    await this.getWatchers();
  },
  computed: {
    watchingAmount() {
      return this.watchers.length;
    },
    alreadyWatching() {
      return this.watchers.some((e) => e.id === this.currentUserId);
    },
    watchLabel() {
      return this.alreadyWatching ? this.$t("common.watching").toString() : this.$t("common.watch").toString();
    },
    nobodyWatching() {
      return !this.watchingAmount;
    }
  },
  methods: {
    async getWatchers() {
      this.watchers = await this.$api.watcher.fetchWatcherForTarget(
        this.typeId,
        this.type
      );
    },
    async toggleWatcher() {
      const e = this.alreadyWatching ? "stop" : "start";
      await this.$api.watcher.setWatcherForTarget(
        this.typeId,
        this.type,
        e
      ), await this.getWatchers();
    }
  }
});
f({
  components: {
    SocialButton: Yt
  }
});
f({
  components: {
    SocialButton: Yt
  },
  props: {
    imagePath: {
      type: String,
      required: !0
    },
    amount: {
      type: [Number, String],
      default: 0
    }
  }
});
f({
  name: "AppMicrosoftTeams",
  props: {
    user: {
      type: Object,
      required: !0
    }
  },
  computed: {
    userDetails() {
      const { microsoftTeamsLink: e, displayEmail: t } = B({ user: this.user });
      return {
        microsoftTeamsLink: e(),
        displayEmail: t()
      };
    },
    microsoftTeamsLink() {
      return this.userDetails.microsoftTeamsLink;
    },
    userEmail() {
      return this.userDetails.displayEmail;
    }
  },
  methods: {
    openTeams() {
      window.open(this.microsoftTeamsLink, "_blank");
    }
  }
});
const T1 = f({
  name: "WalletTransactionItem",
  props: {
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      required: !0
    },
    value: {
      type: Number,
      required: !0
    },
    type: {
      type: String,
      required: !0
    }
  },
  computed: {
    iconSrc() {
      return this.type === "DEBIT" ? "/wallets/transaction-minus.svg" : this.type === "CREDIT" ? "/wallets/transaction-plus.svg" : (console.warn(`Unknown transaction type [type=${this.type}]`), "");
    },
    displayValue() {
      return new Intl.NumberFormat(void 0, {
        style: "decimal",
        signDisplay: "exceptZero",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(this.value);
    }
  }
});
var O1 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-list-item", { staticClass: "wallet-transaction-item", attrs: { description: e.description, image: e.iconSrc, title: e.title }, scopedSlots: e._u([{ key: "controls", fn: function() {
    return [t("div", { staticClass: "transaction-value" }, [e._v(" " + e._s(e.displayValue) + " ")])];
  }, proxy: !0 }]) });
}, B1 = [], M1 = /* @__PURE__ */ x(
  T1,
  O1,
  B1,
  !1,
  null,
  "3031f2ef"
);
const R1 = M1.exports;
f({
  name: "WalletWidget",
  components: {
    WalletTransactionItem: R1
  },
  props: {
    transactions: {
      type: Array,
      required: !0
    },
    owners: {
      type: Object,
      required: !0
    }
  },
  methods: {
    getOwner(e) {
      var t;
      return ((t = this.owners[e]) == null ? void 0 : t.owner.name) ?? "";
    }
  }
});
f({
  name: "WalletTransferControl",
  props: {
    sourceWallet: {
      type: Object,
      required: !0
    },
    targetWallet: {
      type: Object,
      required: !0
    },
    descriptionPlaceholder: {
      type: String,
      required: !0
    },
    confirmLabel: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      transferDescription: "",
      transferAmount: 0
    };
  },
  computed: {
    expectedSourceBalance() {
      return this.sourceWallet.balance - this.transferAmount;
    },
    enableTransfer() {
      return !!this.transferDescription && this.transferAmount > 0 && this.expectedSourceBalance >= 0;
    }
  },
  methods: {
    async onConfirm() {
      this.$emit("transfer", {
        fromWalletId: this.sourceWallet.id,
        toWalletId: this.targetWallet.id,
        value: this.transferAmount,
        description: this.transferDescription
      });
    }
  }
});
f({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    ticketContext: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    appId: {
      type: String,
      required: !0
    },
    permissions: {
      type: Object,
      required: !0
    },
    initialFilter: {
      type: Object,
      required: !1
    }
  },
  data() {
    var e, t, i, r, s, n, a;
    return {
      form: {
        query: ((e = this.initialFilter) == null ? void 0 : e.query) ?? "",
        campaignProductRestriction: ((t = this.initialFilter) == null ? void 0 : t.campaignProductRestriction) ?? "",
        status: ((i = this.initialFilter) == null ? void 0 : i.status) ?? [],
        team: ((r = this.initialFilter) == null ? void 0 : r.team) ?? [],
        topic: ((s = this.initialFilter) == null ? void 0 : s.topic) ?? [],
        fromDate: (n = this.initialFilter) == null ? void 0 : n.fromDate,
        toDate: (a = this.initialFilter) == null ? void 0 : a.toDate
      },
      optionsStatus: [],
      teamOptions: [],
      topicOptions: [],
      workflows: []
    };
  },
  async created() {
    this.onDirty(), await Promise.allSettled([
      this.loadStatus(),
      this.loadTopics(),
      this.loadTeams()
    ]);
  },
  computed: {
    enabledProducts() {
      const { productsData: e } = Ge(this.organization);
      return e.value.filter(
        (t) => this.permissions.checkProductPermission(t.productId, [
          "USER_TICKET_LIST"
        ])
      ).map((t) => t.productId);
    }
  },
  methods: {
    onDirty() {
      this.$emit("dirty");
    },
    onSubmit() {
      this.$emit("update", this.form);
    },
    async loadStatus() {
      const e = await this.$gateway.search.status(
        this.ticketContext,
        "campaign",
        this.appId
      );
      this.optionsStatus = e[0].map((t) => ({
        text: this.$res(J(t, e[1]), { label: t }).label,
        value: t
      }));
    },
    async loadTeams() {
      const e = await this.$gateway.search.searchTeamIds(
        {
          filter: {
            type: ["ORGANIZATIONAL_TEAM", "VIRTUAL_TEAM"]
          }
        },
        this.$res
      ), t = await this.$datasource.team.listBatch(e);
      this.teamOptions = t.map((i) => ({
        text: i.name,
        value: i.id
      }));
    },
    async loadTopics() {
      const e = {
        tags: [
          {
            tag: this.productId,
            class: "product"
          }
        ]
      }, t = await this.$gateway.topic.filterByTags(e);
      this.topicOptions = t.map((i) => ({
        text: this.$res(i == null ? void 0 : i.resources).title,
        value: i.id
      }));
    }
  }
});
const E1 = 180;
f({
  props: {
    searchId: {
      type: Number,
      required: !0
    },
    pageSize: {
      type: Number,
      required: !0
    },
    totalCount: {
      type: Number,
      required: !0
    },
    items: {
      type: Array,
      required: !0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    empty: {
      type: Object,
      required: !1
    },
    sortOrder: {
      type: String,
      default: "DESC"
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrollListener, { passive: !0 });
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollListener);
  },
  watch: {
    searchId() {
      this.currentPage = 0;
    }
  },
  data() {
    return {
      currentPage: 0
    };
  },
  computed: {
    totalCountText() {
      return this.totalCount >= 1e3 ? "1000+" : this.totalCount.toString();
    },
    loadingMore() {
      return !this.lastPage && this.totalCount > 0 && this.currentPage > 0;
    },
    lastPage() {
      const e = Math.ceil(this.totalCount / this.pageSize);
      return this.currentPage >= e;
    },
    sortIcon() {
      return this.sortOrder === "DESC" ? "fa-arrow-down-short-wide" : "fa-arrow-up-wide-short";
    }
  },
  methods: {
    toggleSortOrder() {
      this.$emit("toggleSortOrder", this.sortOrder === "ASC" ? "DESC" : "ASC");
    },
    scrollListener() {
      if (this.lastPage || this.loading)
        return;
      const { scrollTop: e, scrollHeight: t, clientHeight: i } = document.documentElement;
      t - (e + i) < E1 && this.loadMore();
    },
    loadMore() {
      this.lastPage || this.loading || (this.currentPage += 1, this.$emit("load-page", this.currentPage));
    }
  }
});
function L1(e) {
  return !Object.values(e).some((t) => Object.prototype.toString.call(t) === "[object Date]" && !Number.isNaN(t) || typeof t == "string" && t.length > 2 ? !0 : Array.isArray(t) && t.length > 0);
}
const F1 = 6 * 30 * 24 * 60 * 60 * 1e3;
f({
  props: {
    organization: {
      type: Object,
      required: !0
    },
    defaultProductId: {
      type: String,
      required: !0
    },
    appId: {
      type: String,
      required: !0
    },
    permissions: {
      type: Object,
      required: !0
    },
    initialFilter: {
      type: Object,
      required: !1
    }
  },
  data() {
    var e, t, i, r, s, n, a, o, l, c, u, d, h;
    return {
      form: {
        query: ((e = this.initialFilter) == null ? void 0 : e.query) ?? "",
        product: ((t = this.initialFilter) == null ? void 0 : t.product) ?? "",
        phases: ((i = this.initialFilter) == null ? void 0 : i.phases) ?? [],
        status: ((r = this.initialFilter) == null ? void 0 : r.status) ?? [],
        creator: ((s = this.initialFilter) == null ? void 0 : s.creator) ?? [],
        assignee: ((n = this.initialFilter) == null ? void 0 : n.assignee) ?? [],
        team: ((a = this.initialFilter) == null ? void 0 : a.team) ?? [],
        topic: ((o = this.initialFilter) == null ? void 0 : o.topic) ?? [],
        skills: ((l = this.initialFilter) == null ? void 0 : l.skills) ?? [],
        parent: ((c = this.initialFilter) == null ? void 0 : c.parent) ?? "",
        fromDate: (u = this.initialFilter) == null ? void 0 : u.fromDate,
        toDate: (d = this.initialFilter) == null ? void 0 : d.toDate,
        tags: ((h = this.initialFilter) == null ? void 0 : h.tags) ?? []
      },
      statusOptions: [],
      phaseOptions: [],
      teamOptions: [],
      topicOptions: [],
      skillOptions: [],
      tagsOptions: [],
      workflows: []
    };
  },
  async created() {
    this.onDirty(), this.setDefaultFilters(), await Promise.allSettled([
      this.loadPhases(),
      this.loadStatus(),
      this.loadTeams(),
      this.loadTopics(),
      this.loadSkills(),
      this.loadWorkflows(),
      this.loadTags()
    ]);
  },
  computed: {
    contextId() {
      return this.organization.context;
    },
    productIds() {
      const { productsData: e } = Ge(this.organization);
      return e.value.filter(
        (t) => this.permissions.checkProductPermission(t.productId, [
          "USER_TICKET_LIST"
        ])
      ).map((t) => t.productId);
    }
  },
  methods: {
    setDefaultFilters() {
      if (this.form.product || (this.form.product = this.defaultProductId), !this.form.fromDate) {
        const e = /* @__PURE__ */ new Date(), t = new Date(e.getTime() - F1);
        this.form.fromDate = t;
      }
    },
    onDirty() {
      this.$emit("dirty");
    },
    onSubmit() {
      L1(this.form) ? this.$emit("empty") : this.$emit("update", this.form);
    },
    async onChangeProduct(e) {
      this.form.product = e || this.defaultProductId, this.form.phases = [], this.form.status = [], await Promise.all([this.loadStatus(), this.loadPhases()]);
    },
    async loadStatus() {
      const e = await this.$gateway.search.status(
        this.contextId,
        this.form.product,
        this.appId
      );
      this.statusOptions = e[0].map((t) => ({
        text: this.$res(J(t, e[1]), { label: t }).label,
        value: t
      }));
    },
    async loadPhases() {
      const [e, t] = await this.$gateway.search.phases(
        this.contextId,
        this.form.product,
        this.appId
      );
      this.phaseOptions = e.map((i) => ({
        text: this.$res(J(i, t, "phases"), { label: i }).label,
        value: i
      }));
    },
    async loadTeams() {
      const e = await this.$gateway.search.searchTeamIds(
        {
          filter: {
            type: ["ORGANIZATIONAL_TEAM", "VIRTUAL_TEAM"]
          }
        },
        this.$res
      ), t = await this.$datasource.team.listBatch(e);
      this.teamOptions = t.map((i) => ({
        text: i.name,
        value: i.id
      }));
    },
    async loadTopics() {
      const e = {
        tags: [
          {
            tag: this.defaultProductId,
            class: "product"
          }
        ]
      }, t = await this.$gateway.topic.filterByTags(e);
      this.topicOptions = t.map((i) => ({
        text: this.$res(i == null ? void 0 : i.resources).title,
        value: i.id
      }));
    },
    async loadSkills() {
      const e = await this.$gateway.search.skill();
      this.skillOptions = e.map((t) => ({
        text: t,
        value: t
      }));
    },
    async loadTags() {
      const e = await this.$gateway.search.tags();
      this.tagsOptions = e.map((t) => ({
        text: t,
        value: t
      }));
    },
    async loadWorkflows() {
      this.workflows = await this.$gateway.portal.fetchWorkflowsByBatch(
        this.productIds,
        this.contextId
      );
    }
  }
});
f({
  props: {
    item: {
      type: Object,
      required: !0
    },
    attachment: {
      type: Object,
      required: !1
    },
    appId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      resource: {}
    };
  },
  async created() {
    await this.loadResource();
  },
  computed: {
    workflow() {
      return this.item.workflow;
    },
    ticket() {
      return this.item.ticket;
    },
    delegateTopic() {
      var e, t;
      return (t = (e = this.item.delegates) == null ? void 0 : e.find(({ type: i }) => i === "topic")) == null ? void 0 : t.data;
    },
    delegateTeam() {
      var e, t;
      return (t = (e = this.item.delegates) == null ? void 0 : e.find(
        ({ type: i }) => ["workgroup", "team"].includes(i)
      )) == null ? void 0 : t.data;
    },
    creatorName() {
      if (this.item.creator)
        return B(this.item.creator).displayName();
    },
    assigneeName() {
      if (this.item.assignee)
        return B(this.item.assignee).displayName();
    },
    delegateTitle() {
      return this.delegateTopic ? this.$res(this.delegateTopic.resources).title : this.delegateTeam ? Be(this.delegateTeam, this.$res).teamName() : "";
    },
    statusLabel() {
      var e;
      const t = J(this.ticket.status, this.item.workflow);
      return (e = this.$res(t)) == null ? void 0 : e.label;
    },
    dateCreated() {
      if (!this.ticket.createdDate)
        return "";
      try {
        const e = new Date(this.ticket.createdDate), t = {
          year: "numeric",
          month: "short",
          day: "numeric"
        };
        return e.toLocaleDateString(void 0, t);
      } catch (e) {
        return console.error("Could not parse ticket creation date", e), "";
      }
    },
    topicStyle() {
      var e;
      return {
        backgroundColor: ((e = this.delegateTopic) == null ? void 0 : e.meta.color) ?? ""
      };
    }
  },
  methods: {
    async loadResource() {
      const e = an(this.workflow, this.appId).page(
        "TicketDetails"
      );
      this.resource = this.$res(e == null ? void 0 : e.resources);
    },
    onClick() {
      this.$emit("click", this.ticket.canonicalId);
    }
  }
});
f({
  props: {
    initialFilter: {
      type: Object,
      required: !1
    }
  },
  data() {
    var e, t, i, r, s;
    return {
      form: {
        query: ((e = this.initialFilter) == null ? void 0 : e.query) ?? "",
        team: ((t = this.initialFilter) == null ? void 0 : t.team) ?? [],
        virtualTeams: ((i = this.initialFilter) == null ? void 0 : i.virtualTeams) ?? [],
        workgroups: ((r = this.initialFilter) == null ? void 0 : r.workgroups) ?? [],
        skills: ((s = this.initialFilter) == null ? void 0 : s.skills) ?? []
      },
      skillOptions: [],
      allTeams: []
    };
  },
  async created() {
    this.onDirty(), await Promise.allSettled([this.loadTeams(), this.loadSkills()]), this.onSubmit();
  },
  computed: {
    virtualTeamOptions() {
      const e = this.allTeams.filter((t) => t.type === "VIRTUAL_TEAM");
      return this.setTeamOptions(e);
    },
    workgroupOptions() {
      const e = this.allTeams.filter((t) => t.type === "WORKGROUP");
      return this.setTeamOptions(e);
    },
    organisationTeams() {
      const e = this.allTeams.filter(
        (t) => t.type === "ORGANIZATIONAL_TEAM"
      );
      return this.setTeamOptions(e);
    }
  },
  methods: {
    onDirty() {
      this.$emit("dirty");
    },
    onSubmit() {
      this.$emit("update", this.form);
    },
    async loadTeams() {
      const e = await this.$gateway.search.searchTeamIds(
        {
          filter: {
            type: ["ORGANIZATIONAL_TEAM", "VIRTUAL_TEAM", "WORKGROUP"]
          }
        },
        this.$res
      );
      this.allTeams = await this.$datasource.team.listBatch(e);
    },
    setTeamOptions(e) {
      return e.map((t) => ({
        text: Be(t, this.$res).teamName(),
        value: t.id
      }));
    },
    async loadSkills() {
      const e = await this.$gateway.search.skill();
      this.skillOptions = e.map((t) => ({
        text: t,
        value: t
      }));
    }
  }
});
f({
  props: {
    userData: {
      type: Object,
      required: !0
    }
  },
  computed: {
    userDepartment() {
      return B(this.userData).userDepartment();
    },
    userEmail() {
      return B(this.userData).displayEmail();
    },
    displayName() {
      return B(this.userData).displayName();
    },
    avatar() {
      return this.userData.user.avatar;
    }
  },
  methods: {
    onClick() {
      this.$emit("click", this.userData.user.id);
    }
  }
});
const j1 = {
  column: {
    width: 300
  }
};
f({
  props: {
    data: {
      type: Array,
      default: () => []
    },
    groupBy: {
      type: Array,
      required: !0
    },
    groupKeys: {
      type: Array,
      required: !0
    },
    config: {
      type: Object,
      required: !1
    }
  },
  setup(e) {
    const { data: t, groupBy: i, groupKeys: r } = Mt(e), { groupedData: s, groups: n } = _l(
      t,
      i,
      r
    );
    return { groupedData: s, groups: n };
  },
  computed: {
    innerConfig() {
      return { ...j1, ...this.config };
    },
    groupList() {
      return this.groups.map((e) => ({
        key: e,
        data: this.groupedData[e]
      }));
    },
    listConfig() {
      return {
        summary: "disabled",
        display: { separators: "disabled" }
      };
    },
    columnCssStyle() {
      return {
        flex: `0 0 ${this.innerConfig.column.width}px`
      };
    }
  }
});
function U1(e) {
  try {
    return e.filter((t) => {
      var i;
      return (i = t.width) == null ? void 0 : i.endsWith("%");
    }).reduce((t, i) => {
      const r = i.width ?? "0%", s = Number(r.substring(0, r.length - 1));
      return t + s;
    }, 0);
  } catch {
    return console.warn("Could not calculate columns width"), 0;
  }
}
const q1 = f({
  props: {
    headerList: {
      type: Array,
      default() {
        return [];
      }
    },
    config: {
      type: Object,
      required: !0
    }
  },
  created() {
    const e = U1(this.headerList);
    e !== 0 && e !== 100 && console.warn("Table columns width do not add up to 100%");
  },
  computed: {
    selectionVisible() {
      return this.config.selection.mode === "multiple";
    }
  },
  methods: {
    colStyle(e) {
      return {
        width: e.width
      };
    }
  }
});
var H1 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("colgroup", [e.selectionVisible ? t("col", { staticClass: "selection-column" }) : e._e(), e._l(e.headerList, function(i, r) {
    return t("col", { key: r, style: e.colStyle(i) });
  })], 2);
}, z1 = [], N1 = /* @__PURE__ */ x(
  q1,
  H1,
  z1,
  !1,
  null,
  "6d79aa40"
);
const V1 = N1.exports, G1 = f({
  props: {
    sort: {
      type: String,
      required: !1
    }
  },
  computed: {
    sortIcon() {
      return this.sort === "ASC" ? "fa-regular fa-sort-up" : this.sort === "DESC" ? "fa-regular fa-sort-down" : "fa-regular fa-sort";
    }
  },
  methods: {
    onClick(e) {
      this.$emit("click", e);
    }
  }
});
var W1 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("app-icon-button", { staticClass: "sort-button", attrs: { size: 28 }, on: { click: e.onClick } }, [t("fa-icon-compat", { staticClass: "icon", attrs: { icon: e.sortIcon } })], 1);
}, Q1 = [], X1 = /* @__PURE__ */ x(
  G1,
  W1,
  Q1,
  !1,
  null,
  "6f29b28c"
);
const K1 = X1.exports, Y1 = f({
  components: {
    DataControlCheckbox: Mi,
    TableSortButton: K1
  },
  props: {
    headerList: {
      type: Array,
      default() {
        return [];
      }
    },
    selectionStatus: {
      type: String,
      default: "no"
    },
    sortStatus: {
      type: Object,
      required: !1
    },
    config: {
      type: Object,
      required: !0
    }
  },
  computed: {
    selectionEnabled() {
      return this.config.selection.mode === "multiple";
    },
    selectionToggleVisible() {
      return this.config.selection.selectAllButton;
    }
  },
  methods: {
    thStyle(e) {
      return {
        textAlign: e.align,
        paddingRight: e.sortKey ? "36px" : void 0,
        position: e.sortKey ? "relative" : void 0
      };
    },
    colSortDirection(e) {
      var t, i;
      if (e.sortKey)
        return ((t = this.sortStatus) == null ? void 0 : t.field) === e.sortKey ? (i = this.sortStatus) == null ? void 0 : i.direction : void 0;
    },
    toggleCheckbox() {
      this.$emit("click:all");
    },
    onClickSort(e) {
      this.$emit("click:sort", e.sortKey);
    }
  }
});
var Z1 = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("thead", [t("tr", [e.selectionEnabled ? t("th", { staticClass: "selection-th" }, [e.selectionToggleVisible ? t("data-control-checkbox", { attrs: { "selection-status": e.selectionStatus }, on: { click: e.toggleCheckbox } }) : e._e()], 1) : e._e(), e._l(e.headerList, function(i, r) {
    return t("th", { key: r, style: e.thStyle(i) }, [t("span", { staticClass: "header-label" }, [e._v(e._s(i.label))]), i.sortKey ? t("table-sort-button", { staticClass: "sort-button", attrs: { sort: e.colSortDirection(i) }, on: { click: function(s) {
      return e.onClickSort(i);
    } } }) : e._e()], 1);
  })], 2)]);
}, J1 = [], _1 = /* @__PURE__ */ x(
  Y1,
  Z1,
  J1,
  !1,
  null,
  "f5709ebd"
);
const $1 = _1.exports, eI = f({
  props: {
    header: {
      type: Object,
      required: !0
    },
    record: {
      type: Object,
      required: !0
    }
  },
  computed: {
    value() {
      return this.record[this.header.key];
    },
    tdStyle() {
      return {
        textAlign: this.header.align
      };
    },
    formattedValue() {
      return this.value ?? "-";
    }
  }
});
var tI = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("td", { style: e.tdStyle, attrs: { title: e.formattedValue } }, [e.header.component ? t(e.header.component, e._g({ tag: "component", attrs: { header: e.header, value: e.value, item: e.record } }, e.$listeners)) : [t("span", [e._v(" " + e._s(e.formattedValue) + " ")])]], 2);
}, iI = [], rI = /* @__PURE__ */ x(
  eI,
  tI,
  iI,
  !1,
  null,
  "7380a28e"
);
const sI = rI.exports, nI = f({
  components: {
    TableRowItem: sI,
    DataControlCheckbox: Mi
  },
  props: {
    headerList: {
      type: Array,
      default() {
        return [];
      }
    },
    record: {
      type: Object,
      required: !0
    },
    config: {
      type: Object,
      required: !0
    },
    selection: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    clickable() {
      return !!this.$listeners["click:row"];
    },
    selectionVisible() {
      return this.config.selection.mode === "multiple";
    },
    selectionStatus() {
      var e;
      return (e = this.selection) != null && e.includes(this.record.id) ? "yes" : "no";
    }
  },
  methods: {
    onClickRow() {
      this.$emit("click:row", this.record);
    },
    onToggleCheckbox() {
      this.$emit("click:select", this.record.id);
    }
  }
});
var aI = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("tr", { class: { clickable: e.clickable }, attrs: { tabindex: "0" }, on: { click: function(i) {
    return i.stopPropagation(), e.onClickRow.apply(null, arguments);
  }, keypress: [function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "enter", 13, i.key, "Enter") ? null : (i.stopPropagation(), e.onClickRow.apply(null, arguments));
  }, function(i) {
    return !i.type.indexOf("key") && e._k(i.keyCode, "space", 32, i.key, [" ", "Spacebar"]) ? null : (i.stopPropagation(), i.preventDefault(), e.onToggleCheckbox.apply(null, arguments));
  }] } }, [e.selectionVisible ? t("td", { staticClass: "selection-td" }, [t("data-control-checkbox", { attrs: { "selection-status": e.selectionStatus }, on: { click: function(i) {
    return i.stopPropagation(), e.onToggleCheckbox.apply(null, arguments);
  } } })], 1) : e._e(), e._l(e.headerList, function(i, r) {
    return t("table-row-item", e._g({ key: r, attrs: { header: i, record: e.record } }, e.$listeners));
  })], 2);
}, oI = [], lI = /* @__PURE__ */ x(
  nI,
  aI,
  oI,
  !1,
  null,
  "6232bc55"
);
const cI = lI.exports, uI = f({
  components: {
    TableRow: cI
  },
  props: {
    headerList: {
      type: Array,
      default: () => []
    },
    recordList: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      required: !0
    },
    selection: {
      type: Array,
      default: () => []
    }
  }
});
var dI = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("tbody", e._l(e.recordList, function(i, r) {
    return t("table-row", e._g({ key: r, attrs: { "header-list": e.headerList, record: i, config: e.config, selection: e.selection } }, e.$listeners));
  }), 1);
}, hI = [], pI = /* @__PURE__ */ x(
  uI,
  dI,
  hI,
  !1,
  null,
  "2ef917a9"
);
const fI = pI.exports, mI = {
  summary: "simple",
  selection: {
    mode: "disabled",
    selectAllButton: !1
  }
}, gI = f({
  components: {
    DataControlSummary: dn,
    TableColgroup: V1,
    TableHead: $1,
    TableBody: fI
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      required: !1
    }
  },
  setup(e) {
    const { data: t, value: i } = Mt(e), { selection: r, selectionStatus: s, itemStatus: n, toggleAll: a, toggleItem: o } = Or(t.value, i.value), { sortStatus: l, toggleSort: c } = qg();
    return {
      selection: r,
      selectionStatus: s,
      itemStatus: n,
      toggleAll: a,
      toggleItem: o,
      sortStatus: l,
      toggleSort: c
    };
  },
  computed: {
    innerConfig() {
      return { ...mI, ...this.config };
    },
    summaryEnabled() {
      return this.innerConfig.summary === "simple";
    },
    showHeader() {
      return this.headers.some((e) => e.label);
    }
  },
  methods: {
    onToggleSelectAll() {
      this.toggleAll(), this.updateModel(), this.$emit("click:all");
    },
    onToggleSelectItem(e) {
      this.toggleItem(e), this.updateModel(), this.$emit("click:select", e);
    },
    onClickRow(e) {
      this.$emit("click:row", e);
    },
    onClickSort(e) {
      this.toggleSort(e), this.$emit("click:sort", this.sortStatus);
    },
    updateModel() {
      this.$emit("input", [...this.selection]);
    }
  }
});
var yI = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "table-container" }, [e.summaryEnabled ? t("data-control-summary", { staticClass: "data-control-summary", attrs: { selection: e.selection, data: e.data, config: { selectAllButton: !1 } }, on: { "select-all": e.onToggleSelectAll } }) : e._e(), t("table", { staticClass: "table-style" }, [t("table-colgroup", { attrs: { config: e.innerConfig, "header-list": e.headers } }), e.showHeader ? t("table-head", { attrs: { config: e.innerConfig, "header-list": e.headers, "selection-status": e.selectionStatus, "sort-status": e.sortStatus }, on: { "click:all": e.onToggleSelectAll, "click:sort": e.onClickSort } }) : e._e(), t("table-body", e._g({ attrs: { config: e.innerConfig, "header-list": e.headers, "record-list": e.data, selection: e.selection }, on: { "click:select": e.onToggleSelectItem, "click:row": e.onClickRow } }, e.$listeners))], 1)], 1);
}, bI = [], vI = /* @__PURE__ */ x(
  gI,
  yI,
  bI,
  !1,
  null,
  "bde91c0f"
);
const AI = vI.exports, kI = f({
  components: {
    DataControlCheckbox: Mi
  },
  props: {
    selectionEnabled: {
      type: Boolean,
      required: !0
    },
    selectionStatus: {
      type: String,
      default: "no"
    }
  },
  methods: {
    onToggleCheckbox() {
      this.$emit("click:select");
    }
  }
});
var wI = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "data-item-container" }, [e.selectionEnabled ? t("data-control-checkbox", { staticClass: "data-control-checkbox", attrs: { "selection-status": e.selectionStatus }, on: { click: function(i) {
    return i.stopPropagation(), e.onToggleCheckbox.apply(null, arguments);
  } } }) : e._e(), t("div", { staticClass: "item-slot" }, [e._t("default")], 2)], 1);
}, xI = [], CI = /* @__PURE__ */ x(
  kI,
  wI,
  xI,
  !1,
  null,
  "3eb91b81"
);
const SI = CI.exports, II = {
  summary: "simple",
  selection: {
    mode: "disabled",
    selectAllButton: !1
  },
  display: {
    separators: "visible"
  }
}, DI = f({
  components: {
    DataControlSummary: dn,
    AppDataListItem: SI
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      required: !1
    }
  },
  setup(e) {
    const { data: t, value: i } = Mt(e), { selection: r, selectionStatus: s, itemStatus: n, toggleAll: a, toggleItem: o } = Or(t.value, i.value);
    return { selection: r, selectionStatus: s, itemStatus: n, toggleAll: a, toggleItem: o };
  },
  watch: {
    value(e) {
      this.selection = e;
    }
  },
  computed: {
    innerConfig() {
      return { ...II, ...this.config };
    },
    summaryEnabled() {
      return this.innerConfig.summary === "simple";
    },
    selectionEnabled() {
      return this.innerConfig.selection.mode === "multiple";
    },
    hasPrependSlot() {
      return !!this.$slots.prepend;
    }
  },
  methods: {
    separatorVisible(e) {
      return e && this.innerConfig.display.separators === "visible";
    },
    onToggleSelectAll() {
      this.toggleAll(), this.updateModel(), this.$emit("click:all");
    },
    onToggleCheckbox(e) {
      this.toggleItem(e), this.updateModel(), this.$emit("click:select", e);
    },
    updateModel() {
      this.$emit("input", [...this.selection]);
    }
  }
});
var PI = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-data-list" }, [e.summaryEnabled ? t("data-control-summary", { staticClass: "data-control-summary", attrs: { selection: e.selection, data: e.data, config: e.innerConfig.selection }, on: { "select-all": e.onToggleSelectAll } }) : e._e(), e.hasPrependSlot ? t("div", { staticClass: "item-container slot-prepend" }, [t("app-data-list-item", { attrs: { "selection-enabled": !1 } }, [e._t("prepend")], 2)], 1) : e._e(), e._l(e.data, function(i, r) {
    return t("div", { key: i.id, staticClass: "item-container" }, [e.separatorVisible(r) ? t("div", { staticClass: "separator" }) : e._e(), t("app-data-list-item", { attrs: { "selection-enabled": e.selectionEnabled, "selection-status": e.itemStatus(i.id) }, on: { "click:select": function(s) {
      return e.onToggleCheckbox(i.id);
    } } }, [e._t("default", null, { item: i })], 2)], 1);
  })], 2);
}, TI = [], OI = /* @__PURE__ */ x(
  DI,
  PI,
  TI,
  !1,
  null,
  "cd4e8705"
);
const BI = OI.exports, MI = f({
  components: {
    AppDataTable: AI,
    AppDataList: BI,
    AppDataGrid: Lc
  },
  props: {
    value: {
      type: Array,
      required: !1
    },
    view: {
      type: String,
      required: !0
    },
    data: {
      type: Array,
      default: () => []
    },
    tableHeaders: {
      type: Array,
      default: () => []
    },
    tableMapper: {
      type: Function,
      default: (e) => e
    },
    tableConfig: {
      type: Object,
      required: !1
    },
    listConfig: {
      type: Object,
      required: !1
    },
    gridConfig: {
      type: Object,
      required: !1
    }
  },
  data() {
    return {
      selection: []
    };
  },
  watch: {
    value(e) {
      this.selection = e;
    },
    selection(e) {
      this.$emit("input", e);
    }
  },
  computed: {
    tableData() {
      return this.data.map(this.tableMapper);
    },
    dataViewCssClass() {
      return `view-${this.view}`;
    }
  }
});
var RI = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-data-view", class: e.dataViewCssClass }, [e.view === "table" ? [t("app-data-table", e._g({ attrs: { data: e.tableData, headers: e.tableHeaders, config: e.tableConfig }, model: { value: e.selection, callback: function(i) {
    e.selection = i;
  }, expression: "selection" } }, e.$listeners))] : e.view === "list" ? [t("app-data-list", { attrs: { data: e.data, config: e.listConfig }, scopedSlots: e._u([{ key: "default", fn: function({ item: i }) {
    return [e._t("list-item", null, { item: i })];
  } }], null, !0), model: { value: e.selection, callback: function(i) {
    e.selection = i;
  }, expression: "selection" } })] : e.view === "grid" ? [t("app-data-grid", { attrs: { data: e.data, config: e.gridConfig }, scopedSlots: e._u([{ key: "default", fn: function({ item: i }) {
    return [e._t("grid-item", null, { item: i })];
  } }], null, !0), model: { value: e.selection, callback: function(i) {
    e.selection = i;
  }, expression: "selection" } })] : e._e()], 2);
}, EI = [], LI = /* @__PURE__ */ x(
  MI,
  RI,
  EI,
  !1,
  null,
  "c3b21c37"
);
const FI = LI.exports, jI = f({
  props: {
    data: {
      type: Array,
      default: () => []
    },
    groupBy: {
      type: Array,
      required: !0
    },
    groupKeys: {
      type: Array,
      required: !0
    }
  },
  setup(e) {
    const { data: t, groupBy: i, groupKeys: r } = Mt(e), { groupedData: s, nonEmptyGroups: n } = _l(
      t,
      i,
      r
    );
    return { groupedData: s, nonEmptyGroups: n };
  },
  computed: {
    visibleGroups() {
      return this.nonEmptyGroups.map((e) => ({
        key: e,
        data: this.groupedData[e]
      }));
    }
  }
});
var UI = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "app-data-groups" }, e._l(e.visibleGroups, function(i) {
    return t("div", { key: i.key, staticClass: "data-group" }, [t("div", { staticClass: "header-slot" }, [e._t("group-header", null, { groupKey: i.key, groupData: i.data })], 2), t("div", { staticClass: "view-slot" }, [t("app-data-view", e._g(e._b({ attrs: { data: i.data }, scopedSlots: e._u([{ key: "list-item", fn: function({ item: r }) {
      return [e._t("list-item", null, { item: r })];
    } }, { key: "grid-item", fn: function({ item: r }) {
      return [e._t("grid-item", null, { item: r })];
    } }], null, !0) }, "app-data-view", e.$attrs, !1), e.$listeners))], 1)]);
  }), 0);
}, qI = [], HI = /* @__PURE__ */ x(
  jI,
  UI,
  qI,
  !1,
  null,
  "f076050b"
);
const zI = HI.exports;
f({
  components: {
    AppDataView: FI,
    AppDataGroups: zI
  },
  props: {
    value: {
      type: Array,
      required: !1
    },
    view: {
      type: String,
      required: !0
    },
    grouping: {
      type: String,
      required: !0
    },
    data: {
      type: Array,
      default: () => []
    },
    groupBy: {
      type: Array,
      required: !1
    },
    groupKeys: {
      type: Array,
      required: !1
    },
    tableConfig: {
      type: Object,
      required: !1
    },
    tableHeaders: {
      type: Array,
      default: () => []
    },
    tableMapper: {
      type: Function,
      default: (e) => e
    },
    listConfig: {
      type: Object,
      required: !1
    },
    gridConfig: {
      type: Object,
      required: !1
    }
  },
  data() {
    return {
      selection: []
    };
  },
  watch: {
    value(e) {
      this.selection = e;
    },
    selection(e) {
      this.$emit("input", e);
    }
  }
});
f({
  props: {
    value: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      selected: ""
    };
  },
  created() {
    this.selected = this.value;
  },
  watch: {
    value(e) {
      this.selected = e;
    },
    selected(e) {
      this.$emit("input", e);
    }
  },
  computed: {
    options() {
      return [
        {
          value: "status",
          text: this.$t("dataView.dataGroup.groupByStatus").toString()
        }
      ];
    }
  }
});
const ds = ["table", "list", "grid"];
f({
  props: {
    value: {
      type: String,
      required: !0
    },
    available: {
      type: Array,
      default: () => ds,
      validator: (e) => e.length > 0 && e.every((t) => ds.includes(t))
    }
  },
  data() {
    return {
      selection: ""
    };
  },
  created() {
    this.selection = this.value || this.available[0];
  },
  watch: {
    value(e) {
      this.selection = e;
    },
    selection(e) {
      const t = ds.includes(e) ? e : this.available[0];
      pt(() => {
        this.selection = t, this.$emit("input", t);
      });
    }
  },
  computed: {
    options() {
      return [
        {
          value: "table",
          text: this.$t("dataView.table.label").toString()
        },
        {
          value: "list",
          text: this.$t("dataView.list.label").toString()
        },
        {
          value: "grid",
          text: this.$t("dataView.grid.label").toString()
        }
      ].filter((e) => this.available.includes(e.value));
    }
  }
});
const hs = ["table", "list", "grid"];
f({
  props: {
    value: {
      type: String,
      required: !0
    },
    size: {
      type: Number,
      default: 26
    },
    available: {
      type: Array,
      default: () => hs,
      validator: (e) => e.length > 0 && e.every((t) => hs.includes(t))
    }
  },
  data() {
    return {
      selection: ""
    };
  },
  created() {
    this.selection = this.value || this.available[0];
  },
  watch: {
    value(e) {
      this.selection = e;
    },
    selection(e) {
      const t = hs.includes(e) ? e : this.available[0];
      pt(() => {
        this.selection = t, this.$emit("input", t);
      });
    }
  },
  computed: {
    buttons() {
      return this.available.map((e) => this.getViewInfo(e));
    }
  },
  methods: {
    getViewInfo(e) {
      switch (e) {
        case "table":
          return {
            value: "table",
            icon: "fal fa-table",
            hint: this.$t("dataView.table.label").toString()
          };
        case "list":
          return {
            value: "list",
            icon: "fal fa-list-ul",
            hint: this.$t("dataView.list.label").toString()
          };
        case "grid":
          return {
            value: "grid",
            icon: "fal fa-grid-2",
            hint: this.$t("dataView.grid.label").toString()
          };
      }
    }
  }
});
f({
  props: {
    value: {
      type: Boolean,
      default: !1
    },
    item: null
  },
  methods: {
    onClick(e) {
      this.$emit("click:toggle", {
        value: this.item,
        status: e
      });
    }
  }
});
let wt = [];
const NI = {
  sessions: wt,
  chatVisibility: {},
  openChat(e) {
    this.chatVisibility = Object.keys(this.chatVisibility).reduce(
      (t, i) => (t[i] = i === e, t),
      { [e]: !0 }
    );
  },
  closeChat() {
    this.chatVisibility = {};
  },
  pushMessage: (e, t) => {
    wt = wt.map((i) => (i.key === e && i.messages.push(t), i));
  },
  createSession: (e) => (wt.some((t) => t.key === e.key) || wt.push(e), e),
  hasSession: (e) => wt.some((t) => t.key === e),
  loadSession: (e) => wt.find((t) => t.key === e)
}, VI = {
  context: {},
  getContext(e) {
    return this.context[e];
  },
  provideContext(e, t) {
    this.context[t] = e;
  },
  contextUpdated: () => {
  }
}, GI = "data:image/svg+xml,%3csvg%20width='25'%20height='25'%20viewBox='0%200%2025%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cg%20clip-path='url(%23clip0_737_4127)'%3e%3cpath%20d='M10.9263%2014.2844C10.9418%2014.2359%2011.0103%2014.2359%2011.0257%2014.2844L11.2705%2015.0519C11.2757%2015.068%2011.2883%2015.0806%2011.3044%2015.0858L12.072%2015.3306C12.1204%2015.3461%2012.1204%2015.4146%2012.072%2015.43L11.3044%2015.6748C11.2883%2015.68%2011.2757%2015.6926%2011.2705%2015.7087L11.0257%2016.4763C11.0103%2016.5247%2010.9418%2016.5247%2010.9263%2016.4763L10.6815%2015.7087C10.6763%2015.6926%2010.6637%2015.68%2010.6476%2015.6748L9.88006%2015.43C9.83165%2015.4146%209.83165%2015.3461%209.88006%2015.3306L10.6476%2015.0858C10.6637%2015.0806%2010.6763%2015.068%2010.6815%2015.0519L10.9263%2014.2844Z'%20fill='%237910FF'/%3e%3c/g%3e%3cg%20clip-path='url(%23clip1_737_4127)'%3e%3cpath%20d='M11.2466%208.02654C11.2621%207.97813%2011.3306%207.97813%2011.346%208.02654L11.5908%208.79413C11.596%208.81022%2011.6086%208.82283%2011.6247%208.82797L12.3923%209.0728C12.4407%209.08824%2012.4407%209.15674%2012.3923%209.17218L11.6247%209.41701C11.6086%209.42215%2011.596%209.43476%2011.5908%209.45085L11.346%2010.2184C11.3306%2010.2668%2011.2621%2010.2668%2011.2466%2010.2184L11.0018%209.45085C10.9967%209.43476%2010.984%209.42215%2010.968%209.41701L10.2004%209.17218C10.152%209.15674%2010.152%209.08824%2010.2004%209.0728L10.968%208.82797C10.984%208.82283%2010.9967%208.81022%2011.0018%208.79413L11.2466%208.02654Z'%20fill='%237910FF'/%3e%3c/g%3e%3cg%20clip-path='url(%23clip2_737_4127)'%3e%3cmask%20id='mask0_737_4127'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='4'%20y='4'%20width='17'%20height='17'%3e%3cpath%20d='M4.5%204.62891H20.5V20.6289H4.5V4.62891Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_737_4127)'%3e%3cmask%20id='mask1_737_4127'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='4'%20y='4'%20width='17'%20height='17'%3e%3cpath%20d='M4.5%204.62891H20.5V20.6289H4.5V4.62891Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask1_737_4127)'%3e%3cmask%20id='mask2_737_4127'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='4'%20y='4'%20width='17'%20height='17'%3e%3cmask%20id='mask3_737_4127'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='4'%20y='4'%20width='17'%20height='17'%3e%3cpath%20d='M4.5%204.62891H20.5V20.6289H4.5V4.62891Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask3_737_4127)'%3e%3crect%20x='4.5'%20y='4.62891'%20width='16.0001'%20height='16'%20fill='url(%23pattern0_737_4127)'/%3e%3c/g%3e%3c/mask%3e%3cg%20mask='url(%23mask2_737_4127)'%3e%3cmask%20id='mask4_737_4127'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='4'%20y='4'%20width='17'%20height='17'%3e%3crect%20width='16.0001'%20height='16'%20transform='matrix(1%200%200%20-1%204.5%2020.6289)'%20fill='url(%23pattern1_737_4127)'/%3e%3c/mask%3e%3cg%20mask='url(%23mask4_737_4127)'%3e%3crect%20x='4.5'%20y='4.62891'%20width='16.0001'%20height='16'%20fill='url(%23pattern2_737_4127)'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cpath%20d='M16.1416%209.74963C16.2257%209.50287%2016.4345%209.34426%2016.7207%209.34426C17.0739%209.34426%2017.2761%209.58486%2017.2765%209.94028V9.95162L16.7915%2010.1293C16.7993%2010.0993%2016.8027%2010.068%2016.8017%2010.037C16.8017%209.87839%2016.7075%209.77272%2016.5358%209.77272C16.4044%209.77272%2016.3069%209.83162%2016.2397%209.95063C16.1756%2010.0661%2016.142%2010.2044%2016.142%2010.3658V10.8535H15.5967V9.38386H16.1416V9.74963Z'%20fill='white'/%3e%3cpath%20d='M14.8027%208.23987C14.8869%207.9931%2015.0956%207.8345%2015.3818%207.8345H15.3822C15.7354%207.8345%2015.9376%208.07509%2015.9376%208.43052V8.44186L15.4526%208.61957C15.4604%208.58952%2015.4638%208.55828%2015.4628%208.52723C15.4628%208.36863%2015.3687%208.26295%2015.1969%208.26295C15.0656%208.26295%2014.9681%208.32186%2014.9008%208.44086C14.8367%208.55629%2014.8031%208.6946%2014.8031%208.85599V9.34375H14.2578V7.8741H14.8027V8.23987Z'%20fill='white'/%3e%3cpath%20d='M9.41856%2017.4238C9.21697%2017.3387%209.13916%2017.0091%209.01856%2016.825C8.83408%2016.4344%208.54791%2016.2228%208.17697%2016.0503C8.03209%2015.9635%207.75746%2015.8772%207.72363%2015.7138C7.80722%2015.479%208.23727%2015.385%208.43826%2015.2368C8.74951%2015.0716%208.9314%2014.7956%209.08981%2014.4688C9.18055%2014.3203%209.25956%2014.0553%209.42832%2014.0171C9.59707%2014.0553%209.67548%2014.3207%209.76623%2014.4686C9.92404%2014.7956%2010.1055%2015.071%2010.4166%2015.2364C10.6182%2015.3846%2011.0464%2015.4778%2011.1304%2015.7128C11.0962%2015.8766%2010.8212%2015.9625%2010.6767%2016.0497C10.3051%2016.2224%2010.0192%2016.434%209.83369%2016.8248C9.71329%2017.0091%209.63449%2017.3389%209.43289%2017.4238H9.41856Z'%20fill='white'/%3e%3cpath%20d='M14.204%2010.88C14.3674%2011.0235%2014.5698%2011.1411%2014.8578%2011.283C15.3515%2011.5346%2015.9606%2011.8122%2016.4301%2012.0707C16.6038%2012.1716%2016.7027%2012.2558%2016.7061%2012.3409C16.6729%2012.5702%2016.2201%2012.7467%2015.9758%2012.9021C15.1863%2013.3972%2014.2024%2013.6528%2013.8375%2014.5927C13.5672%2015.167%2013.2788%2015.8482%2013.0102%2016.4072C12.9117%2016.6034%2012.8335%2016.7182%2012.7543%2016.7246L12.7371%2016.7244C12.6577%2016.7176%2012.573%2016.6024%2012.4637%2016.4066C12.2052%2015.925%2011.9119%2015.3208%2011.653%2014.8205C11.2253%2013.7636%2010.2762%2013.57%209.37912%2013.0864C9.12062%2012.9421%208.65375%2012.7817%208.59982%2012.5557C8.59425%2012.4641%208.70012%2012.369%208.88858%2012.25C9.40619%2011.9373%2010.0319%2011.6156%2010.5626%2011.3043C11.1073%2011.0126%2011.3212%2010.6623%2011.5646%2010.0973C11.7978%209.59068%2012.0593%208.97635%2012.2971%208.49177C12.5019%208.08461%2012.6203%208.09854%2012.8412%208.49237C13.1354%209.03088%2013.4402%209.67605%2013.7328%2010.2281C13.8854%2010.525%2014.0201%2010.7188%2014.204%2010.88Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cpattern%20id='pattern0_737_4127'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_737_4127'%20transform='scale(0.00195312)'/%3e%3c/pattern%3e%3cpattern%20id='pattern1_737_4127'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image1_737_4127'%20transform='scale(0.00195312)'/%3e%3c/pattern%3e%3cpattern%20id='pattern2_737_4127'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image2_737_4127'%20transform='scale(0.00195312)'/%3e%3c/pattern%3e%3cclipPath%20id='clip0_737_4127'%3e%3crect%20width='3.04676'%20height='2.50346'%20fill='white'%20transform='translate(9.73926%2014.1445)'/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_737_4127'%3e%3crect%20width='3.04676'%20height='2.50346'%20fill='white'%20transform='translate(10.0596%207.88672)'/%3e%3c/clipPath%3e%3cclipPath%20id='clip2_737_4127'%3e%3crect%20width='16'%20height='16'%20fill='white'%20transform='matrix(1%200%200%20-1%204.5%2020.627)'/%3e%3c/clipPath%3e%3cimage%20id='image0_737_4127'%20width='512'%20height='512'%20xlink:href='data:image/png;base64,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'/%3e%3cimage%20id='image1_737_4127'%20width='512'%20height='512'%20xlink:href='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAAAAADRE4smAAAAAXNCSVQI5gpbmQAAIABJREFUeJzkvfmzptdxHtb93jsLZjAzmAFmsMwMgMFgB7iABEARgLhINBdJFClS5mJRXEzLFmVTLkeUFcmRSNtRlkqcvyA/JJXKUhW7UikxUeyU4vxgV2hSDE0SoERSFAFC3AGQIAHMDDCDzg/ndPfz9DnfnQWzgXlJzP2+9z1Ln+6nn+6zvPeq/P/n2mzPbZWjIpfa07J1Xe+7/KvLNlOTZ56/+fF/q8ePiGzTp2Xb80c36bMXWtbzdumFFuCcX5tN5dndun/3ct3uy7Zddmh97fiew7Z+iT0t20XURNSe0W2mzzz//NceW9eHH3/qhz982B5/ZNOzJ+zo2okLLf85vn6CAbC+aVnfffXOPfuuv+zqSy47IJc9K1uOyyYR0/Y/sTZ6cyWYiumzuumobHnq+LHv/uCR7z31+MNff/LYk/b88xduHOf2+okEwGZbtl5x6JpDh/ZffdW2RdU2mxqM1HjUpmJNEaYCJe2ErR97+tknvv/odx75+iOPH336xE8gDH7SALC2acve/Tffce2eg5evL+vrfXhpWP5RL5OsANdxs6ee/f5X/vKRP/vykWee/clCwU8QADYvl2279v7rb7x2z9ratol9jYwbEBiwYJKMIBgd7Nlnjv75Q1//yle/c/zoTwwKfkIAsLb1shtvetVNB/ds3rTuZN6uZkPDmyaaKJD8IlpRglcvZCd+/KNv/r9f//yDR48dO6dDOk/Xix8Am9d27rzh1T91eMfOtU1Ttzftbu6+jmFeseSqq3KHyLGjT33uz77w1S8/9/TZGsaFul7kALhk975bf+aGW3ZvWYuBmHt8pvkZ+WUsdSoq8EI0d7AfP/GlL33xL7905OjZGs2FuF7EAFjbc9kD991yYO+mzbqR+8KzWgqof/KgRoNZqmBPPfmFz/zpQ08+/aJdOXqxAmDr3oN/7dW37FvbrNUyaTxTIO2NILL6mvJDNNf+Of7UDz/7p5/74mPPnUkHF/x6UQJg29X33ff63ZcvynbOqzp9DQCrr8TKuFgQ/5hIBI+WWxx78i/+5LMPff9HL2BQF+h68QFg+1Wvvf81V2/zzK5dExD022zJdkPURLM2e/RG16qZo5jK8Scf/tSDn/nqiw0DLzIAbL/ydfe/7qpLdO6leY1xf160BgdeHGaMbHR1cX781U89+L//8EWFgRcTALZf9dpm/eFi4p4n9/FkVVpwiiFi42L2o7/4t3/2x0/8+BSaujiuFw0Atl9978+87qpg/nEmP13oo5urjHeSTLFMHk8KAfnuX33yk9/8zqkN64JfLwoALFt33f/mu2+6hG09W8TJTR0picGKPLGxxYZqmK0alcckiqn8+PH/40t/9MSLIhS8CACw7Ln9rvvu24+SzjMAE6lBm3/Ua+rMsYbES8OworwBYjLOPPnD//WL//J7F/9q8UUPgO0HX/nWV12xfXWSXr2fHg1VyJ1HeHTS6LYfOzzJ4pCL0QD03a/+n//9oxf76sDFDYBl513vuv/wqrRvw3BMT2bRYvjSb813hPHhBBdIFnD9+In/8d889I2LeufwYgbAcu19v/CqQ+PBHbY87OvKKpaAivSN7Bn1TVcuD69YM9gAh9/44r/+ny/mSHDxAmD7Dfe9665di8wm9StmcBt6Pa8V1aIbJwtY1FqiMQYXOFSEALLnHvwX/+LhixYCFykAll13v/O+G7bFhG8F644mXRm4V83wGBeTO4SNyBCHx/lwfHT0S3/yL7/83YszG7goAbDse8U73nBQVUYqztjf0/T8SkVkg4m9kFELPEpTp5JkTImFkWB/8e8++blHL8Z944sQAMu+V//qq/ct8R0tRK63YrFvHh6gQL27wTRxhqIhZ5DSawOkMJKO/uWDn/zU1y6+fPCiA8Cy775fue9KnXoVXBt6nfFKIR4HWjF/mz2LzGEINqKzNkrD8KF1f+I7X/6j//uLFxsELjIALHsf+Bv37VtMJVdbmJGrh9eIveqqlp/O8tiLx7SxVppnF/MMQUTs2Jf+u399kUHgogLAsveB9z6wV2dn9ONiah0vWgz2e+OEoH2epQuDUYdEdCPsrHrWWhA59qX/4U++cDFB4CICwLL3p9/9AMR+4TAfATmd08EwSRCg2sQhV70WkFwjMub7s4KzQh263hctEpk+9ZX/+o+/c/GkgxcNAJa9D7znp/cuG5Q4BaafzNLy2WSsK6hhLGNCqgp/lw2mCVGgwO35T33xs3/yrYsFAhcJAJa9r3lXev9GZDtN5E8pC9ioIKAGnXdVMO+3pnPUfOCiltZMj3z7//r0Fz91iiKf4+uiAMCy59Xv+dm9CmatOffKWVudApSgMWthFuTLdYpkU75uWIvHdfTb//x/+spTJ+3kPFwXAwB2vvQDb75mQceXSSYneScmaFMr8pw8hlhS/KkkA/r45tgv0gbUyInjytcOnv/3//x/e/AiyAYvPACWQ+9736G1/D4YamV0Hv1/ejvmDVyGhz5SzMpZwYCfcSVyxMWEIX78mT/+X755wVOBtZMXOafXctXb/uCdVy+gG03jaDOdWpsZjucw0hLupab9S3vijWmU8UKaEwjTShPYiIqYqnduoqIZUnrjypJpSqUpCBUxlS3XX3rj5evfOiO1nb3rAjPAzlf8ndftG1J/nqxteDa35Iu5QTCWmOdxZPqTZX0zbVXhpkGHy8aDI4/80Sc/e2FfL7ygAFhuev+7blhWv6jdLwtnnfIslxSJ2RnZ1JP7EtHn3Y0fC9CqbPQIb4yNcQNH/92/+m8uKAlcwBCwXPlL/9U7ruiMKmI6e92ik3ALBcHiojowKuReqkm5bm/vR/u35PhqUo4g/VJ6Knhfg6mEwolAf/6td52dbbr+9uuPfO8Cvll44Rhg590ffMsVIhNPHD0p9V/Wh/H7Ko8en9ErRcVNVxwFmtLCSbtbQRfJQiIi9s3/9l99+oIlgxeKAZZrf+PjD2zj3Mx/uk3igaZPGaRYva5/H+N38+/IC/2e5W6DqKhRg6N1a3JAKw2T2YNg82hwygglhim77jq8ef2bo47Oy3WBALD77X/wy/uWfrzKepofliKbNHIXL6bVHuRNgnrv04eucwu1F6qevltaWAW/QVKhZWuKulKJzs2BSmFHPUhsObR3z7HHL0wcuCAAWF72T/7OS7eq9GDtcXGMuPE9Yzg/94ANBoLID8YISFnti5qLhx2bhfiVCmlMJgUgqKP4VM/UiGdMxeTgbYfX1y4ICVwAACzXvO0/f8POcduHEzKO0k4QJWkz1TS/8M6MaaSNYcmag8WEofQZRJ7R2u2P5ITBZcNdIRQbI5oPTmXLDVdcfeT7F4AEzj8Atrz6d3/z+mWSfTZt+us9YX9RZRNADHBvr+G1f1IsFo1GWLbgoM4WFFhU3FMpTcQ5a5JKRxZOAPErACUuU2+toeDAzYftue+dRHln/zrvANj7t//xay4ZWTe+aJnhabFrv5t1uxlFxVShWeANoSYUH2c3hQnUIt2gkuDIkCDkJ6QFPj9e2AsS3Sb2luv37Tn6/eNyfq/zDIDlzj/49WuqVqqRaCq24RzPnah6v5B1ZLCD5BotNxYNGfJONIEhxDgdDRLS0iYBrz6MD6YievCOO49965nZQM/ddX4BsOuv/7M3bm0f0+ZWp170Xbm4X0mgMuZhIi2L87KC828yiHDF4qBwe2JdBh0RVyLaBqBRBIppb5vkbL36lksfPnJefz/1+QTAcv1v/t6hTo5uMiU1w88Ncqp0zEBHhuG4PH4Dh3O0iX440/MmIWHojesEmZSrpll9HlqmEiFkwjdyDxUVWa586S2PPHk+XyM6jwDY8rN/+N6d/TMYOZyE40D1piFXJ7fVksNBUFERHc0tnlvmAkFBIK8V0IQf13/CjYXWn/M5viWmjhHfojQGlahtu/EVJx7/wai9c3WdPwBc8dHfuWeTf0kjgwloxdc/DflVAQpF6bi0NOG9BOLEzT/h/6QOaBApodcjJprylieo2bATIMYIrKayXH3bnq88aXKervMFgLWb/9GHDy4y2a6VMJeSTYNEsRxXIppAHNBSS1kqVnEDhP2bVErAqysGbuDoBqYBySRlbDoASTjHhSVL70N1923XyzfPVxg4TwDY8pZP/PyuNrOeOHyyMNxwVNjk/ayuNvIt/2SevpUaEOkjhpjTdq8AZhi82dnHZSWIKPEXCq3DElF0D4SG4zfdctsrjz3+hJyX6/wA4Jrf+O27t4jApN60L6OCca0YNLTisdU8orIKjcIz+CGRR8UYNORV8356cznhm1MPpHz1sfX9Cpd6dYAw1Rwk/7oDFZHdN29/4rHzcmLwfABgue3XP3x9nRC5bjQdT+cBYm5c8RxbOE4M1B8gw18WbsnYJZ/Lj9R2Mzolq+K3rJSONMF780KcO2ZjyBGd2/bccegH3zofL5SfBwBsecvvvHd3TPiI7cHRu9YoCvhdyNPxOc6psokadoNBkgQULIWpnQMlKvpPU8ltXr60p/bswo2vxHMLb53qD95AUXHrofvlOz8c+zvb17kHwJ4P/Yf3byI+xKtiP+8OsbFURhJmm5VtnGxyjDF+NwuXZDATufHAUjxXNF1uFvSVAw9cTDfUB1SJa23PTfqNcz8fPOcAuOqjf/dGVpxJVW/7oBaKRBvUqFDNAKyM1m7qJotPwEaUPsWiiJS9YYRSZAhjQurjENXYzxKIFwpN5WI2HoTdfXDLk9851/PBcwyA5SWf+OBeytIktWEKu67WV800MODEjwwv5EiGL+/DkqKbmyhiWHGu1+jguQihBA9w97QgFGhdNsl91hNQMaHVp7jdI4UPRUVkzysu3fG1c7xFfG4BsO3+//T1O2OYgINQbHxXEV9vm67sAiTQgXNekX7ps3wo3FQbgJkGCC1xwnTI8ahTNiIdOPG5QArg8AOJvX3Hfg46gs3ml1x74qvndkXgnAJg5y/+4T1bgy19z9a/cq4tIuEu7g29XORlq46DYntwGajaayscEYScz4lcEDhhyyCTeGpQksHUHgxkElyVXdMUJkaMkUJsueaOLef2HcJzCYA9H/rHh3GgSctk/3Yz3wby8cN3ONkFU4I8ryH57o7zPzII0U4kaW6ryivRh4bAPgQ4WQQmBzRE3RJPIonUHBUGjoxpDjUvsfv69T8/l6+OnEMAXPV7/+AKYXcgvfV/a6iHh0APoeyxNQ0ENTApAi1biS/Rv3MNvPUlVRZw0ta/wl1uEESN0wQ5hIR0GltNCT5Be3gUafcrr/3zH5y7VPCcAWC57Z+8Z0d4V0V4iZBUAC4dbmkGcgKHqXpKaXUmR1jIR7EypB6W4/TukGzM2uot5q0UKwGS4QtA7P1YLk6MGah45rLlttu+9r1zdkbgXAFg6wMff/OOzMPJ66VwaD6ZqaHeUoqWInGczzQzwtpV+xBLURazDkz8eDOKrpHRQ5y6NcxlZ4sHffmTOMFRQW/G9xJrB+94+NFzhYBzBICdP/Nf3LfFj+KQCkYOhfu0XIs/S0HFEK8ZV7ttHR6UUDk7AB0nh2CGVnsc0kur4cpoK5BWFEf7hwJyNiGZXvQJp7lspiKyds3d33r0HE0Hzw0Adr75P7tdYzSDq/vamCnaSYARNayzgoRnjJmzBzRwXXeCyt55cAfiEiXDDjhB8RK8nZMjcRMHzTAivHfgDo1/vFWTZe9dRx46NzsD5wQAOz/8h9f5Zzg+HUp1YLg75mHwvNBIgtrGu/7ZYtWd6rYvU0cM02Yi5k8ioxw5ik2Y+1iCaUcljC6DEfqy7HxQ/am6/i5/+ZGHzgkHnAsA7PjIJ/b0j7Hr6V8KXUo4uef3w+u36HWalUBdGm8YrZyHaUEM9c8GCw8EzBlaFX7yrckJUOw08/08r2IpNjMLCiRiojsfOPqFc4GAcwCAHb/++zv888SpJw4ivl4er4GAEQcCr19cgdq1PI0RSp7LQJkYLdrjSFRhJPx+AQ6tZi/4LBNHtD+L6tJ1PJpuufu5f38OEHD2AbDjP/i9S9sn/D2OGFGrynF1DF/oHLS+IjVsJB6NCyMolElVsg/OUuvKIIvAx8tNyaxV0IhM+ZROONZOvbrxXkFU2Hrvls+c/WXhsw6A7b/1sUtjohsEa5Qo4XBbOcoDhfySyMA/swLBDG7rtOPUwzN2R5LgzgxyYYPgs04nOMUhsgriUDZhRhYUtosb0OL5obigpltesfmzZ/33CJxtAGz/2McujeSFt9P4XTomUxX0xf7eNXiua8ddi3gzDRX90Snu5GroU1RyNtl8XcFLM/fswhbX9VpBGXTokEmPrsr28SlZKneEgzabKje/fPNZ54CzDIDtn/j7nf8bPbKZ+4/iU2l1yQ/qkEDFRKoI+zOw0gYZp6ZXBSeQoJwpZFO8miSF5Nl+2KXRzA3oJ6r5okhJb2ZZq7Kekqc2v3zb187yGZGzC4Dtn/jI9hUpFZNaOd0nIk4aXFChiQgr/oAomwNyRIzwoolY5VIIU8hetGMzCM0P0mwJze7KvsTDVJJV4TBIFjD1CNnubr5x32fO7ubgWQXAvt/+yI4x2RJJe/kkGwgBvbQqNM3hR+/wctdzDhZqKsp4fngKf2kAiigSEtEF5npegOHdZSDnRctjEkOMApTgo5KW4HrtS+/Y++mzioCzCYD9H/+bu5DbTYYVtsjVIf+RYPYaaM1jq1KiR5fPH2NDZ3B2zZJ5s7JHL2Kdcnk/cNqeFVwIgFEgDe6QDwqTafgrggFVxnmBdq2fZQScRQDs+/i7dyH/9QSqJlUiua8eVwf/EKhV2BqD+3k+CECjwLvK50mp4I+dq11uzzsdGBENpKwf4jAkUOOUrjWXGGAKdFNlSqYRMZW1W/edTQScPQBs+4d/8zJNyu+0HGQu4RtZpeY9mUvn4+qmYXZkC/YjZGYCjE6icGbtRa5cWHBQdCx2hlixTRFh3J1/YJDye8ssmh8UwmrySut3Xv7Q2csEzxoAtn387+70FDpUjEBP16FbnFbnDIgeJy9ya7W6DZSTHz2fKOZWQJNnKWAS6CQ2FYrhOYnPQuZZP0LatIYphddh8nMR0euLiujagfVPn7XZ4NkCwKW//5EdlHA3MMTv7/JhRVTE1VDpz/wRqCi1QW5DN9Lzm8NqbEBRRtgRMVoQwGSxGoBleMvfe2vBneJOR1BuENd3jGkAeTOV5mCsviEhvIhsf+mWT5+tVeGzBIAdv/XRXeFL4HA+sngxXuImmQV/3We6oV8NFf0RIWdARf+UHgVCYk7gn+kN1f7Kby7LceYugG/HKwcC9b4VoUz9qXdlNBg3O0ocKwQIB1MR2XL2VoTODgAu/dg/2CUiyJyF+iHraorGuaAkLXZwKCKi3+/oKS7lenTTMHZU0O48++rrPlDWkRk7kAEX9POcduIw8QqYEOjBip5BcLgSw8MsMGTmMVORzXfJn54dDjgrALj0Yx/dLe6l/VL+7f6wUqrgKKbVCWI+J6S5aEaQS8SBFWs+PGVwg2nM0IShqaT9YCayqiknMymYuFWjDfd7gIpSQ/ilI50FUtBAFKSUR0VENt/zzOfPCgLOBgC2/73f2hMRWIJWlaUmh0FtEr+ij9LQ8ymVAv1B0+5ozTwdI4WSUjK4zf4Mv2p0SBwo8yAiK/tYWivE/UA600gGTx/quAlmuvklTz94Ns4InQUAbPu1390jye9MWewD4TDVm+jEhaTq5ktmkqxfN4YKPvLz1H5kEuP+TQX2BTggZXaL9g5vRTh7w/XXHw/UJwImD97BTlCPppfe9f2vngUOeOEA2Pqhj18BLGa0BT6ESOfYDI3tp5YK0B7WpaQBmqiFhjf1arA2GaaLtE2TKQptZAqksyGOYisoOW5cAEgsdjUH5YDXQAI4RBJTUbn05q//5Qs/K/yCAbD2pv/kahSPA2am07lE1N6XrY4rEk4j4HRlIwY3WMAbuYmy2zy4j4j0I0hGkQmxF3FchD5omJOyTaKS/NT/Iyn92AGMBPCDKvAxl7NmQYy7b/2rL8sLvV4wAF7xz26b3I2l8G7JgIVihOjZLmgg88ieuWk00BtuD8V1E9PuVicQwQSLj3H6kUrlFC/biw6T1pJ5BhfGRMQtqbGHzZ2qj1KxT61ttQkRz5n6tVy17QtPvNB3hl4oAA7+lw9M/9wrytuH6sc8kpQTJI4O0GpTHp4AkTScBhWTq6oTTLJF7rH2k8exoMC0hcIP9hfFGOCFJvYPO8Z7HupVxq0nKfbGqa/XNVeQjZsPpjdc9aknZ0KcxvUCAbDrE7+0KVyDBDQcsOFEzZRm4Bj1U2nWjR9T8uqzY7bnZBlUG7By5uG0odi85JHSD5hCemi1N7+JG/lx1+E5pEFEJfHU8Q8lAjuOnmjJlbJcu+nzL/DN0RcGgB2/+6EdsQiDeW3LYZsVM+nvBsEjVvSLgxrRNhdVKYTgeZNpNQVmAhF0MNTUeRaHaiP/TPkTYrGxD3E9uEydeChzjI4AJ2W3023b8lHSHfyQOlr0Ld1y+PkX+Pb4CwLApX/vN3dLasr1E2BuVgyLGejUL9eUuY/2r6QENpE3Wo7YVhc2Kg8XB9uy+D8SjaPZwwqNIMJTnip0LPeGIucfgkZ3G49nrQQEPOhkEjf6cC+99qkX9sLICwHAJe/9/SsC8OktlKnhHYJ45dORXvP1Ca3Dz2ODpU5ecURAa4cOTcz7xm1GEUBDZAO0uOU1zJERUEPu9z1BWCdNlJXmVDJ9raPzWGPq0cxURHbf/LWvvZBfKPgCALC88Z8eBPM6ESfh+6ZYy70B0Z0KQImpGvLjyA+Q5SXVDNULg/o7/wqOh/IIwsrYrqUbEVFRevdMWH4VyfAQFakj2hdOx3BpcHg65Pxe34MiAlN3Hfx/XshU4AUA4OX/8V3smc2uRTNOEMrK6z8i+MctJccTivll4u+gkTj64UHGfNqpEg6skXt4q9GWCr1d6JDlsMxHHdB940HxcC7grMaNoqcztwG6Y0kgq0T8kOXqyz7149E6p3qdOQD2/6O3rLHXhffUaRurDuNtkgU4P1MFKamWQLZNk1pY0ov7HouVAAtrb/U3vQWqZDTScMgjgM5LfBXBMBbKDouqUBmUdBQJ28e16/XrZ35C6IwBsOOjH9hG4vAIcHSBbCpOsVWEFsdh2XCyYkpMEEV405dSDLcQTz8wLI+9BJ3BQIbb7oUoWoIwQgEi2AXHZeJWtrzGUKJekUNABVv3P/WFM94XOlMAXPL+j+4LOczzoArVMGo97indGc2JUUivOTec2b+3HNSahBL/ci3ln30dEVagsv4Y/yXQCzzsK1oEBXBcXLwC4YpAcQY56kA5dhsaFtCMiojsPvjE50cVndp1pgD4ud+9MeV0xsVRWrdslxPQbbH3lwvEaYRy4odiYbae032II/CvDJUo44PV5zRu2r+aToX6Sf+taSHZHSQsuoF0Tzn6ESIzYAFRNAmKsJdv/cyZ/omJMwTAnb9938QwuBTfIJG+mURIEbSzoQ6fe4uTyJFdTtYTh2vw6G4nwfw7ghgTGIYostFgZPgIEBrjdz/4TG5OWU5yJvMfsKuvDsORJr1u16fOcD3ozABw9cfesbnLQj7Xti20Ar4uYrf9jckSnBKxmvLsMW4qTwcMOiSPrwlEKcPPxCfh9JLifMeP/XHSYqe/wujOhDrERIVP0JZOCkguraby12545gtndkjwjACw4yO/tiMzKyRwIEe/JfS9GaX/r6Y0GUGDI2n1JJK+8LPwAVh1aqb3Qk6jY4IiBDVfOEaLQ52JMTR3cgGNeaWhOHh5DIkt7RWJHm4nZSxhUeLaeuu3v3RGhwPOBACbfvmj+2m7sxBiGa9IluA3/Fw9nNJInODTvIeogFiYxwxylace9YRmcIXFtMtFC/EhZ6cPfmGzpiGaZFTNguAZniDYaE4hscLtsdD3z4TTg4FDtt/80NflDK4zAcC9/9HLfPOjhADJG7D5LoTqwEKs3Yz7qr4ZBJm5KxRpPerG3qFUidiy6n+5m+afwxhATt/Vi8Nao0SYCIBgw73EN65HUgnc/hrdCD8ZvLwqIiLLXvnCmawGnAEADn/krWvSl6PV+PgV0lRnYubIdHr3IPax/tjLa7x54YBAts0Jg8aX1JDLQd+79jkRLb0PqA6uIDqJIrT2E+IjOYhbzJlcRYj8XUlMG+EjI/kTOkzUVA8d+dwZpAGnD4BLPvz+XZ0jG2QZikVzOJNlSCtSIE+oNX/UP6xIP6TqD0sGi3tjzje9MG874OfBNSPZnCxnyJh/OkYj3oV4lOmIJCTUv6NUeXCibo+iYK5K2Xrokb86/d8gMz3Os+H1hvdd4yiOrU+Jn/2O+V2NAgoT1RY7s2bYKT8PDGkrv7DtLe8hc1pwVYBIuTRUhhGBSHVOUXpXuh/ubJK9qhkUjFvkGYhKUddb16OWkYPbiBz4rTvltK/TZoA7/uGrM2jCRNeShYewqvBv3tFwUyDoLAFrQuxB4cF0o/3MhA4dCUUquJp/dd4tscC3E8aqq5Iz5yBfudHRl2mLQmyiN+6RWI/KLlft/DenvRpwugC48m+9b7OCoiAdUiDc9sPJPUwSK1g9tIVJWGe9bZoSJ8s7eESak+BxiyRR9H5sFvCywoYOxoGCIhkZryZA65hn/z0SJdGXXCVTghUJ8ZiPCIQyEl2v+tEXT/d0yGmGgPV3vHurSKO5pKYqdOdWlSRdP+3VH6vIcLoGKvfL4h9x8jO8awJrNeEm5jxJbAlWN6+qVKrf7tIPhgB9e/s1Kukk2uW2gUyeUucUk6iMj4eiToW4iFz+4dcO1U9ynSYD3PM7L3Ftl/xUgI99VS1XLAV2ftifhQhwZGRfbbEAWyZ3PgsZfCSYenDxYQESDv7ibbA2hgURKISnIC0OsJd/Yb9Z+NRIu+epKUhfriBclXkWCgO8fNOfnubfGjw9ABx+/zuiAukr7jTDxycok4ttEjwYVnJqeRg+AAAgAElEQVQlg4LMN/F7I4og8MtJl66Yx9E51cSglsqUawzA0Sw8TN5z/PSz2NRHZrl65sSPvkxtQ16DP8tQTXESrSK6/8TnTm8mcFohYNMvvb3bHzN4kkiSCJHSMLumvJp4HgKGkak7qesQIcFR4aZ6Y6Y8+egLBiImZpbigdurM62hoKNnWvlkXtpbtLjp9RWrGFH60IOCnnDmAE1aX9cMZYmIXPb+N8hpXacFgFe+88ZUlVJ0SrnbD46CbgbyrmH2iC6Abxj270JaN4s0ABRE1qZZn6AtTAVe/IwS1mUB0icpEdz9ZkR+ZaR04xSH9f8HG/YuI6WKRlEsRoZ2EGQ8yqTHTPb/6mE5net0QsANH3iH4yV0m5bjE/AY03SWMLBvBfmWoBBM6a3A2n8vyduJgZvKwYJiFX4VP2tbqJ+O+/hI+8/oHUTE3mJXEQbdSuKBhzgRIdgR0Pr8Fcg2RQ269LU0VRW95unPn04QOA0GWH/H2zMBGOMVeYASpicJQ7pWMAm1Uh+672m07M7I0SjWpkabeOs1DrloSPxQnD4r1ezLOiBB5yU3ymREIqKWPJ7aEhiHxghyuco0ZkD1zIT/MBGRHb/y+tPx6tMAwCvfebgMpolTKMt5FNVdqw1HrFVL0STEODbWlmGAtKPbqmNei6H2DLUL8oiJEv+zPDNU5HGn1mbDJzwmdm8xqxtQW6YRaPMcRwI/o4l5WWoIHOKOaDf87s2ngYBTB8Chv353vdUwSvPpNC1nSWgGLTkCmJKb9sIijVOHeBjVh0hNhUCfOuotuyhsAm2q++yIBAur8jOFEhxNIHbBMHuaK8MohwsD2ISk1u786KUb1qfrlAGw/vO/tGY9dWV1h9YzGYO0TJ0NKJcdXVQKmvm7lYR+wuAi4QPUQqRpUC08kO72OWKMDjmcDotRsNCStpTLj0iVYQM/BK9Lzyl5Ppj/YpqI8DKJnFhExC55/VtmksyvUwbALe+7IYjalVRGpchfAwEgL3jS2qtHQps12u5NXrx6M2AhqLQVzSCEJ4Wommbg58DuNm7zK+glARMzL8uBoTR0VbZLFHojkfyo4IwGpBGVct/EfdH5BNzhll85MIix6jrVaLHzN355adK2gES/3sv6YkrTSS8mIslSmckCcZWZU1Rgn8u1HlxGQy7xnnsPftjKV/6yIE1GJqmr5EykMLSoYPYeq1PV6y2gP5F1Ljq7PIhWpgKwYKoSf5kuFYz6u+L4F47IqV2nygBv+MDaID0OVj3x9wU7C99iFx2532pSzH6kdAcpuFxJIMgW7s/uLVYeZLwyy70qF4MikZbV/5AVeaXNxrqXsHxWK4xzFWRWZIe0sdeuyCMd7Pnwy0ZB59cpAuCa910FVIYD9u8ti04Ky+U4YAQRkcHamUTWJ96bEcqZEA1BISa42gvttf9hFDA3gK8xxcvpse2uOSbM0SBXFwr+bfBVO/nVehyaUQMmUjn02oLUwZFjpBj7P3SdnNp1agBY/xtvXIipQ4hUIxqJLFnC2qoNT6XUATI0ra4066FHbHVnplwF0eGddPL1JpAQElomfpKENKwgKOYJQC3Tq7/2C6NjFdTasFjNuOiNSQzBiEZN9C2v27JSDLpODQA3/+p26psjjt8eoD8hzOEq40s9pJegSdwD0ekkYna04n6CS9DpPIq3oiErDzTHl71ZCmhwVifxxpbyXA1HpwpTQkIof46fEaO6oRlo3iZFZ9n9m4fW5VSuUwLAzg/cTkPIL4ZLfgP04QSUzYbabWtsCBl1ICZonwCgV69XCqXDff5s6fZjUcRQbw0EzclnL2u0LWMcwYduvcVBTAwIIgLHf020L7t0LRlXg6/LHX9/q5zKdSoAWF79/oomdnZfIB95zeOnaRkqYgZ1BoE6ortiXEYhcmmwPCv+JSMcTNR61qfeaw4B6pVELXw88/18/cNtMwRmaHYeJmpACSryLS8xw6VAJcyW/kxEdMubf1FO5ToVAOx/15VV3FwJQP/gHQBrhoeABVfd3YOb2j9RH0nOUDz+6SmA1acJhFniMXnxEPPA1m6B1xBGkoTS3IHLyPbA7FZG7nXnjJUu0AJMxhRoDCJU+2oict2v7B/HPF6nAID1n3udsnbVh4bkXYRqz1Ty/whnIf1Qw94W9YH6ihIUXCEJgEWxbHfsaeAH+NbN7wLV5Bz+zTAR6iewlrTANxDUbRm+oSVl6PrUvONvteBpJg7JBjmP3v3zp5IHngIA9v+tQ61TjOO0Zm0C1oLdKTZnR3FJv60YIsKm9+V+HuuG4fjKiUUmDsE3GzKtHwPi2lgL1uX6FA49Dgk+bW44pDZUJBHgJP+F+nhLJF4JzPGoUi4LuB5CXEeAmYjse8+pLAacHADrH7yrj0B9T4QPoaCe2y+9M/N9UUc7FHDthUYARrwEwwmC6pBj0G9jRhrNRem4uK6HmSyvpSizehDZmIlIuqH6eIjaEi7TiCfIiY0SnDyFwEVxiOYGSHXqnmby6l/YNcg6XCcHwJ0fhOVi9TBdMQDZib8wVB4Gm/Yxs59JGzgv3Bbena0ggKUHyDDy6BEs4kcsgt5K2AlYTubvUALdvlZNGVojarDZATVUhDIGdWNzsmvma1JNrzFTEDF1Obe+82UnN+9JSxz69YOzBVCp06YQQDxQATgtjE/E3h9HwNVMrUVif8Mrs7+QzoUQJeBNpZSISJtJc/BMMbI6xDdH92T1fzIe6EnIbDEwCaNz+FkFsERISgLxIzJgC55SVZGbf23ntDm8TgqAu/13gflC5iRlml4YhzWnAziOpttuIhiSEYerB2ML20dkoSMZ9cpkoTfWw1LEVApN+cUdFUWdjhOyDuwvMDccT7LEmYXtkPbGkwDItGUxhclFpSTVJutveNNJN/tOBoCDP3cw+xAVZn6MQ54dwMMSQguj+2QSEyHoKRtwT4b8D/o/pasfQsIAU5oqrj2J9DI8B942SfuozKJjbiHTzV7eqwIZiMCg+1PKnhOovbFBi3vfVibw43USAKy9/fVa9WSpHopcOQKEfwynLOVAcX/e/o9h27JokrpX8C6A5InvBwfJ6DG5hnyjKRnDXw3n9buyxKWOp5rEKH6cM8an+UQEI6K3uwrDHMP6vbU3/PTJFoRPAoB9b70upXXs1pSZ1D4Nhi455THemIjEGxtxqKAVgcbI5YaA7drw9KrgLQy/agOWgWWRl8ZkFvys/Ws5jYwf2Z/BTwoUCAivltlNBDQYbgF1BXDIP0G2yhUfunm8TdfGAFh/z71A7eyEdK634NrqHXQlpZ9KR0T7ctewTlhWPccYKGkjFfiFHtCsCG/jsTQGxlAgsl4moavekrI2OuSI/RROg8X7CyiARSLQxazc2ma/Wiq0/tp0wjvlXKXLr3f8tZO4+MaPD/ztXRCoAcvZYWE7LTeDwFe+1JPEac6GcTQqvG1aF/OtsVOjmkP4L64VRm5ntuuBy1Z2TAPCnkFxIwNiEIE6+KsCwNx1qHgP0sG2Kuh6qEO3fhpK5MB7b5cNrw0BsP7+m/Cr+Qo9L+RFaBCJc/ERM3BhMxvibuDcXseZp8jta4UTdEF2CnOXcJFdcvSJQmUfQYXmnFGW2/e6s+kNoSXCE5yhErbrIGh+we9jBAz1Gw4xD+OIvOznN/bxDZ8e+OAakguwQHz09UyPu1RWHZ3FeXBrIUg0AyblAYJzI9T8GBTU89PMU4sVIFWo/p/pqKI6By5DhThjbWC1GnDoCAWgy8dfYqmsuIboG6CtFLz17bM/6pXXRgBY/+C1NDjz3wqE2g2LqwEaQNJO5qyTfHkgdaE8fcJPMd4hGMQiHh4Iwp8sTijWw40jMHrur2rltiCHiXkEYcDG8CzTyaqulBGU4hgEkBFnZZnpelSNxq3ovb+woZNv9HD/B9cELarqR6WrIVxkkspI0tARJc/M/ckl0AblAUMBb7wFxOma5aCZdosP5ikGkFC++QE+Such+qTljURLM00MVVP5UB5gMJ60dDT7WTVKinFIA8uvbpgFbACA9Q/l6fKId0ov48ZjiJn9cfftWH7jN74Hn6TGcjTqbof5OyqovCpUlvhmSBka4TFS2EhkBrmNYjtXRBQSoWCfxcM8xPNTos8nyPLQo2UplKL1A/FV5La3b+TlGzzb//6yjpjHrckX/CSUta0r96WukMzkZmerLIVGq6lJTAazI+Vh24wJdfYjuuLhTGrCQfASdsJm4f3FBtnlFAOIoEw3ZskCRf+gn3xa3yJw3cFLmYoll3cfqkOHazUA1j90LX2n+GwOaW1Gdmv0UCEiGueDDOtbNpdNQmy1OF5eTk5myWF9bMr7wAGcXeUgBBgqRAzbKpaDWhrHWrpf0leSBQZMm3mJlRwhOMSEEuELvPjUavhCohYJQn+3v3uDHYHVANj/gYUnRwXPlBEFU8YwpM0WNYi/vB2oIlaGCrs77LsKvJYdhwqm1BxBSwwiNZZLhgpnL8OZVfPArxHLM975sATtbjThr8wN/UUx/zJ5ITVGG+8aw9kZEh3uLe++bhxFPFz1YP3dB8kHAcIhaUgJfk0pAFonlZSWDLy41XyvPMcrDuU4irAyf3D3AmkSKFpr6MTcfMHGF+3DhaFxQz8bz9FbOCa8CC4zG5FveJHO5HSiyBlq+ocUUsZcdjYRueU9qylgJQCuId7IDNXcTL19TR1TOfGMoErp4KGA0hfwg4KF0v4+rgk5eFf0QCeVexPDXoCVD0RzqcWgV80OE79hXEUze0GFstQj7HkP8Iyv4+8ZyW+1TQgtFtVFZMtb7pBV10oA/OKt0bCxVtJMGcRsIrsOwQyASY7a/ATChwgdvsJ8oVskokwIhd2gexj8HINBLO/1JwM+/ChCLy1ZOpro4Oib/fROsaVliTuhHoaFsuRlYcpCfMN4sxcYTmrhzpdvkhXXKgBc+5qtXTarvZOM+YUzEKeqSR3HQGoijhBGnDAcVqLGq5nqxFpZBM9uFa/MENu/ZSPTg2F8ZKNg2qCjzF6A26q1S7wEyQpkFR+0+VWZDEh3O9BDLmClBCYisuNtl8uKaxUA7rl76b2rKCfeCGXziIPnhZLZqolWHW+NkOZ0p5Z9ZpVYsx+DaLkwNUKzToieu8DSq8IXbmwmXkc81jcAIl5O5MYWJriGXUWWCNI0Q+0HeauIyNpr37AqC1gBgB2vvS6H4O7sfVZOML8LYRyvTBjImTMgO/uX3swPyErff6KVNfVNqVUw0PFzRxDPC3w4SDKIduKfCCTR7qpzgvkGQNwhMoKkeAWZxeBWJD9Cyz6qqH3/FQP922U/t4oCVgDgxrcvZail30xD2vZ7P3FFSoVxoPDOhf4eVfoT9tbfhEqfKEe9Iy+AyaQfBZmps0nRJjawbeLWVyGOjXxEvZsc+yrAlQeEGxF8PQ5uqsG4jc8dz/MrWGYzD/V9qknUG4FETHTtZ+5bQQFzAKy/+5rxeCIMJT5FsgKAi54d7xR9OWy5jYO3eL7krcSY8tCFtp01SLP81N9U8NBNgSM5ackBmJijhg4FVrEQc5CO2bQA2zSGQ5D05ENZsM4rScrhqe6UiY3s6Yq37piKuAIA+9+zwRKxQr4DJJ20I/GV9RLuOcSq3FQvuZCDPOxmUMjh38fNcQSBGk/D+6vh4hAIG63Y2rAiru+4KNOLKY54bHhxIZVidIAwn49QU1S8WLNJRena6++fU8DU0OvvORCyobfz73Lx0CMj3jyM44pB1RB6AB4zDJpQp0gYvqsQrThfCUM0lef8ln+IVl/vN64c4BERyd8DOlaobdRhU8hnI7sNtdYqY8IUxUfR+LAFRS2PReTAW+evi08BsO/dvg+chlERfp12QCfFoObtxm9KAr5L5aGEO7uMPUZ5mJXzAcVKyXSPl6cm7XtZ4JkhLk+2bqNkgH5cdhIEMXWGNs3YP/F31zG8LZTqrGkn0N2ml750aEtkBQDedHMbDJ+OYREmYqGzNpdijbo93azVlWEgtppR4dLMhwoPgNWQtODHnE5P1uGMIuJrOz/gVrDZCAy7xyAHnDBOvYbUIf4mJahP/dfEmEsjEmcrTeSlN01fFp4BYOcDl7TaETfpMX2rRl91lQgX99CVYV43Je/aKVDC9J3NdGSDvkEIjCdRCXNUf3NYXaHpEuaKnbBNT4xKSDBoSHOVr7taE8hkhpuEAY+8L0P4CzP9laeuFOARUTHZ+vbpSyIzANz45no3FndICNChqzhhjZVFKGUCMJC9HRD+DhjGyihuJX10TU8jPsYvuhdxIDuw3rx2EECjKiKw9pjklrm40f41U3G3X8cpHDbrELKcvKixcup7Muo6GKPS5EtIIiqyvOZVM2NP7q2/9Ur0KHO5rO78YJ/O7rFkQ2D1YefbfdIblHSVHJWCjqUHPM/Tc6KnI32KCKQXsxn7iEGMWXlAATaCsi7qvZDtjP24f5WqGLPoNjpKV2g69V/CBA9TB9213CH6FjGJCL3v/OXZ2+ITAOz7xbVUoznLBDoL5eGRagNan74v638+KH0NiqYqyqXWf/ViWC9MZ1WY1Axy6VhKRAg3sY9NzAm0xY/bHSZb6qiDIjRjIsK/VizfOvKFKZASXhBB1WenOQD1blxHfkSlviq46Y57ZLxGACxvvnmsLKmK3DLJkaRAJpGUgZilimKKNA5puMJFMD8Sj5d4As5SRG8eJK+1WdHgakQyFT8tDJV3lUj+fG0sXKZJpGNbQGHqAlEeULRZRZl9c0ozfnL7nZvHBkYAbL9/W1/RQ/yHCSvp5gOI5tgtbpXMxC1DNTc0St/EUaMZlK+txUjpMHeUyi9lEqtAUz5UHUhI4b8QB480DlfkF9b3swyjGWGAhykmfvo0sVw0Ws7ZgZDx0yMCOaSKiL7t6lHaEQA3vWlRH2ZhyxITh6u7Yx993Kz0FQIZFYRkIvgesYNpWzQ+8als2ZvNfoo/q3sd5A3KBoKDWdRROCYAO6S1EE60/8oOHiJogWuiFkL42CvvQ9PshN3HYLwaA4syr7x7fFd4AMD6W68iL4MOxphqOA5HWkZGLgaN4okdmq/A1aJmfO0Bc/KqGUdmSYOGKbOf/p9RQ7SYo61ew4yCfPCyR2DZ8o5YMk85qy4Z7QvkQ0gfXGiLA4tCq6y9IdEUEVPaE0uEbn7XPqnXAIC9b1vzVvB2ztFjq76LUcCCC6qpu4jK7htEJlmD7TqJmcqoaXWaoxp227SYrytMmkn1SOkmZtb+p8lAWsUD3ooiZWN0Gf6M6JyvRMWLJ+qn4ZE1SzYe43Ol1Z22LlB9PaHVmK0GDgB4803SLUYH3zMXwOVdeFNUwsDpkRHKPRhGWEqdxb4m8PvoAxa9851e1QznUyGE+mZE6qxQb2jSaRl41UT6r/5UKCjgg6uujHlgNy2ZiYn4vBMXB4YjPV0qQnw8m8thJvDHDaCpK2++pJatANhx/7ZSL71Q28uBA+nUPa0wQ65vCNAgU7YqmUekJR8q5WVcc6sirYuUV45iBpKghLYVTY0ia5aGdaZAXesVJ6Jg4vhQjIHbeZUsjUMk2rw25DMKuK8BLFMQFozgHYcDdoF2/exwLqQC4Pp74Y6fOAGagTGlrVlE2NKKMbnkwSq9IqU3RZTwvoYH7JaKSaJy/NOiUShEKDdYQkeMSfv1jOaQru0aHIDv7Tmnu5zke0UK6IvA3xdKqKeuAUtwhubzb97aqL+UKgC8vOKVdVO4AuCeQ9JjvfDbfEFD3YLqwnFvUYodT7wJ6fGvr33ESuWYA/BQc3F2wnqsNDcbLlAxRWHJgj3zkbpgMAuAIrnua9RzSDJQBJQyoVYpJk28pgwSwg+cis5UGnoECu2KvPItJwHAzvu2eWTvIXcYAWDC1cz6A8kiWnZqgLordvFtDLGxgR9xEi42S7emdgIGZsdCkAoMp7QUeujvwaoHupAP+xz2fFi0SejWviNgEu7terZcnsqA2ddNxYtrNjKqIf+cOXSeUN308uuLlAUA19+dNvKFRf/9sMkMePVk0Zm16LOTMx228eO+YXMI9n1SNFhFKQ5VviAf4u5FxhlAgBtLlU8+NO4GqqTxYx1qWD5lQWArIRKXMJE5S6vg+DO+JJX7A+US3Gum3Q6fJt2dh8tSQAHA3YchsvtPT9+axJNFfnWgWt6IqprSFCIGl2hffaAmZIuCiXRC7WiI1jInYrLBbplbEQX4non5vlXENHPCcO4YAmFRjAW2M5TmSGmOxXoFnHSQZNBgp2Yg4wVHt0E6k81vKzGAAXDp/dtLL5gL12FWwI8n+gg5w0JtV+wwJscM9mj8lTkgF60RJgSh3IdMm/VaxtZpllPtczRXv4ACDLBsg3zwJ110mC6wtYajdMZ3KWVVHym2kRKm7E0odJvYL5JNr7+OJCgAOPyaoncpr2zFOCgWlstQdge9H5QyeNRkxDbD4bToCtdzSXHNSk5zKaNnAl1H/noLVgd/x8Hxa0C+nEqz+HH9RX1wRn9DNikciyvRFQ+TKiKg6TwCFcL3djR6K8PyStfeyzGAAXDfZLeA9rtjHNklWJbwG4CVvm3XpFIaloDR6mEDiJnp4bFyan3k2Oqg0TxDinlVeAnrGaevOYTcFxOvGm0oKMjFgL36qZMYDIZBPotNFDRTMOOChTGDFsEQ8XDtTRsAYNcbtifHWISdYRSAKSMbxG3/7CwyjVNNA4FsHDLqdxhDdpOHskwUZhlaCuatftqQglzvkCEOavCi6IHJJ9Ozf5KLfLSQ7H7fb1OECKqEchq8JvSUvL/e6wOh9bmouOle/r0fBIDDdzK3lZFVZuvd+K3Z0o9LDRNKfgZe70K23Xbwj2Zj1zfLhG8bKisLWAnsOnxQaJ1HCHwLCKxAD/IPesHnii1EzMuFm4Hqg2pzQgRModiqjy50WAeRQ7H4xSZ28F56U5gAcO+BEMdIGRxGGFx91FrTtnyqThF4wqA/NMm3Cp1K4M2PdrzSwHGqt+HSGStL/DUw9/HqKcnrsdE1GYErhF4o5PWR2DwSWK5rT0wwNmmYjA6HWGKHMEwBoNy1PlytFeiMg3eaONQtb6R5AAJg28tyqwDWTnJfCFrOft33hAY0Sg6MB6VdOmiFtOB76uNrOyKYioLzlTMT+UdqQubue+oGsm674sODM2V3vIBEuMmlGCw+bbObxWC3lNxDZ5Uk0qDSvUVwYhldHX14+iqKAQiAA3RmLHadMdpi30UFPhqgw/7PqMZsmeNj/wovCvlgZmHW99RE4HRp36yGXStUY1WbLwrFd6MzO1hcQdNDJCappI+6y+E1Oskou4uF5mifX4bNBPAOHZUKwkJW4D5Gwh+8B9NABMBNhylvCPyEK1kEQyRRZK02QAhK6ffTCFG/q4hRNJkaPk2AG9++/dbIJJMwiAnDVp9ksoyjrm+JSQKbpRoOClNLZvGrYdWJJpqXVMsEb8hsTVylB+phukgpHU+JJXPxu1vopjeuAMDmu7chrtJ/InLlMY7esmsrFKaMDaB1mMKPMsPH3DAUWATncsjAud4A5yT6RgD81uys2WuFPsmdQqPhMiF1bGVOKMUYH1GoRgoDL0eP7sRX1GKhjclLD11XHs76zaoWpwuLPExs/afyF4ASALa9cjNup5I4OkmQKDFI2EWAjd+7TmrT5Ng+tGFsqj4P8KldTvbGI2GKWvHzNE19/mc/wkDpEZl50qU0bvJT1HamxcHg2lJjm009wBh59EHhp8cg4KsIquP5i9Cjwt0+vqZY982u/fIrxQ7+FFAAAODwLSjuqBnvKMkJWMkB2Yev0ruNnUVxSEDAjdaNuuCYYO24TxwTyV36Sp0mDOCud/WqqCzPPDu1pSA4o6PdUJVEUaYvzgDBDnBkIhpF4g+xZ4upMSqMXKlV0lcSFMKtrwDDrfF3C63fDS8KJwCWew70lquPkeCAOiyROGaOt3wbAuxTQk0cqsx7aWDFfZ2me+0aKTvDBPNozrejIl+0pB2LprJ1C0Wq+CtRXRbFc0pC3QkzjK1QGf2IdvOHGB1exQ5mB9HM5ezTz1jG6+prMEZ4q4hsug9+WUQCYOvLtpD/AbUSy+bwIEiyMrAquGSmYHHEN8qDx0qcdBqCA3WopQCRginVVJAkGYxe/fG7YaXgK832aEB0lb9iil+G/KA/mtAg7ubjBycq92yKEyZtu7wvoQDe4KAQroVf+/IUIwFw4B5YIGDK8QMZEbJUzBgGQtBwaxtolFg4A0VI5xBwuyYP5ck3KEYSJhB8uOllLgZV8Ny/IC19WcRPhJpAwZkfkNampo7XjooIWAb2zPEJk0b9mS3OFm0pxsSqvIjsujOTgATAzTch2ZEhnHSD4SRme9kd+DGwJGxU4bjBI60vsuFUJ5eCG/BcDamOIWX20imLxYjVf4bDIx2kUb0u8hl0ZBD3mh/wyAQSngKVYrlgeMPKrTudGdPoG22clkNNhNcV15YHLo3PAYDNr9zq0aQUh86kqQDJwQTU0mNV++Tq5hMkfAK4FQRwRjPwY7hi6BSjtNSp0KsEa/nBTAyDpSPKcpXYm9aoaKWLsCp8wi9xBgGEoVLEkXlRudjnL3aKwShWshQeL709k4AAwLa7N7fwKyVoZWcYgCyfen9QxWVJvXVe6dCdgDqjN8kKLeQtPB5bnJCZFRfmgRBD5hbdS+w0EV/0goQMcjDFDGMG0vRSHFHgh8NOBenkHj4DzHOdmSR0pAiavTyTgADAYf8Lg9YPcmEMloiafW8/LY4eECNFgu3taOpLuYVeysXsncUQJL5j1ljeD4BDV6QHDFpzhEHQSklrM00LWitOOMabtAwQVuvxriXsVkUbAI560m6WhOIqDbJzNJRnlNrzHa+KJCAA8PL9GSu9VeKZ3gac99b4h41BaUxfHun7Oek5GFItw7NBpRQdfgsmoS5xQjeIBPgTKAUfxMljG5MWCRYevNPqx1Ae8DY1mBCOMANH0IU1JIryizRPsA6LSu8kAQMTbnvKF2EAACAASURBVKqI2Nrde/yRA2Dz7VupjFjpPRy0D4F6YK/TPNrZnyq5ZqVEDOjh/4qBvXal8B9evnJqqPGqUtJU7irM4jdLnJweWCoLnSN1m/AoQAkt/tRQ0AIc6Q+/dUXGchOghhaaYBh5piRmj3pHnAlwAGy/Y01MIE1Kmek10YlJSH64VqqksBhYM/x/aHtszI1iZdi1BWKnPkbQCampB6L2GSp2bogwU+X2rlLKYDbpEaFefC4wiCmwnwZ16o3PuN9KSuneQ0laiABKENn7FkeAA+CGQ9Xf4TOeuvH+60SjnsirQw7WpqVJgw8Q+6aRzATRnLv8CnXHoz1werGPIZyIpEuS6kvHQ8ifkKuzMYFMw5G655oVIbJ0DTiwmh7tUWzoYwb6B3ow8aHRX9xSri5ittzp3zsAlpfth14GwCLwEqDYZA1GmfQZy0nT3Mymq7bzB+RSbcOF9WGC+0vwE8YRpsu1yELqQ5ggaAbogGUsUFN0W3StbMAxG2AW6eUrYFC7XrEiFJZR8neYQH1LaOn67Zf1Jx0A63fAe8Nw+Aml8B3WJN9sHc84ldMts7R1xdrofMTg4e2AmNVaarmrbzoCGMO8hZ9Y+l/OLyo75fTCeCjEIWHc8gde+Pw5lRxCaZMgHZdg6F9IiHjtBAo25wPvyPoBLVHT20oI2HILvRTcFF7B3Nr2dU1Nk7CcU4OLpFqij+GVmiyPS685y4F9IWA9g1RKVHwGlskGUk4yJhxRT+JVeMokwJM36t7bxleL0siVG2P0ZcgTXdCvwgfi7yKCOpw10vE6/2LbUVVl9639Xrf7/hsFZIKFchBAQfKItYrnhMpoUklJghDcVp0Wb0MloifFw/aiK4LUpuiBUS22ch25bAD08zZAUKbfH3y+FWmiWHk3ECApODGOmh0dTjQzAiRgSwT4GiEicyC3SQgqtNE/b3mgrwR0ANx4dR1WT4kjowRJNIRPpbBQYL1cHcd7VUlN/kRH5NNWinXrmsedDS4Fz4azxupJ7FjZkrI9XJQ0YlIlJSTiTa8zid8trlxLYgz1Fx4StxguBnnzCv34Iko9vQti1M9rP9V/c3ADwNrN20WEVmpxkbcArp/1SbhY0QAWD63Ds8qMvVxd/hElHIvvb4tI/AbNpDuUjwnB/+T1LFIxDUS9DBI8JssPnkw4zHMaTnEq9mSxJ3hn0AmVxdHglsayCpMnPjDA79X4hpTVs44uUjRyuGeBDQCbb1nrbefKFEQ5KSOgKZLJ0NOEuqHJpBmbwCB27GZBUeMZn6sHwwFbGTBFxLSggCoFGR/4juhK84NCXQdjffGhV1SM3MOl0EtBIJ5AKhCpl4FoksUnIGgtXHpju9EAsO0ub5zYnUXitlAvQ5LhXxgn6XSVILgQRIJSlkER2S6egMT5r9Uo4Uoht0YD+ICIcGm+g49KcupCZ1lUXiUTEYF5SGA24WgUp2b+MNyZo6OEgVZ+96H2a0MbAA7fWJoCDzaqJ25A+CPK9Ah+3T3Ta37iNx5sKJQ7znXXk0efrAJoL0eBZPIN9BwwY8pqR4U9EnLK4zXqEBV1JLiSnku7ls98CDWB1ZCphbrJIiKMKh2kxOC540CJtfZ3ARsAlldsDtmgAUjsYNQxMuXwIx6dBoySB+Gl7o2zGI6OMV5EzKVNvh0IJSdXKALrdNCa6gDhJBqPKGhlZIHUXMbUYJo8yb56dC5T/ipoGrffiv6t7LGXAD6iaP3OtvmziIis37SlmxjcZwwBJG8pg5zJODfg5e6jA9iK2B0YGBBq89WkHi4Mxx57fNH5sAIVtiik773QuDIjHWVfRc0lo1o58yWbKXAuGQVXxUBY8UkOUgsG3VFmPdB+Y9wiIrJ2aN1bIZnyt7hZGWE/KZOA0yjYFwyRNhmCue82KINfpFK/lwdUzHKGKPRb8vr4NeCo2Zehpqyq2sW0nIaWWGji40ovx9BHvle+dan7Ik6YiQvholt1vJIleIhAavZeQYAxFtZp7xUHRcRDwK3l2FbvyH9JP/Opr7siWpqUsSLX/7YvuV/RSVKkYzy8q70Qknzr8G6U6D0BsyD6GRk1+NXx9Cr9YRjUQ5vF4+rgXeR0S8YME3afuNUFHFYgkzbWZnrK+EFhSyMM5A0fmsL3aHrLrZtFOgCuvR6wHHgCifJQtAlOAjHscTgMBrBaNsQPs+WMJQ/X+6i11hGV+I2l+JJK6iU5psyF6iAjMBlyg+WkXIlGSX8BmZEdJQoVJqivqPHX6vkQWcF5Z8cWgucpoRzUJ1xluaM5v4jIreLwyROaJFHqGTyZsQogzRpxtmwge6OXs9J6wN+D0wEOY4rnFOCENwuxfoYWaZOuxIm/cNVRD0cxcpNXipVQJclqCG1XQdL/1DqsC9dDDttqKR+Tt2YoA7MN1Ot3N92yRaQBYG3/OtiKSxLwk0rQGlJpFXimGhNFAgXR47lewK/FGRUKa/uLOaTxCOoqIpqTvfjAoc1vVZnVq9QoOpKbBm2NTVOMCCVKfgg+qnpw8iY2NGgoqcJH616Ypsh44To/dLlIA8By63o8DomUAngOJsRcZSdYFTGIpCgFyJzB2nxYgjgx/opP+dQzL5X1UKVO6oKRq9DvVLc0cHdg9g/8nFiw2R3ucRYVNVWiRZxWZxWZw9TEt6VgEMrlU70msvdakQaA9f0aRK35Y/IyTMoG5DhjXayVlIp/7ZD5RPkIYAk5Oa7+1OCxZ5BlqokDn2G1CIiXZszwNvLkWP8f5n1kMXLN8GQfCbq25Uel9G12TcjKH/hGR/t3hvK2Sm1xWreV2XLjujgDCClKW2umQhsDKB1GmNx0Tn/MFE0D3RixcThTAElYJtgayvV7KnPWHWUdr7CCEhigYbrVB2UqavmWEY4YG46tIhTBDwdZf17PdU2vKlr/ggpsfy7SJ17jGF2PqkosuOnAJmkAuO7g0K0fmtPSVHRKtOnO63Gnjb3EORVZKWP3OZ08Mm+Cz9VVNHC7RND4igNVSur058UOCgVDhlBBlEi11IpDWXEcaB8255WjL4zupy4HRFYt1gBkhpsObS8v2SINALeye6EiGOG0T0NjRIQMxzM64oEPNVu2HJEg0/tzFTh8HeQskK2ISDk6w8ofXxqbXrHyYKS4aj/HjEkc0gdmo6qF8rG6+5CqYI7USQH79uGQgRD+hskxTYa62MHrsSneq9+0S0QWkbXL+c/JQXfDymVqIREL40X6wzrA1VJUCb0piDvwT+svTRHHyUDHSSMuP/jGGGwY5h7s+uo7H85j/+j99oPEcBQokRbRzxkMXcnw+BhvJaJ/m/VAMTgbQo3g5bnfeCrQRLTPZf3enmtEZBE5cU0xs0XIVQCVTC4PbTD6FbMDCsp8w4HvTzja0Q/IxdghM/yQt+P7u1qXr1k48CLETP/B1G9RsAyNF1SdUfItDqcrGefcPPAWUfNvgUotgKbpz+IwwojWUrXr6IrLRWQR2XTNwntyzJjAIPWaEFx346HsgNV8kP4dXAuaz6BTepkjknfye0GLprQ0xfgq0gLJhIW0WdTgeDRSWtg9yI220Bid2FcJjDiDT28HftdQV/qGdhjgIZZ8Gcj7VCdDW7t8k8gisr4P1R+9Sr3Af6zcAWlRVL6QU7OZiW8VryaRmt4tt1eqkPC6oUBjmv2ig7At+heikU6EgPXulcqvjmQaO4KV1SP0DQjUQExcfI/F2TihgG3Qckj/46ocV0vfnq/rc4fWRZY+C4ThSkaowsaBn4Ci8r4QITyw2++VpfAKk9kxdK7R4qOGEljb7PpEhVlopCuom+5XWoxXxlbwjrinD4EOPNW/xNNUVoeswqOpyLwh77/U0hRwp/yPix8mk0SMbLrpuMgicuXBiFbRSj+JMjmWnozY5oroT4x0DYkRjGQV4wktv68z0rWFeiZ2yBxTo5yTARf0m8a3krbjLpyPNYm/6GVwWtgo4y1uls2UnlxasPxk3ZV8AC2BDUeai0fPy7szFU0dX2v7LhFZRK7aJDnOrFSlwo5hJy5gS0fbWS0UBnFEOLfXOAZTOTS40vua83/iKxxi0hKAcRanai1cugBl4IoK9KTeh6EqZEg+bZRvhmmc32fnFlQUKWJ3cc9NiGu8Q/jhre9ZRBaRA2XMg2fEZyX9SUZlJC0TmptKUUY0QmBEFRSPmh9vBgvytLhUZzzR/h6Xyp7hizpl0ohxPInJ5CcfVBCm1D+4qTJLIatABjQBz1RjRpPmiA/qvKxdNaBsDm4qB68UWWTtQD2vWmMgShBWCjCMR+f6AGMYgw9NpkDxVJN5oyOuW1WWa461ccJs02uYNOlSi1z+JYyPq0y1axp0QDLs108wqRUl9c3XiddLhiHcHwGebD+sr9TnVbZn+WNGLLjWD4gsshxYJjHKNWGSaxHoTyrSdwRxB917gsWz1C9GsRn7Es4CuPNDdLPK2vFuOAYm35ClvHM1sryQdSfx2bhphfvi78vl+0jaHKVEAnoRhVRCZ26IdYJAqcceAOokuEYQmPWYmFzWcoADa4GxmbJh7brazccG8KRtD67CWmRioyPIHV1JoYhbhBHH9La+UpeIaG3RiuGKX1EIiFrzk9kKcAqoxd5kpUVz8g68GVYril2BeRQa7DFxJnjHrbQXzqGicuLyzbKIXFfCEWm7vn83hE8HL3q5Topyu8VM/sqxgm7gzZthD8Z9osdCDzWzTi3e2InukPP9btdqCpHXyj9InMGlUzXlwURdPSBbjD1nbhx+ncuEKxu0OBEnZitdB/7Tij3Ax0xMnrt+XRaRPfH62nAF/LvkLa4x8YWZZCNdwUhtOgbANOBJRVStaLqiJ1hHxpaV3lUAj0gPROUOxeCKvRT6ikJHgxm7s3B3/0YOJTGmbscHYx5cLl5ZTsqjXUN/KSGJZP3Qc7KIHpSaomIj+f63TzoqKWCYT9UaGlwG9Y7xeV4YZWkd9IQKTwNlkJy0mKwfIZhQ1nXUfig1Uh2RNTMSNyxSzXIX870KPKxu2aUxnZbgmT46iRBWiGsC52jWPUVl/fLnZJGDa/1ZQNvyhwVk/d6kd+ghVatJTFJUFQEfQqJLrfTVrapeq89xtC/L0JBaX5PNKO33J4LEYxHBFKm2G+UJGWW9BZ6UnmI/SEt5QtMAqRkJGOosp3kmY/I7bwm5a/tlsshVRDAW2xduzLbiGPfm+zxjL33UkLh4NOn3eQrTtRAdCyij9x173aMuK3+BmYIAJ1FOBUuQg4WCy0FGhZIl4FkOyvAeCcWGKCxWBgQJTmoy/pR3+zcsAyyumLp5S6QiZ719iyxyIGNEPGS9qKD0BeiVYvKkK/BY89a+0Y4B0nlZparAe8k5QMFHL4LQ4XBnfb1yOKDAX2JFA6HSR3mS0FtDRBB/zCqGRf1CAQlLBq7jiFfUsuCAGkZePM1l5oFbVESuukKWtStWjJKsiUm6OINPo1EscFS2E8nX3CDOKQpXopCX8K4m8zE8Bw6B17ezmlE6u06cDM2SE09/rsIvW9QMQ4tYORQkinphxCskFJuO1scGLcTyIuyaJfCdrqVXlIioIp40FdHFRPfKcuKy/vuiBu2ygEM8jAO5OIIuzSpM6XjEKdMXhQc+PrSIDL+tNxw33DhjaggORziISqJoCQHEIt5RU6BStIwOfUfD8EF4zwBapZ/wvoLfM+58rF1O1caaMZ9Iw5NG05CpsmuTLNJ/P5xrNwgzt5niiIF/cLjl6r3mqD1wTRm9hot0vnxgFQjder6cSkjtfxdMqSz2gR3MAg0dg1DDaOnn/iRoigFYAk8uRESAZiZMkJD9oFE4/TU9yjp+96PbIeYw/YyP0J571CKyrF8WozEXJyTwZmNhCX6XskUZjPadnyaU23FaIoPBJyMvBqyEXkg1BdcW2kQ0+eC13IliSGIlIMEGJQ6joDua6ayKpdG2QdMMMtwYDuLqXRhohuWF4eSfxlN6Qs0zLTsS9eh1mxbZBePNJqLv0l/6QcCcIQfS5mB4dFC6SNucLhRAgwa7AL2TtAU6mI9O3EmH7JAlM5u+ze/CBAwcEfGXK2s7KTTSScy2y0mYxumSMy5PBGdxFSZtUJ1GStEUMiMRkWWfLcf3Zflh3w7w75bxEsUt8uX6MQFYpWTHREScPOGucErChNJxgwr1nHrtLU4UZprBvfPusNGUo2MbVrRAhwHX9gaaidmwDJqTkOpIrV7cIusrDBe6x4UvLFyFc41Y1XuAKAxqsmXb8UW2ZfkKefNHTYx2kh3bS+/W/COu5SzR7HUQlJX2LaJV+KoRBHxoGnKN/uZNWIkQzUdrqqtsUF48beRCzGPco9O36WwRvC89DfOcnPXWmIhS9eKKd4WsSgzr8R9WUajTZLsooHJ8+9Zl8yX9q2mZd4QVzCWOiIpRODopOTu4pI1mSgnhGYMradvn0zaUijiR3OYZO6rK1xAVdhZqUMCpJ9xlLVYoN63XUyYRFEbk91hdQ2vVgMtTzU+TUrNSZxYkQkp+3AW43DwHAKhlGO7fyl/H6jhpZdyn8DxsJoJdB2hQCzOtjgx4TRYxQNB4wlrgZVUDBklFuH+7cFqdhBimn7+cKNFBNzk7RkDOZoT8swdW45IQSmtUbyXNT+3hUy7TP3ZGJiX2b+tXHVuePUgy57B76xpZa6Eg7eprbze10iUx8IGgXA4Sre0J6YBmx9AllnYCTqRBqbIDnGf8Ix3iSAV7C+SeqNnK8xAAhYIFGNio0Tqk/lSxX/9YWBawPgnFmo8K5Sr+OufK3Ntkkc0S2uoWo3FIz1o9ZM9CIEAexxkaXEVNpT2MCPGWw4xHva+IyZ1xMMAXW4U7pajencUDShUJBtPMdnIWDmtm6IqOxogQ8UJdJPJAaHGgMGyN0MGv+YiFD6qwBGaXyAJNrlrY8xLwOAJtFXa0NXrCbI80eugyQc38K4omWMy8PU92ATUyhhdyYgvGmIkMmoNgy+XhsbfEBEzKSJEHT0BnoTcoqF83TxIB9sNJrUW6linZ4FdRVlROXLKAaTmOwudKUBp32QXyWyV28RBaoIVtkYQ2dAfFNDtT6BZ02CZmI+8aZsmoYmczoM9c4ufTDRU6nTpWbJDEXN4nGHlc1k2vPYiswpjxggWfgia8eIzyBIx9prSuJrpLdNOzLqDkiQW46q/Bz9KncE+k/aJrNc0uVhVfUcA9YKOtOa8alUfKP9nVKtu0p9jDmiljw15i3LUvgWHS8SDlu0PuBjR9MruMrVjt9akdy0ue7eGscyoctxlzgkl65BciOFMDzXcElIpNNAaiYlLsv+pnEp+YeTPEwL4G1aJVXGjGhM6LlLdOwrUnh6G858HBcl9GS5CTmK0HuadIuDpkNGrvJ5krrQBUBb1A4MDevFVt+lgubxQHO21MtSzAEDuNDNCHHgaPjnBBjDGd8sPEd1xPBCcJ40psTTlP5h0Er+WYIZ6BJ6kYHpUTPj3S1DMhURLPwUgQ9H9oGxEVLdxtfOrjjBveOsWvqDMnZHIPlD58XGWbLMc3N32XgjrWGwKqSBlas8EYzUj5ZmB00TKqUneSVaBhUK3jIhb0M7JYPuzShZt721EO4Qj8URmw8wjgGI+6r8CP9lFM8ME2iz7GgqAb1BKOBNY7/KmpiCyy+KJxWIGgjIqbEX/NelZRB5RW2FCSyadqRhHMCM2FS6Uhl1MmBhxUm2xLWZW5dfYRXAJCijpHJ1K0w5kGZNBfkbZchkM12IccDuwOxmEVevAJN5fBIGFwkyWJs1fkeOHF0U/Jg/0wWq7c4CzM5CRbbj6cwaPERPy35atCHC5DRhzgn9ESWdlx78vKfJmEytbJ7XQyO4lH/i8MB1LZ/OtCRPt1GCpOo0JJHRE6RQ8pnyPu8Ai7kXjIKsvzSxGlBs/0IgxELkG4IuQQ8AemyzFydGgHjPHrPI6vOEaYmiDyHy6OPAodlCMk/ngFTSnhN/o1MT8fULtlqVwj6f6tGLz0iIMqOAjGgqknnQEz+BeqIT2bO38AnVoW0tXSJrnxVNFxNEJCyo1K5nBVFxpr8WwnDhj6tLsrKw/EDNOt4i3D61p8GkokuBh3yADcnk7jDpc7bQY7jaEJbS/4Kz7jsFmCSXgMwkVrTIYaW9hlqQeMTwoGWu6iuuuNbAnwX+DvRbrUijrpw9JiXPga8g3HJwmm6VUA595XvHoiYQjWCpG1iQwLJ+0Xe/NeLrgvjx8+ZTOqNVyDz1VVq3qXPOzkrIG1csRxdxCQo4abWYvctckcL2+7zHwP1NO+Pb8I50IxVLQe/lKzwj+jln3/DwZpIpkd171Fqp+HsiavZCoXBv8wzbiQh3tjyKtUwRgdPLE06OhKMYaRGKAkoAW+yT6tVN5xNgYG/tj/b/G1uGYUDG8gG7HjiCx978CVEkNVNgvKovQZEZwU613nPmKuhBZJrQTDblLFZqCHZBxt/zC0YcYTP+a7NrP2qZhDeEhiakuSSkY0WZ5ZCRB58GuD4fI0DCAdJZdscTmYpJzIC5nhKHhFdrqmqSygDYtBI5PEN1ruNqFsaVSPv54C0GkqoKFmhG4bBeZTgi5kjsCJehhO18j4QhHK78Gl1uRpAwnqH4b+BEQD1A1Qsoms4Auo7OinZOkcvzAG4eDGWYX2lmBddwJyE5VlidMsJrCfOgtksKTrN0IEcZ6PxkytTX0sGsrXl4wbMpe3C50OR+uT4yBoD20kemZVpESiZLgvcACluHep2n9Dc45lgJIzvPNiOpVhkyTHOIwcfSir8BGtpAEi2zen4GEpsxH/80twdCfUScckYo44yT3PUqjk2SBV0fpyy9yfEgruB+MRGRyhOQtR+FGuMA5axV/DqLhxnBubwFAoZ+/ArNY0Hy5HHx6j9IqkrVEtWsFezuEmR5ewYzIYUCcRUXL6IqKSvx7GuWLFlWOFsMVNp6CsyEqkZs41QV4067OMHbREH8jrs9YQoM8mJ4RNThHDyD8ib4S+HIh5kAMcKpBv1qKgiVIyjdABpcGtJm4RGWKeVYOeZodFyxsJ2DR7r0aLIsuy+Ri042osUaMSZv3c7/QhN/tBsqcRp7pjqPhaQDeEJ3wd0wDKcJ9ob9iwFo8epKAqoWMsC6LluTn1Q/maahmHWyp1ghDQLrU5sfWKd+sCREETnqfn6RAEu/X+lVriaDTI03Po55cfYiO+v4Lpm6MeLDojC2veij4CoO+ZBpLd7EPlRCQ3Kj7EsxSDiT+RAPUQ3VPOcy9m1pUO7HpgF2VYhRfwIeCU6sbzK+mqOUwGPxyZsyrpIsle2gHe0o+Jbj4yBP56SAEHtfJAR6sEy2gaa2p0jGJ2ziG+b3j6hBqxHo6jYq02E5HdLygPJfIbRaBBMDocslHvXS/B1Em0fFZkkGLF5R2TVQY5JmoUnbDnUzuWZ8c+GgdEKJivvNNNIA534k7LLelKwWBhGiqnjKgSYUTDo1wviggxSFiVUzMk4Nf+CRYkM/3zBSztEgWTw/KJT37yeR4gaLaPTMG5O4DGjK34haTP820RnWq5mdVzuNr/KRsjCy6UZ8aFoSCzVqQexebpC7XvCzV99ZzPPweDzZZNDUsO7Vq0iXLNMpMUMUc4S2pmjNzyFEjtOht77y5j11D+htRYzxSv4Auogdi+UJ/aH+RB83GKkwEgzUmHVibHgH3kqrEzKfLwtkWedX3mEX5NbBooA9M6ELNBX6OQw5VGozjaYZ2+tGcdOrmGlyBq5U1E8hd026yhZJ34EJ6oeRabJWWd8gELr+Lco+CGnHUkMBXyKVgrQq1mB8MBMEGvLOMaSMC5q+i2qKa9Tewv8j3/Q1k2PSqgaDjQ0rpPFfF6sEGTIrHMARtRbd3HxmMXzB+sfJG+EDTI3bHLo/VvyFzYGsefZB/cgtY8QW3slO63k3d+BMrTfYtzITYUD9u5t7giymYDDkHjzzAXcPbB4DuYoIuyhRj/CG9o69ZnFvlRsoXR8BW0D41Z0T7hoo5Xg7ssS+CpKahdXbasBUFkjnH6qChiJ9H3WS2xYLgNjQqUF6xt4E65V8NX8Xzlo5XTANb/pkOeLuJfrZ3N5e9TiGhMO2nWw45/dRiVY0kwZhhDD7pPy/Lc08FNdToAIRO2g2shyIuwZhcxDAA6L5mAqyHH5e0xx40WADtHEWBnHeyMASXEV5I3Ou1pbMbu0Zw0NXC2d5gBzbM7apczlACen3RZjisFNJMynAOymdDv2KuLWD4+tSxyLAdtrCH1FbOiyFz793ELnhgQ15dnj/xyIPo+9+bSr7JZvudgDZI9R8Vwio7ab2CGAOTjp81CovG4D5LqyNCslHoz54gw0BIWFBu3MnijRroqo1CJPRpjyMZXURC0/+zjm5b17xDL5lmb0Jym+nsxmBdAmJjbDU1eYEIhxvDLeCUT9gOTxiM24a3WaKp4Up6dglNUljiuA2gfbapLq1+BnnOLW3vGIY3Ax3YSX4YnBLQPk6q4GsADk6kthizZxvzqxl1+sCzyZB7GanoJXDIr19OudeB4dLfp13eEUViBXJiu7pVGNu1jAoCaq1HF+Ts1Y4kj935sfehNus41SkNlyDiDY2jlJgt3CkPNK5XBLIXkMMltwtwQJUHVSRQNjh7YJzc2M7dWZRNyZP1HR5bjj3m8MtJTbovmohY0locapBvGFxnaXks4visnf2hKFvHM5Y25lblLQK/h4WH1XkRMPKVOy0pbNPNO6tgl3CkxBD0LNCURBjUao1ZCymqBFewo0XKPnl6MGlAA1ww6PuVWi3iWTdfZIPCM48xE7IQs648fE06Xmic4hK1wLWQp0nSCh1bD6aNjBA9KDx48aIds4OJ6TBnGZS5I3It9HHXUeMgoL0/5D5RAB5DUmw0GPDBQAgU/GrvB02Q28FI81EgjRS/IwSVyGGP9QLjB97kdjn5/fTn+gwVvWx4Rs2jbSYguXuzxscUIyvDjvLxJHIXqKzljXARbRjyIkwWFImFGn31BOp4sli5Hmz1vhwAAIABJREFUJ+oH4hy9lbixSDF8iMNf6CrpjlideTGL99g02wYxDTRSfkUa6Gd7hjUCHpya6A90ke8tJWP1gtSyhS6hhMuiIv6HsK0MA0fpA4UW3D/zoimGaN3jInMNJ8Z4lMhc4ABWkjHUncFn/4CTYOiWYZ5N9QPLPJuBjyvzwHw9RztgYwAFL5o/tcI5ChIpGAwvfUr0u88t8vSSATkqdYxZJJjFs8cxwF90dMOS44CGijtFixbDMpDCi0zIHxgzXm+udmFsq4i1l5mc50CW3kBqvPptDDXkGtmijaTPgydPMjCRWgjlMpoPh8NDpN9bA+7qn8JFJYfnZY88JoscPxK+MvCcjscmwZUGzWT8KpV4GMY2VyEvy/cGEvitpxocWYtIUACaGQ/nMvAon+X8OfwhNG6lvNbaIG8CfThp2XRgoIrEKei3/VSQHco6RCl6I2a9LE27TPJXS5nI2sOyyGMDaW9w+TQNTxXhqGYjHW6C82m4RVqQA0J240G1xLOZE8Z9BFZx9rEC0afAAV3SuNDdErlD7LQuvnmPGX+ea4uhumQALf5ZVQ7JTiTUpUQFn8XQ1OTriyzyre+jl0QLiXowq+Vr5GXzvkuP3ZRrlha3WAmsYqWqgo4mZ+nKF6sPVcfTgmw8K6LF6BykRZykh2gJtReMG9aNX1ZBgy7MAj9GWgXpBrBb1MGzpxgyMJZ0NfR4bmqPH5VFjj9R2i1Uig3m0o4OxkAljyFDRCPfhwSXthh1MsLZZaUc98pzgjIp5csT0vEcUokNRI3qoFW4a5N6LmnDBPJLbLuL+LlXiGBDgqDiBG9M09SorcYJtZRCPPc9kUVO/BDlnX5OjU6CpuS0JR6syHTpmCM94sPuxoqtbaX3SJTNAJh4J+RHm+R76TU0KiCNXNkw8X40IeGTeMXmS9CZ2QO9rBp9aj/tbGIpCzEI+OSqyAwc1FIQ/a7IIvoNIrG5FJPBhZpoNadF9MLWHSAQF1lMZlaBLfoJIxY7d0+M86wS6xNJ82FI5uGJoi0GGdpkfnGfQ2LzR+iB+f7BJBqCkBLaWXVFnEI9F5aWXqDwsAik1JQDteR+/VvHZJG1h59hOq/xlW1QwwW92cfnfqNIGCDY1kq6m4rv0cnq6KhFqlgE64dRANSpLcVCWhoo/eWmq+XNWrhkCOlrGu8UTEjd5bKJfofu1M9/RgQFz8c1gJ5Vck6RO+8wXK/07JF1WeTZb6xjb0j4Mowf+nMF8fkuWCTJIwpdgPjiy3oJz0zww/KDZXxkEXmmFw18eITjR7FLdYdqM14u6Q2GHMCeRlfCG0uXxSaWT3LBG4oRNIKPDrs9lcGwyXr76HePyyLy9XWoBxyJozH37lS/xnozNu+//EFEIBIgxYCzz6zk+/wjKXpbs6FtcIM5BhuaeSYMujloT/gYLVNaj07IymSgWOCqG8MWJs2qRmpDdh6WfpC4jL+DN1YFiHxJZBH50XEv7GoffN+xShtDNQKpI2iSAgab+soSBw6LGQIx9uyy8q1EAnwDiQqPrWLYwdZDMo1Ni+r8yjWy4/7UIh62fMDP2jj0LNzZBVFKhAdyUMnsD4LbcOEyI5xyF5lM20Se+04DwCMoVjY9fQcrw3N91GVUrcsBJjncpDcpI+mzRIcQhNPykSzL66omkaRxSEGUVHCSMROWpnhGrhwzqNUtN7aS2qJGP1he3TZipI9fOIKiXNGRRo/0LyHdcwsoSE4Zyem3joksIt/8sYsN3bXRsKW7JafHWrwGjm/ybgZ9y11K9QCSM2ygK/6oYKjSC656AqVI6WUlhWNDONPKhBGDMHh9GLSfhIYRh3VbvxU8RUMIuYlc1YFiXEE6BnqAIkk4rhxRsQdNZBE58hiGOckjGtXRvRdwBpAWY48DgZHPACut9xH19Y5WcGan9C3vS2HIKuLHARql2ESV/QhUCQcYMAOM3BXFR37Y7NxmIEPDkLjyqEcNw4i4CWqul+42z6EPSBle4GqaajHpxDcbA2z6M66TB1aBe/1ZshDmn1VV3ctiJNMAyjbowuELJEo2mfAibtzB2HG/WbG/KBCxw9CgIC1GZMQF91/DVd4R1IxMs10QqfSgoXs4woq8hnCP7brBaY2+5zn0Rhgq8vz3TogsIstXjgk6XtbF1Zgwd/ixUgfDpSFUXcCMAsqjjn9dL36Pg3cyCKx9jU01AqbczO8nQBT5kh6vyPrKuyAp9fQ4WNEO6ddyCWUsGgvuwEhN+1bO7pFdAn3OijD6kX+P/EUDwLGHFnxzqzeWppdUCHQCflyHaOWLHzMdwLJq/UuBrYYRrDjqWvzcRYTN3ex1QCKJn1apTuXOR5u4Lmy64MTspSV33WEkA9uFRwxLY/1BjVFMxHyUDe0mYke/LCKLiHzzGHaKJFJpHTqhsJbsivBUEGga1TOm4pBEzDmjm6+UG9/RGIGEVNJgGwhpX+coiu1uJkNodDU/8Es7/HSG9AaniUYaqMCXcP1fZmqbNM+uGMkbHhp44nFpAPjWY6kgh6Cpv5sEwa44JOzUT8bHF4d1HECpq17aD7vGDjkE25pXEP8DAUFigJ+mC8FNRdqnje4t033CwHUGahxcAU83ZcdWtTgElwnhZRo9C+5+ZMGXXBEzXSLMQYLlu12/+qw0ABz7Lp3TazUslkLJoeHKU2+FNAwwwxcEgpn3+60YXMrNNZjLQC34UYf74wXshZbV7I3cmvqwzhiTdbkYo9NY0iG+PEhtz0lCo68sT5GkxZKwVPwChukrONmXmZ34xhFpAFg+O+XQ0bqtfokVCWwLsAKc0mJhtfSbErgFhqljA+WgJUZ1lLPs7nMf1aStwxXkLcrHDrF3DYdCShvozXzssDjWlYGvmXiGV2TAsFUwMgli4eFcmdr0VlR17fFj0gHw0HPj2LEKtbbiBboa7jky0sn0YPkoq2O9bD8ZD3Jieo1nqJGBbpCzdNZgOGpt5j68qAAT8EpLsM6tHkiCGePUK7yb5jU1P2L3CurrXU+CGA+4QDFPV5sv9Bz77rr0EPDgiUlVDArlPBOVpjdH8s/MZjsbEXIOgl4PJ6oFN0DzaNylsCeSgW6GA+xYKQZMBIverDdrmIoxFVffMwlNRExjFmfXsnHkQgbMe2rcl9PjZAAK2XpXs2dAP/racWkAkG8/WscMTIWDMyTY3m135Yw9bawrDiiNp6+s2Spvm69mG9fGzJynciscJzKHHMkAXu5ZZh8FX2XgiRE1ypTpNia+4cBfxXV2ANSA3yjco3DStG2lo2zXMZ4bFK3U44+KdAA8+j2sHKmFOJv6VWItsq8iRFswmqgeKpS5NPBod9+ScyLTZ7wpL22YNEoqhlGDSNLKeN8q8LcHMt4Xfp0EVkBnOpsUJstH2Xh2osPWT2fRgd0LbnxgFhPtMuPHYvi+RL+vIiLPP/yYSAfAic+PY/OeVYa0L+w6IZ0KeFS9ZCBMsHN1YLQxWICLaVqgZFd9KdsEg081gC/BtPdv8C9mrUwgq36V7xN8CR6tlJHCHBfdh6IZCmfUY6YVABovbv4mSsyZxZiTXfUg1/NfflKkA0BbFlj6YicNk3j6BcbEyjQOV30Wqy8+UD/weTgp2a3uJhwY3wR/P0vHG6lL0mqAViTaEgwIx+p8i5evGkidEFYYTXbjnQUkIOqD1A7sGm1aP+rs3NCbCjHcBNcyESzHDUTkxCMnRDoAnn3weWObSeMyAE8OArf3AOTRTw6sKr6Pj40IvirjO1vUhM122goQ6NJYy47ct/LhvLV0TQns1YXNAEnrY8bSNG/Api3MpVgHUb9iIk8Y11RkP7BFUB7YDA8O/+jLCQD59qO6okfLIOKmjc9jjDKl34lbQ8TgaCJN6H5kxpRFr0IV9lDh8BSclOALl9f4VUwJPykKF4Ffj5IhC2aydbw8luqx0pMVCDDuiQqNMJAqSwXpG7gJZTkZXehAS4QCEelJszckoiKPPSwiDoBHf5DVR5LzwaR6tJJrPxCmkmSVV0HLZI9ee0dZ3vAxtiMcpglMwy8n4HaYMcDw4KRab6rklAP9XlnZ5QprIUP/f919abSmR3Fe1Z2RZCGBnBiwtYAEQgsRBAzEPhb2H/sk/5xzcnJOHLzkT/4njpc44SROTOLE9olNRBzbLEYCgzDYBhIUg40BIWxrGSEJSQitMyMNmhmNdpA0i+79Kj+6q+p5qvu7c2efUR9p7nfft9/u6qqnnqpe3u828dALyj9BHP4IPs0TULB38tIYR7w/0EvX8mLr4yLiAFi9XyQiJisI/t56rFxoCBGupBK7xuGLPJpota5SxrDyE5zjQlFqxSZfVkvbBptq2oL8nTxa6SkAin/qS/KuxExk/C2hSbIx3XOcQMXwp+/3B235kxq2nNhoUuxgNdbuay8ENQCs3HNgcB/t4IZ3zgis3IOxajA8leAqIkNOBISW18ELxrrJggH7rjfwznSQ0Ad0XFPYUDBC0T8YxkQ3BJ9pwxWxcF20mcY3RFI0MXcL6JFfKpqEZhc457AZSWqQG9sQkRdvb2eBGwAOfOvFqAYRS0GgZaXvLE28k5A0OV40VO1R2DJKmtHbjaFSNDIH+7pjhTJU+XDtIgcOzOD7eHNgE1ZMFU4ECAYNQEFoKXHhRMp0VFjOOxmcBGZL6X8aEGvapDZ8VM880H7rfzfw/t2iPc9wIelYuvLTg3Q63ubzRTlmWOWDJyMiq68gNQ4EayB9Fw/qRgxlzGhFi0ykMOLsNHYEzbQQMramnlkLIuoBvEvhCS60kuJ2/kwXWeJvWpCBDMevMbkRleIGYmH79vZLB8BDe3qMA4JBJcPI1o0uNBPPHAD9p+m68jv0wFfg0VQYM2s27EQN+wCsMRIkGdbSiOH3PLBYcvQwgQSgyuK3Q/7MUEpGR/lBGhPW1xwIk6stJRu5f7Iu2WdcW59ulzsAVm/BcGH0aIlAQ3QhyQDFrIHSkquldZUALeupw7Mzgk+DRchsk75ZtjmRprNwUERygwVbsTyZqxUlIWo7BJFkRn4niqMWy12UeqThdjV9LsnMvGE84Cly4C/6H4roAFjc+jx0y3KEVrntGCEJkpMtzUvNwyBfi28S7ENGf6TTg+n0dNJnLFWWsAQFIknaHjaB1B07DO4JCFxL9Cu3G1ySSGAt2igJuuz8dZvhLQMRjb1l5HU1gWxJPQKJp1MmePxARZ7e2j87AO56QlyQKgPFWw1QtYZLTFK0Gd4QxVWqrpvJwf9ufchtw7/dCXEcMfqwDsKHQgDbrr6HBQ3m9lmVDAI4PAwRQzEGxuXaWMrXhgoBI+6YDx7jHi7lg7VBKIgqxTLFGR4qAJB7+1cGD2fUWBtOYRgHJlZEoeJzQH0ipHGlvJRvxEJ7GDF6dwpXgNunJlt+jTkca8Gqh/nRUaT94r4eOhqtJPdSkHSNe6xCX1fv1FDbhdcs24FZJI5ZM2L0KNCFueep3qYDYHFT4Xow85K4G6uMhZzxTc8xy4O/wJL/1lkkpcwcjMjsJHBwBzoN/TC8MTtdTocgDDvhfkLb1AZYt636gSoH38kzQeYGhzVULfQ1ibbY7uhI6LHjMTF97gb/W1EOgLVbXxi4qqEHVlqw70hWeUx+wXsarWR9iziinm8FSKJ1cCurugauKEeryllLEtrbbKxbtVqWwuo5LGY9iCMQEjngKB5cG6QyGx9zlRhIQZLH8xV64keoe1zhkddY9N17/UYwwJ2Ph3KAv2j5l4qOEhA5L60eSqZRa0dGc4OmXQwWQfLzaahnmDHEJktywXCmXf3lVI4n9L2b+Dih0YiDaCwoGxxi0zy6FvSulD/I0Mq8mCk03AOASKxUN6sN5mpCdCdb3L7LbzgA5P5HnXEz9U0qCXbCTXFczhlsPsK03FX+VTyXU/wkIr6Yhd6S3xwc44NjJyG4tY1MywreUvsMJ5x8OZ9WGxL4rm48pwarY3V4vPwdn0cDB9GNXMUKzHCf61J9kCTi6Pn5ZOhUF/fs8QoBgLUtUmadBnK09579Wok9cOiIvLpm2sW3aLwmGKvYL/0PdVuyLYZpmZSuk3whQpxXkVwpSQSnyqgXgHLnAHdP+2OgyL4mPrHUIZZjA1kjI1+uljfFAolAqAGTS6DSROXpO+MEEABgb89vKRb358fXGiC64YpPOIilV+X5afEaNUjxQaEamHOoHixQOBGyFTYkBBW1huTeVLC+cNGUPxrAXMbqR5W65A5CJ0jLWw0s6zBw0r9/puWTfDIkNkE0LjnALyKP3RQXAwCL27dJvnpqCv5RRFrK7MRyHujQtRuF0biAyfrlYsvhqKUUW6en2FilPodTLugTIlgG7VlnYVinQhcOhojQMcmEbmmEd70t2Y1G1FmKP1OER8gJ+/jmvImI3f503AgAyPavSw6EIyrRu/O98uWy+YM/qYV0Xu6ik2a8FspIQFcnWQyed4lAkEmqKnlSNY+4KAlfBi+5wGcoAAyJBc1Gy0xilAVLVUnkjQnRydGGgZvwpRFzu3haqCpm+77+ZHSaAFi7eRVkC6Blu9Rho3dcys+3RUcHnakhAi3kFrT7mzpmZfHZLEBAz0UIVB6XBh9UVAs4Dq1EjwaQeEmgHmyqkatLuiQyTYNPqRbBDpgdkWpQOf5gJUqvHrVd1E7Bz2zJrhIA+29/EEX0b4MKe5dzus6BHoFgUCN5xjfuJKrcV5K4BJmcPLMe3gnQKw23rmKas7QGfJNeQxwcT7F+8lwExFhnyu2MPqjYi1HDATEhD/FE6oVuI8E9KKYYbxpP6pTzJJN2Q3EqunV73koAyNY7epfa00e0axsKZxhAt1ar0tXQH70QeFBRLU/tKMFi0giHHVpBRQVxC5jSTlWXu37xtAYgpP9tEH8RDbyF+oHp/rpvq3XbB43Rgq9XgUve2DKlDIQU5etP5WcAwFM3+SuCw6m9ZHkKsIF6WA5G7wJN9FN+HQUUcoEViEBERVWr9oUqxD3nOQibXXBSebwRIhLRgcJWMQ6+gqnNlmVtT3NUzPDDYpx6c6BFMjGFL5GaL4v3QrKhhKyfEvAsotaTW/blHQDAgdt3pFiVq0JoSqtUYzFlcPuk+Kxu4iBudoFVDR9C0W+YD0WQwWObEHwuR0xEfX2snFD1ikkUnisVnxKIwFGjR4JgGOBn1k3aIjkALuRCJKjO6aJujBlE0IRrEXbkDFRR1/azX4PLAADZsZMib202wiEhoVKnp0g0tHZqvKd4auZvPKPm/LlYNAg4Q9yJYSfWJ3vKIEmkzc2yVdpiWIealTrqJ8Ci6XKwrdgXWk+VRkrSbWjh8uOZGV7r9XmLtwdT1PKyRYQ7OkbAEzT7wnMgIwLg0TuichkIxzAimriVqz3w8oNbVSUTAIOEpUM6PVezWn8S1BrK9BEqtsPBtyziurr6zYw86YYQs0oUd6hqPkFnJmP3dgIwrZ8iPyHJotlgs950H4XBLVJdLd1KtAOILz+KPHXPk1AfAbB6037tJ/zjIAqcQVAOQV1qdckzQaAVr0RMVYnTyXDuqYE8+swggbNgTFHHk9y5YDKc/hbJ04/5f5fFoDOQGTyo+SK9Zpl4KeP2f1D9VGuUrPbpPDBGGRVWbIyb9e+VM8I98Zd4BwGwuG1rtN3ywEjyIBT3jixXAmYUHeMeZBGuTbt7MGh8zrzaksaQLfNK+18rHG3WDCNXo6Y3F7ZTkb6Vv87AGuhNYj4VrFgsrvBABoMQ0rgiBxwa8Hj4WybwatW+hARAAJCtuUBgcWIh3E0BCPRaUC1tBqM2Zjj0e8ocSFCsalFtCvZZv1Rmey+aOubrE5+Zc4Cul38YMl5mOZ4y4kFbi0YE7BsptUMChR1WpzViGc3PvAcaU6zJP/3Np/A6AeDAl1/I8c+SvHJcdBkKLCJdkp8xVzjH4AX6BNnbaElcm623gnuHg5szLxnDzzyvzqYg9OBZFIhYMA4TPLuCI44ASlccCdxLSJ6u31k2Fk4LZfgkBXjMf33iizRgAsDi1kfKwPPXqvNiAHpDKcBORyYGJvahYMCEEt5SYlpEs47yGa2WMJsuGZWcZTSlaDfSGyV9FsHZn+QFBuJj0nrMdB0mrqFpLPKHuMn+K8CisyyPmhMElrv9ajUCMABk6w2S+Q36j2muDGJf8XZL/O0SZowBKP2pOGg2fCc3Zxsmo5bSzfhlxpTOyu/5C3vgbCovtJU7skWb0WpPAgBZKr4rrKyFyC+SgZyOqcoIpmo+PEBkTCj1UTiMaYSkp++mCFAAcODLjwvFuN6EDQPCweSWUH7LfrRBqAnb6kTzCSytKJgRvVm5ZVPFDWEGZ+9ju4XDjfZ8GutHHXi6y84nUCgNJo4uuGpuBKeuQDw0X0datjqBgCt2GfAf/yuuzwBY3Lk18gkIxKoQWh3v7Su28mUnP0lmIJiWldiBIGiPxoedu6gOQPRP6+7TlpJS2fGJQ1XdRTCNQ8u4fAsiZkWJo3zonQPPwqPlICOI1PIB53J6DhYZum41w5wCqVmddRXHaiL4gODVkAShfekJFpoBIA+1oyIBxhg+rYS0z+1Au8YIJPtLiThtDB9wXEw2sdT/3mu2Rcw9HnLOjwptNr25vjygmFM/xddIBbSY1xrb948ozIR9FW2OP7TThu/yla8Jd6tpHFRgDkuVU3e02JdAyBeOnCRwba9GgAqA1c8+yjyY65f9d43gEEyFQ4nsQ8stL5q3qwdBH4Xg5pxO5AIdpBsUVWNwHigSd79zFzIRGpsRmhqarzNF8/0NCTdgcgoPSBO0Rac111SKIxndc1SDT8QY2uGIp2gVSAYALO69210HfBNW65r0qSvD/GC+1D6W4XwNMjChGXEOjGbRGwV1c/kAf8XQ1fVSUJ/SeYQRGXMEeoHFOh/BcTTjhzpslMYVbMzWMyevyAf6rXjFOzohEJs7AsUemYxTRdS++LRwKQCQPZ/Z25mSG5ThQv+E2EV3W75Hk7E3l5NgTIXhI07DPkTZ9ZufwW01yrkdXjAhcMSWN9ynRSPzjsIObu/Yp8E4WZkRaRS+T8B7AM411IIOaldind53/QZWaA7H+fSNJQIMAFh8bXsHbt0S5DaFR2nFjuWzAF/r/D5UTK1jCFD26jSshpZmTSpdhhPsLFXEHTiZafBZgPjQk3FWoJR3YT/0RN8LJUrFBkFeE6Wcw+MSkKQDawbm/hAYctuXq34qAGTr1/qTBkpmLIT/otRZk4O0/5gHfYN/QiNJOHTqKDsXgXhuoKdS26BLC44VNEWs07megeQznRK6F7ELM/vouXBYJYO4VZUBRMOKB5EHBS7JpQCkinO4teseq1UHABy4fk9H+pKDDk1AgGD/ECSIeSyD0wZ9MIiGkJvb5gitAhjLI/5FHexKbg7uPRoHEo+OgqlzHO2TH8F0fumZeotXI2DLYgyNJi4n0cQxFTjlCPhmHS4LtdR2H8fO61brrQEAizu2j9ada03wk6b6whnp5TdLOu4qgH1S3hSmiY/m7+CdfKA3WXsYe1+gmpwWEtihw5bpV8MLuXqLaGE9SKxSZ0cicFTAF1qHVeyoMNnZya+o66ONIxHEccPgSScmX9k6VBkAIFtvpOjq0kVTBMVxBESaDJVyPE/Es3KNv/XYb1V7jCS3TrGSEcPDFnEdYIxeC69PdATjFghN1qbGixv5elHqEg4Pihn+aQUQvTfBI64K6Cyc4rSGCXMi/ThN+uhTX6op4AwAL372UQjpAavQGPBmOTxlKDn6WlTn62oZk516p27cFD6qPVN8d+a+BavlaY0qSk+HBuMsYJdHR/Sh4P1CxOkM2EJgCF11nMOd8gKaJMKi7yXkbo3SYpc0zzWWQyR8al5Etg4p4AwAi3vv7g+bmJ/zmQQD34+ak0DWTgDyC4DOZVg5d3cg3LnPql+icOQ9ZsTA6Nj5yNI/UrdO62lQnQ60VwMhXajIdjRveGWPMU4I6fw+OrRP4U0UfHAJ9Z7hxc/UB7RQeXPtut0ylBEAsucze/1MGORzRN0wh8FXBQYxEiAxQiMbZcX2YCUcYGpvz6dr4dgSmgW4TLIGOtQZv/PRHsC7jcNOWU1HmwW8+y69VxjG1oeF4xpiXAqeLAJHHbKpfs16fEvAjPP4XWMKOAXA4oaHxTkKByCpjsl6fNmXg4FSNQAtemRwtNYmMKTljKYyc2/Lik38wc7ueKQmErrhFLgKzg7LMDtGFP2TPRRGmlsTOTavak4PlvbHsJv1gkUg8pRV8v4PZoqCpmkSfGlMAacAkG1fzfMS0tVaMs6hmDJYZkvkJZSHfHQQfBpIEytW1Ng12V2k4NI1rDAvjg7StHVU4LojVaEeGNX+MC4MjJ30eZHF6cKgk4gkcQCvyYlEFr3X81SjZVz6yHqf+XJdBhaZA+DAJ3cRTQ8ztLoFEo4Hy9RW1t1dSB84NE+hdwqeYVsoo0lat2BDnECLbhSaH0HabeV+xUHVxXfgydB4HP7LsfTr4dWhBfMsSi3+RqshvQOQQHi/AFvL9eCA99MDXb+8rZwEaGUGgMW3bu7i+WYWnODwRZeUjjWe/UNgDqFTUGQ9V1qMjjwqWyZ7DadsE4OT01oYR1J1nTiQyCcnFIbiC2VFylw6TvKlg5wsMBKFz5ByQxgFV8nIl6SciIzJQ3Ap9dN+XfvkHpmUGQBkz4d3OR15JJM+QvEENKDtHkhOnFoZoqjGmyEsa6yVBHDYxYwYvIlQvaCLN55dRWoKmKYKfbAJvkmwI88GhQScXfC2BR+OguFu8OpG5xataQ1kxG6wSUtuEiiDfiKI9/4f/NwkBVwCgMWWuxB6eRZREd6zNU+Xxm2Hrhjg7oBO37Dyof9GAyRVA3G0umYQ06MCoqW1ASjCuX5vhDtl0XmMEsnFiBVtrsy2AAbytUloWtXijSk+fgIdu9DsV+glyF7VrVb/+EGZlSkAZM/HX4gtaZ31ZahCy9tuIlz8dp7Fv+iq6JRxsrQMhDoFeyX/RQ/D6unoxwp1Fst0AAAgAElEQVTmnZ3qGefNEuuffMe6zBjFQAddIikayDv5rIWXMI+W7WNuxeNycyLXrkhQiRI2+2Nb//hFmZU5ABZ/fWdOmjAk9ckL5Px5NDt7sx6RpITAnlbweCJLTUWiE0/PPQ428ZSADDs7kmBeN9jEu6XDDDCMuSVAOUiL3uLgpRDGZ5SxBCuMrryu3SXo9QGKwjWRXv2/cwJYAgDZ/oUFjryJ0U5iqod9Mw0oKKkb/QxH5q6DrWIEiEfhI3HOBBXcfv4rEBUg4KgLRlG5HtMizhstFtcG1gi+ElzVbnVxkjK8N4ei4viadPlQAII8JeCnHvWTQdq/j1w7zQCWAmDx+e0IbldbW4aOszNBOu1X7DCZG5Doii++pmVaiTtplpVCISI4j7SsCXM0qdolbx99amA77I3Fjc+88ZGW67O58rBi1cn7m4LBprwypPjJ8iwcS4loE7HMuETsK9sn/YksBYB88wbHLfChpylD72i9YZEUjKt0EdxubLJ/SC5AlQyIUBCkr5WH4ODusYpGtI4Q9d/zDF/BBHByNzvQRDu33QajADXjZpQv5xFUkbDaJJj5iJkaUW890WpLC7jA+OiXZotAIssBsPeju7wTB0LvakwNiLjjZx99fLlUel9LgoYX5SaEOC9x9HmoC1Jmq8Q56pfisfYGdD16l/uT8Melw3MVLiC3qEZL3og2pmj3yaqh3HH/XwaV2qQKVo1ONUYNLLl44GvzR5cDYHHvzZJGBMWJqVlOVgc+pdiqDku/sXS8ks2te2O0Ox4Kdq0RU5dWrSSHfeeG3ZnQHfvuzHaaqvdvQKH4T5ysfaMaGJzayuHMwN+SPsgAJjWGoWp3VlN5/pOTfcBWlgFA9nx4V76sLC5u4xfl1fUqclGxitFbbcLL5Qkhy3HkrQiuXmE4LIFnLoocPU5r5C1iY3AWN4okaxKMg+RzVCY+Fwtgw9Y5nxuFNj1CRetlqCw8fa50KSMSTFk3Jh6LHrl+SQq4DgDWbr0RR9/QXbatWBBwjXKKoCsi5ou+nGX+eRZCZEyU1Dfvqec5a1hHXjQFfQwIYHvPqLo83Ca0ipLHp2wjyCFCBJp6SGSGvlyFfTqVYWl4KkY5Dcyr1z5URxxlKQDksY/0LMA90AR9zUhWzLS6jBQdIzqRAfzC7HUNq+Ns3hMkHzYyAor3Vl8doGIEz45tuEtnh4fgk9WGVv1fyzxDQ1d+qDzHlWOwYQiYYAALz8gCn6yR0UREtv/JUgJYBwCLW26CGNYatcxmChjD1pbjrfnB0sA/ydOkns9BMdqvoWUfKaQm+XCq0+KHUgAvi0LBcgF2o5/QSI26Xo2CTFTVoXZaN0Mkv4uAlX0JeYJqIz7prYYLrH582/iIl+UAkD0f2S04aAXPmoZdSBnMJWCZ5kXrXXhHQCZK9nlcOJt4v6oSq5XdwIkIbQgmtPUsCaEaD5S4QIECdvB9Cy6Ao06JImhPhf9gpGPbPUxiK72hPrmdMQ9riP7uiWz/2HICWA8Ai1tuShNIfnWwhwSSwVx2YI1KICAvfaxMIfk6XW9gTAYiHADn+bN9R99GXQ1TaFHDk4jEMmUleXYEGhvl4K18hGZc66qtiMQso4/LomnLi/lw+EVbeVA0Op1zW/3Ydlle1gGAPHb1Lkm6VyVSp9CYuyyjm1dVal5wtMfQCudn3It/gZGkCefXVSYwGpjU6HWEucROdyjTZPFu2GooPKWkKyVxBmElKAS4ICkO6kcKXaalk+8ta9OxHesRwLoAWGy52brhy5Fp3CKWahrvfKT2dkN9cE4s8EwOiaf3EeEK0JSvDyoY4qn2CUENmaPkFIdo6XkMf+GKMESs4qhTHFe7Ez6VU1W8lblHmFvjAUAHyoHAUVn9yMPzcbayHgBkz4d3NxE01OxCxQwWTDNQZIITxMtEoZ/KTenbiOJ0DLQeVGhFg9jysk/pyUM6IZMLjLGwAoydgluP2NwR28JRV8flUIsBE+VpX//DMyAeYPwpFQeKwUQsF95EbPuybaBW1gXAYsstHaCjs3hfuFcAt41nCpZDGArEQ5j5eOutSuge1ZRPJ9sOpwcJB5q2MhFA7/LiR2tIMKUK/o+H+TbfHRlxGFffHNOwIbffHc8TW+PMW6kxU3qvPSPl2ge3rTu+dQEgez68C7qaMf0oj1/M49CCFqrbxtM37KInUOkUPMmqEDqhBYuvXuLd+J5O16i+rIcRTfxYEMCwRwHvSVJU4/H2o1Y4fIOKPc1zhpxE2+gr30Xpj979p+sSwEEAsNjy1XKFXmcon+DtmahuZJiJ1ocUoT1m/sA8wPVPHlkzESHV+sFUBcEpDsUlDrcwpGwzCTjvRF8RxYfxAPxTzrD0pBUg95AoV1bVdYrRzGK8/rZe8NWD78uvfpyW9QEgj31g90xENxOOEvwUVoxD1owlS1x5aKpUxHe7MhprMTmHYTAavMxUmwaM9b8LDe+FGNoCjDcxNhzCqK4O3IYelOEjm+ZTXhZ3Mwb5U8gf0E04jYnYli+uTwAHA8DixmtzoDDkZREOlgoFBM6/1jcvGFxqhMiLyre70pY0akgffBJZfM82vSjXZ5UnfDjV4sXJvIGsFvht3DGkK8q/oA+V6WkdPXu8UCydrw+ryCPXfXtyA8tBACD7r75r7FrCNVyPqWlIXPIhxWSfLAGCJ1ygI6Uf/smZEdvBoDnzTh4CexE6/BChVGwpyMCFhzsWlGiQBrBA2HKPELhb6ZfaoyPKuB7ZyUREVv8q/0LkknIwAMg9H9nn87NJkoMvCRiNT1FeIzD4pxSc3zJXEad2atOfGp6QstuXmmdceP9jHoOT+3TUCu+QB8LJzPX6GZOo410aV6IW4jBf3UgorIHegZXwepDYt3939joglYMCYPGJm5uVKYZGAbXrcDOxn2BgDnHJR25VaHNyvJeekJKcRPsdhjYePIdmhOHKnxiwLheYhIds3pwMZhSMSa0SBErzMx/coAORcgA+TWEpZj9wEipbvfZuOVjZdNAaL+x958tTli5AvtW4NK67qMu5WOO+wqji/ARMIJIvYzvK8OUL2PMBmVJMraaCkDUdQbRSY09/wF1cyyGM0QPUdFBTiJVjhlA3CtR6Mb+JI8yzFdqFhtdLtv38+I0gtRyUAWTx1Ru7lBCXlT/A2ESEv1aEbuEHItYIkDxvBH7zKqAqSN3SQ/GdQeSniZ2dfOB3cyKeR/boWWJvhOeXggmJdKDWYBFxb6qnMVpI5lAxonw0YqnGjXZz9UMHywBlIwBoJ0Pam0tDABq4uTFRjHcWIUfVTuDP+3ahY37luByebv8uoaQuziAVHmZXZ2+erC1beVHKRNQrQ4wwND0Qd13np0QgKiekIFT4pTzJXhpJybd88iBTQJENAWBxy/WuWKfr6JBep2Hl4oJ0R+mwwcovwkpz4CExy5slf1O8iS1ZrK7m+mz7p/C6dCPAA2MFWMfPnx7tywjc8pXucNiNPggpMSB8HrjQqmQUVchZ4skHP7hDDl42AADZ8wflD4mMiui/GeIUKby7J4NYcPw9LLqRez4cZzsiZR5fn+/VW/CRCExu8cmJMf8c+wKmLlwJWvESXrmao0uLZbyJdXAUJci5UX9dEG2HxzGmpcj59zUHxqlckddXv/rVDRDAhgCwuPnDezGqkj6A7ZWEKvKI1SdgjA7w3IELGu4giNeRgPGgVW2+WNbEeg0IXGUBq1sxw/gQekWrNZACC4BLfCnBKFZ4+e8feGXmA6t4bkqhs0teA3wNzPPtDx10CiiyMQDI/o/ePLWpRNw21gvcDTIgsmRvi6N96G4RQob8RyQCs4Heh+Dvymm9g6rc8bGnrMoNhCFQht4KpHvK/yRni8QMP5pdkqageNpHDtE2KmhKpkMW4jnw6jW3Lu0Fy4YAIA9fFflkzQQtQ7PpgIDha3uQPiPWO8+LOBi4OB2AstWTEv8SpQn+lEyH6w4cyUKjVtoIl4VohndV5i8ZCA0hj1Ngd+ZnPPsjE3KfFHIi9gB8WEW2fHQjAWCjAFj81ZfW4hfmKqBadqCm4xq5cJzu2fD+aatj4Tbpm71m2C/2YPP79CeKGzwEXt4LQITBJtg7SDHwB47fRAFl5H26rhIn/pclKjXWQDBoQFJyMmdQ22AGKBsFgDz32w97FyUKxTSEl3MxD6AFbyVtsScCasrZj2T5tJQOstjk05C0+Ch8aye+MgirwhJySopyJhmpxbtvyCBqwTkMT6BAyAuWMMBwEMKkDJp2HPwlLF397IYyQNkwAORbf+h/c54JgIh0mv+oL1BiyT+JwackJg6Y4QGB3n6PpVNyQaEwmY/0DnraAj10GOKhKg9q7Hspp9JY63lOHxpDexKi8n2AMnJQSw67yZcvQ5gFiiWTJhWRr//ZhjJA2TgAVq/+SvUCcdmra+TcKQ88dO/Cgx4OAX/6IKlR7ZVopwFkZgD/W34hg2FNl2XWz2S0USvponEICmT8dP81Vig5n9CI5nCVlDqROiTPyOgjbmXrn24sA5SNA0Aee9/DufSOhgWhFTQ6mZb5VUjgoYyRMh4ED09SLU5XdBj3VBUTkdlKYb/Cp6yZs+tH7zwbzTTdV5ZI/mFHN+UdM4/hCsYxox+9MVbb6p9/eoMBYCObQd7vjrN/+DTvECet6rsjICsxdod8Uun4zlBUG7aE8KbmB5xJMxLmq/gzw1uKOmlnekmrYBrC5FdhD1l/SDyLnJW1EI255Sap5xKSTHNXyXeMvvnf7qqDXVo2zACy/5obBv8s/giBdvDk0SqT1ExiNWBpPMC8ij6a/zccPrbxc4T7JLXI5ysHFGLwvpx3cYbefwZVjZndjE4g4PfOaJFcG40VSoIYEkf0+2Tiu5/4umy4bBwAsuOqh10XdMAuOSkd22XsbO/0TmrEr97I0xHhU5Osqd+f3clXF5dCh4LVwD8aa/PqKzd4RktpyOjNymksbQfVXixnsiBQTyLy8Gm8WTyMILMDZhMMx4vP/9H8G+Gm5RAAsLj+6n1NXD4brOSzltec7eEtfYNxwMtMcagdSHdmyDRShQAe9ydvA2+KZ6uPwkMNiOqhKhcJGDLmnm4QXXrk898yZUkpATuIVdwyHggHaYRPCqZzYVy49+oN7AJHOQQAyL6PXJ/dhGhFrR2e5bxjYt0yNzR3/Ww0b8igP99v6UNGIjRWH4hiCkmBN5nf0lJOAwwfJ+8XosJz2H2crUKrUvd6S1GvGpxAFF8TTug+HD5O2QO32bc//tVZd8vKoQBAHrlqO8nGizrolzClFjFYzyAMJwnQOWpz6lCCWqQ/gBW/RBq0/EghMohF8ZVutnu2PcMvdOLtiXEHuSCa67usl4IvjCeZSkOwYDwoNajDj7XrPrVXDqEcEgAW139kL3hbihO+lZweD8GGfMyRSc1+4g35BO3SmRwZwfAH/AtCwVVGibuniPQ3OUIc8jX4RXUmQMYH5eXkfEpjQ7s/lYfTCsm3xhXXLBRbhAhrAbWmO06tvn7Nkq8EXVIOCQCy7+obYnghkP82D9rm8/Ae9foIAdC+5JtB2FvsWpFgiph4o8dra9ngocQY4qhZQ0GLRq32ehx3Yrw59bWwTGYXZfApX1CZsYZ6CHOE+muCWprwDwhHAIaG9nrdrX9yCDMAkUMFgOz4n9t4qIiDdA8Ia3iEn8cUP8mfSUlAijEn5vCSUlAPlJJCnVihUFqAoU61PoUSNpjFRibVTYowTwGRl3iwkDGWA+JCbyCJ4JdslzzB/T8aXfvMZza8BNTKhheCehc7Vt55umDu1A+94snXHtlg6ad/CDsFiI3NMpY4C5uNDa90qoPDNFalvDp6lGIfSi2UBvEijExjPsMi449uV22nQZ2HNETqW8g4CHqvaFxHwishWnSJN0W2vHfjS0CtHCIAZG3bay7d7Nb1bG0UUSRtx+r1sOkDyH8lnmc0YQVuKlTqP10zSp32FbQBN9GPCoGAIET8rixW66ou0Rsu+7mKSh0Qv9wYfaFp2PPV+VqHiYqpbvvA5xb11kHKoQJAnnvozRdVOZOXNA6o+6CViNxTAkEPo+XYOEdNC8xZ37Db3lE0oXAjSwYI7Fl7KFABe/ntIJVKTB0rRl0M69aFaJhSApFlOKiT0mu3uap2NpHavYqovHjN1c/KIZZDBoA8/p0f/l7vlzTaHU+Bp6tl0Nr5s6hLU8Vph/bZ1DdD2ym03lFaTKRwfcIoHIfMZSRARqT4Aks2bkIn3whpG/9plOE1kIh0GOxCZbNoqWrUdQJIgXLhbvvtb3/z0GYAIocDANu68s7TKs25jgu78VkdiIpuwUn7faFRYWD8q7ZQ3FcUvAagSMFy5P028mcl8IjWRfnkp+KmCMDwkeLi9qEFOOACJlWr0QnlbvUKHBWbCPU/+B//xoaGDlYOHQCytu2CyzZ3IVzQYOMmVNnVgkHhL2hBqKuoQCw1A/KI0T8SHfHr4CopKLICtAuda33OCc1B5fYPfFqEofwHsTuMAzBpkLDYyDlZnzA2+IbInt/89CHsAXg5DADIcw9d8bomrdKYMVXHjzYGdAkvnQAEvz8YyVXztQERt3H2o5x6cGcYhrXcz5cROLI7npHA8AIyXe+XgwCDOwCa+ur7d+5L5jGUn4XmWJ2k0X0fu+o5OfRyOACQx5/94e81pbkQhgRXMMSwYDCeFIzU1y/D255gr2Dd8nASow6TxOKPJiQAtURBLbw+Vu94NIP8hsMu9vc3O0QY3kg9GiiOaoXyNH7RURv2l/95Zx3XRsphAcC2r1x5umBQmiXMaUPNCjN+H9xFsCkwCfRBz2jSekGFaUrpVmVsQmXFButQoI8xfrQq9WFEutUBxeOj0iJVKe05a/RPPNw7331HFXpD5bAAIKtbL7j0NHYLOhIzlhqTsQ7YMgN4aSW5Bn4nmFRV4hP16YEGymxlSCwoh6jCOycPsQZGy8Cc0Vh2POKYxuwkSmPY8Vufz4P7h1IODwDy3L2Xv0EUZcCjlfM0Jlbs0p+gaPl3giKruWXJKpp3Yl7YfhBLgTjUPbdVnFCqwAPxaQYrK+LTm2C9El/KjypliBAKfCgZJbLyvvd/4AU5rHKYAJCnnnjbqxiqUIbRabC/n44ln+AH0kVGjKA/zkNOcHz6bnU3T12q6vtT3aZL/uxXS2Pi+xiIYjps6isyhbhKsEwoeY7LbOS1k0iGh02+8GuPy+GVwwWA7dh55StYmFkIcAE1OVZzST1u0gPdgYzSBVd4BUVdae7wCYAl0pqC0T1HK9C6RfZuMYwmYCCEsrBgDH7PB2YRHdqDyMEKNUH08SQgDdEdVHDbL90nh1kOFwCy9vDKm1+mkKkW72zFcvUOKlK6oKNdiUSBQyaUM6yLl7miCkEPc6clC1G+NuQ80f6B5cV8iMSpex5hLo2o4MOq3Yawk/QJfN5hbYnT9sCOX/7rQ18B6uWwASAv3n/G206jqX8vbum+VhtiuuoBzQnn6milRFgoc/CREqRuTGFGYHgXFlyzmZqexWVqdAgihdY9Nkx8ov9tKfAAoJ8JIHvLSByYmpqK7fqNTx8YH9xgOXwAyPP3v+HizS4Iq84S7TGAcc3HQcBqsgklpN9wQGe9gznYfUPPZJZEpYSSlztnGJ7YqeRjkcFEM5UWbH4QYdi/iA9Qk6jHK6g89QcfOJwVoF6OAADynbsvfYPLgbh09SMX18VA0BxfcAXPWGDIMlSKutzwitUapKbexfOzwgK8c9XlGoAJaAswVR5xZOjg5h6f8OKAcSF1eBZtLajt/6PfWvZXQTdSjgQA8uSTP/gqEC+pDAOoF/AczPsYCcsWw61vAE3aJW8ifU9uUJfdfCC3AfYCHSCOWxhzMJhSJk9l7YwWNfXDoTjlYcNQgRzHaawfEfj8u5f+UciNlCMCgH175ztjKoDjs6nC4efwqRdc3hdIm2EDhgTgS7j73NU5aJ06x5riHfhn4pn4lKvaSwch9By4BYpIoTygU6YBY9SniYyK6O2/eNgTABE5QgDI6sMH3nK2hGgiUvN8EfQo/911TqAfCN6bUcG8HEtu0nlFvl2w2Z3a6CJxysAiwoby52yYKdT7PHgQaWZ/8Rlq8SKCnqtM8YlH/u3XDnsCICJHCgB58YH9P/iylE1EikazVBs692IaFhWbp1q4HOVDFQiYQdU/n0r1aYpYcviB6otEcQOji5bb8WuVcCRE5g1f5MGedHgIL7QnHvv1PzuMLWAsRwgA2fvAWZefKaiuZWYqkBaYH3t1U08Cmp7bhCn8UOKBkolpNlKSLAtedfKHKUa46mDH+bawH3oonkr91e4hQSQ+nyc7OCgcAZ20CYox3fPb1zy/vIkNlSMFgDx/91lv5nPCAoPOX/ul6QX/6P4OBnGPVZHcLLeh7U6I4x5SGDiXUTWa9her6JmB1t3gfhCJhcOHfIs8ZVP/DhN0eONxigicbMSti2RJEiuG9MRV739GjrAcMQDkubsvvHQz25apM/xnZFQolSXNT/1h1OjL7R0JnIcV2KH3U8uYYqB3hQ0xNBjeG7weJCN6imabpRVMiY9BPw0PrRdccsBTCAMZPPG/f/dIJoCtHDkA5Lu3XfH6qf29DPFLBCYKzmhd1ZAcdLWQCcGDUf/4W8wdqN1xD1XzR2QGLGpz+wj85meOhr/TrhCGKn85CkbYx+o+LA4RiLTIIgIhTB9//1VHbv+jAQB55t63n9c+EQ6EAeFB3n8rmHHQq4r6tD8sE2EvnrGB7bO4EQ3On2i1N0VTBg+RTndEd0iYj1r4/RJBiKH4jmc6bmkcrHSOmzQbgBKRJz/4Owf/MviDl6MBANn1wI+8UkRioOPhGMlIHtQcqy6ZHXkjrmByJyBMD8jxwLTwyqGNq7k9pUNoFgqrdOG/aCac6bgD8mvQA/BrQnHaWWkI7nTyee4P/8eT82EfWjkqAJBdd//4y3G51XjEWNC1c089FWiR+kfSh1lR52PBrsDQnBqm18dRc7RkZ243OsuKogPhVxNTR5D8iQixfqLLEDXLSKxDNnId6Ka1+vyn3nO4JwC4HB0ArO2678deMTpOJlF5Jb0d6Aws1X41NEr4qPOxKLfnv0SKvoSASuyAvezK/JBziUhOR62Og0qXkhvqSQSB0pTTTXjAcsi5OFAblL2f/pU9EwEOoxwdAMjqw/f96DkSJh9G23VnggqQOL+VQbn/5hoHSw4e1zIySzPqcuuMk8BoJz1y4O8YjSdqOa6R2yDfoZX/gDpmFnVMPh7lSxyZ8sbez/7iY7X/wyxHCQCyuv2+d56Dio6sCZw93qSMcBHRFBQS+g9bAV6yR/MJIb9H0D+N5waGYigsBXHwS41MEvL8HGH/J4RPg8WkoSYCremsH7dUJE98SkA7eCddZd/nfvGINoCwHC0AyNrDO658eWrAj3+YDsqHJZsYPk3PsyJccRsI6rulEV0/QAsOjWyOZUA0JUYt4WhxdYIcGYaZ8jiInb+Hl5L7436d7yoyR7SFgU1FZN/n/s1hvQIwLUcNALK27bEfennG6wzr7IHw7o4zbAQ7SWfvz8ZTCvc0nnKrGVnAXVAmoIqqwLYuLYCydTcJ0d4eHwcl/shR83Xj+Ya4ErJVP0MFIg9BQWTf5/71rirP4ZejBwB58YFn3/oKYcX7qkyEemuT/OBJEV4iCUvCT+Bq0EZ1cLJxulcaMb7DKbhdMEExx0CkFGGDfgHNieABsNM48npsROSPrGjZfCxKwv4DDktEZN/n/tXRiv8iRxUA8uKDT7/1FZHJ+bKtNH/pmu60Sn9RisokWk/ou1xilpn6vk/5ggBo+S04IL/fgHAYmQBgR8atnzIAkCJnvK3JdIjgHAKcdwqJRmv9wGd//mja/6gCQPZ9q0UBidfu/fs3jU8ISP1iDYlRDuatiEj/c4/ko36o6KEgSLIrmgaq39TeeLbt4SYoA2P2JNtIjjFIafsw41LK3X9WxkuWMd376V84qvY/ugCQF++/9x1/V8g1MkB3XvC6mIih6t0JIYmjLxFJnXgFtraSDaRMTPEznCeC2YQ/1sMUthXS9SSANmtmJZa0EUzigIiQgqOB9GnQgOlzn/rlozT/93J0ASAvbr/jih9QTmU0jvS5Pl2F8atv/lP6HRmi+HZJb6F8L9UkJkABbxIjqkgvTxruBVk4/vUf/q/p0m7xWHJaEw/4gJ35zQhY41bJRxsKnvzD9xxl+x9tAMja9tsuP683mghOPvXAG/GtVeCA6+aI7/3i47tJxPS/cK8i4HMMl7IViY5ISZ3zF7NHDCu/G6b0Jjm4mTUDiXkHNVBRlScd93zwd462/Y86AER2/fWlF24WodSlF98V7QRYogRUC19L5aCuKc3nYk6YzZoeSzIEOxFNpSMScOG845gmCCUaLBR9K9LkywgounFPAa6cSkvILia65/ffd3TW/7EcfQDIU1/+gUvyjNCEJDGpEaxkzhP0u5fqNUOLvZJphIxUn6IVowVK4ai3EMWDE2fwAcdcm3K0oqsHJrpFrX0hEHUFsotHAMoDfWC73/d7R2X/j8sxAIA8t+WMy850np9VUA/cxItEtZK3xxhPqzxGczZ/PKZ7uVvAsIMc1EhUDALDaly0xKf0CLI5mOSxcGzc4YieEAMpS1kLePS97z8K5z+GciwAIN+98/RLz5KR20VidES37BI6+UkeQ1uAQpvDxKcinjwo8UduuqS2MSHBDIHtC+mr/w7rNy7rhPbD2jgdLNTP5ATvEKqIyCPvvvaQvwNwI+WYAECeu/P5N50tnCL1Et43Nbr5Uv602VCiUMsUG6x907pSF/DlHRjJGUdje91WuT4HwSCSSXJTzBnjsnoyG997SGqx5PxBJY61xf2/8uffnerkSMuxAYA8f99jl71Swgxl2ze32HLE+O0IddXIC1CvFiKNNlTEXZI2VrqWyfsm/ARYjMOFZXsJAkZCASMENNeOPWmBGxMWiMVIzri0/4v/4amTrZsAAA8USURBVMuH+Q0gByvHCACy955vveq8zZ6RxSxOk2LjOzojFPafnsKRZcOfkcnxR9B9j/ztlpFhlBE3SVA0/8BItDY5TQTY5bVLBrWoqMb+B3STqOrG94BFLBX9PXfdv7vtCN//WFqOFQBkdfvNZ7/+zJJ54epanKEPReacgBdOgwnz4pgYMn2CQYYEs6u5puKuekg9pcMuvZG/7UM8ZuGfpYEA4ftezHeedeCEANxDClBF9nzo17ce2ftf65RjBgCxJ29ffaO/OFgnzRK/oYvm57RT1kTn7b6JE4Ag9TRddlCmkD1CuDUz20cJPF4FIq37sySti5/dcoO7KQ3WinMUmRLAeb+ySOVCxlAevur3juL2by3HDgAi373r8b9/DiK8FWJh/IT+0YO5KfoaULn0n8pEDjCK4wLcDWraaw6hQGP5yOMzMFfUyZjlVDaQUGEpjSdVYjEstwX6I/mLiizu+vefOhbTPy/HEgCy966HLnv1ioigIUlL7R55njN0rxDMS+QIdgWiqG4kJXTXXAyuUsnJnbNAIeU4jhLyc0YB3zmAXYfIXc4mL8uYjGEqYvuv+/WvHOnrf+uWYwoAWbv3pnMvPE3ckJ77eEk7gEvS8rtXBAN0+obtWgoUeNLD8Bdqnhr3dsSrZv8jMfVK2UaSfVIVrhuYe7rwqNTjhyulzplVTB+/5je+fqzSv1aOLQBEHrvptDe8zH9p6kTd5Ych/kHBr3UoHpOndSAT79PB8byvgO04ssTVij1vlA4GsCEhm/f0AQAUQozD5iAU638WY3r4vR/YdszSv1aONQDk2TuevuIcEWBtoHuvFDqi4GwZG3FvuFmMgnvZmI/1f1qmMSSIMBcsP4iITN7K9xtpW9PxNvcdcJq1xuyBYksmNaZit7/72mMZ/kXkOABAnr9962Wv7hbGL9EcVYPvRycTg3fl6s+wbubP+7M+fTNa9yWNu+WJX4CMCsjMZ2+UhPYPiVi3v2lcL+1liwxbv2V9Zrn///zSDYf4J8AOoxx7AMjat27+gdf1DeKyJOIawzCL27I9FQfV9OsZV8kL1XxiqBlgC1/nA76y5F/8yvHfyJcztxiSPXJi5VjRO/WOYni9ck1YA90qtuuq//rgMaZ/keMCAJHdN+2/2L9MqnA1b9JArtV1Bmm4cOSnmIH0ihwTGIlkMCkiDBzLTtRWnV24dbCxxGo6/DCp5ECE8JlV7TUWd7776iP+8oeNlOMCAHn2jl3nngssW8lbRMIENpzCKVFjcsqPsoHJVzHQSjQZW4rZ6ansAgOHidb0QjBJocZMUcBgkWQwrxdCmajIvj/75euPbfbv5fgAQPZ+4/a1888OliWjddUlUybn5+00QKR40rN3gEtEaSjwbUvGx3EgxGMSX5EQBxr7NaWVXY2fSVSxHMzn+xS++oI7SqFNVHRtx3t/64HjQP8ixw0AYjvv2v3qc2Ey14O0qfR1U5XwI9oK0Kjrv+cPdCsZs0KsLwS+uFOihSi257LMmpV8u5f4KT+pBExyjoF1PMmMiCItL9j3xfd8/Jhn/16OFwBEvnP77ZsuOAuTOXMIQPYjIvh1nbQGKPnT1WYJG79ZUAA8o4UBhjpebxIOuFoeSgEGWVpmCArbI/TanR2/+9+P8eIPluMHALGd33juwu8TKW6HXtAuY3qfn00FF1goMRPJn0wHYSCl+xhXOBjHtJFDBbacJs3X2WtoyY+qM3h4sBvguu+Lv/aRJ44T/YscVwCIPLvlW696zeaRsTMAh2dLn7BlcqRsqgE3pU3GRuaNeXmZ89aWR/NxOPLvLQnpMbQLoGS5lFl/5+//l1uP/eQfynEFgKxt+9pTr3x1ieat5AvVnrfFam44s3p88MgxciuxtBWKHo0DIQKDiybHlLlaZnY48egIhcdACmap4Rfc7lxs+dUPHU/3l+MNALFntty/+VVnT+5oNU38kyo0f6Uw+Lz6Z+oS4QThgBy7Z6CRzvvxTzSZN9gf1DA/Zx7ZOeEqo0mZzHirrUpbDVvsvPbdXz2u7i/HHQAiqw/d8uT3navlqluo0LLx2jtyqZuUDwwE4+PLZPgIVU1a8Lc1NV5GcoDACwYS6Wtvq9gT8UVYC9ZAqFg/SKI+sL03/uqxPPmxpBx3AIh859bbFq89a9CdpEZTjTHRx9euWvH5gcKdzB8CDL0a22oaOTRrd/P241xBEBJtNQRlM5knxtRG4FBPewrxZLEo3Z9c2/F777n5+CX/UU4AAMR23rn71Y0Eyvs6+Ta5gEezmcXgW8RxYgcEEP94JoFZ3xKh8HBXtofnfAwOq9KORp3f+32IVP6Ehohof9P9f/Ge45r8RzkRABD5zm237z3vHBGfI+WiazOU8upbuwVx1TfxTIuDmyMjrZ3WV0wDeAphmck5+ChodxKIjQBemoIO89/oLY4Zcw6CU0d75Lff843jHf1bOTEAENv5zQfPumBzMCWd3Onm5Vw5szVpddSNpumBFCziYF9/wP+tfJF16bsZmv0t3mcW4Z3LGke0/BsMUDgl5AxuWdv9J7/w2e+cCPeXSTQ8fuXSf/quN6GzDgyNHlN2gLLK4MlzojfU/LSHmQRMJOuImleRY8wT/CXCNJA9f9Nv/s3eWXvHpZxAAMim1//MT10GPjEQb94pBoh7wvjgR8oNmGkUw0+eGy+mZNwVH1zunVDGoiDm0Pzizv/1hd2LSb/HqZxIAIhs+sF/+ZPni8g6rivDbT6F4baceRo9WmP0sk6nRLTuL0uwN7/Av9uuaz64fS73cSonKAfoxXZ+47HvP1fHmFrf58ekKqbUPWRbn7lNAGCS6aRGPoh5gUrxV+82jUvtlneALJOKvG9FcsHAgGFt8dh1/+ljT2xMVceqnFgGEJFNF/7cP790pXD4mKNPbiS50kla4WbGQmySpq+qMJzTr1sGVkBmWB5p1vZs+dCWPSeQ/UXkJACAyMrrf/ZdFxcmmrAqaVWQ9NdX9MTYk5M78Ws9s8i3DwKGeco4B+L+Gz/wlRNu/pMCACKbXvezP3XpSvu83GOm4Rqd1M0Hbj3Yt7j6DBRYd3leseSXdapR+4t7rrn2sRNv/pMEACIrr08IYOFMYKbqpVmc5+MyeXYeMNZp/KDnSJZeNeWnTVRk8eC1H31kbf2+j1M5SQAgsvKGd73rEjy9J/Vj2SrKfw8apNtT1fMjl5ASSw7SJt2ezwCWVWkfFw9e+0cPnxzmP4kAILJy8U//9MUr7K8H4drylsVQKGVMsyxzXdOYOJRO16eCdWMFzzFEFg984mPbTxbzn1QAENl08bv+xUUrMo/ds1KtXnBT6JcWbfAStJfTtOGlj9JwgqkGqPUyhxfu+tPPbDsZYr+XkwoAIpsu+rl3XVKVDhtBdB09a/k60Hijknxx8g20MFqbYoomLngaueuua7+2/WQy/0kHAJFNr/uZf3LJy2SSQi9N99YvE8ccAssh0HrEkGHWgDCsmDIVkV23fHjLSZH5YznpACCyctE/+/GLXy/oUaHwGtRZ0fOMLJuIxwAVgwYyU8gDKlLsOe0FzT0msbb75g+f+GWfsZyEABCR1/3oj/3EhZtElvjvMCssF5az+VBhDPJjmgeLC4DJenTAoSXF9qZium/H315z70lo/pMVALJyxhU/+dOv2zRamwM/29F9d0nmhpYsPhqGWw9CyTfjNm9OLjgpbB8fu+2Gv7xv78lo/pMWACKy6bU/+4+vOFPIGKMp58nW+MCyEm20KCNoyFmrFJaGXGLs1FR23/zHt2w9iBgnrpy8ABDZdP4/vPJHLjpzvGHorEO4F53lB3MOmaFr2U9ORY2h4tc4bxHZt+2GT9x3UnJ/LyczAETkzMt/6B+944K2RpwZWdB1t7HUtbz4vHR2CA3ix8nBkilMylcJzQKPiKw+dPv1N2w7cBKb/6QHgIic/daf/PE3nVE0PH5mZ0yLjHYZKIBmBcuOFq0XTmj2F5OHR+/5f7c88NRJbX05FQAgsvKan7jy7W88Y3S0VHxNvYXsDBtCy7K8Gh+mpke/X4qNBqHHt9702Qf3HNjYAE9kORUAILLyPZe848q3X37GOvO38eJk0x9SxuHRyYEQtyafSAUYzmFkB7becP0dW1dPducXkVMFACKycuYb3vEj77j8DBE3wZIZoQxZoRajrWPBrDHcKdeygVJz7/abr9+ybf8pYX05hQAgIitnXfz2K9/2xtPXt3UtJR1Ay092h6aPD3DjD9GD6d5tt3xly0me9nE5lQAgIitnXvL2K9928cvr9ZKmW125cwuV6QPSwDQ7WOfs2FheePjmr9y69VSyvpxyABCRlTMue/vb33b56WeKDBNxEcjCZckWUtYcJg7r1Vw22Wj/HHh092033nZK+X4rpx4ARGTl9DOv+NF/8Kbzz1qfvbOwq+OLXu3yQWaBk8fx84HVrbffdPcjO0+NrK+UUxIAIiJy9uVvefNlF5931rquK5Juiv+RK6NDm05AUDciERIv7LzrG3fetXNt/1Ec2vEspy4ARFY2nXnpW950yRsu2IxrBGWxYHnwXm8icLAbpiK2Kjv23LzlG1tXT4Hp/tJyKgNARGRl5XvOv+LNb33j+aefvsRkGwryWWHZ+aOCrAM7dn3zzrt2fnttcSryPpRTHQAiInL65tdceuHlF11y/hmb8fKy5QF+9XycQMjAJfjv/tPWtj9+xx33P/Konqq0j+UlAQARkU16xgWXXnj5BW88d+Vlo3VLXIjbcdRntu4zlBft4acfeODBrU/sWFt5KRhf5CUEABER2aybTn/LJee+9tWXXySbTpsv3ImMR7zGMMH237958eLuR+/65t27dqzqCfgin2NYXloAEBGRlcVpm/U1f+/8i887/9zzVmRlM1nakTC8Y55VAC0HVmzvk48/8OAD23ftXjU9lbO9JeUlCIBeNoluXvn+884/77XnX/R9r1msqJ02OwA6o/r9mzbtW3vimWceffyRR7+9Z+cBeYl5PZaXLgC8bNq0ENWLXnnBq88585zvveAV57x282LTYmW/nSEistgkCxVdrDy3+bTVR599fnV19zNPPPn0oy88ufPFxSazk+cVnmNUXvoAiLJpTc5YrG1a2b+yEDn9LX/nwIqprLwom9ZWRBdnPf6N/afZqsjpi9XNJ+YLu05I+f/ZEFkXDNPlhAAAAABJRU5ErkJggg=='/%3e%3cimage%20id='image2_737_4127'%20width='512'%20height='512'%20xlink:href='data:image/png;base64,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'/%3e%3c/defs%3e%3c/svg%3e", WI = f({
  props: {
    agentId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    dynamicField: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      chatStore: NI,
      agentStore: VI,
      aiIcon: GI,
      loading: !0,
      chatWindowExpanded: !1,
      agent: null
    };
  },
  async created() {
    await this.loadAgent();
  },
  computed: {
    chatWindowVisible() {
      return this.chatStore.chatVisibility[this.sessionKey] || !1;
    },
    aiChatAvailable() {
      var e;
      return !!((e = this.agent) != null && e.id);
    },
    chatSessions() {
      return [this.chatStore.loadSession(this.sessionKey)];
    },
    sessionKey() {
      var e;
      return `${(e = this.agent) == null ? void 0 : e.id}-${this.dynamicField.ref}`;
    }
  },
  methods: {
    async loadAgent() {
      this.loading = !0;
      try {
        this.agent = await this.$datasource.aiAgent.find(this.agentId);
        const e = {
          user: this.currentUser,
          ticketSource: this.ticket,
          ticket: this.ticket,
          ticketJson: JSON.stringify(hy(this.ticket)),
          fieldsJson: JSON.stringify([
            py(this.dynamicField, this.$res)
          ])
        };
        this.agentStore.provideContext(e, this.sessionKey);
        const { createSession: t } = ns(
          this.$gateway.ai,
          this.$res,
          this.agent,
          this.currentUser,
          this.agentStore,
          this.chatStore
        );
        t(this.sessionKey);
      } catch (e) {
        console.warn(`AI Agent "${this.agentId}" is MIA`, e), this.chatWindowVisible = !1, this.loading = !1;
        return;
      } finally {
        this.loading = !1;
      }
    },
    async onSendMessage(e) {
      const { openSession: t } = ns(
        this.$gateway.ai,
        this.$res,
        this.agent,
        this.currentUser,
        this.agentStore,
        this.chatStore
      ), { sendMessage: i } = t(e.sessionKey);
      await i(e.text);
    },
    async onSelectSuggestion(e) {
      var r;
      const i = this.$res((r = this.agent) == null ? void 0 : r.messages).suggestedPrompts[e.suggestionIndex];
      this.onSendMessage({
        sessionKey: e.sessionKey,
        text: i.prompt
      });
    },
    async onAcceptAction(e) {
      const { openSession: t } = ns(
        this.$gateway.ai,
        this.$res,
        this.agent,
        this.currentUser,
        this.agentStore,
        this.chatStore
      ), { acceptAction: i } = t(e.sessionKey);
      await i(e.message, this.sessionKey), this.$emit("updateField");
    },
    onToggleVisible() {
      this.chatWindowExpanded = !1, this.chatWindowVisible ? this.chatStore.closeChat(this.sessionKey) : this.chatStore.openChat(this.sessionKey);
    },
    onToggleExpand(e) {
      this.chatWindowExpanded = e;
    }
  }
});
var QI = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.aiChatAvailable ? i("div", { staticClass: "df-chat-container" }, [i("transition", { attrs: { mode: "out-in", name: "transition-chat-window" } }, [t.chatWindowVisible ? i("chat-window", { staticClass: "df-chat-window", class: { expanded: t.chatWindowExpanded }, attrs: { sessions: t.chatSessions }, on: { "accept-action": t.onAcceptAction, "chat-close": t.onToggleVisible, "chat-expand-toggle": t.onToggleExpand, "select-suggestion": t.onSelectSuggestion, "send-message": t.onSendMessage } }) : t._e()], 1), i("button", { staticClass: "df-chat-button", attrs: { disabled: t.loading }, on: { click: t.onToggleVisible } }, [t.loading ? i("app-loading", { staticClass: "loading-button" }) : i("img", { staticClass: "icon", attrs: { src: t.aiIcon } })], 1)], 1) : t._e();
}, XI = [], KI = /* @__PURE__ */ E(
  WI,
  QI,
  XI,
  !1,
  null,
  "f2e6a13d"
);
const YI = KI.exports, ZI = f({
  components: { AppDynamicFieldChat: YI },
  props: {
    mode: {
      type: String,
      required: !0
    },
    dynamicGroup: {
      type: Object,
      required: !0
    },
    dynamicField: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    tasks: {
      type: Array,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    },
    userRoles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visibility: "auto",
      reloadKey: 0,
      empty: !0
    };
  },
  computed: {
    config() {
      return this.dynamicField;
    },
    meta() {
      var e, t;
      return (t = (e = this.dynamicField) == null ? void 0 : e.options) == null ? void 0 : t.meta;
    },
    aiOptions() {
      var e, t;
      return (t = (e = this.dynamicField) == null ? void 0 : e.options) == null ? void 0 : t.ai;
    },
    datasource() {
      var e, t;
      return ((t = (e = this.dynamicField) == null ? void 0 : e.options) == null ? void 0 : t.datasource) ?? void 0;
    },
    resources() {
      var e, t;
      return this.$res((t = (e = this.dynamicField) == null ? void 0 : e.options) == null ? void 0 : t.resources);
    },
    label() {
      var e;
      return ((e = this.resources) == null ? void 0 : e.label) ?? this.dynamicField.ref;
    },
    component() {
      const e = KT[this.dynamicField.type];
      return e || console.error(
        `Unknown dynamic field type '${this.dynamicField.type}'`,
        this.config
      ), e ?? "DynamicFieldItemError";
    },
    accessProvider() {
      return {
        userId: this.currentUser.id,
        userRoles: this.userRoles,
        userActions: this.userActions,
        creatorId: this.ticket.creator,
        assigneeId: this.ticket.assignee
      };
    },
    visible() {
      var s;
      if (!this.visibleOnPolicy())
        return !1;
      const {
        view: t,
        edit: i,
        all: r
      } = ((s = this.config.options) == null ? void 0 : s.display) ?? {};
      return this.mode === "view" && !this.visibleOnMode(t) || this.mode === "edit" && !this.visibleOnMode(i) ? !1 : this.visibility === "visible" ? this.visibleOnMode(r) : this.visibility === "hidden" ? !1 : this.visibility === "auto" ? !(this.mode === "view" && this.empty) && this.visibleOnMode(r) : (console.warn("Unknown visibility mode"), !1);
    },
    agentId() {
      var e;
      return (e = this.aiOptions) == null ? void 0 : e.agentId;
    },
    showAiAgent() {
      return !!this.agentId && this.mode === "edit";
    }
  },
  methods: {
    visibleOnPolicy() {
      var i;
      const e = ((i = this.dynamicField.accessPolicy) == null ? void 0 : i[this.mode]) ?? [], { accessGranted: t } = mu(e, this.accessProvider);
      return t;
    },
    visibleOnMode(e) {
      if (!e) return !0;
      const { status: t } = this.ticket, { show: i, hideOnStatus: r, showOnStatus: s } = e;
      return i === !1 || r != null && r.includes(t) ? !1 : s != null && s.length ? s == null ? void 0 : s.includes(t) : !0;
    },
    eventInterceptor(e) {
      const t = structuredClone(e);
      return t.label = this.label, this.visible || (t.state.empty = !1, t.state.visibility = "hidden"), t;
    },
    onDynamicFieldMounted(e) {
      this.visibility = e.state.visibility ?? "auto", this.empty = e.state.empty ?? !0;
      const t = this.eventInterceptor(e);
      this.$emit("dynamic-field-mounted", t);
    },
    onDynamicFieldUpdated(e) {
      this.$emit("dynamic-field-updated", {
        ...e,
        label: this.label
      });
    },
    chatUpdateField() {
      let e = this.dynamicField.ref;
      e.startsWith("meta.") && (e = e.substring(5));
      const t = this.ticket.meta[e];
      this.onDynamicFieldUpdated({
        ref: this.dynamicField.ref,
        state: { empty: !t },
        value: t
      }), this.reloadKey++;
    }
  }
});
var JI = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { directives: [{ name: "show", rawName: "v-show", value: t.visible, expression: "visible" }], staticClass: "dynamic-field-item", class: { hidden: !t.visible } }, [i("div", { staticClass: "field-container" }, [i(t.component, { key: t.reloadKey, tag: "component", attrs: { "context-id": t.contextId, "current-user": t.currentUser, "dynamic-group": t.dynamicGroup, "field-config": t.config, "field-datasource": t.datasource, "field-meta": t.meta, "field-resources": t.resources, mode: t.mode, organization: t.organization, "product-id": t.productId, tasks: t.tasks, ticket: t.ticket, "user-actions": t.userActions }, on: { "dynamic-field-mounted": t.onDynamicFieldMounted, "dynamic-field-updated": t.onDynamicFieldUpdated } }), t.showAiAgent ? i("app-dynamic-field-chat", { staticClass: "app-chat", attrs: { "agent-id": t.agentId, "current-user": t.currentUser, "dynamic-field": t.dynamicField, ticket: t.ticket }, on: { updateField: t.chatUpdateField } }) : t._e()], 1)]);
}, _I = [], $I = /* @__PURE__ */ E(
  ZI,
  JI,
  _I,
  !1,
  null,
  "602b8763"
);
const Uc = $I.exports, eD = f({
  components: {
    DynamicFieldItem: Uc
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    dynamicGroup: {
      type: Object,
      required: !0
    },
    layoutSection: {
      type: String,
      required: !1
    },
    ticket: {
      type: Object,
      required: !0
    },
    tasks: {
      type: Array,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    },
    userRoles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fieldState: {},
      expanded: !0
    };
  },
  created() {
    this.expanded = this.displayConfig.collapse !== "collapsed", this.$emit("dynamic-group-state", this.groupState);
  },
  provide() {
    return { dynamicFieldBucket: this.ticket.meta };
  },
  computed: {
    isVisible() {
      var r;
      const {
        view: e,
        edit: t,
        all: i
      } = ((r = this.dynamicGroup.options) == null ? void 0 : r.display) ?? {};
      return this.mode === "view" && !this.visibleOnMode(e) || this.mode === "edit" && !this.visibleOnMode(t) ? !1 : this.visibleOnMode(i);
    },
    groupType() {
      return this.dynamicGroup.groupLabel ? "optional" : "default";
    },
    groupDecoration() {
      return this.mode === "view" ? !1 : this.groupType === "optional";
    },
    groupLabel() {
      var e;
      return (e = this.$res(this.dynamicGroup.resources)) == null ? void 0 : e.label;
    },
    displayConfig() {
      if (this.mode === "view")
        return { collapse: "disabled" };
      const { display: e } = this.dynamicGroup.options ?? {};
      return { ...e == null ? void 0 : e.all, ...e == null ? void 0 : e[this.mode] };
    },
    toggleEnabled() {
      const { collapse: e } = this.displayConfig;
      return e === "expanded" || e === "collapsed";
    },
    headerIcon() {
      return this.expanded ? "fa-regular fa-chevron-up" : "fa-regular fa-chevron-down";
    },
    availableFields() {
      const e = this.dynamicGroup.fields ?? [];
      return this.layoutSection ? this.layoutSection === "main" ? e.filter(
        (t) => t.layoutSection === void 0 || t.layoutSection === "main"
      ) : e.filter(
        (t) => t.layoutSection === this.layoutSection
      ) : e;
    },
    groupStatus() {
      const e = this.availableFields.length, t = Object.keys(this.fieldState).length;
      return t < e ? "loading" : t === e ? "ready" : "error";
    },
    groupEmpty() {
      return Object.values(this.fieldState).every(
        (e) => e.state.empty || e.state.visibility === "hidden"
      );
    },
    groupState() {
      return {
        ref: this.dynamicGroup.groupId,
        status: this.groupStatus,
        empty: this.groupEmpty
      };
    }
  },
  methods: {
    visibleOnMode(e) {
      if (!e) return !0;
      const { status: t } = this.ticket, { show: i, hideOnStatus: r, showOnStatus: s } = e;
      return i === !1 || r != null && r.includes(t) ? !1 : s != null && s.length ? s == null ? void 0 : s.includes(t) : !0;
    },
    onDynamicFieldMounted(e) {
      this.$set(this.fieldState, e.ref, e), this.$emit("dynamic-field-updated", e), this.$emit("dynamic-group-state", this.groupState);
    },
    onDynamicFieldUpdated(e) {
      this.$emit("dynamic-field-updated", e);
    },
    onToggleGroup() {
      this.expanded = !this.expanded;
    }
  }
});
var tD = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.isVisible ? i("div", { staticClass: "dynamic-field-group", class: { decorated: t.groupDecoration } }, [t.groupDecoration ? i("div", { staticClass: "group-header" }, [t.toggleEnabled ? i("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: t.onToggleGroup } }, [i("fa-icon-compat", { staticClass: "icon", attrs: { icon: t.headerIcon } })], 1) : t._e(), i("div", { staticClass: "group-header-title" }, [t._v(t._s(t.groupLabel) + " ")])], 1) : t._e(), i("div", { directives: [{ name: "show", rawName: "v-show", value: t.expanded, expression: "expanded" }], staticClass: "dynamic-field-group-content" }, t._l(t.availableFields, function(r, s) {
    return i("dynamic-field-item", { key: s, attrs: { mode: t.mode, "dynamic-group": t.dynamicGroup, "dynamic-field": r, tasks: t.tasks, ticket: t.ticket, "current-user": t.currentUser, organization: t.organization, "context-id": t.contextId, "product-id": t.productId, "user-actions": t.userActions, "user-roles": t.userRoles }, on: { "dynamic-field-mounted": t.onDynamicFieldMounted, "dynamic-field-updated": t.onDynamicFieldUpdated } });
  }), 1)]) : t._e();
}, iD = [], rD = /* @__PURE__ */ E(
  eD,
  tD,
  iD,
  !1,
  null,
  "738ab8de"
);
const sD = rD.exports, nD = f({
  props: {
    group: {
      type: Object,
      required: !0
    }
  },
  computed: {
    groupLabel() {
      var e;
      return (e = this.$res(this.group.resources)) == null ? void 0 : e.label;
    },
    faIcon() {
      return this.group.groupIcon ? `fa-light fa-${this.group.groupIcon}` : void 0;
    }
  },
  methods: {
    onClick() {
      this.$emit("click", this.group.groupId);
    }
  }
});
var aD = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "dynamic-field-chip", on: { click: t.onClick } }, [t.faIcon ? i("fa-icon-compat", { staticClass: "icon", attrs: { icon: t.faIcon } }) : t._e(), i("div", { staticClass: "chip-label" }, [t._v(t._s(t.groupLabel))])], 1);
}, oD = [], lD = /* @__PURE__ */ E(
  nD,
  aD,
  oD,
  !1,
  null,
  null
);
const cD = lD.exports, uD = f({
  components: {
    DynamicFieldGroup: sD,
    DynamicFieldChip: cD
  },
  props: {
    value: {
      type: Object,
      required: !1
    },
    mode: {
      type: String,
      default: "view"
    },
    dynamicForm: {
      type: Object,
      required: !0
    },
    layoutSection: {
      type: String,
      required: !1
    },
    ticket: {
      type: Object,
      required: !0
    },
    tasks: {
      type: Array,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    },
    userRoles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      groupState: {},
      chipState: {},
      dataState: {}
    };
  },
  watch: {
    groupState: {
      deep: !0,
      handler() {
        this.groupList.every(({ groupId: t }) => {
          const i = this.groupState[t];
          return (i == null ? void 0 : i.status) === "ready";
        }) && this.$emit("loadingComplete");
      }
    }
  },
  computed: {
    groupLabel() {
      return this.layoutSection;
    },
    groupList() {
      return this.layoutSection ? this.layoutSection === "main" ? this.dynamicForm.groups.filter(
        (e) => e.fields.some(
          (t) => t.layoutSection === void 0 || t.layoutSection === "main"
        )
      ) : this.dynamicForm.groups.filter(
        (e) => e.fields.some(
          (t) => t.layoutSection === this.layoutSection
        )
      ) : this.dynamicForm.groups;
    },
    hiddenGroups() {
      return this.groupList.filter((e) => e.groupId).filter((e) => this.groupStatus(e.groupId) === "hidden");
    },
    blueChipsVisible() {
      return this.mode === "edit" && this.hiddenGroups.length > 0;
    }
  },
  methods: {
    groupStatus(e) {
      var i;
      const t = this.groupState[e];
      if (t === void 0 || t.status === "loading")
        return "loading";
      if (t.status === "ready")
        return e ? (i = this.chipState[e]) != null && i.expanded ? "visible" : "hidden" : "visible";
    },
    onClickBlueChip(e) {
      this.$set(this.chipState, e, {
        ref: e,
        expanded: !0
      });
    },
    onDynamicGroupState(e) {
      if (this.$set(this.groupState, e.ref, e), e.status === "ready") {
        const t = {
          ref: e.ref,
          expanded: !e.empty
        };
        this.$set(this.chipState, e.ref, t);
      }
    },
    onDynamicFieldRemoved(e) {
      this.$set(this.dataState, e.ref, e), this.$emit("input", { ...this.dataState });
    },
    onDynamicFieldUpdated(e) {
      this.$set(this.dataState, e.ref, e), this.$emit("input", { ...this.dataState });
    }
  }
});
var dD = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "dynamic-field-container" }, [t._l(t.groupList, function(r, s) {
    return [i("dynamic-field-group", { directives: [{ name: "show", rawName: "v-show", value: t.groupStatus(r.groupId) === "visible", expression: "groupStatus(group.groupId) === 'visible'" }], key: s, staticClass: "dynamic-field-group", attrs: { mode: t.mode, "dynamic-group": r, tasks: t.tasks, ticket: t.ticket, "layout-section": t.layoutSection, "current-user": t.currentUser, organization: t.organization, "context-id": t.contextId, "product-id": t.productId, "user-actions": t.userActions, "user-roles": t.userRoles }, on: { "dynamic-group-state": t.onDynamicGroupState, "dynamic-field-removed": t.onDynamicFieldRemoved, "dynamic-field-updated": t.onDynamicFieldUpdated } })];
  }), t.blueChipsVisible ? i("base-input-item", { attrs: { label: t.$t("page.createTicket.addInformation") } }, [i("div", { staticClass: "blue-chip-container" }, t._l(t.hiddenGroups, function(r, s) {
    return i("dynamic-field-chip", { key: s, attrs: { group: r }, on: { click: t.onClickBlueChip } });
  }), 1)]) : t._e()], 2);
}, hD = [], pD = /* @__PURE__ */ E(
  uD,
  dD,
  hD,
  !1,
  null,
  "6492fd8e"
);
const fD = pD.exports, mD = f({
  components: {
    DynamicFieldContainer: fD
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    externalFields: {
      type: Array,
      required: !0
    },
    layoutSection: {
      type: String,
      required: !1
    },
    ticket: {
      type: Object,
      required: !0
    },
    tasks: {
      type: Array,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    },
    userRoles: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dynamicForm() {
      return {
        groups: this.externalFields
      };
    }
  },
  methods: {
    onInput(e) {
      this.$emit("input", { ...e });
    },
    onLoadingComplete() {
      this.$emit("loadingComplete");
    }
  }
});
var gD = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("dynamic-field-container", { attrs: { mode: t.mode, "dynamic-form": t.dynamicForm, "layout-section": t.layoutSection, tasks: t.tasks, ticket: t.ticket, "current-user": t.currentUser, organization: t.organization, "context-id": t.contextId, "product-id": t.productId, "user-actions": t.userActions, "user-roles": t.userRoles }, on: { input: t.onInput, loadingComplete: t.onLoadingComplete } });
}, yD = [], bD = /* @__PURE__ */ E(
  mD,
  gD,
  yD,
  !1,
  null,
  "7303c579"
);
const vD = bD.exports;
function ht() {
  return { importData: (i) => (i ?? "").trim(), exportData: (i) => i.trim() };
}
const AD = f({
  props: {
    dynamicGroup: {
      type: Object,
      required: !0
    },
    label: {
      type: String,
      required: !1
    }
  },
  data() {
    return {
      expanded: !0
    };
  },
  created() {
    this.expanded = this.displayConfig.collapse !== "collapsed";
  },
  computed: {
    displayConfig() {
      const { display: e } = this.dynamicGroup.options ?? {};
      return { ...e == null ? void 0 : e.all, ...e == null ? void 0 : e.view };
    },
    toggleEnabled() {
      const { collapse: e } = this.displayConfig;
      return e === "expanded" || e === "collapsed";
    },
    headerIcon() {
      return this.expanded ? "fa-regular fa-chevron-up" : "fa-regular fa-chevron-down";
    }
  },
  methods: {
    onToggleGroup() {
      this.expanded = !this.expanded;
    }
  }
});
var kD = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "legacy-field-view" }, [t.label ? i("div", { staticClass: "legacy-field-label" }, [t.toggleEnabled ? i("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: t.onToggleGroup } }, [i("fa-icon-compat", { staticClass: "icon", attrs: { icon: t.headerIcon } })], 1) : t._e(), i("div", { staticClass: "legacy-field-label-title" }, [t._v(t._s(t.label) + " ")])], 1) : t._e(), i("div", { directives: [{ name: "show", rawName: "v-show", value: t.expanded, expression: "expanded" }], staticClass: "legacy-field-content" }, [t._t("default")], 2)]);
}, wD = [], xD = /* @__PURE__ */ E(
  AD,
  kD,
  wD,
  !1,
  null,
  "2f7d2683"
);
const $ = xD.exports, CD = f({
  components: {
    LegacyFieldLabel: $
  },
  inject: ["dynamicFieldBucket"],
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      model: "",
      error: !1
    };
  },
  created() {
    this.model = this.getValue() ?? "", this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    bucket() {
      return this.dynamicFieldBucket ?? {};
    },
    required() {
      return this.fieldConfig.required ?? !1;
    }
  },
  methods: {
    onInput() {
      this.$emit("dynamic-field-updated", this.getState());
    },
    onBlur() {
      this.validate();
    },
    getValue() {
      const { importData: e } = ht();
      let t = this.fieldConfig.ref ?? "";
      return t.startsWith("meta.") && (t = t.substring(5)), e(this.bucket[t]);
    },
    getState() {
      const { exportData: e } = ht();
      return {
        ref: this.fieldConfig.ref,
        value: e(this.model),
        state: {
          empty: !this.model
        }
      };
    },
    validate() {
      const e = this.required ? this.model.trim() !== "" : !0;
      return this.error = !e, e;
    }
  }
});
var SD = function() {
  var r, s, n;
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "text-input-adapter" }, [t.mode === "view" ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: t.fieldResources.label } }, [i("span", { staticClass: "text-display" }, [t._v(t._s(t.model))])]) : i("app-text-input", { attrs: { label: (r = t.fieldResources) == null ? void 0 : r.label, placeholder: (s = t.fieldResources) == null ? void 0 : s.placeholder, tooltip: (n = t.fieldResources) == null ? void 0 : n.tooltip, required: t.required, error: t.error }, on: { blur: t.onBlur, input: t.onInput }, model: { value: t.model, callback: function(a) {
    t.model = a;
  }, expression: "model" } })], 1);
}, ID = [], DD = /* @__PURE__ */ E(
  CD,
  SD,
  ID,
  !1,
  null,
  "57c6c59d"
);
const PD = DD.exports;
function No() {
  return { importData: (i) => i !== void 0 && i !== "" ? parseFloat(i) : void 0, exportData: (i) => i || i === 0 ? `${i}` : void 0 };
}
const TD = f({
  components: {
    LegacyFieldLabel: $
  },
  inject: ["dynamicFieldBucket"],
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !1
    },
    fieldResources: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      model: void 0,
      error: !1
    };
  },
  created() {
    this.model = this.getValue() ?? void 0, this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    bucket() {
      return this.dynamicFieldBucket ?? {};
    },
    required() {
      return this.fieldConfig.required ?? !1;
    },
    fractionDigits() {
      var e;
      return ((e = this.fieldMeta) == null ? void 0 : e.fractionDigits) ?? 0;
    },
    isReadonly() {
      var e;
      return !!(this.mode === "view" || (e = this.fieldMeta) != null && e.readonly);
    },
    numberValue() {
      var e;
      return this.model ?? ((e = this.fieldResources) == null ? void 0 : e.readonlyText);
    }
  },
  methods: {
    onInput() {
      this.$emit("dynamic-field-updated", this.getState());
    },
    getValue() {
      const { importData: e } = No();
      let t = this.fieldConfig.ref ?? "";
      return t.startsWith("meta.") && (t = t.substring(5)), e(this.bucket[t]);
    },
    getState() {
      const { exportData: e } = No();
      return {
        ref: this.fieldConfig.ref,
        value: e(this.model),
        state: {
          empty: this.model === void 0
        }
      };
    }
  }
});
var OD = function() {
  var r, s, n;
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "number-input-adapter" }, [t.isReadonly ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: t.fieldResources.label } }, [i("span", { staticClass: "text-display" }, [t._v(t._s(t.numberValue))])]) : i("app-number-input", { attrs: { label: (r = t.fieldResources) == null ? void 0 : r.label, placeholder: (s = t.fieldResources) == null ? void 0 : s.placeholder, tooltip: (n = t.fieldResources) == null ? void 0 : n.tooltip, "fraction-digits": t.fractionDigits, required: t.required, error: t.error }, on: { input: t.onInput }, model: { value: t.model, callback: function(a) {
    t.model = a;
  }, expression: "model" } })], 1);
}, BD = [], MD = /* @__PURE__ */ E(
  TD,
  OD,
  BD,
  !1,
  null,
  "79a6a44f"
);
const RD = MD.exports, ED = f({
  components: {
    LegacyFieldLabel: $
  },
  inject: ["dynamicFieldBucket"],
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      model: "",
      error: !1
    };
  },
  created() {
    this.model = this.getValue() ?? "", this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    bucket() {
      return this.dynamicFieldBucket ?? {};
    },
    required() {
      return this.fieldConfig.required ?? !1;
    }
  },
  methods: {
    onInput() {
      this.$emit("dynamic-field-updated", this.getState());
    },
    onBlur() {
      this.validate();
    },
    getValue() {
      const { importData: e } = ht();
      let t = this.fieldConfig.ref ?? "";
      return t.startsWith("meta.") && (t = t.substring(5)), e(this.bucket[t]);
    },
    getState() {
      const { exportData: e } = ht();
      return {
        ref: this.fieldConfig.ref,
        value: e(this.model),
        state: {
          empty: !this.model
        }
      };
    },
    validate() {
      const e = this.required ? this.model.trim() !== "" : !0;
      return this.error = !e, e;
    }
  }
});
var LD = function() {
  var r, s, n;
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "text-area-adapter" }, [t.mode === "view" ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: t.fieldResources.label } }, [i("span", { staticClass: "text-display" }, [t._v(t._s(t.model))])]) : i("app-text-area", { attrs: { label: (r = t.fieldResources) == null ? void 0 : r.label, placeholder: (s = t.fieldResources) == null ? void 0 : s.placeholder, tooltip: (n = t.fieldResources) == null ? void 0 : n.tooltip, required: t.required, error: t.error }, on: { blur: t.onBlur, input: t.onInput }, model: { value: t.model, callback: function(a) {
    t.model = a;
  }, expression: "model" } })], 1);
}, FD = [], jD = /* @__PURE__ */ E(
  ED,
  LD,
  FD,
  !1,
  null,
  "f0f71cc1"
);
const UD = jD.exports, qD = f({
  components: {
    LegacyFieldLabel: $
  },
  inject: ["dynamicFieldBucket"],
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !1
    },
    fieldResources: {
      type: Object,
      required: !1
    }
  },
  data() {
    return {
      model: "",
      error: !1
    };
  },
  created() {
    this.model = this.getValue() ?? "", this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    isReadOnly() {
      var e;
      return !!(this.mode === "view" || (e = this.fieldMeta) != null && e.readonly);
    },
    readOnlyText() {
      var e;
      return this.model || ((e = this.fieldResources) == null ? void 0 : e.readOnlyText);
    },
    bucket() {
      return this.dynamicFieldBucket ?? {};
    },
    required() {
      return this.fieldConfig.required ?? !1;
    },
    isEmpty() {
      return this.isReadOnly ? !this.readOnlyText : this.model.trim() === "";
    }
  },
  methods: {
    onInput() {
      this.$emit("dynamic-field-updated", this.getState());
    },
    onBlur() {
      this.validate();
    },
    getValue() {
      const { importData: e } = ht();
      let t = this.fieldConfig.ref ?? "";
      return t.startsWith("meta.") && (t = t.substring(5)), e(this.bucket[t]);
    },
    getState() {
      const { exportData: e } = ht();
      return {
        ref: this.fieldConfig.ref,
        value: e(this.model),
        state: {
          empty: this.isEmpty
        }
      };
    },
    validate() {
      const e = this.required ? this.model.trim() !== "" : !0;
      return this.error = !e, e;
    }
  }
});
var HD = function() {
  var r, s, n, a;
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "text-area-adapter" }, [t.isReadOnly ? i("legacy-field-label", { attrs: { label: (r = t.fieldResources) == null ? void 0 : r.label, "dynamic-group": t.$attrs["dynamic-group"] } }, [i("app-markdown-text", { staticClass: "text-display", attrs: { text: t.readOnlyText } })], 1) : i("div", [i("app-markdown-input", { attrs: { error: t.error, label: (s = t.fieldResources) == null ? void 0 : s.label, placeholder: (n = t.fieldResources) == null ? void 0 : n.placeholder, required: t.required, tooltip: (a = t.fieldResources) == null ? void 0 : a.tooltip }, on: { input: t.onInput, onBlur: t.onBlur }, model: { value: t.model, callback: function(o) {
    t.model = o;
  }, expression: "model" } })], 1)], 1);
}, zD = [], ND = /* @__PURE__ */ E(
  qD,
  HD,
  zD,
  !1,
  null,
  "358d469c"
);
const VD = ND.exports;
function ps() {
  return { importData: (i) => {
    if (!i)
      return [];
    try {
      let r = [];
      const s = JSON.parse(i);
      return Array.isArray(s) ? r = s : r = s ? [s] : [], r.map((n) => ({
        id: `${n.id}`,
        label: n.label
      }));
    } catch (r) {
      return console.error("Could not parse Autocomplete data", r), [];
    }
  }, exportData: (i) => {
    const r = (i ?? []).filter((s) => !!(s != null && s.id) && !!(s != null && s.label)).map((s) => ({
      id: s.id,
      label: s.label
    }));
    return JSON.stringify(r);
  } };
}
const GD = f({
  props: {
    value: {
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    tooltip: {
      type: String,
      required: !1
    },
    required: {
      type: Boolean,
      required: !0
    },
    error: {
      type: Boolean,
      default: !1
    },
    multiple: {
      type: Boolean,
      required: !0
    },
    searchEnabled: {
      type: Boolean,
      default: !0
    },
    datasource: {
      type: Object,
      required: !0
    },
    current: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      selection: []
    };
  },
  created() {
    var e;
    this.multiple ? this.selection = this.current.map((t) => t.id) : this.selection = [((e = this.current[0]) == null ? void 0 : e.id) ?? ""];
  },
  computed: {
    selectionMode() {
      return this.multiple ? "multiple" : "single";
    },
    options() {
      const e = JSON.parse(this.datasource.settings.value ?? "[]"), t = this.datasource.settings.labelField, i = this.datasource.settings.idField;
      return e.map((r) => ({
        text: r[t],
        value: `${r[i]}`
      }));
    }
  },
  methods: {
    onUpdate(e) {
      const t = e.map((i) => this.options.find((r) => r.value === i));
      this.$emit("input", t);
    }
  }
});
var WD = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "base-autocomplete-static" }, [i("app-dropdown", { attrs: { label: t.label, placeholder: t.placeholder, tooltip: t.tooltip, required: t.required, error: t.error, options: t.options, "search-enabled": t.searchEnabled, "selection-mode": t.selectionMode }, on: { input: t.onUpdate }, model: { value: t.selection, callback: function(r) {
    t.selection = r;
  }, expression: "selection" } })], 1);
}, QD = [], XD = /* @__PURE__ */ E(
  GD,
  WD,
  QD,
  !1,
  null,
  "345b23bb"
);
const KD = XD.exports, YD = f({
  props: {
    value: {
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      required: !0
    },
    tooltip: {
      type: String,
      required: !1
    },
    required: {
      type: Boolean,
      required: !0
    },
    error: {
      type: Boolean,
      default: !1
    },
    multiple: {
      type: Boolean,
      required: !0
    },
    datasource: {
      type: Object,
      required: !0
    },
    current: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      loading: !1,
      options: [],
      optionsPool: [],
      selection: []
    };
  },
  created() {
    var e;
    this.optionsPool = this.current.map((t) => ({
      text: t.label,
      value: t.id
    })), this.multiple ? this.selection = this.current.map((t) => t.id) : this.selection = [((e = this.current[0]) == null ? void 0 : e.id) ?? ""];
  },
  computed: {
    selectionMode() {
      return this.multiple ? "multiple" : "single";
    }
  },
  methods: {
    onToggleOpen(e) {
      e || (this.options = [], this.$emit("blur"));
    },
    async onSearchDebounced(e) {
      if (e.length < 3) {
        this.options = [];
        return;
      }
      this.loading = !0;
      const t = this.datasource.settings.url, i = await this.$api.dynamicFields.fetchDynamicData(t, e), r = i.content ?? i ?? [];
      this.options = r.map((s) => ({
        text: s[this.datasource.settings.labelField],
        value: s[this.datasource.settings.idField]
      })), this.loading = !1;
    },
    onUpdate(e) {
      const t = e.map((i) => [...this.optionsPool, ...this.options].find(
        (r) => r.value === i
      ));
      this.$emit("input", t);
    }
  }
});
var ZD = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "base-autocomplete-dynamic" }, [i("app-dropdown", { attrs: { label: t.label, placeholder: t.placeholder, tooltip: t.tooltip, required: t.required, error: t.error, options: t.options, "options-pool": t.optionsPool, loading: t.loading, "selection-mode": t.selectionMode }, on: { "toggle-open": t.onToggleOpen, input: t.onUpdate }, scopedSlots: t._u([{ key: "search", fn: function() {
    return [i("app-search-input", { staticClass: "inner-search", attrs: { "debounce-timeout": 500 }, on: { debounced: t.onSearchDebounced } })];
  }, proxy: !0 }]), model: { value: t.selection, callback: function(r) {
    t.selection = r;
  }, expression: "selection" } })], 1);
}, JD = [], _D = /* @__PURE__ */ E(
  YD,
  ZD,
  JD,
  !1,
  null,
  "19cc5fac"
);
const $D = _D.exports, eP = f({
  inject: ["dynamicFieldBucket"],
  components: {
    LegacyFieldLabel: $,
    BaseAutocompleteStatic: KD,
    BaseAutocompleteDynamic: $D
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !1
    },
    fieldDatasource: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      selection: [],
      error: !1
    };
  },
  created() {
    const e = this.internalValue ?? [], { exportData: t } = ps();
    this.$emit("dynamic-field-mounted", {
      ref: this.fieldConfig.ref,
      value: t(e),
      state: {
        empty: e.length === 0
      }
    });
  },
  computed: {
    bucket() {
      return this.dynamicFieldBucket ?? {};
    },
    required() {
      return this.fieldConfig.required ?? !1;
    },
    multiple() {
      var e;
      return ((e = this.fieldMeta) == null ? void 0 : e.multiple) ?? !1;
    },
    isSearchEnabled() {
      var e;
      return ((e = this.fieldMeta) == null ? void 0 : e.searchEnabled) ?? !0;
    },
    internalValue() {
      const e = this.getValue();
      if (e) {
        if (Array.isArray(e))
          return e;
      } else return [];
      return [e];
    },
    plainValue() {
      const e = this.getValue();
      if (!e)
        return;
      const t = Array.isArray(e) ? e : [e];
      return t.length > 0 ? t.map((i) => i.label).join(", ") : void 0;
    }
  },
  methods: {
    onInput() {
      this.$emit("dynamic-field-updated", this.getState());
    },
    getValue() {
      let e = this.fieldConfig.ref ?? "";
      e.startsWith("meta.") && (e = e.substring(5));
      const t = this.bucket[e], { importData: i } = ps();
      return i(t);
    },
    getState() {
      const { exportData: e } = ps();
      return {
        ref: this.fieldConfig.ref,
        value: e(this.selection.map(this.buildOutputItem)),
        state: {
          empty: this.selection.length === 0
        }
      };
    },
    buildOutputItem(e) {
      return {
        label: e.text,
        id: e.value
      };
    },
    onBlur() {
      this.validate();
    },
    validate() {
      const e = this.required ? this.selection.length > 0 : !0;
      return this.error = !e, e;
    }
  }
});
var tP = function() {
  var r, s, n, a, o, l;
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "base-autocomplete" }, [t.mode === "view" ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: t.fieldResources.label } }, [t._v(" " + t._s(t.plainValue) + " ")]) : [t.fieldDatasource.type === "INTERNAL_API" ? i("base-autocomplete-dynamic", { attrs: { current: t.internalValue, datasource: t.fieldDatasource, error: t.error, label: (r = t.fieldResources) == null ? void 0 : r.label, multiple: t.multiple, placeholder: (s = t.fieldResources) == null ? void 0 : s.placeholder, required: t.required, "search-enabled": t.isSearchEnabled, tooltip: (n = t.fieldResources) == null ? void 0 : n.tooltip }, on: { blur: t.onBlur, input: t.onInput }, model: { value: t.selection, callback: function(c) {
    t.selection = c;
  }, expression: "selection" } }) : t._e(), t.fieldDatasource.type === "STATIC" ? i("base-autocomplete-static", { attrs: { current: t.internalValue, datasource: t.fieldDatasource, error: t.error, label: (a = t.fieldResources) == null ? void 0 : a.label, multiple: t.multiple, placeholder: (o = t.fieldResources) == null ? void 0 : o.placeholder, required: t.required, "search-enabled": t.isSearchEnabled, tooltip: (l = t.fieldResources) == null ? void 0 : l.tooltip }, on: { blur: t.onBlur, input: t.onInput }, model: { value: t.selection, callback: function(c) {
    t.selection = c;
  }, expression: "selection" } }) : t._e(), t.error ? i("div", { staticClass: "error-label" }, [t._v(" " + t._s(t.$t("error.requiredField")) + " ")]) : t._e()]], 2);
}, iP = [], rP = /* @__PURE__ */ E(
  eP,
  tP,
  iP,
  !1,
  null,
  "8161c3a6"
);
const sP = rP.exports;
function Vo() {
  return { importData: (i) => i ? JSON.parse(i) : [], exportData: (i) => JSON.stringify(i) };
}
const nP = f({
  components: {
    LegacyFieldLabel: $
  },
  inject: ["dynamicFieldBucket"],
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      model: "",
      error: !1,
      workflows: []
    };
  },
  async created() {
    this.model = this.getValue()[0] ?? "", this.$emit("dynamic-field-mounted", this.getState()), await this.loadWorkflows();
  },
  computed: {
    bucket() {
      return this.dynamicFieldBucket ?? {};
    },
    required() {
      return this.fieldConfig.required ?? !1;
    },
    productIds() {
      const { productIds: e } = fu(this.organization);
      return e.value;
    }
  },
  methods: {
    onInput() {
      this.$emit("dynamic-field-updated", this.getState());
    },
    getValue() {
      const { importData: e } = Vo();
      let t = this.fieldConfig.ref ?? "";
      return t.startsWith("meta.") && (t = t.substring(5)), e(this.bucket[t]);
    },
    getState() {
      const { exportData: e } = Vo(), t = this.model ? [this.model] : [];
      return {
        ref: this.fieldConfig.ref,
        value: e(t),
        state: {
          empty: !t.length
        }
      };
    },
    async loadWorkflows() {
      this.workflows = await this.$gateway.portal.fetchWorkflowsByBatch(
        this.productIds,
        this.organization.context
      );
    }
  }
});
var aP = function() {
  var r, s, n;
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("product-dropdown", { staticClass: "product-dropdown", attrs: { context: t.contextId, error: t.error, label: (r = t.fieldResources) == null ? void 0 : r.label, placeholder: (s = t.fieldResources) == null ? void 0 : s.placeholder, products: t.productIds, required: t.required, tooltip: (n = t.fieldResources) == null ? void 0 : n.tooltip, workflows: t.workflows }, on: { input: t.onInput }, model: { value: t.model, callback: function(a) {
    t.model = a;
  }, expression: "model" } });
}, oP = [], lP = /* @__PURE__ */ E(
  nP,
  aP,
  oP,
  !1,
  null,
  null
);
const cP = lP.exports;
function Go() {
  return { importData: (i) => {
    if (!i)
      return;
    let r = "";
    try {
      r = JSON.parse(i);
    } catch {
      r = i;
    }
    try {
      const s = new Date(r.trim());
      return s instanceof Date && !isNaN(s == null ? void 0 : s.getTime()) ? s : void 0;
    } catch {
      return;
    }
  }, exportData: (i) => (i == null ? void 0 : i.toISOString()) ?? null };
}
const uP = f({
  components: {
    LegacyFieldLabel: $
  },
  inject: ["dynamicFieldBucket"],
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      model: void 0,
      error: !1
    };
  },
  created() {
    const { importData: e } = Go();
    this.model = e(this.getValue()), this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    bucket() {
      return this.dynamicFieldBucket ?? {};
    },
    required() {
      return this.fieldConfig.required ?? !1;
    },
    displayDate() {
      return this.model ? this.model.toLocaleDateString(void 0, {
        dateStyle: "medium"
      }) : "";
    }
  },
  methods: {
    getValue() {
      let e = this.fieldConfig.ref ?? "";
      return e.startsWith("meta.") && (e = e.substring(5)), this.bucket[e] ?? "";
    },
    getState() {
      const { exportData: e } = Go();
      return {
        ref: this.fieldConfig.ref,
        value: e(this.model) ?? null,
        state: {
          empty: !this.model
        }
      };
    },
    onInput(e) {
      this.model = e, this.$emit("dynamic-field-updated", this.getState()), this.validate();
    },
    onBlur() {
      this.validate();
    },
    validate() {
      const e = this.required ? !!this.model : !0;
      return this.error = !e, e;
    }
  }
});
var dP = function() {
  var r, s, n;
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "base-datepicker" }, [t.mode === "view" ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: (r = t.fieldResources) == null ? void 0 : r.label } }, [i("div", { staticClass: "date-display" }, [t._v(" " + t._s(t.displayDate) + " ")])]) : [i("app-datepicker-input", { attrs: { label: (s = t.fieldResources) == null ? void 0 : s.label, tooltip: (n = t.fieldResources) == null ? void 0 : n.tooltip, required: t.required }, on: { input: t.onInput }, model: { value: t.model, callback: function(a) {
    t.model = a;
  }, expression: "model" } }), t.error ? i("div", { staticClass: "error-label" }, [t._v(" " + t._s(t.$t("error.requiredField")) + " ")]) : t._e()]], 2);
}, hP = [], pP = /* @__PURE__ */ E(
  uP,
  dP,
  hP,
  !1,
  null,
  "6d38cade"
);
const fP = pP.exports;
function Wo() {
  return { importData: (i) => {
    const r = (i || "").split(",").map((s) => s.trim());
    return r.length > 0 ? r : [""];
  }, exportData: (i) => (i == null ? void 0 : i.map((r) => (r ?? "").trim()).filter((r) => !!r).join(", ")) ?? "" };
}
const mP = f({
  components: {
    LegacyFieldLabel: $
  },
  inject: ["dynamicFieldBucket"],
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      current: "",
      links: []
    };
  },
  created() {
    const { importData: e } = Wo();
    this.links = e(this.getValue()), this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    bucket() {
      return this.dynamicFieldBucket ?? {};
    }
  },
  methods: {
    getValue() {
      let e = this.fieldConfig.ref ?? "";
      return e.startsWith("meta.") && (e = e.substring(5)), this.bucket[e] ?? "";
    },
    getState() {
      const { exportData: e } = Wo();
      return {
        ref: this.fieldConfig.ref,
        value: e(this.links),
        state: {
          empty: !e(this.links)
        }
      };
    },
    onAddLink() {
      this.links.push("");
    },
    onRemoveLink(e) {
      this.links.splice(e, 1), this.updateModel();
    },
    updateModel() {
      this.$emit("dynamic-field-updated", this.getState());
    }
  }
});
var gP = function() {
  var r, s;
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.mode === "view" ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: (r = t.fieldResources) == null ? void 0 : r.label } }, [i("div", { staticClass: "external-link-adapter-view" }, t._l(t.links, function(n, a) {
    return i("a", { key: a, attrs: { href: n, target: "_blank" } }, [t._v(" " + t._s(n) + " ")]);
  }), 0)]) : i("div", { staticClass: "external-link-adapter-edit" }, [t._l(t.links, function(n, a) {
    var o;
    return i("base-input-text", { key: a, attrs: { placeholder: (o = t.fieldResources) == null ? void 0 : o.placeholder }, on: { input: t.updateModel }, scopedSlots: t._u([{ key: "end", fn: function() {
      return [i("app-icon-button", { attrs: { size: 32 }, on: { click: function(l) {
        return t.onRemoveLink(a);
      } } }, [i("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-trash" } })], 1)];
    }, proxy: !0 }], null, !0), model: { value: t.links[a], callback: function(l) {
      t.$set(t.links, a, l);
    }, expression: "links[i]" } });
  }), i("add-button", { staticClass: "add-button", attrs: { text: (s = t.fieldResources) == null ? void 0 : s.buttonAddLink }, on: { click: t.onAddLink } })], 2);
}, yP = [], bP = /* @__PURE__ */ E(
  mP,
  gP,
  yP,
  !1,
  null,
  "5660d94c"
);
const vP = bP.exports;
function Qo() {
  return { importData: (i) => {
    if (i)
      try {
        const r = JSON.parse(i);
        return r == null ? void 0 : r.value;
      } catch (r) {
        console.error("Could not parse MeasurementInput data", r);
        return;
      }
  }, exportData: (i) => {
    const r = i ? {
      _dfType: "measurement",
      value: i
    } : void 0;
    return r ? JSON.stringify(r) : void 0;
  } };
}
const AP = f({
  components: {
    LegacyFieldLabel: $
  },
  inject: ["dynamicFieldBucket"],
  props: {
    mode: {
      type: String,
      default: "view"
    },
    currentUser: {
      type: Object,
      required: !0
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      model: void 0,
      error: !1
    };
  },
  created() {
    this.model = this.getValue() ?? void 0, this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    bucket() {
      return this.dynamicFieldBucket ?? {};
    },
    required() {
      return this.fieldConfig.required ?? !1;
    },
    plainValue() {
      return this.model ? En(
        this.model,
        (e) => this.$t(e).toString(),
        this.fieldMeta.fractionDigits
      ) : "";
    },
    convertedValue() {
      var i, r;
      if (!this.model || this.model.dimension === "currency")
        return;
      const e = (r = (i = this.currentUser.preferences) == null ? void 0 : i.measurementSettings) == null ? void 0 : r.measurementSystem, t = $o(this.model, e ?? "si");
      if (t && t.unit !== this.model.unit)
        return En(
          t,
          (s) => this.$t(s).toString(),
          this.fieldMeta.fractionDigits
        );
    }
  },
  methods: {
    onInput() {
      this.$emit("dynamic-field-updated", this.getState());
    },
    onBlur() {
      this.validate();
    },
    getValue() {
      const { importData: e } = Qo();
      let t = this.fieldConfig.ref ?? "";
      return t.startsWith("meta.") && (t = t.substring(5)), e(this.bucket[t]);
    },
    getState() {
      const { exportData: e } = Qo();
      return {
        ref: this.fieldConfig.ref,
        value: e(this.model),
        state: {
          empty: !this.model
        }
      };
    },
    validate() {
      const e = this.required ? this.model !== void 0 : !0;
      return this.error = !e, e;
    }
  }
});
var kP = function() {
  var r, s;
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "text-input-adapter" }, [t.mode === "view" ? [i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: t.fieldResources.label } }, [i("div", { staticClass: "measurement-value" }, [i("span", { staticClass: "text-display" }, [t._v(t._s(t.convertedValue ?? t.plainValue))]), t.convertedValue ? i("app-tooltip", { attrs: { tooltip: t.plainValue } }) : t._e()], 1)])] : i("app-measurement-input", { attrs: { "fixed-dimension": t.fieldMeta.dimension, "fraction-digits": t.fieldMeta.fractionDigits, label: (r = t.fieldResources) == null ? void 0 : r.label, tooltip: (s = t.fieldResources) == null ? void 0 : s.tooltip, required: t.required, error: t.error }, on: { blur: t.onBlur, input: t.onInput }, model: { value: t.model, callback: function(n) {
    t.model = n;
  }, expression: "model" } })], 2);
}, wP = [], xP = /* @__PURE__ */ E(
  AP,
  kP,
  wP,
  !1,
  null,
  "858523f9"
);
const CP = xP.exports;
function Xo() {
  return { importData: (i) => {
    if (!i)
      return [];
    try {
      const r = JSON.parse(i);
      if (Array.isArray(r))
        return r;
      throw new Error("Array was expected");
    } catch (r) {
      return console.error("Could not parse TableAdapter options", r), [];
    }
  }, exportData: (i) => {
    const r = i.filter((s) => !!(s != null && s.id)).map((s) => ({ ...s }));
    return JSON.stringify(r);
  } };
}
const SP = f({
  components: {
    DynamicFieldItem: Uc
  },
  props: {
    dynamicFields: {
      type: Array,
      required: !0
    },
    currentData: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    tasks: {
      type: Array,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    creatingItem: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      fieldState: {}
    };
  },
  provide() {
    return {
      dynamicFieldBucket: { ...this.currentData.object }
    };
  },
  computed: {
    dynamicFieldsCompat() {
      return this.dynamicFields.map((e) => {
        const t = { ...e };
        return t.ref || (t.ref = e.field), t;
      });
    },
    isFormValid() {
      return this.dynamicFields.every(({ field: e, required: t }) => {
        var i, r;
        return !t || !((r = (i = this.fieldState[e]) == null ? void 0 : i.state) != null && r.empty);
      });
    },
    title() {
      return this.creatingItem ? this.$t("form.baseTable.newItem") : this.$t("form.baseTable.editItem");
    }
  },
  methods: {
    onDynamicFieldMounted(e) {
      this.$set(this.fieldState, e.ref, e);
    },
    onDynamicFieldUpdated(e) {
      this.$set(this.fieldState, e.ref, e);
    },
    onUpdateConfirm() {
      const e = {};
      Object.entries(this.fieldState).forEach((t) => {
        e[t[0]] = t[1].value;
      }), this.$emit("save", e);
    },
    onUpdateCancel() {
      this.$emit("cancel");
    }
  }
});
var IP = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("app-modal", { staticClass: "base-dynamic-modal" }, [i("div", { staticClass: "modal-content-container" }, [i("div", { staticClass: "header-modal" }, [i("div", { staticClass: "modal-title" }, [t._v(t._s(t.title))]), i("app-icon-button", { staticClass: "close", attrs: { size: 32 }, on: { click: t.onUpdateCancel } }, [i("fa-icon-compat", { attrs: { icon: "fa-solid fa-xmark" } })], 1)], 1), i("div", { staticClass: "modal-content" }, t._l(t.dynamicFieldsCompat, function(r, s) {
    return i("dynamic-field-item", { key: s, attrs: { mode: "edit", "dynamic-field": r, tasks: t.tasks, ticket: t.ticket, "current-user": t.currentUser, organization: t.organization, "context-id": t.contextId, "product-id": t.productId }, on: { "dynamic-field-mounted": t.onDynamicFieldMounted, "dynamic-field-updated": t.onDynamicFieldUpdated } });
  }), 1)]), i("app-button-sheet", { staticClass: "app-button-sheet", attrs: { align: "left", theme: "gray" } }, [i("app-button", { attrs: { enabled: t.isFormValid, label: t.$t("form.button.ticketSave") }, on: { click: t.onUpdateConfirm } }), i("app-secondary-button", { attrs: { label: t.$t("form.button.cancel") }, on: { click: t.onUpdateCancel } })], 1)], 1);
}, DP = [], PP = /* @__PURE__ */ E(
  SP,
  IP,
  DP,
  !1,
  null,
  "32be9272"
);
const TP = PP.exports, OP = De.extend({
  props: {
    label: null
  }
});
var BP = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "label-value-container" }, [i("div", { staticClass: "label" }, [t._v(t._s(t.label))]), i("div", { staticClass: "value" }, [t._t("default")], 2)]);
}, MP = [], RP = /* @__PURE__ */ E(
  OP,
  BP,
  MP,
  !1,
  null,
  "72291562"
);
const EP = RP.exports, LP = f({
  components: {
    AppLabelValue: EP
  },
  props: {
    headerList: {
      type: Array,
      default() {
        return [];
      }
    },
    data: {
      type: Object,
      required: !0
    }
  },
  computed: {
    headers() {
      return this.headerList.filter(
        (e) => !["actions", "icon"].includes(e.key)
      );
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    }
  }
});
var FP = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("app-modal", { on: { "click-outside": t.onClose } }, [i("div", { staticClass: "modal-content" }, [i("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: t.onClose } }, [i("fa-icon-compat", { staticClass: "icon", attrs: { icon: "fa-regular fa-xmark" } })], 1), t._l(t.headers, function(r, s) {
    return i("div", { key: s, staticClass: "column-content" }, [i("div", { staticClass: "label" }, [t._v(t._s(r.label))]), i("div", { staticClass: "value" }, [r.component ? i(r.component, t._g({ tag: "component", attrs: { header: r, item: t.data, value: t.data[r.key] } }, t.$listeners)) : i("span", [t._v(" " + t._s(t.data[r.key] || "-") + " ")])], 1)]);
  })], 2)]);
}, jP = [], UP = /* @__PURE__ */ E(
  LP,
  FP,
  jP,
  !1,
  null,
  "2728d638"
);
const qP = UP.exports, HP = f({
  components: {
    TableRowModal: qP,
    BaseDynamicModal: TP
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    columns: {
      type: Array,
      required: !0
    },
    data: {
      type: Array,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    tasks: {
      type: Array,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    config: {
      type: Object,
      required: !1
    }
  },
  data() {
    return {
      creatingItem: !1,
      itemToUpdate: null,
      itemToDelete: null,
      selectedRow: null
    };
  },
  computed: {
    tableHeaders() {
      const e = this.columns.map((t) => {
        var i;
        return {
          type: t.type,
          key: t.field,
          label: (i = this.resources(t)) == null ? void 0 : i.label
        };
      });
      return this.mode === "edit" && e.push({
        key: "actions",
        label: "",
        width: "50px",
        align: "end",
        component: "table-actions"
      }), this.isRowViewEnabled && e.push({
        key: "icon",
        label: "",
        width: "50px",
        align: "end",
        component: "table-icon"
      }), e;
    },
    isRowViewEnabled() {
      var e;
      return ((e = this.config) == null ? void 0 : e.enableRowView) === !0;
    },
    tableData() {
      return this.data.map((e) => this.convertTableItem(e));
    },
    updateDialogVisible() {
      return this.itemToUpdate !== null;
    },
    deleteDialogVisible() {
      return this.itemToDelete !== null;
    },
    tableIsEmpty() {
      return this.tableData.length === 0;
    }
  },
  methods: {
    convertTableItem(e) {
      const t = {};
      return t.id = e.id, this.tableHeaders.forEach((i) => {
        t[i.key] = this.parseRowValue(i, e);
      }), t.actions = [
        {
          label: this.$t("menu.edit").toString(),
          tabKey: "update"
        },
        {
          label: this.$t("menu.delete").toString(),
          tabKey: "delete"
        }
      ], this.isRowViewEnabled && (t.icon = "fa-regular fa-arrow-up-right-from-square"), t.object = this.convertToExpectedObject(e), t;
    },
    convertToExpectedObject(e) {
      const t = {};
      return this.tableHeaders.forEach((i) => {
        t[i.key] = this.expectedRowValue(i, e);
      }), t;
    },
    convertToPlainObject(e) {
      const t = {};
      return this.tableHeaders.forEach((i) => {
        const r = e[i.key];
        switch (i.type) {
          case "autocomplete":
            t[i.key] = JSON.parse(r);
            break;
          default:
            t[i.key] = r;
            break;
        }
      }), t;
    },
    parseRowValue(e, t) {
      const i = t[e.key];
      switch (e.type) {
        case "autocomplete":
          return Array.isArray(i) ? i.map((r) => r.label).join(", ") : (i == null ? void 0 : i.label) ?? "";
        case "datepicker":
          return new Date(i).toLocaleDateString();
        default:
          return (i == null ? void 0 : i.label) ?? i ?? "";
      }
    },
    expectedRowValue(e, t) {
      const i = t[e.key];
      switch (e.type) {
        case "autocomplete":
          return JSON.stringify(i);
        default:
          return i;
      }
    },
    onRowView(e) {
      this.isRowViewEnabled && (this.selectedRow = e);
    },
    onCloseRowView() {
      this.selectedRow = null;
    },
    resources(e) {
      var t;
      return this.$res((t = e == null ? void 0 : e.options) == null ? void 0 : t.resources);
    },
    onDelete(e) {
      this.itemToDelete = e;
    },
    onUpdate(e) {
      this.itemToUpdate = e;
    },
    onAddRow() {
      const e = {
        id: Date.now()
      };
      this.creatingItem = !0, this.itemToUpdate = this.convertTableItem(e);
    },
    async onUpdateConfirm(e) {
      if (!this.itemToUpdate)
        return;
      const t = this.itemToUpdate.id, i = this.convertToPlainObject(e);
      this.creatingItem ? this.$emit("create-row", { id: t, data: i }) : this.$emit("update-row", { id: t, data: i }), this.resetUpdateDialog();
    },
    resetUpdateDialog() {
      this.creatingItem = !1, this.itemToUpdate = null;
    },
    onDeleteConfirm() {
      if (!this.itemToDelete)
        return;
      const e = this.itemToDelete.id;
      this.$emit("delete-row", e), this.itemToDelete = null;
    },
    onDeleteCancel() {
      this.itemToDelete = null;
    }
  }
});
var zP = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "base-dynamic-table" }, [i("app-data-table", { staticClass: "inner-table", attrs: { headers: t.tableHeaders, data: t.tableData, config: t.config }, on: { "click:delete": t.onDelete, "click:update": t.onUpdate, "click:row": t.onRowView } }), t.tableIsEmpty ? i("div", { staticClass: "inner-table-empty" }, [t._v(" " + t._s(t.$t("common.noDataAvailable")) + " ")]) : t._e(), t.selectedRow ? i("table-row-modal", { attrs: { data: t.selectedRow, "header-list": t.tableHeaders }, on: { close: t.onCloseRowView } }) : t._e(), t.mode === "edit" ? i("add-button", { staticClass: "add-button", attrs: { text: t.$t("baseTable.addItem") }, on: { click: t.onAddRow } }) : t._e(), t.updateDialogVisible ? i("base-dynamic-modal", { attrs: { "dynamic-fields": t.columns, "creating-item": t.creatingItem, "current-data": t.itemToUpdate, tasks: t.tasks, ticket: t.ticket, "current-user": t.currentUser, organization: t.organization, "context-id": t.contextId, "product-id": t.productId }, on: { save: t.onUpdateConfirm, cancel: t.resetUpdateDialog } }) : t._e(), t.deleteDialogVisible ? i("app-modal-confirmation", { attrs: { title: t.$t("form.baseTable.deleteItem"), description: t.$t("baseTable.deleteConfirmation"), "primary-label": t.$t("form.button.remove"), "secondary-label": t.$t("form.button.keep") }, on: { "click-primary": t.onDeleteConfirm, "click-secondary": t.onDeleteCancel } }) : t._e()], 1);
}, NP = [], VP = /* @__PURE__ */ E(
  HP,
  zP,
  NP,
  !1,
  null,
  "b24d5e34"
);
const GP = VP.exports, WP = f({
  components: {
    LegacyFieldLabel: $,
    BaseDynamicTable: GP
  },
  inject: ["dynamicFieldBucket"],
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !1
    },
    ticket: {
      type: Object,
      required: !0
    },
    tasks: {
      type: Array,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !1
    }
  },
  data() {
    return {
      reloadKey: 0,
      model: []
    };
  },
  created() {
    const { importData: e } = Xo();
    this.model = e(this.getValue()), this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    bucket() {
      return this.dynamicFieldBucket ?? {};
    },
    columns() {
      var e;
      return ((e = this.fieldConfig.options) == null ? void 0 : e.columns) ?? [];
    },
    config() {
      var e;
      return {
        summary: "disabled",
        enableRowView: (e = this.fieldMeta) == null ? void 0 : e.enableRowView
      };
    },
    isReadonly() {
      var e;
      return !!(this.mode === "view" || (e = this.fieldMeta) != null && e.readonly);
    }
  },
  methods: {
    getValue() {
      let e = this.fieldConfig.ref ?? "";
      return e.startsWith("meta.") && (e = e.substring(5)), this.bucket[e] ?? "";
    },
    getState() {
      const { exportData: e } = Xo();
      return {
        ref: this.fieldConfig.ref,
        value: e(this.model),
        state: {
          empty: this.model.length === 0
        }
      };
    },
    onCreateRow(e) {
      this.model.push({
        id: e.id,
        ...e.data
      }), this.$emit("dynamic-field-updated", this.getState()), this.reloadKey += 1;
    },
    onUpdateRow(e) {
      const t = this.model.findIndex((i) => i.id === e.id);
      t !== -1 && (this.model[t] = {
        id: e.id,
        ...e.data
      }), this.$emit("dynamic-field-updated", this.getState()), this.reloadKey += 1;
    },
    onDeleteRow(e) {
      this.model = this.model.filter((t) => t.id !== e), this.$emit("dynamic-field-updated", this.getState()), this.reloadKey += 1;
    }
  }
});
var QP = function() {
  var r, s, n;
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.isReadonly ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: (r = t.fieldResources) == null ? void 0 : r.label } }, [i("base-dynamic-table", { attrs: { columns: t.columns, data: t.model, tasks: t.tasks, ticket: t.ticket, "current-user": t.currentUser, organization: t.organization, "context-id": t.contextId, "product-id": t.productId, config: t.config } })], 1) : i("base-input-item", { attrs: { label: (s = t.fieldResources) == null ? void 0 : s.label, tooltip: (n = t.fieldResources) == null ? void 0 : n.tooltip } }, [i("base-dynamic-table", { key: t.reloadKey, attrs: { mode: t.mode, columns: t.columns, data: t.model, tasks: t.tasks, ticket: t.ticket, "current-user": t.currentUser, organization: t.organization, "context-id": t.contextId, "product-id": t.productId, config: t.config }, on: { "create-row": t.onCreateRow, "update-row": t.onUpdateRow, "delete-row": t.onDeleteRow } })], 1);
}, XP = [], KP = /* @__PURE__ */ E(
  WP,
  QP,
  XP,
  !1,
  null,
  "0c36b436"
);
const YP = KP.exports;
function Ko() {
  return { importData: (i) => {
    if (!i)
      return [];
    try {
      return JSON.parse(i);
    } catch (r) {
      return console.error("Could not parse UserSelectionAdapter value", r), [];
    }
  }, exportData: (i) => JSON.stringify(i) };
}
const ZP = f({
  inject: ["dynamicFieldBucket"],
  components: {
    LegacyFieldLabel: $
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    var l;
    const {
      selectionMode: t,
      modelSingle: i,
      modelMultiple: r,
      model: s,
      updateSingle: n,
      updateMultiple: a
    } = pu();
    return t.value = (l = e.fieldMeta) == null ? void 0 : l.selectionMode, {
      selectionMode: t,
      modelSingle: i,
      modelMultiple: r,
      model: s,
      updateSingle: n,
      updateMultiple: a,
      updateModel: (c) => {
        s.value = c;
      }
    };
  },
  data() {
    return {
      error: !1,
      ready: !1,
      plainValue: ""
    };
  },
  watch: {
    model() {
      this.$emit("dynamic-field-updated", this.getState()), this.validate();
    }
  },
  async created() {
    const e = this.getValue();
    if (this.updateModel(e), this.mode === "view") {
      const i = (await this.$gateway.portal.findUsersById(e)).map((r) => yu(r).displayName()).filter((r) => !!r);
      this.plainValue = i.join(", ");
    }
    this.$nextTick(() => {
      this.$emit("dynamic-field-mounted", this.getState()), this.ready = !0;
    });
  },
  computed: {
    bucket() {
      return this.dynamicFieldBucket ?? {};
    },
    required() {
      return this.fieldConfig.required ?? !1;
    },
    filter() {
      return {
        context: this.contextId,
        teamIds: this.fieldMeta.teamIds,
        topicIds: this.fieldMeta.topicIds
      };
    },
    excludeUserIds() {
      var s;
      const e = ((s = this.fieldMeta.exclude) == null ? void 0 : s.actor) ?? [], t = e.includes("creator") ? this.ticket.creator : void 0, i = e.includes("assignee") ? this.ticket.assignee : void 0, r = e.includes("currentUser") ? this.currentUser.id : void 0;
      return [t, i, r].filter(Boolean);
    }
  },
  methods: {
    getValue() {
      const { importData: e } = Ko();
      let t = this.fieldConfig.ref ?? "";
      return t.startsWith("meta.") && (t = t.substring(5)), e(this.bucket[t]);
    },
    getState() {
      const { exportData: e } = Ko();
      return {
        ref: this.fieldConfig.ref,
        value: e(this.model),
        state: {
          empty: this.model.length === 0
        }
      };
    },
    onBlur() {
      this.validate();
    },
    validate() {
      const e = this.required ? !!this.model.length : !0;
      return this.error = !e, e;
    }
  }
});
var JP = function() {
  var r, s, n, a, o, l;
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.ready ? t.mode === "view" ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: t.fieldResources.label } }, [t._v(" " + t._s(t.plainValue) + " ")]) : t.selectionMode === "single" ? i("user-dropdown", { attrs: { label: (r = t.fieldResources) == null ? void 0 : r.label, placeholder: (s = t.fieldResources) == null ? void 0 : s.placeholder, tooltip: (n = t.fieldResources) == null ? void 0 : n.tooltip, filter: t.filter, "exclude-user-ids": t.excludeUserIds, required: t.required, error: t.error }, on: { input: t.updateSingle, blur: t.onBlur }, model: { value: t.modelSingle, callback: function(c) {
    t.modelSingle = c;
  }, expression: "modelSingle" } }) : i("user-multiselect", { attrs: { label: (a = t.fieldResources) == null ? void 0 : a.label, placeholder: (o = t.fieldResources) == null ? void 0 : o.placeholder, tooltip: (l = t.fieldResources) == null ? void 0 : l.tooltip, filter: t.filter, "exclude-user-ids": t.excludeUserIds, required: t.required, error: t.error }, on: { input: t.updateMultiple, blur: t.onBlur }, model: { value: t.modelMultiple, callback: function(c) {
    t.modelMultiple = c;
  }, expression: "modelMultiple" } }) : i("div");
}, _P = [], $P = /* @__PURE__ */ E(
  ZP,
  JP,
  _P,
  !1,
  null,
  "27c0b870"
);
const e2 = $P.exports, t2 = f({
  components: {
    LegacyFieldLabel: $
  },
  inject: ["dynamicFieldBucket"],
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !1
    },
    organization: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loaded: !1,
      selectedTeamId: "",
      teamName: ""
    };
  },
  async created() {
    if (this.selectedTeamId = this.getValue() ?? "", this.mode === "view" && this.selectedTeamId) {
      const e = await this.$datasource.team.find(this.selectedTeamId);
      this.teamName = e ? bu(e, this.$res).teamName() : "";
    }
    this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    bucket() {
      return this.dynamicFieldBucket ?? {};
    },
    teamConfig() {
      return this.fieldMeta;
    },
    required() {
      return this.fieldConfig.required ?? !1;
    },
    showTeamName() {
      return this.mode === "view" && !!this.teamName;
    }
  },
  methods: {
    getValue() {
      const { importData: e } = ht();
      let t = this.fieldConfig.ref ?? "";
      return t.startsWith("meta.") && (t = t.substring(5)), e(this.bucket[t]);
    },
    getState() {
      const { exportData: e } = ht();
      return {
        ref: this.fieldConfig.ref,
        value: e(this.selectedTeamId),
        state: {
          empty: !this.selectedTeamId
        }
      };
    },
    setTeamId(e) {
      this.selectedTeamId = e[0], this.loaded ? this.$emit("dynamic-field-updated", this.getState()) : (this.$emit("dynamic-field-mounted", this.getState()), this.loaded = !0);
    }
  }
});
var i2 = function() {
  var r, s, n, a, o, l;
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.showTeamName ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: (r = t.fieldResources) == null ? void 0 : r.label } }, [t._v(" " + t._s(t.teamName) + " ")]) : t.mode === "edit" ? i("team-selector", { attrs: { configuration: t.teamConfig, "favorites-label": (s = t.fieldResources) == null ? void 0 : s.favoritesLabel, "initial-team-ids": [t.selectedTeamId], label: (n = t.fieldResources) == null ? void 0 : n.label, placeholder: (a = t.fieldResources) == null ? void 0 : a.placeholder, required: t.required, tags: (o = t.fieldMeta) == null ? void 0 : o.tags, tooltip: (l = t.fieldResources) == null ? void 0 : l.tooltip, organization: t.organization, "user-id": t.currentUser.id }, on: { input: t.setTeamId } }) : t._e();
}, r2 = [], s2 = /* @__PURE__ */ E(
  t2,
  i2,
  r2,
  !1,
  null,
  null
);
const n2 = s2.exports, a2 = f({
  components: {
    LegacyFieldLabel: $
  },
  props: {
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !1
    },
    ticket: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      workflow: null,
      label: "",
      backgroundColor: ""
    };
  },
  async created() {
    this.workflow = await this.$datasource.workflow.find(this.ticket.type), this.label = this.getLabel(), this.backgroundColor = this.getBackgroundColor(), this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    status() {
      var e, t, i;
      return this.statusType === "phases" ? ((i = (t = (e = this.workflow) == null ? void 0 : e.settings) == null ? void 0 : t.status[this.ticket.status]) == null ? void 0 : i.phase) ?? "" : this.ticket.status;
    },
    statusType() {
      return this.fieldMeta.showStatus ? "status" : "phases";
    },
    config() {
      return this.statusType === "phases" ? this.phaseConfig.map(({ phase: e }) => e) : this.statusConfig;
    },
    phaseConfig() {
      return this.workflow ? Iu(this.workflow) : [];
    },
    statusConfig() {
      var e, t;
      return ((t = (e = this.workflow) == null ? void 0 : e.settings) == null ? void 0 : t.timelineStatuses) ?? [];
    }
  },
  methods: {
    getLabel() {
      var t;
      const e = Jo(this.status, this.workflow, this.statusType);
      return ((t = this.$res(e)) == null ? void 0 : t.label) ?? this.status;
    },
    getBackgroundColor() {
      const e = gu(this.status, this.workflow, this.statusType) ?? "var(--color-blue)";
      return e != null && e.endsWith(";") ? e.substring(0, e.length - 1) : e;
    },
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: !1
        }
      };
    }
  }
});
var o2 = function() {
  var r;
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.label ? i("legacy-field-label", { staticClass: "ticket-status-adapter", attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: (r = t.fieldResources) == null ? void 0 : r.label } }, [i("app-pill", { attrs: { "background-color": t.backgroundColor, color: "var(--color-white)", label: t.label } })], 1) : t._e();
}, l2 = [], c2 = /* @__PURE__ */ E(
  a2,
  o2,
  l2,
  !1,
  null,
  null
);
const u2 = c2.exports, d2 = f({
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      workflow: void 0,
      ticketHistory: []
    };
  },
  async created() {
    this.workflow = await this.$datasource.workflow.find(this.ticket.type), this.ticketHistory = await this.$api.ticket.getTicketHistory(
      this.ticket.type,
      this.ticket.canonicalId
    ), this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    headerLevel() {
      return this.mode === "edit" ? 3 : 2;
    },
    showTimeline() {
      return !!this.workflow && this.mode === "view";
    },
    statusHistory() {
      return this.ticketHistory.filter(({ eventType: e }) => e === "STATUS_UPDATED").flatMap(({ newValue: e, previousValue: t }) => [e, t]);
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: !1
        }
      };
    }
  }
});
var h2 = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.showTimeline ? i("app-section", { staticClass: "ticket-timeline-adapter", attrs: { level: t.headerLevel, title: t.fieldResources.label } }, [i("ticket-timeline", { attrs: { "show-current": t.fieldMeta.showCurrent, "show-phase": t.fieldMeta.showPhase, "show-status": t.fieldMeta.showStatus, "status-history": t.statusHistory, ticket: t.ticket, workflow: t.workflow } })], 1) : t._e();
}, p2 = [], f2 = /* @__PURE__ */ E(
  d2,
  h2,
  p2,
  !1,
  null,
  null
);
const m2 = f2.exports, g2 = f({
  props: {
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !1
    },
    productId: {
      type: String,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      selected: "",
      error: !1
    };
  },
  async created() {
    this.selected = this.ticket.assignee ?? "", this.$nextTick(() => {
      this.$emit("dynamic-field-mounted", this.getState());
    });
  },
  computed: {
    required() {
      return this.fieldConfig.required ?? !1;
    },
    excludeUserIds() {
      var s, n;
      const e = ((n = (s = this.fieldMeta) == null ? void 0 : s.exclude) == null ? void 0 : n.actor) ?? [], t = e.includes("creator") ? this.ticket.creator : void 0, i = e.includes("assignee") ? this.ticket.assignee : void 0, r = e.includes("currentUser") ? this.currentUser.id : void 0;
      return [t, i, r].filter(Boolean);
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: this.selected,
        state: {
          empty: !this.selected
        }
      };
    },
    onInput() {
      this.$emit("dynamic-field-updated", this.getState()), this.validate();
    },
    onBlur() {
      this.validate();
    },
    validate() {
      const e = this.required ? !!this.selected : !0;
      return this.error = !e, e;
    }
  }
});
var y2 = function() {
  var r, s, n;
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("assignee-singleselect", { attrs: { ticket: t.ticket, productId: t.productId, label: (r = t.fieldResources) == null ? void 0 : r.label, placeholder: (s = t.fieldResources) == null ? void 0 : s.placeholder, tooltip: (n = t.fieldResources) == null ? void 0 : n.tooltip, "exclude-user-ids": t.excludeUserIds, required: t.required, error: t.error }, on: { input: t.onInput, blur: t.onBlur }, model: { value: t.selected, callback: function(a) {
    t.selected = a;
  }, expression: "selected" } });
}, b2 = [], v2 = /* @__PURE__ */ E(
  g2,
  y2,
  b2,
  !1,
  null,
  "24148cce"
);
const A2 = v2.exports, k2 = f({
  components: {
    LegacyFieldLabel: $
  },
  props: {
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      model: 0,
      error: !1,
      props: {}
    };
  },
  created() {
    this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    buttonStyle() {
      return this.fieldMeta.fullWidth ? {
        width: "100%"
      } : {};
    },
    theme() {
      switch (this.fieldMeta.buttonType) {
        case "primary":
          return "button";
        case "cta":
          return "cta-button";
        case "link":
          return "link";
        default:
          return "button";
      }
    },
    url() {
      var e;
      return ((e = this.fieldResources.url) == null ? void 0 : e.replace("{ticketId}", this.ticket.canonicalId).replace("{product}", this.productId)) ?? "/";
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: this.fieldResources.url === ""
        }
      };
    }
  }
});
var w2 = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("app-link", { style: t.buttonStyle, attrs: { "external-path": t.url, label: t.fieldResources.label, target: t.fieldMeta.linkType, theme: t.theme } });
}, x2 = [], C2 = /* @__PURE__ */ E(
  k2,
  w2,
  x2,
  !1,
  null,
  null
);
const S2 = C2.exports, I2 = f({
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    }
  },
  async created() {
    this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    endDate() {
      var t;
      const e = this.ticket.meta[(t = this.fieldMeta) == null ? void 0 : t.endDateField];
      return e ? new Date(e) : void 0;
    },
    showCountDown() {
      return !!(this.endDate && this.endDate > /* @__PURE__ */ new Date());
    },
    label() {
      return this.showCountDown ? this.fieldResources.countdownLabel : this.fieldResources.campaignClosedLabel;
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: !this.endDate
        }
      };
    }
  }
});
var D2 = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.endDate ? i("app-section", { staticClass: "countdown-adapter", attrs: { level: 2, title: t.label } }, [t.showCountDown ? i("app-countdown", { attrs: { "end-date": t.endDate } }) : t._e()], 1) : t._e();
}, P2 = [], T2 = /* @__PURE__ */ E(
  I2,
  D2,
  P2,
  !1,
  null,
  null
);
const O2 = T2.exports, B2 = f({
  props: {
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !1
    },
    organization: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      error: !1,
      loaded: !1,
      selectedDelegation: "",
      selectedDelegationId: ""
    };
  },
  async created() {
    var e, t;
    this.delegateConfiguration.length === 1 ? this.selectedDelegation = this.delegateConfiguration[0].class : this.selectedDelegation = ((e = this.ticket.delegate[0]) == null ? void 0 : e.domain) ?? ((t = this.delegateConfiguration[0]) == null ? void 0 : t.class) ?? "team";
  },
  computed: {
    teamLabel() {
      var e;
      return ((e = this.fieldResources) == null ? void 0 : e.label) ?? this.$t("form.selectTeam.label").toString();
    },
    teamPlaceholder() {
      var e;
      return ((e = this.fieldResources) == null ? void 0 : e.placeholder) ?? this.$t("form.selectTeam.placeholder").toString();
    },
    topicLabel() {
      var e;
      return ((e = this.fieldResources) == null ? void 0 : e.label) ?? this.$t("form.selectTopic.label").toString();
    },
    topicPlaceholder() {
      var e;
      return ((e = this.fieldResources) == null ? void 0 : e.placeholder) ?? this.$t("form.selectTopic.placeholder").toString();
    },
    delegateConfiguration() {
      var e;
      return ((e = this.fieldMeta) == null ? void 0 : e.delegations) ?? [];
    },
    getCurrentTeamIds() {
      const e = this.getCurrentDelegation(this.selectedDelegation);
      return e ? [e.id] : [];
    },
    selectedDelegate() {
      if (!(!this.selectedDelegation || !this.selectedDelegationId))
        return {
          context: "",
          domain: this.selectedDelegation,
          id: this.selectedDelegationId
        };
    },
    delegationOptions() {
      if (!this.delegateConfiguration.length)
        return [];
      const e = this.delegateConfiguration.map((i) => i.class);
      return [
        {
          label: this.$t("form.ticketDelegateToTeam").toString(),
          value: "team"
        },
        {
          label: this.$t("form.ticketDelegateToTopic").toString(),
          value: "topic"
        }
      ].filter((i) => e.includes(i.value));
    },
    required() {
      return this.fieldConfig.required ?? !1;
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: this.selectedDelegate,
        state: {
          empty: !this.selectedDelegate
        }
      };
    },
    validate() {
      this.error = this.required && !this.selectedDelegate;
    },
    getDelegationConfig(e) {
      return this.delegateConfiguration.find((t) => t.class === e);
    },
    getCurrentDelegation(e) {
      return this.ticket.delegate.find((t) => t.domain === e);
    },
    setDelegateTeam(e) {
      this.setDelegate(e[0]);
    },
    setDelegate(e) {
      this.selectedDelegationId = e, this.loaded ? this.$emit("dynamic-field-updated", this.getState()) : (this.$emit("dynamic-field-mounted", this.getState()), this.loaded = !0);
    }
  }
});
var M2 = function() {
  var r, s, n, a;
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "base-delegate-ticket-to" }, [t.delegationOptions.length > 1 ? i("div", { staticClass: "delegate-type-selection" }, t._l(t.delegationOptions, function(o, l) {
    return i("label", { key: l }, [i("input", { directives: [{ name: "model", rawName: "v-model", value: t.selectedDelegation, expression: "selectedDelegation" }], attrs: { type: "radio" }, domProps: { value: o.value, checked: t._q(t.selectedDelegation, o.value) }, on: { change: function(c) {
      t.selectedDelegation = o.value;
    } } }), i("span", [t._v(t._s(o.label))])]);
  }), 0) : t._e(), ["team", "workgroup"].includes(t.selectedDelegation) ? i("team-selector", { attrs: { configuration: t.getDelegationConfig(t.selectedDelegation), error: t.error, "favorites-label": (r = t.fieldResources) == null ? void 0 : r.favoritesLabel, "initial-team-ids": t.getCurrentTeamIds, label: t.teamLabel, placeholder: t.teamPlaceholder, required: t.required, tags: t.fieldMeta.tags, tooltip: (s = t.fieldResources) == null ? void 0 : s.tooltip, organization: t.organization, "user-id": t.currentUser.id }, on: { input: t.setDelegateTeam } }) : t._e(), t.selectedDelegation === "topic" ? i("topic-selector", { attrs: { error: t.error, "initial-topic-id": (n = t.getCurrentDelegation("topic")) == null ? void 0 : n.id, label: t.topicLabel, placeholder: t.topicPlaceholder, product: t.ticket.type, required: t.required, tags: t.fieldMeta.tags, tooltip: (a = t.fieldResources) == null ? void 0 : a.tooltip, user: t.currentUser }, on: { input: t.setDelegate } }) : t._e()], 1);
}, R2 = [], E2 = /* @__PURE__ */ E(
  B2,
  M2,
  R2,
  !1,
  null,
  "f069141b"
);
const L2 = E2.exports, F2 = f({
  inject: ["dynamicFieldBucket"],
  props: {
    fieldConfig: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !1
    },
    fieldMeta: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      loaded: !1,
      teamId: ""
    };
  },
  async created() {
    var e;
    this.teamId = ((e = this.ticket.delegate.find(({ domain: t }) => t === "workgroup")) == null ? void 0 : e.id) ?? "";
  },
  computed: {
    teamConfig() {
      return {
        types: ["WORKGROUP"],
        operations: ["select"]
      };
    },
    workgroupDelegation() {
      return this.teamId ? {
        context: "",
        domain: "workgroup",
        id: this.teamId
      } : null;
    },
    required() {
      return this.fieldConfig.required ?? !1;
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: this.workgroupDelegation,
        state: {
          empty: !this.teamId
        }
      };
    },
    setTeamId(e) {
      this.teamId = e[0], this.loaded ? this.$emit("dynamic-field-updated", this.getState()) : (this.$emit("dynamic-field-mounted", this.getState()), this.loaded = !0);
    }
  }
});
var j2 = function() {
  var r, s, n, a;
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("team-selector", { attrs: { configuration: t.teamConfig, "favorites-label": (r = t.fieldResources) == null ? void 0 : r.favoritesLabel, "initial-team-ids": [t.teamId], label: (s = t.fieldResources) == null ? void 0 : s.label, tags: t.fieldMeta.tags, placeholder: (n = t.fieldResources) == null ? void 0 : n.placeholder, required: t.required, tooltip: (a = t.fieldResources) == null ? void 0 : a.tooltip, organization: t.organization, "user-id": t.currentUser.id }, on: { input: t.setTeamId } });
}, U2 = [], q2 = /* @__PURE__ */ E(
  F2,
  j2,
  U2,
  !1,
  null,
  null
);
const H2 = q2.exports, z2 = f({
  components: {
    LegacyFieldLabel: $
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      tickets: [],
      coverUploadCategory: "cover/upload",
      showProductSelector: !1,
      loading: !1
    };
  },
  async created() {
    this.loading = !0, await this.fetchChildTickets(), this.loading = !1, this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    enableUserInspirePeople() {
      var e;
      return !!this.organization.productCustomization[this.productId].enableAiContentGeneration && ((e = this.organization.settings) == null ? void 0 : e.userInspirePeople);
    },
    allowCreateTicket() {
      var e;
      return !!(this.products.length && ((e = this.fieldMeta.statusesWithAddButton) != null && e.includes(this.ticket.status)));
    },
    campaignImage() {
      return this.getTicketImage(this.ticket);
    },
    products() {
      var t;
      let e;
      return this.ticket.meta[this.fieldMeta.productField] && (e = JSON.parse(this.ticket.meta[this.fieldMeta.productField])), !e && ((t = this.fieldMeta.productList) != null && t.length) && (e = this.fieldMeta.productList), e || [this.ticket.type];
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: !this.tickets.length
        }
      };
    },
    getTicketImage(e) {
      var t, i;
      return e.meta.cover ?? ((i = (t = e.files) == null ? void 0 : t.find((r) => r.category === "ticket-cover")) == null ? void 0 : i.url) ?? "";
    },
    async fetchChildTickets() {
      try {
        const e = await this.$gateway.portal.loadChildTickets(
          this.contextId,
          this.productId,
          this.ticket.canonicalId,
          this.products
        );
        this.tickets = e.splice(0, this.fieldMeta.maxTickets).map((t) => {
          if (!this.getTicketImage(t.ticket)) {
            const i = structuredClone(t);
            return i.ticket.meta.cover = this.campaignImage, i;
          }
          return t;
        });
      } catch (e) {
        console.error("Could not load feedback ticket", e);
      }
    },
    inspireUser() {
      this.$router.replace({
        hash: `inspire-me=${this.ticket.canonicalId}`
      });
    },
    selectProduct() {
      this.products.length === 1 ? this.goToCreateTicket(this.products[0]) : (this.showProductSelector = !0, this.goToCreateTicket(this.products[0]));
    },
    goToCreateTicket(e) {
      this.$router.push({
        name: "CreateTicket",
        params: {
          product: e
        },
        query: {
          parent: this.ticket.canonicalId,
          type: e
        }
      });
    },
    goToTicketSearch() {
      this.$router.push({
        name: "SearchTicketPage",
        query: {
          parent: this.ticket.canonicalId
        }
      });
    },
    routeToTicket(e) {
      return {
        name: "TicketDetails",
        params: {
          id: e.ticket.canonicalId
        }
      };
    }
  }
});
var N2 = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, !t.loading && t.mode === "view" ? i("app-section", { staticClass: "ticket-gallery-adapter", attrs: { level: 2, title: t.fieldResources.label }, scopedSlots: t._u([{ key: "action", fn: function() {
    return [i("view-all-button", { on: { click: t.goToTicketSearch } })];
  }, proxy: !0 }], null, !1, 3606616758) }, [i("div", { staticClass: "ticket-gallery-container" }, [t.allowCreateTicket ? [!t.enableUserInspirePeople && t.allowCreateTicket ? i("add-button", { staticClass: "add-button campaign-card", attrs: { text: t.fieldResources.addTicketLabel }, on: { click: t.selectProduct } }) : t._e(), t.enableUserInspirePeople && t.allowCreateTicket ? i("add-button", { staticClass: "add-button", attrs: { text: "Inspire me!", icon: "fa-solid fa-sparkles" }, on: { click: t.inspireUser } }) : t._e()] : t._e(), t._l(t.tickets, function(r) {
    return i("router-link", { staticClass: "campaign-card", attrs: { to: t.routeToTicket(r) } }, [i("campaign-gallery-card", { attrs: { assignee: r.assignee, creator: r.creator, ticket: r.ticket, workflow: r.workflow } })], 1);
  })], 2)]) : t._e();
}, V2 = [], G2 = /* @__PURE__ */ E(
  z2,
  N2,
  V2,
  !1,
  null,
  "d1361abf"
);
const W2 = G2.exports, Q2 = f({
  components: {
    LegacyFieldLabel: $
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      allSkills: [],
      selectedSkills: []
    };
  },
  async created() {
    await this.loadSkills(), this.$nextTick(() => {
      this.$emit("dynamic-field-mounted", this.getState());
    });
  },
  computed: {
    productId() {
      return this.ticket.type;
    },
    ticketId() {
      return this.ticket.canonicalId;
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: this.selectedSkills.length === 0
        }
      };
    },
    async addSkill(e) {
      await this.$api.ticket.addTicketSkill(
        this.productId,
        this.ticketId,
        e
      ), await this.loadSkills(), this.$emit("dynamic-field-updated", this.getState());
    },
    async removeSkills(e) {
      await this.$api.ticket.removeTicketSkill(
        this.productId,
        this.ticketId,
        e
      ), await this.loadSkills(), this.$emit("dynamic-field-updated", this.getState());
    },
    async loadSkills() {
      const e = await this.$api.ticket.fetchTicketSkills(
        this.productId,
        this.ticketId
      );
      if (this.mode === "edit") {
        const t = await this.$api.skills.fetchSkillCatalog(!1);
        this.allSkills = Array.from(/* @__PURE__ */ new Set([...t, ...e]));
      }
      this.selectedSkills = e;
    },
    searchSkill(e) {
      this.$router.push({
        name: "SearchUserPage",
        query: {
          skills: e
        }
      });
    }
  }
});
var X2 = function() {
  var r, s, n, a, o;
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.mode === "view" ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: t.fieldResources.label } }, [i("app-tag-cloud", { staticClass: "ticket-skills-display", attrs: { tags: t.selectedSkills }, on: { click: t.searchSkill } })], 1) : i("skills-multiselect", { attrs: { label: (r = t.fieldResources) == null ? void 0 : r.label, placeholder: (s = t.fieldResources) == null ? void 0 : s.placeholder, tooltip: (n = t.fieldResources) == null ? void 0 : n.tooltip, "create-item-label": (a = t.fieldResources) == null ? void 0 : a.labelCreateSkill, "search-placeholder": (o = t.fieldResources) == null ? void 0 : o.labelSearchSkill, "skill-catalog": t.allSkills }, on: { "create-skill": t.addSkill, "add-skill": t.addSkill, "remove-skill": t.removeSkills }, model: { value: t.selectedSkills, callback: function(l) {
    t.selectedSkills = l;
  }, expression: "selectedSkills" } });
}, K2 = [], Y2 = /* @__PURE__ */ E(
  Q2,
  X2,
  K2,
  !1,
  null,
  "db41ca75"
);
const Z2 = Y2.exports, J2 = f({
  components: {
    LegacyFieldLabel: $
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      allTags: [],
      selectedTags: []
    };
  },
  async created() {
    await this.loadTags(), this.$nextTick(() => {
      this.$emit("dynamic-field-mounted", this.getState());
    });
  },
  computed: {
    productId() {
      return this.ticket.type;
    },
    ticketId() {
      return this.ticket.canonicalId;
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: this.selectedTags.length === 0
        }
      };
    },
    async addTag(e) {
      await this.$api.genericTags.addGenericTags("tag", this.ticketId, [e]), await this.loadTags(), this.$emit("dynamic-field-updated", this.getState());
    },
    async removeTag(e) {
      await this.$api.genericTags.removeGenericTags("tag", this.ticketId, [
        e
      ]), await this.loadTags(), this.$emit("dynamic-field-updated", this.getState());
    },
    async loadTags() {
      const e = await this.$api.genericTags.fetchGenericTags(
        "tag",
        this.ticketId
      );
      if (this.mode === "edit") {
        const t = await this.$api.genericTags.fetchGenericTagsCatalog(
          "tag"
        );
        this.allTags = Array.from(/* @__PURE__ */ new Set([...t, ...e]));
      }
      this.selectedTags = e;
    },
    searchTag(e) {
      this.$router.push({
        name: "SearchTicketPage",
        query: {
          tags: e
        }
      });
    }
  }
});
var _2 = function() {
  var r, s, n, a, o;
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.mode === "view" ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: t.fieldResources.label } }, [i("app-tag-cloud", { staticClass: "ticket-tags-display", attrs: { tags: t.selectedTags }, on: { click: t.searchTag } })], 1) : i("generic-tags-multiselect", { attrs: { label: (r = t.fieldResources) == null ? void 0 : r.label, placeholder: (s = t.fieldResources) == null ? void 0 : s.placeholder, tooltip: (n = t.fieldResources) == null ? void 0 : n.tooltip, "create-item-label": (a = t.fieldResources) == null ? void 0 : a.labelCreateTag, "search-placeholder": (o = t.fieldResources) == null ? void 0 : o.labelSearchTag, catalog: t.allTags }, on: { "create-tag": t.addTag, "add-tag": t.addTag, "remove-tag": t.removeTag }, model: { value: t.selectedTags, callback: function(l) {
    t.selectedTags = l;
  }, expression: "selectedTags" } });
}, $2 = [], eT = /* @__PURE__ */ E(
  J2,
  _2,
  $2,
  !1,
  null,
  "952b981f"
);
const tT = eT.exports, iT = f({
  components: {
    LegacyFieldLabel: $
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !1
    },
    ticket: {
      type: Object,
      required: !0
    },
    tasks: {
      type: Array,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      reloadKey: 0,
      currentTasks: []
    };
  },
  async created() {
    this.currentTasks = this.tasks.filter(
      (e) => {
        var t;
        return !((t = e[0].ticket.meta) != null && t.taskGroup);
      }
    ), this.$nextTick(() => {
      this.$emit("dynamic-field-mounted", this.getState());
    }), this.reloadKey += 1;
  },
  computed: {
    label() {
      var e;
      return this.mode === "edit" ? (e = this.fieldResources) == null ? void 0 : e.label : void 0;
    },
    tooltip() {
      var e;
      return this.mode === "edit" ? (e = this.fieldResources) == null ? void 0 : e.tooltip : void 0;
    },
    parentCanonicalId() {
      return this.ticket.canonicalId;
    },
    createMode() {
      return this.mode === "edit" && !this.$route.params.id;
    },
    createModeVisible() {
      var e, t;
      return ((t = (e = this.fieldMeta) == null ? void 0 : e.visibility) == null ? void 0 : t.createMode) ?? !1;
    },
    createTaskEnabled() {
      var e, t;
      return ((t = (e = this.fieldMeta) == null ? void 0 : e.actions) == null ? void 0 : t.createTask) ?? !0;
    },
    visibility() {
      return this.createMode && !this.createModeVisible ? "hidden" : "auto";
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: this.currentTasks.length === 0,
          visibility: this.visibility
        }
      };
    },
    async reloadTasks() {
      try {
        const e = await this.$gateway.portal.loadTasks(
          this.contextId,
          this.ticket.type,
          this.parentCanonicalId
        );
        this.currentTasks = e.filter((t) => {
          var i;
          return !((i = t[0].ticket.meta) != null && i.taskGroup);
        });
      } catch (e) {
        console.error("Could not load tasks", e);
      }
      this.reloadKey += 1;
    },
    async onUpdateTaskList() {
      await this.reloadTasks(), this.$emit("dynamic-field-updated", this.getState());
    }
  }
});
var rT = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.mode === "view" ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: t.fieldResources.label } }, [i("task-list", { key: t.reloadKey, attrs: { "current-user": t.currentUser, "product-id": t.productId, "parent-canonical-id": t.parentCanonicalId, mode: t.mode, "actions-create-task": t.createTaskEnabled, tasks: t.currentTasks }, on: { "update-task-list": t.onUpdateTaskList } })], 1) : i("base-input-item", { staticClass: "base-task", attrs: { label: t.label, tooltip: t.tooltip } }, [i("task-list", { key: t.reloadKey, attrs: { "current-user": t.currentUser, "product-id": t.productId, "parent-canonical-id": t.parentCanonicalId, mode: t.mode, "actions-create-task": t.createTaskEnabled, tasks: t.currentTasks }, on: { "update-task-list": t.onUpdateTaskList } })], 1);
}, sT = [], nT = /* @__PURE__ */ E(
  iT,
  rT,
  sT,
  !1,
  null,
  null
);
const aT = nT.exports, oT = f({
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    tasks: {
      type: Array,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      reloadKey: 0,
      currentTasks: [],
      expanded: !0
    };
  },
  async created() {
    this.currentTasks = this.tasks.filter(
      (e) => {
        var t;
        return ((t = e[0].ticket.meta) == null ? void 0 : t.taskGroup) === this.taskGroup;
      }
    ), this.$nextTick(() => {
      this.$emit("dynamic-field-mounted", this.getState());
    }), this.expanded = this.expandedDefault;
  },
  computed: {
    productId() {
      return this.ticket.type;
    },
    parentCanonicalId() {
      return this.ticket.canonicalId;
    },
    createMode() {
      return this.mode === "edit" && !this.$route.params.id;
    },
    createModeVisible() {
      var e;
      return ((e = this.fieldMeta.visibility) == null ? void 0 : e.createMode) ?? !1;
    },
    emptyVisible() {
      var e;
      return ((e = this.fieldMeta.visibility) == null ? void 0 : e.showEmpty) ?? !1;
    },
    createTaskEnabled() {
      var e;
      return ((e = this.fieldMeta.actions) == null ? void 0 : e.createTask) ?? !0;
    },
    expandedDefault() {
      return this.fieldMeta.expanded ?? !1;
    },
    visibility() {
      return this.createMode && !this.createModeVisible ? "hidden" : this.mode === "edit" ? this.emptyVisible ? "visible" : "hidden" : "auto";
    },
    taskGroup() {
      return this.fieldMeta.taskGroup;
    },
    doneCount() {
      return this.currentTasks.filter(
        ([{ ticket: e }]) => e.status === "COMPLETED"
      ).length;
    },
    doneCountingLabel() {
      return this.$t("page.tasks.done-counting", {
        totalCount: this.currentTasks.length,
        doneCount: this.doneCount
      }).toString();
    },
    headerIcon() {
      return this.expanded ? "fa-light fa-chevron-up" : "fa-light fa-chevron-down";
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: this.currentTasks.length === 0,
          visibility: this.visibility
        }
      };
    },
    async reloadTasks() {
      try {
        this.currentTasks = await this.$gateway.portal.loadTasks(
          this.contextId,
          this.ticket.type,
          this.parentCanonicalId,
          this.taskGroup
        );
      } catch (e) {
        console.error("Could not load grouped tasks", e);
      }
      this.reloadKey += 1;
    },
    onToggleGroup() {
      this.expanded = !this.expanded;
    },
    async onUpdateTaskList() {
      await this.reloadTasks(), this.$emit("dynamic-field-updated", this.getState());
    }
  }
});
var lT = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "base-task-group" }, [i("div", { staticClass: "task-group-header" }, [i("app-icon-button", { staticClass: "close-button", attrs: { size: 32 }, on: { click: t.onToggleGroup } }, [i("fa-icon-compat", { staticClass: "icon", attrs: { icon: t.headerIcon } })], 1), i("div", { staticClass: "task-group-title" }, [t._v(t._s(t.fieldResources.title))]), i("div", { staticClass: "task-group-count" }, [t._v(t._s(t.doneCountingLabel))])], 1), t.expanded ? [i("task-list", { key: t.reloadKey, attrs: { "current-user": t.currentUser, "product-id": t.productId, "parent-canonical-id": t.parentCanonicalId, "task-group": t.taskGroup, mode: t.mode, "actions-create-task": t.createTaskEnabled, tasks: t.currentTasks }, on: { "update-task-list": t.onUpdateTaskList } })] : t._e()], 2);
}, cT = [], uT = /* @__PURE__ */ E(
  oT,
  lT,
  cT,
  !1,
  null,
  "484b902e"
);
const dT = uT.exports, hT = f({
  components: {
    LegacyFieldLabel: $
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      ready: !1
    };
  },
  created() {
    this.ready = !0, this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    visible() {
      return !0;
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: !this.hasContent()
        }
      };
    },
    hasContent() {
      return this.fieldMeta.pitchConfig.some((e) => {
        var t;
        return (t = this.ticket.files) == null ? void 0 : t.some(
          (i) => i.category === e.uploadCategory
        );
      });
    },
    onPitchUpdated() {
      this.$emit("dynamic-field-updated", this.getState());
    }
  }
});
var pT = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "video-pitch-adapter" }, [t.mode === "view" ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: t.fieldResources.label } }, [i("ticket-pitch-gallery", { attrs: { ticket: t.ticket, "pitch-config": t.fieldMeta.pitchConfig } })], 1) : [t.ready ? i("ticket-pitch-upload-container", { attrs: { ticket: t.ticket, "pitch-config": t.fieldMeta.pitchConfig }, on: { "pitch-updated": t.onPitchUpdated } }) : t._e()]], 2);
}, fT = [], mT = /* @__PURE__ */ E(
  hT,
  pT,
  fT,
  !1,
  null,
  null
);
const gT = mT.exports, yT = f({
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !1
    },
    fieldMeta: {
      type: Object,
      default: () => ({})
    },
    productId: {
      type: String,
      required: !0
    }
  },
  async created() {
    this.currentTicket = this.ticket, this.$emit("dynamic-field-mounted", this.getState());
  },
  data() {
    return {
      currentTicket: {}
    };
  },
  computed: {
    galleryFiles() {
      var e;
      return ((e = this.currentTicket.files) == null ? void 0 : e.filter(
        (t) => t.category === this.category
      )) ?? [];
    },
    category() {
      var e;
      return ((e = this.fieldMeta) == null ? void 0 : e.category) || "";
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: this.galleryFiles.map((e) => e.url),
        state: {
          empty: this.galleryFiles.length === 0
        }
      };
    },
    onFilesUpdated() {
      this.$emit("dynamic-field-updated", this.getState());
    },
    async onPermissionsUpdated() {
      this.currentTicket = await this.$api.ticket.getTicket(
        this.productId,
        this.ticket.canonicalId
      );
    }
  }
});
var bT = function() {
  var r;
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "ticket-attachment-adapter" }, [t.mode === "view" ? i("app-file-gallery", { attrs: { files: t.galleryFiles, label: (r = t.fieldResources) == null ? void 0 : r.label } }) : i("app-attachment-container", { attrs: { "ticket-id": t.ticket.canonicalId, files: t.galleryFiles, category: t.category, "product-id": t.productId, "accepted-extensions": t.fieldMeta.acceptedExtensions, "max-file-count": t.fieldMeta.maxFileCount, "max-file-size": t.fieldMeta.maxFileSize }, on: { "attachment-updated": t.onFilesUpdated, "permissions-updated": t.onPermissionsUpdated } })], 1);
}, vT = [], AT = /* @__PURE__ */ E(
  yT,
  bT,
  vT,
  !1,
  null,
  "97b09d64"
);
const kT = AT.exports, wT = f({
  components: {
    LegacyFieldLabel: $
  },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !1
    },
    ticket: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    },
    currentUser: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      feedbackTickets: [],
      defaultFeedbackTickets: [],
      loading: !1
    };
  },
  async created() {
    this.loading = !0, await Promise.all([
      this.fetchFeedbackTickets(),
      this.fetchFeedbackWorkflow()
    ]), this.loading = !1, this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    hasAdminFeedbackPermission() {
      return this.userActions.includes("ADMIN_TICKET_USER_FIELD_WRITE_OWN");
    },
    allowCreation() {
      var e;
      return !!((e = this.fieldMeta) != null && e.createButton && this.defaultFeedbackTickets.length);
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: !this.feedbackTickets.length
        }
      };
    },
    async fetchFeedbackWorkflow() {
      try {
        this.defaultFeedbackTickets = await this.$gateway.feedback.fetchDefaultFeedbackTickets(
          this.contextId,
          this.productId
        );
      } catch (e) {
        console.error("Could not load feedback workflow", e);
      }
    },
    async fetchFeedbackTickets() {
      try {
        this.feedbackTickets = await this.$gateway.feedback.loadFeedbackTickets(
          this.ticket.type,
          this.ticket.canonicalId
        ), this.hasAdminFeedbackPermission || (this.feedbackTickets = this.feedbackTickets.filter(
          (e) => !e.audience
        ));
      } catch (e) {
        console.error("Could not load feedback ticket", e);
      }
    }
  }
});
var xT = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.loading ? t._e() : i("div", { staticClass: "feedback-adapter" }, [t.mode === "view" ? i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"], label: t.fieldResources.label } }, [i("feedback-list", { staticClass: "feedback-list", attrs: { "context-id": t.contextId, "current-user": t.currentUser, organization: t.organization, "product-id": t.productId, tickets: t.feedbackTickets, "user-id": t.currentUser.id }, on: { refresh: t.fetchFeedbackTickets } })], 1) : [i("feedback-manager", { attrs: { "allow-creation": t.allowCreation, "context-id": t.contextId, "current-user": t.currentUser, "default-tickets": t.defaultFeedbackTickets, label: t.fieldResources.editLabel, organization: t.organization, "parent-ticket-id": t.ticket.canonicalId, "product-id": t.productId, tickets: t.feedbackTickets }, on: { refresh: t.fetchFeedbackTickets } })]], 2);
}, CT = [], ST = /* @__PURE__ */ E(
  wT,
  xT,
  CT,
  !1,
  null,
  "c37b9ece"
);
const IT = ST.exports, DT = f({
  components: {
    LegacyFieldLabel: $
  },
  props: {
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    organization: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      showProductSelector: !1
    };
  },
  created() {
    this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    products() {
      let e = [];
      return this.ticket.meta[this.fieldMeta.productField] && (e = JSON.parse(this.ticket.meta[this.fieldMeta.productField])), e;
    },
    buttonStyle() {
      return this.fieldMeta.fullWidth ? {
        width: "100%"
      } : {};
    },
    theme() {
      return this.fieldMeta.buttonType ?? "primary";
    },
    label() {
      return this.isEnabled ? this.fieldResources.label : this.fieldResources.disabledLabel;
    },
    isEnabled() {
      return this.products.length >= 1 && !this.fieldMeta.disabledStatuses.includes(this.ticket.status);
    },
    enableUserInspirePeople() {
      var e;
      return !!this.organization.productCustomization[this.productId].enableAiContentGeneration && ((e = this.organization.settings) == null ? void 0 : e.userInspirePeople);
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: !1
        }
      };
    },
    selectProduct() {
      this.enableUserInspirePeople ? this.$router.replace({
        hash: `inspire-me=${this.ticket.canonicalId}`
      }) : this.products.length === 1 ? this.goToCreateTicket(this.products[0]) : (this.showProductSelector = !0, this.goToCreateTicket(this.products[0]));
    },
    goToCreateTicket(e) {
      this.$router.push({
        name: "CreateTicket",
        params: {
          product: e
        },
        query: {
          parent: this.ticket.canonicalId,
          type: e
        }
      });
    }
  }
});
var PT = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("app-button", { style: t.buttonStyle, attrs: { enabled: t.isEnabled, label: t.label, theme: t.theme }, on: { click: t.selectProduct } });
}, TT = [], OT = /* @__PURE__ */ E(
  DT,
  PT,
  TT,
  !1,
  null,
  null
);
const BT = OT.exports;
function Yo() {
  return { importData: (i) => (i ?? "").trim(), exportData: (i) => i.trim() };
}
const MT = f({
  components: {
    LegacyFieldLabel: $
  },
  inject: ["dynamicFieldBucket"],
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    fieldDatasource: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !1
    },
    fieldResources: {
      type: Object,
      required: !1
    },
    organization: {
      type: Object,
      required: !1
    }
  },
  data() {
    return {
      model: "",
      error: !1,
      ideaPictures: [],
      coverUploadCategory: "cover/upload",
      reloadKey: 0,
      ticketImages: []
    };
  },
  async created() {
    if (this.model = this.metaImage || this.fileImage, this.$emit("dynamic-field-mounted", this.getState()), this.editMode) {
      if (this.fieldDatasource.type === "INTERNAL_API") {
        const e = await this.$api.dynamicFields.fetchDynamicData(
          this.fieldDatasource.settings.url
        );
        this.ideaPictures = e.content.map(
          (t) => t.resources.imageUrl
        );
      }
      this.getTicketImages(this.ticket);
    }
  },
  computed: {
    editMode() {
      return this.mode === "edit";
    },
    bucket() {
      return this.dynamicFieldBucket ?? {};
    },
    required() {
      return this.fieldConfig.required ?? !1;
    },
    filePrefix() {
      return `${this.ticket.canonicalId}/image/`;
    },
    organizationMethods() {
      var e;
      return (((e = this.fieldMeta) == null ? void 0 : e.inputMethods) ?? []).filter(
        (t) => t !== "AI" || this.organization.settings.imageGenerationUsingAI
      );
    },
    metaImage() {
      const { importData: e } = Yo();
      let t = this.fieldConfig.ref ?? "";
      return t.startsWith("meta.") && (t = t.substring(5)), e(this.bucket[t]);
    },
    fileImage() {
      const e = this.ticket.files.find(
        (t) => t.category === "ticket-cover"
      );
      return (e == null ? void 0 : e.url) ?? "";
    }
  },
  methods: {
    getTicketImages(e) {
      var i;
      const t = (i = e.files) == null ? void 0 : i.filter(
        (r) => r.category === this.coverUploadCategory || r.category === "cover/ai"
      );
      this.ticketImages = (t == null ? void 0 : t.map((r) => r.url).reverse()) ?? [];
    },
    getTicket() {
      return this.$api.ticket.getTicket(
        this.ticket.type,
        this.ticket.canonicalId
      );
    },
    async uploadFile(e) {
      if (!e)
        return;
      const { upload: t, status: i, result: r } = hu(
        this.$api.fileAttachment,
        this.ticket.canonicalId
      );
      rt(i, (n) => {
        var a;
        n === "SUCCESS" ? (this.model = ((a = r.value) == null ? void 0 : a.url) || "", this.model && this.onInput()) : n === "ERROR" && this.$toast(this.$t("error.general").toString());
      }), await t(e, this.coverUploadCategory);
      const s = await this.getTicket();
      this.getTicketImages(s), this.reloadKey += 1, this.$toast(this.$t("common.toast.imageToGallery").toString());
    },
    onInput() {
      this.$emit("dynamic-field-updated", this.getState());
    },
    getState() {
      const { exportData: e } = Yo();
      return {
        ref: this.fieldConfig.ref,
        value: e(this.model),
        state: {
          empty: !this.model
        }
      };
    },
    async generatedAiImage() {
      const e = await this.getTicket();
      this.getTicketImages(e), this.model = this.ticketImages[0], this.onInput(), this.reloadKey += 1;
    },
    onBlur() {
      this.validate();
    },
    validate() {
      const e = this.required ? this.model.trim() !== "" : !0;
      return this.error = !e, e;
    }
  }
});
var RT = function() {
  var r, s;
  var t = this, i = t._self._c;
  return t._self._setupProxy, i("div", { staticClass: "text-input-adapter" }, [t.editMode ? i("app-image-input-selector-container", { key: t.reloadKey, attrs: { ticket: t.ticket, label: (r = t.fieldResources) == null ? void 0 : r.label, tooltip: (s = t.fieldResources) == null ? void 0 : s.tooltip, methods: t.organizationMethods, required: t.required, error: t.error, filePrefix: t.filePrefix, imageSelectorItems: t.ideaPictures, imageTicketItems: t.ticketImages, uploadMaxHeight: 341, uploadMaxWidth: 512 }, on: { input: t.onInput, blur: t.onBlur, "crop-accept": t.uploadFile, "ai-generated": t.generatedAiImage }, model: { value: t.model, callback: function(n) {
    t.model = n;
  }, expression: "model" } }) : i("legacy-field-label", { attrs: { "dynamic-group": t.$attrs["dynamic-group"] } }, [t.model ? i("img", { staticClass: "image-display", attrs: { src: t.model } }) : t._e()])], 1);
}, ET = [], LT = /* @__PURE__ */ E(
  MT,
  RT,
  ET,
  !1,
  null,
  "85313ec6"
);
const FT = LT.exports, jT = f({
  components: { LegacyFieldLabel: $ },
  props: {
    mode: {
      type: String,
      default: "view"
    },
    fieldConfig: {
      type: Object,
      required: !0
    },
    ticket: {
      type: Object,
      required: !0
    },
    fieldResources: {
      type: Object,
      required: !0
    },
    userActions: {
      type: Array,
      default: () => []
    },
    currentUser: {
      type: Object,
      required: !0
    }
  },
  created() {
    this.$nextTick(() => {
      this.$emit("dynamic-field-mounted", this.getState());
    });
  },
  computed: {
    enabled() {
      return !!this.delegateTeam && this.mode === "edit";
    },
    delegateTeam() {
      return this.ticket.delegate.find(({ domain: e }) => e === "cocreators");
    }
  },
  methods: {
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: !1
        }
      };
    },
    onInput() {
      this.$emit("dynamic-field-updated", this.getState());
    }
  }
});
var UT = function() {
  var r, s, n;
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.delegateTeam ? i("assign-co-creators", { class: { "view-mode": t.mode === "view" }, attrs: { "user-actions": t.userActions, "user-id": t.currentUser.id, enabled: t.enabled, label: (r = t.fieldResources) == null ? void 0 : r.label, "team-id": (s = t.delegateTeam) == null ? void 0 : s.id, tooltip: (n = t.fieldResources) == null ? void 0 : n.tooltip }, on: { input: t.onInput } }) : t._e();
}, qT = [], HT = /* @__PURE__ */ E(
  jT,
  UT,
  qT,
  !1,
  null,
  "4f4e3f1f"
);
const zT = HT.exports, NT = f({
  components: {
    LegacyFieldLabel: $
  },
  props: {
    fieldConfig: {
      type: Object,
      required: !0
    },
    fieldMeta: {
      type: Object,
      required: !1
    },
    ticket: {
      type: Object,
      required: !0
    },
    productId: {
      type: String,
      required: !0
    },
    contextId: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      config: void 0
    };
  },
  async created() {
    this.config = await this.loadConfig(), this.$emit("dynamic-field-mounted", this.getState());
  },
  computed: {
    explicitConfig() {
      var e, t;
      return (t = (e = this.fieldMeta) == null ? void 0 : e.messageConfig) == null ? void 0 : t[this.ticket.status];
    },
    title() {
      var e, t;
      return (t = this.$res((e = this.config) == null ? void 0 : e.resources)) == null ? void 0 : t.statusMessageLabel;
    },
    description() {
      var e, t;
      return (e = this.config) != null && e.fieldRef ? (t = this.ticket.meta) == null ? void 0 : t[this.config.fieldRef] : void 0;
    },
    bannerStyle() {
      var e;
      return ((e = this.config) == null ? void 0 : e.bannerStyle) ?? "notice";
    },
    bannerVisible() {
      return !!this.description;
    }
  },
  methods: {
    async loadConfig() {
      return this.explicitConfig ?? await this.loadFallbackConfig() ?? {};
    },
    async loadFallbackConfig() {
      const e = await this.$datasource.workflow.find(
        this.productId,
        this.contextId
      );
      if (!e)
        return;
      const t = Su(this.ticket.status), r = (e.settings.rejectStatus ?? []).includes(this.ticket.status) ? "warning" : "notice", s = Jo(this.ticket.status, e);
      if (s)
        return {
          fieldRef: t,
          resources: s,
          bannerStyle: r
        };
    },
    getState() {
      return {
        ref: this.fieldConfig.ref,
        value: null,
        state: {
          empty: !this.bannerVisible
        }
      };
    }
  }
});
var VT = function() {
  var t = this, i = t._self._c;
  return t._self._setupProxy, t.bannerVisible ? i("app-banner", { attrs: { "banner-style": t.bannerStyle, title: t.title, description: t.description } }) : t._e();
}, GT = [], WT = /* @__PURE__ */ E(
  NT,
  VT,
  GT,
  !1,
  null,
  null
);
const QT = WT.exports, XT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AssignCoCreatorsAdapter: zT,
  AssignTicketToAdapter: A2,
  AutocompleteAdapter: sP,
  ButtonAdapter: S2,
  CountdownAdapter: O2,
  CreateTicketButtonAdapter: BT,
  DatepickerAdapter: fP,
  DelegateTicketToAdapter: L2,
  DelegateWorkgroupAdapter: H2,
  DynamicFieldItemError: ru,
  ExternalFieldsCompat: vD,
  ExternalLinksAdapter: vP,
  FeedbackAdapter: IT,
  ImageInputAdapter: FT,
  MeasurementInputAdapter: CP,
  NumberInputAdapter: RD,
  ProductDropdownAdapter: cP,
  TableAdapter: YP,
  TagsAdapter: tT,
  TasksAdapter: aT,
  TasksGroupAdapter: dT,
  TeamSelectorAdapter: n2,
  TextAreaAdapter: UD,
  TextAreaMarkdownAdapter: VD,
  TextInputAdapter: PD,
  TicketAttachmentAdapter: kT,
  TicketGalleryAdapter: W2,
  TicketPitchAdapter: gT,
  TicketSkillsAdapter: Z2,
  TicketStatusAdapter: u2,
  TicketTimelineAdapter: m2,
  TransitionMessageAdapter: QT,
  UserSelectionAdapter: e2
}, Symbol.toStringTag, { value: "Module" })), KT = {
  button: "ButtonAdapter",
  text: "TextInputAdapter",
  number: "NumberInputAdapter",
  textarea: "TextAreaAdapter",
  textareaMarkdown: "TextAreaMarkdownAdapter",
  tasks: "TasksAdapter",
  taskGroup: "TasksGroupAdapter",
  assignTo: "AssignTicketToAdapter",
  links: "ExternalLinksAdapter",
  ticketSkills: "TicketSkillsAdapter",
  ticketTags: "TagsAdapter",
  datepicker: "DatepickerAdapter",
  countdown: "CountdownAdapter",
  autocomplete: "AutocompleteAdapter",
  productDropdown: "ProductDropdownAdapter",
  createTicketButton: "CreateTicketButtonAdapter",
  delegateTo: "DelegateTicketToAdapter",
  delegateWorkgroup: "DelegateWorkgroupAdapter",
  table: "TableAdapter",
  files: "TicketAttachmentAdapter",
  ticketPitch: "TicketPitchAdapter",
  ticketGallery: "TicketGalleryAdapter",
  ticketStatus: "TicketStatusAdapter",
  ticketTimeline: "TicketTimelineAdapter",
  feedback: "FeedbackAdapter",
  imageInput: "ImageInputAdapter",
  teamSelector: "TeamSelectorAdapter",
  coCreators: "AssignCoCreatorsAdapter",
  userSelection: "UserSelectionAdapter",
  measurement: "MeasurementInputAdapter",
  transitionMessageBanner: "TransitionMessageAdapter"
}, ZT = {
  install(e) {
    Object.entries(XT).forEach(([t, i]) => {
      e.component(t, i);
    });
  }
};
export {
  zT as AssignCoCreatorsAdapter,
  A2 as AssignTicketToAdapter,
  sP as AutocompleteAdapter,
  S2 as ButtonAdapter,
  O2 as CountdownAdapter,
  BT as CreateTicketButtonAdapter,
  fP as DatepickerAdapter,
  L2 as DelegateTicketToAdapter,
  H2 as DelegateWorkgroupAdapter,
  ru as DynamicFieldItemError,
  vD as ExternalFieldsCompat,
  vP as ExternalLinksAdapter,
  IT as FeedbackAdapter,
  FT as ImageInputAdapter,
  CP as MeasurementInputAdapter,
  RD as NumberInputAdapter,
  cP as ProductDropdownAdapter,
  YP as TableAdapter,
  tT as TagsAdapter,
  aT as TasksAdapter,
  dT as TasksGroupAdapter,
  n2 as TeamSelectorAdapter,
  UD as TextAreaAdapter,
  VD as TextAreaMarkdownAdapter,
  PD as TextInputAdapter,
  kT as TicketAttachmentAdapter,
  W2 as TicketGalleryAdapter,
  gT as TicketPitchAdapter,
  Z2 as TicketSkillsAdapter,
  u2 as TicketStatusAdapter,
  m2 as TicketTimelineAdapter,
  QT as TransitionMessageAdapter,
  e2 as UserSelectionAdapter,
  KT as componentLookup,
  ZT as rreadyDynamicFields
};
